_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[52,26,27,28],{

/***/ "+2AQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SELLER_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellerInfoReducer; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var GET_SELLER_EMAIL = 'GET_SELLER_EMAIL';
var initialState = {
  email: null
};
var sellerInfoReducer = function sellerInfoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case GET_SELLER_EMAIL:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          email: action.payload.sellerInfo ? action.payload.sellerInfo.email : null
        });
      }

    default:
      return state;
  }
};

/***/ }),

/***/ "+7q0":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("eN33"),
    defineProperty = __webpack_require__("Pz+s"),
    identity = __webpack_require__("zWgn");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "+c4W":
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__("711d"),
    basePropertyDeep = __webpack_require__("4/ic"),
    isKey = __webpack_require__("9ggG"),
    toKey = __webpack_require__("9Nap");

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ "+mhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureCity; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PFCZ");



function setDepartureCity(_ref) {
  var value = _ref.value;
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_CITY */ "b"], {
    value: value
  });
}



/***/ }),

/***/ "/WwO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useScriptLoader; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var cachedScripts = [];
function useScriptLoader(scriptUrl) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(cachedScripts.includes(scriptUrl)),
      scriptLoaded = _useState[0],
      setScriptLoaded = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      scriptLoadingFailed = _useState2[0],
      setScriptLoadingFailed = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (scriptLoaded) {
      return;
    }

    var script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    new Promise(function (resolve, reject) {
      script.addEventListener('load', function () {
        return resolve(scriptUrl);
      });
      script.addEventListener('error', function (e) {
        return reject(e);
      });
    }).then(function () {
      cachedScripts.push(scriptUrl);
      setScriptLoaded(true);
    })["catch"](function () {
      script.remove();
      setScriptLoadingFailed(true);
    }); // $FlowFixMe

    document.body.appendChild(script);
  }, [scriptUrl]);
  return {
    scriptLoaded: scriptLoaded,
    scriptLoadingFailed: scriptLoadingFailed
  };
}

/***/ }),

/***/ "03A+":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("JTzB"),
    isObjectLike = __webpack_require__("ExA7");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "04nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_SELECTED_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ADDITIONAL_TRANSPORTS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SEARCH_CRITERIA_TRANSPORTS; });
/* unused harmony export SET_FILTERED_ADDITIONAL_TRANSPORTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOGGLE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISABLE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_FILTERED_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SORT_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return clearAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isSameJourney; });
/* unused harmony export isSameTransport */
/* unused harmony export disableAdditionalTransportFilters */
/* unused harmony export toggleAdditionalTransportFilter */
/* unused harmony export unselectAdditionalTransportsFilterCategory */
/* unused harmony export updateAdditionalTransportsSort */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Y+p1");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("70jX");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rJ95");
/* harmony import */ var _booking_selector__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("uL19");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("NLwV");
/* harmony import */ var _transports_transports_reducer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("Fk4B");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var CLEAR_ADDITIONAL_TRANSPORTS = 'CLEAR_ADDITIONAL_TRANSPORTS';
var FETCH_ADDITIONAL_TRANSPORTS = 'FETCH_ADDITIONAL_TRANSPORTS';
var SEARCH_CRITERIA_TRANSPORTS = 'SEARCH_CRITERIA_TRANSPORTS';
var CREATE_ADDITIONAL_TRANSPORTS_FILTERS = 'CREATE_ADDITIONAL_TRANSPORTS_FILTERS';
var SET_FILTERED_ADDITIONAL_TRANSPORTS = 'SET_FILTERED_ADDITIONAL_TRANSPORTS';
var TOGGLE_FILTER = 'TOGGLE_FILTER';
var DISABLE_FILTERS = 'DISABLE_FILTERS';
var UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY = 'UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY';
var UPDATE_FILTERED_RESULTS = 'UPDATE_FILTERED_RESULTS';
var SORT_ADDITIONAL_TRANSPORTS = 'SORT_ADDITIONAL_TRANSPORTS';
var UPDATE_SELECTED_TRANSPORT = 'UPDATE_SELECTED_TRANSPORT';

function _toggleFilter(filter, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(TOGGLE_FILTER, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState()),
    filter: filter
  });
}

function _disableFilters(filters, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(DISABLE_FILTERS, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState()),
    filters: filters
  });
}

function _unselectFiltersCategory(category, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState()),
    category: category
  });
}

function _updateFilteredTransports(getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(UPDATE_FILTERED_RESULTS, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState()),
    filters: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransportsFilters */ "h"])(getState())
  });
}

function _runAdditionalTransportsQuery(_ref) {
  var proposalId = _ref.proposalId,
      appContext = _ref.appContext,
      searchCriterias = _ref.searchCriterias;
  var query = "\n    {\n      additionalTransports(proposalId : \"".concat(proposalId, "\" ").concat(searchCriterias ? ", searchCriteria: ".concat(Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_8__[/* graphqlify */ "d"])(searchCriterias)) : '', ") {\n        inbound { \n          transportInfo {\n            id\n            isMultiTransport\n            price {\n              ...priceDetails\n            }\n            totalDifferentialPrice {\n              ...priceDetails\n            }\n            way\n          }\n          journey {\n            ...transportsDetails \n          }\n        }\n        outboundList {  \n          transportInfo {\n            id\n            isMultiTransport\n            price {\n              ...priceDetails\n            }\n            totalDifferentialPrice {\n              ...priceDetails\n            }\n            way\n          }\n          journey {\n            ...transportsDetails \n          }\n        }\n       \n      }\n    }\n    ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_3__[/* transportDetailsFragment */ "q"], "\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_3__[/* getPriceDetailFragment */ "h"])(appContext.locale), "\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* PROPOSAL_GET_ADDITIONAL_TRANSPORT */ "od"]
  });
}

function updateAdditionalTransportsSort(sorter) {
  return function (dispatch, getState) {
    var additionalTransports = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransports */ "f"])(getState());
    var filters = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_7__[/* getAdditionalTransportsFilters */ "h"])(getState());
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(SORT_ADDITIONAL_TRANSPORTS, {
      additionalTransports: additionalTransports,
      filters: filters,
      sorter: sorter
    }));
  };
}

function clearAdditionalTransports() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(CLEAR_ADDITIONAL_TRANSPORTS);
}

var formatProposalLegacyTransportAsAlternative = function formatProposalLegacyTransportAsAlternative(_ref2) {
  var _proposal$price, _proposal$price$total, _proposal$price2, _proposal$price2$tota, _proposal$price3, _proposal$price3$tota, _proposal$price4, _proposal$price4$tota, _proposal$transports, _proposal$transports2;

  var proposal = _ref2.proposal,
      appContext = _ref2.appContext;

  if (!proposal) {
    return null;
  }

  var transportInfo = {
    id: proposal.id,
    // this id is added for unit testing - proposal id is not similar to AdditionalTransport id
    price: Object(_transports_transports_reducer__WEBPACK_IMPORTED_MODULE_9__[/* getTotalDifferentialPrice */ "b"])((_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : (_proposal$price$total = _proposal$price.total) === null || _proposal$price$total === void 0 ? void 0 : _proposal$price$total.value, (_proposal$price2 = proposal.price) === null || _proposal$price2 === void 0 ? void 0 : (_proposal$price2$tota = _proposal$price2.totalWithoutTransport) === null || _proposal$price2$tota === void 0 ? void 0 : _proposal$price2$tota.value, appContext.locale),
    totalDifferentialPrice: Object(_transports_transports_reducer__WEBPACK_IMPORTED_MODULE_9__[/* getTotalDifferentialPrice */ "b"])((_proposal$price3 = proposal.price) === null || _proposal$price3 === void 0 ? void 0 : (_proposal$price3$tota = _proposal$price3.totalWithoutTransport) === null || _proposal$price3$tota === void 0 ? void 0 : _proposal$price3$tota.value, (_proposal$price4 = proposal.price) === null || _proposal$price4 === void 0 ? void 0 : (_proposal$price4$tota = _proposal$price4.totalWithoutTransport) === null || _proposal$price4$tota === void 0 ? void 0 : _proposal$price4$tota.value, appContext.locale)
  };
  return {
    inbound: {
      transportInfo: _objectSpread(_objectSpread({}, transportInfo), {}, {
        way: 'INBOUND'
      }),
      journey: proposal === null || proposal === void 0 ? void 0 : (_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : _proposal$transports.inbound
    },
    outboundList: [{
      transportInfo: _objectSpread(_objectSpread({}, transportInfo), {}, {
        way: 'OUTBOUND'
      }),
      journey: proposal === null || proposal === void 0 ? void 0 : (_proposal$transports2 = proposal.transports) === null || _proposal$transports2 === void 0 ? void 0 : _proposal$transports2.outbound
    }]
  };
};

var isSameJourney = function isSameJourney(firstTransport, secondTransport) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (firstTransport && firstTransport.journey && secondTransport && secondTransport.journey) {
    var _firstTransport$journ, _secondTransport$jour, _firstTransport$journ2, _secondTransport$jour2;

    var firstTravelSections = (_firstTransport$journ = firstTransport.journey) === null || _firstTransport$journ === void 0 ? void 0 : _firstTransport$journ.travelSections;
    var secondTravelSections = (_secondTransport$jour = secondTransport.journey) === null || _secondTransport$jour === void 0 ? void 0 : _secondTransport$jour.travelSections;
    var haveSameTravelSections = (firstTravelSections === null || firstTravelSections === void 0 ? void 0 : firstTravelSections.length) === (secondTravelSections === null || secondTravelSections === void 0 ? void 0 : secondTravelSections.length) && ((firstTravelSections === null || firstTravelSections === void 0 ? void 0 : firstTravelSections.length) === 0 || firstTravelSections.every(function (currentValue, index) {
      var selectedValue = secondTravelSections[index];
      return lodash_isEqual__WEBPACK_IMPORTED_MODULE_2___default()(currentValue, selectedValue);
    }));
    var haveSameDurationInMin = ((_firstTransport$journ2 = firstTransport.journey) === null || _firstTransport$journ2 === void 0 ? void 0 : _firstTransport$journ2.durationInMin) === ((_secondTransport$jour2 = secondTransport.journey) === null || _secondTransport$jour2 === void 0 ? void 0 : _secondTransport$jour2.durationInMin);
    return haveSameTravelSections && haveSameDurationInMin;
  }

  return defaultValue;
};

var isSameTransport = function isSameTransport(_ref3) {
  var transportId = _ref3.transportId,
      currentTransport = _ref3.currentTransport,
      selectedTransport = _ref3.selectedTransport,
      _ref3$defaultValue = _ref3.defaultValue,
      defaultValue = _ref3$defaultValue === void 0 ? true : _ref3$defaultValue;

  if (currentTransport && selectedTransport) {
    var sameInbound = isSameJourney(currentTransport === null || currentTransport === void 0 ? void 0 : currentTransport.inbound, selectedTransport === null || selectedTransport === void 0 ? void 0 : selectedTransport.inbound, defaultValue);

    if (sameInbound && transportId) {
      var _selectedTransport$ou;

      var currentOutbound = currentTransport === null || currentTransport === void 0 ? void 0 : currentTransport.outboundList[0];
      var selectedOutbound = selectedTransport === null || selectedTransport === void 0 ? void 0 : (_selectedTransport$ou = selectedTransport.outboundList) === null || _selectedTransport$ou === void 0 ? void 0 : _selectedTransport$ou.find(function (transport) {
        return transport.transportInfo.id === transportId;
      });
      return currentOutbound && selectedOutbound ? isSameJourney(currentOutbound, selectedOutbound, false) : false;
    }

    return sameInbound;
  }

  return defaultValue;
};

function fetchAdditionalTransports(_ref4) {
  var proposal = _ref4.proposal,
      appContext = _ref4.appContext,
      searchCriterias = _ref4.searchCriterias;
  return function (dispatch) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(FETCH_ADDITIONAL_TRANSPORTS));
    var defaultTransport = formatProposalLegacyTransportAsAlternative({
      proposal: proposal,
      appContext: appContext
    });
    return _runAdditionalTransportsQuery({
      proposalId: proposal.id,
      appContext: appContext,
      searchCriterias: searchCriterias
    }).then(function (_ref5) {
      var additionalTransports = _ref5.additionalTransports;
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(SEARCH_CRITERIA_TRANSPORTS, searchCriterias));
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["resolve"])(FETCH_ADDITIONAL_TRANSPORTS), {
        additionalTransports: additionalTransports,
        selectedTransport: defaultTransport
      }));
    }, function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["reject"])(FETCH_ADDITIONAL_TRANSPORTS), error));
    });
  };
}

function toggleAdditionalTransportFilter(filter) {
  return function (dispatch, getState) {
    dispatch(_toggleFilter(filter, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}

function disableAdditionalTransportFilters(filters) {
  return function (dispatch, getState) {
    dispatch(_disableFilters(filters, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}

function unselectAdditionalTransportsFilterCategory(category) {
  return function (dispatch, getState) {
    dispatch(_unselectFiltersCategory(category, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}



/***/ }),

/***/ "05L9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WEB_CALLBACK_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WEB_CALLBACK_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FooterContacts; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_tracking_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9sjr");
/* harmony import */ var _utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9BC+");
/* harmony import */ var _frameworks_block_link_BlockLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Onl6");
/* harmony import */ var _widgets_webcallback_WebCallbackBlockLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("39HS");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






var WEB_CALLBACK_LINK = 'callMeBack';
var WEB_CALLBACK_ENABLED = _config__WEBPACK_IMPORTED_MODULE_1___default.a.get('freespee.enabled');
var FooterContacts = function FooterContacts(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  return __jsx("div", {
    className: "pt-5 relative w-full z-1 lg:border-b-1 border-gray-dark md:pb-5"
  }, __jsx("ul", {
    className: "reset-list flex flex-col md:flex-row md:justify-between md:-mx-px5"
  }, items.map(function (_ref2) {
    var href = _ref2.href,
        text = _ref2.text,
        type = _ref2.type;
    var texts = (text || []).map(function (txt) {
      // the phone number is always written in ltr, even in he-IL (which is rtl)
      return Object(_utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_3__[/* isPhoneNumber */ "c"])(txt) ? __jsx("span", {
        dir: "ltr"
      }, txt) : txt;
    });
    return __jsx("li", {
      className: "border-b-1 md:border-b-0 border-gray-dark mb-px10 md:mb-0 md:mx-px5 pb-px10 md:pb-0 last-child-mb-0 last-child-border-b-0",
      key: type
    }, type === WEB_CALLBACK_LINK && WEB_CALLBACK_ENABLED ? __jsx(_widgets_webcallback_WebCallbackBlockLink__WEBPACK_IMPORTED_MODULE_5__[/* WebCallbackBlockLink */ "a"], {
      icon: type,
      trackingData: {
        actionGA: 'footer'
      },
      texts: texts,
      theme: "default"
    }) : __jsx(_frameworks_block_link_BlockLink__WEBPACK_IMPORTED_MODULE_4__[/* BlockLink */ "a"], {
      icon: type,
      target: "_blank",
      texts: texts,
      trackingData: {
        actionGA: 'footer',
        labelGA: Object(_utils_tracking_footer__WEBPACK_IMPORTED_MODULE_2__[/* formatFooterLabelName */ "a"])(type)
      },
      url: href
    }));
  })));
};

/***/ }),

/***/ "05v4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ESCAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ARROW_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ARROW_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ARROW_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARROW_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HOME; });
// export const BACKSPACE = 8;
// export const SPACE = 32;
var ENTER = 13;
var ESCAPE = 27;
var ARROW_LEFT = 37;
var ARROW_UP = 38;
var ARROW_RIGHT = 39;
var ARROW_DOWN = 40;
var END = 35;
var HOME = 36;

/***/ }),

/***/ "06Jt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_ADDITIONAL_ACCOMMODATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ADDITIONAL_ACCOMMODATIONS; });
/* unused harmony export SET_FILTERED_ADDITIONAL_ACCOMMODATIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOGGLE_ACCOMMODATIONS_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_FILTERED_ACCOMMODATIONS_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toggleAdditionalAccommodationFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return unselectAdditionalAccommodationsFilterCategory; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("70jX");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("rJ95");
/* harmony import */ var _booking_selector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("uL19");









var CLEAR_ADDITIONAL_ACCOMMODATIONS = 'CLEAR_ADDITIONAL_ACCOMMODATIONS';
var FETCH_ADDITIONAL_ACCOMMODATIONS = 'FETCH_ADDITIONAL_ACCOMMODATIONS';
var CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS = 'CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS';
var SET_FILTERED_ADDITIONAL_ACCOMMODATIONS = 'SET_FILTERED_ADDITIONAL_ACCOMMODATIONS';
var TOGGLE_ACCOMMODATIONS_FILTER = 'TOGGLE_ACCOMMODATIONS_FILTER';
var UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY = 'UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY';
var UPDATE_FILTERED_ACCOMMODATIONS_RESULTS = 'UPDATE_FILTERED_ACCOMMODATIONS_RESULTS';

function _getSelectedProposal(state) {
  if (!state) return null;
  var proposals = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getProposals */ "u"])(state) || [];
  var resort = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getCurrentResort */ "l"])(state);
  var selectedProposal = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["find"])(proposals, {
    id: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getSelectedProposalId */ "z"])(state)
  }) || Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_3__[/* getDefaultProposal */ "e"])(proposals, resort);
  return selectedProposal;
}

function _createAdditionalAccommodationsFilters(_ref) {
  var proposal = _ref.proposal,
      resort = _ref.resort,
      getState = _ref.getState,
      i18n = _ref.i18n,
      shouldPreselectFilters = _ref.shouldPreselectFilters;
  var state = getState();
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(state),
    selectedProposal: proposal,
    i18n: i18n,
    shouldPreselectFilters: shouldPreselectFilters,
    resort: resort
  });
}

function _toggleFilter(filter, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(TOGGLE_ACCOMMODATIONS_FILTER, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filter: filter
  });
}

function _unselectFiltersCategory(category, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    category: category
  });
}

function _updateFilterAccommodations(getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(UPDATE_FILTERED_ACCOMMODATIONS_RESULTS, {
    additionalAccommodations: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodations */ "c"])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filters: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getAdditionalAccommodationsFilters */ "e"])(getState())
  });
}

function _runAdditionalAccommodationsQuery(_ref2) {
  var proposalId = _ref2.proposalId,
      appContext = _ref2.appContext,
      duration = _ref2.duration,
      _ref2$selectedRate = _ref2.selectedRate,
      selectedRate = _ref2$selectedRate === void 0 ? '' : _ref2$selectedRate,
      _ref2$roomsArrangemen = _ref2.roomsArrangement,
      roomsArrangement = _ref2$roomsArrangemen === void 0 ? [] : _ref2$roomsArrangemen;
  var query = "\n    {\n      additionalAccommodations(proposalId: \"".concat(proposalId, "\", roomsArrangement:").concat(Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_4__[/* graphqlify */ "d"])(roomsArrangement), ") {\n        id\n        totalDifferentialPrice(selectedRate: \"").concat(selectedRate, "\") {\n          ...priceDetails\n        }\n        differentialPriceByNight(nightsNumber: ").concat(duration, ", selectedRate: \"").concat(selectedRate, "\") {\n          formattedValue(precision: 0)\n          value\n        }\n        remainingStock\n        accommodations {\n          id\n          categories { id label }\n          category\n          categoryId\n          comfortType\n          connectingRoom\n          description\n          label\n          maxCapacity\n          roomType\n          media {\n            photos {\n              url\n            }\n          }\n          minCapacity\n          occupation\n          quantity\n          occupancies {\n            baby_count\n          }\n          outsideFacilities {\n            id\n            label\n          }\n          bathroomEquipments {\n            id\n            label\n          }\n          equipments {\n            id\n            label\n          }\n          services { id label }\n          strengths { id label }\n          surface\n          view { id label }\n          reducedMobilityAccess\n          attendeesDistribution {\n            id\n            quantity\n            attendees {\n              id\n              type\n              birthdate\n              customerId\n            }\n          }\n        }\n      }\n      config {\n        filters {\n          configuration {\n            categoryTitle\n            simpleRoom\n            simpleRooms\n            separatedRooms\n            separatedRooms3\n          }\n          comfort {\n            categoryTitle\n          }\n          extraFeatures {\n            categoryTitle\n          }\n          reducedMobility\n        }\n      }\n    }\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* getPriceDetailFragment */ "h"])(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(appContext, 'locale')), "\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* PROPOSAL_GET_ADDITIONAL_ACCOMMODATIONS */ "nd"]
  });
}

function clearAdditionalAccommodations() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(CLEAR_ADDITIONAL_ACCOMMODATIONS);
}

function fetchAdditionalAccommodations(_ref3) {
  var proposal = _ref3.proposal,
      resort = _ref3.resort,
      appContext = _ref3.appContext,
      _ref3$roomsArrangemen = _ref3.roomsArrangement,
      roomsArrangement = _ref3$roomsArrangemen === void 0 ? [] : _ref3$roomsArrangemen,
      _ref3$shouldPreselect = _ref3.shouldPreselectFilters,
      shouldPreselectFilters = _ref3$shouldPreselect === void 0 ? true : _ref3$shouldPreselect;
  var id = proposal.id,
      duration = proposal.duration,
      selectedRate = proposal.price.selectedRate;
  return function (dispatch, getState) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(FETCH_ADDITIONAL_ACCOMMODATIONS));
    return _runAdditionalAccommodationsQuery({
      proposalId: id,
      appContext: appContext,
      duration: duration,
      selectedRate: selectedRate,
      roomsArrangement: roomsArrangement
    }).then(function (_ref4) {
      var additionalAccommodations = _ref4.additionalAccommodations,
          i18n = _ref4.config;
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
        additionalAccommodations: additionalAccommodations
      }));
      dispatch(_createAdditionalAccommodationsFilters({
        proposal: proposal,
        resort: resort,
        getState: getState,
        i18n: i18n,
        shouldPreselectFilters: shouldPreselectFilters
      }));
      dispatch(_updateFilterAccommodations(getState));
    })["catch"](function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_ADDITIONAL_ACCOMMODATIONS), error));
    });
  };
}

function toggleAdditionalAccommodationFilter(filter) {
  return function (dispatch, getState) {
    dispatch(_toggleFilter(filter, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}

function unselectAdditionalAccommodationsFilterCategory(category) {
  return function (dispatch, getState) {
    dispatch(_unselectFiltersCategory(category, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}



/***/ }),

/***/ "0Cz8":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("Xi7e"),
    Map = __webpack_require__("ebwN"),
    MapCache = __webpack_require__("e4Nc");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "0JpG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useGQL; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ub5k");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var noop = function noop(e) {
  return e;
};

function reducer(state, action) {
  switch (action.type) {
    case 'loading':
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      });

    case 'data':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data,
        isLoading: false
      });

    case 'error':
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.error,
        isLoading: false
      });

    default:
      throw new Error("Unknown action type! [".concat(action.type, "]"));
  }
}

function useGQL() {
  for (var _len = arguments.length, queries = new Array(_len), _key = 0; _key < _len; _key++) {
    queries[_key] = arguments[_key];
  }

  var initialState = {
    data: null,
    error: null,
    isLoading: true
  };

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_1__["useReducer"])(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]);
  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    dispatch({
      type: 'loading'
    });
    var promises = queries.filter(function (query) {
      return !query.ignore;
    }).map(function (_ref) {
      var query = _ref.query,
          _ref$cache = _ref.cache,
          cache = _ref$cache === void 0 ? false : _ref$cache,
          _ref$map = _ref.map,
          map = _ref$map === void 0 ? noop : _ref$map,
          queryOptions = _ref.queryOptions,
          catchCallback = _ref["catch"];
      var promise = cache ? _graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, queryOptions) : _graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(query, appContext, queryOptions);

      if (catchCallback) {
        return promise.then(map)["catch"](catchCallback);
      }

      return promise.then(map);
    });
    Promise.all(promises).then(function (datas) {
      var data = queries.length === 1 ? datas[0] : datas.reduce(function (acc, item) {
        return _objectSpread(_objectSpread({}, acc), item);
      }, {});
      dispatch({
        type: 'data',
        data: data
      });
    })["catch"](function (error) {
      dispatch({
        type: 'error',
        error: error
      });
    });
  }, queries.map(function (q) {
    return q.query + (q.ignore ? 'T' : 'F');
  })); // useEffect run at each render on the react lifecycle. Here the useEffect should run only if the query OR the ignore param change!
  // $FlowFixMe

  return state;
}

/***/ }),

/***/ "0OJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PRICE_TICKET_REQUEST = 'PRICET_TICKET_REQUEST';
/* harmony default export */ __webpack_exports__["a"] = (PRICE_TICKET_REQUEST);

/***/ }),

/***/ "0Sn7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setEntryRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unsetEntryRoute; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _entryRoute_reducer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("m9Sl");


var setEntryRoute = function setEntryRoute(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_entryRoute_reducer__WEBPACK_IMPORTED_MODULE_1__[/* SET_ENTRY_ROUTE */ "a"], payload);
};
var unsetEntryRoute = function unsetEntryRoute() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_entryRoute_reducer__WEBPACK_IMPORTED_MODULE_1__[/* UNSET_ENTRY_ROUTE */ "b"]);
};

/***/ }),

/***/ "0ibg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setKeywords; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");


function setKeywords(keywords) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SEARCH_SET_KEYWORDS */ "s"], {
    keywords: keywords
  });
}

/***/ }),

/***/ "0x7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toast; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _portal_Portal_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Yd/I");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("/Mt0");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qBqs");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qqKu");
/* harmony import */ var _portal_Portal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("3uBn");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;










var Toast = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["forwardRef"])(function (props, ref) {
  var _classnames;

  var _useResponsive = Object(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_7__[/* useResponsive */ "b"])(),
      isAppMounted = _useResponsive.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var _props$color = props.color,
      color = _props$color === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].WATER_GREEN : _props$color,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CONFIRMATION : _props$icon,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      onClose = props.onClose,
      _props$portalName = props.portalName,
      portalName = _props$portalName === void 0 ? _portal_Portal_constants__WEBPACK_IMPORTED_MODULE_5__[/* OVER_BOT */ "d"] : _props$portalName,
      visible = props.visible;

  if (!visible) {
    return null;
  }

  return __jsx(_portal_Portal__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"], {
    name: portalName
  }, __jsx("button", {
    "aria-disabled": !visible,
    "aria-hidden": !visible,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('reset-button bg-white fixed flex font-bold items-center p-1 rtl:right-0 rounded-small transition-all', (_classnames = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, "text-".concat(String(color)), color), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, 'rtl:translate-x-100', !visible), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, 'rtl:mr-10 shadow-md', visible), _classnames), className),
    "data-testid": "Toast",
    onClick: onClose,
    ref: ref,
    style: {
      top: 150,
      width: 280
    },
    tabIndex: visible ? 0 : -1,
    type: "button"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_8__[/* Icon */ "a"], {
    className: "flex-shrink-0 m-1",
    name: icon,
    width: "30px"
  }), __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_9__[/* Text */ "a"], {
    className: "flex-1 p-1 rtl:mr-6",
    text: Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "f"])(label)
  }), __jsx("div", {
    className: "absolute leading-none p-3 top-0 rtl:right-0"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_8__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CROSS,
    width: "10px"
  }))));
});

/***/ }),

/***/ "0ycA":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "19WB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPrePaymentDetailsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInitPaymentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFormDataQuery; });
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pPFN");
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(stringify_object__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _PrePayment_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("XHSI");



function getPrePaymentDetailsQuery(bookingId) {
  return "query {\n    userBooking(bookingId:\"".concat(bookingId, "\") {\n      paymentDetails {\n        duePayment {\n          deadline\n          amount {\n            value\n          }\n        }\n      }\n      information {\n        status\n        bookingId\n        stays {\n          id\n          departureDate\n          returnDate\n          departureCity\n          arrivalCity\n          adults\n          children\n          resort {\n            name\n            image\n            comfort\n            type\n            icon\n            badgeIcon\n            isExplicitEC\n            isJoyview\n            destination {\n              country\n            }\n            departureCity\n            arrivalCity\n          }\n        }\n        vendor {\n          isSoldByClubMed\n          name\n          phoneNumber\n        }\n        isPaid\n      }\n    }\n\n    legalInformations {\n      optionConfirmation {\n        id\n        label\n        description\n        url\n        required\n        preChecked\n      }\n    }\n\n    paymentProviders {\n      id\n      label\n      logo\n      description\n      requiredDelayBeforeDeparture\n      paymentMethods {\n        id\n        label\n        image\n        category\n        timePaymentConditions {\n          id\n          paymentCount\n          chargePercentage\n        }\n      }\n      token {\n        format\n        value\n      }\n    }\n  }");
}
function getInitPaymentQuery(payload) {
  var _payload$bookingId = payload.bookingId,
      bookingId = _payload$bookingId === void 0 ? '' : _payload$bookingId,
      service = payload.service,
      _payload$action = payload.action,
      action = _payload$action === void 0 ? '' : _payload$action;
  var roomSelectionServicePayload = stringify_object__WEBPACK_IMPORTED_MODULE_0___default()(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'roomSelectionServicePayload', null), {
    singleQuotes: false
  });
  var stringifiedService = stringify_object__WEBPACK_IMPORTED_MODULE_0___default()({
    amount: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'amount', null),
    currency: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'currency', null)
  }, {
    singleQuotes: false
  });
  return "query {\n    prePayment(bookingId: \"".concat(bookingId, "\", service: ").concat(stringifiedService, ", roomSelectionServicePayload:").concat(roomSelectionServicePayload, ", action:\"").concat(action, "\") {\n      due {\n        value\n        formattedValue(precision: 2)\n        currency\n      }\n      paymentSchedule {\n        deposit {\n          value\n          formattedValue(precision: 2)\n        }\n        remainingBalance {\n          value\n          formattedValue(precision: 2)\n        }\n        dueDate\n      }\n      bookingBalance(precision: 2)\n      serviceFormattedPrice(precision: 2)\n      remainingCreditBalance(precision: 2)\n    }\n  }");
}
function getFormDataQuery(_ref) {
  var bookingId = _ref.bookingId,
      providerId = _ref.providerId,
      redirectUri = _ref.redirectUri,
      amount = _ref.amount,
      currency = _ref.currency,
      service = _ref.service,
      redirectCancelUrl = _ref.redirectCancelUrl,
      responsive = _ref.responsive,
      paymentConditionId = _ref.paymentConditionId,
      action = _ref.action,
      tokenParam = _ref.token,
      isIframe = _ref.isIframe,
      iframeCallbackUrl = _ref.iframeCallbackUrl;
  var paymentConditionQuery = paymentConditionId ? "paymentConditionId : \"".concat(paymentConditionId, "\"") : '';
  var act = action ? "action: \"".concat(action, "\"") : '';
  var token = tokenParam ? "token: \"".concat(tokenParam, "\"") : '';
  return "mutation {\n    bookingsPaymentRedirect: bookingPaymentRedirect (\n      bookingId: \"".concat(bookingId, "\",\n      providerId:\"").concat(providerId, "\",\n      redirectUri: \"").concat(redirectUri, "\",\n      redirectCancelUrl:\"").concat(redirectCancelUrl, "\",\n      amount: ").concat(amount, ",\n      currency:\"").concat(currency, "\",\n      packages: ").concat(stringify_object__WEBPACK_IMPORTED_MODULE_0___default()(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'packages', []), {
    singleQuotes: false
  }), ",\n      additionalService:").concat(stringify_object__WEBPACK_IMPORTED_MODULE_0___default()(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'additionalService', null), {
    singleQuotes: false
  }), ",\n      roomSelectionServices:").concat(stringify_object__WEBPACK_IMPORTED_MODULE_0___default()(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(service, 'roomSelectionServicePayload', null), {
    singleQuotes: false
  }), ",\n      device: \"").concat(Object(_PrePayment_helpers__WEBPACK_IMPORTED_MODULE_2__[/* getDevice */ "c"])(responsive), "\"\n      ").concat(paymentConditionQuery, "\n      ").concat(act, "\n      ").concat(token, "\n      isIframePayment: ").concat((isIframe || false).toString(), "\n      iframeCallbackUrl: \"").concat(iframeCallbackUrl, "\"\n    ) {\n      url\n      fields\n      method\n      bookingId\n      customerId\n      orderId\n      price {\n        value\n      }\n    }\n  }");
}

/***/ }),

/***/ "1LK5":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ "1P7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFormattedLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCursorClass; });
function getFormattedLabel() {
  var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!placeholder) return '';
  return isRequired ? "".concat(placeholder, "*") : placeholder;
}
function getCursorClass(_ref) {
  var hasPointer = _ref.hasPointer,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly;
  if (isDisabled) return 'cursor-not-allowed';
  if (isReadOnly) return 'cursor-default';
  if (isLoading) return 'cursor-wait';
  return hasPointer ? 'cursor-pointer' : '';
}

/***/ }),

/***/ "1TCz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/next/app.js
var app = __webpack_require__("Khd+");
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/context/ToastContext.js
var ToastContext = __webpack_require__("waz2");

// EXTERNAL MODULE: ./src/client/router/routerContext.js
var routerContext = __webpack_require__("BncX");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// CONCATENATED MODULE: ./src/client/components/utils/responsive/constants.js
var APP_EVENTS = {
  MOUNTING: 'cm_app_mounting',
  MOUNTED: 'cm_app_mounted'
};
// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.helper.js
var Responsive_helper = __webpack_require__("GRjW");

// CONCATENATED MODULE: ./src/client/components/utils/responsive/Responsive.listener.js
/* eslint-env browser */

var componentsList = [];
var hasListener = false;

function shouldBreakpointChange(component, currentBreakpoint) {
  if (currentBreakpoint !== component.state.currentBreakpoint) {
    component.setState({
      currentBreakpoint: currentBreakpoint
    });
  }
}

function listener() {
  var currentBreakpoint = Object(Responsive_helper["a" /* getCurrentBreakpoint */])('', true);
  componentsList.map(function (component) {
    return shouldBreakpointChange(component, currentBreakpoint);
  });
}

function subscribe(component) {
  componentsList.push(component);

  if (!hasListener) {
    window.addEventListener('resize', listener);
    hasListener = true;
  }
}

function unsubscribe(component) {
  componentsList = componentsList.filter(function (item) {
    return item !== component;
  });

  if (!componentsList.length) {
    hasListener = false;
    window.removeEventListener('resize', listener);
  }
}


// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsive_responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/getCurrentResponsive.js
var getCurrentResponsive = __webpack_require__("ZCNJ");

// CONCATENATED MODULE: ./src/client/components/utils/responsive/ResponsiveLayout.jsx







var __jsx = react["createElement"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







 // prevent rerender of all component using ResponsiveContext when the breakpoint doesn't change

var memoizedGetCurrentResponsive = Object(lodash["memoize"])(getCurrentResponsive["a" /* default */]);

function sendEvent(name) {
  var event;

  if (typeof Event === 'function') {
    event = new Event(name);
  } else {
    event = document.createEvent('Event');
    event.initEvent(name, true, true);
  }

  document.dispatchEvent(event);
}

var ResponsiveLayout_ResponsiveLayout = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(ResponsiveLayout, _React$Component);

  var _super = _createSuper(ResponsiveLayout);

  function ResponsiveLayout(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ResponsiveLayout);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      currentBreakpoint: Object(Responsive_helper["a" /* getCurrentBreakpoint */])(_this.props.userAgent || '', false),
      isAppMounted: false
    });

    if ( true && !window.cmAppMounted) {
      sendEvent(APP_EVENTS.MOUNTING);
    }

    return _this;
  }

  Object(createClass["a" /* default */])(ResponsiveLayout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      subscribe(this);
      this.setState({
        currentBreakpoint: Object(Responsive_helper["a" /* getCurrentBreakpoint */])(this.props.userAgent || '', true),
        isAppMounted: true
      });

      if (!window.cmAppMounted) {
        // Dispatch the info that the app is mounted
        window.cmAppMounted = true;
        sendEvent(APP_EVENTS.MOUNTED);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      unsubscribe(this);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          currentBreakpoint = _this$state.currentBreakpoint,
          isAppMounted = _this$state.isAppMounted;
      return __jsx(responsive_responsiveContext["a" /* default */].Provider, {
        value: memoizedGetCurrentResponsive({
          currentBreakpoint: currentBreakpoint,
          isAppMounted: isAppMounted
        })
      }, children);
    }
  }]);

  return ResponsiveLayout;
}(react["Component"]);
// EXTERNAL MODULE: ./src/client/context/ResortListContext.js
var ResortListContext = __webpack_require__("7hcC");

// CONCATENATED MODULE: ./src/client/context/ResortListProvider.jsx







var ResortListProvider_jsx = react_default.a.createElement;

function ResortListProvider_createSuper(Derived) { var hasNativeReflectConstruct = ResortListProvider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function ResortListProvider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var ResortListProvider_ResortListProvider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ResortListProvider, _Component);

  var _super = ResortListProvider_createSuper(ResortListProvider);

  function ResortListProvider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ResortListProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      resortList: [],
      setResortList: function setResortList(resortList) {
        _this.setState({
          resortList: resortList
        });
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(ResortListProvider, [{
    key: "render",
    value: function render() {
      return ResortListProvider_jsx(ResortListContext["a" /* ResortListContext */].Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);

  return ResortListProvider;
}(react["Component"]);
// EXTERNAL MODULE: ./src/client/context/DepartureCitiesContext.js
var DepartureCitiesContext = __webpack_require__("l5FB");

// CONCATENATED MODULE: ./src/client/context/DepartureCitiesProvider.jsx







var DepartureCitiesProvider_jsx = react_default.a.createElement;

function DepartureCitiesProvider_createSuper(Derived) { var hasNativeReflectConstruct = DepartureCitiesProvider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function DepartureCitiesProvider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var DepartureCitiesProvider_DepartureCitiesProvider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(DepartureCitiesProvider, _Component);

  var _super = DepartureCitiesProvider_createSuper(DepartureCitiesProvider);

  function DepartureCitiesProvider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, DepartureCitiesProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      departureCities: [],
      setDepartureCities: function setDepartureCities(departureCities) {
        _this.setState({
          departureCities: departureCities
        });
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(DepartureCitiesProvider, [{
    key: "render",
    value: function render() {
      return DepartureCitiesProvider_jsx(DepartureCitiesContext["a" /* default */].Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);

  return DepartureCitiesProvider;
}(react["Component"]);


// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorageApi.js
var sessionStorageApi = __webpack_require__("9NGo");

// EXTERNAL MODULE: ./src/client/context/ABTestContext.js
var ABTestContext = __webpack_require__("hfZn");

// CONCATENATED MODULE: ./src/client/context/ABTestProvider.jsx








var ABTestProvider_jsx = react_default.a.createElement;

function ABTestProvider_createSuper(Derived) { var hasNativeReflectConstruct = ABTestProvider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function ABTestProvider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-env browser */





var ABTestProvider_isValidValues = function isValidValues(src, values) {
  return Object(lodash["isObject"])(values) && !Object(lodash["isEmpty"])(values) && !Object.entries(values).every(function (_ref) {
    var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return src[key] === value;
  });
};

var ABTEST_PREFIX = 'testAB.';
var ABTEST_EVENT = 'testAB';

var ABTestProvider_fetchABTestData = function fetchABTestData() {
  return Object(sessionStorageApi["a" /* getEntries */])().filter(function (_ref3) {
    var _ref4 = Object(slicedToArray["a" /* default */])(_ref3, 1),
        key = _ref4[0];

    return key.startsWith(ABTEST_PREFIX);
  }).reduce(function (acc, _ref5) {
    var _ref6 = Object(slicedToArray["a" /* default */])(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    return _objectSpread(_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, key.replace(ABTEST_PREFIX, ''), value.toString()));
  }, {});
};

var ABTestProvider_ABTestProvider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ABTestProvider, _Component);

  var _super = ABTestProvider_createSuper(ABTestProvider);

  function ABTestProvider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ABTestProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", _objectSpread({}, ABTestProvider_fetchABTestData()));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleEvent", function (e) {
      /**
       * TODO
       * When REACT 16 ready
       * this.setState((prevState) => isValidValues(prevState, e.values) ? { ...e.values } : null);
       */
      if (ABTestProvider_isValidValues(_this.state, e.values)) {
        _this.setState(function () {
          return _objectSpread({}, e.values);
        });
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(ABTestProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener(ABTEST_EVENT, this.handleEvent, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener(ABTEST_EVENT, this.handleEvent, false);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return ABTestProvider_jsx(ABTestContext["a" /* ABTestContext */].Provider, {
        value: this.state
      }, children ? react["Children"].only(children) : null);
    }
  }]);

  return ABTestProvider;
}(react["Component"]);


// CONCATENATED MODULE: ./src/client/app/AppProviders.jsx
var AppProviders_jsx = react["createElement"];










var AppProviders_AppProviders = function AppProviders(_ref) {
  var children = _ref.children,
      appContext = _ref.appContext,
      pageContext = _ref.pageContext,
      reduxStore = _ref.reduxStore,
      routerContextValue = _ref.routerContextValue,
      toastRef = _ref.toastRef;
  return AppProviders_jsx(ReactAppContext["a" /* default */].Provider, {
    value: appContext
  }, AppProviders_jsx(context_pageContext["a" /* ReactPageContext */].Provider, {
    value: pageContext
  }, AppProviders_jsx(es["a" /* Provider */], {
    store: reduxStore
  }, AppProviders_jsx(ABTestProvider_ABTestProvider, null, AppProviders_jsx(routerContext["a" /* routerContext */].Provider, {
    value: routerContextValue
  }, AppProviders_jsx(ResponsiveLayout_ResponsiveLayout, {
    userAgent: appContext.userAgent
  }, AppProviders_jsx(DepartureCitiesProvider_DepartureCitiesProvider, null, AppProviders_jsx(ResortListProvider_ResortListProvider, null, AppProviders_jsx(ToastContext["a" /* ToastContext */].Provider, {
    value: {
      ref: toastRef
    }
  }, children)))))))));
};
// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToHash.js
var scrollToHash = __webpack_require__("34at");

// EXTERNAL MODULE: ./src/hooks/use-previous/usePrevious.js
var usePrevious = __webpack_require__("AbLU");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/routing/constants.js
var constants = __webpack_require__("Uq20");

// CONCATENATED MODULE: ./src/client/store/routing/routing.actions.js


function routingChange() {
  return Object(createAction["b" /* default */])(constants["a" /* ROUTING_CHANGE */], {});
}
// EXTERNAL MODULE: ./src/client/store/booking/entry-route/entryroute.action.js
var entryroute_action = __webpack_require__("0Sn7");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/app/RouteChangeListener.jsx











var hasNavigated = false;
var RouteChangeListener_RouteChangeListener = function RouteChangeListener() {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history,
      location = _useRouter.location;

  var dispatch = Object(es["d" /* useDispatch */])();
  var previousLocation = Object(usePrevious["a" /* usePrevious */])(location);

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var scrollUnderNav = !isDesktop;
  var href = Object(uriUtils["b" /* convertLocationToHref */])(location);
  Object(react["useEffect"])(function () {
    dispatch(routingChange());

    if (location.hash) {
      scrollToHash["a" /* goToHash */](location.hash, scrollUnderNav);
    } else if (hasNavigated) {
      window.scrollTo(0, 0);
    }
  }, [href, location.hash]);
  Object(react["useEffect"])(function () {
    var showLoader = function showLoader(nextUri) {
      hasNavigated = true; // on the booking engine there is no loader between pages

      if (!(nextUri.startsWith('/booking/') && location.pathname.startsWith('/booking/'))) {
        var nextPath = new URI_default.a(nextUri).pathname();
        var previousPath = Object(uriUtils["c" /* convertLocationToURI */])(location).pathname();

        if (nextPath === previousPath) {
          dispatch(Object(globalLoader_action["d" /* startLoading */])('', false));
        } else {
          if (!nextUri.startsWith('/booking/')) {
            dispatch(Object(entryroute_action["b" /* unsetEntryRoute */])());
          } // startLoading second arg it here to handle scroll correctly after navigation
          // see Components/widgets/loading/Loading.jsx


          dispatch(Object(globalLoader_action["d" /* startLoading */])('', true));
        }
      }
    };

    var hideLoader = function hideLoader(nextUri) {
      // By default next triggers routeChangeComplete even on the first app mount
      // However, in the BookingEngine we show a loader while the content loads
      if (hasNavigated && !(nextUri.startsWith('/booking/') && previousLocation.pathname.startsWith('/booking/'))) {
        dispatch(Object(globalLoader_action["c" /* endLoading */])());
      }
    }; // Show the loader before each page transition, hide after


    history.events.on('routeChangeStart', showLoader);
    history.events.on('routeChangeComplete', hideLoader);
    return function () {
      history.events.off('routeChangeStart', showLoader);
      history.events.off('routeChangeComplete', hideLoader);
    };
  });
  return null;
};
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/detect-browser/index.js
var detect_browser = __webpack_require__("1ih8");

// EXTERNAL MODULE: ./config/index.js
var config_0 = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config_0);

// EXTERNAL MODULE: ./src/client/views/account/pre-payment/PrePayment.helpers.js
var PrePayment_helpers = __webpack_require__("XHSI");

// EXTERNAL MODULE: ./src/hooks/use-script-loader/useScriptLoader.js
var useScriptLoader = __webpack_require__("/WwO");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// CONCATENATED MODULE: ./src/client/chatbot/Chatbot.tracking.js


function Chatbot_tracking_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function Chatbot_tracking_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      Chatbot_tracking_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      Chatbot_tracking_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var CHATBOT_EVENTS = {
  INITIALIZED: 'chatbot-initialized',
  CLICKED_OPEN: 'chatbot-opened',
  CLICKED_CLOSE: 'chatbot-closed'
};
var Chatbot_tracking_trackChatbotEvent = function trackChatbotEvent(chatbotEventType, appContext, pageContext, location) {
  var pageId = pageContext.pageId;
  return Object(tracking_api["b" /* setDataLayer */])(Chatbot_tracking_objectSpread(Chatbot_tracking_objectSpread({}, tracking_constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
    categoryGA: 'chatbot',
    actionGA: chatbotEventType,
    labelGA: pageId || location.origin || 'unknown-context'
  }), appContext, pageId);
};
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./src/utils/invariant/invariant.js
var invariant = __webpack_require__("UQkB");

// EXTERNAL MODULE: ./src/client/local-storage-api/index.js
var local_storage_api = __webpack_require__("1RIK");

// CONCATENATED MODULE: ./src/client/chatbot/Chatbot.utils.js








var CHATBOT_AVATAR_PATH = '/medias/gentil-bot.svg';
var CHATBOT_LOCAL_STORAGE_KEY = 'BOTFUEL_WEBCHAT_USER_ID';

var _config$get = config_default.a.get('botfuel'),
    appToken = _config$get.appToken,
    apiUrl = _config$get.apiUrl; // localStorage API compatible with Botfuel webchat. For the Chatbot only.


function setInLocalStorage(key, value) {
  if (Object(local_storage_api["b" /* localStorageAvailable */])()) {
    localStorage.setItem(key, value);
  }
}

function getFromLocalStorage(key) {
  if (Object(local_storage_api["b" /* localStorageAvailable */])()) {
    return localStorage.getItem(key);
  }
}

function setUserId(googleTrackingId) {
  return new Promise(function (resolve) {
    if (googleTrackingId) {
      resolve(googleTrackingId);
    } else {
      var resolveTimestampedId = function resolveTimestampedId() {
        return resolve("NO.ID.".concat(Date.now()));
      };

      var requestAnimationFrame = dist["windowWrapper"].get('requestAnimationFrame');
      if (!requestAnimationFrame) return resolveTimestampedId();
      var start = null;

      var getGaId = function getGaId(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        var gaId = js_cookie_default.a.get('_ga');

        if (gaId) {
          resolve(gaId);
        } else if (progress < 3000) {
          // Try fetching the _ga cookie at next repaint during 3s max.
          // This delays the chatbot initialization but ensures
          // more users are properly identified by their GA ID.
          requestAnimationFrame(getGaId);
        } else {
          // Or use a timestamp ID
          resolveTimestampedId();
        }
      };

      requestAnimationFrame(getGaId);
    }
  }).then(function (userId) {
    setInLocalStorage(CHATBOT_LOCAL_STORAGE_KEY, userId);
    return true;
  });
}

function sendAppContext(_ref) {
  var pageContext = _ref.pageContext,
      deviceCategory = _ref.deviceCategory,
      location = _ref.location;
  var origin = location.origin;
  var pageId = pageContext.pageId,
      pageType = pageContext.pageType,
      pageMeta = pageContext.pageMeta,
      pageTitle = pageContext.pageTitle,
      pageDescription = pageContext.pageDescription;
  var user = getFromLocalStorage(CHATBOT_LOCAL_STORAGE_KEY);
  axios_default.a.post(apiUrl, {
    user: user,
    deviceCategory: deviceCategory,
    pageId: pageId,
    pageType: pageType,
    pageMeta: pageMeta,
    pageTitle: pageTitle,
    pageDescription: pageDescription,
    origin: origin
  }, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

function createChatbot() {
  var botConfig = {
    appToken: appToken,
    // extraAllowedOrigins: ['http://localhost:3000'],
    startOpen: false,
    startFullScreen: false,
    size: {
      width: 400,
      height: 600
    },
    labels: {
      sendButtonLabel: 'Envoyer',
      messageInputPlaceholder: 'Ecrivez votre message ici',
      webchatHeaderTitle: 'GentilBot ClubMed',
      helpMessage: 'Les services et activités de nos destinations 😀'
    },
    theme: {
      layout: {
        rounded: 0
      },
      buttons: {
        close: true,
        fullScreen: true
      },
      images: {
        botAvatar: "".concat(dist["windowWrapper"].getOrigin()).concat(CHATBOT_AVATAR_PATH),
        startButton: "".concat(dist["windowWrapper"].getOrigin()).concat(CHATBOT_AVATAR_PATH)
      },
      startButtonStyle: 'bubble',
      dialogStyle: 'hover',
      fixed: true
    },
    menuActions: [{
      label: "Demander de l'aide",
      message: {
        type: 'text',
        payload: {
          value: 'Aide'
        }
      }
    }, {
      label: 'Commencer une nouvelle conversation',
      message: {
        type: 'text',
        payload: {
          value: 'Recommencer'
        }
      }
    }],
    parseHTML: true,
    sanitizeDOM: false,
    voiceEnabled: false
  };
  var botfuelWebChat = dist["windowWrapper"].get('BotfuelWebChat');

  if (botfuelWebChat) {
    botfuelWebChat.init(botConfig);
  }

  return !!botfuelWebChat;
}
var Chatbot_utils_createFreespeeObserver = function createFreespeeObserver() {
  return new MutationObserver(function (mutations) {
    var chatbotMessageMutations = mutations.filter(function (mutation) {
      var addedNodes = mutation.addedNodes; // $FlowFixMe stupid typings

      return !Object(lodash["isEmpty"])(addedNodes) && Object.values(Object(lodash["last"])(addedNodes).classList).includes('bf-bot');
    }); // If there are between 1 and 3 new chatbot messages (excludes mutations from past conversation)

    if (!Object(lodash["isEmpty"])(chatbotMessageMutations) && chatbotMessageMutations.length < 3) {
      var _last = Object(lodash["last"])(chatbotMessageMutations),
          chatbotMessageNodes = _last.addedNodes; // $FlowFixMe stupid typings


      var chatbotMessageNode = Object(lodash["last"])(chatbotMessageNodes);

      if (chatbotMessageNode.innerHTML.includes('<span class="freespee-schedule-call">')) {
        var scheduleCallNode = document.getElementById('scheduleCall');
        scheduleCallNode && scheduleCallNode.click();
      }
    }
  });
};
var createBotFuelObserver = function createBotFuelObserver(callback) {
  var targetNode = document.querySelector('body');
  var observerOptions = {
    childList: true,
    attributes: false,
    subtree: true
  };
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // ChatbotFuel really initialized
      if (mutation.type === 'childList' && mutation.target.id === 'botfuel') {
        callback();
      }
    });
  });
  observer.observe(targetNode, observerOptions);
  setTimeout(function () {
    observer.disconnect();
  }, 5000);
};

function observeFreespee(freespeeObserver) {
  var observedNode = document.querySelector('.bf-message-list');
  freespeeObserver.observe(observedNode, {
    attributes: false,
    characterData: false,
    childList: true,
    subtree: false
  });
}

function disconnectFreespee(freespeeObserver) {
  freespeeObserver.disconnect();
} // We send the pageId when the user clicks/sends a message. This means that we need recreate the
// event listeners whenever the page url changes


var Chatbot_utils_setUpClickListeners = function setUpClickListeners(_ref2) {
  var sendAppContextCell = _ref2.sendAppContextCell,
      observerCell = _ref2.observerCell,
      trackingCell = _ref2.trackingCell,
      appContext = _ref2.appContext,
      pageContext = _ref2.pageContext,
      deviceCategory = _ref2.deviceCategory,
      location = _ref2.location;
  var startButton = document.querySelector('.bf-webchat-start-button');
  var closeButton = document.querySelector('.bf-webchat-close-button');

  if (startButton && closeButton) {
    // If listeners already exists (from a previous page), recreate them
    if (sendAppContextCell.current) {
      startButton.removeEventListener('click', sendAppContextCell.current);
    }

    if (trackingCell.open) {
      startButton.removeEventListener('click', trackingCell.open);
    }

    if (trackingCell.close) {
      closeButton.removeEventListener('click', trackingCell.close);
    } // Setup appContext click listeners


    var send = function send() {
      return sendAppContext({
        pageContext: pageContext,
        deviceCategory: deviceCategory,
        location: location
      });
    };

    startButton.addEventListener('click', send);
    sendAppContextCell.current = send; // Setup Freespee observer click listeners

    var observer = observerCell.current;
    Object(invariant["a" /* invariant */])(observer, 'The MutationObserver should always be defined');
    startButton.addEventListener('click', function () {
      return observeFreespee(observer);
    });
    closeButton.addEventListener('click', function () {
      return disconnectFreespee(observer);
    }); // Setup Chatbot Tracking click listeners

    var trackOpen = function trackOpen() {
      return Chatbot_tracking_trackChatbotEvent(CHATBOT_EVENTS.CLICKED_OPEN, appContext, pageContext, location);
    };

    startButton.addEventListener('click', trackOpen);
    trackingCell.open = trackOpen;

    var trackClose = function trackClose() {
      return Chatbot_tracking_trackChatbotEvent(CHATBOT_EVENTS.CLICKED_CLOSE, appContext, pageContext, location);
    };

    closeButton.addEventListener('click', trackClose);
    trackingCell.close = trackClose;
    var startButtonChid = startButton && startButton.firstChild;
    startButtonChid && startButtonChid.click();
  }
};
// CONCATENATED MODULE: ./src/client/chatbot/Chatbot.jsx











var Chatbot_config$get = config_default.a.get('botfuel'),
    scriptUrl = Chatbot_config$get.scriptUrl;

var Chatbot_observerCell = {
  current: null
};
var Chatbot_sendAppContextCell = {
  current: null
};
var Chatbot_trackingCell = {
  open: null,
  close: null
};
var Chatbot_Chatbot = function Chatbot(_ref) {
  var setShowFakeBtn = _ref.setShowFakeBtn;

  var _useScriptLoader = Object(useScriptLoader["a" /* useScriptLoader */])(scriptUrl),
      scriptsLoadedSuccessfully = _useScriptLoader.scriptLoaded;

  var pageContext = react["useContext"](context_pageContext["a" /* ReactPageContext */]);
  var appContext = react["useContext"](ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var responsiveContext = react["useContext"](responsive_responsiveContext["a" /* default */]);
  var deviceCategory = Object(PrePayment_helpers["c" /* getDevice */])(responsiveContext).toLowerCase();
  react["useEffect"](function () {
    if (!scriptsLoadedSuccessfully) return; // create the chatbot & the MutationObserver only once

    Chatbot_observerCell.current = Chatbot_utils_createFreespeeObserver();
    setUserId(appContext.googleTrackingId).then(function () {
      // create the BotFuelObserver to track the DOM insersion of the real chatbot
      createBotFuelObserver(function () {
        Chatbot_tracking_trackChatbotEvent(CHATBOT_EVENTS.INITIALIZED, appContext, pageContext, location);
        Chatbot_utils_setUpClickListeners({
          observerCell: Chatbot_observerCell,
          sendAppContextCell: Chatbot_sendAppContextCell,
          trackingCell: Chatbot_trackingCell,
          appContext: appContext,
          pageContext: pageContext,
          deviceCategory: deviceCategory,
          location: location
        });
        setShowFakeBtn(false);
      });
      createChatbot();
    });
  }, [pageContext.pageId, deviceCategory, scriptsLoadedSuccessfully]);
  return null;
};
// CONCATENATED MODULE: ./src/client/chatbot/ChatbotContainer.jsx
var ChatbotContainer_jsx = react_default.a.createElement;






var ChatbotContainer_CHATBOT_AVATAR_PATH = '/medias/gentil-bot.svg';

var ChatbotContainer_config$get = config_default.a.get('botfuel'),
    chatbotEnabled = ChatbotContainer_config$get.enabled,
    chatbotPages = ChatbotContainer_config$get.enabledPages;

var chatBotStyle = {
  backgroundImage: "url(\"".concat(ChatbotContainer_CHATBOT_AVATAR_PATH, "\")"),
  bottom: '20px',
  boxShadow: '0 2px 5px 0 rgba(0,0,0,.25)',
  cursor: 'pointer',
  height: '65px',
  right: '20px',
  width: '65px',
  zIndex: '6'
};

function isCompatibleWithChatbot() {
  var browser = Object(detect_browser["detect"])();
  return browser.name !== 'ie' && browser.name !== 'edge';
}

var ChatbotContainer_ChatbotContainer = function ChatbotContainer() {
  var _useState = Object(react["useState"])(false),
      loadChatbot = _useState[0],
      setLoadChatbot = _useState[1];

  var _useState2 = Object(react["useState"])(true),
      showFakeChatbotBtn = _useState2[0],
      setShowFakeChatbotBtn = _useState2[1];

  var responsiveContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);

  if (!responsiveContext.isAppMounted || !isCompatibleWithChatbot()) {
    return null;
  } // Livechat Dydu "do you dream up" could be inecjected by GTM


  var activeOnThisPage = chatbotPages.split(',').includes(pageContext.pageType);
  var isDyduLivechatActive = document.getElementById('dydu-popin') || document.getElementById('dydu-teaser');
  var chatbotDiv = document.getElementById('botfuel');

  if (chatbotEnabled && activeOnThisPage && !isDyduLivechatActive) {
    if (chatbotDiv) {
      chatbotDiv.style && (chatbotDiv.style.display = 'block');
      return null;
    }

    return ChatbotContainer_jsx(react["Fragment"], null, loadChatbot && ChatbotContainer_jsx(Chatbot_Chatbot, {
      setShowFakeBtn: setShowFakeChatbotBtn
    }), showFakeChatbotBtn && ChatbotContainer_jsx("div", {
      className: "rounded-full fixed",
      style: chatBotStyle,
      "data-testid": "chatbot-button",
      onClick: function onClick() {
        return setLoadChatbot(true);
      }
    }));
  }

  chatbotDiv && chatbotDiv.style && (chatbotDiv.style.display = 'none');
  return null;
};
// CONCATENATED MODULE: ./src/client/router/createRouterLocation.js


function createRouterLocation_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function createRouterLocation_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      createRouterLocation_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      createRouterLocation_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var createRouterLocation_createRouterLocation = function createRouterLocation(_ref) {
  var asPath = _ref.asPath,
      query = _ref.query,
      originalUrl = _ref.originalUrl;
  var uri = new URI_default.a(asPath);
  var urlParams = {};
  var queryParams = {};
  /*
   * Due to a next-route implementation with a weird `.join('/')`
   * we need to check if the current query param has a slash as separator
   * and split it into an array.
   * cf: https://github.com/fridays/next-routes/issues/250
   */

  for (var queryParameter in query) {
    if (uri.hasSearch(queryParameter)) {
      queryParams[queryParameter] = query[queryParameter];
    } else {
      urlParams[queryParameter] = query[queryParameter];
    }
  }

  return {
    origin: true ? window.location.origin : undefined,
    pathname: uri.pathname(),
    hash: uri.hash(),
    urlParams: urlParams,
    queryParams: queryParams
  };
};
var createRouterLocation_updateShallowQueryParams = function updateShallowQueryParams(_ref2) {
  var location = _ref2.location,
      href = _ref2.href;
  if (!href) return location;
  var uri = Object(uriUtils["c" /* convertLocationToURI */])(location); // We cannot reconstruct the URL simply from href since the front-end doesn't know what routes can
  // be rewritten (/r/Bali/y is {urlParams: { dynamicPage: '/r/Bali/y }})

  var currentUri = new URI_default.a(href);
  var newQueryParams = location.queryParams;
  var queryParamsList = Object.keys(uri.query(true));
  var currentQueryParamsList = Object.keys(currentUri.query(true)); // delete query params which are no longer in the new uri

  for (var queryParamName in uri.query(true)) {
    if (!currentQueryParamsList.includes(queryParamName)) {
      delete newQueryParams[queryParamName];
    }
  } // add missing query params or update the current ones


  for (var _queryParamName in currentUri.query(true)) {
    if (!queryParamsList.includes(_queryParamName) || newQueryParams[_queryParamName] !== currentUri.query(true)[_queryParamName]) {
      newQueryParams[_queryParamName] = currentUri.query(true)[_queryParamName];
    }
  }

  return createRouterLocation_objectSpread(createRouterLocation_objectSpread({}, location), {}, {
    queryParams: newQueryParams
  });
};
// EXTERNAL MODULE: ./src/client/store/toast/toast.actions.js
var toast_actions = __webpack_require__("7Z8V");

// EXTERNAL MODULE: ./src/client/components/frameworks/toast/Toast.jsx
var Toast = __webpack_require__("0x7Y");

// CONCATENATED MODULE: ./src/client/components/frameworks/toast/Toast.container.jsx



function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = state.toast || {},
      shouldDisplay = _ref.shouldDisplay,
      label = _ref.label,
      icon = _ref.icon,
      color = _ref.color,
      className = _ref.className;

  return {
    visible: shouldDisplay,
    className: className,
    label: label,
    icon: icon,
    color: color
  };
}
var mapDispatchToProps = {
  onClose: toast_actions["c" /* closeToast */]
};
var ToastContainer = Object(es["c" /* connect */])(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(Toast["a" /* Toast */]);
// CONCATENATED MODULE: ./src/client/components/layouts/head-info/HeadInfos.jsx
var HeadInfos_jsx = react_default.a.createElement;



var HeadInfos_HeadInfos = function HeadInfos() {
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  return HeadInfos_jsx(react["Fragment"], null, HeadInfos_jsx(head_default.a, null, HeadInfos_jsx("meta", {
    name: "description",
    content: pageContext.pageDescription || ''
  }), HeadInfos_jsx("link", {
    rel: "canonical",
    href: pageContext.canonicalUrl
  }), (pageContext.hrefLang || []).filter(function (hrefLang) {
    return hrefLang.url && hrefLang.locale;
  }).map(function (_ref) {
    var locale = _ref.locale,
        url = _ref.url;
    return HeadInfos_jsx("link", {
      key: "".concat(locale, "_").concat(url),
      rel: "alternate",
      hrefLang: locale,
      href: url
    });
  })));
};
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/user-info/hoc/UserInfo.jsx
var UserInfo = __webpack_require__("EEuM");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// CONCATENATED MODULE: ./src/client/components/widgets/crisis-alert/CrisisAlertLinkBanner.jsx
var CrisisAlertLinkBanner_jsx = react_default.a.createElement;









var CRISIS_ALERT_LOCALSTORAGE_KEY = 'dismissGlobalAlert';
var CrisisAlertLinkBanner_CrisisAlertLinkBanner = function CrisisAlertLinkBanner(_ref) {
  var alertDate = _ref.alertDate,
      className = _ref.className,
      linkLabel = _ref.linkLabel,
      linkUrl = _ref.linkUrl;

  var _useResponsive = Object(responsive_responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  var _useState = Object(react["useState"])(true),
      shouldDisplay = _useState[0],
      setShouldDisplay = _useState[1];

  if (!isAppMounted) {
    return null;
  }

  if (!shouldDisplay || Object(lodash["isEmpty"])(alertDate) || Object(lodash["isEmpty"])(linkLabel) || Object(local_storage_api["a" /* getFromLocalStorage */])(CRISIS_ALERT_LOCALSTORAGE_KEY) === alertDate) {
    return null;
  }

  return CrisisAlertLinkBanner_jsx("div", {
    className: classnames_default()(className, 'bg-white flex items-center max-w-full p-px10 rtl:pr-8 relative rounded-small shadow')
  }, CrisisAlertLinkBanner_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0",
    color: colors["a" /* COLORS */].ORANGE,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "1.875rem"
  }), CrisisAlertLinkBanner_jsx(TextLink["a" /* TextLink */], {
    className: "underline rtl:ml-5",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    iconRightName: null,
    label: linkLabel,
    url: linkUrl
  }), CrisisAlertLinkBanner_jsx("button", {
    className: "reset-button absolute leading-none p-px10 top-0 rtl:right-0",
    onClick: function onClick() {
      Object(local_storage_api["d" /* setInLocalStorage */])(CRISIS_ALERT_LOCALSTORAGE_KEY, alertDate);
      setShouldDisplay(false);
    },
    type: "button"
  }, CrisisAlertLinkBanner_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.625rem"
  })));
};
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// CONCATENATED MODULE: ./src/client/components/widgets/promotional-banner/promo-banner/PromoBanner.jsx

var PromoBanner_jsx = react_default.a.createElement;








function PromoBanner(props) {
  var _props$bgColor = props.bgColor,
      bgColor = _props$bgColor === void 0 ? colors["a" /* COLORS */].GRENADINE : _props$bgColor,
      className = props.className,
      closeLabel = props.closeLabel,
      countdown = props.countdown,
      description = props.description,
      iconName = props.iconName,
      innerRef = props.innerRef,
      label = props.label,
      link = props.link,
      onClose = props.onClose,
      title = props.title,
      _props$titleColor = props.titleColor,
      titleColor = _props$titleColor === void 0 ? colors["a" /* COLORS */].WHITE : _props$titleColor,
      trackingData = props.trackingData,
      trackingDataClose = props.trackingDataClose;
  if (!title) return null;
  return PromoBanner_jsx("aside", {
    className: classnames_default()(className, "bg-".concat(bgColor, " px-4 relative shadow w-full")),
    ref: innerRef
  }, PromoBanner_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    as: DynamicLink["a" /* default */]
  }, link, {
    trackingData: trackingData,
    className: "block"
  }), PromoBanner_jsx("div", {
    className: "flex flex-col lg:flex-row items-center justify-center -mx-1 py-3"
  }, countdown && PromoBanner_jsx(Countdown["a" /* Countdown */], Object(esm_extends["a" /* default */])({}, countdown, {
    size: "small",
    className: "mb-2 lg:mb-0 mx-1"
  })), PromoBanner_jsx("div", {
    className: "flex flex-col lg:flex-row items-center lg:items-baseline justify-center text-center lg:text-initial text-white"
  }, !!iconName && PromoBanner_jsx(Icon["a" /* Icon */], {
    className: "mx-1 hidden lg:block self-center",
    color: colors["a" /* COLORS */].WHITE,
    name: iconName,
    width: "2.2rem"
  }), !!label && PromoBanner_jsx("p", {
    className: "reset-paragraph hidden font-brand lg:block mx-2",
    "data-testid": "PromoBanner-label"
  }, label), PromoBanner_jsx("h2", {
    className: "reset-heading font-brand text-lg lg:text-2xl mx-2 text-".concat(titleColor, " text-shadow underline uppercase"),
    "data-testid": "PromoBanner-title"
  }, title), !!description && PromoBanner_jsx("p", {
    className: "reset-paragraph mt-1 lg:mt-0 mx-2 text-sm",
    "data-testid": "PromoBanner-description"
  }, description)))), PromoBanner_jsx(TrackClick["a" /* TrackClick */], {
    as: "button",
    className: "reset-button absolute leading-none rtl:mr-2 p-3 top-0 rtl:right-0",
    onClick: onClose,
    trackingData: trackingDataClose,
    type: "button"
  }, PromoBanner_jsx("span", {
    className: "sr-only"
  }, closeLabel), PromoBanner_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].WHITE,
    name: icons["a" /* ICONS */].CROSS,
    width: "0.625rem"
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/promotional-banner/PromotionalBanner.jsx


var PromotionalBanner_jsx = react_default.a.createElement;






var PROMOTIONALBANNER_LOCALSTORAGE_KEY = 'disablePromotionalBanner';

function checkDuration() {
  var storaged = Object(local_storage_api["a" /* getFromLocalStorage */])(PROMOTIONALBANNER_LOCALSTORAGE_KEY);
  if (!storaged) return true;
  var now = Date.now();
  var storagedDate = new Date(Number(storaged));
  var tomorrow = storagedDate.setDate(storagedDate.getDate() + 1);
  return now - tomorrow > 0;
}

var PromotionalBanner_PromotionalBannerClass = function PromotionalBannerClass(_ref) {
  var _ref$enabledPages = _ref.enabledPages,
      enabledPages = _ref$enabledPages === void 0 ? [] : _ref$enabledPages,
      _ref$disabledPages = _ref.disabledPages,
      disabledPages = _ref$disabledPages === void 0 ? [] : _ref$disabledPages,
      bannerProps = Object(objectWithoutProperties["a" /* default */])(_ref, ["enabledPages", "disabledPages"]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var responsiveContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]);

  var pageMatch = function pageMatch(pages) {
    var pageId = pageContext.pageId;
    return pages.some(function (page) {
      return page && ( // testing pages that correspond to a resort/tour
      pageId === "resort-".concat(page.toUpperCase()) || pageId === "tour-".concat(page.toUpperCase()) || // pages that correspond to a url
      location.pathname === page || location.pathname.startsWith("".concat(page, "/")));
    });
  };

  var isPageEnabled = enabledPages.length ? pageMatch(enabledPages) : true;
  var isPageDisabled = disabledPages.length ? pageMatch(disabledPages) : false;

  var shouldBeDisplayed = function shouldBeDisplayed() {
    return responsiveContext.isAppMounted && checkDuration() && isPageEnabled && !isPageDisabled;
  };

  var _useState = Object(react["useState"])(shouldBeDisplayed()),
      isDisplayed = _useState[0],
      setDisplay = _useState[1];

  Object(react["useEffect"])(function () {
    setDisplay(shouldBeDisplayed());
  }, [enabledPages, responsiveContext]);

  var disable = function disable() {
    setDisplay(false);
    Object(local_storage_api["d" /* setInLocalStorage */])(PROMOTIONALBANNER_LOCALSTORAGE_KEY, Date.now());
  };

  if (!isDisplayed) {
    return null;
  }

  var trackingData = {
    event: 'eventGA',
    categoryGA: 'promoBanner',
    labelGA: bannerProps.title,
    actionGA: 'click',
    valueGA: '0',
    nonInteraction: '0'
  };
  var trackingDataClose = {
    event: 'eventGA',
    categoryGA: 'promoBanner',
    labelGA: bannerProps.title,
    actionGA: 'close',
    valueGA: '0',
    nonInteraction: '0'
  };
  return PromotionalBanner_jsx(PromoBanner, Object(esm_extends["a" /* default */])({}, bannerProps, {
    onClose: disable,
    trackingData: trackingData,
    trackingDataClose: trackingDataClose
  }));
}; // $FlowFixMe


var PromotionalBanner = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  return PromotionalBanner_jsx(PromotionalBanner_PromotionalBannerClass, Object(esm_extends["a" /* default */])({
    innerRef: ref
  }, props));
});
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/Navigation.tracking.js
var categoryGA = 'headerMenu';
var NAVIGATION_TRACKING_LOGO_BUTTON = {
  categoryGA: categoryGA,
  actionGA: 'header_logo',
  labelGA: null // to override any value coming from previous tracking

};
var NAVIGATION_TRACKING_CONTACT_BUTTON = {
  categoryGA: categoryGA,
  actionGA: 'header_contact',
  labelGA: 'clickToCall'
};
var NAVIGATION_TRACKING_SEARCH_BUTTON = {
  categoryGA: 'headerMenu',
  actionGA: 'header_search'
};
var getNavigationCallCenterButtonTrackingData = function getNavigationCallCenterButtonTrackingData(label) {
  return {
    categoryGA: categoryGA,
    actionGA: 'header_contact',
    labelGA: label
  };
};
var getNavigationLanguagesButtonTrackingData = function getNavigationLanguagesButtonTrackingData(label) {
  return {
    categoryGA: categoryGA,
    actionGA: 'header_language',
    labelGA: label
  };
};
var getNavigationItemLinkTrackingData = function getNavigationItemLinkTrackingData(label) {
  return {
    categoryGA: categoryGA,
    actionGA: "header_".concat(label),
    labelGA: label
  };
};
var getNavigationSubItemLinkTrackingData = function getNavigationSubItemLinkTrackingData(_ref) {
  var label = _ref.label,
      parentLabel = _ref.parentLabel;
  return {
    categoryGA: categoryGA,
    actionGA: "header_".concat(parentLabel),
    labelGA: label
  };
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/Navigation.mapper.js




function mapSubItemsProps(parentLabel, items, index) {
  if (Object(lodash["isEmpty"])(items)) return [];
  return items.map(function (item, subIndex) {
    var dataLabel = "".concat(parentLabel, "_").concat(Object(lodash["camelCase"])(item.label));
    var subItemsProps = {
      id: "".concat(index).concat(subIndex),
      color: item.color || colors["a" /* COLORS */].GRAY_DARKER,
      hasImageBorder: item.frameForExclusiveCollection,
      label: item.label,
      link: {
        url: item.url,
        trackingData: getNavigationSubItemLinkTrackingData({
          label: dataLabel,
          parentLabel: parentLabel.split('_')[0]
        })
      },
      seeMoreLabel: item.seeMoreLabel || ''
    };

    if (!Object(lodash["isEmpty"])(item.imageUrl)) {
      subItemsProps.thumbnail = {
        imageUrl: item.imageUrl
      };
    }

    if (!Object(lodash["isEmpty"])(item.subItems)) {
      subItemsProps.subItems = mapSubItemsProps(dataLabel, item.subItems, "".concat(index).concat(subIndex));
    }

    return subItemsProps;
  });
}

var Navigation_mapper_buildNavigationMenuItems = function buildNavigationMenuItems(menus) {
  if (!menus || !menus.length) {
    return [];
  }

  return menus.map(function (menu, index) {
    return {
      color: menu.color || colors["a" /* COLORS */].GRAY_DARKER,
      id: "".concat(index),
      label: menu.label,
      link: {
        url: menu.url,
        trackingData: getNavigationItemLinkTrackingData(Object(lodash["camelCase"])(menu.label))
      },
      isList: menu.type === 'subItemsList',
      subItems: mapSubItemsProps(Object(lodash["camelCase"])(menu.label), menu.items, index)
    };
  });
};
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react-focus-on/dist/es2015/Combination.js + 8 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// CONCATENATED MODULE: ./src/client/components/utils/languages/SwitchLanguageModel.js


var SwitchLanguageModel_jsx = react["createElement"];


function getUrl(locale) {
  return '/?locale=' + locale;
}

function SwitchLanguageModel_getLocales(localesConfig) {
  return Object.keys(localesConfig);
}

function getSwitchLocale(localesConfig, currentLocale) {
  return SwitchLanguageModel_getLocales(localesConfig).filter(function (locale) {
    return locale !== currentLocale;
  })[0];
}

var SwitchLanguageModel_SwitchLanguage = /*#__PURE__*/function () {
  function SwitchLanguage(availableLocalesConfig, currentLocale) {
    Object(classCallCheck["a" /* default */])(this, SwitchLanguage);

    this.localesConfig = availableLocalesConfig;
    this.currentLocale = currentLocale;
  }

  Object(createClass["a" /* default */])(SwitchLanguage, [{
    key: "getAvailableLocales",
    value: function getAvailableLocales() {
      return this.localesConfig;
    }
  }, {
    key: "getCurrentLocaleLabel",
    value: function getCurrentLocaleLabel() {
      return this.localesConfig[this.currentLocale].label;
    }
  }, {
    key: "getSwitchLocaleLabel",
    value: function getSwitchLocaleLabel() {
      return this.localesConfig[getSwitchLocale(this.localesConfig, this.currentLocale)].label;
    }
  }, {
    key: "getLabelWithUrls",
    value: function getLabelWithUrls() {
      var _this = this;

      return Object.keys(this.localesConfig).map(function (locale) {
        return {
          label: _this.localesConfig[locale].label,
          countryCode: _this.localesConfig[locale].PAYS,
          langCode: _this.localesConfig[locale].LANG,
          languageNativeName: _this.localesConfig[locale].languageNativeName,
          moment: _this.localesConfig[locale].moment,
          url: getUrl(locale)
        };
      });
    }
  }, {
    key: "getSwitchUrl",
    value: function getSwitchUrl() {
      return getUrl(getSwitchLocale(this.localesConfig, this.currentLocale));
    }
  }, {
    key: "isMultiLanguage",
    value: function isMultiLanguage() {
      return SwitchLanguageModel_getLocales(this.localesConfig).length > 1;
    }
    /* todo: es6 : make this class iterable */

  }, {
    key: "map",
    value: function map(mapper) {
      var _this2 = this;

      var mapping = function mapping() {
        return _this2.getLabelWithUrls().map(mapper);
      };

      return this.or(mapping.bind(this));
    }
  }, {
    key: "or",
    value: function or(callback) {
      return this.isMultiLanguage() ? callback() : SwitchLanguageModel_jsx("noscript", null);
    }
  }]);

  return SwitchLanguage;
}();

/* harmony default export */ var SwitchLanguageModel = (SwitchLanguageModel_SwitchLanguage);
// CONCATENATED MODULE: ./src/client/components/widgets/languages/Languages.themes.js
var themes = {
  inline: {
    thRoot: 'inline-flex items-center justify-around whitespace-no-wrap',
    thItemFirst: 'border-l-0 border-gray-light capitalize flex-1 text-center text-gray-dark',
    thItem: 'border-l-1 border-gray-light capitalize flex-1 text-center text-gray-dark',
    thItemCurrent: 'font-bold text-gray-darker',
    thLink: 'inline-block py-1 px-3 focus:underline hover:underline whitespace-no-wrap'
  },
  column: {
    thRoot: '',
    thItemFirst: 'border-t-0 border-gray-light capitalize text-center text-gray-dark',
    thItem: 'border-t-1 border-gray-light capitalize text-center text-gray-dark',
    thItemCurrent: 'font-bold text-gray-darker',
    thLink: 'block p-2 focus:underline hover:underline whitespace-no-wrap'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/languages/Languages.jsx

var Languages_jsx = react_default.a.createElement;






function Languages(props) {
  var className = props.className,
      _props$currentLocale = props.currentLocale,
      currentLocale = _props$currentLocale === void 0 ? '' : _props$currentLocale,
      getTrackingData = props.getTrackingData,
      isActive = props.isActive,
      locales = props.locales,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'inline' : _props$theme;
  if (Object(lodash["isEmpty"])(locales)) return null;
  var _themes$theme = themes[theme],
      thItem = _themes$theme.thItem,
      thItemCurrent = _themes$theme.thItemCurrent,
      thItemFirst = _themes$theme.thItemFirst,
      thLink = _themes$theme.thLink,
      thRoot = _themes$theme.thRoot;
  var currentLangCode = currentLocale.split('-')[0].toUpperCase();
  var languages = new SwitchLanguageModel(locales, currentLocale);
  return Languages_jsx("ul", {
    className: classnames_default()(className, 'reset-list', thRoot)
  }, languages.map(function () {
    var localeInfos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var idx = arguments.length > 1 ? arguments[1] : undefined;
    var isCurrentItem = currentLangCode === localeInfos.langCode;
    var label = localeInfos.moment ? localeInfos.moment.slice(0, 2) : localeInfos.label;
    return Languages_jsx("li", {
      key: "".concat(localeInfos.countryCode, "-").concat(localeInfos.langCode),
      className: classnames_default()(idx === 0 ? thItemFirst : thItem, Object(defineProperty["a" /* default */])({}, "".concat(thItemCurrent), isCurrentItem))
    }, Languages_jsx(TrackClick["a" /* TrackClick */], {
      as: "a",
      "aria-current": isCurrentItem,
      "aria-label": "".concat(label, " ").concat(localeInfos.languageNativeName),
      className: classnames_default()('reset-anchor', thLink),
      "data-testid": "Languages-link",
      href: localeInfos.url,
      lang: localeInfos.moment,
      tabIndex: isActive ? 0 : -1,
      trackingData: getTrackingData ? getTrackingData(localeInfos.url.replace('/?locale=', '')) : null
    }, localeInfos.label));
  }));
}
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/hooks/use-autocomplete/useAutocomplete.js
var useAutocomplete = __webpack_require__("aUQU");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/FacetSearch.utils.js
var FacetSearch_utils = __webpack_require__("hPQF");

// EXTERNAL MODULE: ./src/client/store/faceting/facetingSearch.action.js
var facetingSearch_action = __webpack_require__("loSl");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackSearchResults.js
var useTrackSearchResults = __webpack_require__("NrqW");

// EXTERNAL MODULE: ./src/client/store/faceting/faceting.selector.js + 1 modules
var faceting_selector = __webpack_require__("vIa8");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchQuery.jsx



var GlobalSearchQuery_jsx = react_default.a.createElement;

function GlobalSearchQuery_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function GlobalSearchQuery_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { GlobalSearchQuery_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { GlobalSearchQuery_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






















var redirection = 'redirection_suggestedRequest';
var GlobalSearchQuery_ReferencedSearchQuery = function ReferencedSearchQuery(props) {
  var autocompleteQuery = props.autocompleteQuery,
      clearGlobalSearch = props.clearGlobalSearch,
      facetingSuggestedRequests = props.facetingSuggestedRequests,
      onChangeQuery = props.onChangeQuery,
      searchInputRef = props.searchInputRef,
      trackingData = props.trackingData;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      isSeller = _useContext.isSeller;

  var _useContext2 = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext2.isDesktop;

  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);
  var kidsValidationState = Object(es["e" /* useSelector */])(faceting_selector["k" /* getKidsValidationState */]);
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var trackSearchResults = Object(useTrackSearchResults["a" /* useTrackSearchResults */])();
  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'layer'
  });
  var buttonSize = isDesktop ? 'large' : 'medium';
  var containerPadding = isDesktop ? {
    paddingLeft: '15%',
    paddingRight: '15%'
  } : {};
  var splitSuggests = Object(lodash["chunk"])(Object(toConsumableArray["a" /* default */])(facetingSuggestedRequests.items), 2);
  var hasSuggestRequests = !!splitSuggests.length;
  return GlobalSearchQuery_jsx("div", {
    className: "bg-white",
    style: containerPadding
  }, GlobalSearchQuery_jsx("div", {
    className: classnames_default()('m-auto max-w-site w-full py-6 flex flex-no-wrap items-stretch justify-between border-0 border-gray-light', {
      'border-b-1': isDesktop && !!autocompleteQuery || !isDesktop && hasSuggestRequests && !autocompleteQuery
    })
  }, GlobalSearchQuery_jsx("div", {
    className: "flex-grow h-12 lg:h-16"
  }, GlobalSearchQuery_jsx("label", {
    className: "block pb-1 text-sm lg:text-md text-gray-medium transition-color",
    htmlFor: "global-search-query-input"
  }, Object(lodash["upperFirst"])(Object(i18n["f" /* t */])('faceting.autocomplete.enterYourSearch'))), GlobalSearchQuery_jsx("input", {
    className: "reset-input text-current cursor-pointer w-full leading-normal font-bold text-xl lg:text-2xl text-gray",
    id: "global-search-query-input",
    "data-testid": "global-search-input",
    onChange: onChangeQuery,
    placeholder: Object(i18n["f" /* t */])('faceting.searchTitle'),
    ref: searchInputRef,
    type: "search",
    value: autocompleteQuery
  })), GlobalSearchQuery_jsx("div", {
    className: "flex justify-end",
    style: {
      minWidth: isDesktop ? 190 : 110
    }
  }, GlobalSearchQuery_jsx(Button["a" /* Button */], {
    className: "self-center flex-none ml-1 lg:ml-2 lg:justify-center lg:leading-none",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].BLUE,
    colorBorder: colors["a" /* COLORS */].BLUE,
    dataTestId: "global-search-search-button",
    isExternalLink: false,
    minWidth: "initial",
    onClick: function onClick() {
      var query = {
        label: autocompleteQuery
      };
      Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
        criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
        location: location,
        searchCriteria: {
          query: query,
          departureCity: departureCity,
          departureDate: departureDate,
          duration: duration,
          keywords: '',
          kids: kids,
          kidsValidationState: kidsValidationState
        },
        searchPageRouteName: 'search'
      });
      dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(query));
      clearGlobalSearch();
    },
    size: buttonSize,
    style: {
      flexBasis: isDesktop ? 80 : 50
    },
    trackingData: {
      categoryGA: 'layer',
      actionGA: 'search',
      labelGA: 'validate',
      searchReferrer: 'layer'
    },
    url: autocompleteQuery ? "/s?search=".concat(autocompleteQuery) : '/s'
  }, GlobalSearchQuery_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS,
    width: "1rem"
  })), GlobalSearchQuery_jsx(Button["a" /* Button */], {
    className: "self-center flex-none ml-1 lg:ml-2 lg:justify-center lg:leading-none",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].GRAY_MEDIUM,
    dataTestId: "global-search-close-button",
    minWidth: "initial",
    onClick: clearGlobalSearch,
    size: buttonSize,
    style: {
      flexBasis: isDesktop ? 80 : 50
    },
    trackingData: GlobalSearchQuery_objectSpread(GlobalSearchQuery_objectSpread({}, trackingData), {}, {
      labelGA: 'close'
    })
  }, GlobalSearchQuery_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    color: colors["a" /* COLORS */].GRAY_MEDIUM
  })))), !isSeller && hasSuggestRequests && !autocompleteQuery && GlobalSearchQuery_jsx("div", {
    className: "m-auto max-w-site w-full py-6 md:pt-0 md:pb-2 mb-2 md:border-gray-light md:border-b-1"
  }, GlobalSearchQuery_jsx("div", {
    className: "text-blue text-xs font-sans font-bold"
  }, facetingSuggestedRequests.title), GlobalSearchQuery_jsx("div", {
    className: "md:flex"
  }, splitSuggests.map(function (splitSuggest, i) {
    return GlobalSearchQuery_jsx("div", {
      className: "md:w-1/3",
      key: i
    }, GlobalSearchQuery_jsx("div", {
      className: "md:flex"
    }, splitSuggest.map(function (_ref) {
      var suggestLabel = _ref.label,
          suggestUrl = _ref.url;
      return GlobalSearchQuery_jsx("div", {
        className: "md:w-1/2 rtl:pr-5 pt-2 md:pt-0",
        key: suggestLabel
      }, GlobalSearchQuery_jsx("div", {
        className: "font-sans text-sm truncate pt-2 w-full"
      }, GlobalSearchQuery_jsx(TrackClick["a" /* TrackClick */], {
        as: DynamicLink["a" /* default */],
        className: "text-gray-darker focus:text-blue hover:text-blue transition-color",
        onClick: function onClick() {
          var isSearchUrl = suggestUrl.startsWith('/s');
          var internalSearchEngineNbResults = !isSearchUrl ? {
            internalSearchEngineNbResults: redirection,
            searchResorts: []
          } : undefined;
          track({
            actionGA: 'search',
            categoryGA: 'layer',
            internalSearchEngineNbResults: isSearchUrl ? '' : redirection,
            labelGA: 'suggestedRequest',
            searchReferrer: 'layer',
            searchRequestType: 'Autocomplete',
            searchTerms: suggestLabel
          });
          trackSearchResults(GlobalSearchQuery_objectSpread({
            searchRequestType: 'Autocomplete',
            searchTerms: suggestLabel
          }, internalSearchEngineNbResults));
          clearGlobalSearch();
        },
        url: suggestUrl
      }, suggestLabel)));
    })));
  }))));
};
var SearchQuery = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  return GlobalSearchQuery_jsx(GlobalSearchQuery_ReferencedSearchQuery, Object(esm_extends["a" /* default */])({}, props, {
    searchInputRef: ref
  }));
});
// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackQueryChange.js
var useTrackQueryChange = __webpack_require__("kWbI");

// EXTERNAL MODULE: ./src/client/store/utils/autocompleteItemHelper.js
var autocompleteItemHelper = __webpack_require__("Qmkj");

// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/striptags/striptags.js
var striptags = __webpack_require__("47go");
var striptags_default = /*#__PURE__*/__webpack_require__.n(striptags);

// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchSuggestionsList.jsx
var GlobalSearchSuggestionsList_jsx = react_default.a.createElement;


var SUGGESTION_TYPES = {
  ACTIVITY: 'activity',
  AREA: 'area',
  COUNTRY: 'country',
  RESORT: 'resort'
};
var GlobalSearchSuggestionsList_GlobalSearchSuggestionsList = function GlobalSearchSuggestionsList(props) {
  var maxNumberOfSuggestions = props.isDesktop ? 5 : 3;

  var onPress = function onPress(suggestion) {
    props.onClick(suggestion);
  };

  return GlobalSearchSuggestionsList_jsx("ul", {
    className: "list-none p-0 mb-6"
  }, props.blockSuggestions.slice(0, maxNumberOfSuggestions).map(function (_ref) {
    var label = _ref.label,
        type = _ref.type;
    return {
      label: striptags_default()(label),
      type: type
    };
  }).map(function (suggestion, index) {
    var label = suggestion.label,
        type = suggestion.type;
    return GlobalSearchSuggestionsList_jsx("li", {
      key: label,
      className: "mb-3",
      "data-testid": "".concat(type, "-link")
    }, GlobalSearchSuggestionsList_jsx("span", {
      role: "button",
      tabIndex: index,
      className: "leading-tight font-bold text-xl lg:text-2xl text-gray cursor-pointer",
      onClick: function onClick() {
        return onPress(suggestion);
      },
      onKeyUp: function onKeyUp(event) {
        /* Space & Enter */
        if (event.keyCode === 32 || event.keyCode === 13) {
          onPress(suggestion);
        }
      }
    }, label));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/grid/Grid.jsx + 2 modules
var Grid = __webpack_require__("uLWw");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.jsx + 6 modules
var Product = __webpack_require__("XTOr");

// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchSuggestionsGrid.jsx

var GlobalSearchSuggestionsGrid_jsx = react_default.a.createElement;





var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var MAX_GRID_SUGGESTIONS = 4;
var GlobalSearchSuggestionsGrid_GlobalSearchSuggestionsGrid = function GlobalSearchSuggestionsGrid(props) {
  var products = props.blockSuggestions.slice(0, MAX_GRID_SUGGESTIONS).map(function (_ref) {
    var icon = _ref.icon,
        image = _ref.image,
        isExclusiveCollection = _ref.isExclusiveCollection,
        label = _ref.label,
        link = _ref.link,
        productColor = _ref.productColor,
        productId = _ref.productId,
        productType = _ref.productType,
        season = _ref.season,
        subLabel1 = _ref.subLabel1,
        subLabel2 = _ref.subLabel2,
        tagsColor = _ref.tagsColor;
    return {
      header: {
        badge: season,
        badgeColor: tagsColor,
        badgeIcon: {
          alt: '',
          color: colors["a" /* COLORS */].WHITE,
          colorBg: productColor,
          colorBorder: productColor,
          iconName: icon
        },
        hasECLogo: !icon,
        heading: {
          subtitle: productType === PRODUCT_TYPES.RESORT ? subLabel1 : subLabel2,
          title: label
        }
      },
      id: productId,
      thumbnail: {
        hasBorder: isExclusiveCollection,
        pictures: [{
          altMsg: label,
          src: image
        }],
        tagsColor: tagsColor
      },
      type: productType,
      url: link
    };
  });
  var grid = {
    desktop: 2,
    mobile: 1,
    phablet: 2,
    tablet: 3
  };
  return products.length > 0 && GlobalSearchSuggestionsGrid_jsx(Grid["a" /* default */], {
    className: "mb-6",
    display: grid,
    grid: grid,
    hasSeeMore: false,
    totalNumberToDisplay: MAX_GRID_SUGGESTIONS
  }, products.map(function (product) {
    return GlobalSearchSuggestionsGrid_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({
      key: product.id
    }, product, {
      onClick: function onClick() {
        var query = {
          label: product.header.heading.title,
          type: 'resort'
        };
        props.onClick(query);
      }
    }));
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchSuggestions.jsx


var GlobalSearchSuggestions_jsx = react_default.a.createElement;

function GlobalSearchSuggestions_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function GlobalSearchSuggestions_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { GlobalSearchSuggestions_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { GlobalSearchSuggestions_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






















var SuggestionsBlockTitle = function SuggestionsBlockTitle(_ref) {
  var title = _ref.title;
  return GlobalSearchSuggestions_jsx("h3", {
    className: "my-6 lg:my-8 font-bold font-sans leading-tight text-base text-blue uppercase"
  }, title);
};

var GlobalSearchSuggestions_SearchSuggestions = function SearchSuggestions(props) {
  var _useResponsive = Object(responsive_responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var trackQueryChange = Object(useTrackQueryChange["a" /* useTrackQueryChange */])();
  var trackSearchResults = Object(useTrackSearchResults["a" /* useTrackSearchResults */])();
  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);
  var kidsValidationState = Object(es["e" /* useSelector */])(faceting_selector["k" /* getKidsValidationState */]);
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var suggestionsBlocks = [{
    id: SUGGESTION_TYPES.COUNTRY,
    types: [SUGGESTION_TYPES.AREA, SUGGESTION_TYPES.COUNTRY],
    title: Object(i18n["f" /* t */])('faceting.autocomplete.destinationsTitle'),
    linkLabel: Object(i18n["f" /* t */])('faceting.autocomplete.moreDestinationsLabel'),
    linkURL: Object(i18n["f" /* t */])('faceting.autocomplete.moreDestinationsURL'),
    width: isDesktop ? 'w-1/4' : 'w-full',
    order: 1
  }, {
    id: SUGGESTION_TYPES.ACTIVITY,
    types: [SUGGESTION_TYPES.ACTIVITY],
    type: SUGGESTION_TYPES.ACTIVITY,
    title: Object(i18n["f" /* t */])('faceting.autocomplete.activitiesTitle'),
    linkLabel: Object(i18n["f" /* t */])('faceting.autocomplete.moreActivitiesLabel'),
    linkURL: Object(i18n["f" /* t */])('faceting.autocomplete.moreActivitiesURL'),
    width: isDesktop ? 'w-1/4' : 'w-full',
    order: isDesktop ? 2 : 3
  }, {
    id: SUGGESTION_TYPES.RESORT,
    types: [SUGGESTION_TYPES.RESORT],
    title: Object(i18n["f" /* t */])('faceting.autocomplete.productsTitle'),
    linkLabel: Object(i18n["f" /* t */])('faceting.autocomplete.moreProductsLabel'),
    linkURL: '/s',
    width: isDesktop ? 'w-1/2' : 'w-full',
    order: isDesktop ? 3 : 2
  }];
  var trackingPayload = {
    categoryGA: 'layer',
    searchReferrer: 'layer'
  };
  return GlobalSearchSuggestions_jsx("div", {
    id: "search-suggestions",
    className: classnames_default()('flex m-auto max-w-site', {
      'mb-15 flex-wrap': !isDesktop
    })
  }, suggestionsBlocks.map(function (block) {
    var blockSuggestions = props.autocompleteResults.filter(function (result) {
      return !!result.label && block.types.includes(result.type);
    });
    var SuggestionsBlock = block.id === SUGGESTION_TYPES.RESORT ? GlobalSearchSuggestionsGrid_GlobalSearchSuggestionsGrid : GlobalSearchSuggestionsList_GlobalSearchSuggestionsList;
    return !isDesktop && Object(lodash["isEmpty"])(blockSuggestions) ? null : GlobalSearchSuggestions_jsx("div", {
      key: "search-suggestions-".concat(block.id),
      className: classnames_default()(block.width, {
        'mb-6 border-gray-light border-t-1': !isDesktop
      }),
      style: {
        order: block.order
      }
    }, block.id !== SUGGESTION_TYPES.RESORT ? GlobalSearchSuggestions_jsx(SuggestionsBlockTitle, {
      title: block.title
    }) : GlobalSearchSuggestions_jsx("div", {
      className: "flex justify-between items-strech"
    }, GlobalSearchSuggestions_jsx(SuggestionsBlockTitle, {
      title: block.title
    }), blockSuggestions.length > MAX_GRID_SUGGESTIONS && GlobalSearchSuggestions_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      className: "my-6 lg:my-8 leading-tight font-bold text-sm text-gray underline",
      isExternalLink: false,
      onClick: function onClick() {
        props.clearGlobalSearch();
      },
      trackingData: GlobalSearchSuggestions_objectSpread(GlobalSearchSuggestions_objectSpread({}, trackingPayload), {}, {
        actionGA: 'search',
        labelGA: "viewMore_".concat(Object(utils["c" /* getSearchMappedTypeForLabelGA */])(block.id))
      }),
      url: "/s?search=".concat(props.autocompleteQuery)
    }, Object(lodash["upperFirst"])(block.linkLabel))), Object(lodash["isEmpty"])(blockSuggestions) ? GlobalSearchSuggestions_jsx("p", {
      className: "mt-0 mb-6 leading-tight text-xl lg:text-2xl text-gray-light"
    }, Object(lodash["upperFirst"])(Object(i18n["f" /* t */])('faceting.autocomplete.noResult'))) : GlobalSearchSuggestions_jsx(SuggestionsBlock, Object(esm_extends["a" /* default */])({}, props, {
      blockSuggestions: blockSuggestions,
      isDesktop: isDesktop,
      onClick: function onClick(query) {
        props.clearGlobalSearch();

        if (query.type === autocompleteItemHelper["a" /* RESORT_PRODUCT_TYPE */]) {
          trackQueryChange(query, GlobalSearchSuggestions_objectSpread(GlobalSearchSuggestions_objectSpread({}, trackingPayload), {}, {
            internalSearchEngineNbResults: 'redirection'
          }));
          trackSearchResults({
            internalSearchEngineNbResults: 'redirection',
            searchRequestType: 'Autocomplete',
            searchTerms: query.label,
            searchResorts: []
          });
        } else {
          dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(query));
          trackQueryChange(query, trackingPayload);
          Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
            criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
            location: location,
            searchCriteria: {
              query: query,
              departureCity: departureCity,
              departureDate: departureDate,
              duration: duration,
              keywords: '',
              kids: kids,
              kidsValidationState: kidsValidationState
            },
            searchPageRouteName: 'search'
          });
        }
      }
    })), block.linkLabel && block.linkURL && block.id !== SUGGESTION_TYPES.RESORT ? GlobalSearchSuggestions_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      className: "font-bold text-sm text-gray underline",
      isExternalLink: false,
      onClick: props.clearGlobalSearch,
      trackingData: {
        categoryGA: 'layer',
        actionGA: 'search',
        labelGA: "viewMore_".concat(block.id),
        searchReferrer: 'layer'
      },
      url: block.linkURL
    }, Object(lodash["upperFirst"])(block.linkLabel)) : null);
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearch.jsx

var GlobalSearch_jsx = react_default.a.createElement;

function GlobalSearch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function GlobalSearch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { GlobalSearch_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { GlobalSearch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





















function DesktopSearchContainer(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      offsetTop = _ref.offsetTop;
  return GlobalSearch_jsx("aside", {
    className: classnames_default()('fadeIn fixed flex flex-col inset-0', {
      'invisible opacity-0': !isOpen
    }),
    style: {
      backgroundColor: 'rgba(1, 1, 1, 0.5)',
      top: "".concat(Navigation_constants["e" /* heights */].NAVIGATION_LARGE_HEIGHT + offsetTop, "px")
    }
  }, children);
}

var onScroll = Object(lodash["throttle"])(function () {
  Object(lib["forceCheck"])();
}, 250);

function MobileSearchContainer(_ref2) {
  var children = _ref2.children,
      isOpen = _ref2.isOpen,
      offsetTop = _ref2.offsetTop;
  return GlobalSearch_jsx("div", {
    className: classnames_default()('bg-white fixed bottom-0 rtl:right-0 p-4 overflow-y-auto w-full', {
      'translate-x-0': isOpen,
      'rtl:translate-x-100': !isOpen
    }),
    onScroll: onScroll,
    style: {
      top: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT + offsetTop,
      transition: 'transform linear 330ms'
    }
  }, isOpen ? children : null);
}

var GlobalSearch_GlobalSearch = function GlobalSearch(props) {
  var facetingSuggestedRequests = props.facetingSuggestedRequests,
      isOpen = props.isOpen,
      offsetTop = props.offsetTop,
      toggleOpen = props.toggleOpen;

  var _useResponsive = Object(responsive_responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      isSeller = _useContext.isSeller;

  var _useAutocomplete = Object(useAutocomplete["a" /* useAutocomplete */])(),
      autocompleteQuery = _useAutocomplete.autocompleteQuery,
      setAutocompleteQuery = _useAutocomplete.setAutocompleteQuery,
      autocompleteResults = _useAutocomplete.autocompleteResults,
      setAutocompleteResults = _useAutocomplete.setAutocompleteResults;

  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'layer'
  }); // This effect is used to focus the search query input element when the GlobalSearch is opened
  // Use timer to wait for css transition

  var searchInput = /*#__PURE__*/Object(react["createRef"])();
  Object(react["useEffect"])(function () {
    var timer = null;

    if (isOpen && searchInput.current) {
      var _facetingSuggestedReq;

      if (!isSeller && !autocompleteQuery && !!(facetingSuggestedRequests === null || facetingSuggestedRequests === void 0 ? void 0 : (_facetingSuggestedReq = facetingSuggestedRequests.items) === null || _facetingSuggestedReq === void 0 ? void 0 : _facetingSuggestedReq.length)) {
        track({
          actionGA: 'search',
          labelGA: 'requestsDisplay'
        });
      }

      timer = setTimeout(function () {
        searchInput.current && searchInput.current.focus();
      }, 500);
    }

    return function () {
      clearTimeout(timer);
    };
  }, [isOpen]);
  var trackingData = {
    categoryGA: 'headerMenu',
    actionGA: 'header_search'
  };
  var toggleGlobalSearch = Object(react["useCallback"])(function () {
    setAutocompleteQuery('');
    setAutocompleteResults([]);
    toggleOpen();
  }, []);

  var onChangeQuery = function onChangeQuery(e) {
    var value = e.currentTarget.value;
    setAutocompleteQuery(value);
  };

  var GLOBAL_SEARCH_ENABLED = config_default.a.get('featureFlipping.faceting.globalSearchEnabled');

  var searchComponent = GlobalSearch_jsx(react["Fragment"], null, GlobalSearch_jsx(SearchQuery, {
    autocompleteQuery: autocompleteQuery,
    clearGlobalSearch: toggleGlobalSearch,
    facetingSuggestedRequests: facetingSuggestedRequests,
    onChangeQuery: onChangeQuery,
    ref: searchInput,
    trackingData: trackingData
  }), GlobalSearch_jsx("div", {
    className: classnames_default()('slideInTop fadeIn w-full bg-white', {
      'flex-1 overflow-y-auto': isDesktop,
      'pb-12': !isDesktop,
      'invisible opacity-0': autocompleteQuery.length === 0
    }),
    "data-testid": "search-suggestions-container",
    style: isDesktop ? {
      paddingLeft: '15%',
      paddingRight: '15%'
    } : {}
  }, GlobalSearch_jsx(GlobalSearchSuggestions_SearchSuggestions, {
    autocompleteQuery: autocompleteQuery,
    autocompleteResults: autocompleteResults,
    clearGlobalSearch: toggleGlobalSearch
  })));

  var searchLinkLabel = Object(i18n["f" /* t */])('faceting.searchLinkLabel');
  return GLOBAL_SEARCH_ENABLED ? GlobalSearch_jsx(react["Fragment"], null, GlobalSearch_jsx(TrackClick["a" /* TrackClick */], {
    "aria-expanded": isOpen,
    "aria-label": "Search",
    "aria-pressed": isOpen,
    as: "button",
    className: props.className,
    "data-testid": "global-search-button",
    onClick: toggleGlobalSearch,
    title: searchLinkLabel,
    trackingData: GlobalSearch_objectSpread(GlobalSearch_objectSpread({}, trackingData), {}, {
      labelGA: isOpen ? 'close' : 'open'
    }),
    type: "button",
    url: routeBuilder["a" /* buildUrl */]('search')
  }, GlobalSearch_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS,
    width: "1.1875rem"
  }), GlobalSearch_jsx("span", {
    className: "sr-only"
  }, searchLinkLabel)), isDesktop ? GlobalSearch_jsx(DesktopSearchContainer, {
    isOpen: isOpen,
    offsetTop: offsetTop
  }, searchComponent) : GlobalSearch_jsx(MobileSearchContainer, {
    isOpen: isOpen,
    offsetTop: offsetTop
  }, searchComponent)) : GlobalSearch_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: props.className,
    "data-testid": "global-search-link",
    title: searchLinkLabel,
    trackingData: NAVIGATION_TRACKING_SEARCH_BUTTON,
    url: routeBuilder["a" /* buildUrl */]('search')
  }, GlobalSearch_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS,
    width: "1.1875rem"
  }), GlobalSearch_jsx("span", {
    className: "sr-only"
  }, searchLinkLabel));
};
// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/member-access/member-access-button/NavigationMemberAccessButton.jsx







var NavigationMemberAccessButton_jsx = react_default.a.createElement;

function NavigationMemberAccessButton_createSuper(Derived) { var hasNativeReflectConstruct = NavigationMemberAccessButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationMemberAccessButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var NavigationMemberAccessButton_NavigationMemberAccessButton = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(NavigationMemberAccessButton, _Component);

  var _super = NavigationMemberAccessButton_createSuper(NavigationMemberAccessButton);

  function NavigationMemberAccessButton() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, NavigationMemberAccessButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      animate: false
    });

    return _this;
  }

  Object(createClass["a" /* default */])(NavigationMemberAccessButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var isAnimationEnable = !Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('memberSpace.disableConnectionAnimation'); // $FlowFixMe

      this.timeoutID = setTimeout(function () {
        _this2.setState({
          animate: true
        });
      }, 1500);

      if (isAnimationEnable && !this.props.isAuthenticated) {
        // $FlowFixMe
        this.intervalID = setInterval(function () {
          _this2.setState({
            animate: true
          });
        }, 10000);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;

      if (this.state.animate) {
        // $FlowFixMe
        this.timeoutID = setTimeout(function () {
          _this3.setState({
            animate: false
          });
        }, 2000);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // $FlowFixMe
      clearTimeout(this.timeoutID); // $FlowFixMe

      clearInterval(this.intervalID);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          isActive = _this$props.isActive,
          isAuthenticated = _this$props.isAuthenticated,
          isQuickLoggedIn = _this$props.isQuickLoggedIn,
          onClick = _this$props.onClick,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? 1.25 : _this$props$size,
          title = _this$props.title;
      var animate = this.state.animate;
      var trackingData = {
        categoryGA: 'headerMenu',
        actionGA: 'header_memberSpace',
        labelGA: 'memberSpace'
      };
      return NavigationMemberAccessButton_jsx(TrackClick["a" /* TrackClick */], {
        "aria-expanded": isActive,
        as: "button",
        className: className,
        onClick: onClick,
        title: title,
        trackingData: isActive || isAuthenticated ? null : trackingData,
        type: "button"
      }, NavigationMemberAccessButton_jsx("span", {
        className: "flex relative"
      }, !!title && NavigationMemberAccessButton_jsx("span", {
        className: "sr-only"
      }, title), NavigationMemberAccessButton_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].USER,
        width: "".concat(size, "rem")
      }), (isAuthenticated || isQuickLoggedIn) && NavigationMemberAccessButton_jsx("span", {
        className: classnames_default()('absolute flex items-center justify-center leading-none rounded-half', {
          'bg-emerald': isAuthenticated && !isQuickLoggedIn,
          'bg-blue': isQuickLoggedIn
        }),
        style: {
          top: '-0.5625rem',
          right: '-0.3125rem',
          width: '0.75rem',
          height: '0.75rem'
        }
      }, NavigationMemberAccessButton_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].CHECK,
        width: "0.5rem",
        color: colors["a" /* COLORS */].WHITE
      })), animate && NavigationMemberAccessButton_jsx("span", {
        style: {
          position: 'absolute',
          top: "".concat(size * 0.22, "rem"),
          left: "".concat(-size * 0.65, "rem"),
          width: "".concat(size * 0.8, "rem"),
          height: "".concat(size * 0.6, "rem"),
          border: "solid ".concat(size * 0.06, "rem black"),
          borderRadius: '0 0 50% 80%',
          borderColor: 'transparent transparent black transparent',
          transformOrigin: 'bottom right',
          animation: 'memberAnimation 2s'
        }
      })));
    }
  }]);

  return NavigationMemberAccessButton;
}(react["Component"]);

Object(defineProperty["a" /* default */])(NavigationMemberAccessButton_NavigationMemberAccessButton, "contextType", ReactAppContext["a" /* default */]);
// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 1 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/utils/graphql-client/cacheFront.js
var cacheFront = __webpack_require__("ESA2");

// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/member-sign-in/MemberSignIn.jsx
var MemberSignIn_jsx = react_default.a.createElement;










function MemberSignIn(_ref) {
  var hasFacebookConnect = _ref.hasFacebookConnect,
      hasQuickLogin = _ref.hasQuickLogin,
      hasWechatConnect = _ref.hasWechatConnect,
      _ref$join = _ref.join,
      join = _ref$join === void 0 ? {} : _ref$join,
      _ref$quickLogin = _ref.quickLogin,
      quickLogin = _ref$quickLogin === void 0 ? {} : _ref$quickLogin,
      _ref$signin = _ref.signin,
      signin = _ref$signin === void 0 ? {} : _ref$signin;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale;

  return MemberSignIn_jsx(react["Fragment"], null, MemberSignIn_jsx("div", {
    className: "flex flex-col-reverse lg:flex-row",
    "data-testid": "signInContent"
  }, MemberSignIn_jsx("div", {
    className: "border-t-1 lg:border-t-0 lg:rtl:border-r-1 border-gray-dark lg:w-1/2 lg:rtl:pr-px15 mt-5 pt-5 lg:mt-0 lg:pt-0"
  }, MemberSignIn_jsx("div", {
    className: "flex items-end mb-px15"
  }, MemberSignIn_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0 text-gray-darker",
    isNotMonoChrome: true,
    name: icons["a" /* ICONS */].ICON_45,
    width: "2.5rem"
  }), MemberSignIn_jsx("div", {
    className: "rtl:ml-px15"
  }, MemberSignIn_jsx("p", {
    className: "reset-paragraph text-md leading-normal font-brand"
  }, signin.title), MemberSignIn_jsx("p", {
    className: "m-0 text-sm leading-tight text-gray-darker"
  }, signin.text))), MemberSignIn_jsx("div", {
    className: "flex"
  }, MemberSignIn_jsx(Button["a" /* Button */], {
    className: "w-full",
    dataTestId: "member-nav-signIn",
    isExternalLink: true,
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
    },
    trackingData: {
      labelGA: 'memberSpace_signIn',
      categoryGA: 'headerMenu',
      actionGA: 'header_memberSpace'
    },
    url: ple_utils["f" /* buildSigninUrl */]({
      locale: locale
    })
  }, signin.ctaLabel), hasFacebookConnect ? MemberSignIn_jsx(Button["a" /* Button */], {
    className: "rtl:ml-px10 rounded-small",
    dataTestId: "MemberSignIn-facebook",
    isExternalLink: true,
    minWidth: "0",
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
    },
    style: {
      width: '4rem',
      backgroundColor: '#4267b2',
      borderColor: '#4267b2'
    },
    trackingData: {
      categoryGA: tracking_constants["l" /* PLE */],
      actionGA: 'CTA_incentive_FB_connect',
      labelGA: 'memberSpace'
    },
    url: ple_utils["d" /* buildFacebookConnectUrl */]({
      locale: locale
    })
  }, MemberSignIn_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].FACEBOOK
  }), MemberSignIn_jsx("span", {
    className: "sr-only"
  }, "Club Med - Facebook")) : null, hasWechatConnect ? MemberSignIn_jsx(Button["a" /* Button */], {
    className: "rtl:ml-px10",
    colorBg: colors["a" /* COLORS */].EMERALD,
    colorBorder: colors["a" /* COLORS */].EMERALD,
    dataTestId: "MemberSignIn-wechat",
    isExternalLink: true,
    minWidth: "0",
    style: {
      width: '5rem'
    },
    trackingData: {
      categoryGA: tracking_constants["l" /* PLE */],
      actionGA: 'CTA_incentive_wechat_connect',
      labelGA: 'memberSpace'
    },
    url: ple_utils["j" /* buildWechatConnectUrl */]({
      locale: locale
    })
  }, MemberSignIn_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].WECHAT
  }), MemberSignIn_jsx("span", {
    className: "sr-only"
  }, "Club Med - Wechat")) : null), MemberSignIn_jsx("div", {
    className: "flex lg:justify-center justify-between mt-5"
  }, MemberSignIn_jsx("p", {
    className: "reset-paragraph text-sm leading-tight text-gray-darker"
  }, join.text), MemberSignIn_jsx(TrackClick["a" /* TrackClick */], {
    as: "a",
    className: "reset-button inline-flex items-center ml-px10 text-blue font-bold font-sans leading-tight text-sm focus:underline hover:underline",
    "data-testid": "member-nav-createAccount",
    href: ple_utils["h" /* buildSignupUrl */]({
      locale: locale
    }),
    rel: "nofollow",
    trackingData: {
      actionGA: 'header_memberSpace',
      categoryGA: 'headerMenu',
      labelGA: 'memberSpace_createAccount'
    }
  }, MemberSignIn_jsx("span", null, join.ctaLabel), MemberSignIn_jsx(Icon["a" /* Icon */], {
    className: "rtl:ml-px5",
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "1em"
  })))), hasQuickLogin && MemberSignIn_jsx("div", {
    className: "lg:w-1/2 lg:rtl:pl-px15"
  }, MemberSignIn_jsx("div", {
    className: "flex mb-px15"
  }, MemberSignIn_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0 text-gray-darker",
    name: icons["a" /* ICONS */].DOCUMENT_COLORED,
    width: "3.5rem",
    isNotMonoChrome: true
  }), MemberSignIn_jsx("div", {
    className: "rtl:ml-px10"
  }, MemberSignIn_jsx("p", {
    className: "reset-paragraph text-grenadine text-md font-brand"
  }, quickLogin.title), MemberSignIn_jsx("p", {
    className: "m-0 text-sm text-gray-darker leading-tight font-bold"
  }, quickLogin.text))), MemberSignIn_jsx("ul", {
    className: "text-sm leading-tight m-0 p-0 list-none p-0 mb-5"
  }, quickLogin.keyPoint && quickLogin.keyPoint.map(function (key) {
    return MemberSignIn_jsx("li", {
      key: key,
      className: "flex items-start mb-px10 rtl:pl-px10"
    }, MemberSignIn_jsx(Icon["a" /* Icon */], {
      className: "flex-shrink-0 text-emerald",
      name: icons["a" /* ICONS */].CHECK,
      width: "1rem"
    }), MemberSignIn_jsx("span", {
      className: "rtl:pl-px10"
    }, key));
  })), MemberSignIn_jsx(Button["a" /* Button */], {
    className: "w-full",
    dataTestId: "member-nav-quickLogin",
    isExternalLink: true,
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
    },
    trackingData: {
      labelGA: 'memberSpace_quickLogin',
      categoryGA: 'headerMenu',
      actionGA: 'header_memberSpace'
    },
    url: ple_utils["f" /* buildSigninUrl */]({
      provider: 'bookingGM',
      locale: locale
    })
  }, quickLogin.ctaLabel))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/member-sign-in/MemberSignIn.container.jsx
var MemberSignIn_container_jsx = react_default.a.createElement;







var MemberSignIn_container_query = "\n  query {\n    facebookConnect {\n      isAvailable\n    }\n    wechatConnect {\n      isAvailable\n    }\n  }\n";
function MemberSignInContainer(_ref) {
  var cmsContentAuthentication = _ref.cmsContentAuthentication;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useState = Object(react["useState"])(false),
      isFacebookConnect = _useState[0],
      setIsFacebookConnect = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isWechatConnect = _useState2[0],
      setIsWechatConnect = _useState2[1];

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: MemberSignIn_container_query,
    queryOptions: {
      requestName: requestDictionary["d" /* CORE_GET_FACEBOOK_CONNECT_CONFIG */]
    },
    cache: true
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  Object(react["useEffect"])(function () {
    setIsFacebookConnect(Object(lodash["get"])(data, 'facebookConnect.isAvailable', false));
    setIsWechatConnect(Object(lodash["get"])(data, 'wechatConnect.isAvailable', false));
  }, [isLoading]);
  return MemberSignIn_container_jsx(MemberSignIn, {
    hasFacebookConnect: isFacebookConnect,
    hasQuickLogin: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('navigationBar.hasQuickLogin'),
    hasWechatConnect: isWechatConnect,
    join: {
      ctaLabel: Object(lodash["get"])(cmsContentAuthentication, 'createAccountLinkLabel'),
      text: Object(lodash["get"])(cmsContentAuthentication, 'newToClubMed')
    },
    quickLogin: {
      ctaLabel: Object(lodash["get"])(cmsContentAuthentication, 'quickLogin.cta'),
      text: Object(lodash["get"])(cmsContentAuthentication, 'quickLogin.text'),
      title: Object(lodash["get"])(cmsContentAuthentication, 'quickLogin.title'),
      keyPoint: Object(lodash["get"])(cmsContentAuthentication, 'quickLogin.keyPoint')
    },
    signin: {
      ctaLabel: Object(lodash["get"])(cmsContentAuthentication, 'signin'),
      text: Object(lodash["get"])(cmsContentAuthentication, 'yourAccount.text'),
      title: Object(lodash["get"])(cmsContentAuthentication, 'yourAccount.title')
    }
  });
}
// EXTERNAL MODULE: ./src/client/store/user-info/actions/signout.js
var signout = __webpack_require__("qd7E");

// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/logged-nav/LoggedNav.jsx

var LoggedNav_jsx = react_default.a.createElement;

function LoggedNav_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function LoggedNav_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { LoggedNav_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { LoggedNav_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














function formatWelcomeMessage(template, firstName, lastName) {
  return Object(dist["messageFormat"])(template).format({
    firstname: firstName || '',
    lastname: lastName || ''
  });
}

function LoggedNav(_ref) {
  var cmsContent = _ref.cmsContent,
      userInfo = _ref.userInfo;
  var cmsNavigationSections = Object(lodash["get"])(cmsContent, 'navigationSections', {});
  var trackingData = {
    actionGA: 'header_memberSpace',
    categoryGA: 'headerMenu'
  };
  var items = [{
    label: cmsNavigationSections.dashboard,
    url: routeBuilder["b" /* urlPattern */]('account'),
    icon: icons["a" /* ICONS */].NOTEBOOK,
    trackingData: LoggedNav_objectSpread(LoggedNav_objectSpread({}, trackingData), {}, {
      labelGA: 'memberSpace_dashboard'
    })
  }, {
    label: cmsNavigationSections.myTrips,
    url: routeBuilder["b" /* urlPattern */]('futureTrips'),
    icon: icons["a" /* ICONS */].DETAILS,
    trackingData: LoggedNav_objectSpread(LoggedNav_objectSpread({}, trackingData), {}, {
      labelGA: 'memberSpace_myTrips'
    })
  }, {
    label: cmsNavigationSections.myProfile,
    url: routeBuilder["b" /* urlPattern */]('profile'),
    icon: icons["a" /* ICONS */].USER,
    trackingData: LoggedNav_objectSpread(LoggedNav_objectSpread({}, trackingData), {}, {
      labelGA: 'memberSpace_myProfile'
    })
  }, {
    label: cmsNavigationSections.greatMembers,
    url: routeBuilder["b" /* urlPattern */]('greatMembers'),
    icon: icons["a" /* ICONS */].BAR,
    trackingData: LoggedNav_objectSpread(LoggedNav_objectSpread({}, trackingData), {}, {
      labelGA: 'memberSpace_greatMembersProgram'
    })
  }, {
    label: Object(lodash["get"])(cmsContent, 'account.authentication.signout', ''),
    url: ple_utils["g" /* buildSignoutUrl */](),
    icon: icons["a" /* ICONS */].DISCONNECTION,
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
      Object(signout["b" /* default */])();
    },
    isExternalLink: true,
    trackingData: LoggedNav_objectSpread(LoggedNav_objectSpread({}, trackingData), {}, {
      labelGA: 'memberSpace_signOut'
    })
  }];
  var itemClasses = 'flex items-center font-bold leading-tight text-gray-darker text-md p-3';
  return LoggedNav_jsx(react["Fragment"], null, LoggedNav_jsx("div", {
    className: itemClasses
  }, formatWelcomeMessage(cmsContent.welcomeLabelTemplate, userInfo.firstName, userInfo.lastName)), LoggedNav_jsx("nav", null, items.map(function (_ref2) {
    var icon = _ref2.icon,
        isExternalLink = _ref2.isExternalLink,
        label = _ref2.label,
        onClick = _ref2.onClick,
        target = _ref2.target,
        url = _ref2.url;
    return LoggedNav_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      className: classnames_default()(itemClasses, 'border-t-1 focus:text-blue hover:text-blue transition-color'),
      isExternalLink: isExternalLink,
      key: url,
      onClick: onClick,
      target: target,
      trackingData: trackingData,
      url: url
    }, icon && LoggedNav_jsx(Icon["a" /* Icon */], {
      className: "rtl:mr-3",
      name: icon,
      width: "1.25rem"
    }), label);
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/quicklogged-nav/QuickLoggedNav.jsx
var QuickLoggedNav_jsx = react_default.a.createElement;











function QuickLoggedNav(_ref) {
  var cmsContent = _ref.cmsContent,
      bookingId = _ref.bookingId,
      stayId = _ref.stayId;
  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'headerMenu',
    actionGA: 'header_memberSpace'
  });
  var items = [{
    label: Object(lodash["get"])(cmsContent, 'navigationSections.dashboard', ''),
    url: routeBuilder["b" /* urlPattern */]('account'),
    dataTestId: 'member-nav-quickdashboard-dashboard',
    icon: icons["a" /* ICONS */].NOTEBOOK,
    onClick: function onClick() {
      track({
        labelGA: 'memberSpace_dashboard'
      });
    }
  }, {
    label: Object(lodash["get"])(cmsContent, 'navigationSections.quickLogin.details', ''),
    url: routeBuilder["a" /* buildUrl */]('bookings', {
      bookingId: bookingId,
      stayId: stayId
    }),
    dataTestId: 'member-nav-quickdashboard-details',
    icon: icons["a" /* ICONS */].DETAILS,
    hide: !bookingId || !stayId,
    onClick: function onClick() {
      track({
        labelGA: 'memberSpace_bookingDetails'
      });
    }
  }, {
    label: Object(lodash["get"])(cmsContent, 'navigationSections.quickLogin.prepareMyStay', ''),
    url: routeBuilder["a" /* buildUrl */]('prepareMyStay', {
      bookingId: bookingId,
      stayId: stayId
    }),
    dataTestId: 'member-nav-quickdashboard-prepareMyStay',
    icon: icons["a" /* ICONS */].LUGGAGE,
    hide: !bookingId || !stayId,
    onClick: function onClick() {
      track({
        labelGA: 'memberSpace_prepareMyStay'
      });
    }
  }, {
    label: Object(lodash["get"])(cmsContent, 'navigationSections.quickLogin.signin', ''),
    url: routeBuilder["b" /* urlPattern */]('stepup'),
    dataTestId: 'member-nav-quickdashboard-stepup',
    icon: icons["a" /* ICONS */].CONNECT,
    description: Object(lodash["get"])(cmsContent, 'navigationSections.quickLogin.signinDescription', ''),
    isExternalLink: true,
    onClick: function onClick() {
      track({
        labelGA: 'memberSpace_stepUp'
      });
      Object(cacheFront["a" /* clearAllCacheFront */])();
    }
  }, {
    label: Object(lodash["get"])(cmsContent, 'navigationSections.quickLogin.signout', ''),
    url: ple_utils["g" /* buildSignoutUrl */](),
    dataTestId: 'member-nav-quickdashboard-Signout',
    icon: icons["a" /* ICONS */].DISCONNECTION,
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
      Object(signout["b" /* default */])();
      track({
        labelGA: 'memberSpace_signOut'
      });
    },
    isExternalLink: true
  }];
  return QuickLoggedNav_jsx("nav", null, items.filter(function (i) {
    return !i.hide;
  }).map(function (_ref2, index) {
    var dataTestId = _ref2.dataTestId,
        description = _ref2.description,
        icon = _ref2.icon,
        isExternalLink = _ref2.isExternalLink,
        label = _ref2.label,
        onClick = _ref2.onClick,
        target = _ref2.target,
        url = _ref2.url;
    return QuickLoggedNav_jsx("div", {
      className: classnames_default()('p-3', {
        'border-t-1': index > 0
      }),
      key: url
    }, description && QuickLoggedNav_jsx("p", {
      className: "reset-paragraph text-xs text-gray-darker"
    }, description), QuickLoggedNav_jsx(DynamicLink["a" /* default */], {
      className: "flex items-center font-bold leading-tight text-gray-darker text-md focus:text-blue hover:text-blue transition-color",
      "data-testid": dataTestId,
      isExternalLink: isExternalLink,
      onClick: onClick,
      target: target,
      url: url
    }, icon && QuickLoggedNav_jsx(Icon["a" /* Icon */], {
      className: "rtl:mr-3",
      name: icon,
      width: "1.25rem"
    }), label));
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/quicklogged-nav/QuickLoggedNav.container.js




function QuickLoggedNav_container_mapStateToProps(state) {
  return {
    bookingId: Object(lodash["get"])(state, 'memberSpace.quickLogin.bookingId'),
    stayId: Object(lodash["get"])(state, 'memberSpace.quickLogin.stayId')
  };
}

var QuickLoggedNavContainer = Object(es["c" /* connect */])(QuickLoggedNav_container_mapStateToProps)(QuickLoggedNav);
// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/MemberNav.jsx
var MemberNav_jsx = react_default.a.createElement;






function MemberNav(props) {
  var userInfo = props.userInfo,
      cmsContent = props.cmsContent;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      cxoNeolid = _useRouter.location.queryParams.cxo_neolid;

  if (!cmsContent) {
    return null;
  }

  if (userInfo.isQuickLoggedIn) {
    return MemberNav_jsx(QuickLoggedNavContainer, {
      cmsContent: cmsContent
    });
  }

  if (userInfo.isLoggedIn || cxoNeolid) {
    return MemberNav_jsx(LoggedNav, props);
  }

  return MemberNav_jsx(MemberSignInContainer, {
    cmsContentAuthentication: Object(lodash["get"])(cmsContent, 'account.authentication', {})
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/member-access/NavigationMemberAccess.jsx
var NavigationMemberAccess_jsx = react_default.a.createElement;




function getUserInfo() {
  var _userInfo$unicodeFirs, _userInfo$firstName, _userInfo$unicodeLast, _userInfo$lastName;

  var userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var res = {
    firstName: ((_userInfo$unicodeFirs = userInfo.unicodeFirstName) === null || _userInfo$unicodeFirs === void 0 ? void 0 : _userInfo$unicodeFirs.trim()) || ((_userInfo$firstName = userInfo.firstName) === null || _userInfo$firstName === void 0 ? void 0 : _userInfo$firstName.trim()),
    lastName: ((_userInfo$unicodeLast = userInfo.unicodeLastName) === null || _userInfo$unicodeLast === void 0 ? void 0 : _userInfo$unicodeLast.trim()) || ((_userInfo$lastName = userInfo.lastName) === null || _userInfo$lastName === void 0 ? void 0 : _userInfo$lastName.trim()),
    isLoggedIn: !!userInfo.isLoggedIn,
    isQuickLoggedIn: !!userInfo.isQuickLoggedIn
  };
  return res;
}

var NavigationMemberAccess_NavigationMemberAccess = function NavigationMemberAccess(props) {
  var responsiveContext = react_default.a.useContext(responsive_responsiveContext["a" /* default */]);

  if (!responsiveContext.isAppMounted) {
    return null;
  }

  var cmsAccount = props.cmsAccount,
      _props$cmsMemberSpace = props.cmsMemberSpace,
      cmsMemberSpace = _props$cmsMemberSpace === void 0 ? {} : _props$cmsMemberSpace,
      userInfo = props.userInfo;
  var userInfos = getUserInfo(userInfo);
  var welcomeLabelTemplate = cmsMemberSpace.accessButtonLoggedin;
  return NavigationMemberAccess_jsx(MemberNav, {
    userInfo: userInfos,
    cmsContent: {
      welcomeLabelTemplate: welcomeLabelTemplate,
      title: cmsMemberSpace.title,
      navigationSections: cmsMemberSpace.navigationSections,
      account: cmsAccount
    }
  });
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/contact/NavigationContact.jsx
var NavigationContact_jsx = react_default.a.createElement;







function NavigationContact(_ref) {
  var _ref$contact = _ref.contact,
      contact = _ref$contact === void 0 ? {} : _ref$contact,
      hasTel = _ref.hasTel;
  var description = contact.description,
      hours = contact.hours,
      _contact$phoneNumber = contact.phoneNumber,
      phoneNumber = _contact$phoneNumber === void 0 ? '' : _contact$phoneNumber,
      _contact$title = contact.title,
      title = _contact$title === void 0 ? '' : _contact$title,
      toll = contact.toll;
  var link = "tel:".concat(phoneNumber);
  return NavigationContact_jsx(react["Fragment"], null, NavigationContact_jsx(Title["a" /* Title */], {
    className: "mb-px10",
    theme: "title-sans-4"
  }, title), NavigationContact_jsx(Text["a" /* Text */], {
    "data-testid": "NavigationContact-description",
    text: description
  }), toll && NavigationContact_jsx("p", {
    className: "reset-paragraph font-sans text-sm leading-normal text-gray-medium",
    "data-testid": "NavigationContact-toll"
  }, toll), NavigationContact_jsx(Text["a" /* Text */], {
    className: "mt-px10",
    color: colors["a" /* COLORS */].BLUE,
    "data-testid": "NavigationContact-hours",
    text: hours,
    theme: "text-sans-2"
  }), phoneNumber && hasTel && NavigationContact_jsx("div", {
    className: "flex items-center justify-center mt-5"
  }, NavigationContact_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    iconLeft: {
      name: icons["a" /* ICONS */].PHONE_BUBBLE
    },
    trackingData: getNavigationCallCenterButtonTrackingData(phoneNumber),
    url: link
  }, NavigationContact_jsx("span", {
    dir: "ltr"
  }, phoneNumber))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/panels/NavigationLargeBackPanel.jsx
var NavigationLargeBackPanel_jsx = react_default.a.createElement;


function NavigationLargeBackPanel(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 0 : _ref$height;
  return NavigationLargeBackPanel_jsx("div", {
    className: "absolute inset-x-0 pointer-events-none top-full z-0"
  }, NavigationLargeBackPanel_jsx("div", {
    className: "bg-white h-0 my-0 mx-auto max-w-site overflow-hidden pointer-events-none shadow transition-heights w-full",
    style: {
      height: "".concat(String(height), "px"),
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/panels/NavigationLargeElement.jsx

var NavigationLargeElement_jsx = react_default.a.createElement;

function NavigationLargeElement_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function NavigationLargeElement_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { NavigationLargeElement_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { NavigationLargeElement_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var NavigationLargeElement_NavigationLargeElement = function NavigationLargeElement(_ref) {
  var children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      id = _ref.id,
      onClose = _ref.onClose,
      style = _ref.style;

  if (!react["Children"].count(children)) {
    return null;
  }

  return NavigationLargeElement_jsx("div", {
    id: id,
    className: classnames_default()(className, 'absolute bg-white overflow-y-auto p-5 rtl:right-0 mt-px top-full'),
    style: NavigationLargeElement_objectSpread({
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }, style)
  }, closeLabel && NavigationLargeElement_jsx("button", {
    className: "reset-button sr-only focus:not-sr-only float-right mb-2 px-1 text-blue text-sm",
    onClick: onClose,
    type: "button"
  }, closeLabel), children);
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/panels/NavigationLargePanel.jsx

var NavigationLargePanel_jsx = react_default.a.createElement;

function NavigationLargePanel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function NavigationLargePanel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { NavigationLargePanel_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { NavigationLargePanel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var NavigationLargePanel = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var children = props.children,
      isActive = props.isActive;

  if (!react["Children"].count(children)) {
    return null;
  }

  return NavigationLargePanel_jsx("div", {
    className: "absolute inset-x-0 pointer-events-none top-full z-0"
  }, NavigationLargePanel_jsx("div", {
    className: classnames_default()('my-0 mx-auto max-w-site overflow-hidden w-full transition-none', {
      'absolute opacity-0 pointer-events-none rtl:left-outOfBounds': !isActive,
      'opacity-100 pointer-events-auto': isActive
    }),
    "data-testid": "NavigationLarge-subItems",
    ref: ref,
    style: NavigationLargePanel_objectSpread({
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }, isActive ? {
      transition: 'opacity ease-in 0.4s 0.2s'
    } : null)
  }, children));
});
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/first-level-item/NavigationLargeFirstLevelItem.jsx


var NavigationLargeFirstLevelItem_jsx = react_default.a.createElement;




function NavigationLargeFirstLevelItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      hasSubItems = _ref.hasSubItems,
      isActive = _ref.isActive,
      link = _ref.link;

  if (!react["Children"].count(children)) {
    return null;
  }

  return NavigationLargeFirstLevelItem_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, link, {
    "aria-haspopup": hasSubItems,
    as: DynamicLink["a" /* default */],
    className: classnames_default()(className, 'reset-anchor cursor-pointer flex font-sans font-bold items-center px-4 relative focus:text-blue hover:text-blue transition-color uppercase', "text-".concat(color), Object(defineProperty["a" /* default */])({}, "focus:text-".concat(color, "-active hover:text-").concat(color, "-active"), !!color), {
      'navigation-arrow': hasSubItems
    }, {
      'navigation-arrow-active': isActive && hasSubItems
    }),
    "data-testid": "NavigationLarge-item-link",
    style: {
      fontSize: '0.8125rem'
    }
  }), children);
}
// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/frameworks/thumbnail-navigation/ThumbnailNavigation.themes.js


function ThumbnailNavigation_themes_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function ThumbnailNavigation_themes_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ThumbnailNavigation_themes_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ThumbnailNavigation_themes_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var ThumbnailNavigation_themes_themes = {
  "default": function _default(_ref) {
    var hasImageBorder = _ref.hasImageBorder,
        hasLink = _ref.hasLink,
        isHovering = _ref.isHovering;
    return {
      thRoot: '',
      thLink: classnames_default()('bg-black block overflow-hidden relative', {
        'decoration-fancy-frame': hasImageBorder
      }),
      thThumbnail: classnames_default()({
        'transition-transform-opacity': hasLink,
        'opacity-50 scale-105 ': hasLink && isHovering
      }),
      thLabel: classnames_default()('absolute px-1 text-center text-md text-shadow-1 text-white -translate-y-50 w-full', {
        'top-1/2': !isHovering,
        'top-9/20': isHovering
      }),
      thLabelStyle: ThumbnailNavigation_themes_objectSpread({}, isHovering ? {
        top: '45%',
        transition: 'all ease-in 0.25s'
      } : {
        top: '50%',
        transition: 'all ease-in 0.25s 0.15s'
      }),
      thSeeMoreLabel: 'absolute flex items-center justify-center leading-one text-center text-shadow-1 text-white uppercase w-full',
      thSeeMoreLabelStyle: ThumbnailNavigation_themes_objectSpread({
        fontSize: '0.6875rem'
      }, isHovering ? {
        bottom: '30%',
        opacity: 1,
        transition: 'all ease-in 0.15s 0.2s'
      } : {
        bottom: '27%',
        opacity: 0,
        transition: 'all ease-in 0.15s'
      }),
      thSeeMoreIcon: 'mx-1',
      thSeeMoreIconSize: '0.625rem',
      thBody: 'p-3'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/thumbnail-navigation/ThumbnailNavigation.jsx

var ThumbnailNavigation_jsx = react_default.a.createElement;









var ThumbnailNavigation_ThumbnailNavigation = function ThumbnailNavigation(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hasImageBorder = _ref.hasImageBorder,
      label = _ref.label,
      link = _ref.link,
      seeMoreLabel = _ref.seeMoreLabel,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      thumbnail = _ref.thumbnail;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setHovering = _useState[1];

  if (!thumbnail.imageUrl) {
    return null;
  }

  var hasLink = link === null || link === void 0 ? void 0 : link.url;

  var _themes$theme = ThumbnailNavigation_themes_themes[theme]({
    hasImageBorder: hasImageBorder,
    hasLink: hasLink,
    isHovering: isHovering
  }),
      thBody = _themes$theme.thBody,
      thLabel = _themes$theme.thLabel,
      thLabelStyle = _themes$theme.thLabelStyle,
      thLink = _themes$theme.thLink,
      thRoot = _themes$theme.thRoot,
      thSeeMoreIcon = _themes$theme.thSeeMoreIcon,
      thSeeMoreIconSize = _themes$theme.thSeeMoreIconSize,
      thSeeMoreLabel = _themes$theme.thSeeMoreLabel,
      thSeeMoreLabelStyle = _themes$theme.thSeeMoreLabelStyle,
      thThumbnail = _themes$theme.thThumbnail;

  var onEnter = hasLink ? function () {
    return setHovering(true);
  } : null;
  var onLeave = hasLink ? function () {
    return setHovering(false);
  } : null;
  return ThumbnailNavigation_jsx("div", {
    className: classnames_default()(className, thRoot, 'image-responsive-cell')
  }, ThumbnailNavigation_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, link, {
    as: hasLink ? DynamicLink["a" /* default */] : 'div',
    className: thLink,
    onMouseEnter: onEnter,
    onMouseLeave: onLeave,
    onFocus: onEnter,
    onBlur: onLeave
  }), ThumbnailNavigation_jsx(Image["a" /* default */], Object(esm_extends["a" /* default */])({}, thumbnail, {
    className: thThumbnail,
    ratioKey: thumbnail.ratioKey || ratios_utils["a" /* default */].XL
  })), !!label && ThumbnailNavigation_jsx("div", {
    className: thLabel,
    style: thLabelStyle
  }, label), !!seeMoreLabel && ThumbnailNavigation_jsx("div", {
    className: thSeeMoreLabel,
    style: thSeeMoreLabelStyle
  }, seeMoreLabel, ThumbnailNavigation_jsx(Icon["a" /* Icon */], {
    className: thSeeMoreIcon,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: thSeeMoreIconSize
  }))), !!children && !!react["Children"].count(children) && ThumbnailNavigation_jsx("div", {
    className: thBody
  }, children));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/subnavs/NavigationLargeSubNav.jsx

var NavigationLargeSubNav_jsx = react_default.a.createElement;









function NavigationLargeSubNav(props) {
  var _props$subItems = props.subItems,
      subItems = _props$subItems === void 0 ? [] : _props$subItems;

  if (Object(lodash["isEmpty"])(subItems)) {
    return null;
  }

  return NavigationLargeSubNav_jsx("div", {
    className: "bg-white overflow-y-auto py-6 px-12",
    style: {
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }
  }, NavigationLargeSubNav_jsx("ul", {
    className: "flex flex-wrap -m-2 reset-list"
  }, subItems.map(function (item) {
    var _item$thumbnail;

    var thumbnail = {
      imageUrl: ((_item$thumbnail = item.thumbnail) === null || _item$thumbnail === void 0 ? void 0 : _item$thumbnail.imageUrl) || '',
      ratioKey: !Object(lodash["isEmpty"])(item.subItems) ? ratios_utils["a" /* default */].S : ratios_utils["a" /* default */].XL
    };
    return NavigationLargeSubNav_jsx("li", {
      className: "w-1/4 p-2",
      key: item.label
    }, NavigationLargeSubNav_jsx(ThumbnailNavigation_ThumbnailNavigation, {
      hasImageBorder: item.hasImageBorder,
      label: item.label,
      link: Object(lodash["isEmpty"])(item.subItems) ? item.link : null,
      seeMoreLabel: item.seeMoreLabel,
      thumbnail: thumbnail
    }, !Object(lodash["isEmpty"])(item.subItems) && NavigationLargeSubNav_jsx(react["Fragment"], null, NavigationLargeSubNav_jsx("ul", {
      className: "reset-list font-bold font-sans text-gray-darker text-sm"
    }, (item.subItems || []).map(function (subitem) {
      return subitem.label ? NavigationLargeSubNav_jsx("li", {
        key: subitem.label
      }, NavigationLargeSubNav_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, subitem.link, {
        as: DynamicLink["a" /* default */],
        className: "inline-block no-underline py-1 text-gray-darker focus:text-blue hover:text-blue transition-color",
        "data-testid": "NavigationLargeSubNav-third-link"
      }), subitem.label)) : null;
    })), item.seeMoreLabel && NavigationLargeSubNav_jsx(TextLink["a" /* TextLink */], Object(esm_extends["a" /* default */])({}, item.link, {
      className: "mt-2 uppercase",
      color: colors["a" /* COLORS */].GRAY_MEDIUM,
      label: item.seeMoreLabel,
      theme: "fancy",
      trackingData: item.link.trackingData
    })))));
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/subnavs/NavigationLargeSubNavList.jsx


var NavigationLargeSubNavList_jsx = react_default.a.createElement;






function NavigationLargeSubNavList(props) {
  var _props$subItems = props.subItems,
      subItems = _props$subItems === void 0 ? [] : _props$subItems;

  if (Object(lodash["isEmpty"])(subItems)) {
    return null;
  }

  return NavigationLargeSubNavList_jsx("div", {
    className: "bg-white overflow-y-auto py-6 px-12",
    style: {
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }
  }, NavigationLargeSubNavList_jsx("ul", {
    className: "reset-list colum-count-5 column-gap-50"
  }, subItems.map(function (item, index) {
    return NavigationLargeSubNavList_jsx("li", {
      className: "break-inside-avoid-column ".concat(index ? 'my-4' : ''),
      "data-testid": "NavigationLargeSubNavList-sublist-item",
      key: item.label
    }, NavigationLargeSubNavList_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, item.link, {
      as: DynamicLink["a" /* default */],
      className: classnames_default()("text-".concat(item.color), Object(defineProperty["a" /* default */])({}, "focus:text-".concat(item.color, "-active hover:text-").concat(item.color, "-active"), !!item.color), 'reset-anchor font-bold font-sans text-md focus:text-blue hover:text-blue'),
      "data-testid": "NavigationLargeSubNavList-sublist-link"
    }), item.label), !Object(lodash["isEmpty"])(item.subItems) && NavigationLargeSubNavList_jsx("ul", {
      className: "reset-list mt-4"
    }, (item.subItems || []).map(function (subItem) {
      return NavigationLargeSubNavList_jsx("li", {
        key: subItem.label
      }, NavigationLargeSubNavList_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, subItem.link, {
        as: DynamicLink["a" /* default */],
        className: "reset-anchor font-bold font-sans text-gray-darker text-sm focus:text-blue hover:text-blue",
        "data-testid": "NavigationLargeSubNavList-subsublist-link"
      }), subItem.label));
    })));
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/NavigationLarge.jsx








var NavigationLarge_jsx = react_default.a.createElement;

function NavigationLarge_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function NavigationLarge_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { NavigationLarge_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { NavigationLarge_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function NavigationLarge_createSuper(Derived) { var hasNativeReflectConstruct = NavigationLarge_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationLarge_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-env browser */























var POPHOVER_IN_DELAY = 300;
var POPHOVER_OUT_DELAY = 500;
var NavigationLarge_NavigationLarge = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(NavigationLarge, _Component);

  var _super = NavigationLarge_createSuper(NavigationLarge);

  function NavigationLarge(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, NavigationLarge);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickOutside", function (e) {
      if (_this.state.activeElement) {
        if (!_this.navigationNode.current || !_this.navigationNode.current.contains(e.target)) {
          _this.setState({
            activeElement: null
          });
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setSubnav", function (activeIndex, isFocus) {
      return function () {
        var height = 0;

        if (true) {
          // $FlowFixMe
          height = _this["subnav".concat(activeIndex)] ? _this["subnav".concat(activeIndex)].clientHeight : 0;
        }

        clearTimeout(_this.hoverOutTimeout);
        _this.hoverInTimeout = setTimeout(function () {
          _this.setState({
            activeElement: null,
            activeIndex: activeIndex,
            height: height
          });
        }, isFocus ? 0 : POPHOVER_IN_DELAY);
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "resetSubnav", function (isFocus) {
      return function () {
        clearTimeout(_this.hoverInTimeout);
        _this.hoverOutTimeout = setTimeout(function () {
          _this.setState({
            activeIndex: -1,
            height: 0
          });
        }, isFocus ? 0 : POPHOVER_OUT_DELAY);
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleElement", function (activeElement) {
      return function () {
        _this.setState(function (prevState) {
          return {
            activeElement: prevState.activeElement === activeElement ? null : activeElement,
            activeIndex: -1,
            height: 0
          };
        });
      };
    });

    _this.navigationNode = /*#__PURE__*/Object(react["createRef"])();
    _this.state = {
      activeElement: null,
      activeIndex: -1,
      height: 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(NavigationLarge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (true) {
        document.addEventListener('click', this.onClickOutside);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (true) {
        document.removeEventListener('click', this.onClickOutside);
      }

      clearTimeout(this.hoverInTimeout);
      clearTimeout(this.hoverOutTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props$cmsMember;

      var _this$props = this.props,
          facetingSuggestedRequests = _this$props.facetingSuggestedRequests,
          id = _this$props.id,
          contact = _this$props.contact,
          items = _this$props.items,
          language = _this$props.language,
          promoBannerRef = _this$props.promoBannerRef,
          userInfo = _this$props.userInfo,
          isMicePage = _this$props.isMicePage,
          backToB2CWebsiteLabel = _this$props.backToB2CWebsiteLabel,
          backToB2CWebsiteLink = _this$props.backToB2CWebsiteLink,
          MICELogoRedirectionLink = _this$props.MICELogoRedirectionLink;

      var _ref = userInfo || {},
          isLoggedIn = _ref.isLoggedIn,
          isQuickLoggedIn = _ref.isQuickLoggedIn;

      var activeElement = this.state.activeElement;
      var iconButtonClassNames = 'reset-button cursor-pointer flex items-center px-4 relative focus:text-blue hover:text-blue';
      var offsetTop = promoBannerRef && promoBannerRef.current ? promoBannerRef.current.offsetHeight : 0;
      var isGlobalSearchActiveElement = activeElement === Navigation_constants["d" /* elements */].SEARCH;
      var hasContactDetails = (contact === null || contact === void 0 ? void 0 : contact.hours) || (contact === null || contact === void 0 ? void 0 : contact.description) || (contact === null || contact === void 0 ? void 0 : contact.toll) || (contact === null || contact === void 0 ? void 0 : contact.title);
      var logoTitle = isMicePage ? 'Club Med meetings and events page' : 'Club Med Homepage';
      return NavigationLarge_jsx("nav", {
        "aria-label": "ClubMed main navigation",
        className: "".concat(Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */], " fadeInLong absolute bg-white top-0 inset-x-0 z-main-navigation"),
        id: id,
        role: "navigation"
      }, NavigationLarge_jsx(Combination["a" /* FocusOn */], {
        allowPinchZoom: true,
        enabled: isGlobalSearchActiveElement
      }, NavigationLarge_jsx(BodyLocker["a" /* BodyLocker */], {
        isLocked: isGlobalSearchActiveElement
      }, NavigationLarge_jsx(NavigationLargeBackPanel, {
        height: this.state.height
      }), NavigationLarge_jsx("div", {
        className: "border-b-1 border-gray-light flex items-stretch justify-between px-5",
        ref: this.navigationNode,
        style: {
          height: Navigation_constants["e" /* heights */].NAVIGATION_LARGE_HEIGHT
        }
      }, NavigationLarge_jsx(TrackClick["a" /* TrackClick */], {
        as: DynamicLink["a" /* default */],
        className: "cursor-pointer flex flex-shrink-0 items-center px-5 text-blue",
        "data-testid": "NavigationLarge-logo",
        onFocus: this.resetSubnav(true),
        queryParamsToIgnore: ['selectedProposalId', 'proposalIds', 'optionIds'],
        title: logoTitle,
        trackingData: NAVIGATION_TRACKING_LOGO_BUTTON,
        url: "".concat(isMicePage ? MICELogoRedirectionLink : '/')
      }, NavigationLarge_jsx(Icon["a" /* Icon */], {
        className: classnames_default()({
          '-mt-1': !isMicePage,
          'mt-1': isMicePage
        }),
        isNotSquare: true,
        name: isMicePage ? icons["a" /* ICONS */].CLUBMED_MEETINGS : icons["a" /* ICONS */].CLUBMED,
        width: "10rem"
      }), NavigationLarge_jsx("span", {
        className: "sr-only"
      }, logoTitle)), NavigationLarge_jsx("ul", {
        className: "reset-list flex",
        style: {
          flex: '0 1 auto'
        }
      }, items.map(function (item, index) {
        var subItems = item.subItems || [];
        var hasSubItems = !!subItems.length;
        var isList = item.isList,
            label = item.label;
        var isActive = index === _this2.state.activeIndex;
        var subnavName = "subnav".concat(index);
        return !!label && NavigationLarge_jsx("li", {
          className: "flex items-stretch",
          "data-testid": "NavigationLarge-item",
          key: label,
          onFocus: _this2.setSubnav(index, true),
          onMouseEnter: _this2.setSubnav(index),
          onBlur: _this2.resetSubnav(true),
          onMouseLeave: _this2.resetSubnav()
        }, NavigationLarge_jsx(NavigationLargeFirstLevelItem, {
          color: item.color,
          hasSubItems: hasSubItems,
          isActive: isActive,
          link: item.link
        }, label), hasSubItems && NavigationLarge_jsx(NavigationLargePanel, {
          isActive: isActive // $FlowFixMe
          ,
          ref: function ref(elem) {
            return _this2[subnavName] = elem;
          }
        }, isList ? NavigationLarge_jsx(NavigationLargeSubNavList, {
          parentLabel: label,
          subItems: subItems
        }) : NavigationLarge_jsx(NavigationLargeSubNav, {
          subItems: subItems
        })));
      })), NavigationLarge_jsx("div", {
        className: "flex flex-shrink-0 relative"
      }, !Object(lodash["isEmpty"])(contact) && NavigationLarge_jsx(react["Fragment"], null, NavigationLarge_jsx(TrackClick["a" /* TrackClick */], {
        as: "button",
        "aria-expanded": activeElement === Navigation_constants["d" /* elements */].CONTACT,
        "data-testid": "NavigationLarge-contact-button",
        className: classnames_default()(iconButtonClassNames, 'navigation-arrow', {
          'text-blue navigation-arrow-active': activeElement === Navigation_constants["d" /* elements */].CONTACT
        }),
        onClick: hasContactDetails ? this.toggleElement(Navigation_constants["d" /* elements */].CONTACT) : undefined,
        style: {
          fontSize: '0.8125rem'
        },
        title: contact.title,
        trackingData: activeElement === Navigation_constants["d" /* elements */].CONTACT || !hasContactDetails ? null : NAVIGATION_TRACKING_CONTACT_BUTTON,
        type: "button"
      }, NavigationLarge_jsx(Icon["a" /* Icon */], {
        className: "rtl:mr-1",
        color: colors["a" /* COLORS */].BLUE,
        hasRtl: true,
        name: icons["a" /* ICONS */].PHONE,
        width: "1em"
      }), NavigationLarge_jsx("span", {
        className: "sr-only"
      }, contact.title, "\xA0"), NavigationLarge_jsx("span", {
        className: "font-bold text-blue whitespace-no-wrap",
        dir: "ltr"
      }, contact.phoneNumber)), NavigationLarge_jsx(NavigationLargeElement_NavigationLargeElement, {
        onClose: this.toggleElement(Navigation_constants["d" /* elements */].CONTACT),
        style: {
          width: '18.75rem'
        }
      }, activeElement === Navigation_constants["d" /* elements */].CONTACT ? NavigationLarge_jsx(NavigationContact, {
        contact: contact
      }) : null)), isMicePage && NavigationLarge_jsx(TrackClick["a" /* TrackClick */], {
        as: DynamicLink["a" /* default */],
        trackingData: {
          categoryGA: 'headerMenu',
          actionGA: 'header_backToB2C',
          labelGA: 'backToB2C'
        },
        className: "text-base leading-tight font-bold underline reset-button cursor-pointer flex items-center relative px-4 focus:text-blue hover:text-blue text-gray-darker",
        url: backToB2CWebsiteLink
      }, backToB2CWebsiteLabel), !isMicePage && NavigationLarge_jsx(react["Fragment"], null, NavigationLarge_jsx(GlobalSearch_GlobalSearch, {
        className: "reset-button cursor-pointer flex items-center relative px-4 focus:text-blue hover:text-blue text-gray-darker",
        facetingSuggestedRequests: facetingSuggestedRequests,
        isOpen: activeElement === Navigation_constants["d" /* elements */].SEARCH,
        offsetTop: offsetTop,
        toggleOpen: this.toggleElement(Navigation_constants["d" /* elements */].SEARCH)
      }), NavigationLarge_jsx(NavigationMemberAccessButton_NavigationMemberAccessButton, {
        className: classnames_default()(iconButtonClassNames, 'navigation-arrow', {
          'text-blue navigation-arrow-active': activeElement === Navigation_constants["d" /* elements */].LOGIN
        }),
        isActive: activeElement === Navigation_constants["d" /* elements */].LOGIN,
        isAuthenticated: isLoggedIn,
        isQuickLoggedIn: isQuickLoggedIn,
        onClick: this.toggleElement(Navigation_constants["d" /* elements */].LOGIN),
        title: (_this$props$cmsMember = this.props.cmsMemberSpace) === null || _this$props$cmsMember === void 0 ? void 0 : _this$props$cmsMember.title
      }), NavigationLarge_jsx(NavigationLargeElement_NavigationLargeElement, {
        className: "rounded-small shadow-md",
        onClose: this.toggleElement(Navigation_constants["d" /* elements */].LOGIN),
        style: NavigationLarge_objectSpread({
          width: '40rem'
        }, isLoggedIn || isQuickLoggedIn ? {
          width: '18.125rem',
          padding: '0'
        } : {})
      }, activeElement === Navigation_constants["d" /* elements */].LOGIN ? NavigationLarge_jsx(NavigationMemberAccess_NavigationMemberAccess, {
        cmsAccount: this.props.cmsAccount,
        cmsMemberSpace: this.props.cmsMemberSpace,
        userInfo: userInfo
      }) : null)), Object.keys((language === null || language === void 0 ? void 0 : language.locales) || {}).length > 1 && NavigationLarge_jsx(react["Fragment"], null, NavigationLarge_jsx("button", {
        "aria-expanded": activeElement === Navigation_constants["d" /* elements */].LANGUAGES,
        className: classnames_default()(iconButtonClassNames, 'text-center text-sm uppercase navigation-arrow', {
          'text-blue navigation-arrow-active': activeElement === Navigation_constants["d" /* elements */].LANGUAGES
        }),
        "data-testid": "NavigationLarge-language-button",
        onClick: this.toggleElement(Navigation_constants["d" /* elements */].LANGUAGES),
        style: {
          minWidth: '3.5rem'
        },
        title: "languages",
        type: "button"
      }, NavigationLarge_jsx("span", {
        className: classnames_default()('toggler', {
          'toggler-active': activeElement === Navigation_constants["d" /* elements */].LANGUAGES
        })
      }, language.locales[language.currentLocale].label)), NavigationLarge_jsx(NavigationLargeElement_NavigationLargeElement, {
        className: "px-1 py-0",
        onClose: this.toggleElement(Navigation_constants["d" /* elements */].LANGUAGES)
      }, activeElement === Navigation_constants["d" /* elements */].LANGUAGES && NavigationLarge_jsx(Languages, Object(esm_extends["a" /* default */])({}, language, {
        currentLocale: language.currentLocale,
        getTrackingData: getNavigationLanguagesButtonTrackingData,
        isActive: activeElement === Navigation_constants["d" /* elements */].LANGUAGES,
        locales: language.locales,
        theme: "column"
      })))))))));
    }
  }]);

  return NavigationLarge;
}(react["Component"]);

Object(defineProperty["a" /* default */])(NavigationLarge_NavigationLarge, "defaultProps", {
  id: 'Navigation',
  language: {}
});
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react-stickynode/index.js
var react_stickynode = __webpack_require__("gyFy");
var react_stickynode_default = /*#__PURE__*/__webpack_require__.n(react_stickynode);

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/NavigationSticky.jsx








var NavigationSticky_jsx = react_default.a.createElement;

function NavigationSticky_createSuper(Derived) { var hasNativeReflectConstruct = NavigationSticky_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationSticky_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






function stickyNav(WrappedComponent) {
  var _temp;

  return _temp = /*#__PURE__*/function (_Component) {
    Object(inherits["a" /* default */])(NavigationSticky, _Component);

    var _super = NavigationSticky_createSuper(NavigationSticky);

    function NavigationSticky(props) {
      var _this;

      Object(classCallCheck["a" /* default */])(this, NavigationSticky);

      _this = _super.call(this, props);

      Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onLock", function () {
        var isLocked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        _this.setState({
          isLocked: isLocked
        });
      });

      Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleScroll", Object(lodash["throttle"])(function () {
        var _this$state = _this.state,
            lastY = _this$state.lastY,
            isLocked = _this$state.isLocked;

        if (!isLocked) {
          var posY = Math.max(window.pageYOffset, 0);
          var stickyStart = Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT;
          var scrolledDown = posY > lastY;

          _this.setState(function () {
            return {
              isHidden: scrolledDown && posY > stickyStart,
              lastY: posY
            };
          });
        }
      }, 200));

      Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onStateChange", function (status) {
        _this.setState(function () {
          return {
            isSticky: status.status !== react_stickynode_default.a.STATUS_ORIGINAL
          };
        });
      });

      _this.state = {
        isHidden: false,
        isLocked: false,
        isSticky: false,
        lastY: 0
      };
      return _this;
    }

    Object(createClass["a" /* default */])(NavigationSticky, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        document.addEventListener('scroll', this.handleScroll, false);
        this.handleScroll();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll, false);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state2 = this.state,
            isHidden = _this$state2.isHidden,
            isLocked = _this$state2.isLocked,
            isSticky = _this$state2.isSticky;
        return NavigationSticky_jsx(react_stickynode_default.a, {
          enableTransforms: false,
          innerClass: classnames_default()('w-full', {
            '-translate-y-100': isSticky && isHidden
          }),
          innerZ: isLocked ? 7 : 5,
          onStateChange: this.onStateChange
        }, NavigationSticky_jsx(WrappedComponent, Object(esm_extends["a" /* default */])({}, this.props, {
          onLock: this.onLock,
          isSticky: isSticky
        })));
      }
    }]);

    return NavigationSticky;
  }(react["Component"]), _temp;
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/SideNavigationItem.jsx

var SideNavigationItem_jsx = react_default.a.createElement;







var SideNavigationItem_SideNavigationItem = function SideNavigationItem(props) {
  var color = props.color,
      hasFocus = props.hasFocus,
      isRoot = props.isRoot,
      label = props.label,
      _props$link = props.link,
      link = _props$link === void 0 ? {} : _props$link,
      nextPanel = props.nextPanel,
      onClick = props.onClick,
      setActiveItem = props.setActiveItem,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex;
  var buttonRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (hasFocus && buttonRef && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [hasFocus]);

  var handleClick = function handleClick() {
    onClick(nextPanel);
    setActiveItem();
  };

  var content = SideNavigationItem_jsx(react["Fragment"], {
    key: label
  }, SideNavigationItem_jsx("span", {
    className: classnames_default()("text-".concat(color), 'font-bold font-sans text-md', {
      uppercase: isRoot
    })
  }, label), SideNavigationItem_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.625rem"
  }));

  return link && link.url ? SideNavigationItem_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, link, {
    as: DynamicLink["a" /* default */],
    className: "reset-anchor cursor-pointer flex items-center w-full h-full py-4 justify-between",
    "data-testid": "SideNavigationItem-subitem-link",
    onClick: handleClick,
    tabIndex: tabIndex
  }), content) : SideNavigationItem_jsx("button", {
    className: "reset-button w-full",
    "data-testid": "SideNavigationItem-subitem-button",
    onClick: handleClick,
    ref: buttonRef,
    tabIndex: tabIndex,
    type: "button"
  }, SideNavigationItem_jsx("div", {
    className: "flex items-center w-full h-full py-4 justify-between"
  }, content));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/SideNavigation.jsx

var SideNavigation_jsx = react_default.a.createElement;












function SideNavigation(props) {
  var backButtonLabel = props.backButtonLabel,
      backToB2CWebsiteLabel = props.backToB2CWebsiteLabel,
      backToB2CWebsiteLink = props.backToB2CWebsiteLink,
      closeMenu = props.closeMenu,
      _props$id = props.id,
      id = _props$id === void 0 ? 'SideNavigation' : _props$id,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      isActive = props.isActive,
      isHidden = props.isHidden,
      isMicePage = props.isMicePage,
      label = props.label,
      language = props.language,
      navBack = props.navBack,
      navForward = props.navForward,
      parent = props.parent,
      parentLabel = props.parentLabel,
      parentLink = props.parentLink,
      style = props.style;

  var _useState = Object(react["useState"])(-1),
      activeItem = _useState[0],
      _setActiveItem = _useState[1];

  var backButtonRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (!isHidden && backButtonRef && backButtonRef.current) {
      backButtonRef.current.focus();
    }

    if (isHidden) {
      _setActiveItem(-1);
    }
  }, [isHidden]);
  var classNames = isHidden ? 'rtl:-translate-x-100' : 'translate-x-0';
  var hasParentLink = parentLink && parentLink.url;
  var navItems = items.map(function (item, idx) {
    var itemProps = {
      color: item.color,
      isRoot: Object(lodash["isEmpty"])(parent),
      label: item.label,
      link: {},
      nextPanel: '',
      onClick: navForward,
      setActiveItem: function setActiveItem() {
        _setActiveItem(idx);
      },
      tabIndex: isActive ? 0 : -1
    };
    var subItems = item.subItems || [];
    var itemId = "".concat(item.label.replace(/ /g, '-').toLowerCase()).concat(item.id);

    if (subItems.length) {
      itemProps.nextPanel = itemId;
    } else {
      itemProps.link = Object(lodash["get"])(item, 'link');
    }

    return SideNavigation_jsx("li", {
      key: itemId
    }, SideNavigation_jsx(SideNavigationItem_SideNavigationItem, Object(esm_extends["a" /* default */])({}, itemProps, {
      hasFocus: isActive && activeItem === idx
    })));
  });
  return SideNavigation_jsx("div", {
    "aria-hidden": isHidden,
    className: classnames_default()('bg-white fixed bottom-0 w-full rtl:left-0', classNames),
    id: id,
    style: style
  }, SideNavigation_jsx("div", {
    className: "bg-white h-full overflow-y-scroll p-px15"
  }, !!parent && !!label && SideNavigation_jsx("div", {
    className: "flex justify-between"
  }, SideNavigation_jsx("button", {
    className: "reset-button flex font-bold items-center p-px10 text-base rtl:-ml-px10",
    "data-testid": "SideNavigation-back",
    onClick: navBack ? function () {
      return navBack();
    } : null,
    ref: backButtonRef,
    tabIndex: isActive ? 0 : -1,
    type: "button"
  }, SideNavigation_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLUE,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    rotation: 180,
    width: "0.8125rem"
  }), !!backButtonLabel && SideNavigation_jsx("span", {
    className: "sr-only",
    "data-testid": "SideNavigation-back-label"
  }, Object(dist["messageFormat"])(backButtonLabel).format({
    item: parentLabel
  }))), SideNavigation_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, hasParentLink ? parentLink : null, {
    as: hasParentLink ? DynamicLink["a" /* default */] : 'div',
    className: "block font-bold py-px10 text-blue text-md uppercase",
    onClick: closeMenu,
    "data-testid": "SideNavigation-item-link",
    tabIndex: isActive ? 0 : -1,
    trackingData: parentLink && parentLink.trackingData
  }), label)), SideNavigation_jsx("ul", {
    className: "reset-list"
  }, !Object(lodash["isEmpty"])(items) && navItems), !parent && isMicePage && backToB2CWebsiteLabel && SideNavigation_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    trackingData: {
      categoryGA: 'headerMenu',
      actionGA: 'header_backToB2C',
      labelGA: 'backToB2C'
    },
    className: "block text-md py-px15 leading-tight font-bold underline reset-button cursor-pointer relative focus:text-blue hover:text-blue text-gray-darker",
    url: backToB2CWebsiteLink,
    onClick: closeMenu
  }, backToB2CWebsiteLabel), !parent && language && Object.keys(Object(lodash["get"])(language, 'locales', {})).length > 1 && SideNavigation_jsx("div", {
    className: "border-b-1 border-t-1 border-gray-light overflow-x-auto"
  }, SideNavigation_jsx(Languages, Object(esm_extends["a" /* default */])({}, language, {
    className: "min-w-full py-px15",
    getTrackingData: getNavigationLanguagesButtonTrackingData,
    isActive: isActive
  })))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/SubItems.jsx

var SubItems_jsx = react_default.a.createElement;



function SubItems(props) {
  var backButtonLabel = props.backButtonLabel,
      backButtonMainNavLabel = props.backButtonMainNavLabel,
      items = props.items,
      language = props.language,
      navBack = props.navBack,
      navForward = props.navForward,
      closeMenu = props.closeMenu,
      panelStyles = props.panelStyles,
      parentId = props.parentId,
      parentLabel = props.parentLabel,
      sideNavigationPanels = props.sideNavigationPanels;
  return items.filter(function (item) {
    return item.subItems && item.subItems.length;
  }).map(function (_ref) {
    var id = _ref.id,
        label = _ref.label,
        link = _ref.link,
        subItems = _ref.subItems;
    var itemId = "".concat(label.replace(/ /g, '-').toLowerCase()).concat(id);
    var panelProps = {
      backButtonLabel: parentId === Navigation_constants["c" /* ROOT_ID */] ? backButtonMainNavLabel : backButtonLabel,
      id: itemId,
      isActive: !!sideNavigationPanels.length && sideNavigationPanels[sideNavigationPanels.length - 1] === itemId,
      isHidden: !sideNavigationPanels.includes(itemId),
      items: subItems,
      label: label,
      language: language,
      navBack: navBack,
      navForward: navForward,
      closeMenu: closeMenu,
      parent: parentId,
      parentLabel: parentLabel,
      parentLink: link,
      style: panelStyles
    };
    return [SubItems_jsx(SideNavigation, Object(esm_extends["a" /* default */])({
      key: label
    }, panelProps)), SubItems_jsx(SubItems, Object(esm_extends["a" /* default */])({
      key: itemId
    }, props, {
      parentId: itemId,
      parentLabel: label,
      items: subItems
    }))];
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/NavigationNarrowElementPanel.jsx
var NavigationNarrowElementPanel_jsx = react_default.a.createElement;


function NavigationNarrowElementPanel(_ref) {
  var children = _ref.children,
      isActive = _ref.isActive,
      className = _ref.className,
      style = _ref.style;
  return NavigationNarrowElementPanel_jsx("div", {
    className: classnames_default()(className ? className : 'bg-white fixed bottom-0 rtl:right-0 p-4 w-full', {
      'translate-x-0': isActive,
      'rtl:translate-x-100': !isActive
    }),
    style: style
  }, children);
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/NavigationNarrow.jsx








var NavigationNarrow_jsx = react_default.a.createElement;

function NavigationNarrow_createSuper(Derived) { var hasNativeReflectConstruct = NavigationNarrow_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationNarrow_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }





















var NavigationNarrow_NavigationNarrow = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(NavigationNarrow, _PureComponent);

  var _super = NavigationNarrow_createSuper(NavigationNarrow);

  function NavigationNarrow(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, NavigationNarrow);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleElement", function (activeElement) {
      return function () {
        _this.setState(function (prevState) {
          return {
            activeElement: prevState.activeElement === activeElement ? null : activeElement,
            sideNavigationPanels: []
          };
        }, function () {
          return _this.props.onLock(!!_this.state.activeElement);
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "resetNav", function () {
      _this.setState({
        activeElement: null,
        sideNavigationPanels: []
      }, function () {
        return _this.props.onLock(false);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "navBack", function () {
      var sideNavigationPanels = _this.state.sideNavigationPanels;

      _this.setState({
        sideNavigationPanels: sideNavigationPanels.splice(0, sideNavigationPanels.length - 1)
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "navForward", function (nextPanel) {
      var sideNavigationPanels = _this.state.sideNavigationPanels;
      nextPanel && !sideNavigationPanels.includes(nextPanel) ? _this.setState({
        sideNavigationPanels: [].concat(Object(toConsumableArray["a" /* default */])(sideNavigationPanels), [nextPanel])
      }) : _this.toggleElement(Navigation_constants["d" /* elements */].MENU)();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeMenu", function () {
      _this.toggleElement(Navigation_constants["d" /* elements */].MENU)();
    });

    _this.state = {
      activeElement: null,
      sideNavigationPanels: []
    };
    return _this;
  }

  Object(createClass["a" /* default */])(NavigationNarrow, [{
    key: "render",
    value: function render() {
      var _this$props$cmsMember;

      var _this$props = this.props,
          backButtonLabel = _this$props.backButtonLabel,
          backButtonMainNavLabel = _this$props.backButtonMainNavLabel,
          backToB2CWebsiteLabel = _this$props.backToB2CWebsiteLabel,
          backToB2CWebsiteLink = _this$props.backToB2CWebsiteLink,
          closeMainNavLabel = _this$props.closeMainNavLabel,
          cmsAccount = _this$props.cmsAccount,
          cmsMemberSpace = _this$props.cmsMemberSpace,
          contact = _this$props.contact,
          facetingSuggestedRequests = _this$props.facetingSuggestedRequests,
          id = _this$props.id,
          isMicePage = _this$props.isMicePage,
          isSticky = _this$props.isSticky,
          items = _this$props.items,
          language = _this$props.language,
          openMainNavLabel = _this$props.openMainNavLabel,
          promoBannerRef = _this$props.promoBannerRef,
          userInfo = _this$props.userInfo,
          MICELogoRedirectionLink = _this$props.MICELogoRedirectionLink;
      var _this$state = this.state,
          activeElement = _this$state.activeElement,
          sideNavigationPanels = _this$state.sideNavigationPanels;
      var offsetTop = !isSticky && promoBannerRef && promoBannerRef.current ? promoBannerRef.current.offsetHeight : 0;
      var panelStyles = {
        maxWidth: '31rem',
        top: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT + offsetTop,
        transition: 'transform linear 330ms'
      };
      var hasContactDetails = (contact === null || contact === void 0 ? void 0 : contact.phoneNumber) || (contact === null || contact === void 0 ? void 0 : contact.hours) || (contact === null || contact === void 0 ? void 0 : contact.description) || (contact === null || contact === void 0 ? void 0 : contact.toll) || (contact === null || contact === void 0 ? void 0 : contact.title);
      return NavigationNarrow_jsx("nav", {
        className: classnames_default()('bg-white w-full', Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */]),
        id: id,
        role: "navigation"
      }, NavigationNarrow_jsx(Combination["a" /* FocusOn */], {
        allowPinchZoom: true,
        enabled: !!activeElement
      }, NavigationNarrow_jsx(BodyLocker["a" /* BodyLocker */], {
        isLocked: !!activeElement
      }, NavigationNarrow_jsx("div", {
        className: "border-b-1 flex flex-no-wrap",
        style: {
          height: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT
        }
      }, NavigationNarrow_jsx("div", {
        className: "rtl:border-r-1 border-gray-light flex items-center h-full"
      }, NavigationNarrow_jsx("button", {
        id: "NavigationNarrow-toggleSideNav-button",
        className: "reset-button h-full p-4 text-blue",
        onClick: this.toggleElement(Navigation_constants["d" /* elements */].MENU),
        type: "button"
      }, NavigationNarrow_jsx("span", {
        className: "sr-only"
      }, activeElement === Navigation_constants["d" /* elements */].MENU ? closeMainNavLabel : openMainNavLabel), NavigationNarrow_jsx("div", {
        className: "hamburger"
      }, NavigationNarrow_jsx("span", {
        className: classnames_default()('hamburger-span', {
          'hamburger-span-active': activeElement === Navigation_constants["d" /* elements */].MENU
        })
      })))), NavigationNarrow_jsx(SideNavigation, {
        id: Navigation_constants["c" /* ROOT_ID */],
        isActive: activeElement === Navigation_constants["d" /* elements */].MENU && !sideNavigationPanels.length,
        isHidden: activeElement !== Navigation_constants["d" /* elements */].MENU,
        items: items,
        language: language,
        navBack: this.navBack,
        navForward: this.navForward,
        closeMenu: this.closeMenu,
        style: panelStyles,
        isMicePage: isMicePage,
        backToB2CWebsiteLink: backToB2CWebsiteLink,
        backToB2CWebsiteLabel: backToB2CWebsiteLabel
      }), NavigationNarrow_jsx(SubItems, {
        parentId: Navigation_constants["c" /* ROOT_ID */],
        items: items,
        sideNavigationPanels: sideNavigationPanels,
        backButtonLabel: backButtonLabel,
        backButtonMainNavLabel: backButtonMainNavLabel,
        language: language,
        panelStyles: panelStyles,
        navBack: this.navBack,
        navForward: this.navForward,
        closeMenu: this.closeMenu
      }), NavigationNarrow_jsx("div", {
        className: "flex-1 px-2"
      }, NavigationNarrow_jsx(TrackClick["a" /* TrackClick */], {
        as: DynamicLink["a" /* default */],
        className: "flex items-center",
        "data-testid": "NavigationNarrow-logo-link",
        onClick: this.resetNav,
        style: {
          height: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT
        },
        trackingData: NAVIGATION_TRACKING_LOGO_BUTTON,
        url: "".concat(isMicePage ? MICELogoRedirectionLink : '/')
      }, NavigationNarrow_jsx(Icon["a" /* Icon */], {
        className: classnames_default()({
          'mt-1': isMicePage
        }),
        color: colors["a" /* COLORS */].BLUE,
        isNotSquare: true,
        name: isMicePage ? icons["a" /* ICONS */].CLUBMED_MEETINGS : icons["a" /* ICONS */].CLUBMED,
        width: isMicePage ? '9rem' : '6rem'
      }), NavigationNarrow_jsx("span", {
        className: "sr-only"
      }, isMicePage ? 'Club Med meetings and events page' : 'Club Med Homepage'))), NavigationNarrow_jsx("div", {
        className: "flex"
      }, !isMicePage && NavigationNarrow_jsx(GlobalSearch_GlobalSearch, {
        className: classnames_default()('reset-button flex items-center px-2 relative navigation-arrow', {
          'text-gray-darker': activeElement !== Navigation_constants["d" /* elements */].SEARCH,
          'text-blue navigation-arrow-active': activeElement === Navigation_constants["d" /* elements */].SEARCH
        }),
        facetingSuggestedRequests: facetingSuggestedRequests,
        isOpen: activeElement === Navigation_constants["d" /* elements */].SEARCH,
        offsetTop: offsetTop,
        toggleOpen: this.toggleElement(Navigation_constants["d" /* elements */].SEARCH)
      }), !Object(lodash["isEmpty"])(contact) && NavigationNarrow_jsx(react["Fragment"], null, NavigationNarrow_jsx(TrackClick["a" /* TrackClick */], {
        as: "button",
        "aria-expanded": activeElement === Navigation_constants["d" /* elements */].CONTACT,
        className: classnames_default()('reset-button flex items-center px-2 relative navigation-arrow', {
          'text-gray-darker': activeElement !== Navigation_constants["d" /* elements */].CONTACT,
          'text-blue navigation-arrow-active': activeElement === Navigation_constants["d" /* elements */].CONTACT
        }),
        "data-testid": "NavigationNarrow-contact-button",
        onClick: hasContactDetails ? this.toggleElement(Navigation_constants["d" /* elements */].CONTACT) : undefined,
        title: contact.title,
        trackingData: activeElement === Navigation_constants["d" /* elements */].CONTACT || !hasContactDetails ? null : NAVIGATION_TRACKING_CONTACT_BUTTON,
        type: "button"
      }, NavigationNarrow_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].PHONE,
        width: "1.1875rem"
      }), NavigationNarrow_jsx("span", {
        className: "sr-only"
      }, contact.title)), NavigationNarrow_jsx(NavigationNarrowElementPanel, {
        isActive: activeElement === Navigation_constants["d" /* elements */].CONTACT,
        style: panelStyles
      }, activeElement === Navigation_constants["d" /* elements */].CONTACT && NavigationNarrow_jsx(NavigationContact, {
        contact: contact,
        hasTel: true
      }))), !isMicePage && NavigationNarrow_jsx(react["Fragment"], null, NavigationNarrow_jsx(NavigationMemberAccessButton_NavigationMemberAccessButton, {
        className: classnames_default()('reset-button flex items-center px-2 relative navigation-arrow', {
          'text-gray-darker': activeElement !== Navigation_constants["d" /* elements */].LOGIN,
          'text-blue navigation-arrow-active': activeElement === Navigation_constants["d" /* elements */].LOGIN
        }),
        isActive: activeElement === Navigation_constants["d" /* elements */].LOGIN,
        isAuthenticated: userInfo && userInfo.isLoggedIn,
        isQuickLoggedIn: userInfo && userInfo.isQuickLoggedIn,
        onClick: this.toggleElement(Navigation_constants["d" /* elements */].LOGIN),
        title: (_this$props$cmsMember = this.props.cmsMemberSpace) === null || _this$props$cmsMember === void 0 ? void 0 : _this$props$cmsMember.title
      }), NavigationNarrow_jsx(NavigationNarrowElementPanel, {
        className: classnames_default()('w-9/10 bg-white fixed bottom-0 rtl:right-0 p-5 rounded-small overflow-y-auto', {
          'shadow-xs': activeElement === Navigation_constants["d" /* elements */].LOGIN
        }),
        isActive: activeElement === Navigation_constants["d" /* elements */].LOGIN,
        style: panelStyles
      }, activeElement === Navigation_constants["d" /* elements */].LOGIN && NavigationNarrow_jsx(NavigationMemberAccess_NavigationMemberAccess, {
        cmsAccount: cmsAccount,
        cmsMemberSpace: cmsMemberSpace,
        userInfo: userInfo
      }))))))));
    }
  }]);

  return NavigationNarrow;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(NavigationNarrow_NavigationNarrow, "defaultProps", {
  backButtonLabel: '',
  contact: {},
  id: 'Navigation',
  items: [],
  onLock: function onLock() {}
});

var StickyNavigationNarrow = stickyNav(NavigationNarrow_NavigationNarrow);
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/Navigation.jsx

var Navigation_jsx = react_default.a.createElement;







var Navigation_Navigation = function Navigation(props) {
  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var _useContext2 = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]),
      pageType = _useContext2.pageType;

  var facetingSuggestedRequests = props.facetingSuggestedRequests,
      navigation = props.navigation,
      userInfo = props.userInfo,
      id = props.id,
      promoBannerRef = props.promoBannerRef,
      language = props.language,
      cmsAccount = props.cmsAccount,
      cmsMemberSpace = props.cmsMemberSpace;
  var menus = navigation.menus,
      menusMICE = navigation.menusMICE,
      contact = navigation.contact,
      contactMICE = navigation.contactMICE,
      backButtonLabel = navigation.backButtonLabel,
      backButtonMainNavLabel = navigation.backButtonMainNavLabel,
      closeMainNavLabel = navigation.closeMainNavLabel,
      openMainNavLabel = navigation.openMainNavLabel,
      backToB2CWebsiteLabel = navigation.backToB2CWebsiteLabel,
      backToB2CWebsiteLink = navigation.backToB2CWebsiteLink,
      MICELogoRedirectionLink = navigation.MICELogoRedirectionLink;
  var isMicePage = dist["b2cPagesService"].isMicePage(pageType);
  var navigationProps = {
    backToB2CWebsiteLabel: backToB2CWebsiteLabel,
    backToB2CWebsiteLink: backToB2CWebsiteLink,
    cmsAccount: cmsAccount,
    cmsMemberSpace: cmsMemberSpace,
    contact: isMicePage ? contactMICE : contact,
    facetingSuggestedRequests: facetingSuggestedRequests,
    id: id,
    isMicePage: isMicePage,
    items: Navigation_mapper_buildNavigationMenuItems(isMicePage ? menusMICE : menus),
    language: language,
    promoBannerRef: promoBannerRef,
    userInfo: userInfo,
    MICELogoRedirectionLink: MICELogoRedirectionLink
  };
  return isDesktop ? Navigation_jsx(NavigationLarge_NavigationLarge, navigationProps) : Navigation_jsx(StickyNavigationNarrow, Object(esm_extends["a" /* default */])({}, navigationProps, {
    backButtonLabel: backButtonLabel,
    backButtonMainNavLabel: backButtonMainNavLabel,
    closeMainNavLabel: closeMainNavLabel,
    openMainNavLabel: openMainNavLabel
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/popin-newsletter/PopinNewsletter.jsx
var PopinNewsletter = __webpack_require__("Qosd");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/router/withRouter.js
var withRouter = __webpack_require__("MGbB");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/widgets/cookie-warning/CookieWarningBanner.jsx
var CookieWarningBanner_jsx = react_default.a.createElement;







var CookieWarningBanner_CookieWarningBanner = function CookieWarningBanner(_ref) {
  var acceptCookies = _ref.acceptCookies,
      approveAriaLabel = _ref.approveAriaLabel,
      buttonLabel = _ref.buttonLabel,
      cookieKey = _ref.cookieKey,
      dataSelector = _ref.dataSelector,
      link = _ref.link,
      openLayer = _ref.openLayer,
      openLayerLabel = _ref.openLayerLabel,
      text = _ref.text,
      title = _ref.title;
  return CookieWarningBanner_jsx(react["Fragment"], null, CookieWarningBanner_jsx("section", {
    className: "bg-white fixed bottom-0 shadow w-full z-6"
  }, CookieWarningBanner_jsx(SiteContainer["a" /* SiteContainer */], null, CookieWarningBanner_jsx("div", {
    className: "flex flex-col sm:flex-row sm:items-center py-2"
  }, CookieWarningBanner_jsx("div", {
    className: "p-2"
  }, !!title && CookieWarningBanner_jsx("h3", {
    className: "reset-heading font-bold font-sans leading-tight mb-1 text-gray-darker text-md sm:text-lg"
  }, title), CookieWarningBanner_jsx(Text["a" /* Text */], {
    className: "font-sans leading-normal mb-1 text-gray-darker text-sm sm:text-base",
    text: text
  }), !!link.label && CookieWarningBanner_jsx("p", {
    className: "font-bold font-sans leading-normal mb-1 mt-0 text-gray-darker text-sm sm:text-base"
  }, CookieWarningBanner_jsx(DynamicLink["a" /* default */], {
    className: "no-underline text-gray-darker",
    target: "_blank",
    url: link.url
  }, link.label))), CookieWarningBanner_jsx("div", {
    className: "flex-shrink-0 p-2 text-center sm:w-1/5 sm:max-w-xs"
  }, CookieWarningBanner_jsx(Button["a" /* Button */], {
    ariaLabel: approveAriaLabel,
    className: "w-full",
    onClick: acceptCookies
  }, buttonLabel), CookieWarningBanner_jsx(TextLink["a" /* TextLink */], {
    className: "mt-4",
    isUppercase: true,
    label: openLayerLabel,
    onClick: openLayer
  }))))), CookieWarningBanner_jsx("script", {
    dangerouslySetInnerHTML: {
      __html: "\n        var banner = document.querySelector(\"div[data-selector='".concat(dataSelector, "']\");\n\n        if (banner && document && document.cookie.match(/").concat(cookieKey, "=1/)) {\n          console.log('hide')\n          banner.style.display = \"none\";\n        }\n      ")
    }
  }));
};

/* harmony default export */ var cookie_warning_CookieWarningBanner = (CookieWarningBanner_CookieWarningBanner);
// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/cookie-warning/PreferencesItemSwitch.jsx
var PreferencesItemSwitch_jsx = react_default.a.createElement;




var PreferencesItemSwitch_PreferencesItemSwitch = function PreferencesItemSwitch(_ref) {
  var index = _ref.index,
      isChecked = _ref.isChecked,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      title = _ref.title;
  return PreferencesItemSwitch_jsx("div", {
    className: "flex mt-4"
  }, PreferencesItemSwitch_jsx("div", {
    className: "rtl:mr-4"
  }, PreferencesItemSwitch_jsx(InputSwitch["a" /* InputSwitch */], {
    ariaDescribedby: "".concat(name, "-text"),
    ariaLabelledby: name,
    color: colors["a" /* COLORS */].EMERALD,
    isChecked: isChecked,
    isDisabled: index === 0,
    isSwitch: true,
    name: name,
    onChange: onChange(index),
    size: "medium",
    value: name
  })), PreferencesItemSwitch_jsx("div", {
    className: "flex-1"
  }, PreferencesItemSwitch_jsx("h4", {
    id: name,
    className: "reset-heading font-bold font-sans leading-normal text-gray-darker text-sm sm:text-base uppercase"
  }, title), PreferencesItemSwitch_jsx(Text["a" /* Text */], {
    id: "".concat(name, "-text"),
    className: "font-sans leading-normal text-gray-darker text-sm sm:text-base",
    text: label
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/cookie-warning/constants.js
var COOKIE_PREFERENCES_STATS = 'statsCookie';
var COOKIE_PREFERENCES_PERSO = 'persoCookie';
var COOKIE_PREFERENCES_MEDIA = 'mediaCookie';
var COOKIE_PREFERENCES_LAYER = 'cookiePreferences';
var COOKIE_WARNING_LOCALSTORAGE_KEY = 'cookieBanner';
var COOKIES_ARRAY = [COOKIE_PREFERENCES_STATS, COOKIE_PREFERENCES_PERSO, COOKIE_PREFERENCES_MEDIA];
// CONCATENATED MODULE: ./src/client/components/widgets/cookie-warning/CookiePreferencesLayer.jsx
var CookiePreferencesLayer_jsx = react_default.a.createElement;












var CookiePreferencesLayer_CookiePreferencesLayer = function CookiePreferencesLayer(_ref) {
  var approveAriaLabel = _ref.approveAriaLabel,
      back = _ref.back,
      backAriaLabel = _ref.backAriaLabel,
      buttonLabel = _ref.buttonLabel,
      closeLabel = _ref.closeLabel,
      closeLayer = _ref.closeLayer,
      items = _ref.items,
      link = _ref.link,
      onChange = _ref.onChange,
      onValidatePreferences = _ref.onValidatePreferences,
      personnalCookiesState = _ref.personnalCookiesState,
      text = _ref.text,
      title = _ref.title;
  return CookiePreferencesLayer_jsx(Layer["b" /* Layer */], {
    ariaLabel: title,
    ariaLabelledby: identifiers_constants["l" /* ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES */],
    bgColor: colors["a" /* COLORS */].WHITE,
    buttonLeft: {
      ariaHidden: true,
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      label: backAriaLabel,
      onClick: closeLayer,
      tabIndex: -1
    },
    closeLabel: closeLabel,
    enterAnimation: "slideInBottom",
    hasAnimateEnter: true,
    hasContainer: true,
    hasContainerHeader: true,
    onClose: closeLayer
  }, CookiePreferencesLayer_jsx("div", {
    className: "py-5"
  }, CookiePreferencesLayer_jsx("div", {
    className: "text-center"
  }, CookiePreferencesLayer_jsx(Icon["a" /* Icon */], {
    className: "mb-5",
    color: colors["a" /* COLORS */].BLUE,
    isNotSquare: true,
    name: icons["a" /* ICONS */].CLUBMED,
    width: "10rem"
  })), !!title && CookiePreferencesLayer_jsx("h3", {
    className: "reset-heading font-bold font-sans leading-tight mb-1 text-gray-darker text-md sm:text-lg",
    id: identifiers_constants["l" /* ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES */]
  }, title), CookiePreferencesLayer_jsx(Text["a" /* Text */], {
    className: "font-sans leading-normal mb-1 text-gray-darker text-sm sm:text-base",
    text: text
  }), !!link.label && CookiePreferencesLayer_jsx("p", {
    className: "font-bold font-sans leading-normal mb-1 mt-0 text-gray-darker text-sm sm:text-base"
  }, CookiePreferencesLayer_jsx(DynamicLink["a" /* default */], {
    className: "no-underline text-gray-darker",
    target: "_blank",
    url: link.url
  }, link.label)), Object.keys(items).map(function (key, i) {
    return CookiePreferencesLayer_jsx(PreferencesItemSwitch_PreferencesItemSwitch, {
      index: i,
      isChecked: i === 0 || personnalCookiesState[COOKIES_ARRAY[i - 1]],
      key: key,
      label: items[key].label,
      name: "CookiePreferences-".concat(key),
      onChange: onChange,
      title: items[key].title
    });
  }), CookiePreferencesLayer_jsx("div", {
    className: "flex flex flex-col sm:flex-row-reverse sm:items-center sm:justify-between mt-4"
  }, CookiePreferencesLayer_jsx(Button["a" /* Button */], {
    ariaLabel: approveAriaLabel,
    className: "sm:w-1/6",
    onClick: onValidatePreferences
  }, buttonLabel), CookiePreferencesLayer_jsx(TextLink["a" /* TextLink */], {
    ariaHidden: true,
    className: "block justify-center mt-2 sm:mt-0",
    iconLeftName: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_LEFT,
    iconRightName: null,
    isUppercase: true,
    label: back,
    onClick: closeLayer,
    tabIndex: -1
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/cookie-warning/CookieWarning.jsx








var CookieWarning_jsx = react_default.a.createElement;

function CookieWarning_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CookieWarning_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CookieWarning_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CookieWarning_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function CookieWarning_createSuper(Derived) { var hasNativeReflectConstruct = CookieWarning_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function CookieWarning_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
















var CookieWarning_CookieWarning = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_CookieWarning, _Component);

  var _super = CookieWarning_createSuper(_CookieWarning);

  function _CookieWarning() {
    var _personnalCookies;

    var _this;

    Object(classCallCheck["a" /* default */])(this, _CookieWarning);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      hasApproved: false,
      personnalCookies: (_personnalCookies = {}, Object(defineProperty["a" /* default */])(_personnalCookies, COOKIE_PREFERENCES_STATS, true), Object(defineProperty["a" /* default */])(_personnalCookies, COOKIE_PREFERENCES_PERSO, true), Object(defineProperty["a" /* default */])(_personnalCookies, COOKIE_PREFERENCES_MEDIA, true), _personnalCookies),
      showBanner: true,
      showLayer: false
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handler", null);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "acceptCookies", function () {
      _this.updateCookies();

      _this.setState({
        showBanner: false,
        hasApproved: true
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwitchChange", function (index) {
      return function (name, checked) {
        var realIndex = index - 1;

        _this.setState(function (prevState) {
          return CookieWarning_objectSpread(CookieWarning_objectSpread({}, prevState), {}, {
            personnalCookies: CookieWarning_objectSpread(CookieWarning_objectSpread({}, prevState.personnalCookies), {}, Object(defineProperty["a" /* default */])({}, COOKIES_ARRAY[realIndex], checked))
          });
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onValidatePreferences", function () {
      _this.updateCookies();

      _this.setState({
        hasApproved: true
      }, _this.closeLayer);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "redirect", function (location, type) {
      var fullURL = Object(uriUtils["c" /* convertLocationToURI */])(location)[type](Object(defineProperty["a" /* default */])({}, dist["appQueryParameters"].openLayer, COOKIE_PREFERENCES_LAYER)).toString();
      redirectUtils["a" /* default */].redirectTo()(Object(DynamicLinkUtil["b" /* getSpaUrl */])(new URI_default.a(fullURL)), {
        shallow: true
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeLayer", function () {
      _this.redirect(_this.props.location, 'removeQuery');
    });

    return _this;
  }

  Object(createClass["a" /* default */])(_CookieWarning, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.location.pathname !== this.props.location.pathname && !this.state.hasApproved) {
        this.setState({
          showBanner: false,
          showLayer: false,
          hasApproved: true
        }, this.updateCookies);
      }
    }
  }, {
    key: "updateCookies",
    value: function updateCookies() {
      var _this2 = this;

      var cookieOptions = {
        expires: moment_default()().add(13, 'month').toDate()
      };
      var cookieValue;
      js_cookie_default.a.set(COOKIE_WARNING_LOCALSTORAGE_KEY, 1, cookieOptions);
      COOKIES_ARRAY.forEach(function (cookieName) {
        cookieValue = _this2.state.personnalCookies[cookieName];
        js_cookie_default.a.set(cookieName, +cookieValue, cookieOptions);
      }); // retrieve current virtualPageLoadingDataLayer

      var currentPageDataLayer = tracking_api["a" /* getDataLayer */]().google.find(function (layer) {
        return layer.event === tracking_constants["y" /* VIRTUAL_PAGE_LOAD */];
      }) || {};
      tracking_api["b" /* setDataLayer */](CookieWarning_objectSpread(CookieWarning_objectSpread({}, currentPageDataLayer), {}, {
        rgpd: 'OK'
      }), this.context);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          approveAriaLabel = _this$props.approveAriaLabel,
          buttonLabel = _this$props.buttonLabel,
          closeLabel = _this$props.closeLabel,
          layerInfo = _this$props.layerInfo,
          link = _this$props.link,
          location = _this$props.location,
          text = _this$props.text,
          title = _this$props.title;

      var _ref = layerInfo || {},
          back = _ref.back,
          backAriaLabel = _ref.backAriaLabel,
          openLayerLabel = _ref.link,
          rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["back", "backAriaLabel", "link"]);

      if (this.state.showBanner && text) {
        return CookieWarning_jsx(cookie_warning_CookieWarningBanner, {
          acceptCookies: this.acceptCookies,
          approveAriaLabel: approveAriaLabel,
          buttonLabel: buttonLabel,
          cookieKey: COOKIE_WARNING_LOCALSTORAGE_KEY,
          dataSelector: "cookieWarning",
          link: link,
          openLayer: function openLayer() {
            return _this3.redirect(location, 'addQuery');
          },
          openLayerLabel: openLayerLabel,
          text: text,
          title: title
        });
      }

      if (this.state.showLayer) {
        return CookieWarning_jsx(CookiePreferencesLayer_CookiePreferencesLayer, {
          approveAriaLabel: approveAriaLabel,
          back: back,
          backAriaLabel: backAriaLabel,
          buttonLabel: buttonLabel,
          closeLabel: closeLabel,
          closeLayer: this.closeLayer,
          items: rest,
          link: link,
          onChange: this.onSwitchChange,
          onValidatePreferences: this.onValidatePreferences,
          personnalCookiesState: this.state.personnalCookies,
          text: text,
          title: title
        });
      }

      return null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // first time rendering check if cookies were already approved
      // TODO change this because it prevents the customization after having set the cookies
      if (props.isApproved) {
        return {
          showBanner: false,
          showLayer: false,
          hasApproved: true
        };
      } // check in the location if we have to open the cookie preferences layer


      if (props.isAppMounted && props.location.queryParams[dist["appQueryParameters"].openLayer] === COOKIE_PREFERENCES_LAYER && !state.showLayer) {
        return {
          showBanner: false,
          showLayer: true
        };
      }

      if ((props.location.queryParams[dist["appQueryParameters"].openLayer] !== COOKIE_PREFERENCES_LAYER || !props.location.queryParams[dist["appQueryParameters"].openLayer]) && state.showLayer) {
        return {
          showBanner: !state.hasApproved,
          showLayer: false
        };
      }

      return null;
    }
  }]);

  return _CookieWarning;
}(react["Component"]);

Object(defineProperty["a" /* default */])(CookieWarning_CookieWarning, "contextType", ReactAppContext["a" /* default */]);

Object(defineProperty["a" /* default */])(CookieWarning_CookieWarning, "defaultProps", {
  buttonLabel: '',
  isApproved: false,
  layerInfo: {
    back: '',
    link: '',
    item1: {
      title: '',
      label: ''
    },
    item2: {
      title: '',
      label: ''
    },
    item3: {
      title: '',
      label: ''
    },
    item4: {
      title: '',
      label: ''
    }
  },
  link: {
    label: '',
    url: ''
  },
  text: '',
  title: ''
});

var CookieWarning = Object(withRouter["a" /* withRouter */])(CookieWarning_CookieWarning);
// EXTERNAL MODULE: ./src/utils/locale/constants.js
var locale_constants = __webpack_require__("qFX+");

// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-annexes/FooterAnnexes.jsx
var FooterAnnexes_jsx = react_default.a.createElement;


var FooterAnnexes_FooterAnnexes = function FooterAnnexes(_ref) {
  var className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  return FooterAnnexes_jsx("div", {
    className: className
  }, FooterAnnexes_jsx("ul", {
    className: "reset-list mb-5 -mx-px10"
  }, items.map(function (_ref2) {
    var label = _ref2.label,
        links = _ref2.links;
    return FooterAnnexes_jsx("li", {
      className: "align-top inline-block mb-5 px-px10 w-1/3",
      "data-testid": "FooterAnnexesItem",
      key: label
    }, FooterAnnexes_jsx("p", {
      "aria-level": "2",
      className: "reset-paragraph font-bold leading-one mb-px10 text-sm uppercase",
      "data-testid": "FooterAnnexesHeading",
      role: "heading"
    }, label), FooterAnnexes_jsx("ul", {
      className: "reset-list"
    }, links.map(function (link) {
      return FooterAnnexes_jsx("li", {
        className: "leading-loose mb-px5 text-sm",
        key: link.label
      }, FooterAnnexes_jsx(DynamicLink["a" /* default */], {
        className: "inline-block leading-one text-inherit focus:text-gray-light hover:text-gray-light transition-color",
        target: "_blank",
        url: link.href
      }, link.label));
    })));
  })));
};
// EXTERNAL MODULE: ./src/client/components/layouts/footer/footer-contacts/FooterContacts.jsx
var FooterContacts = __webpack_require__("05L9");

// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-policies/FooterPolicies.jsx
var FooterPolicies_jsx = react_default.a.createElement;




var FooterPolicies_FooterPolicies = function FooterPolicies(_ref) {
  var className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;

  if (!items.length) {
    return null;
  }

  return FooterPolicies_jsx("ul", {
    className: classnames_default()(className, 'reset-list text-sm')
  }, items.map(function (_ref2) {
    var imageSrc = _ref2.imageSrc,
        label = _ref2.label,
        url = _ref2.url;
    return FooterPolicies_jsx("li", {
      className: "my-px5",
      key: url
    }, FooterPolicies_jsx(DynamicLink["a" /* default */], {
      className: "reset-anchor inline-flex items-center text-white focus:text-gray-light hover:text-gray-light",
      url: url
    }, FooterPolicies_jsx(Image["a" /* default */], {
      className: "flex-shrink-0 rtl:mr-px5",
      dontChangeAnything: true,
      imageUrl: imageSrc
    }), label));
  }));
};
// EXTERNAL MODULE: ./src/routes/constants.js
var routes_constants = __webpack_require__("dNxv");

// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-seo/FooterSeo.jsx
var FooterSeo_jsx = react_default.a.createElement;



var FooterSeo_FooterSeo = function FooterSeo(_ref) {
  var className = _ref.className,
      description = _ref.description,
      title = _ref.title,
      siteplanLinkIsDisplayed = _ref.siteplanLinkIsDisplayed,
      siteplanLinkLabel = _ref.siteplanLinkLabel;

  if (!description && !title) {
    return null;
  }

  return FooterSeo_jsx("section", {
    className: className
  }, FooterSeo_jsx("p", {
    "aria-level": "2",
    className: "mb-px10 text-sm uppercase",
    role: "heading"
  }, title), FooterSeo_jsx("p", {
    className: "mb-px10 reset-paragraph text-base"
  }, description), siteplanLinkIsDisplayed && FooterSeo_jsx(DynamicLink["a" /* default */], {
    className: "leading-one text-inherit text-sm focus:text-gray-light hover:text-gray-light transition-color",
    url: routes_constants["E" /* SITEPLAN_PAGE_URL */]
  }, siteplanLinkLabel));
};
// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-social-networks/FooterSocialNetworks.jsx
var FooterSocialNetworks_jsx = react_default.a.createElement;




var FooterSocialNetworks_FooterSocialNetworks = function FooterSocialNetworks(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;

  if (!items.length) {
    return null;
  }

  return FooterSocialNetworks_jsx("div", {
    className: "decoration-strikethrough lg:rtl:pl-px10 relative w-full lg:w-auto z-1"
  }, FooterSocialNetworks_jsx("ul", {
    className: "reset-list flex md:justify-center lg:justify-start -mx-px5 py-5 md:py-0"
  }, items.map(function (_ref2) {
    var icon = _ref2.icon,
        href = _ref2.href,
        label = _ref2.label;
    return FooterSocialNetworks_jsx("li", {
      className: "mx-px5",
      key: href
    }, FooterSocialNetworks_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      className: "bg-gray-darker border-1 border-gray-dark flex items-center justify-center text-center text-white focus:text-gray-light hover:text-gray-light",
      trackingData: {
        actionGA: 'footer',
        labelGA: icon
      },
      target: "_blank",
      url: href,
      style: {
        width: '3.125rem',
        height: '3.125rem'
      }
    }, FooterSocialNetworks_jsx(Icon["a" /* Icon */], {
      alt: typeof icon === 'string' ? icon : '',
      name: icon,
      width: "1.5rem"
    }), FooterSocialNetworks_jsx("span", {
      className: "sr-only"
    }, "Club Med - ".concat(label))));
  })));
};
// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-tripadvisor/FooterTripAdvisor.jsx
var FooterTripAdvisor_jsx = react_default.a.createElement;



var FooterTripAdvisor_FooterTripAdvisor = function FooterTripAdvisor(_ref) {
  var className = _ref.className,
      text = _ref.text;

  if (!text) {
    return null;
  }

  return FooterTripAdvisor_jsx("div", {
    className: classnames_default()(className, 'rtl:text-right')
  }, FooterTripAdvisor_jsx("span", {
    className: "align-middle text-xs sm:text-base",
    "data-testid": "FooterTripAdvisor-title"
  }, text), FooterTripAdvisor_jsx(Image["a" /* default */], {
    altMsg: "Trip Advisor",
    className: "align-middle rtl:ml-px10",
    dontChangeAnything: true,
    imageUrl: "https://www.tripadvisor.com/img/cdsi/langs/en/tripadvisor_logo_white_340x80-24206-0-en_US.png",
    style: {
      width: '8.5rem'
    }
  }));
};
// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-websites/footer-website/FooterWebsite.jsx
var FooterWebsite_jsx = react_default.a.createElement;



var FooterWebsite_FooterWebsite = function FooterWebsite(_ref) {
  var description = _ref.description,
      href = _ref.href,
      iconAlt = _ref.iconAlt,
      iconName = _ref.iconName,
      iconWidth = _ref.iconWidth,
      isVisible = _ref.isVisible;

  if (!isVisible) {
    return null;
  }

  return FooterWebsite_jsx("li", {
    className: "align-top inline-block mb-10 px-px10 w-1/2 lg:w-full"
  }, FooterWebsite_jsx(DynamicLink["a" /* default */], {
    className: "reset-anchor block focus:underline hover:underline",
    target: "_blank",
    url: href
  }, FooterWebsite_jsx("p", {
    "aria-level": "2",
    className: "reset-paragraph mb-px5",
    role: "heading",
    style: {
      minHeight: '2.5rem'
    }
  }, FooterWebsite_jsx(Icon["a" /* Icon */], {
    alt: iconAlt,
    name: iconName,
    isNotSquare: true,
    width: iconWidth
  }), FooterWebsite_jsx("span", {
    className: "sr-only"
  }, iconAlt)), FooterWebsite_jsx("p", {
    className: "reset-paragraph text-base"
  }, description)));
};
// CONCATENATED MODULE: ./src/client/components/layouts/footer/footer-websites/FooterWebsites.jsx

var FooterWebsites_jsx = react_default.a.createElement;



var FooterWebsites_FooterWebsites = function FooterWebsites(_ref) {
  var business = _ref.business,
      className = _ref.className,
      corp = _ref.corp,
      job = _ref.job,
      property = _ref.property;
  return FooterWebsites_jsx("div", {
    className: className
  }, FooterWebsites_jsx("ul", {
    className: "reset-list -mx-px10"
  }, FooterWebsites_jsx(FooterWebsite_FooterWebsite, Object(esm_extends["a" /* default */])({}, business, {
    iconAlt: "Meetings and events by Club Med",
    iconName: icons["a" /* ICONS */].CLUBMED_MEETINGS,
    iconWidth: "12.5rem"
  })), FooterWebsites_jsx(FooterWebsite_FooterWebsite, Object(esm_extends["a" /* default */])({}, property, {
    iconAlt: "Club Med Property",
    iconName: icons["a" /* ICONS */].CLUBMED_PROPERTY,
    iconWidth: "7.5rem"
  })), FooterWebsites_jsx(FooterWebsite_FooterWebsite, Object(esm_extends["a" /* default */])({}, job, {
    iconAlt: "ClubMed Jobs",
    iconName: icons["a" /* ICONS */].CLUBMED_JOBS,
    iconWidth: "7.5rem"
  })), FooterWebsites_jsx(FooterWebsite_FooterWebsite, Object(esm_extends["a" /* default */])({}, corp, {
    iconAlt: "Club M\xE9diterran\xE9e",
    iconName: icons["a" /* ICONS */].CLUBMED,
    iconWidth: "7.5rem"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/layouts/footer/Footer.jsx

var Footer_jsx = react_default.a.createElement;









var Footer_Footer = function Footer(_ref) {
  var annexes = _ref.annexes,
      contacts = _ref.contacts,
      className = _ref.className,
      policies = _ref.policies,
      socialNetworks = _ref.socialNetworks,
      seo = _ref.seo,
      tabText = _ref.tabText,
      tripAdvisor = _ref.tripAdvisor,
      websites = _ref.websites;
  return Footer_jsx("footer", {
    className: classnames_default()(className, 'relative z-3'),
    "data-testid": "Footer",
    role: "contentinfo"
  }, Footer_jsx("div", {
    className: "text-md text-white"
  }, Footer_jsx("div", {
    className: "m-auto w-full max-w-site"
  }, Footer_jsx("div", {
    className: "bg-gray-darker font-bold inline-block px-px10 relative text-md text-gray-darker",
    style: {
      bottom: '-1px',
      height: '2.5rem',
      left: '1.5rem',
      lineHeight: '2.5rem',
      right: '1.5rem'
    }
  }, Footer_jsx("svg", {
    className: "absolute fill-current top-0",
    width: "24",
    height: "40",
    viewBox: "0 0 24 40",
    style: {
      height: '2.5rem',
      left: -23
    }
  }, Footer_jsx("path", {
    d: "M24 0c-4.3 0-8 3.1-8.7 7.3L8.6 33c-.8 4-4.5 7-8.6 7h24V0z"
  })), Footer_jsx("svg", {
    className: "absolute fill-current top-0 -scale-x-1",
    width: "24",
    height: "40",
    viewBox: "0 0 24 40",
    style: {
      height: '2.5rem',
      right: -23
    }
  }, Footer_jsx("path", {
    d: "M24 0c-4.3 0-8 3.1-8.7 7.3L8.6 33c-.8 4-4.5 7-8.6 7h24V0z"
  })), Footer_jsx("span", {
    className: "text-white"
  }, tabText))), Footer_jsx("div", {
    className: "bg-gray-darker flex items-center px-5"
  }, Footer_jsx("div", {
    className: "flex flex-col lg:flex-row md:items-end m-auto max-w-site relative w-full"
  }, Footer_jsx(FooterContacts["a" /* FooterContacts */], {
    items: contacts
  }), Footer_jsx(FooterSocialNetworks_FooterSocialNetworks, {
    items: socialNetworks
  })))), Footer_jsx("div", {
    className: "bg-gray-darker text-white"
  }, Footer_jsx("div", {
    className: "flex flex-wrap m-auto max-w-site px-5 lg:px-0 py-5"
  }, Footer_jsx(FooterWebsites_FooterWebsites, Object(esm_extends["a" /* default */])({}, websites, {
    className: "hidden sm:block lg:w-2/5 lg:rtl:pr-24"
  })), Footer_jsx("div", {
    className: "lg:w-3/5"
  }, Footer_jsx(FooterAnnexes_FooterAnnexes, {
    items: annexes,
    className: "hidden sm:block"
  }), Footer_jsx(FooterSeo_FooterSeo, Object(esm_extends["a" /* default */])({}, seo, {
    className: "md:w-4/5 lg:w-auto"
  })), Footer_jsx(FooterPolicies_FooterPolicies, {
    items: policies,
    className: "mt-8"
  })), Footer_jsx(FooterTripAdvisor_FooterTripAdvisor, Object(esm_extends["a" /* default */])({}, tripAdvisor, {
    className: "mt-5 pt-5 w-full"
  })))));
};
// CONCATENATED MODULE: ./src/client/components/layouts/footer/FooterContainer.jsx



var FooterContainer_jsx = react_default.a.createElement;

function FooterContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FooterContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FooterContainer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FooterContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















function FooterContainer(props) {
  var ABTests = Object(react["useContext"])(ABTestContext["a" /* ABTestContext */]);

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isAppMounted = _useContext.isAppMounted;

  var conditionToShowPopin = isAppMounted && ABTests['ab-test-popinNewsletter'] === '1' && Object(local_storage_api["a" /* getFromLocalStorage */])(PopinNewsletter["b" /* POPIN_NEWSLETTER */]) !== 'viewed';
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var newsletters = props.newsletters,
      legalInformations = props.legalInformations,
      _props$config = props.config,
      cookieWarning = _props$config.cookieWarning,
      memberSpace = _props$config.memberSpace,
      footer = _props$config.footer,
      webCallback = _props$config.webCallback,
      common = _props$config.common;

  var approve = cookieWarning.approve,
      label = cookieWarning.label,
      layer = cookieWarning.layer,
      otherCookieWarningProps = Object(objectWithoutProperties["a" /* default */])(cookieWarning, ["approve", "label", "layer"]);

  var isCookiesBannerEnabled = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('cookiesBanner.isEnabled');
  Object(i18n["a" /* addTranslationKeys */])({
    common: common,
    webCallback: FooterContainer_objectSpread(FooterContainer_objectSpread({}, webCallback), common.dateTime),
    newsletter: props.config.newsletter,
    memberSpace: memberSpace
  });
  var policies = appContext.locale === locale_constants["a" /* LOCALES */].ZH_CN ? [{
    imageSrc: 'https://ns.clubmed.com/it/2019/footer/logo_cn_gov1.png',
    label: '沪公网安备31010102005123号',
    url: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010102005123'
  }, {
    imageSrc: 'https://ns.clubmed.com/it/2019/footer/logo_cn_gov2.png',
    label: '上海工商',
    url: 'http://www.sgs.gov.cn/lz/licenseLink.do?method=licenceView&entyId=gs20140504000004692'
  }, {
    imageSrc: 'https://ns.clubmed.com/grc/2021/66/B2C/B2C-common/lz2small.png',
    label: '电子营业执照',
    url: 'http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020180720162942000002716445-SAIC_SHOW_310000-gs20140504000004692831&signData=MEQCICVEte6pmi5SO//8AxfjZUK7RxW7WeW24X4RCCfMtOz/AiBvLE0C/bmZf+2F8yZFnspaSbC5Xu6wxR0IAvym4a0VEg=='
  }] : [];

  var _useState = Object(react["useState"])(conditionToShowPopin),
      popinShow = _useState[0],
      setPopinShow = _useState[1];

  var onClosePopin = function onClosePopin() {
    setPopinShow(false);
    Object(local_storage_api["d" /* setInLocalStorage */])(PopinNewsletter["b" /* POPIN_NEWSLETTER */], 'viewed');
  };

  Object(react["useEffect"])(function () {
    return setPopinShow(conditionToShowPopin);
  }, [conditionToShowPopin]);
  return FooterContainer_jsx(react["Fragment"], null, popinShow && FooterContainer_jsx(PopinNewsletter["c" /* PopinNewsletter */], {
    checkboxes: newsletters,
    legalInformations: legalInformations ? legalInformations.newsletter : [],
    onClose: onClosePopin
  }), isCookiesBannerEnabled && FooterContainer_jsx(CookieWarning, Object(esm_extends["a" /* default */])({}, otherCookieWarningProps, {
    buttonLabel: approve,
    closeLabel: Object(lodash["get"])(props, 'config.common.close'),
    layerInfo: layer,
    text: label,
    isAppMounted: isAppMounted,
    isApproved: !!js_cookie_default.a.get(COOKIE_WARNING_LOCALSTORAGE_KEY)
  })), FooterContainer_jsx(Footer_Footer, {
    policies: policies,
    annexes: footer.annexes,
    contacts: footer.contactsBar,
    seo: footer.seo,
    socialNetworks: footer.socialNetworks,
    tabText: footer.contactsBarLabel,
    tripAdvisor: footer.tripAdvisor,
    websites: footer.websites
  }));
}
// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// CONCATENATED MODULE: ./src/utils/tracking/dataScore.js


var dataScore_getDataScore = function getDataScore(_ref) {
  var resortId = _ref.resortId,
      departureDate = _ref.departureDate,
      appContext = _ref.appContext;
  var neolaneId = appContext.neolaneId,
      googleTrackingId = appContext.googleTrackingId;
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    query{\n      dataScore(\n      resortId: \"".concat(resortId || '', "\",\n      departureDate: \"").concat(departureDate || '', "\",\n      neolaneId: \"").concat(neolaneId || '', "\",\n      gaTrackingId: \"").concat(googleTrackingId || '', "\") {\n        leadScoring\n      }\n    }\n  "));
};


// EXTERNAL MODULE: ./src/client/store/lead-info/constants.js
var lead_info_constants = __webpack_require__("unIT");

// CONCATENATED MODULE: ./src/client/store/lead-info/leadInfos.action.js



var leadInfos_action_setDataScore = function setDataScore(score) {
  return Object(createAction["b" /* default */])(lead_info_constants["b" /* SET_DATA_SCORE */], {
    score: score
  });
};


// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// CONCATENATED MODULE: ./src/client/components/widgets/data-score/DataScore.jsx


function DataScore_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function DataScore_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DataScore_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DataScore_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var pendingDataScoreTimeout = null;
/*
 * the following function is used to execute the fn arg on the last call only
 * the previous scheduled call to fn will be canceled at every new call
 * by clearing the setTimeout id stored in pendingDataScoreTimeout
 *
 */

var takeLast = function takeLast(fn) {
  clearTimeout(pendingDataScoreTimeout); // 5000ms is choosed arbitrarily

  pendingDataScoreTimeout = setTimeout(fn, 5000);
};

var DataScore_neolaneId = null;

var DataScore_DataScore = function DataScore() {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isAppMounted = _useContext.isAppMounted;

  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var selectedProposal = Object(es["e" /* useSelector */])(booking_selector["k" /* getCurrentProposal */]);
  var resort = Object(es["e" /* useSelector */])(booking_selector["l" /* getCurrentResort */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var dataScoreHasBeenFetched = !!Object(sessionStorageApi["b" /* getFromSessionStorage */])(lead_info_constants["a" /* DATA_SCORE_SESSION_STORAGE_KEY */]);
  Object(react["useEffect"])(function () {
    if (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('enableLeadScoring') && isAppMounted && ( // neolaneId will change after user sign in
    !DataScore_neolaneId && appContext.neolaneId || !dataScoreHasBeenFetched && (appContext.neolaneId || appContext.googleTrackingId))) {
      DataScore_neolaneId = appContext.neolaneId;
      /*
         every calls to the lead scoring API is billed so we want to make
         sure there is only one call to be done when the app state is stabilized
       */

      takeLast(function () {
        dataScore_getDataScore(DataScore_objectSpread(DataScore_objectSpread(DataScore_objectSpread({}, selectedProposal ? {
          departureDate: selectedProposal.departureDate
        } : null), resort ? {
          resortId: resort.id
        } : null), {}, {
          appContext: appContext
        })).then(function (_ref) {
          var leadScoring = _ref.dataScore.leadScoring;
          var score = parseFloat(leadScoring);
          tracking_api["b" /* setDataLayer */](DataScore_objectSpread(DataScore_objectSpread({}, tracking_constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
            event: 'leadScoring',
            leadScoring: score
          }), appContext, pageContext.pageId);
          dispatch(leadInfos_action_setDataScore(leadScoring));
          Object(sessionStorageApi["d" /* setInSessionStorage */])(lead_info_constants["a" /* DATA_SCORE_SESSION_STORAGE_KEY */], leadScoring);
        }).catch(function () {
          /* we don't do anything if the call fails */
        });
      });
    }
  }, [isAppMounted, appContext, selectedProposal]);
  return null;
};


// EXTERNAL MODULE: ./src/client/components/stylesheets/critical.css
var critical = __webpack_require__("yAUU");

// CONCATENATED MODULE: ./src/client/components/layouts/layout/Layout.jsx






var Layout_jsx = react_default.a.createElement;

function Layout_createSuper(Derived) { var hasNativeReflectConstruct = Layout_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Layout_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }















var LazyLayout = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(48), __webpack_require__.e(89), __webpack_require__.e(94)]).then(__webpack_require__.bind(null, "nsiK")).then(function (c) {
    return c.LazyLayout;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("nsiK")];
    },
    modules: ["./LazyLayout.jsx"]
  }
});
var NavigationBar = Object(UserInfo["a" /* userInfoWrapper */])(Navigation_Navigation);

var Layout_getLocales = function getLocales(currentLocale, availableLocales) {
  var hiddenLocales = (config_default.a.get('featureFlipping.hiddenLocales') || '').split(',').filter(function (l) {
    return l !== currentLocale;
  });
  return Object(lodash["omit"])(availableLocales, hiddenLocales);
};

var Layout_Layout = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Layout, _Component);

  var _super = Layout_createSuper(Layout);

  function Layout(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Layout);

    _this = _super.call(this, props);
    _this.promoBannerRef = /*#__PURE__*/react_default.a.createRef();
    return _this;
  }

  Object(createClass["a" /* default */])(Layout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          CMSConfig = _this$props.config,
          disableFooter = _this$props.disableFooter,
          disableHeader = _this$props.disableHeader,
          className = _this$props.className,
          isMicePage = _this$props.isMicePage,
          legalInformations = _this$props.legalInformations,
          newsletters = _this$props.newsletters;
      var _this$context = this.context,
          availableLocales = _this$context.availableLocales,
          currentLocale = _this$context.locale;

      var _ref = CMSConfig || {},
          account = _ref.account,
          memberSpace = _ref.memberSpace,
          navigationBar = _ref.navigationBar,
          maybePromotionalBanner = _ref.promotionalBanner,
          faceting = _ref.faceting; // sometimes CMSConfig is undefined at first render witch causes error with destructuring ;


      var promotionalBanner = maybePromotionalBanner || {};
      Object(i18n["a" /* addTranslationKeys */])(CMSConfig);
      var navLanguage = {
        currentLocale: currentLocale,
        locales: Layout_getLocales(currentLocale, availableLocales)
      };
      return Layout_jsx(react["Fragment"], null, Layout_jsx(LazyLayout, null), !disableHeader && !isMicePage && promotionalBanner.enabled && (promotionalBanner.title || promotionalBanner.description) && Layout_jsx(PromotionalBanner, {
        bgColor: promotionalBanner.color,
        className: "relative z-6",
        closeLabel: promotionalBanner.closeButtonLabel,
        countdown: promotionalBanner.countdown,
        description: promotionalBanner.description,
        disabledPages: promotionalBanner.disabledPages,
        enabledPages: promotionalBanner.enabledPages,
        iconName: promotionalBanner.icon,
        label: promotionalBanner.iconTitle,
        link: {
          url: promotionalBanner.link
        },
        title: promotionalBanner.title,
        titleColor: promotionalBanner.titleColor,
        ref: this.promoBannerRef
      }), Layout_jsx("div", {
        className: classnames_default()(className, 'Layout relative table table-fixed w-full')
      }, !disableHeader ? Layout_jsx("div", {
        className: "absolute top-0 inset-x-0"
      }, Object(lodash["get"])(CMSConfig, 'crisisAlert.enabled') && Layout_jsx("div", {
        className: "absolute top-0 rtl:right-0 w-full z-5"
      }, Layout_jsx("div", {
        className: "flex p-5 max-w-site mt-navigation mx-auto"
      }, Layout_jsx(CrisisAlertLinkBanner_CrisisAlertLinkBanner, {
        alertDate: Object(lodash["get"])(CMSConfig, 'crisisAlert.alertDate', ''),
        className: "rtl:ml-auto",
        isEnabled: Object(lodash["get"])(CMSConfig, 'crisisAlert.enabled'),
        linkLabel: Object(lodash["get"])(CMSConfig, 'crisisAlert.link.label'),
        linkUrl: Object(lodash["get"])(CMSConfig, 'crisisAlert.link.url')
      }))), Layout_jsx(NavigationBar, {
        cmsAccount: account,
        cmsMemberSpace: memberSpace,
        language: navLanguage,
        navigation: navigationBar,
        promoBannerRef: this.promoBannerRef,
        facetingSuggestedRequests: faceting === null || faceting === void 0 ? void 0 : faceting.suggestedRequests
      })) : null, this.props.children, !disableFooter && Layout_jsx(FooterContainer, {
        newsletters: newsletters,
        legalInformations: legalInformations,
        config: CMSConfig
      })), Layout_jsx(DataScore_DataScore, null));
    }
  }]);

  return Layout;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Layout_Layout, "contextType", ReactAppContext["a" /* default */]);
// CONCATENATED MODULE: ./src/client/components/layouts/layout/Layout.query.js


var Layout_query_fetchLayoutConfig = function fetchLayoutConfig(appContext) {
  return graphqlClient["a" /* default */].runQuery('', appContext, {
    requestName: requestDictionary["e" /* CORE_LAYOUT */],
    queryId: requestDictionary["e" /* CORE_LAYOUT */]
  });
};
// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/client/components/third-party/thirdParty.utils.js
var thirdParty_utils = __webpack_require__("kD1E");

// CONCATENATED MODULE: ./src/client/components/third-party/GoogleTagManager.jsx
var GoogleTagManager_jsx = react_default.a.createElement;





var GoogleTagManager_GoogleTagManager = function GoogleTagManager() {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      queryParams = _useRouter.location.queryParams;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var tracking = Object(thirdParty_utils["a" /* getConfigWithNoThirdPartySupport */])({
    name: 'tracking',
    locale: appContext.locale,
    queryParams: queryParams
  });
  var key = 'GTM-KJ3DSC';

  if (Object(sellerUtils["g" /* isSeller */])(appContext)) {
    key = appContext.isCmta ? 'GTM-P9H7QS7' : 'GTM-N8CQ3J6';
  }

  if (tracking.enabled) {
    return GoogleTagManager_jsx(react["Fragment"], null, GoogleTagManager_jsx("noscript", null, GoogleTagManager_jsx("iframe", {
      title: "googletagmanager",
      src: "https://www.googletagmanager.com/ns.html?id=".concat(key),
      height: "0",
      width: "0",
      style: {
        display: 'none',
        visibility: 'hidden'
      }
    })), GoogleTagManager_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n              })(window,document,'script','clubMedLayer','".concat(key, "');\n          ")
      }
    }));
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Sentry.jsx
var Sentry_jsx = react_default.a.createElement;



var Sentry_Sentry = function Sentry() {
  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale;

  var appVersion = config_default.a.get('APP_VERSION');
  var deploymentEnv = config_default.a.get('DEPLOYMENT_ENV');
  var sentry = config_default.a.get('clientError.sentry');

  if (sentry.enabled && sentry.url && sentry.dsn) {
    return Sentry_jsx(react["Fragment"], null, Sentry_jsx("script", {
      src: sentry.url,
      crossOrigin: "anonymous"
    }), Sentry_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n              if (window.Sentry) {\n                Sentry.init({\n                  dsn: '".concat(sentry.dsn, "',\n                  environment: '").concat(deploymentEnv, "',\n                  release: '").concat(appVersion, "',\n                });\n                Sentry.configureScope(function (scope) {\n                  scope.setExtra('locale', '").concat(locale, "');\n                  scope.setTag('locale', '").concat(locale, "');\n                });\n              }\n          ")
      }
    }));
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Cedexis.jsx
var Cedexis_jsx = react_default.a.createElement;




var Cedexis_Cedexis = function Cedexis() {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var performance = config_default.a.get('performance');

  if (!Object(sellerUtils["g" /* isSeller */])(appContext) && performance.cedexis.enabled) {
    return Cedexis_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n            (function(e,c,a,g,f){function d(){var b=c.createElement(\"script\");b.async=!0;\n              b.src=\"//radar.cedexis.com/1/10015/radar.js\";c.body.appendChild(b)}\n              (function(){for(var b=[/\bMSIE (5|6)/i],a=b.length;a--;)if(b[a]\n                .test(navigator.userAgent))return!1;return!0})()\n              &&(\"complete\"!==c.readyState?(a=e[a])?a(f,d,!1):(a=e[g])&&a(\"on\"+f,d):d())})\n            (window,document,\"addEventListener\",\"attachEvent\",\"load\");\n        "
      }
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/PriorityThirdPartyScripts.jsx
var PriorityThirdPartyScripts_jsx = react["createElement"];




var PriorityThirdPartyScripts_PriorityThirdPartyScripts = function PriorityThirdPartyScripts() {
  return PriorityThirdPartyScripts_jsx(react["Fragment"], null, PriorityThirdPartyScripts_jsx(GoogleTagManager_GoogleTagManager, null), PriorityThirdPartyScripts_jsx(Cedexis_Cedexis, null), PriorityThirdPartyScripts_jsx(Sentry_Sentry, null));
};
// EXTERNAL MODULE: ./src/client/components/utils/ab-tasty/abTasty.utils.js
var abTasty_utils = __webpack_require__("FtaI");

// CONCATENATED MODULE: ./src/client/components/third-party/AbTasty.jsx
var AbTasty_jsx = react_default.a.createElement;



var AbTasty_AbTasty = function AbTasty() {
  var _useAbTasty = Object(abTasty_utils["b" /* useAbTasty */])(),
      abTastyScriptUrl = _useAbTasty.abTastyScriptUrl,
      isAbTastyActive = _useAbTasty.isAbTastyActive;

  return isAbTastyActive ? AbTasty_jsx(head_default.a, null, AbTasty_jsx("script", {
    key: "abtasty-lib",
    src: abTastyScriptUrl
  }), AbTasty_jsx("script", {
    key: "abtasty-inline-script"
    /* eslint-disable-next-line react/no-danger */
    ,
    dangerouslySetInnerHTML: {
      __html: "\n              document.addEventListener('cm_app_mounting', function () {\n                if (window.ABTasty && window.ABTasty.rollbackModifications) {\n                  window.ABTasty.rollbackModifications();\n                }\n              });\n              document.addEventListener('cm_app_mounted', function () {\n                if (window.ABTasty && window.ABTasty.applyModifications) {\n                  window.ABTasty.applyModifications();\n                }\n              });\n            "
    }
  })) : null;
};
// EXTERNAL MODULE: ./src/utils/context/contextUtils.js
var contextUtils = __webpack_require__("igjW");

// CONCATENATED MODULE: ./src/client/components/third-party/ContentSquare.jsx
var ContentSquare_jsx = react_default.a.createElement;







var ContentSquare_ContentSquare = function ContentSquare() {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      queryParams = _useRouter.location.queryParams;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var config = Object(thirdParty_utils["a" /* getConfigWithNoThirdPartySupport */])({
    name: 'tracking',
    locale: appContext.locale,
    queryParams: queryParams
  });

  if (!Object(contextUtils["f" /* isStrictlyProductionEnv */])(config_default.a) && !Object(contextUtils["h" /* isStrictlyTestEnv */])(config_default.a) && !Object(sellerUtils["g" /* isSeller */])(appContext) && config.enabled && config.contentsquare.devId) {
    return ContentSquare_jsx("script", {
      defer: true,
      src: "//t.contentsquare.net/uxa/".concat(config.contentsquare.devId, ".js"),
      type: "text/javascript",
      charSet: "utf-8"
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Freespee.jsx
var Freespee_jsx = react_default.a.createElement;





var Freespee_Freespee = function Freespee() {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var accountId = config_default.a.get('freespee.accountId');

  if (!Object(contextUtils["f" /* isStrictlyProductionEnv */])(config_default.a) && !Object(sellerUtils["g" /* isSeller */])(appContext) && accountId) {
    return Freespee_jsx(react["Fragment"], null, Freespee_jsx("script", {
      async: true,
      type: "text/javascript",
      src: "//analytics.freespee.com/js/external/fs.js"
    }), Freespee_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n              var __fs_conf = __fs_conf || [];\n              __fs_conf.push(['setAdv',{'id': '".concat(accountId, "' }]);\n          ")
      }
    }));
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Hosting.jsx
var Hosting_jsx = react_default.a.createElement;


var Hosting_Hosting = function Hosting() {
  var hosting = config_default.a.get('hosting');

  if (hosting.pixel.enabled) {
    return Hosting_jsx("img", {
      src: "https://s3.cn-north-1.amazonaws.com.cn/nscn/pixel.png",
      alt: "",
      width: "1",
      height: "1"
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Jivochat.jsx
var Jivochat_jsx = react_default.a.createElement;





var Jivochat_Jivochat = function Jivochat() {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      queryParams = _useRouter.location.queryParams;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var jivochat = Object(thirdParty_utils["a" /* getConfigWithNoThirdPartySupport */])({
    name: 'jivochat',
    locale: appContext.locale,
    queryParams: queryParams
  });

  if (!Object(sellerUtils["g" /* isSeller */])(appContext) && jivochat.enabled && jivochat.id) {
    return Jivochat_jsx("script", {
      async: true,
      type: "text/javascript",
      src: "//code.jivosite.com/script/widget/".concat(jivochat.id)
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/ThirdPartyScripts.jsx
var ThirdPartyScripts_jsx = react_default.a.createElement;






var ThirdPartyScripts_ThirdPartyScripts = function ThirdPartyScripts() {
  return ThirdPartyScripts_jsx(react["Fragment"], null, ThirdPartyScripts_jsx(Jivochat_Jivochat, null), ThirdPartyScripts_jsx(ContentSquare_ContentSquare, null), ThirdPartyScripts_jsx(Hosting_Hosting, null), ThirdPartyScripts_jsx(AbTasty_AbTasty, null), ThirdPartyScripts_jsx(Freespee_Freespee, null));
};
// CONCATENATED MODULE: ./src/client/components/utils/easy-testing/index.jsx
var easy_testing_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-onchange */

/* eslint-env browser */




var easy_testing_EasyTesting = function EasyTesting() {
  var _useState = Object(react["useState"])('ltr'),
      currentDirection = _useState[0],
      setCurrentDirection = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var responsive = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]);

  var handleDirectionChange = function handleDirectionChange(event) {
    var newDirection = event.target.value;
    setCurrentDirection(newDirection); // $FlowFixMe

    var docEl = document.documentElement;
    docEl.classList.remove('ltr', 'rtl');
    docEl.classList.add(newDirection);
    docEl.dir = newDirection; // $FlowFixMe

    document.body.dir = newDirection;
  };

  var handleVisibilityChange = function handleVisibilityChange() {
    setIsVisible(!isVisible);
  }; // don't render on server and initial boot. Fixes some weird SSR problems


  if (!Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])(config_default.a) || !responsive.isAppMounted) {
    return null;
  }

  var easyTestingStyle = {
    position: 'fixed',
    zIndex: 300,
    top: '210px',
    left: '10px',
    transform: 'rotateZ(-90deg)',
    WebkitTransform: 'rotateZ(-90deg)',
    transformOrigin: 'top left',
    WebkitTransformOrigin: 'top left',
    width: isVisible ? 'auto' : '25px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    direction: 'ltr'
  };
  var directionStyle = {
    margin: '0 3px',
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: currentDirection === 'ltr' ? 'emerald' : 'red',
    width: '80px',
    verticalAlign: 'middle',
    outline: 0
  };
  var visibilityStyle = {
    border: 0,
    padding: 0,
    margin: '0 3px 0',
    verticalAlign: 'middle',
    background: 'transparent',
    outline: 0
  };
  var switchVisibilityStyle = {
    fontSize: 0,
    display: 'block',
    border: '2px solid rgba(0, 0, 0, 0.4)',
    width: '20px',
    height: '20px',
    backgroundColor: isVisible ? 'red' : 'yellow',
    borderRadius: '10px',
    transition: 'background-color ease-out 0.7s'
  };
  return easy_testing_jsx("div", {
    className: "easyTesting",
    style: easyTestingStyle
  }, easy_testing_jsx("button", {
    onClick: handleVisibilityChange,
    style: visibilityStyle,
    type: "button"
  }, easy_testing_jsx("span", {
    style: switchVisibilityStyle
  }, "x")), easy_testing_jsx("label", {
    className: "sr-only",
    htmlFor: "switchRTL"
  }, "Switch"), easy_testing_jsx("select", {
    id: "switchRTL",
    onChange: handleDirectionChange,
    style: directionStyle,
    value: currentDirection
  }, easy_testing_jsx("option", {
    value: "ltr"
  }, "L\u2192R"), easy_testing_jsx("option", {
    value: "rtl"
  }, "R\u2192L")));
};
// EXTERNAL MODULE: ./src/client/store/seller/sellerInfoReducer.js
var sellerInfoReducer = __webpack_require__("+2AQ");

// CONCATENATED MODULE: ./src/client/components/widgets/cmta/CMTA.jsx





var CMTA_CMTA = function CMTA() {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  Object(react["useEffect"])(function () {
    if (!appContext.isCmta) {
      return;
    }

    graphqlClient["a" /* default */].runNoCacheQuery("{\n      sellerInfo {\n        email\n      }\n    }", appContext).then(function (data) {
      dispatch({
        type: sellerInfoReducer["a" /* GET_SELLER_EMAIL */],
        payload: data
      });
    });
  }, []);
  return null;
};
// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/label/SpinnerLabel.jsx
var SpinnerLabel = __webpack_require__("4SQ0");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/utils/layers/stopScroll.js
var stopScroll = __webpack_require__("qVkC");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/reselect/lib/index.js
var reselect_lib = __webpack_require__("hqKg");

// CONCATENATED MODULE: ./src/client/store/global-loader/storeHelper.js


var globalLoaderSelector = function globalLoaderSelector(_ref) {
  var globalLoader = _ref.globalLoader;
  return globalLoader || {};
};

var getShouldDisplayGlobalLoader = Object(reselect_lib["createSelector"])(globalLoaderSelector, function (_ref2) {
  var shouldDisplay = _ref2.shouldDisplay;
  return shouldDisplay;
});
var getGlobalLoaderLabel = Object(reselect_lib["createSelector"])(globalLoaderSelector, function (_ref3) {
  var label = _ref3.label;
  return label;
});
var getIsNavigation = Object(reselect_lib["createSelector"])(globalLoaderSelector, function (_ref4) {
  var isNavigation = _ref4.isNavigation;
  return isNavigation;
});

// CONCATENATED MODULE: ./src/client/components/widgets/loading/Loading.jsx
var Loading_jsx = react_default.a.createElement;











var Loading_Loading = function Loading() {
  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isAppMounted = _useContext.isAppMounted;

  var shouldDisplay = Object(es["e" /* useSelector */])(getShouldDisplayGlobalLoader);
  var isNavigation = Object(es["e" /* useSelector */])(getIsNavigation);
  var isPreviousNavigation = Object(usePrevious["a" /* usePrevious */])(isNavigation);
  var previousShouldDisplay = Object(usePrevious["a" /* usePrevious */])(shouldDisplay);
  var label = Object(es["e" /* useSelector */])(getGlobalLoaderLabel);

  var _useState = Object(react["useState"])(0),
      bodyScrollTop = _useState[0],
      setBodyScrollTop = _useState[1];

  Object(react["useEffect"])(function () {
    if (shouldDisplay) {
      setBodyScrollTop(Object(stopScroll["a" /* getTopScrollValue */])(document));
      Object(stopScroll["b" /* lockBodyScroll */])(document);
    } else if (previousShouldDisplay) {
      // prevent removing the body locker when hydrate from server (there is no previousShouldDisplay)
      if (isPreviousNavigation) {
        // in case of navigation to another page we do not have to scroll to the last position
        Object(stopScroll["c" /* resumeBodyScroll */])(document, 0);
      } else {
        Object(stopScroll["c" /* resumeBodyScroll */])(document, bodyScrollTop);
      }

      setBodyScrollTop(0);
    }
  }, [shouldDisplay]);

  if (!isAppMounted || !shouldDisplay) {
    return null;
  }

  return Loading_jsx(Portal["a" /* default */], {
    name: Portal_constants["d" /* OVER_BOT */]
  }, Loading_jsx("div", {
    id: "loading",
    className: "fixed flex flex-col items-center justify-center bg-overlay-white-90 inset-0 z-4"
  }, Loading_jsx(Spinner["a" /* Spinner */], {
    iconName: icons["a" /* ICONS */].TRIDENT1
  }), Loading_jsx(SpinnerLabel["a" /* SpinnerLabel */], {
    label: label
  })));
};
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react-collapse/lib/index.js
var react_collapse_lib = __webpack_require__("3OwS");

// CONCATENATED MODULE: ./src/client/components/widgets/three-sixty/ThreeSixty.jsx
var ThreeSixty_jsx = react_default.a.createElement;





var ThreeSixty_ThreeSixty = function ThreeSixty(_ref) {
  var clientName = _ref.clientName,
      lastVisitsLabel = _ref.lastVisitsLabel,
      lastVisits = _ref.lastVisits;

  var _useState = Object(react["useState"])(false),
      isOpened = _useState[0],
      toggleThreeSixty = _useState[1];

  return ThreeSixty_jsx("div", {
    className: classnames_default()('ThreeSixty', {
      open: isOpened
    })
  }, ThreeSixty_jsx("div", {
    className: classnames_default()('ThreeSixty-content', {
      open: isOpened
    }),
    onClick: function onClick() {
      return toggleThreeSixty(!isOpened);
    }
  }, ThreeSixty_jsx("div", {
    className: "ThreeSixty-header"
  }, ThreeSixty_jsx("svg", {
    className: "ThreeSixty-cxoLogo",
    width: "130px",
    height: "60px",
    viewBox: "0 0 130 60",
    version: "1.1"
  }, ThreeSixty_jsx("defs", null, ThreeSixty_jsx("linearGradient", {
    x1: "44.7159195%",
    y1: "50%",
    x2: "75.035875%",
    y2: "50%",
    id: "linearGradient-1"
  }, ThreeSixty_jsx("stop", {
    stopColor: "#235472",
    offset: "0%"
  }), ThreeSixty_jsx("stop", {
    stopColor: "#A6DADE",
    offset: "100%"
  }))), ThreeSixty_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, ThreeSixty_jsx("g", {
    id: "10-B2B/Desktop/01-1_CXO",
    transform: "translate(0.000000, -403.000000)"
  }, ThreeSixty_jsx("g", {
    id: "Group-2",
    transform: "translate(0.000000, 403.160714)"
  }, ThreeSixty_jsx("path", {
    d: "M71.2064596,29.6873674 L85.6177833,42.8646077 C90.4453086,46.8799323 94.6046143,49.5481129 100.552511,49.5481129 C111.547972,49.5481129 120.461554,40.7137316 120.461554,29.81597 C120.461554,18.9182085 111.547972,10.0838272 100.552511,10.0838272 C94.4637587,10.0838272 89.1245616,12.6929064 85.219571,16.8145493 L71.2064596,29.6873674 Z M64.84932,23.3302278 L77.7054691,11.0848976 C84.1408993,4.71799111 91.2565906,0.502982484 100.390844,0.502982484 C116.691308,0.502982484 129.905444,13.7171187 129.905444,30.0175819 C129.905444,46.318045 116.691308,58.2393852 100.390844,58.2393852 C90.5625021,58.2393852 85.6177833,56.1114281 76.0119282,47.4843048 L64.3463874,36.5474396 L55.5310792,45.6122108 L48.7298497,38.8109814 L57.5340046,29.7350568 L47.9798065,20.32894 L54.9139193,13.3948271 L64.84932,23.3302278 Z M49.9291515,8.41005929 L42.9950386,15.3441722 C39.4697613,12.110536 34.7699391,10.0838272 29.6091556,10.0838272 C18.66937,10.0838272 9.80092149,19.0053746 9.80092149,29.9451602 C9.80092149,40.8849458 18.66937,48.7579875 29.6091556,48.7579875 C34.7678471,48.7579875 39.4659509,47.7813842 42.990751,44.5500801 L49.7919804,51.3513095 C44.5137473,56.3000378 37.4153607,59.3305694 29.6091556,59.3305694 C13.3086924,59.3305694 0.0945561695,46.1164332 0.0945561695,29.81597 C0.0945561695,13.5155069 13.3086924,0.301370651 29.6091556,0.301370651 C37.483187,0.301370651 44.6370464,3.38479421 49.9291515,8.41005929 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), ThreeSixty_jsx("path", {
    d: "M104.611739,34.6884892 L102.092025,37.2082036 L104.611739,39.7279181 L107.131453,37.2082036 L104.611739,34.6884892 Z M106.214867,18.7758278 C106.099844,18.2043091 104.726762,19.005873 101.750551,21.6370156 C102.893589,22.8950756 103.468702,22.2085343 104.496716,21.8670609 C105.29828,23.2401435 105.528326,29.764083 100.607514,31.7122788 C100.722537,25.1883392 100.837559,18.2043091 100.837559,18.2043091 C100.722537,18.0892865 100.607514,18.0892865 100.492491,18.0892865 C99.1194087,18.3193317 96.7147169,20.6090009 94.8815438,22.6686248 C95.9131529,24.3867753 97.1712129,22.7836474 98.2028221,22.4385795 C98.2028221,22.6686248 97.9727768,27.4744139 98.0877995,32.3988201 C93.0519651,32.7402935 93.853529,22.4385795 94.0799798,21.1805196 C94.1950025,20.0374822 90.8737241,22.4385795 89.1591681,23.9266848 C89.7306868,24.8432713 90.4172281,24.7282487 91.3338146,24.3831808 C90.9887468,28.9625191 94.1950025,33.1967896 98.0877995,33.0817669 C98.2028221,37.8911505 98.7743408,42.4668943 100.147423,42.8119622 C100.377469,42.8119622 100.492491,38.0025787 100.603919,32.5102483 C109.651168,29.764083 106.214867,18.7758278 106.214867,18.7758278 Z",
    id: "Shape",
    fill: "#005589",
    fillRule: "nonzero"
  }))))), isOpened ? ThreeSixty_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "16px",
    className: "ThreeSixty-closeIcon"
  }) : null), ThreeSixty_jsx(react_collapse_lib["UnmountClosed"], {
    theme: {
      collapse: 'ThreeSixty-collapse',
      content: 'ThreeSixty-collapseContent'
    },
    isOpened: isOpened
  }, ThreeSixty_jsx("div", {
    className: "ThreeSixty-clientName"
  }, clientName), ThreeSixty_jsx("div", {
    className: "ThreeSixty-lastVisitsLabel"
  }, lastVisitsLabel), ThreeSixty_jsx("div", {
    className: "ThreeSixty-lastVisits"
  }, lastVisits.map(function (lastVisit, index) {
    return ThreeSixty_jsx("div", {
      key: lastVisit.name + index,
      className: "ThreeSixty-lastVisit"
    }, ThreeSixty_jsx("div", null, lastVisit.name), ThreeSixty_jsx("div", {
      className: "whitespace-no-wrap"
    }, ThreeSixty_jsx("span", null, "\xA0-\xA0"), lastVisit.category.join(' / ')));
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/three-sixty/ThreeSixtyContainer.jsx









var ThreeSixtyContainer_jsx = react_default.a.createElement;

function ThreeSixtyContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ThreeSixtyContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ThreeSixtyContainer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ThreeSixtyContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function ThreeSixtyContainer_createSuper(Derived) { var hasNativeReflectConstruct = ThreeSixtyContainer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function ThreeSixtyContainer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var ThreeSixtyContainer_ThreeSixtyContainer = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(ThreeSixtyContainer, _PureComponent);

  var _super = ThreeSixtyContainer_createSuper(ThreeSixtyContainer);

  function ThreeSixtyContainer(props, context) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ThreeSixtyContainer);

    _this = _super.call(this, props, context);

    var _URI$search = new URI_default.a(dist["windowWrapper"].getLocation() || '').search(true),
        cxoMainContactId = _URI$search.cxo_primarycontact,
        _URI$search$cxo_villa = _URI$search.cxo_village,
        cxoLastResorts = _URI$search$cxo_villa === void 0 ? [] : _URI$search$cxo_villa; // when there is always one village it's not an array so we need to force it


    var arrayCxoLastResorts = Array.prototype.concat(cxoLastResorts);
    _this.cxoMainContactId = cxoMainContactId;
    _this.state = {
      i18n: null,
      cxoMainContact: null,
      cxoLastResorts: arrayCxoLastResorts.map(function (resort) {
        var _resort$split = resort.split(' '),
            _resort$split2 = Object(slicedToArray["a" /* default */])(_resort$split, 2),
            resortId = _resort$split2[0],
            roomCategories = _resort$split2[1];

        return {
          id: resortId,
          name: resortId,
          category: roomCategories.split(',')
        };
      }),
      shouldRender: Object(sellerUtils["g" /* isSeller */])(context) && cxoMainContactId && cxoLastResorts.length > 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(ThreeSixtyContainer, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _yield$graphQLClient$, resorts, config, profile;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.state.shouldRender) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return graphqlClient["a" /* default */].runNoCacheQuery("{\n        resorts(resortIds: [\"".concat(this.state.cxoLastResorts.map(function (_ref) {
                  var id = _ref.id;
                  return id;
                }).join('","'), "\"]) {\n          id\n          name\n        }\n        config {\n          booking {\n            cxo {\n              v360 {\n                resortsAndRooms\n              }\n            }\n          }\n        }\n        profile(userId: \"").concat(this.cxoMainContactId, "\", throw401Error: true) {\n          firstName\n          lastName\n        }\n    }"), this.context);

              case 5:
                _yield$graphQLClient$ = _context.sent;
                resorts = _yield$graphQLClient$.resorts;
                config = _yield$graphQLClient$.config;
                profile = _yield$graphQLClient$.profile;
                this.setState({
                  i18n: config,
                  cxoMainContact: "".concat(profile.firstName, " ").concat(profile.lastName),
                  cxoLastResorts: this.state.cxoLastResorts.map(function (resort) {
                    return ThreeSixtyContainer_objectSpread(ThreeSixtyContainer_objectSpread({}, resort), {}, {
                      name: Object(lodash["get"])(resorts.find(function (_ref2) {
                        var id = _ref2.id;
                        return id === resort.id;
                      }), 'name', resort.id)
                    });
                  }),
                  shouldRender: true
                });
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](2);
                Object(sellerUtils["f" /* handle401GraphqlErrorSeller */])(_context.t0, this.context);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 12]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      if (!this.state.shouldRender || !this.state.cxoMainContact) {
        return null;
      }

      return ThreeSixtyContainer_jsx(ThreeSixty_ThreeSixty, {
        clientName: this.state.cxoMainContact,
        lastVisitsLabel: Object(lodash["get"])(this.state.i18n, 'booking.cxo.v360.resortsAndRooms') // $FlowFixMe
        ,
        lastVisits: this.state.cxoLastResorts
      });
    }
  }]);

  return ThreeSixtyContainer;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(ThreeSixtyContainer_ThreeSixtyContainer, "contextType", ReactAppContext["a" /* default */]);
// EXTERNAL MODULE: ../domains-service/dist/index.js
var domains_service_dist = __webpack_require__("g/E1");
var domains_service_dist_default = /*#__PURE__*/__webpack_require__.n(domains_service_dist);

// EXTERNAL MODULE: ./src/utils/ple-utils/cookies.js
var ple_utils_cookies = __webpack_require__("H6pA");

// CONCATENATED MODULE: ./src/client/context/initAppContext.js









function initAppContext(uri) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$cookies = _ref.cookies,
      cookies = _ref$cookies === void 0 ? {} : _ref$cookies,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'fr-FR' : _ref$locale,
      originalUrl = _ref.originalUrl,
      requestId = _ref.requestId,
      userAgent = _ref.userAgent;

  var _ref2 = domains_service_dist_default.a.isValidLocale(locale) ? locale.split('-') : [],
      _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 2),
      language = _ref3[0],
      country = _ref3[1];

  var encodedUserInfo = cookies[ple_utils_cookies["d" /* USER_INFO */]] ? dist["oidc"].fromUriEncodedState(cookies[ple_utils_cookies["d" /* USER_INFO */]]) : undefined;
  var sellerInfo = cookies[ple_utils_cookies["b" /* SELLER_INFO */]] ? dist["oidc"].fromUriEncodedState(cookies[ple_utils_cookies["b" /* SELLER_INFO */]]) : undefined;
  var uriObject = new URI_default.a(uri);
  var queryParameters = uriObject.query(true);
  var domainServiceForHostname = domains_service_dist_default.a.forHostname(uriObject.hostname());
  var availableLocales = domainServiceForHostname.getAllLocales();
  var cm_ta = dist["appQueryParameters"].cmta.cm_ta,
      cxo_sales_network_id = dist["appQueryParameters"].cxo.cxo_sales_network_id,
      indirect = dist["appQueryParameters"].indirect;
  var isCmta = queryParameters[cm_ta] !== undefined;
  var isIndirect = queryParameters[indirect] !== undefined;
  var isDirectCxo = !!queryParameters[cxo_sales_network_id] && !isIndirect && !isCmta;
  var isIndirectCxo = !!queryParameters[cxo_sales_network_id] && isIndirect && !isCmta;
  var isCxo = isDirectCxo || isIndirectCxo;
  return {
    authenticationToken: cookies[ple_utils_cookies["a" /* ACCESS_TOKEN */]] || cookies.CM_SELLER_TOKEN || '',
    availableLocales: availableLocales,
    bypassCache: queryParameters[dist["appQueryParameters"].bypassCache] === 'true',
    canUseOnlinePayment: domains_service_dist_default.a.getEnabledPaymentProviders(locale).length > 0,
    cmsContent: queryParameters.commonContent || config_default.a.get('cms.commonContent'),
    cmsRelease: queryParameters.commonRelease || config_default.a.get('cms.commonRelease'),
    cmta: isCmta ? {
      agency: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.agency) || '',
      agent: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.agent) || '',
      isDelCredere: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.isDelCredere) || false,
      email: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.email) || '',
      searchType: uriObject.path() === routes_constants["B" /* QUICK_SEARCH_URL */] ? 'quick' : 'advanced'
    } : {},
    cookies: cookies,
    country: country || '',
    customerNeolaneId: queryParameters.cxo_neolid,
    customerType: (encodedUserInfo === null || encodedUserInfo === void 0 ? void 0 : encodedUserInfo.customerType) || '',
    cxoQueryParams: {
      cxo_azur_code: queryParameters.cxo_azur_code,
      cxo_sales_channel: queryParameters.cxo_sales_channel,
      cxo_country_code: queryParameters.cxo_country_code,
      cxo_user_id: typeof queryParameters.cxo_id === 'string' ? Object(sellerUtils["a" /* decryptHeptaSeller */])(queryParameters.cxo_id) : ''
    },
    displayUnicodeFields: domains_service_dist_default.a.shouldDisplayUnicodeFields(locale) || false,
    // TODO replace this by - and improve for SSR - GoogleAnalytics tracking helper
    googleTrackingId: queryParameters.visitorGUID || cookies._ga || null,
    headers: {},
    isProduction: Object(contextUtils["c" /* isProduction */])(),
    isCmta: isCmta,
    isCxo: isCxo,
    isDirectCxo: isDirectCxo,
    isIndirectCxo: isIndirectCxo,
    isSeller: isCmta || isDirectCxo || isIndirectCxo,
    isSellerLogged: cookies[ple_utils_cookies["c" /* SELLER_LOGGED */]] === 'true',
    isUserLogged: (encodedUserInfo === null || encodedUserInfo === void 0 ? void 0 : encodedUserInfo.isLoggedIn) || false,
    isUserQuickLogged: (encodedUserInfo === null || encodedUserInfo === void 0 ? void 0 : encodedUserInfo.isQuickLoggedIn) || false,
    language: language || '',
    lines: [],
    locale: locale,
    neolaneId: cookies.cm_client_uid || (encodedUserInfo ? encodedUserInfo.neolaneId : null),
    originalUrl: originalUrl,
    pagesContent: queryParameters.pagesContent || config_default.a.get('cms.pagesContent'),
    pagesRelease: queryParameters.pagesRelease || config_default.a.get('cms.pagesRelease'),
    requestId: requestId,
    userAgent: userAgent || ''
  };
}
// CONCATENATED MODULE: ./src/client/context/createOrUpdateAppContext.js


function createOrUpdateAppContext_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function createOrUpdateAppContext_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      createOrUpdateAppContext_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      createOrUpdateAppContext_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





 // Server-side the context is created everytime
// client-side, it's first saved in the constructor of _app, then retrieved in subsequent
// getInitialProps

var localAppContext; // $FlowFixMe

var getAppContext = function getAppContext() {
  return localAppContext;
};
var createOrUpdateAppContext_saveAppContext = function saveAppContext(appContext) {
  var data = createOrUpdateAppContext_objectSpread(createOrUpdateAppContext_objectSpread({}, appContext), {}, {
    cookies: js_cookie_default.a.get(),
    userAgent: Object(lodash["get"])(window, 'navigator.userAgent')
  });

  localAppContext = createOrUpdateAppContext_objectSpread(createOrUpdateAppContext_objectSpread({}, data), initAppContext(data.originalUrl, data));
  var momentLocale = Object(lodash["get"])(localAppContext, "availableLocales.".concat(localAppContext.locale, ".moment"), 'fr');
  moment_default.a.locale(momentLocale);
  Object(i18n["e" /* setLocale */])(localAppContext.locale.slice(0, 2));
  return localAppContext;
};
// EXTERNAL MODULE: ./src/client/context/ErrorBoundary.jsx
var ErrorBoundary = __webpack_require__("oG87");

// EXTERNAL MODULE: ./src/errors/clientErrorHandler.js
var clientErrorHandler = __webpack_require__("aPQG");

// EXTERNAL MODULE: ./src/routes/nextRoutes.js
var nextRoutes = __webpack_require__("qm5D");
var nextRoutes_default = /*#__PURE__*/__webpack_require__.n(nextRoutes);

// CONCATENATED MODULE: ./src/server/context/createAppContextFromReq.js


function createAppContextFromReq_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function createAppContextFromReq_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      createAppContextFromReq_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      createAppContextFromReq_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var createAppContextFromReq_createAppContextFromProps = function createAppContextFromProps(appContext) {
  var uri = new URI_default.a(appContext.originalUrl);
  var hostname = uri.hostname();
  return createAppContextFromReq_objectSpread(createAppContextFromReq_objectSpread({}, appContext), {}, {
    availableLocales: domains_service_dist_default.a.forHostname(hostname).getAllLocales()
  }, initAppContext(appContext.originalUrl, appContext));
};
var createAppContextFromReq_createAppContextFromReq = function createAppContextFromReq(req) {
  // $FlowFixMe: id is injected from express-request-id
  var requestId = req.headers[dist["httpHeaders"].X_REQUEST_ID] || req.id;
  var uri = Object(contextUtils["b" /* getCurrentUri */])(req);
  var queryParameters = dist["url"].decodeQueryParameters(uri.query(true));
  var requestedLocale = queryParameters.locale;
  var hostname = uri.hostname(); // $FlowFixMe we have a host

  var host = req.get('host');
  var appContext = {
    availableLocales: domains_service_dist_default.a.forHostname(hostname).getAllLocales(),
    originalUrl: req.protocol + '://' + host + req.originalUrl,
    cookies: req.cookies,
    locale: Object(contextUtils["a" /* getCurrentLocale */])(requestedLocale, hostname),
    requestId: requestId,
    userAgent: req.headers['user-agent']
  };
  moment_default.a.locale(Object(lodash["get"])(appContext.availableLocales, "".concat(appContext.locale, ".moment"), 'fr'));
  return createAppContextFromReq_objectSpread(createAppContextFromReq_objectSpread({}, appContext), initAppContext(uri, appContext));
};
// EXTERNAL MODULE: ./src/client/store/constants.js
var store_constants = __webpack_require__("cvSI");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/utils/faceting/kidsValidationStateUtils.js
var kidsValidationStateUtils = __webpack_require__("cGFA");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/constants.js
var kids_constants = __webpack_require__("wQ38");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.helper.js
var calendar_helper = __webpack_require__("VtPb");

// CONCATENATED MODULE: ./src/client/store/getInitialReduxState.client.js


function getInitialReduxState_client_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function getInitialReduxState_client_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      getInitialReduxState_client_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      getInitialReduxState_client_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
















var LOCAL_STORAGE_STATE_KEY = 'state';

function stateFromLocalStorage(locale, state) {
  var serializedState = Object(local_storage_api["a" /* getFromLocalStorage */])("".concat(LOCAL_STORAGE_STATE_KEY, "-").concat(locale));
  if (!serializedState) return {};
  var localStorageState = Object(lodash["merge"])(JSON.parse(serializedState), {
    tripInformation: {}
  });
  var _localStorageState$tr = localStorageState.tripInformation.kids,
      kids = _localStorageState$tr === void 0 ? [] : _localStorageState$tr;
  return {
    faceting: getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state.faceting), {}, {
      kidsValidationState: Object(kidsValidationStateUtils["b" /* getValidationStateFromKids */])(kids)
    }),
    tripInformation: {
      kids: kids.map(function (_ref) {
        var birthdate = _ref.birthdate;
        return getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]), {}, {
          birthdate: birthdate
        });
      }),
      adults: kids.length > 0 ? Array(adults_constants["a" /* DEFAULT_ADULTS_NB */]).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */]) : []
    },
    seller: localStorageState.seller
  };
}

function stateFromCookies() {
  var encodedUserInfo = js_cookie_default.a.get(ple_utils_cookies["d" /* USER_INFO */]);
  return {
    userInfo: encodedUserInfo ? dist["oidc"].fromUriEncodedState(encodedUserInfo) : {}
  };
}

function parseCxoKids(cxoKids) {
  return cxoKids.length <= faceting_constants["u" /* KIDS_NUMBER_MAX */] ? cxoKids.map(function (_ref2) {
    var neolid = _ref2.neolid,
        birthdate = _ref2.birthdate;
    return {
      neolid: neolid,
      birthdate: birthdate
    };
  }) : [];
}

function parseCxoAdults(cxoAdults) {
  return cxoAdults.length <= faceting_constants["b" /* ADULTS_NUMBER_MAX */] ? cxoAdults.map(function (_ref3) {
    var neolid = _ref3.neolid,
        birthdate = _ref3.birthdate;
    return getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */]), {}, {
      neolid: neolid,
      birthdate: birthdate
    });
  }) : [{}, {}];
}

function parseAdultsQueryParam(adultQueryParam) {
  var nbAdults = parseInt(adultQueryParam, 10);
  var hasAdults = Object(lodash["isInteger"])(nbAdults) && nbAdults <= faceting_constants["b" /* ADULTS_NUMBER_MAX */];
  return hasAdults ? Array(nbAdults).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */]) : [];
}

function stateFromQueryParams() {
  // NOTE: getCxoTravelers() and getNeolids() rely on queryparams
  var neolids = Object(sellerUtils["c" /* getNeolids */])();
  var queryParams = Object(uriUtils["i" /* getQueryParameters */])(dist["windowWrapper"].getLocation()) || {};
  var departureDate = queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]];
  var departureDateIsValid = Object(dateUtils["e" /* isYearsRangeValid */])(queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]], uri_constants["e" /* QUERY_DATE_FORMAT */], faceting_constants["l" /* DEPARTURE_DATE_MAX_DATE */]);
  var kids = Object(facetingUtils["i" /* unserializeKidsFromQueryParam */])(queryParams[uri_constants["h" /* QUERY_KIDS */]]);
  var adults = parseAdultsQueryParam(queryParams[uri_constants["j" /* QUERY_NUMBER_OF_ADULTS */]]);
  return {
    calendar: {
      selectedMonth: departureDateIsValid ? Object(calendar_helper["b" /* getDefaultSelectedMonth */])(departureDate) : undefined
    },
    // null states are explicitly omitted further
    faceting: {
      query: {
        label: queryParams[faceting_constants["A" /* QUERY_QUERY_PARAM */]] || ''
      },
      kidsValidationState: Object(kidsValidationStateUtils["b" /* getValidationStateFromKids */])(kids)
    },
    facetingTripInformation: neolids.length > 0 ? null : undefined,
    seller: neolids.length > 0 ? {
      neolids: neolids
    } : undefined,
    tripCriteria: {
      departureDate: departureDateIsValid ? Object(dateUtils["d" /* getTimestamp */])(departureDate, uri_constants["e" /* QUERY_DATE_FORMAT */]) : undefined,
      duration: parseInt(queryParams[uri_constants["g" /* QUERY_DURATION */]], 10) || null,
      departureCity: queryParams[uri_constants["k" /* QUERY_TRANSPORT */]]
    },
    tripInformation: {
      kids: kids,
      adults: kids.length > 0 && adults.length === 0 ? Array(adults_constants["a" /* DEFAULT_ADULTS_NB */]).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */]) : adults
    }
  };
}

function getSellerTripInformation() {
  // CMTA sellers
  var queryParams = Object(uriUtils["i" /* getQueryParameters */])(dist["windowWrapper"].getLocation()) || {};
  var cmtaQueryParam = queryParams[uri_constants["d" /* QUERY_CMTA */]];

  if (typeof cmtaQueryParam !== 'undefined') {
    var _stateFromQueryParams = stateFromQueryParams(),
        tripInformation = _stateFromQueryParams.tripInformation;

    return tripInformation;
  } // CXO sellers


  var cxoTravelers = Object(sellerUtils["b" /* getCxoTravelers */])() || [];

  if (cxoTravelers.length === 0) {
    return;
  }

  return {
    kids: parseCxoKids(cxoTravelers.filter(function (_ref4) {
      var isChild = _ref4.isChild;
      return isChild;
    })),
    adults: parseCxoAdults(cxoTravelers.filter(function (_ref5) {
      var isChild = _ref5.isChild;
      return !isChild;
    }))
  };
}

function cleanTripInfoKids(state) {
  if (!state.tripInformation) return state;
  var _state$tripInformatio = state.tripInformation.kids,
      kids = _state$tripInformatio === void 0 ? [] : _state$tripInformatio;
  var cleanedKids = kids.map(function (_ref6) {
    var neolid = _ref6.neolid,
        birthdate = _ref6.birthdate,
        _ref6$childcareInclud = _ref6.childcareIncluded,
        childcareIncluded = _ref6$childcareInclud === void 0 ? false : _ref6$childcareInclud;
    return {
      neolid: neolid,
      birthdate: birthdate,
      childcareIncluded: childcareIncluded
    };
  });
  return getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state), {}, {
    tripInformation: getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state.tripInformation), {}, {
      kids: cleanedKids
    })
  });
}

function getInitialReduxState(initialState, locale) {
  var state = getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, initialState), stateFromLocalStorage(locale, {})), stateFromCookies()); // NOTE: With merge() behavior, subvalues that are undefined won't override existing values
  // ie: merge({ a: 1, b: 2 }, { a: undefined, b: null }) returns { a: 1, b: null }


  state = Object(lodash["merge"])({}, state, stateFromQueryParams()); // for seller erase tripInformation

  state = getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state), {}, {
    tripInformation: getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state.tripInformation), getSellerTripInformation())
  });
  state = cleanTripInfoKids(state);
  state = Object(lodash["omitBy"])(state, function (value) {
    return value === null;
  });
  return state;
}
// EXTERNAL MODULE: ./src/client/store/user-info/userInfo.selectors.js
var userInfo_selectors = __webpack_require__("apzf");

// EXTERNAL MODULE: ./src/client/store/configureStore.js
var configureStore = __webpack_require__("Crz2");

// CONCATENATED MODULE: ./src/client/store/withReduxStore.js
// https://github.com/zeit/next.js/blob/126eb498675e6f1a27d568672c2a9da49eec09f9/examples/with-redux/lib/with-redux-store.js
// From this example https://github.com/zeit/next.js/tree/126eb498675e6f1a27d568672c2a9da49eec09f9/examples/with-redux


var isServer = false;
var __NEXT_REDUX_STORE__ = '__NEXT_REDUX_STORE__'; // The store is a singleton on the client, but is created every time on the server

function getOrCreateStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // Always make a new store if server, otherwise state is shared between requests

  if (isServer) {
    return Object(configureStore["a" /* init */])(initialState);
  } // Create store if unavailable on the client and set it on the window object


  if (!window[__NEXT_REDUX_STORE__]) {
    window[__NEXT_REDUX_STORE__] = Object(configureStore["a" /* init */])(initialState);
  }

  return window[__NEXT_REDUX_STORE__];
}
// EXTERNAL MODULE: ./src/utils/booking-payment-status/bookingPaymentStatus.constants.js
var bookingPaymentStatus_constants = __webpack_require__("ycRU");

// EXTERNAL MODULE: ./src/utils/ple-utils/handleInvalidToken.js
var handleInvalidToken = __webpack_require__("bJ4E");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/client/tracking/tracking-pageload/TrackingPageLoad.jsx + 2 modules
var TrackingPageLoad = __webpack_require__("TVUe");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx + 2 modules
var Hero = __webpack_require__("2B1m");

// CONCATENATED MODULE: ./src/client/views/errors/not-found/NotFoundView.jsx


var NotFoundView_jsx = react_default.a.createElement;








var NotFoundView_getInitialProps = /*#__PURE__*/function () {
  var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref) {
    var appContext, query;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            appContext = _ref.appContext;
            query = "query {\n      config {\n        errors { notFound { image title } }\n        common { goToHome }\n      }\n    }";
            return _context.abrupt("return", graphqlClient["a" /* default */].runQuery(query, appContext, {
              requestName: requestDictionary["Nc" /* PAGE_404 */]
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getInitialProps(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var NotFoundView_NotFoundView = function NotFoundView(_ref3) {
  var _config$errors, _config$errors$notFou, _config$errors2, _config$errors2$notFo, _config$common;

  var config = _ref3.config;
  return NotFoundView_jsx(react_default.a.Fragment, null, NotFoundView_jsx(TrackingPageLoad["a" /* TrackingPageLoad */], {
    pageName: "Shopping_NotFound",
    siteSection: "Shopping_NotFound"
  }), NotFoundView_jsx("main", {
    className: "NotFoundView",
    role: "main"
  }, NotFoundView_jsx(Hero["a" /* Hero */], {
    size: "total",
    url: config === null || config === void 0 ? void 0 : (_config$errors = config.errors) === null || _config$errors === void 0 ? void 0 : (_config$errors$notFou = _config$errors.notFound) === null || _config$errors$notFou === void 0 ? void 0 : _config$errors$notFou.image
  }), NotFoundView_jsx("div", {
    className: "NotFoundView-inner"
  }, NotFoundView_jsx(SiteContainer["a" /* SiteContainer */], {
    size: "mini"
  }, NotFoundView_jsx("h1", {
    className: "NotFoundView-title font-brand"
  }, config === null || config === void 0 ? void 0 : (_config$errors2 = config.errors) === null || _config$errors2 === void 0 ? void 0 : (_config$errors2$notFo = _config$errors2.notFound) === null || _config$errors2$notFo === void 0 ? void 0 : _config$errors2$notFo.title), NotFoundView_jsx(TextLink["a" /* TextLink */], {
    url: "/",
    label: config === null || config === void 0 ? void 0 : (_config$common = config.common) === null || _config$common === void 0 ? void 0 : _config$common.goToHome,
    theme: "solid"
  })))));
};

NotFoundView_NotFoundView.getInitialProps = NotFoundView_getInitialProps;
/* harmony default export */ var not_found_NotFoundView = (NotFoundView_NotFoundView);
// CONCATENATED MODULE: ./pages/_app.js









var _app_jsx = react_default.a.createElement;

function _app_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _app_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      _app_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      _app_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(possibleConstructorReturn["a" /* default */])(this, result);
  };
}












































 // $FlowFixMe issue with next typings

var _app_App = /*#__PURE__*/function (_NextApp) {
  Object(inherits["a" /* default */])(App, _NextApp);

  var _super = _createSuper2(App);

  Object(createClass["a" /* default */])(App, null, [{
    key: "getInitialProps",
    value: function () {
      var _getInitialProps = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref) {
        var Component, ctx, req, res, asPath, query, appContext, pageProps, reduxStore, currentUri, isUserQuickLogged, originalUrl, pageId, pageType, location, isOption, staticPageContext, layoutPromise, _require, getRedirect, RULES, _ref2, status, url, pageContext, layoutData, appContextLight;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Component = _ref.Component, ctx = _ref.ctx;
                req = ctx.req, res = ctx.res, asPath = ctx.asPath, query = ctx.query;
                appContext = req ? createAppContextFromReq_createAppContextFromReq(req) : getAppContext(); // If no appContext, we reload the page. It's occurring when navigating back from an error layer

                if (!appContext && true && Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])(config_default.a)) {
                  window.location.reload();
                }

                pageProps = {}; // Get or Create the store with initialState from cookies
                // This allows you to set a custom default initialState

                reduxStore = getOrCreateStore(stateFromCookies());

                if (Component.requireAuthentication) {
                  currentUri = req ? Object(contextUtils["b" /* getCurrentUri */])(req) : new URI_default.a(window.location.href);
                  Object(handleInvalidToken["a" /* handleInvalidToken */])({
                    appContext: appContext,
                    currentUri: currentUri,
                    res: res,
                    userInfo: Object(userInfo_selectors["a" /* userInfoSelector */])(reduxStore.getState())
                  });
                } // Provide the store to getInitialProps of pages


                ctx.reduxStore = reduxStore;
                isUserQuickLogged = appContext.isUserQuickLogged, originalUrl = appContext.originalUrl;
                pageId = Component.pageId;
                pageType = Component.pageType || Component.pageId || 'none';
                location = createRouterLocation_createRouterLocation({
                  asPath: asPath,
                  query: query,
                  originalUrl: originalUrl
                });
                isOption = query.bookingStatusBeforePayment === bookingPaymentStatus_constants["c" /* BOOKING_PAYMENT_STATUS_OPTION */]; // There are two possibilities for the pageContext
                // - it's created in the getInitialProps of the page (DynamicPage.jsx)
                // - it's static, the properties depending on the pages can be statically resolved (e.g. pageId)
                // We create it before the getInitialProps and pass it to the getInitialProps because some
                // components might need it, like ThemeView which does render lines

                staticPageContext = {
                  pageId: pageId,
                  pageTitle: dist["constants"].WEBSITE_NAME,
                  pageDescription: '',
                  // usually we don't care about the statusCode in the pageContext, since a 404/500 will
                  // directly route us to a specific branch
                  statusCode: statusCode_constants["a" /* STATUS_CODE_200 */],
                  canonicalUrl: Object(uriUtils["h" /* getPageCanonicalUrl */])(appContext.originalUrl, appContext.originalUrl),
                  hrefLang: [],
                  pageMeta: {},
                  pageType: pageType || pageId || 'none',
                  siteSection: Object(utils["d" /* getSiteSection */])({
                    isOption: isOption,
                    isUserQuickLogged: isUserQuickLogged,
                    pageType: pageType
                  })
                }; // Call here, await later to make this call and the getInitialProps one parallels

                layoutPromise = req ? Layout_query_fetchLayoutConfig(appContext) : Promise.resolve({});

                if (!Component.getInitialProps) {
                  _context.next = 54;
                  break;
                }

                _context.prev = 16;
                _context.next = 19;
                return Component.getInitialProps(_app_objectSpread(_app_objectSpread({}, ctx), {}, {
                  appContext: appContext,
                  pageContext: staticPageContext,
                  location: location
                }));

              case 19:
                pageProps = _context.sent;
                _context.next = 25;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](16);
                pageProps = _context.t0;

              case 25:
                if (!pageProps.statusCode) {
                  _context.next = 54;
                  break;
                }

                if (!(pageProps.statusCode === statusCode_constants["d" /* STATUS_CODE_404 */])) {
                  _context.next = 54;
                  break;
                }

                if (true) {
                  _context.next = 48;
                  break;
                }

                _context.prev = 28;
                _require = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module '@clubmed/redirects'"); e.code = 'MODULE_NOT_FOUND'; throw e; }())), getRedirect = _require.getRedirect, RULES = _require.RULES;
                _context.next = 32;
                return getRedirect(config_default.a.get(), req, [// Those rules only apply to b2c pages that couldn't be found in the CMS content b2c-pages
                RULES.NORMALIZE_B2C_SHOPPING_PATHS, // this redirection rule is temporary (i.e. issue #11090)
                RULES.B2C_CMS_CONTENT, RULES.PRODUCT_SHORT_LINKS, RULES.GLOBAL_B2C, RULES.LEGACY_B2C_NOT_FOUND]);

              case 32:
                _ref2 = _context.sent;
                status = _ref2.status;
                url = _ref2.url;
                return _context.abrupt("return", res.redirect(status, url));

              case 38:
                _context.prev = 38;
                _context.t1 = _context["catch"](28);
                _context.t2 = _app_objectSpread;
                _context.t3 = _app_objectSpread({}, pageProps);
                _context.next = 44;
                return not_found_NotFoundView.getInitialProps({
                  appContext: appContext
                });

              case 44:
                _context.t4 = _context.sent;
                pageProps = (0, _context.t2)(_context.t3, _context.t4);

              case 46:
                _context.next = 54;
                break;

              case 48:
                _context.t5 = _app_objectSpread;
                _context.t6 = _app_objectSpread({}, pageProps);
                _context.next = 52;
                return not_found_NotFoundView.getInitialProps({
                  appContext: appContext
                });

              case 52:
                _context.t7 = _context.sent;
                pageProps = (0, _context.t5)(_context.t6, _context.t7);

              case 54:
                if (pageProps.pageContext) {
                  pageContext = pageProps.pageContext;
                } else {
                  Object(invariant["a" /* invariant */])(pageId, "The page corresponding to the url ".concat(asPath, " doesn't have a pageId. This is an error."));
                  pageContext = _app_objectSpread(_app_objectSpread({}, staticPageContext), {}, {
                    statusCode: pageProps.statusCode || staticPageContext.statusCode
                  });
                } // Sync store with url, works fine on SSR to have
                // last version of state before rendering on frontend.


                if (false) {}

                _context.next = 58;
                return layoutPromise;

              case 58:
                layoutData = _context.sent;
                appContextLight = {
                  locale: appContext.locale,
                  userAgent: appContext.userAgent,
                  originalUrl: appContext.originalUrl,
                  cookies: {// TODO is_mobile
                  }
                };

                if (false) {}

                return _context.abrupt("return", {
                  appContext: appContextLight,
                  pageContext: pageContext,
                  i18nData: Object(i18n["b" /* getAll */])(),
                  pageProps: pageProps,
                  layoutData: layoutData,
                  disableHeader: Object(sellerUtils["g" /* isSeller */])(appContext) || query.disableLayout === 'true' || (typeof Component.disableHeader === 'function' ? Component.disableHeader(appContext) : Component.disableHeader),
                  disableFooter: Object(sellerUtils["g" /* isSeller */])(appContext) || query.disableLayout === 'true' || (typeof Component.disableFooter === 'function' ? Component.disableHeader(appContext) : Component.disableFooter),
                  location: location,
                  initialReduxState: reduxStore.getState(),
                  statusCode: pageContext.statusCode
                });

              case 62:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[16, 22], [28, 38]]);
      }));

      function getInitialProps(_x) {
        return _getInitialProps.apply(this, arguments);
      }

      return getInitialProps;
    }()
  }]);

  function App(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, App); // $FlowFixMe issue with next typings


    _this = _super.call(this, props);
    _this.toastRef = /*#__PURE__*/Object(react["createRef"])();
    _this.appContext = true ? createOrUpdateAppContext_saveAppContext(props.appContext) : undefined; // Get or Create the store with initialState from cookies

    _this.reduxStore = getOrCreateStore(true ? getInitialReduxState(props.initialReduxState, _this.appContext.locale) : undefined);
    Object(i18n["e" /* setLocale */])(_this.appContext.locale.slice(0, 2)); // First time on the render it comes from the props, then it's there and won't have to be refeched

    _this.layoutData = props.layoutData || _this.layoutData;
    return _this;
  } // eslint-disable-next-line class-methods-use-this


  Object(createClass["a" /* default */])(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      Object(clientErrorHandler["c" /* start */])();
      nextRoutes_default.a.Router.events.on('routeChangeComplete', function () {
        // as shallow navigation may happen, ensure the store is synced with location.
        _this2.reduxStore.dispatch({
          type: store_constants["t" /* SYNC_WITH_LOCATION */],
          payload: {
            location: _this2.props.location,
            pageType: _this2.props.pageContext.pageType
          }
        });
      }); // https://github.com/zeit/next.js/issues/7814
      // Navigating back (clicking on the browser back button) triggers a getInitialProps every time
      // This makes change when changing of page. But we often do shallow-routing on a page to show a
      // layer (or to persist things in the url), but don' trigger getInitialProps
      // Sadly, back/forward means that we retrigger the getInitialProps, show the loader, etc.
      // So with this snippet we force same page navigation as shallow (since different pages skip
      // shallow routing)

      nextRoutes_default.a.Router.beforePopState(function (_ref3) {
        var options = _ref3.options; // this.props.location has not been updated yet, so we can check and prevent shallow navigation
        // between two different dynamic pages

        if (_this2.props.location.pathname === new URI_default.a(window.location.href).pathname()) {
          options.shallow = true;
        }

        return true;
      }); // Sync the state with the local storage

      this.reduxStore.subscribe(Object(lodash["throttle"])(function () {
        var state = _this2.reduxStore.getState();

        var persistedStore = JSON.stringify({
          tripInformation: {
            kids: Object(storeHelper["c" /* getKids */])(state)
          },
          seller: state.seller
        });
        Object(local_storage_api["d" /* setInLocalStorage */])("".concat(LOCAL_STORAGE_STATE_KEY, "-").concat(_this2.appContext.locale), persistedStore);
      }, 1000));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Component = _this$props.Component,
          pageContext = _this$props.pageContext,
          pageProps = _this$props.pageProps,
          i18nData = _this$props.i18nData,
          disableFooter = _this$props.disableFooter,
          disableHeader = _this$props.disableHeader,
          unUpdatedLocation = _this$props.location; // With shallow routing, the page is rerendered and the query params are updated, but
      // getInitialProps is not called. So we need to manually update the queryParams

      var location = createRouterLocation_updateShallowQueryParams({
        location: unUpdatedLocation,
        href: true ? window.location.href : undefined
      });
      var routerContextValue = {
        history: nextRoutes_default.a.Router,
        location: location
      };

      if (true) {
        Object(i18n["a" /* addTranslationKeys */])(i18nData);
      }

      return _app_jsx(react["Fragment"], null, _app_jsx(ErrorBoundary["a" /* ErrorBoundary */], {
        useNativeErrorHandling: true
      }, _app_jsx(head_default.a, null, _app_jsx("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
      }), _app_jsx("title", {
        key: "title"
      }, pageContext.pageTitle)), _app_jsx(AppProviders_AppProviders, {
        appContext: this.appContext,
        pageContext: pageContext,
        reduxStore: this.reduxStore,
        routerContextValue: routerContextValue,
        toastRef: this.toastRef
      }, _app_jsx(RouteChangeListener_RouteChangeListener, null), _app_jsx(HeadInfos_HeadInfos, null), _app_jsx(PriorityThirdPartyScripts_PriorityThirdPartyScripts, {
        key: "PriorityThirdPartyScripts"
      }), _app_jsx(ThreeSixtyContainer_ThreeSixtyContainer, null), _app_jsx(CMTA_CMTA, null), _app_jsx(Loading_Loading, null), _app_jsx(ErrorBoundary["a" /* ErrorBoundary */], null, _app_jsx(ChatbotContainer_ChatbotContainer, null)), _app_jsx(easy_testing_EasyTesting, null), _app_jsx("div", {
        id: pageContext.pageId || 'pageWrapper' // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
        ,
        "data-cs-override-id": "page"
      }, _app_jsx(Layout_Layout, Object(esm_extends["a" /* default */])({}, this.layoutData, {
        disableHeader: disableHeader,
        disableFooter: disableFooter,
        isMicePage: dist["b2cPagesService"].isMicePage(pageContext.pageType)
      }), pageProps.statusCode === 404 ? _app_jsx(not_found_NotFoundView, pageProps) : _app_jsx(Component, pageProps))), _app_jsx(ToastContainer, {
        ref: this.toastRef
      }), _app_jsx(ThirdPartyScripts_ThirdPartyScripts, {
        key: "ThirdPartyScripts"
      }))));
    }
  }]);

  return App;
}(app_default.a); // eslint-disable-next-line import/no-default-export


/* harmony default export */ var _app = __webpack_exports__["default"] = (_app_App);

/***/ }),

/***/ "1bWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setKids; });
/* unused harmony export updateKid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setKidsWithoutClearProposals; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* eslint-disable flowtype/no-weak-types */



function setKids(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS */ "c"], {
    kids: kids
  });
}

function setKidsWithoutClearProposals(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS */ "d"], {
    kids: kids
  });
}

function resetKids() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_RESET_KIDS */ "b"]);
}

function updateKid(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_KID */ "e"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}



/***/ }),

/***/ "1dAi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (re) {
	return Object.prototype.toString.call(re) === '[object RegExp]';
};


/***/ }),

/***/ "1hJj":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("e4Nc"),
    setCacheAdd = __webpack_require__("ftKO"),
    setCacheHas = __webpack_require__("3A9y");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "1ih8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserInfo = /** @class */ (function () {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
    }
    return BrowserInfo;
}());
exports.BrowserInfo = BrowserInfo;
var NodeInfo = /** @class */ (function () {
    function NodeInfo(version) {
        this.version = version;
        this.name = 'node';
        this.os = process.platform;
    }
    return NodeInfo;
}());
exports.NodeInfo = NodeInfo;
var BotInfo = /** @class */ (function () {
    function BotInfo() {
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}());
exports.BotInfo = BotInfo;
// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    ['aol', /AOLShield\/([0-9\._]+)/],
    ['edge', /Edge\/([0-9\._]+)/],
    ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
    ['vivaldi', /Vivaldi\/([0-9\.]+)/],
    ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/],
    ['samsung', /SamsungBrowser\/([0-9\.]+)/],
    ['silk', /\bSilk\/([0-9._-]+)\b/],
    ['miui', /MiuiBrowser\/([0-9\.]+)$/],
    ['beaker', /BeakerBrowser\/([0-9\.]+)/],
    ['edge-chromium', /Edg\/([0-9\.]+)/],
    ['chromium-webview', /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/],
    ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/],
    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
    ['fxios', /FxiOS\/([0-9\.]+)/],
    ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/],
    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
    ['opera', /OPR\/([0-9\.]+)(:?\s|$)/],
    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
    ['ie', /MSIE\s(7\.0)/],
    ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
    ['android', /Android\s([0-9\.]+)/],
    ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
    ['safari', /Version\/([0-9\._]+).*Safari/],
    ['facebook', /FBAV\/([0-9\.]+)/],
    ['instagram', /Instagram\s([0-9\.]+)/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
    ['searchbot', SEARCHBOX_UA_REGEX],
];
var operatingSystemRules = [
    ['iOS', /iP(hone|od|ad)/],
    ['Android OS', /Android/],
    ['BlackBerry OS', /BlackBerry|BB10/],
    ['Windows Mobile', /IEMobile/],
    ['Amazon OS', /Kindle/],
    ['Windows 3.11', /Win16/],
    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
    ['Windows 98', /(Windows 98)|(Win98)/],
    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
    ['Windows Server 2003', /(Windows NT 5.2)/],
    ['Windows Vista', /(Windows NT 6.0)/],
    ['Windows 7', /(Windows NT 6.1)/],
    ['Windows 8', /(Windows NT 6.2)/],
    ['Windows 8.1', /(Windows NT 6.3)/],
    ['Windows 10', /(Windows NT 10.0)/],
    ['Windows ME', /Windows ME/],
    ['Open BSD', /OpenBSD/],
    ['Sun OS', /SunOS/],
    ['Chrome OS', /CrOS/],
    ['Linux', /(Linux)|(X11)/],
    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
    ['QNX', /QNX/],
    ['BeOS', /BeOS/],
    ['OS/2', /OS\/2/],
    ['Search Bot', SEARCHBOT_OS_REGEX],
];
function detect(userAgent) {
    if (!!userAgent) {
        return parseUserAgent(userAgent);
    }
    if (typeof navigator !== 'undefined') {
        return parseUserAgent(navigator.userAgent);
    }
    return getNodeVersion();
}
exports.detect = detect;
function parseUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    var matchedRule = ua !== '' &&
        userAgentRules.reduce(function (matched, _a) {
            var browser = _a[0], regex = _a[1];
            if (matched) {
                return matched;
            }
            var uaMatch = regex.exec(ua);
            return !!uaMatch && [browser, uaMatch];
        }, false);
    if (!matchedRule) {
        return null;
    }
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') {
        return new BotInfo();
    }
    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) {
            versionParts = versionParts.concat(createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length));
        }
    }
    else {
        versionParts = [];
    }
    return new BrowserInfo(name, versionParts.join('.'), detectOS(ua));
}
exports.parseUserAgent = parseUserAgent;
function detectOS(ua) {
    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.test(ua);
        if (match) {
            return os;
        }
    }
    return null;
}
exports.detectOS = detectOS;
function getNodeVersion() {
    var isNode = typeof process !== 'undefined' && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
exports.getNodeVersion = getNodeVersion;
function createVersionParts(count) {
    var output = [];
    for (var ii = 0; ii < count; ii++) {
        output.push('0');
    }
    return output;
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "1qsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWinterResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isWinterMountainResort; });
/* unused harmony export resortHasBeActivities */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);


var WINTER_MOUNTAIN_RESORT = _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["constants"].WINTER_MOUNTAIN_RESORT;
function isWinterResort(resort) {
  var seasons = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(resort, 'seasons', []);
  return seasons.length === 1 && seasons.includes('WINTER') && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(resort, 'type', '').toUpperCase() === 'VILLAGE';
}
function isWinterMountainResort(resort) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(resort, 'category') === WINTER_MOUNTAIN_RESORT;
}
var resortHasBeActivities = function resortHasBeActivities(resort) {
  return resort.activityCategories.leisure.some(function (_ref) {
    var subCategories = _ref.subCategories;
    return subCategories.length !== 0;
  });
};

/***/ }),

/***/ "2ajD":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ "30WP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return open; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return close; });
function fetch(name) {
  return "FETCH_".concat(name);
}
function clear(name) {
  return "CLEAR_".concat(name);
}
function open(name) {
  return "OPEN_".concat(name);
}
function close(name) {
  return "CLOSE_".concat(name);
}

/***/ }),

/***/ "34at":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goToHash; });
/* harmony import */ var _widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1cDg");
/* eslint-env browser */

function goToHash(hash) {
  var scrollUnderNav = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
  /* In mobile context, navBar is on top of the content of the page so hash scroll goes under the nav */

  function scrollUnderNavBar() {
    var navBar = document.getElementsByClassName(_widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__[/* NAVIGATION_OFFSET_SELECTOR */ "b"])[0];

    if (navBar) {
      document.documentElement.scrollTop -= navBar.clientHeight;
    }
  }

  if (hash) {
    var hashName = hash.split('#')[1];
    setTimeout(function () {
      var element = document.getElementById(hashName);

      if (element) {
        element.scrollIntoView({
          behavior: behavior
        });
      }

      if (scrollUnderNav) {
        scrollUnderNavBar();
      }
    }, 100);
  }
}

/***/ }),

/***/ "39HS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WebCallbackBlockLink; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_block_link_BlockLink_themes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("uRnh");
/* harmony import */ var _WebCallbackTrigger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PZXw");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






var WebCallbackBlockLink = function WebCallbackBlockLink(_ref) {
  var icon = _ref.icon,
      texts = _ref.texts,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      trackingData = _ref.trackingData;
  return __jsx(_WebCallbackTrigger__WEBPACK_IMPORTED_MODULE_5__[/* WebCallbackTrigger */ "a"], {
    trackingData: trackingData,
    theme: theme
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_3__[/* Icon */ "a"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('flex-shrink-0', _frameworks_block_link_BlockLink_themes__WEBPACK_IMPORTED_MODULE_4__[/* themes */ "a"][theme].thIcon),
    name: icon,
    width: _frameworks_block_link_BlockLink_themes__WEBPACK_IMPORTED_MODULE_4__[/* themes */ "a"][theme].thIconWidth
  }), __jsx("span", {
    className: "rtl:text-left"
  }, texts.map(function (text, idx) {
    return __jsx("div", {
      className: Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(_frameworks_block_link_BlockLink_themes__WEBPACK_IMPORTED_MODULE_4__[/* themes */ "a"][theme], "customText".concat(idx), ''),
      key: text
    }, text);
  })));
};

/***/ }),

/***/ "3A9y":
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "3L66":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("MMmD"),
    isObjectLike = __webpack_require__("ExA7");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "4+vj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPertimmDateFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatPertimmDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadOffsetSell; });
/* unused harmony export loadProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadProductsWithIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return searchWithFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadChildcareAvailabilities; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_pertimm_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("y316");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jw1E");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("L73y");
/* harmony import */ var _utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("KL6I");




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}











var PERTIMM_ENGLISH_SPEAKING_LOCALE = 'en';
function getPertimmDateFormat(locale) {
  return (locale === null || locale === void 0 ? void 0 : locale.slice(0, 2)) === PERTIMM_ENGLISH_SPEAKING_LOCALE ? 'YYYY/MM/DD' : 'DD/MM/YYYY';
}
function formatPertimmDate(departureDate, locale) {
  var format = getPertimmDateFormat(locale);
  return departureDate.isValid() ? departureDate.format(format) : '';
}

function getResortThumbnailArgsConfig(appContext) {
  var query = "query {\n    config {\n      thumbnails {\n        tourDurationPlaceholder\n        cruiseTimingPlaceholder\n        cruiseDurationPlaceholder\n        dateFormat\n      }\n    }\n  }";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCT_CONFIG */ "Id"]
  });
}

function getAllProductsInfo(_ref) {
  var appContext = _ref.appContext,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      _ref$ids = _ref.ids,
      ids = _ref$ids === void 0 ? [] : _ref$ids;
  var cmsContent = appContext.cmsContent,
      cmsRelease = appContext.cmsRelease;
  var _options$offerId = options.offerId,
      offerId = _options$offerId === void 0 ? '' : _options$offerId,
      _options$offerName = options.offerName,
      offerName = _options$offerName === void 0 ? '' : _options$offerName,
      _options$productIds = options.productIds,
      productIds = _options$productIds === void 0 ? [] : _options$productIds;
  return getResortThumbnailArgsConfig(appContext).then(function (data) {
    var resortThumbnailQueryArgs = _objectSpread({
      content: cmsContent,
      release: cmsRelease,
      offerName: offerName,
      offerId: offerId
    }, data.config.thumbnails);

    var allProductsId = productIds.length ? ids.filter(function (id) {
      return productIds.includes(id);
    }) : ids;
    var query = "query {\n      resorts(resortIds : [\"".concat(allProductsId.join('","'), "\"]) {\n        ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(resortThumbnailQueryArgs, {
      withoutPrice: true
    }), "\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCTS */ "Gd"]
    });
  });
}

function loadOffsetSell(_ref2) {
  var appContext = _ref2.appContext;
  var query = "\n    query {\n      locale {\n        joyviewOffsetSell\n        resortOffsetSell\n      }\n    }\n  ";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_OFFSET_SELL */ "Fd"]
  });
}
function loadProducts(_ref3) {
  var appContext = _ref3.appContext,
      options = _ref3.options;
  return Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_5__[/* getIdsFromProducts */ "a"])(appContext).then(function (ids) {
    return getAllProductsInfo({
      appContext: appContext,
      options: options,
      ids: ids
    });
  });
}
function loadProductsWithIds(_ref4) {
  var appContext = _ref4.appContext,
      productIds = _ref4.productIds;
  return getAllProductsInfo({
    appContext: appContext,
    options: {},
    ids: productIds
  });
}
function searchWithFacets(_ref5) {
  var criteria = _ref5.criteria,
      options = _ref5.options,
      appContext = _ref5.appContext;
  var productsPromise = loadProducts({
    appContext: appContext,
    options: options
  });
  var userIsSeller = Object(_utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_12__[/* isSeller */ "g"])(appContext); // $FlowFixMe

  var searchPromise = Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_5__[/* searchWithFacets */ "c"])({
    criteria: _objectSpread(_objectSpread({}, criteria), {}, {
      tripDuration: userIsSeller ? null : criteria.tripDuration
    }),
    appContext: appContext
  });
  return Promise.all([productsPromise, searchPromise]).then(function (_ref6) {
    var _ref7 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref6, 2),
        productsInfo = _ref7[0],
        pertimmResults = _ref7[1];

    var filteredProducts = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(pertimmResults, 'answers', []).reduce(function (acc, result) {
      var resultProductId = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(result, 'meta.product_id[0]');
      var resort = productsInfo.resorts.find(function (_ref8) {
        var id = _ref8.id;
        return id === resultProductId;
      });
      var isAllAttendeeAllowed = !!resort && (!criteria.kids || criteria.kids.every(function (_ref9) {
        var birthdate = _ref9.birthdate;
        return Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_9__[/* getKidAgeInMonths */ "e"])({
          birthdate: birthdate,
          departureDate: criteria.departureDate
        }) >= resort.minAuthorizedAge.value;
      }));
      return resort && isAllAttendeeAllowed ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [resort]) : acc;
    }, []);
    var sortedFilteredProducts = criteria.productIds && criteria.productIds.length > 0 ? criteria.productIds.map(function (id) {
      return filteredProducts.find(function (product) {
        return product.id === id;
      });
    }) : filteredProducts;
    return _objectSpread(_objectSpread({}, pertimmResults), {}, {
      query: criteria.query || '',
      search: {
        products: sortedFilteredProducts.filter(Boolean)
      }
    });
  });
}

function getTransportArgs(criteria) {
  var departureCityFilter = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(criteria, 'filters', []).find(function (filter) {
    return filter.id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DEPARTURE_CITY_FACET_ID */ "j"];
  });
  var selectedDepartureCity = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(departureCityFilter, 'name');

  switch (selectedDepartureCity) {
    case 'NO':
      return {
        forceWithoutTransport: true,
        departureCity: ''
      };

    case undefined:
      return {
        forceWithoutTransport: false,
        departureCity: ''
      };

    default:
      return {
        forceWithoutTransport: false,
        departureCity: selectedDepartureCity
      };
  }
}

function loadPrices(_ref10) {
  var appContext = _ref10.appContext,
      _ref10$criteria = _ref10.criteria,
      criteria = _ref10$criteria === void 0 ? {} : _ref10$criteria,
      withFlexibility = _ref10.withFlexibility;
  var _criteria$offerName = criteria.offerName,
      offerName = _criteria$offerName === void 0 ? '' : _criteria$offerName,
      _criteria$offerId = criteria.offerId,
      offerId = _criteria$offerId === void 0 ? '' : _criteria$offerId,
      _criteria$productIds = criteria.productIds,
      productIds = _criteria$productIds === void 0 ? [] : _criteria$productIds,
      duration = criteria.duration;

  var _getTransportArgs = getTransportArgs(criteria),
      departureCity = _getTransportArgs.departureCity,
      forceWithoutTransport = _getTransportArgs.forceWithoutTransport;

  var date = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(criteria.departureDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DATE_FORMAT */ "g"]) || '';
  var dateStart = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(criteria.minDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DATE_FORMAT */ "g"]) || '';
  var dateEnd = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(criteria.maxDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DATE_FORMAT */ "g"]) || '';
  var hasDateRange = dateStart && dateEnd && (!date || withFlexibility);
  var query = "\n    query {\n      resorts(\n        optimizedPriceCalls: true,\n        ".concat(date ? "date: \"".concat(date, "\",") : '', "\n        ").concat(hasDateRange ? "dateStart: \"".concat(dateStart, "\",") : '', "\n        ").concat(hasDateRange ? "dateEnd: \"".concat(dateEnd, "\",") : '', "\n        resortIds: [\"").concat(productIds.join('","'), "\"],\n        departureCity: \"").concat(departureCity, "\",\n        duration: ").concat(String(duration || null), ",\n        offerName: \"").concat(offerName, "\",\n        offerId: \"").concat(offerId, "\",\n        forceWithoutTransport: ").concat(String(forceWithoutTransport), ",\n      ) {\n        id\n        ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* getPriceFields */ "c"])(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* cleanupArgs */ "a"])({
    optimizedPriceCalls: true,
    resortIds: productIds,
    departureCity: departureCity,
    duration: duration || undefined,
    // for flow: criteria duration can be null, but cleanupArgs doesn't accept null as parameter.
    offerName: offerName,
    offerId: offerId,
    forceWithoutTransport: forceWithoutTransport,
    content: appContext.cmsContent,
    release: appContext.cmsRelease,
    date: date,
    dateStart: dateStart,
    dateEnd: dateEnd
  })), "\n      }\n    }\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCT_PRICE */ "Jd"]
  });
}
function loadChildcareAvailabilities(_ref11) {
  var appContext = _ref11.appContext,
      _ref11$criteria = _ref11.criteria,
      criteria = _ref11$criteria === void 0 ? {} : _ref11$criteria;
  var _criteria$productIds2 = criteria.productIds,
      productIds = _criteria$productIds2 === void 0 ? [] : _criteria$productIds2,
      arrivalDate = criteria.departureDate,
      duration = criteria.duration,
      kids = criteria.kids;

  if (!kids || kids.length === 0) {
    return Promise.resolve();
  }

  var query = "\n    query {\n      childcareSearch(\n        arrival_date: \"".concat(Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(arrivalDate, 'YYYYMMDD') || '', "\",\n        product_ids: [\"").concat(productIds.join('","'), "\"],\n        concerned_attendees_birthdates: [\"").concat(kids.map(function (_ref12) {
    var birthdate = _ref12.birthdate;
    return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(birthdate, 'YYYYMMDD');
  }).join('","'), "\"],\n        duration: ").concat(String(duration || null), ",\n      ) {\n        id\n        productId,\n        availability,\n        isIncluded,\n        ageMin,\n        ageMax\n        remainingStock\n      }\n    }\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCT_CHILDCARE */ "Hd"]
  });
}

/***/ }),

/***/ "4/ic":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("ZWtO");

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ "45Yg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRIP_INFORMATION_SET_FLEXIBILITY; });
var TRIP_INFORMATION_SET_FLEXIBILITY = 'TRIP_INFORMATION_SET_FLEXIBILITY';

/***/ }),

/***/ "47Eh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shouldHideServicesPage */
/* unused harmony export shouldHideTransportPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStepIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilteredBreadcrumbPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return navigateInBookingEngine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllProposalsIdWithAlternative; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z8xc");
/* harmony import */ var _components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("aWOT");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("1qsz");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("nv//");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var JOYVIEW_ROOM_ONLY = _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PACKAGES.JOYVIEW_ROOM_ONLY;
var BASE_PATH = '/booking/';
var shouldHideServicesPage = function shouldHideServicesPage(selectedProposal, resort) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_8__[/* hasChildcare */ "p"])(selectedProposal) && !resort.isJoyview && selectedProposal.additionalServices.childcares.length === 0 || resort.isJoyview && !selectedProposal.alternativePackages && selectedProposal.packageId === JOYVIEW_ROOM_ONLY;
};
var shouldHideTransportPage = function shouldHideTransportPage(selectedProposal) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_8__[/* hasTransfer */ "s"])(selectedProposal) && !Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports');
};
var getStepIndex = function getStepIndex(steps, bookingStep) {
  return steps.findIndex(function (step) {
    return step.name === bookingStep;
  });
}; // eslint-disable-next-line max-params

var getFilteredBreadcrumbPages = function getFilteredBreadcrumbPages(_ref) {
  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      i18n = _ref.i18n,
      isActivitiesViewFeatureFlipped = _ref.isActivitiesViewFeatureFlipped,
      isOptionHoldOnlyFeatureFlipped = _ref.isOptionHoldOnlyFeatureFlipped,
      _ref$isSeller = _ref.isSeller,
      isSeller = _ref$isSeller === void 0 ? false : _ref$isSeller,
      _ref$isCmta = _ref.isCmta,
      isCmta = _ref$isCmta === void 0 ? false : _ref$isCmta,
      _ref$isDelCredere = _ref.isDelCredere,
      isDelCredere = _ref$isDelCredere === void 0 ? false : _ref$isDelCredere;
  var isRecommendedTransportSelected = selectedProposal.transports && Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_8__[/* isRecommendedTransport */ "x"])(selectedProposal.transports, selectedProposal.id);
  var activitiesView = isActivitiesViewFeatureFlipped && (selectedProposal.additionalServices.activities.some(function (activity) {
    return activity.productInfo.isIncluded === false;
  }) || selectedProposal.additionalServices.rentals.length > 0) ? {
    name: 'activities',
    path: "".concat(BASE_PATH, "activities"),
    actionGA: 'activities',
    labelGA: 'validateActivities',
    basePriceGALabel: 'basePriceActivities',
    icon: Object(_utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_9__[/* isWinterMountainResort */ "a"])(resort) ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].SKI : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].GOLF,
    showIcon: true,
    title: i18n.booking.activities.pageTitle,
    seoTitle: i18n.booking.activities.seo.title,
    gridSize: 'large'
  } : null;
  var isJoyview = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(resort, 'isJoyview');
  var breadcrumbPages = [{
    name: 'accommodation',
    path: "".concat(BASE_PATH, "accommodation"),
    eventPageName: 'accommodations',
    actionGA: 'accommodation',
    labelGA: 'validateAccommodation',
    basePriceGALabel: 'basePriceAccommodation',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ACCOMODATIONS,
    showIcon: true,
    title: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__[/* tAlt */ "b"])({
      resortKeyPath: 'booking.accommodation.pageTitle',
      cruiseKeyPath: 'booking.accommodation.pageTitleCruise',
      resort: resort
    }),
    seoTitle: i18n.booking.accommodation.seo.title,
    gridSize: 'large'
  }, _objectSpread(_objectSpread({
    name: 'transport',
    path: "".concat(BASE_PATH, "transport"),
    actionGA: 'transport',
    labelGA: 'validateTransport'
  }, Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports') ? {
    icon: Object(_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_6__[/* getTransportIcon */ "l"])(Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports.inbound'), Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports.outbound')),
    title: isRecommendedTransportSelected ? i18n.booking.transport.transportPageTitle : i18n.booking.transport.additionalTransports.transportSelection,
    seoTitle: i18n.booking.transport.seo.title,
    basePriceGALabel: 'basePriceTransport'
  } : {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRANSFER,
    title: i18n.booking.transport.transferPageTitle,
    seoTitle: i18n.booking.transport.transfer.seo.title,
    basePriceGALabel: 'basePriceTransfer'
  }), {}, {
    showIcon: true,
    isToBeHidden: shouldHideTransportPage(selectedProposal),
    gridSize: 'large'
  }), {
    name: 'services',
    path: "".concat(BASE_PATH, "services"),
    actionGA: isJoyview ? 'allInclusive' : 'service',
    labelGA: isJoyview ? 'validateAllInclusive' : 'validateServices',
    basePriceGALabel: 'basePriceServices',
    icon: isJoyview ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].DATE_PLUS : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CHILDREN,
    showIcon: true,
    title: isJoyview ? i18n.booking.services.pageTitleJoyview : i18n.booking.services.pageTitleChildcare,
    seoTitle: i18n.booking.services.seo.title,
    isToBeHidden: shouldHideServicesPage(selectedProposal, resort),
    gridSize: isJoyview ? 'small' : 'large'
  }, {
    name: 'participants',
    path: "".concat(BASE_PATH, "participants"),
    actionGA: 'participant',
    labelGA: 'validateParticipants',
    basePriceGALabel: 'basePricePaymentParticipants',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CONTACT,
    showIcon: true,
    title: i18n.booking.participants.pageTitle,
    seoTitle: i18n.booking.participants.seo.title,
    gridSize: 'mini'
  }, {
    name: 'summary',
    path: "".concat(BASE_PATH, "summary"),
    actionGA: 'summary',
    labelGA: 'validateSummary',
    basePriceGALabel: 'basePriceSummary',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].SUMMARY,
    showIcon: true,
    title: i18n.booking.summary.pageTitle,
    seoTitle: i18n.booking.summary.seo.title,
    gridSize: 'large'
  }];
  if (activitiesView) breadcrumbPages.splice(3, 0, activitiesView); // adds the banking step if the optionHoldOnly featureFlip is disabled

  if (!isOptionHoldOnlyFeatureFlipped) breadcrumbPages.push({
    name: 'banking',
    eventPageName: isSeller && isDelCredere ? 'banking_Ducroire' : 'banking',
    path: "".concat(BASE_PATH, "banking"),
    actionGA: isSeller && isDelCredere ? 'bankingDucroire' : 'banking',
    labelGA: 'validateBanking',
    basePriceGALabel: 'basePricePaymentBanking',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CREDIT_CARD,
    showIcon: !isSeller || isCmta,
    title: i18n.booking.banking.pageTitle,
    seoTitle: i18n.booking.banking.seo.title
  }); // $FlowFixMe Absolutely no clue of why

  return Object(lodash__WEBPACK_IMPORTED_MODULE_2__["reject"])(breadcrumbPages, 'isToBeHidden');
};
var navigateInBookingEngine = function navigateInBookingEngine(_ref2) {
  var location = _ref2.location,
      history = _ref2.history,
      _ref2$replace = _ref2.replace,
      replace = _ref2$replace === void 0 ? false : _ref2$replace;
  var nextUri = location instanceof urijs__WEBPACK_IMPORTED_MODULE_3___default.a ? location : Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_10__[/* convertLocationToURI */ "c"])(location);
  var fileName = nextUri.filename();
  var shownUri = nextUri.clone();
  nextUri.pathname('/booking').setQuery('bookingStep', fileName);
  var nextUrl = nextUri.resource().toString();
  var shownUrl = shownUri.resource().toString();

  if (replace) {
    history.replace(nextUrl, shownUrl);
  } else {
    history.push(nextUrl, shownUrl);
  }
};
var getAllProposalsIdWithAlternative = function getAllProposalsIdWithAlternative(proposal) {
  return [proposal.id].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(proposal.alternativePackages ? proposal.alternativePackages.map(function (alternativePackage) {
    return alternativePackage.proposalId;
  }) : []));
};

/***/ }),

/***/ "47go":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {
    var STATE_OUTPUT       = 0,
        STATE_HTML         = 1,
        STATE_PRE_COMMENT  = 2,
        STATE_COMMENT      = 3,
        WHITESPACE         = /\s/,
        ALLOWED_TAGS_REGEX = /<(\w*)>/g;

    function striptags(html, allowableTags) {
        var html = html || '',
            state = STATE_OUTPUT,
            depth = 0,
            output = '',
            tagBuffer = '',
            inQuote = false,
            i, length, c;

        if (typeof allowableTags === 'string') {
            // Parse the string into an array of tags
            allowableTags = parseAllowableTags(allowableTags);
        } else if (!Array.isArray(allowableTags)) {
            // If it is not an array, explicitly set to null
            allowableTags = null;
        }

        for (i = 0, length = html.length; i < length; i++) {
            c = html[i];

            switch (c) {
                case '<': {
                    // ignore '<' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // '<' followed by a space is not a valid tag, continue
                    if (html[i + 1] == ' ') {
                        consumeCharacter(c);
                        break;
                    }

                    // change to STATE_HTML
                    if (state == STATE_OUTPUT) {
                        state = STATE_HTML;

                        consumeCharacter(c);
                        break;
                    }

                    // ignore additional '<' characters when inside a tag
                    if (state == STATE_HTML) {
                        depth++;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '>': {
                    // something like this is happening: '<<>>'
                    if (depth) {
                        depth--;
                        break;
                    }

                    // ignore '>' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // an HTML tag was closed
                    if (state == STATE_HTML) {
                        inQuote = state = 0;

                        if (allowableTags) {
                            tagBuffer += '>';
                            flushTagBuffer();
                        }

                        break;
                    }

                    // '<!' met its ending '>'
                    if (state == STATE_PRE_COMMENT) {
                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    // if last two characters were '--', then end comment
                    if (state == STATE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '-') {

                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                // catch both single and double quotes
                case '"':
                case '\'': {
                    if (state == STATE_HTML) {
                        if (inQuote == c) {
                            // end quote found
                            inQuote = false;
                        } else if (!inQuote) {
                            // start quote only if not already in one
                            inQuote = c;
                        }
                    }

                    consumeCharacter(c);
                    break;
                }

                case '!': {
                    if (state == STATE_HTML &&
                        html[i - 1] == '<') {

                        // looks like we might be starting a comment
                        state = STATE_PRE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '-': {
                    // if the previous two characters were '!-', this is a comment
                    if (state == STATE_PRE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '!') {

                        state = STATE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case 'E':
                case 'e': {
                    // check for DOCTYPE, because it looks like a comment and isn't
                    if (state == STATE_PRE_COMMENT &&
                        html.substr(i - 6, 7).toLowerCase() == 'doctype') {

                        state = STATE_HTML;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                default: {
                    consumeCharacter(c);
                }
            }
        }

        function consumeCharacter(c) {
            if (state == STATE_OUTPUT) {
                output += c;
            } else if (allowableTags && state == STATE_HTML) {
                tagBuffer += c;
            }
        }

        function flushTagBuffer() {
            var normalized = '',
                nonWhitespaceSeen = false,
                i, length, c;

            normalizeTagBuffer:
            for (i = 0, length = tagBuffer.length; i < length; i++) {
                c = tagBuffer[i].toLowerCase();

                switch (c) {
                    case '<': {
                        break;
                    }

                    case '>': {
                        break normalizeTagBuffer;
                    }

                    case '/': {
                        nonWhitespaceSeen = true;
                        break;
                    }

                    default: {
                        if (!c.match(WHITESPACE)) {
                            nonWhitespaceSeen = true;
                            normalized += c;
                        } else if (nonWhitespaceSeen) {
                            break normalizeTagBuffer;
                        }
                    }
                }
            }

            if (allowableTags.indexOf(normalized) !== -1) {
                output += tagBuffer;
            }

            tagBuffer = '';
        }

        return output;
    }

    /**
     * Return an array containing tags that are allowed to pass through the
     * algorithm.
     *
     * @param string allowableTags A string of tags to allow (e.g. "<b><strong>").
     * @return array|null An array of allowed tags or null if none.
     */
    function parseAllowableTags(allowableTags) {
        var tagsArray = [],
            match;

        while ((match = ALLOWED_TAGS_REGEX.exec(allowableTags)) !== null) {
            tagsArray.push(match[1]);
        }

        return tagsArray.length !== 0 ? tagsArray : null;
    }

    return striptags;
}));


/***/ }),

/***/ "4Bi9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createReducer(initialState) {
  var handlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var handler = action && action.type && handlers ? handlers[action.type] : undefined; // if no action was provided, return the actual state

    if (!handler) {
      return state;
    }

    state = handler(state, action);
    return state;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),

/***/ "4SQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerLabel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var SpinnerLabel = function SpinnerLabel(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'text-center font-brand leading-normal max-w-4/5 sm:max-w-3/5 mt-5 text-blue text-xl', {
      'sr-only': !label
    }),
    "aria-live": "polite"
  }, label ? label : 'Loading');
};

/***/ }),

/***/ "4oK2":
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__("BRr/"),
    decode = __webpack_require__("oW49");

exports.decode = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level){
	return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 =
exports.encodeHTML5 =
exports.encodeHTML  = encode.HTML;

exports.decodeXML =
exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 =
exports.decodeHTML5 =
exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict =
exports.decodeHTML5Strict =
exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),

/***/ "4sDh":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("4uTw"),
    isArguments = __webpack_require__("03A+"),
    isArray = __webpack_require__("Z0cm"),
    isIndex = __webpack_require__("wJg7"),
    isLength = __webpack_require__("shjB"),
    toKey = __webpack_require__("9Nap");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("ZHK4");
module.exports = __webpack_require__("7xIC");


/***/ }),

/***/ "6sVZ":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "6wD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateTripDateCriteria; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function updateTripDateCriteria(options) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* UPDATE_TRIP_DATE_CRITERIA */ "w"], options);
}



/***/ }),

/***/ "70jX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return childcaresQuery; });
/* unused harmony export transfersQuery */
/* unused harmony export additionalServicesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addAccommodationMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addServiceMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addTransportMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteServicesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPaymentScheduleRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPriceDetailFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return proposalsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return proposalFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return proposalPriceQuery; });
/* unused harmony export proposalTransfersQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return transportDetailsFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return paymentProvidersRequest; });
/* unused harmony export getKnownAttendeesInformation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return insurancesQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return promoCodeProposalMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return putServicesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return switchProposalsOffers; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("MAH5");
/* harmony import */ var _client_store_validation_schema_validationSchema_address_fragment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("GZ82");
/* harmony import */ var _client_components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("BYx+");
/* harmony import */ var _client_components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("SQLw");
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("L7OA");
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("PIvV");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("CcNa");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ldK3");
/* harmony import */ var _graphql__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("NLwV");





function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}













var _constants$PACKAGES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_6__["constants"].PACKAGES,
    JOYVIEW_ROOM_ONLY = _constants$PACKAGES.JOYVIEW_ROOM_ONLY,
    JOYVIEW_ALL_INCLUSIVE = _constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    JOYVIEW_FOOD_AND_BEVERAGES = _constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES;

function getPriceDetailFragment(locale) {
  var precision = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_5___default.a.getBookingPrecision(locale);
  return "\n    fragment priceDetails on PriceDetailType {\n      value\n      formattedValue(precision : ".concat(precision, ")\n    }\n  ");
}

var flightFragment = "{\n  id\n  cityId\n  label\n  airportLabel\n  terminalCode\n  date\n  time\n}";
var transportFragment = "{\n  type\n  class\n  travelNumber\n  baggage {\n    quantity\n    weight\n  }\n  companyOperator {\n    id\n    label\n    logo\n  }\n  companyExploiter {\n    id\n    label\n    logo\n  }\n}";
var transportDetailsFragment = "\n  fragment transportsDetails on TransportDetailType {\n    isClubmedTransport\n    durationInMin\n    travelSections {\n      connectionDurationInMin\n      isClubmedTransport\n      stopDurationInMin\n      technicalStops\n      departure {\n        ...".concat(flightFragment, "\n      }\n      arrival {\n        ...").concat(flightFragment, "\n      }\n      transport {\n        ...").concat(transportFragment, "\n      }\n    }\n    cancellationPolicyType\n    transferIncluded\n    stayId\n  }\n");
var childcaresQuery = "\nchildcares {\n  pricingInfo {\n    id\n    isIncluded\n    isManuallyIncluded\n    price: startingPricePerAdult {\n      ...priceDetails\n      formattedValueRounded : formattedValue(precision : 0)\n    }\n    isPartiallyRented\n    type\n    rentedAmount {\n      value\n    }\n    schedules {\n      startDate\n      endDate\n      remainingStock\n      attendees {\n        id\n        isRented\n      }\n    }\n  }\n  productInfo {\n    id\n    label\n    images\n    description\n    durationDescription\n    isIncluded\n    ageInMonths {\n      min\n      max\n    }\n    closingWeekdays\n    openingHours {\n      start\n      end\n    }\n  }\n}";
var transfersQuery = "\ntransfers {\n  pricingInfo {\n    id\n    isIncluded\n    price: startingPricePerAdult {\n      ...priceDetails\n      formattedValueRounded : formattedValue(precision : 0)\n    }\n    totalPrice {\n      value\n      formattedValue\n      currency\n    }\n    isPartiallyRented\n    isFullyRented\n    type\n    rentedAmount {\n      value\n    }\n    schedules {\n      startDate\n      endDate\n      remainingStock\n      attendees {\n        id\n        isRented\n      }\n    }\n  }\n  productInfo {\n    id\n    description\n    durationInMinutes\n    vehicle {\n      id\n      label\n    }\n    label\n  }\n}\n";
var additionalServicesQuery = "\n  additionalServices(types: [EXCURSION, RENTAL, CHILDCARE, LAND_SPORT, WATER_SPORT, WINTER_SPORT, TRANSFER]) {\n    activities {\n      pricingInfo {\n        id\n        type\n        timeSlot\n        rentedAmount {\n          formattedValue\n          value\n          currency\n        }\n        startingPricePerAdult {\n          formattedValue\n          value\n        }\n        isPartiallyRented\n        schedules {\n          startDate\n          endDate\n          attendees {\n            id\n            isRented\n            price {\n              formattedValue\n              value\n            }\n          }\n        }\n      }\n      productInfo {\n        id\n        label\n        isIncluded\n        parentActivityCategoriesId\n      }\n    }\n    rentals {\n      pricingInfo {\n        id\n        type\n        rentedAmount {\n          value\n          formattedValue\n          currency\n        }\n        startingPricePerAdult {\n          value\n          formattedValue\n        }\n        isPartiallyRented\n        schedules {\n          startDate\n          endDate\n          attendees {\n            id\n            isRented\n            price {\n              formattedValue\n              value\n            }\n          }\n        }\n      }\n      productInfo {\n        id\n        label\n        ageInMonths {\n          min\n          max\n        }\n        useCase {\n          id\n          label\n        }\n        typeId: type\n        typeLabel\n        description: longDescription\n        sizes {\n          min\n          max\n          unit\n        }\n        practiceLevels {\n          id\n          label\n        }\n      }\n    }\n    ".concat(childcaresQuery, "\n    ").concat(transfersQuery, "\n  }\n");

function proposalPriceQuery() {
  return "\n    price {\n      total {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      aggregateDiscount {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      aggregateDiscountPromoCode {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      promoCode {\n        offerColor\n        offerName\n        amount {\n          value\n          formattedValue\n        }\n      }\n      totalWithoutChildcare {...priceDetails}\n      totalWithoutChildcareAndDiscount {...priceDetails}\n      totalWithoutTransport {...priceDetails}\n      initialPrice {...priceDetails}\n      discounts {\n        amount {...priceDetails}\n        offerId\n        offerName\n        offerColor\n      }\n      transfer {...priceDetails}\n      fees {\n        type\n        amount {...priceDetails}\n      }\n      childcare {...priceDetails}\n      rental {...priceDetails}\n      excursions {...priceDetails}\n      sports {...priceDetails}\n      currency\n      hasFlexRates\n      selectedRate\n      yieldPricingVariation\n      gap\n    }\n    alternativePrice {\n      total {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      aggregateDiscount {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      aggregateDiscountPromoCode {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      promoCode {\n        offerColor\n        offerName\n        amount {\n          value\n          formattedValue\n        }\n      }\n      totalWithoutChildcare {...priceDetails}\n      totalWithoutChildcareAndDiscount {...priceDetails}\n      initialPrice {...priceDetails}\n      discounts {\n        amount {...priceDetails}\n        offerId\n        offerName\n        offerColor\n      }\n      transfer {...priceDetails}\n      fees {\n        type\n        amount {...priceDetails}\n      }\n      childcare {...priceDetails}\n      rental {...priceDetails}\n      currency\n    }\n    ";
}

function insurancesQuery() {
  return "\n    listInsurances {\n      id\n      label\n      subscribed\n      price {\n        ...priceDetails\n      }\n      insuranceDetails{\n        id\n        label\n        images\n        description\n        shortDescription\n        videos\n        attachedDocuments {\n          label\n          url\n        }\n        company {\n          label\n          logo\n        }\n        coverageDescriptions\n        subscriptionConditions {\n          age_min\n          ageMax\n          byAttendees\n        }\n      }\n    }";
}

function proposalTransfersQuery() {
  return "\n    availableTransfers {\n      ...transferDetails\n    }\n    selectedTransfers {\n      ...transferDetails\n    }\n  ";
}

function proposalFields(params) {
  return "\n    id\n    packageId\n    productId\n    originalLocale\n    ".concat(additionalServicesQuery, "\n    ").concat(params.isJoyView ? "\n    alternativePackages {\n      proposalId\n      packageId\n      upsellPrice\n    }\n    packages(packageIds : [\"".concat(JOYVIEW_ROOM_ONLY, "\", \"").concat(JOYVIEW_ALL_INCLUSIVE, "\", \"").concat(JOYVIEW_FOOD_AND_BEVERAGES, "\"]) {\n      id\n      image\n      additionalInfo\n      description\n      label\n      prices {\n        perAdultPerNight {\n          ...priceDetails\n          currency\n        }\n        perKidPerNight {\n          ...priceDetails\n          currency\n        }\n      }\n    }") : '', "\n    label\n    accommodationsCount\n    accommodations {\n      id\n      label\n      description\n      quantity\n      connectingRoom\n      familyRoom\n      surface\n      view {\n        id\n        label\n      }\n      strengths {\n        id\n        label\n      }\n      equipments {\n        id\n        label\n      }\n      services {\n        id\n        label\n      }\n      outsideFacilities {\n        id\n        label\n      }\n      bathroomEquipments {\n        id\n        label\n      }\n      equipments {\n        id\n        label\n      }\n      categories {\n        id\n      }\n      category\n      categoryId\n      comfortType\n      comfortId\n      maxCapacity\n      media {\n        photos {\n          url\n        }\n      }\n      roomType\n      attendeesDistribution {\n        attendees {\n          id\n          type\n          birthdate,\n          customerId\n        }\n      }\n    }\n    duration\n    media {\n      photos {\n        url\n      }\n    }\n    ").concat(proposalPriceQuery(), "\n    arrivalDate\n    departureDate\n    adultsCount\n    childrenCount\n    attendees {\n      list {\n        id\n        birthdate\n        customerId\n      }\n      adults {\n        id\n      }\n      children(birthdateSort: asc) {\n        id\n        birthdate\n        customerId\n      }\n    }\n    remainingStock\n    optionAvailable\n    isCounterProposal\n    transports {\n      inbound {\n        ...transportsDetails\n      }\n      outbound {\n        ...transportsDetails\n      }\n    }\n     ").concat(insurancesQuery(), "\n    allInclusiveServices {\n      icon\n      label\n      description\n    }\n    ").concat(params.withCommission ? "sellerCommission {\n            formattedValue(precision: 2)\n          }" : '', "\n     ");
}

var paymentScheduleRequest = "paymentSchedule {\n  total {...priceDetails}\n  depositAmount {...priceDetails}\n  repaymentSchedules{\n    amount {...priceDetails}\n    deadline\n  }\n}";

var paymentProvidersRequest = function paymentProvidersRequest() {
  return "paymentProviders {\n  description\n  id\n  label\n  logo\n  paymentMethods {\n    category\n    id\n    image\n    label\n    timePaymentConditions {\n      chargePercentage\n      id\n      paymentCount\n    }\n  }\n  requiredDelayBeforeDeparture\n  token {\n    format\n    value\n  }\n}";
};

function getPaymentScheduleRequest(appContext) {
  return Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_11__[/* isFeatureFlipped */ "a"])(appContext)('booking.deposit') ? paymentScheduleRequest : '';
}

function fetchPayment(proposalId, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposal(id: \"".concat(proposalId, "\") {\n        ").concat(getPaymentScheduleRequest(appContext), "\n      }\n      ").concat(paymentProvidersRequest(), "\n    }\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale')), "\n  "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_GET_SCHEDULE_PAYMENT */ "qd"]
  });
}

function getKnownAttendeesInformation(attendees, neolaneId) {
  var attendeeInfo = attendees.map(function (attendee, index) {
    var _attendee$neolid = attendee.neolid,
        neolid = _attendee$neolid === void 0 ? '' : _attendee$neolid,
        birthdate = attendee.birthdate; // neolid : Send by CXO in query params
    // neolaneId : In appContext, identify user logged
    // When not seller, set first adult with neolaneId if user is authenticated

    return _objectSpread({
      customer_id: index === 0 && neolaneId ? neolaneId : neolid
    }, birthdate ? {
      birthdate: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* timestampToApiDate */ "l"])(birthdate)
    } : null);
  });
  return Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(attendeeInfo);
}

function proposalsQuery(params, appContext) {
  var kids = params.kids,
      adults = params.adults;
  var attendees = adults && adults.length ? adults.concat(kids) : kids; // When quick logged neolaneId but should not call profile api
  // TODO: handle quicklogged status and not call profile API every fucking time because 401 is silent

  var neolaneId = appContext.isUserLogged ? appContext.neolaneId : null; // $FlowFixMe

  var knownAttendeesInformation = getKnownAttendeesInformation(attendees, neolaneId);
  var proposalArgs = ["productId: \"".concat(params.productId, "\""), "arrivalDate: \"".concat(params.arrivalDate, "\""), "duration: ".concat(params.duration), "numberAttendees: ".concat(params.numberAttendees), "knownAttendeesInformation: ".concat(knownAttendeesInformation)].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(params.departureCity ? ["departureCity : \"".concat(params.departureCity, "\"")] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(params.isJoyView ? ['isJoyView: true'] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(params.salesNetworkId ? ["salesNetworkId: \"".concat(params.salesNetworkId, "\"")] : []), ["displayCounterDurations: ".concat(Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_11__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayDurationsCounterProposals') ? 'true' : 'false')]);
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposals(".concat(proposalArgs.join(', '), ") {\n        ... on ErrorsProposalType {\n          errors {\n            errorCode\n          }\n        }\n        ... on ProposalsType {\n          proposals {\n            ").concat(proposalFields(_objectSpread(_objectSpread({}, params), {}, {
    withCommission: appContext.isCmta || appContext.isIndirectCxo
  })), "\n          }\n          dateSuggestion {\n            dateOffset\n            price {\n              total\n            }\n            resortArrivalDate\n            resortDepartureDate\n          }\n          priceCurrency\n          suggestions {\n            resort {\n              badgeIcon\n              color\n              comfort\n              comfortLabel\n              destination {\n                country\n              }\n              href\n              id\n              images\n              isExplicitEC\n              name\n              type\n            }\n            remainingStock\n            initialStock\n          }\n          durationSuggestions {\n            ids\n            data {\n              price {\n                total {\n                  formattedValue\n                }\n              }\n              duration\n              resortArrivalDate: arrivalDate\n              resortDepartureDate: departureDate\n            }\n          }\n          ").concat(Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_7__[/* getResort */ "b"])(params.fetchActivityCategories), "\n        }\n      }\n      ").concat(appContext.isUserLogged ? 'profile { ...BookingProfile }' : '', "\n      validationSchema(resource : \"profile\", fields: [\"address\"]) {\n        ...ValidationSchemaAddress\n      }\n      ").concat(Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_7__[/* getCxoAttendeesData */ "a"])(params), "\n    }\n\n    ").concat(_client_store_validation_schema_validationSchema_address_fragment__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"], "\n    ").concat(appContext.isUserLogged ? _client_components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_9__[/* profileFragment */ "b"] : '', "\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale')), "\n    ").concat(params.adultsAttendeesIds && params.adultsAttendeesIds[0] || params.kidsAttendeesIds && params.kidsAttendeesIds[0] ? _client_components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"] : '', "\n  "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_GET_SEVERAL */ "rd"]
  });
}

function addTransportMutation(transportId, proposalsId, isJoyView, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addTransport (proposalsId: [\"".concat(proposalsId.join('","'), "\"], transportId: \"").concat(transportId, "\") {\n        ").concat(proposalFields({
    isJoyView: isJoyView,
    withCommission: appContext.isCmta
  }), "\n      }\n    }\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_ADD_TRANSPORT */ "ld"]
  });
}

function addAccommodationMutation(arrangement, proposalsId, isJoyView, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addAccommodation (proposalsId: [\"".concat(proposalsId.join('","'), "\"], arrangement: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(arrangement), ") {\n        ").concat(proposalFields({
    isJoyView: isJoyView,
    withCommission: appContext.isCmta
  }), "\n      }\n    }\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_ACCOMMODATION_ADD */ "hd"]
  });
}

var putServicesGraphQLQuery = function putServicesGraphQLQuery(proposalsId, services, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      putServices(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(proposalsId), ", services: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(services), ") {\n        id\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_ADDITIONAL_SERVICES_UPDATE */ "kd"]
  });
};
/**
 * We don't want to have this request in parallel, it's a put and it can be really long, so we create a queue to do
 * these requests synchronously
 */


var serviceRequestRunning = null;

var putServicesMutation = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(proposalIds, services, appContext) {
    var result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (serviceRequestRunning) {
              _context.next = 15;
              break;
            }

            serviceRequestRunning = putServicesGraphQLQuery(proposalIds, services, appContext);
            _context.prev = 2;
            _context.next = 5;
            return serviceRequestRunning;

          case 5:
            result = _context.sent;
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            throw _context.t0;

          case 11:
            _context.prev = 11;
            serviceRequestRunning = null;
            return _context.finish(11);

          case 14:
            return _context.abrupt("return", result);

          case 15:
            _context.next = 17;
            return serviceRequestRunning;

          case 17:
            return _context.abrupt("return", putServicesMutation(proposalIds, services, appContext));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8, 11, 14]]);
  }));

  return function putServicesMutation(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var deleteServiceGraphQLQuery = function deleteServiceGraphQLQuery(_ref2) {
  var proposalIds = _ref2.proposalIds,
      serviceIds = _ref2.serviceIds,
      attendeeIds = _ref2.attendeeIds,
      overloadForSpecificProposalIds = _ref2.overloadForSpecificProposalIds,
      appContext = _ref2.appContext;
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      deleteService(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(proposalIds), " serviceIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(serviceIds), " attendeeIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(attendeeIds), " ").concat(overloadForSpecificProposalIds ? "overloadForSpecificProposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(overloadForSpecificProposalIds)) : '', ") {\n        id\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_ADDITIONAL_SERVICES_DELETE */ "jd"]
  });
};

var deleteServicesMutation = /*#__PURE__*/function () {
  var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2(_ref3) {
    var proposalIds, serviceIds, attendeeIds, overloadForSpecificProposalIds, appContext, result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            proposalIds = _ref3.proposalIds, serviceIds = _ref3.serviceIds, attendeeIds = _ref3.attendeeIds, overloadForSpecificProposalIds = _ref3.overloadForSpecificProposalIds, appContext = _ref3.appContext;

            if (serviceRequestRunning) {
              _context2.next = 16;
              break;
            }

            serviceRequestRunning = deleteServiceGraphQLQuery({
              proposalIds: proposalIds,
              serviceIds: serviceIds,
              attendeeIds: attendeeIds,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            });
            _context2.prev = 3;
            _context2.next = 6;
            return serviceRequestRunning;

          case 6:
            result = _context2.sent;
            _context2.next = 12;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](3);
            throw _context2.t0;

          case 12:
            _context2.prev = 12;
            serviceRequestRunning = null;
            return _context2.finish(12);

          case 15:
            return _context2.abrupt("return", result);

          case 16:
            _context2.next = 18;
            return serviceRequestRunning;

          case 18:
            return _context2.abrupt("return", deleteServicesMutation({
              proposalIds: proposalIds,
              serviceIds: serviceIds,
              attendeeIds: attendeeIds,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            }));

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 9, 12, 15]]);
  }));

  return function deleteServicesMutation(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

var addServiceGraphQLQuery = function addServiceGraphQLQuery(_ref5) {
  var proposalIds = _ref5.proposalIds,
      serviceId = _ref5.serviceId,
      attendeeIds = _ref5.attendeeIds,
      schedules = _ref5.schedules,
      overloadForSpecificProposalIds = _ref5.overloadForSpecificProposalIds,
      appContext = _ref5.appContext;
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addService(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(proposalIds), ", serviceId: \"").concat(serviceId, "\", attendeeIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(attendeeIds), ", schedules: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(schedules), "  ").concat(overloadForSpecificProposalIds ? "overloadForSpecificProposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_15__[/* graphqlify */ "d"])(overloadForSpecificProposalIds)) : '', ") {\n        id\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_ADDITIONAL_SERVICES_ADD */ "id"]
  });
};

var addServiceMutation = /*#__PURE__*/function () {
  var _ref7 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee3(_ref6) {
    var proposalIds, serviceId, attendeeIds, schedules, overloadForSpecificProposalIds, appContext, result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            proposalIds = _ref6.proposalIds, serviceId = _ref6.serviceId, attendeeIds = _ref6.attendeeIds, schedules = _ref6.schedules, overloadForSpecificProposalIds = _ref6.overloadForSpecificProposalIds, appContext = _ref6.appContext;

            if (serviceRequestRunning) {
              _context3.next = 16;
              break;
            }

            serviceRequestRunning = addServiceGraphQLQuery(_objectSpread(_objectSpread({
              proposalIds: proposalIds,
              serviceId: serviceId,
              attendeeIds: attendeeIds,
              schedules: schedules
            }, overloadForSpecificProposalIds && {
              overloadForSpecificProposalIds: {
                proposalIds: overloadForSpecificProposalIds.proposalIds,
                serviceId: overloadForSpecificProposalIds.serviceIds[0]
              }
            }), {}, {
              appContext: appContext
            }));
            _context3.prev = 3;
            _context3.next = 6;
            return serviceRequestRunning;

          case 6:
            result = _context3.sent;
            _context3.next = 12;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](3);
            throw _context3.t0;

          case 12:
            _context3.prev = 12;
            serviceRequestRunning = null;
            return _context3.finish(12);

          case 15:
            return _context3.abrupt("return", result);

          case 16:
            _context3.next = 18;
            return serviceRequestRunning;

          case 18:
            return _context3.abrupt("return", addServiceMutation({
              proposalIds: proposalIds,
              serviceId: serviceId,
              attendeeIds: attendeeIds,
              schedules: schedules,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            }));

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 9, 12, 15]]);
  }));

  return function addServiceMutation(_x5) {
    return _ref7.apply(this, arguments);
  };
}();

function promoCodeProposalMutation(params, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      promoCodeProposal(id: \"".concat(params.proposalId, "\", promoCode: \"").concat(params.promoCode, "\" ").concat(params.partnerId && params.accessCode ? ", partnerId: \"".concat(params.partnerId, "\", accessCode: \"").concat(params.accessCode, "\"") : '', ", customerId: ").concat(params.customerId, ") {\n        id\n        price {\n          aggregateDiscount {\n            offerColor\n            offerName\n            amount {...priceDetails}\n          }\n          aggregateDiscountPromoCode {\n            offerColor\n            offerName\n            amount {...priceDetails}\n         }\n          promoCode {\n            offerColor\n            offerName\n            amount {\n              value\n              formattedValue\n            }\n          }\n          total {...priceDetails}\n          discounts {\n            amount {...priceDetails}\n            offerName\n            offerColor\n          }\n        }\n        paymentSchedule {\n          total {...priceDetails}\n          depositAmount {...priceDetails}\n          repaymentSchedules {\n            amount {...priceDetails}\n            deadline\n          }\n        }\n      }\n    }\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_USE_PROMO_CODE */ "yd"]
  });
}

function switchProposalsOffers(proposalIds, offerIds, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("mutation {\n      proposals: switchProposalsOffers(proposalIds: [\"".concat(proposalIds.join('","'), "\"], offerIds: [\"").concat(offerIds.join('","'), "\"]) {\n        id\n        optionAvailable\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_SWITCH_OFFER */ "ud"]
  });
}



/***/ }),

/***/ "711d":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ "77Zs":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("Xi7e");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "7GkX":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("b80T"),
    baseKeys = __webpack_require__("A90E"),
    isArrayLike = __webpack_require__("MMmD");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "7Pat":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("+7q0"),
    shortOut = __webpack_require__("kG2z");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "7Z8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPEN_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showTemporaryToast; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var CLOSE_TOAST = 'CLOSE_TOAST';
var OPEN_TOAST = 'OPEN_TOAST';

function openToast(toastLabel, className) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(OPEN_TOAST, {
    toastLabel: toastLabel,
    className: className
  });
}

function closeToast() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(CLOSE_TOAST);
}

var showTemporaryToast = function showTemporaryToast(_ref) {
  var _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 2000 : _ref$timeout,
      toastLabel = _ref.toastLabel,
      className = _ref.className;
  return function (dispatch) {
    return Promise.resolve(dispatch(openToast(toastLabel, className))).then(function () {
      setTimeout(function () {
        return dispatch(closeToast());
      }, timeout);
    });
  };
};



/***/ }),

/***/ "7fqy":
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "7hcC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResortListContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ResortListContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({
  resortList: [],
  setResortList: function setResortList() {}
});

/***/ }),

/***/ "88Gu":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "8PLQ":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Abreve\":\"Ă\",\"abreve\":\"ă\",\"ac\":\"∾\",\"acd\":\"∿\",\"acE\":\"∾̳\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"Acy\":\"А\",\"acy\":\"а\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"af\":\"⁡\",\"Afr\":\"𝔄\",\"afr\":\"𝔞\",\"Agrave\":\"À\",\"agrave\":\"à\",\"alefsym\":\"ℵ\",\"aleph\":\"ℵ\",\"Alpha\":\"Α\",\"alpha\":\"α\",\"Amacr\":\"Ā\",\"amacr\":\"ā\",\"amalg\":\"⨿\",\"amp\":\"&\",\"AMP\":\"&\",\"andand\":\"⩕\",\"And\":\"⩓\",\"and\":\"∧\",\"andd\":\"⩜\",\"andslope\":\"⩘\",\"andv\":\"⩚\",\"ang\":\"∠\",\"ange\":\"⦤\",\"angle\":\"∠\",\"angmsdaa\":\"⦨\",\"angmsdab\":\"⦩\",\"angmsdac\":\"⦪\",\"angmsdad\":\"⦫\",\"angmsdae\":\"⦬\",\"angmsdaf\":\"⦭\",\"angmsdag\":\"⦮\",\"angmsdah\":\"⦯\",\"angmsd\":\"∡\",\"angrt\":\"∟\",\"angrtvb\":\"⊾\",\"angrtvbd\":\"⦝\",\"angsph\":\"∢\",\"angst\":\"Å\",\"angzarr\":\"⍼\",\"Aogon\":\"Ą\",\"aogon\":\"ą\",\"Aopf\":\"𝔸\",\"aopf\":\"𝕒\",\"apacir\":\"⩯\",\"ap\":\"≈\",\"apE\":\"⩰\",\"ape\":\"≊\",\"apid\":\"≋\",\"apos\":\"'\",\"ApplyFunction\":\"⁡\",\"approx\":\"≈\",\"approxeq\":\"≊\",\"Aring\":\"Å\",\"aring\":\"å\",\"Ascr\":\"𝒜\",\"ascr\":\"𝒶\",\"Assign\":\"≔\",\"ast\":\"*\",\"asymp\":\"≈\",\"asympeq\":\"≍\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"awconint\":\"∳\",\"awint\":\"⨑\",\"backcong\":\"≌\",\"backepsilon\":\"϶\",\"backprime\":\"‵\",\"backsim\":\"∽\",\"backsimeq\":\"⋍\",\"Backslash\":\"∖\",\"Barv\":\"⫧\",\"barvee\":\"⊽\",\"barwed\":\"⌅\",\"Barwed\":\"⌆\",\"barwedge\":\"⌅\",\"bbrk\":\"⎵\",\"bbrktbrk\":\"⎶\",\"bcong\":\"≌\",\"Bcy\":\"Б\",\"bcy\":\"б\",\"bdquo\":\"„\",\"becaus\":\"∵\",\"because\":\"∵\",\"Because\":\"∵\",\"bemptyv\":\"⦰\",\"bepsi\":\"϶\",\"bernou\":\"ℬ\",\"Bernoullis\":\"ℬ\",\"Beta\":\"Β\",\"beta\":\"β\",\"beth\":\"ℶ\",\"between\":\"≬\",\"Bfr\":\"𝔅\",\"bfr\":\"𝔟\",\"bigcap\":\"⋂\",\"bigcirc\":\"◯\",\"bigcup\":\"⋃\",\"bigodot\":\"⨀\",\"bigoplus\":\"⨁\",\"bigotimes\":\"⨂\",\"bigsqcup\":\"⨆\",\"bigstar\":\"★\",\"bigtriangledown\":\"▽\",\"bigtriangleup\":\"△\",\"biguplus\":\"⨄\",\"bigvee\":\"⋁\",\"bigwedge\":\"⋀\",\"bkarow\":\"⤍\",\"blacklozenge\":\"⧫\",\"blacksquare\":\"▪\",\"blacktriangle\":\"▴\",\"blacktriangledown\":\"▾\",\"blacktriangleleft\":\"◂\",\"blacktriangleright\":\"▸\",\"blank\":\"␣\",\"blk12\":\"▒\",\"blk14\":\"░\",\"blk34\":\"▓\",\"block\":\"█\",\"bne\":\"=⃥\",\"bnequiv\":\"≡⃥\",\"bNot\":\"⫭\",\"bnot\":\"⌐\",\"Bopf\":\"𝔹\",\"bopf\":\"𝕓\",\"bot\":\"⊥\",\"bottom\":\"⊥\",\"bowtie\":\"⋈\",\"boxbox\":\"⧉\",\"boxdl\":\"┐\",\"boxdL\":\"╕\",\"boxDl\":\"╖\",\"boxDL\":\"╗\",\"boxdr\":\"┌\",\"boxdR\":\"╒\",\"boxDr\":\"╓\",\"boxDR\":\"╔\",\"boxh\":\"─\",\"boxH\":\"═\",\"boxhd\":\"┬\",\"boxHd\":\"╤\",\"boxhD\":\"╥\",\"boxHD\":\"╦\",\"boxhu\":\"┴\",\"boxHu\":\"╧\",\"boxhU\":\"╨\",\"boxHU\":\"╩\",\"boxminus\":\"⊟\",\"boxplus\":\"⊞\",\"boxtimes\":\"⊠\",\"boxul\":\"┘\",\"boxuL\":\"╛\",\"boxUl\":\"╜\",\"boxUL\":\"╝\",\"boxur\":\"└\",\"boxuR\":\"╘\",\"boxUr\":\"╙\",\"boxUR\":\"╚\",\"boxv\":\"│\",\"boxV\":\"║\",\"boxvh\":\"┼\",\"boxvH\":\"╪\",\"boxVh\":\"╫\",\"boxVH\":\"╬\",\"boxvl\":\"┤\",\"boxvL\":\"╡\",\"boxVl\":\"╢\",\"boxVL\":\"╣\",\"boxvr\":\"├\",\"boxvR\":\"╞\",\"boxVr\":\"╟\",\"boxVR\":\"╠\",\"bprime\":\"‵\",\"breve\":\"˘\",\"Breve\":\"˘\",\"brvbar\":\"¦\",\"bscr\":\"𝒷\",\"Bscr\":\"ℬ\",\"bsemi\":\"⁏\",\"bsim\":\"∽\",\"bsime\":\"⋍\",\"bsolb\":\"⧅\",\"bsol\":\"\\\\\",\"bsolhsub\":\"⟈\",\"bull\":\"•\",\"bullet\":\"•\",\"bump\":\"≎\",\"bumpE\":\"⪮\",\"bumpe\":\"≏\",\"Bumpeq\":\"≎\",\"bumpeq\":\"≏\",\"Cacute\":\"Ć\",\"cacute\":\"ć\",\"capand\":\"⩄\",\"capbrcup\":\"⩉\",\"capcap\":\"⩋\",\"cap\":\"∩\",\"Cap\":\"⋒\",\"capcup\":\"⩇\",\"capdot\":\"⩀\",\"CapitalDifferentialD\":\"ⅅ\",\"caps\":\"∩︀\",\"caret\":\"⁁\",\"caron\":\"ˇ\",\"Cayleys\":\"ℭ\",\"ccaps\":\"⩍\",\"Ccaron\":\"Č\",\"ccaron\":\"č\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"Ccirc\":\"Ĉ\",\"ccirc\":\"ĉ\",\"Cconint\":\"∰\",\"ccups\":\"⩌\",\"ccupssm\":\"⩐\",\"Cdot\":\"Ċ\",\"cdot\":\"ċ\",\"cedil\":\"¸\",\"Cedilla\":\"¸\",\"cemptyv\":\"⦲\",\"cent\":\"¢\",\"centerdot\":\"·\",\"CenterDot\":\"·\",\"cfr\":\"𝔠\",\"Cfr\":\"ℭ\",\"CHcy\":\"Ч\",\"chcy\":\"ч\",\"check\":\"✓\",\"checkmark\":\"✓\",\"Chi\":\"Χ\",\"chi\":\"χ\",\"circ\":\"ˆ\",\"circeq\":\"≗\",\"circlearrowleft\":\"↺\",\"circlearrowright\":\"↻\",\"circledast\":\"⊛\",\"circledcirc\":\"⊚\",\"circleddash\":\"⊝\",\"CircleDot\":\"⊙\",\"circledR\":\"®\",\"circledS\":\"Ⓢ\",\"CircleMinus\":\"⊖\",\"CirclePlus\":\"⊕\",\"CircleTimes\":\"⊗\",\"cir\":\"○\",\"cirE\":\"⧃\",\"cire\":\"≗\",\"cirfnint\":\"⨐\",\"cirmid\":\"⫯\",\"cirscir\":\"⧂\",\"ClockwiseContourIntegral\":\"∲\",\"CloseCurlyDoubleQuote\":\"”\",\"CloseCurlyQuote\":\"’\",\"clubs\":\"♣\",\"clubsuit\":\"♣\",\"colon\":\":\",\"Colon\":\"∷\",\"Colone\":\"⩴\",\"colone\":\"≔\",\"coloneq\":\"≔\",\"comma\":\",\",\"commat\":\"@\",\"comp\":\"∁\",\"compfn\":\"∘\",\"complement\":\"∁\",\"complexes\":\"ℂ\",\"cong\":\"≅\",\"congdot\":\"⩭\",\"Congruent\":\"≡\",\"conint\":\"∮\",\"Conint\":\"∯\",\"ContourIntegral\":\"∮\",\"copf\":\"𝕔\",\"Copf\":\"ℂ\",\"coprod\":\"∐\",\"Coproduct\":\"∐\",\"copy\":\"©\",\"COPY\":\"©\",\"copysr\":\"℗\",\"CounterClockwiseContourIntegral\":\"∳\",\"crarr\":\"↵\",\"cross\":\"✗\",\"Cross\":\"⨯\",\"Cscr\":\"𝒞\",\"cscr\":\"𝒸\",\"csub\":\"⫏\",\"csube\":\"⫑\",\"csup\":\"⫐\",\"csupe\":\"⫒\",\"ctdot\":\"⋯\",\"cudarrl\":\"⤸\",\"cudarrr\":\"⤵\",\"cuepr\":\"⋞\",\"cuesc\":\"⋟\",\"cularr\":\"↶\",\"cularrp\":\"⤽\",\"cupbrcap\":\"⩈\",\"cupcap\":\"⩆\",\"CupCap\":\"≍\",\"cup\":\"∪\",\"Cup\":\"⋓\",\"cupcup\":\"⩊\",\"cupdot\":\"⊍\",\"cupor\":\"⩅\",\"cups\":\"∪︀\",\"curarr\":\"↷\",\"curarrm\":\"⤼\",\"curlyeqprec\":\"⋞\",\"curlyeqsucc\":\"⋟\",\"curlyvee\":\"⋎\",\"curlywedge\":\"⋏\",\"curren\":\"¤\",\"curvearrowleft\":\"↶\",\"curvearrowright\":\"↷\",\"cuvee\":\"⋎\",\"cuwed\":\"⋏\",\"cwconint\":\"∲\",\"cwint\":\"∱\",\"cylcty\":\"⌭\",\"dagger\":\"†\",\"Dagger\":\"‡\",\"daleth\":\"ℸ\",\"darr\":\"↓\",\"Darr\":\"↡\",\"dArr\":\"⇓\",\"dash\":\"‐\",\"Dashv\":\"⫤\",\"dashv\":\"⊣\",\"dbkarow\":\"⤏\",\"dblac\":\"˝\",\"Dcaron\":\"Ď\",\"dcaron\":\"ď\",\"Dcy\":\"Д\",\"dcy\":\"д\",\"ddagger\":\"‡\",\"ddarr\":\"⇊\",\"DD\":\"ⅅ\",\"dd\":\"ⅆ\",\"DDotrahd\":\"⤑\",\"ddotseq\":\"⩷\",\"deg\":\"°\",\"Del\":\"∇\",\"Delta\":\"Δ\",\"delta\":\"δ\",\"demptyv\":\"⦱\",\"dfisht\":\"⥿\",\"Dfr\":\"𝔇\",\"dfr\":\"𝔡\",\"dHar\":\"⥥\",\"dharl\":\"⇃\",\"dharr\":\"⇂\",\"DiacriticalAcute\":\"´\",\"DiacriticalDot\":\"˙\",\"DiacriticalDoubleAcute\":\"˝\",\"DiacriticalGrave\":\"`\",\"DiacriticalTilde\":\"˜\",\"diam\":\"⋄\",\"diamond\":\"⋄\",\"Diamond\":\"⋄\",\"diamondsuit\":\"♦\",\"diams\":\"♦\",\"die\":\"¨\",\"DifferentialD\":\"ⅆ\",\"digamma\":\"ϝ\",\"disin\":\"⋲\",\"div\":\"÷\",\"divide\":\"÷\",\"divideontimes\":\"⋇\",\"divonx\":\"⋇\",\"DJcy\":\"Ђ\",\"djcy\":\"ђ\",\"dlcorn\":\"⌞\",\"dlcrop\":\"⌍\",\"dollar\":\"$\",\"Dopf\":\"𝔻\",\"dopf\":\"𝕕\",\"Dot\":\"¨\",\"dot\":\"˙\",\"DotDot\":\"⃜\",\"doteq\":\"≐\",\"doteqdot\":\"≑\",\"DotEqual\":\"≐\",\"dotminus\":\"∸\",\"dotplus\":\"∔\",\"dotsquare\":\"⊡\",\"doublebarwedge\":\"⌆\",\"DoubleContourIntegral\":\"∯\",\"DoubleDot\":\"¨\",\"DoubleDownArrow\":\"⇓\",\"DoubleLeftArrow\":\"⇐\",\"DoubleLeftRightArrow\":\"⇔\",\"DoubleLeftTee\":\"⫤\",\"DoubleLongLeftArrow\":\"⟸\",\"DoubleLongLeftRightArrow\":\"⟺\",\"DoubleLongRightArrow\":\"⟹\",\"DoubleRightArrow\":\"⇒\",\"DoubleRightTee\":\"⊨\",\"DoubleUpArrow\":\"⇑\",\"DoubleUpDownArrow\":\"⇕\",\"DoubleVerticalBar\":\"∥\",\"DownArrowBar\":\"⤓\",\"downarrow\":\"↓\",\"DownArrow\":\"↓\",\"Downarrow\":\"⇓\",\"DownArrowUpArrow\":\"⇵\",\"DownBreve\":\"̑\",\"downdownarrows\":\"⇊\",\"downharpoonleft\":\"⇃\",\"downharpoonright\":\"⇂\",\"DownLeftRightVector\":\"⥐\",\"DownLeftTeeVector\":\"⥞\",\"DownLeftVectorBar\":\"⥖\",\"DownLeftVector\":\"↽\",\"DownRightTeeVector\":\"⥟\",\"DownRightVectorBar\":\"⥗\",\"DownRightVector\":\"⇁\",\"DownTeeArrow\":\"↧\",\"DownTee\":\"⊤\",\"drbkarow\":\"⤐\",\"drcorn\":\"⌟\",\"drcrop\":\"⌌\",\"Dscr\":\"𝒟\",\"dscr\":\"𝒹\",\"DScy\":\"Ѕ\",\"dscy\":\"ѕ\",\"dsol\":\"⧶\",\"Dstrok\":\"Đ\",\"dstrok\":\"đ\",\"dtdot\":\"⋱\",\"dtri\":\"▿\",\"dtrif\":\"▾\",\"duarr\":\"⇵\",\"duhar\":\"⥯\",\"dwangle\":\"⦦\",\"DZcy\":\"Џ\",\"dzcy\":\"џ\",\"dzigrarr\":\"⟿\",\"Eacute\":\"É\",\"eacute\":\"é\",\"easter\":\"⩮\",\"Ecaron\":\"Ě\",\"ecaron\":\"ě\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"ecir\":\"≖\",\"ecolon\":\"≕\",\"Ecy\":\"Э\",\"ecy\":\"э\",\"eDDot\":\"⩷\",\"Edot\":\"Ė\",\"edot\":\"ė\",\"eDot\":\"≑\",\"ee\":\"ⅇ\",\"efDot\":\"≒\",\"Efr\":\"𝔈\",\"efr\":\"𝔢\",\"eg\":\"⪚\",\"Egrave\":\"È\",\"egrave\":\"è\",\"egs\":\"⪖\",\"egsdot\":\"⪘\",\"el\":\"⪙\",\"Element\":\"∈\",\"elinters\":\"⏧\",\"ell\":\"ℓ\",\"els\":\"⪕\",\"elsdot\":\"⪗\",\"Emacr\":\"Ē\",\"emacr\":\"ē\",\"empty\":\"∅\",\"emptyset\":\"∅\",\"EmptySmallSquare\":\"◻\",\"emptyv\":\"∅\",\"EmptyVerySmallSquare\":\"▫\",\"emsp13\":\" \",\"emsp14\":\" \",\"emsp\":\" \",\"ENG\":\"Ŋ\",\"eng\":\"ŋ\",\"ensp\":\" \",\"Eogon\":\"Ę\",\"eogon\":\"ę\",\"Eopf\":\"𝔼\",\"eopf\":\"𝕖\",\"epar\":\"⋕\",\"eparsl\":\"⧣\",\"eplus\":\"⩱\",\"epsi\":\"ε\",\"Epsilon\":\"Ε\",\"epsilon\":\"ε\",\"epsiv\":\"ϵ\",\"eqcirc\":\"≖\",\"eqcolon\":\"≕\",\"eqsim\":\"≂\",\"eqslantgtr\":\"⪖\",\"eqslantless\":\"⪕\",\"Equal\":\"⩵\",\"equals\":\"=\",\"EqualTilde\":\"≂\",\"equest\":\"≟\",\"Equilibrium\":\"⇌\",\"equiv\":\"≡\",\"equivDD\":\"⩸\",\"eqvparsl\":\"⧥\",\"erarr\":\"⥱\",\"erDot\":\"≓\",\"escr\":\"ℯ\",\"Escr\":\"ℰ\",\"esdot\":\"≐\",\"Esim\":\"⩳\",\"esim\":\"≂\",\"Eta\":\"Η\",\"eta\":\"η\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"euro\":\"€\",\"excl\":\"!\",\"exist\":\"∃\",\"Exists\":\"∃\",\"expectation\":\"ℰ\",\"exponentiale\":\"ⅇ\",\"ExponentialE\":\"ⅇ\",\"fallingdotseq\":\"≒\",\"Fcy\":\"Ф\",\"fcy\":\"ф\",\"female\":\"♀\",\"ffilig\":\"ﬃ\",\"fflig\":\"ﬀ\",\"ffllig\":\"ﬄ\",\"Ffr\":\"𝔉\",\"ffr\":\"𝔣\",\"filig\":\"ﬁ\",\"FilledSmallSquare\":\"◼\",\"FilledVerySmallSquare\":\"▪\",\"fjlig\":\"fj\",\"flat\":\"♭\",\"fllig\":\"ﬂ\",\"fltns\":\"▱\",\"fnof\":\"ƒ\",\"Fopf\":\"𝔽\",\"fopf\":\"𝕗\",\"forall\":\"∀\",\"ForAll\":\"∀\",\"fork\":\"⋔\",\"forkv\":\"⫙\",\"Fouriertrf\":\"ℱ\",\"fpartint\":\"⨍\",\"frac12\":\"½\",\"frac13\":\"⅓\",\"frac14\":\"¼\",\"frac15\":\"⅕\",\"frac16\":\"⅙\",\"frac18\":\"⅛\",\"frac23\":\"⅔\",\"frac25\":\"⅖\",\"frac34\":\"¾\",\"frac35\":\"⅗\",\"frac38\":\"⅜\",\"frac45\":\"⅘\",\"frac56\":\"⅚\",\"frac58\":\"⅝\",\"frac78\":\"⅞\",\"frasl\":\"⁄\",\"frown\":\"⌢\",\"fscr\":\"𝒻\",\"Fscr\":\"ℱ\",\"gacute\":\"ǵ\",\"Gamma\":\"Γ\",\"gamma\":\"γ\",\"Gammad\":\"Ϝ\",\"gammad\":\"ϝ\",\"gap\":\"⪆\",\"Gbreve\":\"Ğ\",\"gbreve\":\"ğ\",\"Gcedil\":\"Ģ\",\"Gcirc\":\"Ĝ\",\"gcirc\":\"ĝ\",\"Gcy\":\"Г\",\"gcy\":\"г\",\"Gdot\":\"Ġ\",\"gdot\":\"ġ\",\"ge\":\"≥\",\"gE\":\"≧\",\"gEl\":\"⪌\",\"gel\":\"⋛\",\"geq\":\"≥\",\"geqq\":\"≧\",\"geqslant\":\"⩾\",\"gescc\":\"⪩\",\"ges\":\"⩾\",\"gesdot\":\"⪀\",\"gesdoto\":\"⪂\",\"gesdotol\":\"⪄\",\"gesl\":\"⋛︀\",\"gesles\":\"⪔\",\"Gfr\":\"𝔊\",\"gfr\":\"𝔤\",\"gg\":\"≫\",\"Gg\":\"⋙\",\"ggg\":\"⋙\",\"gimel\":\"ℷ\",\"GJcy\":\"Ѓ\",\"gjcy\":\"ѓ\",\"gla\":\"⪥\",\"gl\":\"≷\",\"glE\":\"⪒\",\"glj\":\"⪤\",\"gnap\":\"⪊\",\"gnapprox\":\"⪊\",\"gne\":\"⪈\",\"gnE\":\"≩\",\"gneq\":\"⪈\",\"gneqq\":\"≩\",\"gnsim\":\"⋧\",\"Gopf\":\"𝔾\",\"gopf\":\"𝕘\",\"grave\":\"`\",\"GreaterEqual\":\"≥\",\"GreaterEqualLess\":\"⋛\",\"GreaterFullEqual\":\"≧\",\"GreaterGreater\":\"⪢\",\"GreaterLess\":\"≷\",\"GreaterSlantEqual\":\"⩾\",\"GreaterTilde\":\"≳\",\"Gscr\":\"𝒢\",\"gscr\":\"ℊ\",\"gsim\":\"≳\",\"gsime\":\"⪎\",\"gsiml\":\"⪐\",\"gtcc\":\"⪧\",\"gtcir\":\"⩺\",\"gt\":\">\",\"GT\":\">\",\"Gt\":\"≫\",\"gtdot\":\"⋗\",\"gtlPar\":\"⦕\",\"gtquest\":\"⩼\",\"gtrapprox\":\"⪆\",\"gtrarr\":\"⥸\",\"gtrdot\":\"⋗\",\"gtreqless\":\"⋛\",\"gtreqqless\":\"⪌\",\"gtrless\":\"≷\",\"gtrsim\":\"≳\",\"gvertneqq\":\"≩︀\",\"gvnE\":\"≩︀\",\"Hacek\":\"ˇ\",\"hairsp\":\" \",\"half\":\"½\",\"hamilt\":\"ℋ\",\"HARDcy\":\"Ъ\",\"hardcy\":\"ъ\",\"harrcir\":\"⥈\",\"harr\":\"↔\",\"hArr\":\"⇔\",\"harrw\":\"↭\",\"Hat\":\"^\",\"hbar\":\"ℏ\",\"Hcirc\":\"Ĥ\",\"hcirc\":\"ĥ\",\"hearts\":\"♥\",\"heartsuit\":\"♥\",\"hellip\":\"…\",\"hercon\":\"⊹\",\"hfr\":\"𝔥\",\"Hfr\":\"ℌ\",\"HilbertSpace\":\"ℋ\",\"hksearow\":\"⤥\",\"hkswarow\":\"⤦\",\"hoarr\":\"⇿\",\"homtht\":\"∻\",\"hookleftarrow\":\"↩\",\"hookrightarrow\":\"↪\",\"hopf\":\"𝕙\",\"Hopf\":\"ℍ\",\"horbar\":\"―\",\"HorizontalLine\":\"─\",\"hscr\":\"𝒽\",\"Hscr\":\"ℋ\",\"hslash\":\"ℏ\",\"Hstrok\":\"Ħ\",\"hstrok\":\"ħ\",\"HumpDownHump\":\"≎\",\"HumpEqual\":\"≏\",\"hybull\":\"⁃\",\"hyphen\":\"‐\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"ic\":\"⁣\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"Icy\":\"И\",\"icy\":\"и\",\"Idot\":\"İ\",\"IEcy\":\"Е\",\"iecy\":\"е\",\"iexcl\":\"¡\",\"iff\":\"⇔\",\"ifr\":\"𝔦\",\"Ifr\":\"ℑ\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"ii\":\"ⅈ\",\"iiiint\":\"⨌\",\"iiint\":\"∭\",\"iinfin\":\"⧜\",\"iiota\":\"℩\",\"IJlig\":\"Ĳ\",\"ijlig\":\"ĳ\",\"Imacr\":\"Ī\",\"imacr\":\"ī\",\"image\":\"ℑ\",\"ImaginaryI\":\"ⅈ\",\"imagline\":\"ℐ\",\"imagpart\":\"ℑ\",\"imath\":\"ı\",\"Im\":\"ℑ\",\"imof\":\"⊷\",\"imped\":\"Ƶ\",\"Implies\":\"⇒\",\"incare\":\"℅\",\"in\":\"∈\",\"infin\":\"∞\",\"infintie\":\"⧝\",\"inodot\":\"ı\",\"intcal\":\"⊺\",\"int\":\"∫\",\"Int\":\"∬\",\"integers\":\"ℤ\",\"Integral\":\"∫\",\"intercal\":\"⊺\",\"Intersection\":\"⋂\",\"intlarhk\":\"⨗\",\"intprod\":\"⨼\",\"InvisibleComma\":\"⁣\",\"InvisibleTimes\":\"⁢\",\"IOcy\":\"Ё\",\"iocy\":\"ё\",\"Iogon\":\"Į\",\"iogon\":\"į\",\"Iopf\":\"𝕀\",\"iopf\":\"𝕚\",\"Iota\":\"Ι\",\"iota\":\"ι\",\"iprod\":\"⨼\",\"iquest\":\"¿\",\"iscr\":\"𝒾\",\"Iscr\":\"ℐ\",\"isin\":\"∈\",\"isindot\":\"⋵\",\"isinE\":\"⋹\",\"isins\":\"⋴\",\"isinsv\":\"⋳\",\"isinv\":\"∈\",\"it\":\"⁢\",\"Itilde\":\"Ĩ\",\"itilde\":\"ĩ\",\"Iukcy\":\"І\",\"iukcy\":\"і\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"Jcirc\":\"Ĵ\",\"jcirc\":\"ĵ\",\"Jcy\":\"Й\",\"jcy\":\"й\",\"Jfr\":\"𝔍\",\"jfr\":\"𝔧\",\"jmath\":\"ȷ\",\"Jopf\":\"𝕁\",\"jopf\":\"𝕛\",\"Jscr\":\"𝒥\",\"jscr\":\"𝒿\",\"Jsercy\":\"Ј\",\"jsercy\":\"ј\",\"Jukcy\":\"Є\",\"jukcy\":\"є\",\"Kappa\":\"Κ\",\"kappa\":\"κ\",\"kappav\":\"ϰ\",\"Kcedil\":\"Ķ\",\"kcedil\":\"ķ\",\"Kcy\":\"К\",\"kcy\":\"к\",\"Kfr\":\"𝔎\",\"kfr\":\"𝔨\",\"kgreen\":\"ĸ\",\"KHcy\":\"Х\",\"khcy\":\"х\",\"KJcy\":\"Ќ\",\"kjcy\":\"ќ\",\"Kopf\":\"𝕂\",\"kopf\":\"𝕜\",\"Kscr\":\"𝒦\",\"kscr\":\"𝓀\",\"lAarr\":\"⇚\",\"Lacute\":\"Ĺ\",\"lacute\":\"ĺ\",\"laemptyv\":\"⦴\",\"lagran\":\"ℒ\",\"Lambda\":\"Λ\",\"lambda\":\"λ\",\"lang\":\"⟨\",\"Lang\":\"⟪\",\"langd\":\"⦑\",\"langle\":\"⟨\",\"lap\":\"⪅\",\"Laplacetrf\":\"ℒ\",\"laquo\":\"«\",\"larrb\":\"⇤\",\"larrbfs\":\"⤟\",\"larr\":\"←\",\"Larr\":\"↞\",\"lArr\":\"⇐\",\"larrfs\":\"⤝\",\"larrhk\":\"↩\",\"larrlp\":\"↫\",\"larrpl\":\"⤹\",\"larrsim\":\"⥳\",\"larrtl\":\"↢\",\"latail\":\"⤙\",\"lAtail\":\"⤛\",\"lat\":\"⪫\",\"late\":\"⪭\",\"lates\":\"⪭︀\",\"lbarr\":\"⤌\",\"lBarr\":\"⤎\",\"lbbrk\":\"❲\",\"lbrace\":\"{\",\"lbrack\":\"[\",\"lbrke\":\"⦋\",\"lbrksld\":\"⦏\",\"lbrkslu\":\"⦍\",\"Lcaron\":\"Ľ\",\"lcaron\":\"ľ\",\"Lcedil\":\"Ļ\",\"lcedil\":\"ļ\",\"lceil\":\"⌈\",\"lcub\":\"{\",\"Lcy\":\"Л\",\"lcy\":\"л\",\"ldca\":\"⤶\",\"ldquo\":\"“\",\"ldquor\":\"„\",\"ldrdhar\":\"⥧\",\"ldrushar\":\"⥋\",\"ldsh\":\"↲\",\"le\":\"≤\",\"lE\":\"≦\",\"LeftAngleBracket\":\"⟨\",\"LeftArrowBar\":\"⇤\",\"leftarrow\":\"←\",\"LeftArrow\":\"←\",\"Leftarrow\":\"⇐\",\"LeftArrowRightArrow\":\"⇆\",\"leftarrowtail\":\"↢\",\"LeftCeiling\":\"⌈\",\"LeftDoubleBracket\":\"⟦\",\"LeftDownTeeVector\":\"⥡\",\"LeftDownVectorBar\":\"⥙\",\"LeftDownVector\":\"⇃\",\"LeftFloor\":\"⌊\",\"leftharpoondown\":\"↽\",\"leftharpoonup\":\"↼\",\"leftleftarrows\":\"⇇\",\"leftrightarrow\":\"↔\",\"LeftRightArrow\":\"↔\",\"Leftrightarrow\":\"⇔\",\"leftrightarrows\":\"⇆\",\"leftrightharpoons\":\"⇋\",\"leftrightsquigarrow\":\"↭\",\"LeftRightVector\":\"⥎\",\"LeftTeeArrow\":\"↤\",\"LeftTee\":\"⊣\",\"LeftTeeVector\":\"⥚\",\"leftthreetimes\":\"⋋\",\"LeftTriangleBar\":\"⧏\",\"LeftTriangle\":\"⊲\",\"LeftTriangleEqual\":\"⊴\",\"LeftUpDownVector\":\"⥑\",\"LeftUpTeeVector\":\"⥠\",\"LeftUpVectorBar\":\"⥘\",\"LeftUpVector\":\"↿\",\"LeftVectorBar\":\"⥒\",\"LeftVector\":\"↼\",\"lEg\":\"⪋\",\"leg\":\"⋚\",\"leq\":\"≤\",\"leqq\":\"≦\",\"leqslant\":\"⩽\",\"lescc\":\"⪨\",\"les\":\"⩽\",\"lesdot\":\"⩿\",\"lesdoto\":\"⪁\",\"lesdotor\":\"⪃\",\"lesg\":\"⋚︀\",\"lesges\":\"⪓\",\"lessapprox\":\"⪅\",\"lessdot\":\"⋖\",\"lesseqgtr\":\"⋚\",\"lesseqqgtr\":\"⪋\",\"LessEqualGreater\":\"⋚\",\"LessFullEqual\":\"≦\",\"LessGreater\":\"≶\",\"lessgtr\":\"≶\",\"LessLess\":\"⪡\",\"lesssim\":\"≲\",\"LessSlantEqual\":\"⩽\",\"LessTilde\":\"≲\",\"lfisht\":\"⥼\",\"lfloor\":\"⌊\",\"Lfr\":\"𝔏\",\"lfr\":\"𝔩\",\"lg\":\"≶\",\"lgE\":\"⪑\",\"lHar\":\"⥢\",\"lhard\":\"↽\",\"lharu\":\"↼\",\"lharul\":\"⥪\",\"lhblk\":\"▄\",\"LJcy\":\"Љ\",\"ljcy\":\"љ\",\"llarr\":\"⇇\",\"ll\":\"≪\",\"Ll\":\"⋘\",\"llcorner\":\"⌞\",\"Lleftarrow\":\"⇚\",\"llhard\":\"⥫\",\"lltri\":\"◺\",\"Lmidot\":\"Ŀ\",\"lmidot\":\"ŀ\",\"lmoustache\":\"⎰\",\"lmoust\":\"⎰\",\"lnap\":\"⪉\",\"lnapprox\":\"⪉\",\"lne\":\"⪇\",\"lnE\":\"≨\",\"lneq\":\"⪇\",\"lneqq\":\"≨\",\"lnsim\":\"⋦\",\"loang\":\"⟬\",\"loarr\":\"⇽\",\"lobrk\":\"⟦\",\"longleftarrow\":\"⟵\",\"LongLeftArrow\":\"⟵\",\"Longleftarrow\":\"⟸\",\"longleftrightarrow\":\"⟷\",\"LongLeftRightArrow\":\"⟷\",\"Longleftrightarrow\":\"⟺\",\"longmapsto\":\"⟼\",\"longrightarrow\":\"⟶\",\"LongRightArrow\":\"⟶\",\"Longrightarrow\":\"⟹\",\"looparrowleft\":\"↫\",\"looparrowright\":\"↬\",\"lopar\":\"⦅\",\"Lopf\":\"𝕃\",\"lopf\":\"𝕝\",\"loplus\":\"⨭\",\"lotimes\":\"⨴\",\"lowast\":\"∗\",\"lowbar\":\"_\",\"LowerLeftArrow\":\"↙\",\"LowerRightArrow\":\"↘\",\"loz\":\"◊\",\"lozenge\":\"◊\",\"lozf\":\"⧫\",\"lpar\":\"(\",\"lparlt\":\"⦓\",\"lrarr\":\"⇆\",\"lrcorner\":\"⌟\",\"lrhar\":\"⇋\",\"lrhard\":\"⥭\",\"lrm\":\"‎\",\"lrtri\":\"⊿\",\"lsaquo\":\"‹\",\"lscr\":\"𝓁\",\"Lscr\":\"ℒ\",\"lsh\":\"↰\",\"Lsh\":\"↰\",\"lsim\":\"≲\",\"lsime\":\"⪍\",\"lsimg\":\"⪏\",\"lsqb\":\"[\",\"lsquo\":\"‘\",\"lsquor\":\"‚\",\"Lstrok\":\"Ł\",\"lstrok\":\"ł\",\"ltcc\":\"⪦\",\"ltcir\":\"⩹\",\"lt\":\"<\",\"LT\":\"<\",\"Lt\":\"≪\",\"ltdot\":\"⋖\",\"lthree\":\"⋋\",\"ltimes\":\"⋉\",\"ltlarr\":\"⥶\",\"ltquest\":\"⩻\",\"ltri\":\"◃\",\"ltrie\":\"⊴\",\"ltrif\":\"◂\",\"ltrPar\":\"⦖\",\"lurdshar\":\"⥊\",\"luruhar\":\"⥦\",\"lvertneqq\":\"≨︀\",\"lvnE\":\"≨︀\",\"macr\":\"¯\",\"male\":\"♂\",\"malt\":\"✠\",\"maltese\":\"✠\",\"Map\":\"⤅\",\"map\":\"↦\",\"mapsto\":\"↦\",\"mapstodown\":\"↧\",\"mapstoleft\":\"↤\",\"mapstoup\":\"↥\",\"marker\":\"▮\",\"mcomma\":\"⨩\",\"Mcy\":\"М\",\"mcy\":\"м\",\"mdash\":\"—\",\"mDDot\":\"∺\",\"measuredangle\":\"∡\",\"MediumSpace\":\" \",\"Mellintrf\":\"ℳ\",\"Mfr\":\"𝔐\",\"mfr\":\"𝔪\",\"mho\":\"℧\",\"micro\":\"µ\",\"midast\":\"*\",\"midcir\":\"⫰\",\"mid\":\"∣\",\"middot\":\"·\",\"minusb\":\"⊟\",\"minus\":\"−\",\"minusd\":\"∸\",\"minusdu\":\"⨪\",\"MinusPlus\":\"∓\",\"mlcp\":\"⫛\",\"mldr\":\"…\",\"mnplus\":\"∓\",\"models\":\"⊧\",\"Mopf\":\"𝕄\",\"mopf\":\"𝕞\",\"mp\":\"∓\",\"mscr\":\"𝓂\",\"Mscr\":\"ℳ\",\"mstpos\":\"∾\",\"Mu\":\"Μ\",\"mu\":\"μ\",\"multimap\":\"⊸\",\"mumap\":\"⊸\",\"nabla\":\"∇\",\"Nacute\":\"Ń\",\"nacute\":\"ń\",\"nang\":\"∠⃒\",\"nap\":\"≉\",\"napE\":\"⩰̸\",\"napid\":\"≋̸\",\"napos\":\"ŉ\",\"napprox\":\"≉\",\"natural\":\"♮\",\"naturals\":\"ℕ\",\"natur\":\"♮\",\"nbsp\":\" \",\"nbump\":\"≎̸\",\"nbumpe\":\"≏̸\",\"ncap\":\"⩃\",\"Ncaron\":\"Ň\",\"ncaron\":\"ň\",\"Ncedil\":\"Ņ\",\"ncedil\":\"ņ\",\"ncong\":\"≇\",\"ncongdot\":\"⩭̸\",\"ncup\":\"⩂\",\"Ncy\":\"Н\",\"ncy\":\"н\",\"ndash\":\"–\",\"nearhk\":\"⤤\",\"nearr\":\"↗\",\"neArr\":\"⇗\",\"nearrow\":\"↗\",\"ne\":\"≠\",\"nedot\":\"≐̸\",\"NegativeMediumSpace\":\"​\",\"NegativeThickSpace\":\"​\",\"NegativeThinSpace\":\"​\",\"NegativeVeryThinSpace\":\"​\",\"nequiv\":\"≢\",\"nesear\":\"⤨\",\"nesim\":\"≂̸\",\"NestedGreaterGreater\":\"≫\",\"NestedLessLess\":\"≪\",\"NewLine\":\"\\n\",\"nexist\":\"∄\",\"nexists\":\"∄\",\"Nfr\":\"𝔑\",\"nfr\":\"𝔫\",\"ngE\":\"≧̸\",\"nge\":\"≱\",\"ngeq\":\"≱\",\"ngeqq\":\"≧̸\",\"ngeqslant\":\"⩾̸\",\"nges\":\"⩾̸\",\"nGg\":\"⋙̸\",\"ngsim\":\"≵\",\"nGt\":\"≫⃒\",\"ngt\":\"≯\",\"ngtr\":\"≯\",\"nGtv\":\"≫̸\",\"nharr\":\"↮\",\"nhArr\":\"⇎\",\"nhpar\":\"⫲\",\"ni\":\"∋\",\"nis\":\"⋼\",\"nisd\":\"⋺\",\"niv\":\"∋\",\"NJcy\":\"Њ\",\"njcy\":\"њ\",\"nlarr\":\"↚\",\"nlArr\":\"⇍\",\"nldr\":\"‥\",\"nlE\":\"≦̸\",\"nle\":\"≰\",\"nleftarrow\":\"↚\",\"nLeftarrow\":\"⇍\",\"nleftrightarrow\":\"↮\",\"nLeftrightarrow\":\"⇎\",\"nleq\":\"≰\",\"nleqq\":\"≦̸\",\"nleqslant\":\"⩽̸\",\"nles\":\"⩽̸\",\"nless\":\"≮\",\"nLl\":\"⋘̸\",\"nlsim\":\"≴\",\"nLt\":\"≪⃒\",\"nlt\":\"≮\",\"nltri\":\"⋪\",\"nltrie\":\"⋬\",\"nLtv\":\"≪̸\",\"nmid\":\"∤\",\"NoBreak\":\"⁠\",\"NonBreakingSpace\":\" \",\"nopf\":\"𝕟\",\"Nopf\":\"ℕ\",\"Not\":\"⫬\",\"not\":\"¬\",\"NotCongruent\":\"≢\",\"NotCupCap\":\"≭\",\"NotDoubleVerticalBar\":\"∦\",\"NotElement\":\"∉\",\"NotEqual\":\"≠\",\"NotEqualTilde\":\"≂̸\",\"NotExists\":\"∄\",\"NotGreater\":\"≯\",\"NotGreaterEqual\":\"≱\",\"NotGreaterFullEqual\":\"≧̸\",\"NotGreaterGreater\":\"≫̸\",\"NotGreaterLess\":\"≹\",\"NotGreaterSlantEqual\":\"⩾̸\",\"NotGreaterTilde\":\"≵\",\"NotHumpDownHump\":\"≎̸\",\"NotHumpEqual\":\"≏̸\",\"notin\":\"∉\",\"notindot\":\"⋵̸\",\"notinE\":\"⋹̸\",\"notinva\":\"∉\",\"notinvb\":\"⋷\",\"notinvc\":\"⋶\",\"NotLeftTriangleBar\":\"⧏̸\",\"NotLeftTriangle\":\"⋪\",\"NotLeftTriangleEqual\":\"⋬\",\"NotLess\":\"≮\",\"NotLessEqual\":\"≰\",\"NotLessGreater\":\"≸\",\"NotLessLess\":\"≪̸\",\"NotLessSlantEqual\":\"⩽̸\",\"NotLessTilde\":\"≴\",\"NotNestedGreaterGreater\":\"⪢̸\",\"NotNestedLessLess\":\"⪡̸\",\"notni\":\"∌\",\"notniva\":\"∌\",\"notnivb\":\"⋾\",\"notnivc\":\"⋽\",\"NotPrecedes\":\"⊀\",\"NotPrecedesEqual\":\"⪯̸\",\"NotPrecedesSlantEqual\":\"⋠\",\"NotReverseElement\":\"∌\",\"NotRightTriangleBar\":\"⧐̸\",\"NotRightTriangle\":\"⋫\",\"NotRightTriangleEqual\":\"⋭\",\"NotSquareSubset\":\"⊏̸\",\"NotSquareSubsetEqual\":\"⋢\",\"NotSquareSuperset\":\"⊐̸\",\"NotSquareSupersetEqual\":\"⋣\",\"NotSubset\":\"⊂⃒\",\"NotSubsetEqual\":\"⊈\",\"NotSucceeds\":\"⊁\",\"NotSucceedsEqual\":\"⪰̸\",\"NotSucceedsSlantEqual\":\"⋡\",\"NotSucceedsTilde\":\"≿̸\",\"NotSuperset\":\"⊃⃒\",\"NotSupersetEqual\":\"⊉\",\"NotTilde\":\"≁\",\"NotTildeEqual\":\"≄\",\"NotTildeFullEqual\":\"≇\",\"NotTildeTilde\":\"≉\",\"NotVerticalBar\":\"∤\",\"nparallel\":\"∦\",\"npar\":\"∦\",\"nparsl\":\"⫽⃥\",\"npart\":\"∂̸\",\"npolint\":\"⨔\",\"npr\":\"⊀\",\"nprcue\":\"⋠\",\"nprec\":\"⊀\",\"npreceq\":\"⪯̸\",\"npre\":\"⪯̸\",\"nrarrc\":\"⤳̸\",\"nrarr\":\"↛\",\"nrArr\":\"⇏\",\"nrarrw\":\"↝̸\",\"nrightarrow\":\"↛\",\"nRightarrow\":\"⇏\",\"nrtri\":\"⋫\",\"nrtrie\":\"⋭\",\"nsc\":\"⊁\",\"nsccue\":\"⋡\",\"nsce\":\"⪰̸\",\"Nscr\":\"𝒩\",\"nscr\":\"𝓃\",\"nshortmid\":\"∤\",\"nshortparallel\":\"∦\",\"nsim\":\"≁\",\"nsime\":\"≄\",\"nsimeq\":\"≄\",\"nsmid\":\"∤\",\"nspar\":\"∦\",\"nsqsube\":\"⋢\",\"nsqsupe\":\"⋣\",\"nsub\":\"⊄\",\"nsubE\":\"⫅̸\",\"nsube\":\"⊈\",\"nsubset\":\"⊂⃒\",\"nsubseteq\":\"⊈\",\"nsubseteqq\":\"⫅̸\",\"nsucc\":\"⊁\",\"nsucceq\":\"⪰̸\",\"nsup\":\"⊅\",\"nsupE\":\"⫆̸\",\"nsupe\":\"⊉\",\"nsupset\":\"⊃⃒\",\"nsupseteq\":\"⊉\",\"nsupseteqq\":\"⫆̸\",\"ntgl\":\"≹\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"ntlg\":\"≸\",\"ntriangleleft\":\"⋪\",\"ntrianglelefteq\":\"⋬\",\"ntriangleright\":\"⋫\",\"ntrianglerighteq\":\"⋭\",\"Nu\":\"Ν\",\"nu\":\"ν\",\"num\":\"#\",\"numero\":\"№\",\"numsp\":\" \",\"nvap\":\"≍⃒\",\"nvdash\":\"⊬\",\"nvDash\":\"⊭\",\"nVdash\":\"⊮\",\"nVDash\":\"⊯\",\"nvge\":\"≥⃒\",\"nvgt\":\">⃒\",\"nvHarr\":\"⤄\",\"nvinfin\":\"⧞\",\"nvlArr\":\"⤂\",\"nvle\":\"≤⃒\",\"nvlt\":\"<⃒\",\"nvltrie\":\"⊴⃒\",\"nvrArr\":\"⤃\",\"nvrtrie\":\"⊵⃒\",\"nvsim\":\"∼⃒\",\"nwarhk\":\"⤣\",\"nwarr\":\"↖\",\"nwArr\":\"⇖\",\"nwarrow\":\"↖\",\"nwnear\":\"⤧\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"oast\":\"⊛\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"ocir\":\"⊚\",\"Ocy\":\"О\",\"ocy\":\"о\",\"odash\":\"⊝\",\"Odblac\":\"Ő\",\"odblac\":\"ő\",\"odiv\":\"⨸\",\"odot\":\"⊙\",\"odsold\":\"⦼\",\"OElig\":\"Œ\",\"oelig\":\"œ\",\"ofcir\":\"⦿\",\"Ofr\":\"𝔒\",\"ofr\":\"𝔬\",\"ogon\":\"˛\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ogt\":\"⧁\",\"ohbar\":\"⦵\",\"ohm\":\"Ω\",\"oint\":\"∮\",\"olarr\":\"↺\",\"olcir\":\"⦾\",\"olcross\":\"⦻\",\"oline\":\"‾\",\"olt\":\"⧀\",\"Omacr\":\"Ō\",\"omacr\":\"ō\",\"Omega\":\"Ω\",\"omega\":\"ω\",\"Omicron\":\"Ο\",\"omicron\":\"ο\",\"omid\":\"⦶\",\"ominus\":\"⊖\",\"Oopf\":\"𝕆\",\"oopf\":\"𝕠\",\"opar\":\"⦷\",\"OpenCurlyDoubleQuote\":\"“\",\"OpenCurlyQuote\":\"‘\",\"operp\":\"⦹\",\"oplus\":\"⊕\",\"orarr\":\"↻\",\"Or\":\"⩔\",\"or\":\"∨\",\"ord\":\"⩝\",\"order\":\"ℴ\",\"orderof\":\"ℴ\",\"ordf\":\"ª\",\"ordm\":\"º\",\"origof\":\"⊶\",\"oror\":\"⩖\",\"orslope\":\"⩗\",\"orv\":\"⩛\",\"oS\":\"Ⓢ\",\"Oscr\":\"𝒪\",\"oscr\":\"ℴ\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"osol\":\"⊘\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"otimesas\":\"⨶\",\"Otimes\":\"⨷\",\"otimes\":\"⊗\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"ovbar\":\"⌽\",\"OverBar\":\"‾\",\"OverBrace\":\"⏞\",\"OverBracket\":\"⎴\",\"OverParenthesis\":\"⏜\",\"para\":\"¶\",\"parallel\":\"∥\",\"par\":\"∥\",\"parsim\":\"⫳\",\"parsl\":\"⫽\",\"part\":\"∂\",\"PartialD\":\"∂\",\"Pcy\":\"П\",\"pcy\":\"п\",\"percnt\":\"%\",\"period\":\".\",\"permil\":\"‰\",\"perp\":\"⊥\",\"pertenk\":\"‱\",\"Pfr\":\"𝔓\",\"pfr\":\"𝔭\",\"Phi\":\"Φ\",\"phi\":\"φ\",\"phiv\":\"ϕ\",\"phmmat\":\"ℳ\",\"phone\":\"☎\",\"Pi\":\"Π\",\"pi\":\"π\",\"pitchfork\":\"⋔\",\"piv\":\"ϖ\",\"planck\":\"ℏ\",\"planckh\":\"ℎ\",\"plankv\":\"ℏ\",\"plusacir\":\"⨣\",\"plusb\":\"⊞\",\"pluscir\":\"⨢\",\"plus\":\"+\",\"plusdo\":\"∔\",\"plusdu\":\"⨥\",\"pluse\":\"⩲\",\"PlusMinus\":\"±\",\"plusmn\":\"±\",\"plussim\":\"⨦\",\"plustwo\":\"⨧\",\"pm\":\"±\",\"Poincareplane\":\"ℌ\",\"pointint\":\"⨕\",\"popf\":\"𝕡\",\"Popf\":\"ℙ\",\"pound\":\"£\",\"prap\":\"⪷\",\"Pr\":\"⪻\",\"pr\":\"≺\",\"prcue\":\"≼\",\"precapprox\":\"⪷\",\"prec\":\"≺\",\"preccurlyeq\":\"≼\",\"Precedes\":\"≺\",\"PrecedesEqual\":\"⪯\",\"PrecedesSlantEqual\":\"≼\",\"PrecedesTilde\":\"≾\",\"preceq\":\"⪯\",\"precnapprox\":\"⪹\",\"precneqq\":\"⪵\",\"precnsim\":\"⋨\",\"pre\":\"⪯\",\"prE\":\"⪳\",\"precsim\":\"≾\",\"prime\":\"′\",\"Prime\":\"″\",\"primes\":\"ℙ\",\"prnap\":\"⪹\",\"prnE\":\"⪵\",\"prnsim\":\"⋨\",\"prod\":\"∏\",\"Product\":\"∏\",\"profalar\":\"⌮\",\"profline\":\"⌒\",\"profsurf\":\"⌓\",\"prop\":\"∝\",\"Proportional\":\"∝\",\"Proportion\":\"∷\",\"propto\":\"∝\",\"prsim\":\"≾\",\"prurel\":\"⊰\",\"Pscr\":\"𝒫\",\"pscr\":\"𝓅\",\"Psi\":\"Ψ\",\"psi\":\"ψ\",\"puncsp\":\" \",\"Qfr\":\"𝔔\",\"qfr\":\"𝔮\",\"qint\":\"⨌\",\"qopf\":\"𝕢\",\"Qopf\":\"ℚ\",\"qprime\":\"⁗\",\"Qscr\":\"𝒬\",\"qscr\":\"𝓆\",\"quaternions\":\"ℍ\",\"quatint\":\"⨖\",\"quest\":\"?\",\"questeq\":\"≟\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"rAarr\":\"⇛\",\"race\":\"∽̱\",\"Racute\":\"Ŕ\",\"racute\":\"ŕ\",\"radic\":\"√\",\"raemptyv\":\"⦳\",\"rang\":\"⟩\",\"Rang\":\"⟫\",\"rangd\":\"⦒\",\"range\":\"⦥\",\"rangle\":\"⟩\",\"raquo\":\"»\",\"rarrap\":\"⥵\",\"rarrb\":\"⇥\",\"rarrbfs\":\"⤠\",\"rarrc\":\"⤳\",\"rarr\":\"→\",\"Rarr\":\"↠\",\"rArr\":\"⇒\",\"rarrfs\":\"⤞\",\"rarrhk\":\"↪\",\"rarrlp\":\"↬\",\"rarrpl\":\"⥅\",\"rarrsim\":\"⥴\",\"Rarrtl\":\"⤖\",\"rarrtl\":\"↣\",\"rarrw\":\"↝\",\"ratail\":\"⤚\",\"rAtail\":\"⤜\",\"ratio\":\"∶\",\"rationals\":\"ℚ\",\"rbarr\":\"⤍\",\"rBarr\":\"⤏\",\"RBarr\":\"⤐\",\"rbbrk\":\"❳\",\"rbrace\":\"}\",\"rbrack\":\"]\",\"rbrke\":\"⦌\",\"rbrksld\":\"⦎\",\"rbrkslu\":\"⦐\",\"Rcaron\":\"Ř\",\"rcaron\":\"ř\",\"Rcedil\":\"Ŗ\",\"rcedil\":\"ŗ\",\"rceil\":\"⌉\",\"rcub\":\"}\",\"Rcy\":\"Р\",\"rcy\":\"р\",\"rdca\":\"⤷\",\"rdldhar\":\"⥩\",\"rdquo\":\"”\",\"rdquor\":\"”\",\"rdsh\":\"↳\",\"real\":\"ℜ\",\"realine\":\"ℛ\",\"realpart\":\"ℜ\",\"reals\":\"ℝ\",\"Re\":\"ℜ\",\"rect\":\"▭\",\"reg\":\"®\",\"REG\":\"®\",\"ReverseElement\":\"∋\",\"ReverseEquilibrium\":\"⇋\",\"ReverseUpEquilibrium\":\"⥯\",\"rfisht\":\"⥽\",\"rfloor\":\"⌋\",\"rfr\":\"𝔯\",\"Rfr\":\"ℜ\",\"rHar\":\"⥤\",\"rhard\":\"⇁\",\"rharu\":\"⇀\",\"rharul\":\"⥬\",\"Rho\":\"Ρ\",\"rho\":\"ρ\",\"rhov\":\"ϱ\",\"RightAngleBracket\":\"⟩\",\"RightArrowBar\":\"⇥\",\"rightarrow\":\"→\",\"RightArrow\":\"→\",\"Rightarrow\":\"⇒\",\"RightArrowLeftArrow\":\"⇄\",\"rightarrowtail\":\"↣\",\"RightCeiling\":\"⌉\",\"RightDoubleBracket\":\"⟧\",\"RightDownTeeVector\":\"⥝\",\"RightDownVectorBar\":\"⥕\",\"RightDownVector\":\"⇂\",\"RightFloor\":\"⌋\",\"rightharpoondown\":\"⇁\",\"rightharpoonup\":\"⇀\",\"rightleftarrows\":\"⇄\",\"rightleftharpoons\":\"⇌\",\"rightrightarrows\":\"⇉\",\"rightsquigarrow\":\"↝\",\"RightTeeArrow\":\"↦\",\"RightTee\":\"⊢\",\"RightTeeVector\":\"⥛\",\"rightthreetimes\":\"⋌\",\"RightTriangleBar\":\"⧐\",\"RightTriangle\":\"⊳\",\"RightTriangleEqual\":\"⊵\",\"RightUpDownVector\":\"⥏\",\"RightUpTeeVector\":\"⥜\",\"RightUpVectorBar\":\"⥔\",\"RightUpVector\":\"↾\",\"RightVectorBar\":\"⥓\",\"RightVector\":\"⇀\",\"ring\":\"˚\",\"risingdotseq\":\"≓\",\"rlarr\":\"⇄\",\"rlhar\":\"⇌\",\"rlm\":\"‏\",\"rmoustache\":\"⎱\",\"rmoust\":\"⎱\",\"rnmid\":\"⫮\",\"roang\":\"⟭\",\"roarr\":\"⇾\",\"robrk\":\"⟧\",\"ropar\":\"⦆\",\"ropf\":\"𝕣\",\"Ropf\":\"ℝ\",\"roplus\":\"⨮\",\"rotimes\":\"⨵\",\"RoundImplies\":\"⥰\",\"rpar\":\")\",\"rpargt\":\"⦔\",\"rppolint\":\"⨒\",\"rrarr\":\"⇉\",\"Rrightarrow\":\"⇛\",\"rsaquo\":\"›\",\"rscr\":\"𝓇\",\"Rscr\":\"ℛ\",\"rsh\":\"↱\",\"Rsh\":\"↱\",\"rsqb\":\"]\",\"rsquo\":\"’\",\"rsquor\":\"’\",\"rthree\":\"⋌\",\"rtimes\":\"⋊\",\"rtri\":\"▹\",\"rtrie\":\"⊵\",\"rtrif\":\"▸\",\"rtriltri\":\"⧎\",\"RuleDelayed\":\"⧴\",\"ruluhar\":\"⥨\",\"rx\":\"℞\",\"Sacute\":\"Ś\",\"sacute\":\"ś\",\"sbquo\":\"‚\",\"scap\":\"⪸\",\"Scaron\":\"Š\",\"scaron\":\"š\",\"Sc\":\"⪼\",\"sc\":\"≻\",\"sccue\":\"≽\",\"sce\":\"⪰\",\"scE\":\"⪴\",\"Scedil\":\"Ş\",\"scedil\":\"ş\",\"Scirc\":\"Ŝ\",\"scirc\":\"ŝ\",\"scnap\":\"⪺\",\"scnE\":\"⪶\",\"scnsim\":\"⋩\",\"scpolint\":\"⨓\",\"scsim\":\"≿\",\"Scy\":\"С\",\"scy\":\"с\",\"sdotb\":\"⊡\",\"sdot\":\"⋅\",\"sdote\":\"⩦\",\"searhk\":\"⤥\",\"searr\":\"↘\",\"seArr\":\"⇘\",\"searrow\":\"↘\",\"sect\":\"§\",\"semi\":\";\",\"seswar\":\"⤩\",\"setminus\":\"∖\",\"setmn\":\"∖\",\"sext\":\"✶\",\"Sfr\":\"𝔖\",\"sfr\":\"𝔰\",\"sfrown\":\"⌢\",\"sharp\":\"♯\",\"SHCHcy\":\"Щ\",\"shchcy\":\"щ\",\"SHcy\":\"Ш\",\"shcy\":\"ш\",\"ShortDownArrow\":\"↓\",\"ShortLeftArrow\":\"←\",\"shortmid\":\"∣\",\"shortparallel\":\"∥\",\"ShortRightArrow\":\"→\",\"ShortUpArrow\":\"↑\",\"shy\":\"­\",\"Sigma\":\"Σ\",\"sigma\":\"σ\",\"sigmaf\":\"ς\",\"sigmav\":\"ς\",\"sim\":\"∼\",\"simdot\":\"⩪\",\"sime\":\"≃\",\"simeq\":\"≃\",\"simg\":\"⪞\",\"simgE\":\"⪠\",\"siml\":\"⪝\",\"simlE\":\"⪟\",\"simne\":\"≆\",\"simplus\":\"⨤\",\"simrarr\":\"⥲\",\"slarr\":\"←\",\"SmallCircle\":\"∘\",\"smallsetminus\":\"∖\",\"smashp\":\"⨳\",\"smeparsl\":\"⧤\",\"smid\":\"∣\",\"smile\":\"⌣\",\"smt\":\"⪪\",\"smte\":\"⪬\",\"smtes\":\"⪬︀\",\"SOFTcy\":\"Ь\",\"softcy\":\"ь\",\"solbar\":\"⌿\",\"solb\":\"⧄\",\"sol\":\"/\",\"Sopf\":\"𝕊\",\"sopf\":\"𝕤\",\"spades\":\"♠\",\"spadesuit\":\"♠\",\"spar\":\"∥\",\"sqcap\":\"⊓\",\"sqcaps\":\"⊓︀\",\"sqcup\":\"⊔\",\"sqcups\":\"⊔︀\",\"Sqrt\":\"√\",\"sqsub\":\"⊏\",\"sqsube\":\"⊑\",\"sqsubset\":\"⊏\",\"sqsubseteq\":\"⊑\",\"sqsup\":\"⊐\",\"sqsupe\":\"⊒\",\"sqsupset\":\"⊐\",\"sqsupseteq\":\"⊒\",\"square\":\"□\",\"Square\":\"□\",\"SquareIntersection\":\"⊓\",\"SquareSubset\":\"⊏\",\"SquareSubsetEqual\":\"⊑\",\"SquareSuperset\":\"⊐\",\"SquareSupersetEqual\":\"⊒\",\"SquareUnion\":\"⊔\",\"squarf\":\"▪\",\"squ\":\"□\",\"squf\":\"▪\",\"srarr\":\"→\",\"Sscr\":\"𝒮\",\"sscr\":\"𝓈\",\"ssetmn\":\"∖\",\"ssmile\":\"⌣\",\"sstarf\":\"⋆\",\"Star\":\"⋆\",\"star\":\"☆\",\"starf\":\"★\",\"straightepsilon\":\"ϵ\",\"straightphi\":\"ϕ\",\"strns\":\"¯\",\"sub\":\"⊂\",\"Sub\":\"⋐\",\"subdot\":\"⪽\",\"subE\":\"⫅\",\"sube\":\"⊆\",\"subedot\":\"⫃\",\"submult\":\"⫁\",\"subnE\":\"⫋\",\"subne\":\"⊊\",\"subplus\":\"⪿\",\"subrarr\":\"⥹\",\"subset\":\"⊂\",\"Subset\":\"⋐\",\"subseteq\":\"⊆\",\"subseteqq\":\"⫅\",\"SubsetEqual\":\"⊆\",\"subsetneq\":\"⊊\",\"subsetneqq\":\"⫋\",\"subsim\":\"⫇\",\"subsub\":\"⫕\",\"subsup\":\"⫓\",\"succapprox\":\"⪸\",\"succ\":\"≻\",\"succcurlyeq\":\"≽\",\"Succeeds\":\"≻\",\"SucceedsEqual\":\"⪰\",\"SucceedsSlantEqual\":\"≽\",\"SucceedsTilde\":\"≿\",\"succeq\":\"⪰\",\"succnapprox\":\"⪺\",\"succneqq\":\"⪶\",\"succnsim\":\"⋩\",\"succsim\":\"≿\",\"SuchThat\":\"∋\",\"sum\":\"∑\",\"Sum\":\"∑\",\"sung\":\"♪\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"sup\":\"⊃\",\"Sup\":\"⋑\",\"supdot\":\"⪾\",\"supdsub\":\"⫘\",\"supE\":\"⫆\",\"supe\":\"⊇\",\"supedot\":\"⫄\",\"Superset\":\"⊃\",\"SupersetEqual\":\"⊇\",\"suphsol\":\"⟉\",\"suphsub\":\"⫗\",\"suplarr\":\"⥻\",\"supmult\":\"⫂\",\"supnE\":\"⫌\",\"supne\":\"⊋\",\"supplus\":\"⫀\",\"supset\":\"⊃\",\"Supset\":\"⋑\",\"supseteq\":\"⊇\",\"supseteqq\":\"⫆\",\"supsetneq\":\"⊋\",\"supsetneqq\":\"⫌\",\"supsim\":\"⫈\",\"supsub\":\"⫔\",\"supsup\":\"⫖\",\"swarhk\":\"⤦\",\"swarr\":\"↙\",\"swArr\":\"⇙\",\"swarrow\":\"↙\",\"swnwar\":\"⤪\",\"szlig\":\"ß\",\"Tab\":\"\\t\",\"target\":\"⌖\",\"Tau\":\"Τ\",\"tau\":\"τ\",\"tbrk\":\"⎴\",\"Tcaron\":\"Ť\",\"tcaron\":\"ť\",\"Tcedil\":\"Ţ\",\"tcedil\":\"ţ\",\"Tcy\":\"Т\",\"tcy\":\"т\",\"tdot\":\"⃛\",\"telrec\":\"⌕\",\"Tfr\":\"𝔗\",\"tfr\":\"𝔱\",\"there4\":\"∴\",\"therefore\":\"∴\",\"Therefore\":\"∴\",\"Theta\":\"Θ\",\"theta\":\"θ\",\"thetasym\":\"ϑ\",\"thetav\":\"ϑ\",\"thickapprox\":\"≈\",\"thicksim\":\"∼\",\"ThickSpace\":\"  \",\"ThinSpace\":\" \",\"thinsp\":\" \",\"thkap\":\"≈\",\"thksim\":\"∼\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"tilde\":\"˜\",\"Tilde\":\"∼\",\"TildeEqual\":\"≃\",\"TildeFullEqual\":\"≅\",\"TildeTilde\":\"≈\",\"timesbar\":\"⨱\",\"timesb\":\"⊠\",\"times\":\"×\",\"timesd\":\"⨰\",\"tint\":\"∭\",\"toea\":\"⤨\",\"topbot\":\"⌶\",\"topcir\":\"⫱\",\"top\":\"⊤\",\"Topf\":\"𝕋\",\"topf\":\"𝕥\",\"topfork\":\"⫚\",\"tosa\":\"⤩\",\"tprime\":\"‴\",\"trade\":\"™\",\"TRADE\":\"™\",\"triangle\":\"▵\",\"triangledown\":\"▿\",\"triangleleft\":\"◃\",\"trianglelefteq\":\"⊴\",\"triangleq\":\"≜\",\"triangleright\":\"▹\",\"trianglerighteq\":\"⊵\",\"tridot\":\"◬\",\"trie\":\"≜\",\"triminus\":\"⨺\",\"TripleDot\":\"⃛\",\"triplus\":\"⨹\",\"trisb\":\"⧍\",\"tritime\":\"⨻\",\"trpezium\":\"⏢\",\"Tscr\":\"𝒯\",\"tscr\":\"𝓉\",\"TScy\":\"Ц\",\"tscy\":\"ц\",\"TSHcy\":\"Ћ\",\"tshcy\":\"ћ\",\"Tstrok\":\"Ŧ\",\"tstrok\":\"ŧ\",\"twixt\":\"≬\",\"twoheadleftarrow\":\"↞\",\"twoheadrightarrow\":\"↠\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"uarr\":\"↑\",\"Uarr\":\"↟\",\"uArr\":\"⇑\",\"Uarrocir\":\"⥉\",\"Ubrcy\":\"Ў\",\"ubrcy\":\"ў\",\"Ubreve\":\"Ŭ\",\"ubreve\":\"ŭ\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ucy\":\"У\",\"ucy\":\"у\",\"udarr\":\"⇅\",\"Udblac\":\"Ű\",\"udblac\":\"ű\",\"udhar\":\"⥮\",\"ufisht\":\"⥾\",\"Ufr\":\"𝔘\",\"ufr\":\"𝔲\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uHar\":\"⥣\",\"uharl\":\"↿\",\"uharr\":\"↾\",\"uhblk\":\"▀\",\"ulcorn\":\"⌜\",\"ulcorner\":\"⌜\",\"ulcrop\":\"⌏\",\"ultri\":\"◸\",\"Umacr\":\"Ū\",\"umacr\":\"ū\",\"uml\":\"¨\",\"UnderBar\":\"_\",\"UnderBrace\":\"⏟\",\"UnderBracket\":\"⎵\",\"UnderParenthesis\":\"⏝\",\"Union\":\"⋃\",\"UnionPlus\":\"⊎\",\"Uogon\":\"Ų\",\"uogon\":\"ų\",\"Uopf\":\"𝕌\",\"uopf\":\"𝕦\",\"UpArrowBar\":\"⤒\",\"uparrow\":\"↑\",\"UpArrow\":\"↑\",\"Uparrow\":\"⇑\",\"UpArrowDownArrow\":\"⇅\",\"updownarrow\":\"↕\",\"UpDownArrow\":\"↕\",\"Updownarrow\":\"⇕\",\"UpEquilibrium\":\"⥮\",\"upharpoonleft\":\"↿\",\"upharpoonright\":\"↾\",\"uplus\":\"⊎\",\"UpperLeftArrow\":\"↖\",\"UpperRightArrow\":\"↗\",\"upsi\":\"υ\",\"Upsi\":\"ϒ\",\"upsih\":\"ϒ\",\"Upsilon\":\"Υ\",\"upsilon\":\"υ\",\"UpTeeArrow\":\"↥\",\"UpTee\":\"⊥\",\"upuparrows\":\"⇈\",\"urcorn\":\"⌝\",\"urcorner\":\"⌝\",\"urcrop\":\"⌎\",\"Uring\":\"Ů\",\"uring\":\"ů\",\"urtri\":\"◹\",\"Uscr\":\"𝒰\",\"uscr\":\"𝓊\",\"utdot\":\"⋰\",\"Utilde\":\"Ũ\",\"utilde\":\"ũ\",\"utri\":\"▵\",\"utrif\":\"▴\",\"uuarr\":\"⇈\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"uwangle\":\"⦧\",\"vangrt\":\"⦜\",\"varepsilon\":\"ϵ\",\"varkappa\":\"ϰ\",\"varnothing\":\"∅\",\"varphi\":\"ϕ\",\"varpi\":\"ϖ\",\"varpropto\":\"∝\",\"varr\":\"↕\",\"vArr\":\"⇕\",\"varrho\":\"ϱ\",\"varsigma\":\"ς\",\"varsubsetneq\":\"⊊︀\",\"varsubsetneqq\":\"⫋︀\",\"varsupsetneq\":\"⊋︀\",\"varsupsetneqq\":\"⫌︀\",\"vartheta\":\"ϑ\",\"vartriangleleft\":\"⊲\",\"vartriangleright\":\"⊳\",\"vBar\":\"⫨\",\"Vbar\":\"⫫\",\"vBarv\":\"⫩\",\"Vcy\":\"В\",\"vcy\":\"в\",\"vdash\":\"⊢\",\"vDash\":\"⊨\",\"Vdash\":\"⊩\",\"VDash\":\"⊫\",\"Vdashl\":\"⫦\",\"veebar\":\"⊻\",\"vee\":\"∨\",\"Vee\":\"⋁\",\"veeeq\":\"≚\",\"vellip\":\"⋮\",\"verbar\":\"|\",\"Verbar\":\"‖\",\"vert\":\"|\",\"Vert\":\"‖\",\"VerticalBar\":\"∣\",\"VerticalLine\":\"|\",\"VerticalSeparator\":\"❘\",\"VerticalTilde\":\"≀\",\"VeryThinSpace\":\" \",\"Vfr\":\"𝔙\",\"vfr\":\"𝔳\",\"vltri\":\"⊲\",\"vnsub\":\"⊂⃒\",\"vnsup\":\"⊃⃒\",\"Vopf\":\"𝕍\",\"vopf\":\"𝕧\",\"vprop\":\"∝\",\"vrtri\":\"⊳\",\"Vscr\":\"𝒱\",\"vscr\":\"𝓋\",\"vsubnE\":\"⫋︀\",\"vsubne\":\"⊊︀\",\"vsupnE\":\"⫌︀\",\"vsupne\":\"⊋︀\",\"Vvdash\":\"⊪\",\"vzigzag\":\"⦚\",\"Wcirc\":\"Ŵ\",\"wcirc\":\"ŵ\",\"wedbar\":\"⩟\",\"wedge\":\"∧\",\"Wedge\":\"⋀\",\"wedgeq\":\"≙\",\"weierp\":\"℘\",\"Wfr\":\"𝔚\",\"wfr\":\"𝔴\",\"Wopf\":\"𝕎\",\"wopf\":\"𝕨\",\"wp\":\"℘\",\"wr\":\"≀\",\"wreath\":\"≀\",\"Wscr\":\"𝒲\",\"wscr\":\"𝓌\",\"xcap\":\"⋂\",\"xcirc\":\"◯\",\"xcup\":\"⋃\",\"xdtri\":\"▽\",\"Xfr\":\"𝔛\",\"xfr\":\"𝔵\",\"xharr\":\"⟷\",\"xhArr\":\"⟺\",\"Xi\":\"Ξ\",\"xi\":\"ξ\",\"xlarr\":\"⟵\",\"xlArr\":\"⟸\",\"xmap\":\"⟼\",\"xnis\":\"⋻\",\"xodot\":\"⨀\",\"Xopf\":\"𝕏\",\"xopf\":\"𝕩\",\"xoplus\":\"⨁\",\"xotime\":\"⨂\",\"xrarr\":\"⟶\",\"xrArr\":\"⟹\",\"Xscr\":\"𝒳\",\"xscr\":\"𝓍\",\"xsqcup\":\"⨆\",\"xuplus\":\"⨄\",\"xutri\":\"△\",\"xvee\":\"⋁\",\"xwedge\":\"⋀\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"YAcy\":\"Я\",\"yacy\":\"я\",\"Ycirc\":\"Ŷ\",\"ycirc\":\"ŷ\",\"Ycy\":\"Ы\",\"ycy\":\"ы\",\"yen\":\"¥\",\"Yfr\":\"𝔜\",\"yfr\":\"𝔶\",\"YIcy\":\"Ї\",\"yicy\":\"ї\",\"Yopf\":\"𝕐\",\"yopf\":\"𝕪\",\"Yscr\":\"𝒴\",\"yscr\":\"𝓎\",\"YUcy\":\"Ю\",\"yucy\":\"ю\",\"yuml\":\"ÿ\",\"Yuml\":\"Ÿ\",\"Zacute\":\"Ź\",\"zacute\":\"ź\",\"Zcaron\":\"Ž\",\"zcaron\":\"ž\",\"Zcy\":\"З\",\"zcy\":\"з\",\"Zdot\":\"Ż\",\"zdot\":\"ż\",\"zeetrf\":\"ℨ\",\"ZeroWidthSpace\":\"​\",\"Zeta\":\"Ζ\",\"zeta\":\"ζ\",\"zfr\":\"𝔷\",\"Zfr\":\"ℨ\",\"ZHcy\":\"Ж\",\"zhcy\":\"ж\",\"zigrarr\":\"⇝\",\"zopf\":\"𝕫\",\"Zopf\":\"ℤ\",\"Zscr\":\"𝒵\",\"zscr\":\"𝓏\",\"zwj\":\"‍\",\"zwnj\":\"‌\"}");

/***/ }),

/***/ "8miM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormErrors; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _form_feedback_FormFeedback_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("DwNm");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


function FormErrors(_ref) {
  var className = _ref.className,
      _ref$texts = _ref.texts,
      texts = _ref$texts === void 0 ? [] : _ref$texts,
      dataTestId = _ref.dataTestId;
  return __jsx("div", {
    className: className,
    "data-testid": dataTestId
  }, texts.map(function (text) {
    return __jsx(_form_feedback_FormFeedback_jsx__WEBPACK_IMPORTED_MODULE_1__[/* FormFeedback */ "a"], {
      key: text,
      isError: true,
      message: text
    });
  }));
}

/***/ }),

/***/ "8soX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isSymbol2 = __webpack_require__("a88S");

var _isSymbol3 = _interopRequireDefault(_isSymbol2);

var _isString2 = __webpack_require__("nDih");

var _isString3 = _interopRequireDefault(_isString2);

var _isPlainObject2 = __webpack_require__("Kkar");

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

exports.isFSA = isFSA;
exports.isError = isError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFSA(action) {
  return (0, _isPlainObject3.default)(action) && ((0, _isString3.default)(action.type) || (0, _isSymbol3.default)(action.type)) && Object.keys(action).every(isValidKey);
}

function isError(action) {
  return action.error === true;
}

function isValidKey(key) {
  return ['type', 'payload', 'error', 'meta'].indexOf(key) > -1;
}

/***/ }),

/***/ "9BC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isPhoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emailRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPhoneRegex; });
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0__);
 // WARNING: iF this file is growing too much, think of replacing it with a library like Validator.js

function isPhoneNumber(stringToTest) {
  return /^[\d\s()+-.]+$/.test(stringToTest.trim());
}

var emailRegex = new RegExp(/^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/);

var getPhoneRegex = function getPhoneRegex(locale) {
  var _domainsService$getDo, _domainsService$getDo2;

  return new RegExp(((_domainsService$getDo = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0___default.a.getDomain(locale)) === null || _domainsService$getDo === void 0 ? void 0 : (_domainsService$getDo2 = _domainsService$getDo.fields) === null || _domainsService$getDo2 === void 0 ? void 0 : _domainsService$getDo2.phoneNumber) || /^ *\+? *(?:[ \-()\.\/]*[0-9][ \-()\.\/]*){6,12}$/);
};



/***/ }),

/***/ "9KBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewsletterForm; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("luEP");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(yup__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ub5k");
/* harmony import */ var _frameworks_grid_row_Grid_row_jsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("WzQP");
/* harmony import */ var _frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PCgT");
/* harmony import */ var _frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("/HC4");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var CELL_GRID_ONE_THIRD = {
  M: 4
};
var subscriptionSchema = function subscriptionSchema() {
  return yup__WEBPACK_IMPORTED_MODULE_1__["object"]().shape({
    civility: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().required(Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.requiredField')),
    firstName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(20, Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.fieldTooLong', {
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.firstName'),
      maxlength: 20
    })) // regex to validate first / last name - no special characters, only letters, dashes, dots or apostrophs are allowed
    .matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.noSpecialCharsField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.requiredField')),
    lastName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(30, Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.fieldTooLong', {
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.lastName'),
      maxlength: 30
    })) // regex to validate first / last name - no special characters, only letters, dashes, dots or apostrophs are allowed
    .matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.noSpecialCharsField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.requiredField')),
    unicodeFirstName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(100),
    unicodeLastName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(100),
    email: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().email(Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.invalidEmailField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.form.errors.requiredField'))
  });
};
function NewsletterForm() {
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]);
  return __jsx(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, __jsx(_frameworks_grid_row_Grid_row_jsx__WEBPACK_IMPORTED_MODULE_4__[/* GridRow */ "a"], {
    className: "mt-4 md:mt-0",
    hasTopGutters: false
  }, __jsx(_frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__[/* GridCell */ "a"], {
    cols: CELL_GRID_ONE_THIRD
  }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    name: "civility",
    type: "select",
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.civility'),
    options: [{
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.civility'),
      value: '',
      isDisabled: true
    }, {
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('newsletter.signup.civilityMale'),
      value: 'M'
    }, {
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('newsletter.signup.civilityFemale'),
      value: 'F'
    }]
  })), __jsx(_frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__[/* GridCell */ "a"], {
    className: "mt-4 md:mt-0",
    cols: CELL_GRID_ONE_THIRD
  }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    name: "firstName",
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.firstName'),
    type: "text",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.firstName')
  })), __jsx(_frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__[/* GridCell */ "a"], {
    className: "mt-4 md:mt-0",
    cols: CELL_GRID_ONE_THIRD
  }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    name: "lastName",
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.lastName'),
    type: "text",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.lastName')
  }))), appContext.displayUnicodeFields && __jsx(_frameworks_grid_row_Grid_row_jsx__WEBPACK_IMPORTED_MODULE_4__[/* GridRow */ "a"], {
    className: "mt-4",
    hasTopGutters: false
  }, __jsx(_frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__[/* GridCell */ "a"], {
    offsets: CELL_GRID_ONE_THIRD,
    cols: CELL_GRID_ONE_THIRD
  }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    name: "unicodeFirstName",
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.unicodeFirstName'),
    type: "text",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.unicodeFirstName')
  })), __jsx(_frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__[/* GridCell */ "a"], {
    className: "mt-4 md:mt-0",
    cols: CELL_GRID_ONE_THIRD
  }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    name: "unicodeLastName",
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.unicodeLastName'),
    type: "text",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.unicodeLastName')
  }))), __jsx(_frameworks_grid_row_Grid_row_jsx__WEBPACK_IMPORTED_MODULE_4__[/* GridRow */ "a"], {
    className: "mt-4",
    hasTopGutters: false
  }, __jsx(_frameworks_grid_cell_Grid_cell_jsx__WEBPACK_IMPORTED_MODULE_5__[/* GridCell */ "a"], {
    cols: {
      M: 12
    }
  }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    name: "email",
    isRequired: true,
    type: "email",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.email'),
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.email'),
    labelAdditionalInfo: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('memberSpace.profile.additionalInfoEmail')
  }))));
}

/***/ }),

/***/ "9LZ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchBookingEngineI18nQuery; });
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("CcNa");


function fetchBookingEngineI18nQuery(appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].runQuery('', appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* BOOKING_GET_BOOKING_I18N */ "a"],
    queryId: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* BOOKING_GET_BOOKING_I18N */ "a"]
  });
}

/***/ }),

/***/ "9QcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACETING_CHILDCARE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FACETING_CLEAR_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FACETING_PRICES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FACETING_SEARCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FACETING_LOAD_PRODUCTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FACETING_LOAD_OFFSET_SELL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FACETING_SET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FACETING_SET_INITIAL_PRICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FACETING_SET_IS_DATE_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FACETING_SET_IS_SEARCH_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FACETING_SET_KIDS_VALIDATION_STATE; });
/* unused harmony export FACETING_SET_SCROLL_TO_RESULTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FACETING_SET_SEARCH_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FACETING_RESET_REDIRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FACETING_RESET_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FACETING_TOGGLE_FACET_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FACETING_UPDATE_FILTERS; });
var FACETING_CHILDCARE_REQUEST = 'FACETING_CHILDCARE_REQUEST';
var FACETING_CLEAR_FACETS = 'FACETING_CLEAR_FACETS';
var FACETING_PRICES_REQUEST = 'FACETING_PRICES_REQUEST';
var FACETING_SEARCH_REQUEST = 'FACETING_SEARCH_REQUEST';
var FACETING_LOAD_PRODUCTS_REQUEST = 'FACETING_LOAD_PRODUCTS_REQUEST';
var FACETING_LOAD_OFFSET_SELL_REQUEST = 'FACETING_LOAD_OFFSET_SELL_REQUEST';
var FACETING_SET_FILTERS = 'FACETING_SET_FILTERS';
var FACETING_SET_INITIAL_PRICES = 'FACETING_SET_INITIAL_PRICES';
var FACETING_SET_IS_DATE_REQUIRED = 'FACETING_SET_IS_DATE_REQUIRED';
var FACETING_SET_IS_SEARCH_ENABLED = 'FACETING_SET_IS_SEARCH_ENABLED';
var FACETING_SET_KIDS_VALIDATION_STATE = 'FACETING_SET_KIDS_VALIDATION_STATE';
var FACETING_SET_SCROLL_TO_RESULTS = 'FACETING_SCROLL_TO_RESULTS';
var FACETING_SET_SEARCH_QUERY = 'FACETING_SET_SEARCH_QUERY';
var FACETING_RESET_REDIRECTION = 'FACETING_RESET_REDIRECTION';
var FACETING_RESET_SEARCH = 'FACETING_RESET_SEARCH';
var FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_FACET_SELECTED = 'FACETING_TOGGLE_FACET_SELECTED';
var FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON = 'FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON';
var FACETING_UPDATE_FILTERS = 'FACETING_UPDATE_FILTERS';

/***/ }),

/***/ "9sjr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatFooterLabelName; });
var CSS_TRACKING_MAPPING = {
  phoneBubble: 'clickToCall',
  callMeBack: 'webCallBack'
};
function formatFooterLabelName(id) {
  return CSS_TRACKING_MAPPING.hasOwnProperty(id) ? CSS_TRACKING_MAPPING[id] : id;
}

/***/ }),

/***/ "A5Hi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SliderHandler_SliderHandler; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.helper.js
function getIndexInRange(index, max) {
  if (index < 0) {
    return 0;
  }

  return index < max ? index : max;
}
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandlerItems.jsx
var __jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */


// $FlowFixMe
var SliderHandlerItems = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var children = props.children,
      className = props.className,
      hasControls = props.hasControls,
      isSwiping = props.isSwiping,
      itemPercentSize = props.itemPercentSize,
      onSwipeEnd = props.onSwipeEnd,
      onSwipeMove = props.onSwipeMove,
      onSwipeStart = props.onSwipeStart,
      position = props.position;
  return __jsx("div", {
    className: classnames_default()(className, 'overflow-hidden'),
    ref: ref,
    tabIndex: hasControls ? 0 : -1
  }, __jsx("div", {
    className: classnames_default()('flex h-full will-change-transform', {
      'transition-transform': !isSwiping
    }),
    style: {
      transform: "translate(".concat(position, "%, 0)"),
      WebkitTapHighlightColor: 'transparent'
    },
    onTouchStart: onSwipeStart,
    onTouchMove: onSwipeMove,
    onTouchEnd: onSwipeEnd
  }, react["Children"].map(children, function (child, idx) {
    return __jsx("div", {
      "aria-hidden": child.props.ariaHidden,
      className: "max-w-full image-responsive-cell will-change-transform",
      key: idx,
      style: {
        minWidth: "".concat(itemPercentSize, "%"),
        maxWidth: "".concat(itemPercentSize, "%")
      },
      tabIndex: child.props.tabIndex
    }, child);
  })));
});
// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx







var SliderHandler_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var SliderHandler_SliderHandler = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(SliderHandler, _Component);

  var _super = _createSuper(SliderHandler);

  function SliderHandler(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, SliderHandler);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onNext", function (event) {
      if (event) {
        event.preventDefault();
      }

      var _this$state = _this.state,
          maxIndex = _this$state.maxIndex,
          index = _this$state.index;

      var i = index + _this.getStep();

      if (i > maxIndex) {
        i = _this.props.hasInfiniteScroll ? 0 : maxIndex;
      }

      _this.goToIndex(i, _this.props.onNext);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onPrevious", function (event) {
      if (event) {
        event.preventDefault();
      }

      var _this$state2 = _this.state,
          maxIndex = _this$state2.maxIndex,
          index = _this$state2.index;
      var min = 0;

      var i = index - _this.getStep();

      if (i < min) {
        i = _this.props.hasInfiniteScroll ? maxIndex + i + 1 : min;
      }

      _this.goToIndex(i, _this.props.onPrevious);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyUp", function (event) {
      var isRTL = _this.state.isRTL;

      if (_this.props.hasKeyboardSupport) {
        switch (event.which) {
          case keyCodes["c" /* ARROW_RIGHT */]:
            event.stopPropagation();
            isRTL ? _this.onPrevious(event) : _this.onNext(event);
            break;

          case keyCodes["b" /* ARROW_LEFT */]:
            event.stopPropagation();
            isRTL ? _this.onNext(event) : _this.onPrevious(event);
            break;

          default:
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeStart", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        var swipeStart = _this.getSwipeX(event);

        var slideWidth = _this.sliderRef.current ? _this.sliderRef.current.offsetWidth : 0;

        _this.setState(function (_ref) {
          var lastIndex = _ref.lastIndex;
          return {
            slideWidth: slideWidth,
            isSwiping: true,
            swipeStart: swipeStart,
            swipeX: lastIndex,
            swipeStartTime: new Date()
          };
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeMove", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        var x = _this.getSwipeX(event);

        _this.setState(function (prevState) {
          var prevItemsToRender = prevState.itemsToRender,
              lastIndex = prevState.lastIndex,
              swipeStart = prevState.swipeStart,
              slideWidth = prevState.slideWidth,
              maxIndex = prevState.maxIndex,
              isRTL = prevState.isRTL;
          var offset = swipeStart - x;
          var percentageOffset = offset / slideWidth;
          var swipeX = isRTL ? lastIndex - percentageOffset : lastIndex + percentageOffset;
          var index = getIndexInRange(Math.round(swipeX), maxIndex);

          var itemsToRender = _this.getItemsToRender(prevItemsToRender, index, _this.props.nbItemsToShow);

          return _objectSpread({
            swipeX: getIndexInRange(swipeX, maxIndex)
          }, itemsToRender && {
            itemsToRender: itemsToRender
          });
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeEnd", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        _this.setState(function (prevState) {
          var prevItemsToRender = prevState.itemsToRender,
              lastIndex = prevState.lastIndex,
              swipeStartTime = prevState.swipeStartTime,
              swipeX = prevState.swipeX,
              maxIndex = prevState.maxIndex;

          var step = _this.getStep();

          var timeElapsed = new Date().getTime() - swipeStartTime.getTime();
          var offset = lastIndex - swipeX;
          var velocity = Math.round(offset / timeElapsed * 10000);
          var index = Math.round(swipeX);

          if (Math.abs(velocity) > 5) {
            index = velocity < 0 ? lastIndex + step : lastIndex - step;
          }

          var itemsToRender = _this.getItemsToRender(prevItemsToRender, index, _this.props.nbItemsToShow);

          return _objectSpread({
            index: getIndexInRange(index, maxIndex),
            isSwiping: false,
            swipeStart: 0,
            swipeX: 0
          }, itemsToRender && {
            itemsToRender: itemsToRender
          });
        }, function () {
          var _this$state3 = _this.state,
              index = _this$state3.index,
              lastIndex = _this$state3.lastIndex;
          var _this$props = _this.props,
              onPrevious = _this$props.onPrevious,
              onNext = _this$props.onNext;

          if (index < lastIndex && onPrevious) {
            onPrevious();
          } else if (index > lastIndex && onNext) {
            onNext();
          }

          _this.setState(function () {
            return {
              lastIndex: index
            };
          });
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "isItemVisible", function (itemIndex) {
      var index = _this.state.index;
      return itemIndex >= index && itemIndex < index + _this.props.nbItemsToShow;
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "shouldRenderItem", function (itemIndex) {
      return !_this.props.hasLazyload || _this.state.itemsToRender[itemIndex];
    });

    _this.sliderRef = /*#__PURE__*/Object(react["createRef"])();
    _this.state = _this.initState(props);
    return _this;
  }

  Object(createClass["a" /* default */])(SliderHandler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props2 = this.props,
          hasAutoplay = _this$props2.hasAutoplay,
          hasKeyboardSupport = _this$props2.hasKeyboardSupport;

      if (hasKeyboardSupport && this.sliderRef.current) {
        this.sliderRef.current.addEventListener('keyup', this.onKeyUp, false);
      }

      if (hasAutoplay) {
        this.intervalId = setInterval(function () {
          return _this2.onNext();
        }, 3000);
      }

      if (Object(lodash["get"])(document, 'documentElement.dir', 'ltr') === 'rtl') {
        this.setState({
          isRTL: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var hasKeyboardSupport = this.props.hasKeyboardSupport;

      if (hasKeyboardSupport && this.sliderRef.current) {
        this.sliderRef.current.removeEventListener('keyup', this.onKeyUp, false);
      }

      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }
  }, {
    key: "initState",
    value: function initState(props) {
      var hasLazyload = props.hasLazyload,
          initialIndex = props.initialIndex,
          items = props.items,
          nbItemsToShow = props.nbItemsToShow;
      var itemsCount = items.length;
      var maxIndex = itemsCount < nbItemsToShow ? 0 : itemsCount - nbItemsToShow;
      var index = getIndexInRange(initialIndex, maxIndex);
      var initialItemsToRender = Array(itemsCount).fill(!hasLazyload, 0, itemsCount);
      var itemsToRender = this.getItemsToRender(initialItemsToRender, index, nbItemsToShow);
      return {
        index: index,
        isSwiping: false,
        isRTL: false,
        itemsCount: itemsCount,
        itemsToRender: itemsToRender,
        lastIndex: index,
        maxIndex: maxIndex,
        slideWidth: 0,
        swipeStart: 0,
        swipeStartTime: new Date(),
        swipeX: 0
      };
    }
  }, {
    key: "getItemsToRender",
    value: function getItemsToRender(itemsToRender, index, nbItemsToShow) {
      var hasLazyload = this.props.hasLazyload;
      var step = this.getStep();
      var minRange = index - step;
      var maxRange = index + nbItemsToShow + step;
      var newItemToRender = itemsToRender.map(function (isRendered, itemIndex) {
        return isRendered || Object(lodash["inRange"])(itemIndex, minRange, maxRange);
      });

      if (!hasLazyload || itemsToRender.every(function (isRendered) {
        return isRendered;
      }) || Object(lodash["isEqual"])(itemsToRender, newItemToRender)) {
        return itemsToRender;
      }

      return newItemToRender;
    }
  }, {
    key: "getStep",
    value: function getStep() {
      var _this$props$nbItemsTo = this.props.nbItemsToScroll,
          nbItemsToScroll = _this$props$nbItemsTo === void 0 ? 1 : _this$props$nbItemsTo;
      return nbItemsToScroll > 0 ? nbItemsToScroll : 1;
    } // Slide

  }, {
    key: "getItemPosition",
    value: function getItemPosition() {
      var _this$state4 = this.state,
          index = _this$state4.index,
          swipeX = _this$state4.swipeX,
          isSwiping = _this$state4.isSwiping,
          isRTL = _this$state4.isRTL;
      var x = isSwiping ? swipeX : index;
      var posX = x * 100 / this.props.nbItemsToShow;
      return isRTL ? posX : -posX;
    }
  }, {
    key: "goToIndex",
    value: function goToIndex(index) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : lodash["noop"];
      this.setState(function (prevState) {
        var itemsToRender = _this3.getItemsToRender(prevState.itemsToRender, index, _this3.props.nbItemsToShow);

        return {
          index: index,
          itemsToRender: itemsToRender,
          lastIndex: index
        };
      }, callback);
    } // Events handlers

  }, {
    key: "getSwipeX",
    // Swipe
    value: function getSwipeX(event) {
      return event.touches[0].pageX;
    }
  }, {
    key: "isFirstItemVisible",
    value: function isFirstItemVisible() {
      return this.isItemVisible(0);
    }
  }, {
    key: "isLastItemVisible",
    value: function isLastItemVisible() {
      var itemsCount = this.state.itemsCount;
      return this.isItemVisible(itemsCount - 1);
    }
  }, {
    key: "hasControls",
    value: function hasControls() {
      return this.state.itemsCount > this.props.nbItemsToShow;
    }
  }, {
    key: "render",
    // render
    value: function render() {
      var _this4 = this;

      var _this$state5 = this.state,
          index = _this$state5.index,
          isSwiping = _this$state5.isSwiping,
          itemsCount = _this$state5.itemsCount;
      if (!itemsCount) return null;
      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          hasInfiniteScroll = _this$props3.hasInfiniteScroll,
          items = _this$props3.items,
          nbItemsToShow = _this$props3.nbItemsToShow;
      var hasControls = this.hasControls();

      var itemsNode = SliderHandler_jsx(SliderHandlerItems, {
        className: className,
        hasControls: hasControls,
        isSwiping: isSwiping,
        itemPercentSize: 100 / nbItemsToShow,
        onSwipeEnd: this.onSwipeEnd,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        position: this.getItemPosition(),
        ref: this.sliderRef
      }, items.map(function (item, idx) {
        return _this4.shouldRenderItem(idx) ? /*#__PURE__*/Object(react["cloneElement"])(item, {
          ariaHidden: !_this4.isItemVisible(idx),
          tabIndex: -1
        }) : null;
      }).filter(Boolean));

      var childrenProps = {
        hasControls: hasControls,
        index: index,
        isNextControlDisabled: !hasInfiniteScroll && this.isLastItemVisible(),
        isPreviousControlDisabled: !hasInfiniteScroll && this.isFirstItemVisible(),
        itemsNode: itemsNode,
        onNext: this.onNext,
        onPrevious: this.onPrevious
      };
      return children(childrenProps);
    }
  }]);

  return SliderHandler;
}(react["Component"]);

Object(defineProperty["a" /* default */])(SliderHandler_SliderHandler, "defaultProps", {
  initialIndex: 0,
  nbItemsToScroll: 1,
  nbItemsToShow: 1
});

/***/ }),

/***/ "A90E":
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__("6sVZ"),
    nativeKeys = __webpack_require__("V6Ve");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "AbLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return usePrevious; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var usePrevious = function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(); // Store current value in ref

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)

  return ref.current;
};

/***/ }),

/***/ "B3yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keywordsSelector; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var searchSelector = function searchSelector(_ref) {
  var search = _ref.search;
  return search || {};
};

var querySelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(searchSelector, function (_ref2) {
  var query = _ref2.query;
  return query || {};
});
var keywordsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(querySelector, function (_ref3) {
  var keywords = _ref3.keywords;
  return keywords;
});


/***/ }),

/***/ "B8du":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "BRr/":
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__("ZLJe")),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__("8PLQ")),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj){
	return Object.keys(obj).sort().reduce(function(inverse, name){
		inverse[obj[name]] = "&" + name + ";";
		return inverse;
	}, {});
}

function getInverseReplacer(inverse){
	var single = [],
	    multiple = [];

	Object.keys(inverse).forEach(function(k){
		if(k.length === 1){
			single.push("\\" + k);
		} else {
			multiple.push(k);
		}
	});

	//TODO add ranges
	multiple.unshift("[" + single.join("") + "]");

	return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c){
	return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
}

function astralReplacer(c){
	// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	var high = c.charCodeAt(0);
	var low  = c.charCodeAt(1);
	var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
	return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re){
	function func(name){
		return inverse[name];
	}

	return function(data){
		return data
				.replace(re, func)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	};
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data){
	return data
			.replace(re_xmlChars, singleCharReplacer)
			.replace(re_astralSymbols, astralReplacer)
			.replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),

/***/ "BYx+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return profileFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commonProfileFieldsFragment; });
/* harmony import */ var _address_form_AddressForm_fragment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("tJAy");

var profileFragment = "\n  fragment BookingProfile on Profile {\n    optinEmail\n    optinSms\n    optinPhone\n    optinMail\n    optinClubmedPlus\n    address {\n      ...Address\n    }\n    passport{\n      issuingDate\n      expirationDate\n      nationality\n      documentNumber\n    }\n   dateOfBirth\n   civility\n   mobilePhoneNumber\n  }\n  ".concat(_address_form_AddressForm_fragment__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"], "\n");
/**
 * Common fields between adults and children
 * customerId is used as temp id, till being override by real proposal attendees id
 * see addSearchDataToAttendees
 *  */

var commonProfileFieldsFragment = "\n  fragment CommonProfileFields on Profile {\n    birthdate:dateOfBirth\n    civility\n    firstName\n    gmNumber\n    id:customerId \n    lastName\n    neolid:customerId\n    unicodeFirstName\n    unicodeLastName\n  }\n";


/***/ }),

/***/ "Bcqe":
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__("RNvQ"),
    isObject = __webpack_require__("tQYX");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ "BiGR":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("nmnc"),
    isArguments = __webpack_require__("03A+"),
    isArray = __webpack_require__("Z0cm");

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ "C5R2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDuration; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _duration_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("RBvG");


function setDuration(value) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_duration_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DURATION */ "c"], {
    value: value
  });
}

/***/ }),

/***/ "C9cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProductBadgeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getServiceAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getServiceAgesLabelTranslateOptions; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");


var IS_DISABLED = 'isDisabled';
var IS_ENABLED = 'isEnabled';
var IS_SELECTED = 'isSelected';

var getProductBadgeIcon = function getProductBadgeIcon(_ref) {
  var badgeIcon = _ref.badgeIcon,
      color = _ref.color,
      comfortLabel = _ref.comfortLabel;
  return {
    alt: comfortLabel || '',
    color: _color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    colorBg: color,
    colorBorder: color,
    iconName: badgeIcon
  };
};

function getServiceAgesLabel(ageInMonths, i18n) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["messageFormat"])(i18n.booking.services.childcare.kidsAgeInYears).format({
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    });
  }

  if (min < 23 && max && max > 23) {
    return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["messageFormat"])(i18n.booking.services.childcare.kidsAgeInMonthsAndYears).format({
      min: min,
      max: Math.floor(max / 12)
    });
  }

  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["messageFormat"])(i18n.booking.services.childcare.kidsAgeInMonths).format({
    min: min,
    max: max
  });
}

function getServiceAgesLabelTranslateOptions(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return ['booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    }];
  }

  if (min < 23 && max && max > 23) {
    return ['booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    }];
  }

  return ['booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  }];
}



/***/ }),

/***/ "CDVU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_CUSTOMER_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_CUSTOMER_REJECTED; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);

var FETCH_CUSTOMER = 'FETCH_CUSTOMER';
var FETCH_CUSTOMER_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_CUSTOMER);
var FETCH_CUSTOMER_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_CUSTOMER);

/***/ }),

/***/ "CH3K":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "CMye":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("GoyQ");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ "CZoQ":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "Crz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9OUN");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var redux_thunk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("V8Kl");
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("igjW");
/* harmony import */ var _middlewares_authenticationMiddleware__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("u9tP");
/* harmony import */ var _rootReducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("v315");









function getReduxMiddlewares() {
  return [redux_thunk__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3___default()(), Object(_middlewares_authenticationMiddleware__WEBPACK_IMPORTED_MODULE_6__[/* createAuthenticationMiddleware */ "a"])()];
}

function init(initialState) {
  var enhancer = Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_5__[/* isStrictlyDevelopmentEnv */ "d"])(_config__WEBPACK_IMPORTED_MODULE_1___default.a) ? global.window && global.window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux__WEBPACK_IMPORTED_MODULE_2__[/* compose */ "d"] : redux__WEBPACK_IMPORTED_MODULE_2__[/* compose */ "d"];
  return Object(redux__WEBPACK_IMPORTED_MODULE_2__[/* createStore */ "e"])(_rootReducer__WEBPACK_IMPORTED_MODULE_7__[/* rootReducer */ "a"], initialState, enhancer(redux__WEBPACK_IMPORTED_MODULE_2__[/* applyMiddleware */ "a"].apply(void 0, Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(getReduxMiddlewares()))));
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "CwJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterAccommodations; });
/* unused harmony export sortAccommodations */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("lZ21");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




function sortAccommodations(accommodationsSets) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["sortBy"])(accommodationsSets, function (set) {
    // sort accommodations by comfort level: Standard, Deluxe, Suite
    return _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_2__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(set, 'accommodations[0].categoryId'));
  }).map(function (set, index) {
    // accommodationSetNumber was set to index + 1 in accommodationsSetsReducer
    // need to be updated after filtering & sorting
    return _objectSpread(_objectSpread({}, set), {}, {
      accommodationSetNumber: index + 1
    });
  });
}

function filterAccommodations(proposal, accommodationsSets) {
  var proposalAccommodations = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(proposal, 'accommodations', []); // remove additional accommodation if already exists in selected proposal

  var filteredAccommodations = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["reject"])(accommodationsSets, function (_ref) {
    var accommodations = _ref.accommodations;
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEqual"])(accommodations, proposalAccommodations);
  }); // sort additional accommodations by comfort level: Standard, Deluxe, Suite

  return sortAccommodations(filteredAccommodations);
}



/***/ }),

/***/ "DQFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSlideShow; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("u/u4");
/* harmony import */ var _arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Gy6l");
/* harmony import */ var _backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("NZxu");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("0IQ5");
/* harmony import */ var _slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("A5Hi");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;







var ImageSlideShow = function ImageSlideShow(_ref) {
  var className = _ref.className,
      closeLabel = _ref.closeLabel,
      galleryLabel = _ref.galleryLabel,
      _ref$groupKey = _ref.groupKey,
      groupKey = _ref$groupKey === void 0 ? 'thumbnails' : _ref$groupKey,
      hasControlsOnHover = _ref.hasControlsOnHover,
      hasFullScreenMode = _ref.hasFullScreenMode,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      hasInsetBorder = _ref.hasInsetBorder,
      hasLazyLoading = _ref.hasLazyLoading,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].XL : _ref$ratio;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false),
      isFullScreen = _useState[0],
      setIsFullScreen = _useState[1];

  if (!media.length) {
    return null;
  }

  var gk = hasFullScreenMode ? null : groupKey;
  var ItemTagName = hasFullScreenMode ? 'button' : 'div';
  var itemProps = hasFullScreenMode ? {
    className: 'reset-button block w-full',
    onClick: function onClick() {
      return setIsFullScreen(true);
    },
    type: 'button'
  } : null;
  var items = media.map(function (_ref2) {
    var _ref2$alt = _ref2.alt,
        alt = _ref2$alt === void 0 ? '' : _ref2$alt,
        src = _ref2.src;
    return src ? __jsx(ItemTagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
      key: src
    }, itemProps), __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"], {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
        'inset-border-after': hasInsetBorder
      }),
      altMsg: alt,
      groupKey: gk,
      hasLazyLoading: hasLazyLoading,
      imageUrl: src,
      key: src,
      ratioKey: ratio
    })) : null;
  }).filter(Boolean);
  return __jsx(_slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_7__[/* SliderHandler */ "a"], {
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items
  }, function (_ref3) {
    var hasControls = _ref3.hasControls,
        isNextControlDisabled = _ref3.isNextControlDisabled,
        isPreviousControlDisabled = _ref3.isPreviousControlDisabled,
        itemsNode = _ref3.itemsNode,
        onNext = _ref3.onNext,
        onPrevious = _ref3.onPrevious;
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'group relative')
    }, itemsNode, hasControls && __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('transition-opacity will-change-transform absolute flex items-center justify-between max-w-site m-auto inset-0 pointer-events-none px-3 sm:px-5 w-full z-2', {
        'group-hover:opacity-100 opacity-0': hasControlsOnHover
      }),
      "data-testid": "ImageSlideShow-controls-parent"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__[/* ArrowButton */ "a"], {
      className: "rtl:mr-auto pointer-events-auto shadow-sm z-2",
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__[/* ArrowButton */ "a"], {
      className: "rtl:ml-auto pointer-events-auto shadow-sm z-2",
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })), hasFullScreenMode && isFullScreen && __jsx(_backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_5__[/* Backdrop */ "a"], {
      ariaLabel: galleryLabel,
      closeLabel: closeLabel,
      hasCloseButton: true,
      onClose: function onClose() {
        return setIsFullScreen(false);
      }
    }, __jsx("div", {
      className: "relative w-full"
    }, itemsNode, hasControls && __jsx("div", {
      className: "absolute flex items-center justify-between m-auto inset-0 pointer-events-none px-3 sm:px-5 w-full"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__[/* ArrowButton */ "a"], {
      className: "rtl:mr-auto pointer-events-auto shadow-sm z-2",
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_4__[/* ArrowButton */ "a"], {
      className: "rtl:ml-auto pointer-events-auto shadow-sm z-2",
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })))));
  });
};

/***/ }),

/***/ "DSRE":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("Kz5y"),
    stubFalse = __webpack_require__("B8du");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("EIeC")(module)))

/***/ }),

/***/ "E+oP":
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__("A90E"),
    getTag = __webpack_require__("QqLw"),
    isArguments = __webpack_require__("03A+"),
    isArray = __webpack_require__("Z0cm"),
    isArrayLike = __webpack_require__("MMmD"),
    isBuffer = __webpack_require__("DSRE"),
    isPrototype = __webpack_require__("6sVZ"),
    isTypedArray = __webpack_require__("c6wG");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ "E3ZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CUSTOMER_SEARCH_RESULT; });
/* unused harmony export UNSET_CUSTOMER_SEARCH_RESULT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customerSearch; });
var SET_CUSTOMER_SEARCH_RESULT = 'SET_CUSTOMER_SEARCH_RESULT';
var UNSET_CUSTOMER_SEARCH_RESULT = 'UNSET_CUSTOMER_SEARCH_RESULT';
var initialState = {};
var customerSearch = function customerSearch() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_CUSTOMER_SEARCH_RESULT:
      return action.payload;

    case UNSET_CUSTOMER_SEARCH_RESULT:
      return initialState;

    default:
      return state;
  }
};

/***/ }),

/***/ "EA7m":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("zZ0H"),
    overRest = __webpack_require__("Ioao"),
    setToString = __webpack_require__("wclG");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "EEuM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userInfoWrapper; });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("uDfI");
/* harmony import */ var _userInfo_selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("apzf");


var connector = Object(react_redux__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "c"])(function (state) {
  return {
    userInfo: Object(_userInfo_selectors__WEBPACK_IMPORTED_MODULE_1__[/* userInfoSelector */ "a"])(state)
  };
});
function userInfoWrapper(ComponentToWrap) {
  return connector(ComponentToWrap);
}

/***/ }),

/***/ "ELg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductFlag_ProductFlag; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 10 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx + 4 modules
var ProductPriceModal = __webpack_require__("yfdt");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.themes.js
var themes = {
  thumbnail: {
    thPriceFrom: 'font-sans text-sm sm:text-base text-gray-darker px-1',
    thPriceTheme: 'thumbnail'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx

var __jsx = react_default.a.createElement;






var ProductFlag_ProductFlag = function ProductFlag(_ref) {
  var _ref$isLinkDisabled = _ref.isLinkDisabled,
      isLinkDisabled = _ref$isLinkDisabled === void 0 ? false : _ref$isLinkDisabled,
      _ref$isPriceLoading = _ref.isPriceLoading,
      isPriceLoading = _ref$isPriceLoading === void 0 ? false : _ref$isPriceLoading,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? lodash["noop"] : _ref$onClick,
      _ref$onCtaClick = _ref.onCtaClick,
      onCtaClick = _ref$onCtaClick === void 0 ? lodash["noop"] : _ref$onCtaClick,
      _ref$onEmptyPriceClic = _ref.onEmptyPriceClick,
      onEmptyPriceClick = _ref$onEmptyPriceClic === void 0 ? lodash["noop"] : _ref$onEmptyPriceClic,
      _ref$onPriceClick = _ref.onPriceClick,
      onPriceClick = _ref$onPriceClick === void 0 ? lodash["noop"] : _ref$onPriceClick,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? {} : _ref$price,
      _ref$priceInfo = _ref.priceInfo,
      priceInfo = _ref$priceInfo === void 0 ? {} : _ref$priceInfo,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'thumbnail' : _ref$theme;

  if (Object(lodash["isEmpty"])(price)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thPriceFrom = _themes$theme.thPriceFrom,
      thPriceTheme = _themes$theme.thPriceTheme;
  var hasPrice = !isPriceLoading && (!!price.initialPrice || !!price.bestPrice);

  var handleEmptyPriceClick = function handleEmptyPriceClick() {
    onEmptyPriceClick && onEmptyPriceClick();

    if (!isLinkDisabled) {
      onClick && onClick();
    }
  };

  var handlePriceClick = function handlePriceClick() {
    onPriceClick && onPriceClick();
  };

  var handleProductPriceModalOnClickButton = function handleProductPriceModalOnClickButton() {
    onCtaClick && onCtaClick();
    onClick && onClick();
  };

  var priceNode = __jsx("span", {
    className: "flex items-center justify-end w-full"
  }, Object(price_util["d" /* hasAtLeastOnePrice */])(price) && __jsx("span", {
    className: thPriceFrom
  }, price.from), __jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({}, price, {
    className: "flex items-center h-full rounded-tiny",
    "data-testid": "ProductFlag-price",
    from: null,
    isLoading: isPriceLoading,
    onClick: hasPrice ? handlePriceClick : handleEmptyPriceClick,
    theme: thPriceTheme
  })));

  return hasPrice ? __jsx(ProductPriceModal["a" /* ProductPriceModal */], Object(esm_extends["a" /* default */])({
    className: "m-px5 z-2"
  }, priceInfo, {
    onClickButton: handleProductPriceModalOnClickButton
  }), priceNode) : priceNode;
};

/***/ }),

/***/ "ENE1":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("IBsm");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "EvYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Modal_Modal; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/modal/Modal.themes.js
var MAX_HEIGHT = '70vh';
var sizes = {
  auto: 'auto',
  small: '23.75rem',
  medium: '40rem',
  large: '50rem'
};
var themes = function themes(_ref) {
  var size = _ref.size;
  return {
    "default": {
      thRoot: 'fadeIn flex relative scaleIn',
      thRootStyles: {
        width: sizes[size],
        maxWidth: '100%',
        maxHeight: MAX_HEIGHT,
        minHeight: 100
      },
      thCloseButton: 'absolute bg-white border-1 cursor-pointer leading-none top-0 mb-px10 rtl:right-0 p-px5 reset-button rounded-full z-1',
      thCloseButtonLabel: 'sr-only',
      thCloseButtonStyles: {
        top: 'auto',
        bottom: '100%',
        width: 40,
        height: 40
      },
      thBody: 'bg-white max-h-full relative overflow-hidden rounded-tiny shadow w-full',
      thBodyStyles: {
        maxHeight: MAX_HEIGHT
      },
      // ⚠️ relative is only needed to prevent a weird bug of reflow on chrome
      thContent: 'max-h-full overflow-auto relative w-full'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/modal/Modal.jsx
var __jsx = react_default.a.createElement;






var Modal_Modal = function Modal(_ref) {
  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      backdropColor = _ref.backdropColor,
      backdropOpacity = _ref.backdropOpacity,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      id = _ref.id,
      onClose = _ref.onClose,
      portalName = _ref.portalName,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var modalButtonRef = Object(react["useRef"])();
  var closeBtnModal = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  Object(react["useEffect"])(function () {
    modalButtonRef.current && modalButtonRef.current.focus();
  }, []);
  var _themes$theme = themes({
    size: size
  })[theme],
      thBody = _themes$theme.thBody,
      thBodyStyles = _themes$theme.thBodyStyles,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thCloseButtonStyles = _themes$theme.thCloseButtonStyles,
      thCloseIconWidth = _themes$theme.thCloseIconWidth,
      thContent = _themes$theme.thContent,
      thRoot = _themes$theme.thRoot,
      thRootStyles = _themes$theme.thRootStyles;
  return __jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: ariaLabel,
    ariaLabelledby: ariaLabelledby,
    bgColor: backdropColor,
    onClose: onClose,
    opacity: backdropOpacity,
    portalName: portalName
  }, __jsx("aside", {
    className: thRoot,
    id: id,
    style: thRootStyles
  }, __jsx("button", {
    className: thCloseButton,
    "data-testid": "Modal-close",
    onClick: onClose,
    ref: modalButtonRef,
    style: thCloseButtonStyles,
    type: "button"
  }, closeBtnModal && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnModal), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), __jsx("div", {
    className: thBody,
    style: thBodyStyles
  }, __jsx("div", {
    className: classnames_default()(className, thContent)
  }, children))));
};

/***/ }),

/***/ "FcTP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CRITERIA_LIST; });
/* unused harmony export UNSET_CRITERIA_LIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return criteriaListReducer; });
var SET_CRITERIA_LIST = 'SET_CRITERIA_LIST';
var UNSET_CRITERIA_LIST = 'UNSET_CRITERIA_LIST';
var initialState = [];
var criteriaListReducer = function criteriaListReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_CRITERIA_LIST:
      return action.payload;

    case UNSET_CRITERIA_LIST:
      return initialState;

    default:
      return state;
  }
};

/***/ }),

/***/ "Fe0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return grid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateProductLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateLinkProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return localeHasCmtaLinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateCmtaLinkProp; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("igjW");



var grid = {
  mobile: 1,
  phablet: 2,
  tablet: 3,
  desktop: 3
};
var generateProductLink = function generateProductLink(url, offer) {
  var newLink = offer && offer.seoName ? new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(url).addSearch(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["appQueryParameters"].shopping.offer, _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["url"].normalizeSlug(offer.seoName)).toString() : url;
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["url"].normalizeUrl(newLink);
};
var generateLinkProp = function generateLinkProp(url, offer) {
  return url ? {
    url: generateProductLink(url, offer),
    queryParamsToIgnore: offer ? [] : ['offer']
  } : undefined;
};
var localeHasCmtaLinks = function localeHasCmtaLinks(cmtaLinks) {
  return cmtaLinks && cmtaLinks.cmtaIntegLink && cmtaLinks.cmtaStagingLink && cmtaLinks.cmtaProdLink;
};
var generateCmtaLinkProp = function generateCmtaLinkProp(resortId, cmtaLinks) {
  var cmtaIntegLink = cmtaLinks.cmtaIntegLink,
      cmtaStagingLink = cmtaLinks.cmtaStagingLink,
      cmtaProdLink = cmtaLinks.cmtaProdLink;
  var cmtaUrl = cmtaProdLink;

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_2__[/* isStrictlyIntegrationEnv */ "e"])()) {
    cmtaUrl = cmtaIntegLink;
  }

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_2__[/* isStrictlyStagingEnv */ "g"])()) {
    cmtaUrl = cmtaStagingLink;
  }

  return {
    url: cmtaUrl + resortId,
    isExternalLink: true
  };
};

/***/ }),

/***/ "Fk4B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTotalDifferentialPrice; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("E+oP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("mwIZ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("xweI");
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_sortBy__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_unionWith__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("VD47");
/* harmony import */ var lodash_unionWith__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_unionWith__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("04nu");
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("wz9x");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var getTotalDifferentialPrice = function getTotalDifferentialPrice() {
  var price1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var price2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var locale = arguments.length > 2 ? arguments[2] : undefined;
  var diff = price1 - price2;
  return {
    value: diff,
    formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__[/* formatAmountForLocale */ "b"])(diff, locale)
  };
};
var sortPath = 'inbound.transportInfo.price.value';

var updateAlternativeTransports = function updateAlternativeTransports(_ref) {
  var selectedTransportId = _ref.selectedTransportId,
      state = _ref.state; // we do not change this value to keep track of the proposal's selected transport

  var proposalTransport = _objectSpread({}, state.proposalTransport); // fetched Alternative transports from api


  var previousAlternativeTransports = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(state.alternativeTransports); // current selected which also is the first recommended


  var currentSelectedTransport = _objectSpread({}, state.selectedTransport); // searching by id


  var selectedInboundInAlternative = previousAlternativeTransports.find(function (_ref2) {
    var inbound = _ref2.inbound;
    return inbound.transportInfo.id === selectedTransportId;
  }); // if it's not an alternative then we have selected the current selected (in the right)

  var newSelectedTransport = selectedInboundInAlternative || currentSelectedTransport;
  var proposalInAlternative = false;
  var currenAlternativeTransports = previousAlternativeTransports.map(function (_ref3) {
    var inbound = _ref3.inbound,
        outboundList = _ref3.outboundList,
        transportNumber = _ref3.transportNumber;

    if (Object(_additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* isSameJourney */ "m"])(inbound, proposalTransport.inbound)) {
      proposalInAlternative = true; // the same selected recommended and alternative should have the same outboundlist

      var sameOutboundList = lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default()(lodash_unionWith__WEBPACK_IMPORTED_MODULE_5___default()(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(proposalTransport.outboundList), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(outboundList), _additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* isSameJourney */ "m"]), sortPath); // if the proposal's transport was selected && there's a similar inbound in alternative transports

      if (Object(_additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* isSameJourney */ "m"])(proposalTransport.inbound, newSelectedTransport.inbound)) {
        newSelectedTransport.outboundList = sameOutboundList;
      }

      return {
        inbound: inbound,
        outboundList: sameOutboundList,
        transportNumber: transportNumber
      };
    }

    return {
      inbound: inbound,
      outboundList: outboundList,
      transportNumber: transportNumber
    };
  });

  if (!proposalInAlternative && proposalTransport.inbound.transportInfo.id !== newSelectedTransport.inbound.transportInfo.id) {
    // after selecting an inbound, if the proposal's transport is not in the list we should add it to be able to find it afterwards
    currenAlternativeTransports.push(proposalTransport);
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    // keep selectedTransportId in redux store
    selectedTransportId: selectedTransportId,
    selectedTransport: newSelectedTransport,
    alternativeTransports: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default()(currenAlternativeTransports, sortPath))
  });
};

var initialState = {
  alternativeTransports: [],
  selectedTransport: {}
};

var hasAvailabilityCheckedWithAmadeus = function hasAvailabilityCheckedWithAmadeus(transport) {
  return (// the flight class should always be present, even for clubmed charter for which we have almost no data
    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(transport, 'inbound.journey.travelSections.0.transport.class'))
  );
};

function transportsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(action, 'type')) {
    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_6__["resolve"])(_additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* FETCH_ADDITIONAL_TRANSPORTS */ "d"]):
      var _action$payload = action.payload,
          additionalTransports = _action$payload.additionalTransports,
          selectedTransport = _action$payload.selectedTransport;
      var alternativeTransports = lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default()(additionalTransports.filter(hasAvailabilityCheckedWithAmadeus), sortPath).map(function (transport, index) {
        return _objectSpread(_objectSpread({}, transport), {}, {
          transportNumber: index + 1
        });
      });
      return {
        selectedTransport: selectedTransport,
        proposalTransport: selectedTransport,
        alternativeTransports: alternativeTransports
      };

    case _additionalTransports_action__WEBPACK_IMPORTED_MODULE_7__[/* UPDATE_SELECTED_TRANSPORT */ "j"]:
      var selectedTransportId = action.payload.selectedTransportId;
      return updateAlternativeTransports({
        selectedTransportId: selectedTransportId,
        state: state
      });

    default:
      return state;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (transportsReducer);

/***/ }),

/***/ "FtaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sendTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useAbTasty; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _router_useRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7jla");
/* harmony import */ var _third_party_thirdParty_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kD1E");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ub5k");





var sendTransaction = function sendTransaction(_ref) {
  var id = _ref.id,
      affiliation = _ref.affiliation,
      revenue = _ref.revenue,
      currency = _ref.currency;
  var timeLimit = moment__WEBPACK_IMPORTED_MODULE_0___default()().add(5, 's');
  var waiter = setInterval(function () {
    var _window, _window$abtasty;

    if ((_window = window) === null || _window === void 0 ? void 0 : (_window$abtasty = _window.abtasty) === null || _window$abtasty === void 0 ? void 0 : _window$abtasty.send) {
      window.abtasty.send('transaction', {
        tid: id,
        // Transaction ID
        ta: affiliation,
        // Transaction Affiliation
        tr: revenue,
        // Transaction Revenue
        tc: currency // Transaction Currency

      });
      clearInterval(waiter);
    } else if (moment__WEBPACK_IMPORTED_MODULE_0___default()().isAfter(timeLimit)) {
      // clear after Maximum 5s, we assume that it should be there by then
      clearInterval(waiter);
    }
  }, 100);
};
var useAbTasty = function useAbTasty() {
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]);

  var _useRouter = Object(_router_useRouter__WEBPACK_IMPORTED_MODULE_2__[/* useRouter */ "a"])(),
      queryParams = _useRouter.location.queryParams;

  var tracking = Object(_third_party_thirdParty_utils__WEBPACK_IMPORTED_MODULE_3__[/* getConfigWithNoThirdPartySupport */ "a"])({
    locale: appContext.locale,
    name: 'tracking',
    queryParams: queryParams
  });
  var abTastyId = tracking.abtasty.id;

  if (appContext.isCmta) {
    abTastyId = tracking.abtasty.cmta.id;
  } else if (appContext.isDirectCxo || appContext.isIndirectCxo) {
    abTastyId = tracking.abtasty.cxo.id;
  }

  var isAbTastyActive = tracking && tracking.enabled && tracking.abtasty && tracking.abtasty.enabled && tracking.abtasty.host && !!abTastyId;
  var abTastyScriptUrl = isAbTastyActive ? "https://".concat(tracking.abtasty.host, "/").concat(abTastyId, ".js") : '';
  return {
    abTastyScriptUrl: abTastyScriptUrl,
    isAbTastyActive: isAbTastyActive
  };
};

/***/ }),

/***/ "GDhZ":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("wF/u"),
    get = __webpack_require__("mwIZ"),
    hasIn = __webpack_require__("hgQt"),
    isKey = __webpack_require__("9ggG"),
    isStrictComparable = __webpack_require__("CMye"),
    matchesStrictComparable = __webpack_require__("IOzZ"),
    toKey = __webpack_require__("9Nap");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ "GJxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "listen", function() { return /* binding */ index_es_listen; });
__webpack_require__.d(__webpack_exports__, "subscribe", function() { return /* binding */ index_es_subscribe; });
__webpack_require__.d(__webpack_exports__, "unsubscribe", function() { return /* binding */ index_es_unsubscribe; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/lodash/assign.js
var lodash_assign = __webpack_require__("whR3");
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__("Gpi5");
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);

// CONCATENATED MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/subscribe-ui-event/dist-es/lib/supportPassiveEvent.js
/* global window */

var passiveSupported = false; // eslint-disable-line import/no-mutable-exports

if (typeof window !== 'undefined') {
  try {
    var supportPassiveEvent_options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', null, supportPassiveEvent_options);
  } catch (err) {} // eslint-disable-line no-empty
}

/* harmony default export */ var supportPassiveEvent = (passiveSupported);

// CONCATENATED MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/subscribe-ui-event/dist-es/globalVars.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




/* harmony default export */ var globalVars = ({
  connections: {},
  EE: new eventemitter3_default.a(),
  enableResizeInfo: false,
  enableScrollInfo: false,
  listeners: {},
  removers: [],
  supportPassiveEvent: supportPassiveEvent
});

// CONCATENATED MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/subscribe-ui-event/dist-es/lib/listen.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




var listen_supportPassiveEvent = globalVars.supportPassiveEvent;


var defaultEventOption = {
  capture: false,
  passive: false
};

/**
 * Cross-browser addEventListener.
 * @method listen
 * @param {Object} target - The target to add event listener.
 * @param {String} eventType - The event type.
 * @param {Function} handler - The event handler.
 * @param {Object} handler - The options object that specifies
 * characteristics about the event listener.
 * @return {Object} The object to be able to remove the handler.
 */
function listen(target, eventType, handler, options) {
  var add = 'addEventListener';
  var _remove = 'removeEventListener';
  var type = eventType;

  var eventOptions = listen_supportPassiveEvent ? assign_default()({}, defaultEventOption, options) : false;

  if (!target.addEventListener && target.attachEvent) {
    add = 'attachEvent';
    _remove = 'detachEvent';
    type = 'on' + eventType;
  }
  target[add](type, handler, eventOptions);

  return {
    remove: function remove() {
      target[_remove](eventType, handler);
    }
  };
}

/* harmony default export */ var lib_listen = (listen);

// CONCATENATED MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/subscribe-ui-event/dist-es/lib/leIE8.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global navigator, parseFloat */

// less then or equal to IE8
var leIE8 = false; // eslint-disable-line import/no-mutable-exports

if (typeof navigator !== 'undefined') {
  var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
  if (matches) {
    leIE8 = parseFloat(matches[1], 10) < 9;
  }
}

/* harmony default export */ var lib_leIE8 = (leIE8);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/lodash/clone.js
var clone = __webpack_require__("zr3P");
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/lodash/throttle.js
var lodash_throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// CONCATENATED MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/subscribe-ui-event/dist-es/AugmentedEvent.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var resize = { // eslint-disable-line prefer-const
  width: 0,
  height: 0
};
var AugmentedEvent_scroll = { // eslint-disable-line prefer-const
  delta: 0,
  top: 0
};
var touch = { // eslint-disable-line prefer-const
  axisIntention: '',
  startX: 0,
  startY: 0,
  deltaX: 0,
  deltaY: 0
};

var INTENTION_THRESHOLD = 5;

var getXY = function getXY(pos) {
  var t = { x: 0, y: 0 }; // eslint-disable-line prefer-const
  var docBody = document.body;
  var docEl = document.documentElement;

  if (pos.pageX || pos.pageY) {
    t.x = pos.pageX;
    t.y = pos.pageY;
  } else {
    t.x = pos.clientX + docBody.scrollLeft + docEl.scrollLeft;
    t.y = pos.clientY + docBody.scrollTop + docEl.scrollTop;
  }

  return t;
};

/**
 * ArgmentedEvent will hold some global information, such like window scroll postion,
 * so that those information is only calculated once.
 * @param {Object} option - The option for SyntheticEvent
 */

var AugmentedEvent_AugmentedEvent = function () {
  function AugmentedEvent() {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AugmentedEvent);

    var mainType = (option.mainType || '').toLowerCase();
    var subType = (option.subType || '').toLowerCase();

    this.mainType = mainType;
    this.subType = subType;
    this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
    this.scroll = AugmentedEvent_scroll;
    this.resize = resize;
    this.touch = touch;
  }

  _createClass(AugmentedEvent, [{
    key: 'update',
    value: function update(e) {
      var mainType = this.mainType,
          subType = this.subType;

      var docEl = document.documentElement;

      if (globalVars.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
        var top = docEl.scrollTop + document.body.scrollTop;
        // Prevent delta from being 0
        if (top !== this.scroll.top) {
          this.scroll.delta = top - this.scroll.top;
          this.scroll.top = top;
        }
      }
      if (globalVars.enableResizeInfo && mainType === 'resize') {
        this.resize.width = window.innerWidth || docEl.clientWidth;
        this.resize.height = window.innerHeight || docEl.clientHeight;
      }
      if (globalVars.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
        var pos = void 0;
        var absX = void 0;
        var absY = void 0;
        if (mainType === 'touchstart' || subType === 'start') {
          pos = getXY(e.touches[0]);
          this.touch.axisIntention = '';
          this.touch.startX = pos.x;
          this.touch.startY = pos.y;
          this.touch.deltaX = 0;
          this.touch.deltaY = 0;
        } else if (mainType === 'touchmove') {
          pos = getXY(e.touches[0]);
          this.touch.deltaX = pos.x - this.touch.startX;
          this.touch.deltaY = pos.y - this.touch.startY;
          if (this.touch.axisIntention === '') {
            absX = Math.abs(this.touch.deltaX);
            absY = Math.abs(this.touch.deltaY);
            if (absX > INTENTION_THRESHOLD && absX >= absY) {
              this.touch.axisIntention = 'x';
            } else if (absY > INTENTION_THRESHOLD && absY > absX) {
              this.touch.axisIntention = 'y';
            }
          }
        }
      }
    }
  }]);

  return AugmentedEvent;
}();

/* harmony default export */ var dist_es_AugmentedEvent = (AugmentedEvent_AugmentedEvent);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/raf/index.js
var raf = __webpack_require__("0xii");
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// CONCATENATED MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/subscribe-ui-event/dist-es/lib/rAFThrottle.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var getTime = Date.now ||
/* istanbul ignore next */function () {
  return new Date().getTime();
};

function rAFThrottle(func) {
  var throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;

  var context = void 0;
  var args = void 0;
  var last = 0;
  var requestId = 0;

  var later = function later() {
    var now = getTime();
    var remaining = throttle - (now - last);

    if (remaining <= 0) {
      last = now;
      requestId = 0;
      func.apply(context, args);
    } else {
      requestId = raf_default()(later);
    }
  };

  return function throttledFunc() {
    context = this;
    args = arguments; // eslint-disable-line prefer-rest-params

    if (!requestId) {
      requestId = raf_default()(later);
    }
  };
}

/* harmony default export */ var lib_rAFThrottle = (rAFThrottle);

// CONCATENATED MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/subscribe-ui-event/dist-es/constants.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var EVENT_END_DELAY = 100;
var DEFAULT_THROTTLE_RATE = 50;

// CONCATENATED MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/subscribe-ui-event/dist-es/mainEventConnectors.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document, setTimeout */











// constants


var connections = globalVars.connections,
    EE = globalVars.EE,
    listeners = globalVars.listeners,
    removers = globalVars.removers;

// global variables

var doc = void 0;
var win = void 0;
var body = void 0;
var hashId = 0;

if (typeof window !== 'undefined') {
  win = window;
  doc = win.document || document;
  body = doc.body;
}

function getHash(domNode) {
  return domNode.id || 'target-id-' + hashId++; // eslint-disable-line
}

/**
 * Connect a throttled event to a throttled main event, and return an event remover.
 * The number of connections to a throttled main event will be kept. If all throttled events
 * are removed, then remove throttled main event.
 * @method connectThrottle
 * @param {String} throttledEvent - A throttled event
 * @param {Function} cb - Callback function
 * @param {Object} ctx - The "this"
 * @param {String} throttledMainEvent - A throttled main event
 * @return {Object} An event remover
 */
function connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
  EE.on(throttledEvent, cb || noop_default.a, ctx);
  throttledMainEvent = throttledMainEvent || throttledEvent;
  connections[throttledMainEvent] = (connections[throttledMainEvent] || 0) + 1;
  return {
    _type: throttledEvent,
    _cb: cb,
    _ctx: ctx,
    unsubscribe: function unsubscribe() {
      if (!this._type) {
        return;
      }

      EE.removeListener(throttledEvent, cb, ctx);
      connections[throttledMainEvent]--;
      if (connections[throttledMainEvent] === 0) {
        listeners[throttledMainEvent].remove();
        listeners[throttledMainEvent] = undefined;
      }

      this._type = undefined;
      this._cb = undefined;
      this._ctx = undefined;

      // remove the remover from removers array
      for (var i = removers.length - 1; i >= 0; i--) {
        var remover = removers[i];
        if (remover === this) {
          removers.splice(i, 1);
          break;
        }
      }
    }
  };
}

/**
 * Connect to event, event start and event end.
 * @method connectContinuousEvent
 * @param {Object} target - The target of a main event, window or document.
 * @param {String} mainEvent - A browser event, like scroll or resize.
 * @param {String} event - A subscribe event.
 * @param {Object} eventOptions - An options pass to event listener
 */
function connectContinuousEvent(target, mainEvent, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);
    var targetPart = domId ? ':' + domId : '';

    var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
    var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
    var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
    var throttledEvent = event + ':' + throttleRate + targetPart;

    var remover = connectThrottle(throttledEvent, cb, context, throttledMainEvent);
    removers.push(remover);

    if (listeners[throttledMainEvent]) {
      return remover;
    }

    var ae = {
      start: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'start' }), // start
      main: new dist_es_AugmentedEvent({ mainType: mainEvent }), // main
      end: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'end' })
    };

    // No throttle for throttleRate = 0
    // end
    if (throttleRate === 'raf') {
      throttleRate = 16; // Set as a number for setTimeout later.
      handler = lib_rAFThrottle(handler);
    } else if (throttleRate > 0) {
      handler = throttle_default()(handler, throttleRate);
    }

    var timer = void 0;
    function endCallback(e) {
      ae.end.update(e);
      EE.emit(throttledEndEvent, e, ae.end);
      timer = null;
    }
    function handler(e) {
      if (!timer) {
        ae.start.update(e);
        EE.emit(throttledStartEvent, e, ae.start);
      }
      clearTimeout(timer);

      ae.main.update(e);
      EE.emit(throttledMainEvent, e, ae.main);
      if (!lib_leIE8) {
        timer = setTimeout(endCallback.bind(null, e), throttleRate + EVENT_END_DELAY);
      } else {
        // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
        timer = setTimeout(function () {
          endCallback(clone_default()(e));
        }, throttleRate + EVENT_END_DELAY);
      }
    }

    listeners[throttledMainEvent] = lib_listen(domTarget || target, mainEvent, handler, eventOptions);
    return remover;
  };
}

function connectDiscreteEvent(target, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);

    // no throttling for discrete event
    var throttledEvent = event + ':0' + (domId ? ':' + domId : '');

    var remover = connectThrottle(throttledEvent, cb, context);
    removers.push(remover);

    if (listeners[throttledEvent]) {
      return remover;
    }

    var ae = new dist_es_AugmentedEvent({ mainType: event });

    function handler(e) {
      ae.update(e);
      EE.emit(throttledEvent, e, ae);
    }

    listeners[throttledEvent] = lib_listen(domTarget || target, event, handler, eventOptions);
    return remover;
  };
}

/* harmony default export */ var mainEventConnectors = ({
  scrollStart: connectContinuousEvent(win, 'scroll', 'scrollStart'),
  scrollEnd: connectContinuousEvent(win, 'scroll', 'scrollEnd'),
  scroll: connectContinuousEvent(win, 'scroll', 'scroll'),
  resizeStart: connectContinuousEvent(win, 'resize', 'resizeStart'),
  resizeEnd: connectContinuousEvent(win, 'resize', 'resizeEnd'),
  resize: connectContinuousEvent(win, 'resize', 'resize'),
  visibilitychange: connectDiscreteEvent(doc, 'visibilitychange'),
  touchmoveStart: connectContinuousEvent(body, 'touchmove', 'touchmoveStart'),
  touchmoveEnd: connectContinuousEvent(body, 'touchmove', 'touchmoveEnd'),
  touchmove: connectContinuousEvent(body, 'touchmove', 'touchmove'),
  touchstart: connectDiscreteEvent(body, 'touchstart'),
  touchend: connectDiscreteEvent(body, 'touchend')
});

// CONCATENATED MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/subscribe-ui-event/dist-es/subscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


 // less then or equal to IE8


// constants


/**
 * Subscribe to UI events.
 * @method subscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 * @param {Object} options.context - The caller.
 * @param {Number} options.throttleRate - The amount of time for throttling.
 * @param {Boolean} options.useRAF - Use rAF for throttling if true.
 * @param {Object} options.eventOptions - Option to pass to event listener
 * @return {Object} The object with unsubscribe function.
 */
function subscribe(type, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var useRAF = options.useRAF || false;
  var throttleRate = parseInt(options.throttleRate, 10);
  var eventOptions = options.eventOptions;

  if (isNaN(throttleRate)) {
    throttleRate = DEFAULT_THROTTLE_RATE;
  }

  if (useRAF) {
    throttleRate = 'raf';
  }

  // turn off throttle if the browser is IE8 or less, because window.event will be reset
  // when using any delayed function, i.g., setTimeout, or rAF.
  if (lib_leIE8) {
    throttleRate = 0;
  }

  // once those variables enabled, then never disabled.
  globalVars.enableScrollInfo = globalVars.enableScrollInfo || options.enableScrollInfo || false;
  globalVars.enableResizeInfo = globalVars.enableResizeInfo || options.enableResizeInfo || false;
  globalVars.enableTouchInfo = globalVars.enableTouchInfo || options.enableTouchInfo || false;

  return mainEventConnectors[type](throttleRate, cb, options, eventOptions);
}

/* harmony default export */ var dist_es_subscribe = (subscribe);

// CONCATENATED MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/subscribe-ui-event/dist-es/unsubscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var unsubscribe_removers = globalVars.removers;

/**
 * Unsubscribe to UI events.
 * @method unsubscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 */

function unsubscribe(type, cb) {
  var remover = void 0;
  for (var i = unsubscribe_removers.length - 1; i >= 0; i -= 1) {
    remover = unsubscribe_removers[i];
    if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
      remover.unsubscribe();
      unsubscribe_removers.splice(i, 1);
    }
  }
}

/* harmony default export */ var dist_es_unsubscribe = (unsubscribe);

// CONCATENATED MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/subscribe-ui-event/index.es.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */





var IS_CLIENT = typeof window !== 'undefined';

function warn() {
  if (false) {}
}

var index_es_listen = IS_CLIENT ? lib_listen : warn;
var index_es_subscribe = IS_CLIENT ? dist_es_subscribe : warn;
var index_es_unsubscribe = IS_CLIENT ? dist_es_unsubscribe : warn;


/***/ }),

/***/ "GZ82":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Technically, this is not related to the address, since it can work with any type of validationSchema
// but other form of schemas, might not be object. So here we went for the simplest case, the one we
// use, i.e. address
var validationSchemaAddressFragment = "\n fragment ValidationSchemaAddress on SchemaValidationFieldInterface {\n  name\n  ...on ValidationSchemaObjectField {\n    fields {\n      name\n      required\n      validators {\n        name\n        value\n      }\n    }\n  }\n }\n";
/* harmony default export */ __webpack_exports__["a"] = (validationSchemaAddressFragment);

/***/ }),

/***/ "GZgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_OF_STAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_PRICE_OF_STAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_INCLUSIVE_SERVICES_REQUEST; });
var PRICE_OF_STAY_REQUEST = 'PRICE_OF_STAY_REQUEST';
var RESET_PRICE_OF_STAY = 'RESET_PRICE_OF_STAY';
var ALL_INCLUSIVE_SERVICES_REQUEST = 'ALL_INCLUSIVE_SERVICES_REQUEST';

/***/ }),

/***/ "Gpi5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ "Gqxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _responsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/Mt0");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7__["createElement"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




function Responsiveness(WrappedComponent) {
  var Responsive = /*#__PURE__*/function (_React$Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Responsive, _React$Component);

    var _super = _createSuper(Responsive);

    function Responsive() {
      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(this, Responsive);

      return _super.apply(this, arguments);
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(Responsive, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            forwardRef = _this$props.forwardRef,
            rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_this$props, ["forwardRef"]);

        return __jsx(_responsiveContext__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].Consumer, null, function (responsive) {
          return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
            ref: forwardRef
          }, rest, {
            responsive: responsive
          }));
        });
      }
    }]);

    return Responsive;
  }(react__WEBPACK_IMPORTED_MODULE_7__["Component"]); //$FlowFixMe


  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__["forwardRef"](function (props, ref) {
    return __jsx(Responsive, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, props, {
      forwardRef: ref
    }));
  });
}

/* harmony default export */ __webpack_exports__["a"] = (Responsiveness);

/***/ }),

/***/ "Gy6l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ArrowButton_ArrowButton; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.themes.js




var ArrowButton_themes_themes = function themes(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _ref$color,
      _ref$colorBg = _ref.colorBg,
      colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].WHITE : _ref$colorBg,
      isDisabled = _ref.isDisabled;
  return {
    "default": {
      thRoot: classnames_default()('reset-button block flex items-center justify-center leading-none rounded-tiny text-sm transition-colors', Object(defineProperty["a" /* default */])({
        'bg-gray-light cursor-default pointer-events-none text-gray-medium': isDisabled
      }, "bg-".concat(colorBg, " focus:bg-").concat(colorBg, "-active hover:bg-").concat(colorBg, "-active text-").concat(color), !isDisabled)),
      thIconName: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_LEFT,
      thLabel: 'sr-only'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx
var __jsx = react_default.a.createElement;





var ArrowButton_ArrowButton = function ArrowButton(_ref) {
  var className = _ref.className,
      color = _ref.color,
      colorBg = _ref.colorBg,
      hasNoRtl = _ref.hasNoRtl,
      isDisabled = _ref.isDisabled,
      label = _ref.label,
      onClick = _ref.onClick,
      onMouseDown = _ref.onMouseDown,
      onMouseUp = _ref.onMouseUp,
      _ref$rotation = _ref.rotation,
      rotation = _ref$rotation === void 0 ? 0 : _ref$rotation,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 28 : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title,
      trackingData = _ref.trackingData;
  var _themes$theme = ArrowButton_themes_themes({
    color: color,
    colorBg: colorBg,
    isDisabled: isDisabled
  })[theme],
      thIconName = _themes$theme.thIconName,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;
  var style = {
    height: size,
    width: size
  };
  return __jsx(TrackClick["a" /* TrackClick */], {
    "aria-disabled": isDisabled,
    as: "button",
    className: classnames_default()(className, thRoot),
    onClick: onClick,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    style: style,
    title: title,
    trackingData: trackingData,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    hasRtl: !hasNoRtl,
    name: thIconName,
    rotation: rotation,
    width: "1em"
  }), label && __jsx("span", {
    className: thLabel
  }, label));
};

/***/ }),

/***/ "HDyB":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("nmnc"),
    Uint8Array = __webpack_require__("JHRd"),
    eq = __webpack_require__("ljhN"),
    equalArrays = __webpack_require__("or5M"),
    mapToArray = __webpack_require__("7fqy"),
    setToArray = __webpack_require__("rEGp");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "HOxn":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("Cwc5"),
    root = __webpack_require__("Kz5y");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "HaU7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regeneratorRuntime = __webpack_require__("IebI");

var _classCallCheck = __webpack_require__("zQIG");

var _createClass = __webpack_require__("8mBC");

var _inherits = __webpack_require__("I/kN");

var _possibleConstructorReturn = __webpack_require__("cMav");

var _getPrototypeOf = __webpack_require__("pSQP");

var _asyncToGenerator = __webpack_require__("4mCN");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireDefault = __webpack_require__("Y3ZS");

exports.__esModule = true;
exports.Container = Container;
exports.createUrl = createUrl;
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

var _utils = __webpack_require__("fvxO");

exports.AppInitialProps = _utils.AppInitialProps;
exports.NextWebVitalsMetric = _utils.NextWebVitalsMetric;
/**
* `App` component is used for initialize of pages. It allows for overwriting and full control of the `page` initialization.
* This allows for keeping state between navigation, custom error handling, injecting additional data.
*/

function appGetInitialProps(_x) {
  return _appGetInitialProps.apply(this, arguments);
}

function _appGetInitialProps() {
  _appGetInitialProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Component, ctx, pageProps;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Component = _ref.Component, ctx = _ref.ctx;
            _context.next = 3;
            return (0, _utils.loadGetInitialProps)(Component, ctx);

          case 3:
            pageProps = _context.sent;
            return _context.abrupt("return", {
              pageProps: pageProps
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _appGetInitialProps.apply(this, arguments);
}

var App = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(App, _react$default$Compon);

  var _super = _createSuper(App);

  function App() {
    _classCallCheck(this, App);

    return _super.apply(this, arguments);
  }

  _createClass(App, [{
    key: "componentDidCatch",
    // Kept here for backwards compatibility.
    // When someone ended App they could call `super.componentDidCatch`.
    // @deprecated This method is no longer needed. Errors are caught at the top level
    value: function componentDidCatch(error, _errorInfo) {
      throw error;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          router = _this$props.router,
          Component = _this$props.Component,
          pageProps = _this$props.pageProps,
          __N_SSG = _this$props.__N_SSG,
          __N_SSP = _this$props.__N_SSP;
      return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({}, pageProps, // we don't add the legacy URL prop if it's using non-legacy
      // methods like getStaticProps and getServerSideProps
      !(__N_SSG || __N_SSP) ? {
        url: createUrl(router)
      } : {}));
    }
  }]);

  return App;
}(_react["default"].Component);

exports["default"] = App;
App.origGetInitialProps = appGetInitialProps;
App.getInitialProps = appGetInitialProps;
var warnContainer;
var warnUrl;

if (false) {} // @deprecated noop for now until removal


function Container(p) {
  if (false) {}
  return p.children;
}

function createUrl(router) {
  // This is to make sure we don't references the router object at call time
  var pathname = router.pathname,
      asPath = router.asPath,
      query = router.query;
  return {
    get query() {
      if (false) {}
      return query;
    },

    get pathname() {
      if (false) {}
      return pathname;
    },

    get asPath() {
      if (false) {}
      return asPath;
    },

    back: function back() {
      if (false) {}
      router.back();
    },
    push: function push(url, as) {
      if (false) {}
      return router.push(url, as);
    },
    pushTo: function pushTo(href, as) {
      if (false) {}
      var pushRoute = as ? href : '';
      var pushUrl = as || href;
      return router.push(pushRoute, pushUrl);
    },
    replace: function replace(url, as) {
      if (false) {}
      return router.replace(url, as);
    },
    replaceTo: function replaceTo(href, as) {
      if (false) {}
      var replaceRoute = as ? href : '';
      var replaceUrl = as || href;
      return router.replace(replaceRoute, replaceUrl);
    }
  };
}

/***/ }),

/***/ "I8qj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = Object.prototype.toString;

module.exports = function (x) {
  var prototype;
  return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};

/***/ }),

/***/ "IOzZ":
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ "IWTy":
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__("yue5");

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ "Ioao":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("heNW");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "Itgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ECBadge; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var ECBadge = function ECBadge(_ref) {
  var className = _ref.className,
      height = _ref.height,
      iconWidth = _ref.iconWidth;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'bg-deepBlue px-px5 flex items-center inset-border-after--small justify-center'),
    style: {
      height: height,
      width: height * 2
    }
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].WHITE,
    isNotSquare: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].EXCLUSIVE_COLLECTION,
    width: iconWidth
  }));
};
ECBadge.defaultProps = {
  iconWidth: '90%',
  height: 50
};

/***/ }),

/***/ "IuYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Price_Price; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// CONCATENATED MODULE: ./src/client/components/frameworks/price-item/PriceItem.themes.js

var PriceItem_themes_themes = function themes(_ref) {
  var hasAction = _ref.hasAction;
  return {
    best: {
      "package": {
        thRoot: 'font-bold leading-one text-center',
        thLabel: 'block font-sans text-gray-darker text-base uppercase',
        thValue: 'block text-turquoise text-5xl',
        thLongValue: 'block text-turquoise text-3xl'
      },
      thumbnail: {
        thRoot: 'text-base flex items-center',
        thLabel: 'font-sans text-gray-darker',
        thValue: 'leading-tight text-2xl underline px-px5',
        thLongValue: 'leading-tight text-2xl underline'
      },
      instagram: {
        thRoot: 'text-sm sm:text-base',
        thLabel: 'font-sans',
        thValue: 'leading-tight text-md underline font-bold',
        thLongValue: 'leading-tight text-2xl underline'
      },
      remote: {
        thRoot: 'leading-one font-bold px-px5 flex items-center',
        thLabel: 'align-top font-sans inline-block text-sm pr-px5 rtl:pr-px5',
        thValue: classnames_default()('font-sans inline-block text-3xl', {
          underline: hasAction
        }),
        thLongValue: classnames_default()('font-sans inline-block text-3xl', {
          underline: hasAction
        })
      }
    },
    initial: {
      "package": {
        thRoot: 'block font-bold leading-tight text-center',
        thLabel: 'inline-block font-sans text-gray-darker text-base',
        thValue: 'inline-block line-through text-gray-darker text-base',
        thLongValue: 'block line-through text-gray-darker text-base'
      },
      thumbnail: {
        thRoot: 'inline-block lowercase text-md',
        thLabel: 'hidden',
        thValue: 'line-through uppercase',
        thLongValue: 'line-through uppercase'
      },
      instagram: {
        thRoot: 'text-sm sm:text-base',
        thLabel: 'font-sans',
        thValue: 'font-sans line-through',
        thLongValue: 'font-sans line-through'
      },
      remote: {
        thRoot: 'font-bold text-md text-grenadine',
        thLabel: 'font-sans',
        thValue: 'font-sans line-through',
        thLongValue: 'font-sans line-through'
      }
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price-item/PriceItem.jsx
var __jsx = react_default.a.createElement;




var PriceItem_PriceItem = function PriceItem(_ref) {
  var className = _ref.className,
      formattedValue = _ref.formattedValue,
      hasAction = _ref.hasAction,
      label = _ref.label,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'package' : _ref$theme,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'best' : _ref$type,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value;

  if (!value || !formattedValue) {
    return null;
  }

  var _themes$type$theme = PriceItem_themes_themes({
    hasAction: hasAction
  })[type][theme],
      thLabel = _themes$type$theme.thLabel,
      thLongValue = _themes$type$theme.thLongValue,
      thRoot = _themes$type$theme.thRoot,
      thValue = _themes$type$theme.thValue;
  var valueClasses = Object(price_util["g" /* isLongFormat */])(value) ? thLongValue : thValue;
  return __jsx("span", {
    className: classnames_default()(className, thRoot)
  }, !!label && __jsx("span", {
    className: thLabel,
    "data-testid": "PriceItem-label"
  }, label), !!label && !!formattedValue && __jsx("span", null, " "), __jsx("span", {
    className: valueClasses,
    "data-testid": "PriceItem-value"
  }, formattedValue));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/unit/PriceUnit.themes.js
var PriceUnit_themes_themes = {
  "package": {
    thRoot: 'block font-sans font-bold text-center text-sm uppercase'
  },
  thumbnail: {
    thRoot: 'inline-block font-sans text-sm md:text-base text-gray-darker'
  },
  instagram: {
    thRoot: 'inline-block font-sans text-sm sm:text-base'
  },
  remote: {
    thRoot: 'font-bold font-sans inline-block text-sm'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/unit/PriceUnit.jsx
var PriceUnit_jsx = react_default.a.createElement;


var PriceUnit_PriceUnit = function PriceUnit(_ref) {
  var hasAsterisk = _ref.hasAsterisk,
      theme = _ref.theme,
      unit = _ref.unit;
  return unit ? PriceUnit_jsx("span", {
    className: PriceUnit_themes_themes[theme].thRoot,
    "data-testid": "Price-unit"
  }, unit, hasAsterisk && PriceUnit_jsx("sup", null, "*")) : null;
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.themes.js
var PriceDiscount_themes_themes = {
  "package": {},
  thumbnail: {
    thInitialPrice: 'text-grenadine -order-1 -mb-1'
  },
  instagram: {
    thInitialPrice: 'text-grenadine'
  },
  remote: {
    thInitialPrice: '-order-1'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.jsx

var PriceDiscount_jsx = react_default.a.createElement;








var PriceDiscount_PriceDiscount = function PriceDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      from = _ref.from,
      hasAction = _ref.hasAction,
      hasAsterisk = _ref.hasAsterisk,
      hasInitialPrice = _ref.hasInitialPrice,
      hasInstalment = _ref.hasInstalment,
      initialPrice = _ref.initialPrice,
      _ref$instalmentLocale = _ref.instalmentLocales,
      instalmentLocales = _ref$instalmentLocale === void 0 ? [] : _ref$instalmentLocale,
      instead = _ref.instead,
      theme = _ref.theme,
      unit = _ref.unit;
  var context = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var thInitialPrice = PriceDiscount_themes_themes[theme].thInitialPrice;
  var displayInstalment = hasInstalment && Object(i18n["c" /* getKeyValue */])('common.price.displayInstalmentsPrice');
  var locale = context.locale;
  return PriceDiscount_jsx(react["Fragment"], null, PriceDiscount_jsx(PriceItem_PriceItem, Object(esm_extends["a" /* default */])({
    hasAction: hasAction,
    label: from,
    theme: theme,
    type: "best"
  }, bestPrice, {
    formattedValue: hasInstalment ? Object(price_util["b" /* getInstalmentPrice */])(bestPrice, locale) : bestPrice && bestPrice.formattedValue
  })), PriceDiscount_jsx("span", null, " "), hasInitialPrice && PriceDiscount_jsx(PriceItem_PriceItem, Object(esm_extends["a" /* default */])({
    hasAction: hasAction,
    label: instead,
    theme: theme,
    type: "initial"
  }, initialPrice, {
    className: thInitialPrice,
    formattedValue: displayInstalment && initialPrice && instalmentLocales.includes(locale) ? Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Math.trunc(initialPrice.value), locale, initialPrice.currency, {
      precision: 0
    }) : initialPrice && initialPrice.formattedValue
  })), PriceDiscount_jsx("span", null, " "), PriceDiscount_jsx(PriceUnit_PriceUnit, {
    hasAsterisk: hasAsterisk,
    theme: theme,
    unit: unit
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/no-discount/PriceNoDiscount.jsx

var PriceNoDiscount_jsx = react_default.a.createElement;





var PriceNoDiscount_PriceNoDiscount = function PriceNoDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      from = _ref.from,
      hasAsterisk = _ref.hasAsterisk,
      hasInstalment = _ref.hasInstalment,
      initialPrice = _ref.initialPrice,
      theme = _ref.theme,
      unit = _ref.unit;
  var context = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var price;

  if (Object(price_util["f" /* hasPrice */])(initialPrice)) {
    price = initialPrice;
  } else if (Object(price_util["f" /* hasPrice */])(bestPrice)) {
    price = bestPrice;
  }

  return PriceNoDiscount_jsx(react["Fragment"], null, PriceNoDiscount_jsx(PriceItem_PriceItem, Object(esm_extends["a" /* default */])({
    label: from,
    theme: theme,
    type: "best"
  }, price, {
    formattedValue: hasInstalment ? Object(price_util["b" /* getInstalmentPrice */])(price, context.locale) : price && price.formattedValue
  })), PriceNoDiscount_jsx("span", null, " "), PriceNoDiscount_jsx(PriceUnit_PriceUnit, {
    hasAsterisk: hasAsterisk,
    theme: theme,
    unit: unit
  }));
};
// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.themes.js
var PriceViewRate_themes_themes = {
  "package": {
    thRoot: 'flex font-bold font-sans justify-center leading-tight text-center text-md',
    thLabel: 'rtl:ml-2'
  },
  thumbnail: {
    thRoot: 'flex items-center underline font-sans leading-one text-sm md:text-base',
    thIcon: 'hidden',
    thLabel: 'rtl:ml-1'
  },
  instagram: {
    thRoot: 'flex items-center underline font-sans leading-one text-sm sm:text-base',
    thIcon: 'hidden',
    thLabel: 'rtl:ml-1'
  },
  remote: {
    thRoot: 'flex items-center font-bold font-sans leading-one text-xl',
    thLabel: 'rtl:ml-2'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.jsx
var PriceViewRate_jsx = react_default.a.createElement;




var PriceViewRate_PriceViewRate = function PriceViewRate(_ref) {
  var label = _ref.label,
      theme = _ref.theme;
  var _themes$theme = PriceViewRate_themes_themes[theme],
      thIcon = _themes$theme.thIcon,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  if (!label) {
    return null;
  }

  return PriceViewRate_jsx("div", {
    className: thRoot
  }, PriceViewRate_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].DATE,
    width: "1em"
  }), PriceViewRate_jsx("span", {
    className: thLabel,
    "data-testid": "Price-viewRate"
  }, label));
};
// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.themes.js

var Price_themes_themes = function themes(_ref) {
  var color = _ref.color;
  return {
    "package": {
      thRoot: 'overflow-hidden'
    },
    thumbnail: {
      thRoot: 'flex items-center leading-half overflow-hidden pt-1 pb-2 text-gray-darker',
      thPriceRoot: 'font-brand flex items-center'
    },
    instagram: {
      thRoot: 'w-full flex items-center leading-half truncate text-white',
      thPriceRoot: 'font-brand text-inherit'
    },
    remote: {
      thRoot: "inline-flex overflow-hidden text-".concat(color || colors["a" /* COLORS */].BLUE),
      thPriceRoot: 'flex items-center'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.jsx
var Price_jsx = react_default.a.createElement;







var HEIGHT = '2.5rem';
var Price_Price = function Price(_ref) {
  var bestPrice = _ref.bestPrice,
      className = _ref.className,
      color = _ref.color,
      _ref$containerStyle = _ref.containerStyle,
      containerStyle = _ref$containerStyle === void 0 ? {
    minHeight: HEIGHT
  } : _ref$containerStyle,
      from = _ref.from,
      _ref$hasAsterisk = _ref.hasAsterisk,
      hasAsterisk = _ref$hasAsterisk === void 0 ? true : _ref$hasAsterisk,
      _ref$hasInitialPrice = _ref.hasInitialPrice,
      hasInitialPrice = _ref$hasInitialPrice === void 0 ? true : _ref$hasInitialPrice,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? true : _ref$hasInstalment,
      initialPrice = _ref.initialPrice,
      _ref$instalmentLocale = _ref.instalmentLocales,
      instalmentLocales = _ref$instalmentLocale === void 0 ? ['pt-BR', 'es-AR'] : _ref$instalmentLocale,
      instead = _ref.instead,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      onClick = _ref.onClick,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'package' : _ref$theme,
      unit = _ref.unit,
      viewRates = _ref.viewRates;
  var displayPrice = Object(price_util["d" /* hasAtLeastOnePrice */])({
    initialPrice: initialPrice,
    bestPrice: bestPrice
  });

  if (!displayPrice && !viewRates) {
    return null;
  }

  var _themes$theme = Price_themes_themes({
    color: color
  })[theme],
      thPriceRoot = _themes$theme.thPriceRoot,
      thRoot = _themes$theme.thRoot;
  var hasAction = !!onClick;
  var TagName = hasAction ? 'button' : 'div';
  return Price_jsx(TagName, {
    "data-testid": "Price-wrapper",
    className: classnames_default()(className, thRoot, {
      'reset-button': hasAction
    }),
    onClick: onClick,
    style: containerStyle
  }, Price_jsx("div", {
    className: thPriceRoot,
    style: style
  }, isLoading ? Price_jsx("div", {
    className: "loadingDots",
    "data-testid": "Price-loader"
  }) : Price_jsx(react["Fragment"], null, displayPrice ? Price_jsx(react["Fragment"], null, Object(price_util["e" /* hasDiscount */])({
    initialPrice: initialPrice,
    bestPrice: bestPrice
  }) ? Price_jsx(PriceDiscount_PriceDiscount, {
    bestPrice: bestPrice,
    from: from,
    hasAction: hasAction,
    hasAsterisk: hasAsterisk,
    hasInitialPrice: hasInitialPrice,
    hasInstalment: hasInstalment,
    initialPrice: initialPrice,
    instalmentLocales: instalmentLocales,
    instead: instead,
    theme: theme,
    unit: unit
  }) : Price_jsx(PriceNoDiscount_PriceNoDiscount, {
    bestPrice: bestPrice,
    from: from,
    hasAsterisk: hasAsterisk,
    hasInstalment: hasInstalment,
    initialPrice: initialPrice,
    theme: theme,
    unit: unit
  })) : Price_jsx(PriceViewRate_PriceViewRate, {
    label: viewRates,
    theme: theme
  }))));
};

/***/ }),

/***/ "JC6p":
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__("cq/+"),
    keys = __webpack_require__("7GkX");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ "JHRd":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("Kz5y");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "JPie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("aWzz");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("R6jJ");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("s5tn");






var AutoFocusInside = function AutoFocusInside(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      className = _ref.className;
  return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, Object(_util__WEBPACK_IMPORTED_MODULE_4__[/* inlineProp */ "b"])(focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__[/* FOCUS_AUTO */ "b"], !disabled), {
    className: className
  }), children);
};

AutoFocusInside.propTypes =  false ? undefined : {};
AutoFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (AutoFocusInside);

/***/ }),

/***/ "JTzB":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("NykK"),
    isObjectLike = __webpack_require__("ExA7");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "Jsmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tripInformationSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdultsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getKids; });
/* unused harmony export getMainContactOptins */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);

var tripInformationSelector = function tripInformationSelector(_ref) {
  var tripInformation = _ref.tripInformation;
  return tripInformation || {};
};

var tripCriteriaSelector = function tripCriteriaSelector(_ref2) {
  var tripCriteria = _ref2.tripCriteria;
  return tripCriteria || {};
};

var getAdults = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref3) {
  var adults = _ref3.adults;
  return adults || [];
});
var getAdultsNumber = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref4) {
  var adults = _ref4.adults;
  return (adults || []).length;
});
var getKids = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref5) {
  var kids = _ref5.kids;
  return kids || [];
});
var getMainContactOptins = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref6) {
  var mainContact = _ref6.mainContact;
  return mainContact;
});


/***/ }),

/***/ "Juji":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ "Kb9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_VALIDATION_SCHEMA; });
var UPDATE_VALIDATION_SCHEMA = 'UPDATE_VALIDATION_SCHEMA';

/***/ }),

/***/ "Khd+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("HaU7")


/***/ }),

/***/ "Kkar":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("Dhk8"),
    getPrototype = __webpack_require__("/wCD"),
    isObjectLike = __webpack_require__("tLQN");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "KwMD":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ "KxdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMFORT_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXTRA_FEATURES_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONFIGURATION_CATEGORY; });
/* unused harmony export matchConfiguration */
/* unused harmony export matchComfort */
/* unused harmony export matchExtraFeatures */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createFilters; });
/* unused harmony export createConfigurationFilters */
/* unused harmony export createComfortFilters */
/* unused harmony export createExtraFeaturesFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return unselectCategory; });
/* unused harmony export REDUCED_MOBILITY_FILTER_ID */
/* unused harmony export matchExtraFeaturesReducedMobility */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MIfU");
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(shortid__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("YS3K");
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("lZ21");
/* harmony import */ var _components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("aWOT");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var COMFORT_CATEGORY = 'accommodations';
var EXTRA_FEATURES_CATEGORY = 'extra';
var CONFIGURATION_CATEGORY = 'configuration';
var REDUCED_MOBILITY_FILTER_ID = 'reduced_mobility_access';

var matchConfiguration = function matchConfiguration(accommodations, roomType) {
  return accommodations.some(function (accommodation) {
    return accommodation.roomType === roomType;
  });
};

var matchComfort = function matchComfort(accommodations, categoryId) {
  return accommodations.some(function (accommodation) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(accommodation, 'categories').find(function (category) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(category, 'id') === categoryId;
    });
  });
};

var matchExtraFeatures = function matchExtraFeatures(accommodations, strengthId) {
  return accommodations.some(function (accommodation) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(accommodation, 'view.id', null) === strengthId || Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(accommodation, 'strengths', []).find(function (strength) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(strength, 'id') === strengthId;
    });
  });
};

var matchExtraFeaturesReducedMobility = function matchExtraFeaturesReducedMobility(accommodations) {
  return accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  });
};

function createConfigurationFilters(accommodationsSets, resort) {
  var accommodations = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('accommodations')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('roomType')])(accommodationsSets);
  return accommodations.map(function (_ref) {
    var roomType = _ref.roomType;
    return {
      id: shortid__WEBPACK_IMPORTED_MODULE_2___default.a.generate(),
      category: CONFIGURATION_CATEGORY,
      match: matchConfiguration,
      className: 'additionalAccommodationsFilters',
      meta: {
        label: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__[/* tAlt */ "b"])({
          resortKeyPath: "filters.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_6__[/* ROOM_TYPE */ "e"][roomType]),
          cruiseKeyPath: "filters.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_6__[/* CABIN_TYPE */ "b"][roomType]),
          resort: resort
        }),
        icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"][roomType],
        iconClassName: "icon--".concat(roomType),
        iconInheritColor: true
      },
      path: 'accommodations',
      selected: false,
      value: roomType
    };
  });
}

function createComfortFilters(accommodationsSets) {
  var accommodations = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('accommodations')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], lodash_fp__WEBPACK_IMPORTED_MODULE_4__["compact"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('categoryId')])(accommodationsSets);
  var comfortSeen = [];
  return accommodations.map(function (accommodation) {
    /**
     * in some cases we have differents categories with same comfort type
     * it causes a duplicate filter
     * Concat comfort type & category, as label for teh second one
     */
    var comfortType = accommodation.comfortType,
        category = accommodation.category;
    var label = comfortSeen.includes(comfortType) ? "".concat(comfortType, " ").concat(category) : comfortType || category;
    comfortSeen.push(accommodation.comfortType);
    return {
      id: shortid__WEBPACK_IMPORTED_MODULE_2___default.a.generate(),
      category: COMFORT_CATEGORY,
      match: matchComfort,
      className: 'additionalAccommodationsFilters',
      meta: {
        label: label
      },
      path: 'accommodations',
      selected: false,
      value: accommodation.categoryId
    };
  });
}

function createExtraFeaturesFilters(accommodationsSets, i18n) {
  var accommodations = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('accommodations')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('id')])(accommodationsSets);
  var strengths = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('strengths')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["flatten"], lodash_fp__WEBPACK_IMPORTED_MODULE_4__["compact"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('id')])(accommodations);
  var views = Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["path"])('view')), lodash_fp__WEBPACK_IMPORTED_MODULE_4__["compact"], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_4__["uniqBy"])('id')])(accommodations);
  var reducedMobityAccess = accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  }) ? [{
    id: REDUCED_MOBILITY_FILTER_ID,
    label: i18n.filters.reducedMobility
  }] : [];
  var features = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(strengths), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(views), reducedMobityAccess);
  return features.map(function (feature) {
    return {
      id: shortid__WEBPACK_IMPORTED_MODULE_2___default.a.generate(),
      category: EXTRA_FEATURES_CATEGORY,
      match: feature.id === REDUCED_MOBILITY_FILTER_ID ? matchExtraFeaturesReducedMobility : matchExtraFeatures,
      meta: {
        label: feature.label,
        icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"][feature.id],
        iconClassName: "icon--".concat(feature.id),
        iconInheritColor: true
      },
      path: 'accommodations',
      selected: false,
      value: feature.id
    };
  });
}

function createFilters(accommodationsSets, i18n, resort) {
  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(createExtraFeaturesFilters(accommodationsSets, i18n)), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(createConfigurationFilters(accommodationsSets, resort)), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(createComfortFilters(accommodationsSets)));
}

function unselectCategory(filters) {
  return function (category) {
    return filters.map(function (filter) {
      return _objectSpread(_objectSpread({}, filter), {}, {
        selected: filter.category === category ? false : filter.selected
      });
    });
  };
}



/***/ }),

/***/ "L8xA":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "LGYb":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("1hJj"),
    arrayIncludes = __webpack_require__("jbM+"),
    arrayIncludesWith = __webpack_require__("Xt/L"),
    cacheHas = __webpack_require__("xYSL"),
    createSet = __webpack_require__("dQpi"),
    setToArray = __webpack_require__("rEGp");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ "LXxW":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "MAH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return proposalsByIdQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCxoAttendeesData; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("70jX");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");
/* harmony import */ var _store_validation_schema_validationSchema_address_fragment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("GZ82");
/* harmony import */ var _components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("BYx+");
/* harmony import */ var _components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SQLw");







var CHILDREN_ACTIVITY_IDENTIFIER = '_CHILD_';
function getResort() {
  var fetchActivityCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return "\n    resort {\n      childcareDetails {\n        isIncluded\n      }\n      accommodations {\n        category\n        categoryId\n        comfortId\n        comfortType\n        connectingRoom\n        id\n        roomType\n      }\n      adultOnly\n      associatedResort{\n        id\n        name\n      }\n      badgeIcon\n      category\n      childrenActivities: productActivities(idFilter: \"".concat(CHILDREN_ACTIVITY_IDENTIFIER, "\") {\n        ageInMonths {\n          max\n          min\n        }\n        description\n        equipments {\n          id\n          label\n        }\n        id\n        isIncluded\n        label\n        subtitle\n      }\n      color\n      comfort\n      comfortLabel\n      destination {\n        area\n        country\n      }\n      facilities(types: [\"CHILDREN\"], withEquipments: true) {\n        equipments {\n          id\n          label\n        }\n        label\n        subtitle\n      }\n      href\n      id\n      image\n      images\n      isCruise\n      isExplicitEC\n      isJoyview\n      name\n      offsetSell\n      seasonName\n      seasons\n      title\n      type\n      ").concat(fetchActivityCategories ? "activityCategories {\n        leisure {\n          id\n          label\n          subCategories {\n            id\n            label\n            imageUrl\n            keywords\n            activities {\n              id\n              label\n              description\n              isIncluded\n              durationDescription\n              practiceLevelDescription\n              activityTags{\n                id\n                label\n              }\n              ageInMonths {\n                min\n                max\n              }\n            }\n          }\n        }\n      }" : '', "\n    }");
}

function getValidationSchema() {
  return "\n    validationSchema(resource : \"profile\", fields: [\"address\"]) {\n      ...ValidationSchemaAddress\n    }\n  ";
}

var getCxoAttendeesData = function getCxoAttendeesData(_ref) {
  var adultsAttendeesIds = _ref.adultsAttendeesIds,
      kidsAttendeesIds = _ref.kidsAttendeesIds;
  return "".concat(adultsAttendeesIds && adultsAttendeesIds[0] ? "adultsAttendees: attendees(attendeesIds: [\"".concat(adultsAttendeesIds.join('","'), "\"]) {\n          ...BookingAttendeesProfile\n          birthdate: dateOfBirth\n          email\n          mobile: mobilePhoneNumber\n          optinEmail\n          optinSms\n          optinPhone\n          optinMail\n          optinClubmedPlus\n        }") : '', "\n  ").concat( // no need of birthday, we already have it
  kidsAttendeesIds && kidsAttendeesIds[0] ? "kidsAttendees: attendees(attendeesIds: [\"".concat(kidsAttendeesIds.join('","'), "\"]) {\n          ...BookingAttendeesProfile\n        }") : '', "\n");
};
/*
 * * Used in fetchProposalsById to get transports list and node for <TransportsSection/>
 * * Uses  API route /v1/proposals/{proposal_id}
 */


function proposalsByIdQuery(params, appContext) {
  var proposalsArgs = Array.isArray(params.proposalsId) ? ["ids: [\"".concat(params.proposalsId.join('","'), "\"]")] : ["ids: [\"".concat(params.proposalsId, "\"]")];
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposals: proposalsById(".concat(proposalsArgs.join(', '), ") {\n        ... on ProposalsType {\n          proposals {\n            ").concat(params.shouldRequestPayment ? Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* getPaymentScheduleRequest */ "g"])(appContext) : '', "\n            ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* proposalFields */ "l"])({
    isJoyView: true,
    withCommission: appContext.isCmta || appContext.isIndirectCxo
  }), "\n          }\n          ").concat(getResort(params.fetchActivityCategories), "\n        }\n      }\n      ").concat(getValidationSchema(), "\n      ").concat(appContext.isUserLogged ? 'profile {...BookingProfile}' : '', "\n      ").concat(getCxoAttendeesData(params), "\n      ").concat(params.shouldRequestPayment ? Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* paymentProvidersRequest */ "j"])() : '', "\n    }\n    ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* transportDetailsFragment */ "q"], "\n    ").concat(_store_validation_schema_validationSchema_address_fragment__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], "\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* getPriceDetailFragment */ "h"])(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(appContext, 'locale')), "\n    ").concat(appContext.isUserLogged ? _components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_5__[/* profileFragment */ "b"] : '', "\n    ").concat(params.adultsAttendeesIds && params.adultsAttendeesIds[0] || params.kidsAttendeesIds && params.kidsAttendeesIds[0] ? _components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"] : '', "\n  "), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* PROPOSAL_GET_BY_ID */ "pd"]
  });
}



/***/ }),

/***/ "MMmD":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("lSCD"),
    isLength = __webpack_require__("shjB");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "MvSz":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("LXxW"),
    stubArray = __webpack_require__("0ycA");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "NLwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return graphqlify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return graphqlifyString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return buildProductArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildCruiseArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildArgs; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var EMPTY_STRING = '""';

function graphqlify(jsonObject) {
  if (jsonObject) {
    return JSON.stringify(jsonObject).replace(/\"([^(\")"]+)\":/g, '$1:').replace(/(null)/g, EMPTY_STRING);
  }

  return '';
}

function graphqlifyString(str) {
  if (Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isString"])(str)) {
    return JSON.stringify(str);
  }

  return EMPTY_STRING;
}

function buildArgs() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var initialArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Object.keys(args).reduce(function (acc, key) {
    var value = args[key];

    if (Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isNull"])(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isUndefined"])(value)) {
      return acc;
    }

    if (Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isNumber"])(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isBoolean"])(value)) {
      return "".concat(acc, " ").concat(key, ": ").concat(value);
    }

    if (Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isArray"])(value)) {
      return "".concat(acc, " ").concat(key, ": ").concat(graphqlify(value));
    }

    return "".concat(acc, " ").concat(key, ": \"").concat(value, "\"");
  }, initialArgs);
}

function getCruiseArgs() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$departureDate = params.departureDate,
      departureDate = _params$departureDate === void 0 ? '' : _params$departureDate,
      _params$arrivalDate = params.arrivalDate,
      arrivalDate = _params$arrivalDate === void 0 ? '' : _params$arrivalDate;
  return {
    cruiseDepartureDate: departureDate,
    cruiseArrivalDate: arrivalDate
  };
}

function buildCruiseArgs() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var optionalArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var args = _objectSpread(_objectSpread({}, optionalArguments), getCruiseArgs(params));

  return buildArgs(args);
}

var CRUISE_RESORT_ID = 'CM2C';

function buildProductArgs(productId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var optionalArguments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!productId) {
    throw new Error('You must provide a productId');
  }

  var productArg;

  if (productId !== CRUISE_RESORT_ID) {
    productArg = "productId: \"".concat(productId, "\"");
  } else {
    var _getCruiseArgs = getCruiseArgs(params),
        cruiseDepartureDate = _getCruiseArgs.cruiseDepartureDate,
        cruiseArrivalDate = _getCruiseArgs.cruiseArrivalDate;

    productArg = "productId: \"".concat(productId, "_").concat(cruiseDepartureDate, "_").concat(cruiseArrivalDate, "\"");
  }

  return buildArgs(optionalArguments, productArg);
}



/***/ }),

/***/ "NXDx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInstalmentPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrencySymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTotalPriceWithDonation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasAtLeastOnePrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isLongFormat; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wz9x");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var MAX_LENGTH = 10;

function getCurrencySymbol(locale, currency) {
  return 0 .toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).replace(/\d/g, '').trim();
}

function hasPrice(price) {
  return !!(price === null || price === void 0 ? void 0 : price.value);
}

var hasDiscount = function hasDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      initialPrice = _ref.initialPrice;
  return hasPrice(initialPrice) && hasPrice(bestPrice) && (initialPrice === null || initialPrice === void 0 ? void 0 : initialPrice.value) !== (bestPrice === null || bestPrice === void 0 ? void 0 : bestPrice.value);
};

function hasAtLeastOnePrice() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref2 = props || {},
      initialPrice = _ref2.initialPrice,
      bestPrice = _ref2.bestPrice;

  return hasPrice(initialPrice) || hasPrice(bestPrice);
}

function isLongFormat(amount) {
  return amount ? amount.toString().length > MAX_LENGTH : false;
}

var getTotalPriceWithDonation = function getTotalPriceWithDonation(price, locale) {
  var donation = price.donation,
      total = price.total,
      totalWithoutDiscount = price.totalWithoutDiscount;
  var totalWithDonation = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(donation, 'value', 0) + Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(total, 'value', 0);
  var totalWithoutDiscountWithDonation = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(donation, 'value', 0) + Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(totalWithoutDiscount, 'value', 0);
  var currencyOptions = {
    precision: Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_3__["getBookingPrecision"])(locale)
  };
  return _objectSpread(_objectSpread({}, price), {}, {
    withDonation: {
      total: {
        value: totalWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__[/* formatAmountForLocale */ "b"])(totalWithDonation, locale, price.currency, currencyOptions)
      },
      totalWithoutDiscount: {
        value: totalWithoutDiscountWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__[/* formatAmountForLocale */ "b"])(totalWithoutDiscountWithDonation, locale, price.currency, currencyOptions)
      },
      hasFlexRates: price.hasFlexRates,
      selectedRate: price.selectedRate
    }
  });
};

var getInstalmentPrice = function getInstalmentPrice(price, locale) {
  if (!price || !price.value) return '';

  if (Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* getKeyValue */ "c"])('common.price.displayInstalmentsPrice')) {
    var instalmentValue = Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* getKeyValue */ "c"])('common.price.instalmentValue');
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('common.price.instalmentPrice', {
      instalmentValue: instalmentValue,
      dividedPrice: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_2__[/* formatAmountForLocale */ "b"])(Math.ceil(price.value / instalmentValue), locale, price.currency, {
        precision: 0
      })
    });
  }

  return price.formattedValue;
};


/***/ }),

/***/ "NZxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Backdrop_Backdrop; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react-focus-on/dist/es2015/Combination.js + 8 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react-focus-lock/dist/es2015/MoveFocusInside.js
var MoveFocusInside = __webpack_require__("oweP");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/frameworks/backdrop/Backdrop.themes.js
var themes = {
  "default": {
    thCloseButton: 'reset-button bg-white flex items-center justify-center leading-none m-5 rtl:right-0 rtl:slideInRight rounded-tiny shadow text-gray-darker text-sm transition-colors',
    thCloseButtonStyle: {
      width: 28,
      height: 28
    },
    thCloseButtonLabel: 'sr-only'
  },
  lite: {
    thCloseButton: 'reset-button bg-white cursor-pointer leading-none mt-5 mx-5 md:mx-12 p-px15 rtl:right-0 rounded-full text-gray-darker text-md rtl:slideInRight',
    thCloseButtonLabel: 'sr-only'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx
var __jsx = react_default.a.createElement;









var Backdrop_Backdrop = function Backdrop(_ref) {
  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? '#000' : _ref$bgColor,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      externalFocusTrapRefs = _ref.externalFocusTrapRefs,
      hasCloseButton = _ref.hasCloseButton,
      hasNoFocusTrap = _ref.hasNoFocusTrap,
      onClose = _ref.onClose,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 0.8 : _ref$opacity,
      _ref$portalName = _ref.portalName,
      portalName = _ref$portalName === void 0 ? Portal_constants["b" /* AFTER_APP */] : _ref$portalName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thCloseButtonStyle = _themes$theme.thCloseButtonStyle;
  var closeBtnLabel = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  return __jsx(Portal["a" /* default */], {
    name: portalName
  }, __jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: true
  }, __jsx("div", {
    className: classnames_default()(className, 'fadeIn fixed inset-0 escape-responsive-helper z-3')
  }, __jsx("div", {
    className: "fixed h-screen inset-0 z-1",
    "data-testid": "Backdrop-overlay",
    style: {
      backgroundColor: bgColor,
      opacity: opacity
    }
  }), __jsx("div", {
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, __jsx("div", {
    role: "document"
  }, hasCloseButton ? __jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: !hasNoFocusTrap,
    onEscapeKey: onClose,
    shards: externalFocusTrapRefs
  }, __jsx(MoveFocusInside["a" /* default */], null, __jsx("button", {
    className: classnames_default()('absolute top-0 z-3', thCloseButton),
    "data-testid": "Backdrop-close",
    onClick: onClose,
    title: closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : null,
    type: "button",
    style: thCloseButtonStyle
  }, closeBtnLabel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnLabel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  }))), __jsx("div", {
    className: "absolute flex items-center justify-center inset-0 z-2"
  }, children)) : __jsx("div", {
    className: "absolute flex items-center justify-center inset-0 p-5 z-2"
  }, __jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    className: "max-w-full",
    enabled: !hasNoFocusTrap,
    onClickOutside: onClose,
    onEscapeKey: onClose,
    shards: externalFocusTrapRefs
  }, children)))))));
};

/***/ }),

/***/ "Nhxn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attributesToString; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("pPFN");
/* harmony import */ var stringify_object__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(stringify_object__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable no-duplicate-imports  */


function attributesToString(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(data).reduce(function (acc, key) {
    if (options.ignoreUndefined && data[key] === undefined) {
      return '';
    }

    var value = data[key] === null ? '' : data[key];
    var dataToString = Array.isArray(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isBoolean"])(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isObject"])(value) ? stringify_object__WEBPACK_IMPORTED_MODULE_1___default()(value, {
      singleQuotes: false,
      inlineCharacterLimit: 1024,
      filter: function filter(o, p) {
        return options.ignoreUndefined ? o[p] !== undefined : true;
      }
    }) : "\"".concat(value, "\"");
    return "".concat(acc).concat(key, " : ").concat(dataToString, " ");
  }, '');
}

/***/ }),

/***/ "NrqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTrackSearchResults; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("uDfI");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _FacetSearch_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hPQF");
/* harmony import */ var _store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("vIa8");
/* harmony import */ var _store_search_search_selector__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("B3yO");
/* harmony import */ var _store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("RBO1");
/* harmony import */ var _store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Jsmy");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_tracking_resort__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("zCbR");
/* harmony import */ var _store_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("apzf");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}














var useTrackSearchResults = function useTrackSearchResults() {
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__[/* useTracking */ "a"])();
  var adults = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_8__[/* getAdults */ "a"])(state) || [];
  });
  var departureCity = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_7__[/* getDepartureCity */ "a"])(state);
  });
  var departureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_7__[/* getDepartureDate */ "b"])(state);
  });
  var duration = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_7__[/* getTripDuration */ "c"])(state);
  });

  var _useSelector = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_5__[/* facetingCriteriaSelector */ "c"])(state);
  }),
      _useSelector$filters = _useSelector.filters,
      filters = _useSelector$filters === void 0 ? [] : _useSelector$filters;

  var keywords = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_search_search_selector__WEBPACK_IMPORTED_MODULE_6__[/* keywordsSelector */ "a"])(state);
  });
  var kids = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_8__[/* getKids */ "c"])(state) || [];
  });
  var products = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_5__[/* filteredProductsSelector */ "g"])(state) || [];
  });
  var productsCount = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_5__[/* filteredProductsCountSelector */ "e"])(state) || 0;
  });
  var query = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (_ref) {
    var faceting = _ref.faceting;
    return faceting.query || {};
  });
  var redirection = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (_ref2) {
    var faceting = _ref2.faceting;
    return faceting.redirection;
  });
  var profile = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(_store_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_13__[/* userInfoSelector */ "a"]);
  var isFromAutoComplete = Boolean(query.type);
  var nbAdults = adults.length;
  var nbKids = kids.length;
  var nbParticipants = nbAdults + nbKids;
  var searchTerms = isFromAutoComplete || query.label ? query.label : keywords;
  var withFilter = Boolean(nbKids > 0 || duration || departureDate || departureCity || filters.length > 0);

  var executeTracking = function executeTracking(payload) {
    var _profile$loyaltyProgr;

    var searchResorts = products.map(function (product) {
      return {
        resortCode: product.id,
        resortName: product.name,
        resortTrident: product.comfort,
        resortCountry: product.destination ? product.destination.country : null,
        resortRegion: product.destination ? product.destination.area : null,
        resortAdult: nbAdults,
        resortChildren: nbKids,
        resortDepartureCityCode: departureCity,
        resortSeasonType: product.seasonName || 'Summer',
        resortUrlImage: product.image,
        versionBooking: 'responsive',
        resortSeason: departureDate && Object(_utils_tracking_resort__WEBPACK_IMPORTED_MODULE_12__[/* isSummer */ "e"])(new Date(departureDate)) ? 'Summer' : 'Winter',
        resortYearSeason: moment__WEBPACK_IMPORTED_MODULE_3___default()(departureDate).format('YYYY')
      };
    }); // $FlowFixMe

    track(_objectSpread({
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_9__[/* VIRTUAL_PAGE_LOAD */ "y"],
      internalSearchEngineNbResults: redirection ? 'redirection' : productsCount,
      pageName: 'shopping_home_search',
      resortAdult: nbAdults,
      resortChildren: nbKids,
      resortDepartureCityCode: departureCity,
      resortNightNumber: duration,
      resortTotalParticipant: nbParticipants,
      resortTransport: departureCity ? 'with Transport' : null,
      searchDate: moment__WEBPACK_IMPORTED_MODULE_3___default()().format(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__[/* DATE_FORMAT */ "g"]),
      searchDepartureDate: departureDate ? moment__WEBPACK_IMPORTED_MODULE_3___default()(departureDate).format(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__[/* DATE_FORMAT */ "g"]) : null,
      searchDestinationArea: Object(_FacetSearch_utils__WEBPACK_IMPORTED_MODULE_4__[/* getFacetsAsString */ "d"])(filters, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__[/* DESTINATIONS_FACET_ID */ "o"]),
      searchDestinationCountry: Object(_FacetSearch_utils__WEBPACK_IMPORTED_MODULE_4__[/* getFacetsAsString */ "d"])(filters, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__[/* COUNTRIES_FACET_ID */ "f"]),
      searchFilter: withFilter ? 'withFilter' : 'withoutFilter',
      searchRequestType: isFromAutoComplete ? 'Autocomplete' : 'Nocomplete',
      searchTerms: searchTerms || '',
      // $FlowFixMe - Could not get around an issue with Array<TrackingSearchResort>
      searchResorts: searchResorts,
      fidelityStatus: (profile === null || profile === void 0 ? void 0 : (_profile$loyaltyProgr = profile.loyaltyProgram) === null || _profile$loyaltyProgr === void 0 ? void 0 : _profile$loyaltyProgr.status) || ''
    }, payload)); // Reset searchReferrer after each pageView is sent.
    // If searchReferrer === "null", GTM will set it to "search"

    track({
      event: 'PUSH',
      searchReferrer: 'null'
    });
  };

  return executeTracking;
};

/***/ }),

/***/ "O0oS":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("Cwc5");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "O7RO":
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__("CMye"),
    keys = __webpack_require__("7GkX");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ "OFL0":
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__("lvO4"),
    hasPath = __webpack_require__("4sDh");

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),

/***/ "ORYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_SET_ADULTS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRIP_INFORMATION_UPDATE_ADULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ADULTS_NB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ADULT_VALUE; });
var TRIP_INFORMATION_SET_ADULTS_NUMBER = 'TRIP_INFORMATION_SET_ADULTS_NUMBER';
var TRIP_INFORMATION_UPDATE_ADULT = 'TRIP_INFORMATION_UPDATE_ADULT';
var SET_ATTENDEES = 'SET_ATTENDEES';
var SET_ADULTS = 'SET_ADULTS';
var DEFAULT_ADULTS_NB = 2;
var DEFAULT_ADULT_VALUE = {
  birthdate: undefined,
  civility: undefined,
  firstName: undefined,
  lastName: undefined,
  unicodeFirstName: undefined,
  unicodeLastName: undefined,
  neolid: undefined
};

/***/ }),

/***/ "Of+w":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("Cwc5"),
    root = __webpack_require__("Kz5y");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "Onl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockLink; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("NJJ8");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qBqs");
/* harmony import */ var _BlockLink_themes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("uRnh");





var __jsx = react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var BlockLink = /*#__PURE__*/function (_PureComponent) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(BlockLink, _PureComponent);

  var _super = _createSuper(BlockLink);

  function BlockLink() {
    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, BlockLink);

    return _super.apply(this, arguments);
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(BlockLink, [{
    key: "renderTexts",
    value: function renderTexts() {
      var texts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var _this$props$theme = this.props.theme,
          theme = _this$props$theme === void 0 ? 'default' : _this$props$theme;
      return texts.filter(function (text) {
        return !Object(lodash__WEBPACK_IMPORTED_MODULE_6__["isEmpty"])(text);
      }).map(function (text, idx) {
        return __jsx("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(classes, _BlockLink_themes__WEBPACK_IMPORTED_MODULE_10__[/* themes */ "a"][theme]["thCustomText".concat(idx)]),
          "data-testid": "BlockLink-text",
          key: idx
        }, text);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          icon = _this$props.icon,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === void 0 ? function () {} : _this$props$onClick,
          _this$props$secondary = _this$props.secondaryTexts,
          secondaryTexts = _this$props$secondary === void 0 ? [] : _this$props$secondary,
          _this$props$target = _this$props.target,
          target = _this$props$target === void 0 ? '_blank' : _this$props$target,
          _this$props$texts = _this$props.texts,
          texts = _this$props$texts === void 0 ? [] : _this$props$texts,
          _this$props$theme2 = _this$props.theme,
          theme = _this$props$theme2 === void 0 ? 'default' : _this$props$theme2,
          trackingData = _this$props.trackingData,
          _this$props$url = _this$props.url,
          url = _this$props$url === void 0 ? '' : _this$props$url;
      var title = (texts || []).filter(function (t) {
        return typeof t === 'string';
      }).join(' ');
      var linkTarget = url.startsWith('tel:') ? '' : target;
      var _themes$theme = _BlockLink_themes__WEBPACK_IMPORTED_MODULE_10__[/* themes */ "a"][theme],
          thIcon = _themes$theme.thIcon,
          thIconWidth = _themes$theme.thIconWidth,
          thRoot = _themes$theme.thRoot,
          thTexts = _themes$theme.thTexts,
          thSText = _themes$theme.thSText;
      return !!texts.length || icon ? __jsx(_tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_8__[/* TrackClick */ "a"], {
        as: "a",
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(className, thRoot),
        href: url,
        onClick: onClick,
        rel: "noopener noreferrer",
        target: linkTarget,
        title: title,
        trackingData: trackingData
      }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "a"], {
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()('flex-shrink-0', thIcon),
        name: icon,
        width: thIconWidth
      }), !!texts.length && __jsx("span", {
        className: thTexts
      }, this.renderTexts(texts), this.renderTexts(secondaryTexts, thSText))) : null;
    }
  }]);

  return BlockLink;
}(react__WEBPACK_IMPORTED_MODULE_5__["PureComponent"]);

/***/ }),

/***/ "PCgT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridCell; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("I6kL");






var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function getClass(prop, key, css) {
  // $FlowFixMe
  return prop.hasOwnProperty(key) && Object(lodash__WEBPACK_IMPORTED_MODULE_8__["isInteger"])(prop[key]) && prop[key] > 0 ? " ".concat(key).concat(css).concat(prop[key]) : '';
}

function getResponsiveClasses(_ref) {
  var _ref$cols = _ref.cols,
      cols = _ref$cols === void 0 ? _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* DEFAULT_CELL_COLS */ "b"] : _ref$cols,
      _ref$offsets = _ref.offsets,
      offsets = _ref$offsets === void 0 ? {} : _ref$offsets;

  var cellCols = _objectSpread(_objectSpread({}, _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* DEFAULT_CELL_COLS */ "b"]), cols);

  return Object.keys(_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* BREAKPOINTS */ "a"]).map(function (key) {
    return getClass(cellCols, _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* BREAKPOINTS */ "a"][key], '-GridCell--') + getClass(offsets, _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* BREAKPOINTS */ "a"][key], '-GridCell--offset-');
  }).join('');
}

var GridCell = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(GridCell, _React$Component);

  var _super = _createSuper(GridCell);

  function GridCell() {
    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, GridCell);

    return _super.apply(this, arguments);
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(GridCell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          id = _this$props.id;
      if (!react__WEBPACK_IMPORTED_MODULE_6__["Children"].count(children)) return null;
      return __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(className, 'flex-1 max-w-full', "GridCell".concat(getResponsiveClasses(this.props))),
        id: id
      }, children);
    }
  }]);

  return GridCell;
}(react__WEBPACK_IMPORTED_MODULE_6___default.a.Component);

/***/ }),

/***/ "PFCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_DEPARTURE_CITY; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cvSI");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _constants__WEBPACK_IMPORTED_MODULE_0__["u"]; });


var DEFAULT_DEPARTURE_CITY = 'NO';

/***/ }),

/***/ "PSHn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STATUS_CODE_200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STATUS_CODE_400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STATUS_CODE_401; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STATUS_CODE_404; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STATUS_CODE_409; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STATUS_CODE_500; });
var STATUS_CODE_200 = 200;
var STATUS_CODE_400 = 400;
var STATUS_CODE_401 = 401;
var STATUS_CODE_404 = 404;
var STATUS_CODE_409 = 409;
var STATUS_CODE_500 = 500;

/***/ }),

/***/ "PZXw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ WebCallbackTrigger; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx + 1 modules
var SidePanel = __webpack_require__("p7XS");

// EXTERNAL MODULE: ./src/client/components/frameworks/block-link/BlockLink.themes.js
var BlockLink_themes = __webpack_require__("uRnh");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/formik/dist/formik.esm.js + 115 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackFields.jsx

var __jsx = react_default.a.createElement;





function GroupedSelect(_ref) {
  var fieldName = _ref.fieldName,
      position = _ref.position,
      width = _ref.width,
      options = _ref.options,
      onChange = _ref.onChange;
  return __jsx(formik_esm["b" /* Field */], {
    name: fieldName
  }, function (_ref2) {
    var field = _ref2.field,
        errors = _ref2.form.errors;
    return __jsx("div", {
      className: classnames_default()("relative inline-block w-".concat(width, " border-1 overflow-hidden"), {
        'border-r-0': position === 'left',
        'rounded-l-small': position === 'left',
        'rounded-r-small': position === 'right',
        'border-success': !errors[field.name],
        'border-danger': errors[field.name]
      })
    }, __jsx("select", Object(esm_extends["a" /* default */])({
      autoComplete: "off",
      className: "reset-input reset-select relative text-current w-full bg-white px-3 py-2"
    }, field, onChange ? {
      onChange: onChange
    } : null), options.map(function (_ref3) {
      var value = _ref3.value,
          name = _ref3.name;
      return __jsx("option", {
        key: name,
        value: value
      }, name);
    })), __jsx("div", {
      className: "absolute flex h-full items-center top-0 rtl:right-0 pointer-events-none px-2 text-current"
    }, __jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].SELECT,
      width: "0.75rem"
    })));
  });
}
function GroupedInput(_ref4) {
  var fieldName = _ref4.fieldName,
      position = _ref4.position,
      width = _ref4.width,
      _ref4$type = _ref4.type,
      type = _ref4$type === void 0 ? 'text' : _ref4$type,
      _ref4$required = _ref4.required,
      required = _ref4$required === void 0 ? false : _ref4$required;
  return __jsx(formik_esm["b" /* Field */], {
    name: fieldName
  }, function (_ref5) {
    var field = _ref5.field,
        _ref5$form = _ref5.form,
        touched = _ref5$form.touched,
        errors = _ref5$form.errors;
    return __jsx("input", Object(esm_extends["a" /* default */])({
      type: type,
      required: required
    }, field, {
      className: classnames_default()("outline-none shadows-none inline-block w-".concat(width, " px-3 py-2 align-top text-current bg-white border-1"), {
        'border-r-0': position === 'left',
        'rounded-l-small': position === 'left',
        'rounded-r-small': position === 'right',
        'border-gray-medium': !touched[field.name],
        'border-success': touched[field.name] && !errors[field.name],
        'border-danger': touched[field.name] && errors[field.name]
      })
    }));
  });
}
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackForm.utils.js




/* eslint-disable space-before-function-paren */






var ACCOUNT_ID = config_default.a.get('freespee.accountId');
var AGENT_NUMBER = config_default.a.get('freespee.agentNumber');
var AGENT_NUMBER_ID = config_default.a.get('freespee.agentNumberId');
var CALLER_ID = config_default.a.get('freespee.callerId') || '';
var CUSTOMER_ID = config_default.a.get('freespee.customerId');
var FREESPEE_DATE_FORMAT = 'YYYY-MM-DD';
var FREESPEE_TIME_FORMAT = 'HH:mm:ss';
var FREESPEE_DATETIME_FORMAT = "".concat(FREESPEE_DATE_FORMAT, " ").concat(FREESPEE_TIME_FORMAT);
var DISPLAY_TIME_FORMAT = 'HH:mm';
var RETRIES = '2';
var RETRY_INTERVAL = '120';
var ASAP_TIME = 'ASAP';
var CALLBACK_STATUS = {
  UNSCHEDULED: 'unscheduled',
  SCHEDULED: 'scheduled',
  ERROR: 'error'
};
var PHONE_PREFIXES = [{
  countryCode: 'AL',
  value: 355,
  name: '+355 (AL)'
}, {
  countryCode: 'AR',
  value: 54,
  name: '+54 (AR)'
}, {
  countryCode: 'AT',
  value: 43,
  name: '+43 (AT)'
}, {
  countryCode: 'AU',
  value: 61,
  name: '+61 (AU)'
}, {
  countryCode: 'BA',
  value: 387,
  name: '+387 (BA)'
}, {
  countryCode: 'BE',
  value: 32,
  name: '+32 (BE)'
}, {
  countryCode: 'BG',
  value: 359,
  name: '+359 (BG)'
}, {
  countryCode: 'BR',
  value: 55,
  name: '+55 (BR)'
}, {
  countryCode: 'CA',
  value: 1,
  name: '+1 (CA)'
}, {
  countryCode: 'CH',
  value: 41,
  name: '+41 (CH)'
}, {
  countryCode: 'CL',
  value: 56,
  name: '+56 (CL)'
}, {
  countryCode: 'CN',
  value: 86,
  name: '+86 (CN)'
}, {
  countryCode: 'CY',
  value: 357,
  name: '+357 (CY)'
}, {
  countryCode: 'CZ',
  value: 420,
  name: '+420 (CZ)'
}, {
  countryCode: 'DE',
  value: 49,
  name: '+49 (DE)'
}, {
  countryCode: 'DK',
  value: 45,
  name: '+45 (DK)'
}, {
  countryCode: 'EE',
  value: 372,
  name: '+372 (EE)'
}, {
  countryCode: 'EG',
  value: 20,
  name: '+20 (EG)'
}, {
  countryCode: 'ES',
  value: 34,
  name: '+34 (ES)'
}, {
  countryCode: 'FI',
  value: 358,
  name: '+358 (FI)'
}, {
  countryCode: 'FR',
  value: 33,
  name: '+33 (FR)'
}, {
  countryCode: 'GB',
  value: 44,
  name: '+44 (GB)'
}, {
  countryCode: 'GI',
  value: 350,
  name: '+350 (GI)'
}, {
  countryCode: 'GR',
  value: 30,
  name: '+30 (GR)'
}, {
  countryCode: 'HK',
  value: 852,
  name: '+852 (HK)'
}, {
  countryCode: 'HR',
  value: 385,
  name: '+385 (HR)'
}, {
  countryCode: 'HU',
  value: 36,
  name: '+36 (HU)'
}, {
  countryCode: 'IE',
  value: 353,
  name: '+353 (IE)'
}, {
  countryCode: 'IL',
  value: 972,
  name: '+972 (IL)'
}, {
  countryCode: 'IN',
  value: 91,
  name: '+91 (IN)'
}, {
  countryCode: 'IR',
  value: 98,
  name: '+98 (IR)'
}, {
  countryCode: 'IS',
  value: 354,
  name: '+354 (IS)'
}, {
  countryCode: 'IT',
  value: 39,
  name: '+39 (IT)'
}, {
  countryCode: 'JP',
  value: 81,
  name: '+81 (JP)'
}, {
  countryCode: 'LB',
  value: 961,
  name: '+961 (LB)'
}, {
  countryCode: 'LT',
  value: 370,
  name: '+370 (LT)'
}, {
  countryCode: 'LU',
  value: 352,
  name: '+352 (LU)'
}, {
  countryCode: 'LV',
  value: 371,
  name: '+371 (LV)'
}, {
  countryCode: 'MC',
  value: 377,
  name: '+377 (MC)'
}, {
  countryCode: 'MD',
  value: 373,
  name: '+373 (MD)'
}, {
  countryCode: 'MT',
  value: 356,
  name: '+356 (MT)'
}, {
  countryCode: 'MX',
  value: 52,
  name: '+52 (MX)'
}, {
  countryCode: 'NL',
  value: 31,
  name: '+31 (NL)'
}, {
  countryCode: 'NO',
  value: 47,
  name: '+47 (NO)'
}, {
  countryCode: 'NZ',
  value: 64,
  name: '+64 (NZ)'
}, {
  countryCode: 'PA',
  value: 507,
  name: '+507 (PA)'
}, {
  countryCode: 'PE',
  value: 51,
  name: '+51 (PE)'
}, {
  countryCode: 'PK',
  value: 92,
  name: '+92 (PK)'
}, {
  countryCode: 'PL',
  value: 48,
  name: '+48 (PL)'
}, {
  countryCode: 'PT',
  value: 351,
  name: '+351 (PT)'
}, {
  countryCode: 'RO',
  value: 40,
  name: '+40 (RO)'
}, {
  countryCode: 'RS',
  value: 381,
  name: '+381 (RS)'
}, {
  countryCode: 'RU',
  value: 7,
  name: '+7 (RU)'
}, {
  countryCode: 'SE',
  value: 46,
  name: '+46 (SE)'
}, {
  countryCode: 'SG',
  value: 65,
  name: '+65 (SG)'
}, {
  countryCode: 'SI',
  value: 386,
  name: '+386 (SI)'
}, {
  countryCode: 'SK',
  value: 421,
  name: '+421 (SK)'
}, {
  countryCode: 'TH',
  value: 66,
  name: '+66 (TH)'
}, {
  countryCode: 'TR',
  value: 90,
  name: '+90 (TR)'
}, {
  countryCode: 'US',
  value: 1,
  name: '+1 (US)'
}, {
  countryCode: 'ZA',
  value: 27,
  name: '+27 (ZA)'
}];

function hasNameInSlots(slots, name) {
  return slots.some(function (slot) {
    return slot.name === name;
  });
}

var WebCallbackForm_utils_getTimeSlots = function getTimeSlots(_ref) {
  var openingTimesPerDay = _ref.openingTimesPerDay,
      i18n = _ref.i18n;
  if (!openingTimesPerDay) return [];
  var openDays = Object.keys(openingTimesPerDay);
  var asap = i18n.asap,
      today = i18n.today,
      tomorrow = i18n.tomorrow;
  var maxDaysInTheFuture = 7;

  var daysOfWeek = Object(toConsumableArray["a" /* default */])(Array(maxDaysInTheFuture).keys()).map(function (day) {
    return moment_default()().utc().add(day, 'd').locale('en').format('ddd').toLowerCase();
  });

  return Object(toConsumableArray["a" /* default */])(Array(maxDaysInTheFuture).keys()).filter(function (day) {
    var dayOfWeek = moment_default()().utc().add(day, 'd').locale('en').format('ddd');
    return openDays.includes(dayOfWeek.toLowerCase());
  }).map(function (day, idx) {
    var slots = [];
    var dayLabel = daysOfWeek[day];
    var openingTimes = openingTimesPerDay[dayLabel];
    var now = moment_default.a.utc().add(day, 'd');
    var dayOfWeek = now.calendar(null, {
      sameDay: "[".concat(Object(lodash["upperFirst"])(today), "]"),
      nextDay: "[".concat(Object(lodash["upperFirst"])(tomorrow), "]"),
      nextWeek: 'dddd',
      sameElse: 'dddd'
    });
    openingTimes === null || openingTimes === void 0 ? void 0 : openingTimes.forEach(function (openingTime) {
      var _openingTime$from$spl = openingTime.from.split(':'),
          _openingTime$from$spl2 = Object(slicedToArray["a" /* default */])(_openingTime$from$spl, 2),
          beginHour = _openingTime$from$spl2[0],
          beginMinute = _openingTime$from$spl2[1];

      var begin = moment_default.a.utc().startOf('day').hour(parseInt(beginHour, 10)).minute(parseInt(beginMinute, 10));

      var _openingTime$to$split = openingTime.to.split(':'),
          _openingTime$to$split2 = Object(slicedToArray["a" /* default */])(_openingTime$to$split, 2),
          endHour = _openingTime$to$split2[0],
          endMinute = _openingTime$to$split2[1];

      var end = moment_default.a.utc().startOf('day').hour(parseInt(endHour, 10)).minute(parseInt(endMinute, 10));
      var current = begin;

      if (idx === 0) {
        current = moment_default.a.max(now, begin).add(1, 'h').startOf('h');

        if (!hasNameInSlots(slots, Object(lodash["upperFirst"])(asap))) {
          slots.push({
            value: ASAP_TIME,
            name: Object(lodash["upperFirst"])(asap)
          });
        }
      }

      while (current.isBefore(end)) {
        var value = current.format(FREESPEE_DATETIME_FORMAT);
        var slotStart = current.format(DISPLAY_TIME_FORMAT);
        current.add(30, 'm');
        var slotEnd = current.format(DISPLAY_TIME_FORMAT);
        var name = "".concat(slotStart, " - ").concat(slotEnd);

        if (!hasNameInSlots(slots, name)) {
          slots.push({
            value: value,
            name: name
          });
        }
      }
    });
    return {
      value: now.format(FREESPEE_DATE_FORMAT),
      name: Object(lodash["upperFirst"])(dayOfWeek),
      slots: slots
    };
  });
};

function concatIntervalsPerDay(openingTimesPerDay, weekday) {
  var _weekday$intervals;

  if (!(weekday === null || weekday === void 0 ? void 0 : weekday.intervals)) return openingTimesPerDay;
  var openingTimeInterval = weekday === null || weekday === void 0 ? void 0 : (_weekday$intervals = weekday.intervals) === null || _weekday$intervals === void 0 ? void 0 : _weekday$intervals.map(function (interval) {
    return {
      from: interval === null || interval === void 0 ? void 0 : interval.openingTime,
      to: interval === null || interval === void 0 ? void 0 : interval.closingTime
    };
  });

  if (openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day]) {
    openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day] = openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day].concat(openingTimeInterval);
  } else {
    openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day] = openingTimeInterval;
  }

  return openingTimesPerDay;
}

var fetchOpeningHours = /*#__PURE__*/function () {
  var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2, appContext) {
    var setOpeningTimesPerDay, query, data, _openingTimesPerDay;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setOpeningTimesPerDay = _ref2.setOpeningTimesPerDay;
            query = "query {\n    webCallbackHours(customerId: \"".concat(CUSTOMER_ID, "\") {\n      weekdays {\n        day\n        intervals {\n          openingTime\n          closingTime\n        }\n      }\n    }\n  }");
            _context.prev = 2;
            _context.next = 5;
            return graphqlClient["a" /* default */].runQuery(query, appContext, {
              requestName: requestDictionary["Od" /* WIDGET_WEBCALLBACK_OPENING_HOURS */]
            });

          case 5:
            data = _context.sent;
            _openingTimesPerDay = data.webCallbackHours.weekdays.reduce(concatIntervalsPerDay, {});
            if (_openingTimesPerDay && !Object(lodash["isEmpty"])(_openingTimesPerDay)) setOpeningTimesPerDay(_openingTimesPerDay);
            _context.next = 12;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));

  return function fetchOpeningHours(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
var submitCallback = /*#__PURE__*/function () {
  var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref4, appContext) {
    var scheduled, requesterNumber, setCallbackStatus, setSubmitting, schedule, query, _ref6, webCallback;

    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            scheduled = _ref4.scheduled, requesterNumber = _ref4.requesterNumber, setCallbackStatus = _ref4.setCallbackStatus, setSubmitting = _ref4.setSubmitting;
            schedule = scheduled ? "\"".concat(scheduled, "\"") : 'null';
            query = "mutation {\n    webCallback(\n      agentNumber: \"".concat(AGENT_NUMBER, "\",\n      callerId: \"").concat(CALLER_ID, "\",\n      customerId: \"").concat(CUSTOMER_ID, "\",\n      webCallbackInput: {\n        requesterNumber: \"").concat(requesterNumber, "\",\n        scheduled: ").concat(schedule, ",\n        retries: ").concat(RETRIES, ",\n        retryInterval: ").concat(RETRY_INTERVAL, "\n      }) {\n      ... on WebCallback {\n        id\n        type\n        agentNumber\n        callerId\n        requesterNumber\n        retries\n        retryInterval\n      }\n      ... on WebCallbackError {\n        errorCode\n        errorDescription\n        errorKey\n        errorValue        \n      }\n    }\n  }");
            _context2.prev = 3;
            _context2.next = 6;
            return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
              requestName: requestDictionary["Pd" /* WIDGET_WEBCALLBACK_SCHEDULE_CALL */]
            });

          case 6:
            _ref6 = _context2.sent;
            webCallback = _ref6.webCallback;

            if (webCallback.errorCode) {
              setCallbackStatus(CALLBACK_STATUS.ERROR);
            } else {
              setCallbackStatus(CALLBACK_STATUS.SCHEDULED);
            }

            _context2.next = 14;
            break;

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](3);
            setCallbackStatus(CALLBACK_STATUS.ERROR);

          case 14:
            _context2.prev = 14;
            setSubmitting(false);
            return _context2.finish(14);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 11, 14, 17]]);
  }));

  return function submitCallback(_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}();
var requestCallback = function requestCallback(_ref7) {
  var scheduled = _ref7.scheduled,
      requesterNumber = _ref7.requesterNumber,
      requesterNumberPrefix = _ref7.requesterNumberPrefix,
      setCallbackStatus = _ref7.setCallbackStatus,
      setSubmitting = _ref7.setSubmitting;

  try {
    window.__fs_dncs_instance.requestCallback(ACCOUNT_ID, // AVD_ID
    AGENT_NUMBER_ID, // Answering_number_id
    requesterNumberPrefix, // Country_code
    requesterNumber, // customer_phonenr
    CALLER_ID, // caller_id
    {}, // custom_*
    scheduled ? scheduled : null, // call_time,
    function (ref, data) {
      var status = data.status,
          callId = data.call_uuid;

      if (status === 'ok' && callId) {
        setCallbackStatus(CALLBACK_STATUS.SCHEDULED);
      } else {
        setCallbackStatus(CALLBACK_STATUS.ERROR);
      }

      setSubmitting(false);
    }, null, RETRIES // retries
    );
  } catch (error) {
    setCallbackStatus(CALLBACK_STATUS.ERROR);
    setSubmitting(false);
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackForm.jsx


var WebCallbackForm_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var DEFAULT_OPENING_TIME = '10:00:00';
var DEFAULT_CLOSING_TIME = '18:00:00';
var DEFAULT_OPENING_TIMES_PER_DAY = {
  mon: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  tue: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  wed: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  thu: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  fri: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  sat: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  sun: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }]
};
function WebCallbackForm(_ref) {
  var _currentDay$slots, _currentDay$slots$;

  var callbackStatus = _ref.callbackStatus,
      setCallbackStatus = _ref.setCallbackStatus,
      trackingData = _ref.trackingData;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var track = Object(useTracking["a" /* useTracking */])(); // These are UTC times, like what Freespee returns in from_time, to_time.

  var _useState = Object(react["useState"])(DEFAULT_OPENING_TIMES_PER_DAY),
      openingTimesPerDay = _useState[0],
      setOpeningTimesPerDay = _useState[1];

  var timeSlots = Object(react["useMemo"])(function () {
    return WebCallbackForm_utils_getTimeSlots({
      openingTimesPerDay: openingTimesPerDay,
      i18n: {
        asap: Object(src_i18n["f" /* t */])('common.dateTime.asap'),
        today: Object(src_i18n["f" /* t */])('common.dateTime.today'),
        tomorrow: Object(src_i18n["f" /* t */])('common.dateTime.tomorrow')
      }
    });
  }, [openingTimesPerDay]);

  var _timeSlots = Object(slicedToArray["a" /* default */])(timeSlots, 1),
      initialDay = _timeSlots[0];

  var _useState2 = Object(react["useState"])(initialDay),
      currentDay = _useState2[0],
      setCurrentDay = _useState2[1];

  Object(react["useEffect"])(function () {
    fetchOpeningHours({
      setOpeningTimesPerDay: setOpeningTimesPerDay
    }, appContext);
  }, []);
  Object(react["useEffect"])(function () {
    var _timeSlots2 = Object(slicedToArray["a" /* default */])(timeSlots, 1),
        newDay = _timeSlots2[0];

    setCurrentDay(newDay);
  }, [timeSlots]);
  if (!currentDay) return null;
  var localPhonePrefix = PHONE_PREFIXES.find(function (prefix) {
    var country = appContext.locale.split('-')[1];
    return country === prefix.countryCode;
  });
  var initialPhonePrefix = localPhonePrefix || PHONE_PREFIXES.find(function (prefix) {
    return prefix.countryCode === 'FR';
  }) || {};

  var changeDay = function changeDay(event, setFieldValue) {
    var dayValue = event.target.value;
    var newDay = timeSlots.find(function (slot) {
      return slot.value === dayValue;
    });

    if (newDay) {
      setCurrentDay(newDay);
      setFieldValue('slotDay', newDay.value, false);
    }
  };

  return WebCallbackForm_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      slotDay: currentDay.value,
      slotTime: currentDay === null || currentDay === void 0 ? void 0 : (_currentDay$slots = currentDay.slots) === null || _currentDay$slots === void 0 ? void 0 : (_currentDay$slots$ = _currentDay$slots[0]) === null || _currentDay$slots$ === void 0 ? void 0 : _currentDay$slots$.value,
      phonePrefix: initialPhonePrefix.value,
      phoneNumber: ''
    },
    validate: function validate(_ref2) {
      var phoneNumber = _ref2.phoneNumber;
      var errors = {};

      if (!phoneNumber) {
        errors.phoneNumber = 'Phone number is required';
      } // https://www.twilio.com/docs/glossary/what-e164


      if (!/^[1-9]\d{1,14}$/.test(phoneNumber)) {
        errors.phoneNumber = 'Phone number is not valid';
      }

      return errors;
    },
    onSubmit: function onSubmit(formValues, _ref3) {
      var setSubmitting = _ref3.setSubmitting;
      var slotTime = formValues.slotTime,
          phonePrefix = formValues.phonePrefix,
          phoneNumber = formValues.phoneNumber;
      requestCallback({
        scheduled: slotTime === ASAP_TIME ? null : slotTime,
        requesterNumber: "+".concat(phonePrefix).concat(phoneNumber),
        requesterNumberPrefix: phonePrefix,
        setCallbackStatus: setCallbackStatus,
        setSubmitting: setSubmitting
      });
      track(_objectSpread({
        categoryGA: pageContext.pageId,
        labelGA: tracking_constants["A" /* WEB_CALLBACK_SUBMIT */]
      }, trackingData));
    }
  }, function (_ref4) {
    var isValid = _ref4.isValid,
        isSubmitting = _ref4.isSubmitting,
        setFieldValue = _ref4.setFieldValue;
    var isDisabled = callbackStatus !== CALLBACK_STATUS.UNSCHEDULED || !isValid;
    return WebCallbackForm_jsx(formik_esm["c" /* Form */], {
      "data-testid": "web-callback-form",
      className: "h-full"
    }, WebCallbackForm_jsx("div", {
      className: "flex flex-col justify-between h-full w-full bg-gray-200"
    }, WebCallbackForm_jsx("div", {
      className: "w-full bg-ardoise",
      style: {
        backgroundImage: "url(\"".concat(Object(src_i18n["f" /* t */])('webCallback.picture'), "\")"),
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '150px'
      }
    }), WebCallbackForm_jsx("div", {
      className: "flex-auto px-6 py-5"
    }, WebCallbackForm_jsx("h3", {
      className: "my-0",
      id: constants["y" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */]
    }, Object(src_i18n["f" /* t */])('webCallback.title')), WebCallbackForm_jsx("p", null, Object(src_i18n["f" /* t */])('webCallback.subtitle')), callbackStatus !== CALLBACK_STATUS.UNSCHEDULED ? WebCallbackForm_jsx(Notification["a" /* Notification */], {
      color: callbackStatus === CALLBACK_STATUS.SCHEDULED ? colors["a" /* COLORS */].SUCCESS : colors["a" /* COLORS */].WARNING,
      hasBorder: true,
      icon: callbackStatus === CALLBACK_STATUS.SCHEDULED ? icons["a" /* ICONS */].SMALL_CIRCLE_CHECK : icons["a" /* ICONS */].CIRCLED_CROSS,
      iconWidth: "1rem"
    }, WebCallbackForm_jsx("p", {
      className: "m-0 text-base text-".concat(callbackStatus === CALLBACK_STATUS.SCHEDULED ? colors["a" /* COLORS */].SUCCESS : colors["a" /* COLORS */].WARNING)
    }, callbackStatus === CALLBACK_STATUS.SCHEDULED ? Object(src_i18n["f" /* t */])('webCallback.successMessage') : Object(src_i18n["f" /* t */])('webCallback.errorMessage'))) : WebCallbackForm_jsx(react["Fragment"], null, WebCallbackForm_jsx("div", {
      className: "inline-block w-full md:w-3/5 mb-3 md:pr-2"
    }, WebCallbackForm_jsx("label", {
      className: "block w-full p-1 text-sm"
    }, Object(src_i18n["f" /* t */])('webCallback.timeLabel')), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "slotDay",
      position: "left",
      width: "2/5" // $FlowFixMe
      ,
      options: timeSlots,
      onChange: function onChange(e) {
        return changeDay(e, setFieldValue);
      }
    }), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "slotTime",
      position: "right",
      width: "3/5" // $FlowFixMe
      ,
      options: currentDay.slots
    })), WebCallbackForm_jsx("div", {
      className: "inline-block w-full md:w-2/5 mb-3"
    }, WebCallbackForm_jsx("label", {
      className: "block w-full p-1 text-sm"
    }, Object(src_i18n["f" /* t */])('webCallback.phoneLabel')), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "phonePrefix",
      position: "left",
      width: "1/2",
      options: PHONE_PREFIXES
    }), WebCallbackForm_jsx(GroupedInput, {
      fieldName: "phoneNumber",
      position: "right",
      width: "1/2",
      type: "tel",
      required: true
    })))), WebCallbackForm_jsx("div", {
      className: "flex justify-end px-6 w-full",
      style: {
        minHeight: '3.75rem'
      }
    }, callbackStatus === CALLBACK_STATUS.UNSCHEDULED ? WebCallbackForm_jsx(Button["a" /* Button */], {
      className: "self-center w-full md:w-1/2 text-center",
      type: "submit",
      isLoading: isSubmitting,
      isDisabled: isDisabled
    }, Object(src_i18n["f" /* t */])('webCallback.callToAction')) : null)));
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackTrigger.jsx

var WebCallbackTrigger_jsx = react_default.a.createElement;

function WebCallbackTrigger_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function WebCallbackTrigger_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WebCallbackTrigger_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WebCallbackTrigger_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














function WebCallbackTrigger(_ref) {
  var trackingData = _ref.trackingData,
      children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet,
      isAppMounted = _useContext.isAppMounted;

  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var track = Object(useTracking["a" /* useTracking */])();

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = Object(react["useState"])(CALLBACK_STATUS.UNSCHEDULED),
      callbackStatus = _useState2[0],
      setCallbackStatus = _useState2[1];

  var webCallbackModal = isOpen ? WebCallbackTrigger_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["f" /* t */])('webCallback.title'),
    ariaLabelledby: constants["y" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */],
    closeLabel: Object(src_i18n["f" /* t */])('common.close'),
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, WebCallbackTrigger_jsx(WebCallbackForm, {
    callbackStatus: callbackStatus,
    setCallbackStatus: setCallbackStatus,
    trackingData: trackingData
  })) : null;

  var webCallbackDrawer = WebCallbackTrigger_jsx(SidePanel["a" /* SidePanel */], {
    ariaLabel: Object(src_i18n["f" /* t */])('webCallback.title'),
    ariaLabelledby: constants["y" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */],
    closeLabel: Object(src_i18n["f" /* t */])('common.close'),
    isExpanded: isOpen,
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, WebCallbackTrigger_jsx("div", {
    className: "h-full w-full fadeIn"
  }, WebCallbackTrigger_jsx(WebCallbackForm, {
    callbackStatus: callbackStatus,
    setCallbackStatus: setCallbackStatus,
    trackingData: trackingData
  })));

  var webCallbackPopin = isTablet ? webCallbackModal : webCallbackDrawer;
  return WebCallbackTrigger_jsx(react["Fragment"], null, isAppMounted ? webCallbackPopin : null, WebCallbackTrigger_jsx("button", {
    type: "button",
    className: classnames_default()(BlockLink_themes["a" /* themes */][theme].thRoot, 'bg-transparent'),
    onClick: function onClick() {
      setCallbackStatus(CALLBACK_STATUS.UNSCHEDULED);
      setIsOpen(true);

      if (isOpen === false && trackingData) {
        track(WebCallbackTrigger_objectSpread({
          categoryGA: pageContext.pageId,
          labelGA: tracking_constants["z" /* WEB_CALLBACK_OPEN */]
        }, trackingData));
      }
    }
  }, children));
}

/***/ }),

/***/ "Phb7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__("ERkP");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("aWzz");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _subscribeUiEvent = __webpack_require__("GJxp");

var _classnames = __webpack_require__("O94r");

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = __webpack_require__("Pu0A");

var _shallowequal2 = _interopRequireDefault(_shallowequal);

// constants
var STATUS_ORIGINAL = 0; // The default status, locating at the original position.
var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.
var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.

var TRANSFORM_PROP = 'transform';

// global variable for all instances
var doc;
var docBody;
var docEl;
var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr
var M;
var scrollDelta = 0;
var win;
var winHeight = -1;

var Sticky = (function (_Component) {
    _inherits(Sticky, _Component);

    function Sticky(props, context) {
        _classCallCheck(this, Sticky);

        _get(Object.getPrototypeOf(Sticky.prototype), 'constructor', this).call(this, props, context);
        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleScrollStart = this.handleScrollStart.bind(this);
        this.delta = 0;
        this.stickyTop = 0;
        this.stickyBottom = 0;
        this.frozen = false;
        this.skipNextScrollEvent = false;
        this.scrollTop = -1;

        this.bottomBoundaryTarget;
        this.topTarget;
        this.subscribers;

        this.state = {
            top: 0, // A top offset from viewport top where Sticky sticks to when scrolling up
            bottom: 0, // A bottom offset from viewport top where Sticky sticks to when scrolling down
            width: 0, // Sticky width
            height: 0, // Sticky height
            x: 0, // The original x of Sticky
            y: 0, // The original y of Sticky
            topBoundary: 0, // The top boundary on document
            bottomBoundary: Infinity, // The bottom boundary on document
            status: STATUS_ORIGINAL, // The Sticky status
            pos: 0, // Real y-axis offset for rendering position-fixed and position-relative
            activated: false // once browser info is available after mounted, it becomes true to avoid checksum error
        };
    }

    _createClass(Sticky, [{
        key: 'getTargetHeight',
        value: function getTargetHeight(target) {
            return target && target.offsetHeight || 0;
        }
    }, {
        key: 'getTopPosition',
        value: function getTopPosition(top) {
            // a top argument can be provided to override reading from the props
            top = top || this.props.top || 0;
            if (typeof top === 'string') {
                if (!this.topTarget) {
                    this.topTarget = doc.querySelector(top);
                }
                top = this.getTargetHeight(this.topTarget);
            }
            return top;
        }
    }, {
        key: 'getTargetBottom',
        value: function getTargetBottom(target) {
            if (!target) {
                return -1;
            }
            var rect = target.getBoundingClientRect();
            return this.scrollTop + rect.bottom;
        }
    }, {
        key: 'getBottomBoundary',
        value: function getBottomBoundary(bottomBoundary) {
            // a bottomBoundary can be provided to avoid reading from the props
            var boundary = bottomBoundary || this.props.bottomBoundary;

            // TODO, bottomBoundary was an object, depricate it later.
            if (typeof boundary === 'object') {
                boundary = boundary.value || boundary.target || 0;
            }

            if (typeof boundary === 'string') {
                if (!this.bottomBoundaryTarget) {
                    this.bottomBoundaryTarget = doc.querySelector(boundary);
                }
                boundary = this.getTargetBottom(this.bottomBoundaryTarget);
            }
            return boundary && boundary > 0 ? boundary : Infinity;
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.setState({
                status: STATUS_ORIGINAL,
                pos: 0
            });
        }
    }, {
        key: 'release',
        value: function release(pos) {
            this.setState({
                status: STATUS_RELEASED,
                pos: pos - this.state.y
            });
        }
    }, {
        key: 'fix',
        value: function fix(pos) {
            this.setState({
                status: STATUS_FIXED,
                pos: pos
            });
        }

        /**
         * Update the initial position, width, and height. It should update whenever children change.
         * @param {Object} options optional top and bottomBoundary new values
         */
    }, {
        key: 'updateInitialDimension',
        value: function updateInitialDimension(options) {
            options = options || {};

            var outerRect = this.outerElement.getBoundingClientRect();
            var innerRect = this.innerElement.getBoundingClientRect();

            var width = outerRect.width || outerRect.right - outerRect.left;
            var height = innerRect.height || innerRect.bottom - innerRect.top;;
            var outerY = outerRect.top + this.scrollTop;

            this.setState({
                top: this.getTopPosition(options.top),
                bottom: Math.min(this.state.top + height, winHeight),
                width: width,
                height: height,
                x: outerRect.left,
                y: outerY,
                bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
                topBoundary: outerY
            });
        }
    }, {
        key: 'handleResize',
        value: function handleResize(e, ae) {
            if (this.props.shouldFreeze()) {
                return;
            }

            winHeight = ae.resize.height;
            this.updateInitialDimension();
            this.update();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart(e, ae) {
            this.frozen = this.props.shouldFreeze();

            if (this.frozen) {
                return;
            }

            if (this.scrollTop === ae.scroll.top) {
                // Scroll position hasn't changed,
                // do nothing
                this.skipNextScrollEvent = true;
            } else {
                this.scrollTop = ae.scroll.top;
                this.updateInitialDimension();
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e, ae) {
            // Scroll doesn't need to be handled
            if (this.skipNextScrollEvent) {
                this.skipNextScrollEvent = false;
                return;
            }

            scrollDelta = ae.scroll.delta;
            this.scrollTop = ae.scroll.top;
            this.update();
        }

        /**
         * Update Sticky position.
         */
    }, {
        key: 'update',
        value: function update() {
            var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;

            if (disabled) {
                if (this.state.status !== STATUS_ORIGINAL) {
                    this.reset();
                }
                return;
            }

            var delta = scrollDelta;
            // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
            // on document from viewport.
            var top = this.scrollTop + this.state.top;
            var bottom = this.scrollTop + this.state.bottom;

            // There are 2 principles to make sure Sticky won't get wrong so much:
            // 1. Reset Sticky to the original postion when "top" <= topBoundary
            // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary
            if (top <= this.state.topBoundary) {
                // #1
                this.reset();
            } else if (bottom >= this.state.bottomBoundary) {
                // #2
                this.stickyBottom = this.state.bottomBoundary;
                this.stickyTop = this.stickyBottom - this.state.height;
                this.release(this.stickyTop);
            } else {
                if (this.state.height > winHeight - this.state.top) {
                    // In this case, Sticky is higher then viewport minus top offset
                    switch (this.state.status) {
                        case STATUS_ORIGINAL:
                            this.release(this.state.y);
                            this.stickyTop = this.state.y;
                            this.stickyBottom = this.stickyTop + this.state.height;
                        // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
                        // from ORIGINAL when calling window.scrollTo().
                        // break;
                        case STATUS_RELEASED:
                            // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
                            // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
                            // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
                            this.stickyBottom = this.stickyTop + this.state.height;
                            if (delta > 0 && bottom > this.stickyBottom) {
                                this.fix(this.state.bottom - this.state.height);
                            } else if (delta < 0 && top < this.stickyTop) {
                                this.fix(this.state.top);
                            }
                            break;
                        case STATUS_FIXED:
                            var toRelease = true;
                            var pos = this.state.pos;
                            var height = this.state.height;
                            // In regular cases, when Sticky is in FIXED status,
                            // 1. it's top will stick to the screen top,
                            // 2. it's bottom will stick to the screen bottom,
                            // 3. if not the cases above, then it's height gets changed
                            if (delta > 0 && pos === this.state.top) {
                                // case 1, and scrolling down
                                this.stickyTop = top - delta;
                                this.stickyBottom = this.stickyTop + height;
                            } else if (delta < 0 && pos === this.state.bottom - height) {
                                // case 2, and scrolling up
                                this.stickyBottom = bottom - delta;
                                this.stickyTop = this.stickyBottom - height;
                            } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
                                // case 3
                                // This case only happens when Sticky's bottom sticks to the screen bottom and
                                // its height gets changed. Sticky should be in RELEASE status and update its
                                // sticky bottom by calculating how much height it changed.
                                var deltaHeight = pos + height - this.state.bottom;
                                this.stickyBottom = bottom - delta + deltaHeight;
                                this.stickyTop = this.stickyBottom - height;
                            } else {
                                toRelease = false;
                            }

                            if (toRelease) {
                                this.release(this.stickyTop);
                            }
                            break;
                    }
                } else {
                    // In this case, Sticky is shorter then viewport minus top offset
                    // and will always fix to the top offset of viewport
                    this.fix(this.state.top);
                }
            }
            this.delta = delta;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this = this;

            if (prevState.status !== this.state.status && this.props.onStateChange) {
                this.props.onStateChange({ status: this.state.status });
            }
            var arePropsChanged = !(0, _shallowequal2['default'])(this.props, prevProps);
            if (arePropsChanged) {
                // if the props for enabling are toggled, then trigger the update or reset depending on the current props
                if (prevProps.enabled !== this.props.enabled) {
                    if (this.props.enabled) {
                        this.setState({ activated: true }, function () {
                            _this.updateInitialDimension();
                            _this.update();
                        });
                    } else {
                        this.setState({ activated: false }, function () {
                            _this.reset();
                        });
                    }
                }
                // if the top or bottomBoundary props were changed, then trigger the update
                else if (prevProps.top !== this.props.top || prevProps.bottomBoundary !== this.props.bottomBoundary) {
                        this.updateInitialDimension();
                        this.update();
                    }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var subscribers = this.subscribers || [];
            for (var i = subscribers.length - 1; i >= 0; i--) {
                this.subscribers[i].unsubscribe();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Only initialize the globals if this is the first
            // time this component type has been mounted
            if (!win) {
                win = window;
                doc = document;
                docEl = doc.documentElement;
                docBody = doc.body;
                winHeight = win.innerHeight || docEl.clientHeight;
                M = window.Modernizr;
                // No Sticky on lower-end browser when no Modernizr
                if (M && M.prefixed) {
                    canEnableTransforms = M.csstransforms3d;
                    TRANSFORM_PROP = M.prefixed('transform');
                }
            }

            // when mount, the scrollTop is not necessary on the top
            this.scrollTop = docBody.scrollTop + docEl.scrollTop;

            if (this.props.enabled) {
                this.setState({ activated: true });
                this.updateInitialDimension();
                this.update();
            }
            // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality
            this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), { useRAF: true }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), { useRAF: true, enableScrollInfo: true }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), { enableResizeInfo: true })];
        }
    }, {
        key: 'translate',
        value: function translate(style, pos) {
            var enableTransforms = canEnableTransforms && this.props.enableTransforms;
            if (enableTransforms && this.state.activated) {
                style[TRANSFORM_PROP] = 'translate3d(0,' + Math.round(pos) + 'px,0)';
            } else {
                style.top = pos + 'px';
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return !this.props.shouldFreeze() && !((0, _shallowequal2['default'])(this.props, nextProps) && (0, _shallowequal2['default'])(this.state, nextState));
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this2 = this;

            // TODO, "overflow: auto" prevents collapse, need a good way to get children height
            var innerStyle = {
                position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
                top: this.state.status === STATUS_FIXED ? '0px' : '',
                zIndex: this.props.innerZ
            };
            var outerStyle = {};

            // always use translate3d to enhance the performance
            this.translate(innerStyle, this.state.pos);
            if (this.state.status !== STATUS_ORIGINAL) {
                innerStyle.width = this.state.width + 'px';
                outerStyle.height = this.state.height + 'px';
            }

            var outerClasses = (0, _classnames2['default'])('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));

            var children = this.props.children;

            return _react2['default'].createElement(
                'div',
                { ref: function (outer) {
                        _this2.outerElement = outer;
                    }, className: outerClasses, style: outerStyle },
                _react2['default'].createElement(
                    'div',
                    { ref: function (inner) {
                            _this2.innerElement = inner;
                        }, className: ['sticky-inner-wrapper', this.props.innerClass].join(' '), style: innerStyle },
                    typeof children === 'function' ? children({ status: this.state.status }) : children
                )
            );
        }
    }]);

    return Sticky;
})(_react.Component);

Sticky.displayName = 'Sticky';

Sticky.defaultProps = {
    shouldFreeze: function shouldFreeze() {
        return false;
    },
    enabled: true,
    top: 0,
    bottomBoundary: 0,
    enableTransforms: true,
    activeClass: 'active',
    releasedClass: 'released',
    onStateChange: null,
    innerClass: ''
};

/**
 * @param {Bool} enabled A switch to enable or disable Sticky.
 * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
 *        whose height should serve as the top offset.
 * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
 *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
 */
Sticky.propTypes = {
    enabled: _propTypes2['default'].bool,
    top: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
    bottomBoundary: _propTypes2['default'].oneOfType([_propTypes2['default'].object, // TODO, may remove
    _propTypes2['default'].string, _propTypes2['default'].number]),
    enableTransforms: _propTypes2['default'].bool,
    activeClass: _propTypes2['default'].string,
    releasedClass: _propTypes2['default'].string,
    innerClass: _propTypes2['default'].string,
    onStateChange: _propTypes2['default'].func,
    shouldFreeze: _propTypes2['default'].func,
    innerZ: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])
};

Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
Sticky.STATUS_RELEASED = STATUS_RELEASED;
Sticky.STATUS_FIXED = STATUS_FIXED;

module.exports = Sticky;


/***/ }),

/***/ "Pu0A":
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ "Qmkj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESORT_PRODUCT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getResultItem; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("47go");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var COMFORT_EXCLUSIVE = 5;
var REGEXP_DYNAMIC_CRUISE = /^CM2C_\d{8}_\d{8}$/;
var RESORT_PRODUCT_TYPE = 'resort';

function getType(item) {
  return item.product_id ? RESORT_PRODUCT_TYPE : item.type || item.section || '';
}

function isItemResort(item) {
  return getType(item) === RESORT_PRODUCT_TYPE;
}

function getLabel(item) {
  var label = striptags__WEBPACK_IMPORTED_MODULE_1___default()(item.value || '', '<span>');
  return isItemResort(item) && item.sibling_id ? "".concat(label, " - ").concat(item.season || '') : label;
}

function isCruise(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.CRUISE;
}

function isDynamicCruise(item) {
  return isCruise(item) && REGEXP_DYNAMIC_CRUISE.test(item.product_id || '');
}

function isJoyview(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.JOYVIEW;
}

function isTour(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.TOUR;
}

function isVilla(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.VILLA;
}

function isExclusiveComfort(item) {
  return Number(item.comfort_level) >= COMFORT_EXCLUSIVE;
}

function isExclusiveCollection(item) {
  return isVilla(item) || isCruise(item) || isExclusiveComfort(item);
}

function getProductId(item) {
  return isItemResort(item) ? item.product_id : null;
}

function getProductSeason(item) {
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["resortAction"].getSeasonInfos(item.sibling_id ? item.season_id : _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].ALL_YEAR);
}

function getProductUrl(item) {
  var productUrl = new urijs__WEBPACK_IMPORTED_MODULE_2___default.a('/');

  if (isDynamicCruise(item)) {
    productUrl.segment('c').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizePath((item.product_id || '').split('_').join('/')));
  } else if (isTour(item)) {
    productUrl.segment('i').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeSlug(item.title)).segment(getProductSeason(item));
  } else {
    productUrl.segment('r').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeSlug(item.title)).segment(getProductSeason(item));
  }

  return productUrl.toString();
}

function getLink(item) {
  return isItemResort(item) ? getProductUrl(item) : item.url;
}

function getHeadlines(item) {
  return isItemResort(item) ? {
    subLabel1: Array.isArray(item.destination_country) ? item.destination_country.join(', ') : item.destination_country,
    subLabel2: item.destination_area,
    image: item.immersive_image,
    productId: item.product_id,
    productType: item.type,
    comfortLevel: item.comfort_level,
    season: Array.isArray(item.season) ? '' : item.season
  } : {};
}

function getIcon(item) {
  var comfortLevel = item.comfort_level || 1;

  switch (item.type) {
    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.CRUISE:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CRUISE;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.JOYVIEW:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRIDENT_JOYVIEW;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.TOUR:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TOUR;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.RESORT:
    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.VILLA:
      return comfortLevel === String(COMFORT_EXCLUSIVE) ? null : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"]["TRIDENT".concat(comfortLevel)];

    default:
      return item.type === 'activity' ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ACTIVITIES : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ADDRESS;
  }
}

function getColor(item) {
  if (isExclusiveCollection(item)) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].DEEP_BLUE;
  }

  if (isJoyview(item)) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WATER_GREEN;
  }

  return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLUE;
}

var getTagsColor = function getTagsColor(item) {
  var seasonName = Array.isArray(item.seasons_id) ? '' : item.seasons_id;

  if (seasonName === _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].SEASONS.SUMMER) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].ORANGE;
  }

  if (isTour(item) || isCruise(item)) {
    return getColor(item);
  }

  return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLUE;
};

function getResultItem(item) {
  return _objectSpread({
    icon: getIcon(item),
    id: getProductId(item) || getLabel(item),
    isExclusiveCollection: isExclusiveCollection(item),
    label: getLabel(item),
    link: getLink(item),
    productColor: getColor(item),
    product_id: getProductId(item),
    tagsColor: getTagsColor(item),
    type: getType(item)
  }, getHeadlines(item));
}

/***/ }),

/***/ "QoRX":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "Qosd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return POPIN_NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NEWSLETTER_SUBSCRIPTION_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PopinNewsletter; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("uDfI");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ljKo");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ub5k");
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/Mt0");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("YZTm");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("UCZK");
/* harmony import */ var _profile_info_newsletter_subscription_NewsletterSubscription_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("p9RO");
/* harmony import */ var _views_newsletter_newsletterActions__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("TnNS");
/* harmony import */ var _utils_ratios_ratios_utils_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("u/u4");
/* harmony import */ var _frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_form_errors_FormErrors_jsx__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("8miM");
/* harmony import */ var _frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("/HC4");
/* harmony import */ var _frameworks_image_Image_jsx__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_modal_Modal_jsx__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("EvYw");
/* harmony import */ var _frameworks_text_Text_jsx__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_title_Title_jsx__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("MWZw");
/* harmony import */ var _newsletter_form_NewsletterForm_jsx__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("9KBE");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }























var POPIN_NEWSLETTER = 'POPIN_NEWSLETTER';
var NEWSLETTER_SUBSCRIPTION_VALIDATION = 'NEWSLETTER_SUBSCRIPTION_VALIDATION';
function PopinNewsletter(_ref) {
  var _ref$checkboxes = _ref.checkboxes,
      checkboxes = _ref$checkboxes === void 0 ? [] : _ref$checkboxes,
      _ref$legalInformation = _ref.legalInformations,
      legalInformations = _ref$legalInformation === void 0 ? [] : _ref$legalInformation,
      onClose = _ref.onClose;
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"]);
  var defaultPayload = {
    categoryGA: 'newsletter',
    actionGA: 'shopping'
  };
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__[/* useTracking */ "a"])(defaultPayload);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])([]),
      submitErrors = _useState[0],
      setSubmitErrors = _useState[1];

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_4__[/* useDispatch */ "d"])();

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"]),
      isTablet = _useContext.isTablet;

  var labelConfirmation = "".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.confirmation.headline'), " \n ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.confirmation.description'));
  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    return track({
      labelGA: 'displayPopin'
    });
  }, []);
  return __jsx(_frameworks_modal_Modal_jsx__WEBPACK_IMPORTED_MODULE_21__[/* Modal */ "a"], {
    ariaLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.popin.title'),
    ariaLabelledby: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_11__[/* ID_MODAL_HEADER__PLE__NEWSLETTER */ "x"],
    backdropColor: "#000",
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('common.close'),
    onClose: onClose,
    size: "large"
  }, __jsx(_frameworks_image_Image_jsx__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"], {
    className: "w-full sm:w-12/25 md:w-1/3 h-full flex-shrink-0 sm:absolute",
    imageUrl: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.popin.imageUrl'),
    mandatoryWidthAndHeight: isTablet ? {
      w: 320,
      h: 700
    } : {
      w: 500,
      h: 200
    },
    ratioKey: _utils_ratios_ratios_utils_js__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"].XS
  }), __jsx("div", {
    className: "PopinNewsletter-content m-6"
  }, __jsx(_frameworks_title_Title_jsx__WEBPACK_IMPORTED_MODULE_23__[/* Title */ "a"], {
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_12__[/* ICONS */ "a"].NEWSLETTER,
    id: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_11__[/* ID_MODAL_HEADER__PLE__NEWSLETTER */ "x"],
    theme: "title-brand-2",
    iconSize: "1.5rem",
    iconColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__[/* COLORS */ "a"].BLUE
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.popin.title')), __jsx(_frameworks_text_Text_jsx__WEBPACK_IMPORTED_MODULE_22__[/* Text */ "a"], {
    className: "mt-2 mb-3",
    text: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.popin.subtitle')
  }), __jsx(formik__WEBPACK_IMPORTED_MODULE_6__[/* Formik */ "d"], {
    validationSchema: _newsletter_form_NewsletterForm_jsx__WEBPACK_IMPORTED_MODULE_24__[/* subscriptionSchema */ "b"],
    initialValues: _objectSpread({}, checkboxes.reduce(function (newslettersCheckbox, newsletter) {
      newslettersCheckbox[newsletter.id] = false;
      return newslettersCheckbox;
    }, {})),
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(values) {
        var response, error;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(_views_newsletter_newsletterActions__WEBPACK_IMPORTED_MODULE_15__[/* submitSubscriptionForm */ "b"])({
                  appContext: appContext,
                  data: Object(_views_newsletter_newsletterActions__WEBPACK_IMPORTED_MODULE_15__[/* formatedData */ "a"])(values),
                  isSubscription: true
                });

              case 2:
                response = _context.sent;
                track({
                  labelGA: 'registrationPopin',
                  user: {
                    neolaneID: Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(response, 'subscription.neolaneId')
                  }
                });
                error = Object(lodash__WEBPACK_IMPORTED_MODULE_5__["get"])(response, 'subscription.error.errorDescription', '');

                if (Object(lodash__WEBPACK_IMPORTED_MODULE_5__["isEmpty"])(error)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", setSubmitErrors([error]));

              case 7:
                dispatch({
                  type: NEWSLETTER_SUBSCRIPTION_VALIDATION,
                  payload: {
                    toastLabel: labelConfirmation
                  }
                });
                onClose && onClose();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()
  }, function (_ref3) {
    var setFieldValue = _ref3.setFieldValue,
        isValid = _ref3.isValid;
    return __jsx(formik__WEBPACK_IMPORTED_MODULE_6__[/* Form */ "c"], null, __jsx(_newsletter_form_NewsletterForm_jsx__WEBPACK_IMPORTED_MODULE_24__[/* NewsletterForm */ "a"], null), checkboxes.map(function (checkbox) {
      return __jsx("div", {
        className: "mt-4",
        key: checkbox.id
      }, __jsx(_frameworks_formik_FormikInput_jsx__WEBPACK_IMPORTED_MODULE_19__[/* FormikInput */ "a"], {
        name: checkbox.id,
        type: "checkbox",
        label: checkbox.description,
        value: checkbox.id,
        onChange: function onChange(e) {
          return Object(_profile_info_newsletter_subscription_NewsletterSubscription_utils__WEBPACK_IMPORTED_MODULE_14__[/* onCheckboxChange */ "b"])(e.target, setFieldValue);
        }
      }));
    }), __jsx("div", {
      className: "mt-4 text-right"
    }, !Object(lodash__WEBPACK_IMPORTED_MODULE_5__["isEmpty"])(submitErrors) && __jsx(_frameworks_form_errors_FormErrors_jsx__WEBPACK_IMPORTED_MODULE_18__[/* FormErrors */ "a"], {
      texts: submitErrors
    }), __jsx(_frameworks_button_Button_jsx__WEBPACK_IMPORTED_MODULE_17__[/* Button */ "a"], {
      type: "submit",
      colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__[/* COLORS */ "a"].BLUE,
      colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__[/* COLORS */ "a"].BLUE,
      isDisabled: !isValid
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "f"])('newsletter.popin.cta'))));
  }), __jsx("div", {
    className: "mt-4"
  }, legalInformations.map(function (info) {
    return !Object(lodash__WEBPACK_IMPORTED_MODULE_5__["isEmpty"])(info.description) ? __jsx("div", {
      key: "LegalInfo-".concat(info.id)
    }, __jsx(_frameworks_text_Text_jsx__WEBPACK_IMPORTED_MODULE_22__[/* Text */ "a"], {
      theme: "text-sans-2",
      text: info.description
    })) : null;
  }))));
}

/***/ }),

/***/ "QqLw":
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__("tadb"),
    Map = __webpack_require__("ebwN"),
    Promise = __webpack_require__("HOxn"),
    Set = __webpack_require__("yGk4"),
    WeakMap = __webpack_require__("Of+w"),
    baseGetTag = __webpack_require__("NykK"),
    toSource = __webpack_require__("3Fdi");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "R/W3":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("KwMD"),
    baseIsNaN = __webpack_require__("2ajD"),
    strictIndexOf = __webpack_require__("CZoQ");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ "R2jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return START_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return endLoading; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var START_LOADING = 'START_LOADING';
var END_LOADING = 'END_LOADING';

function endLoading() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(END_LOADING, {});
}

function startLoading(globalLoaderLabel, isNavigation) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(START_LOADING, {
    globalLoaderLabel: globalLoaderLabel,
    isNavigation: isNavigation
  });
}



/***/ }),

/***/ "R3QM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_BOOKING_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_BOOKING_DETAILS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_BOOKING_DETAILS_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_BOOKING_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_BOOKING_ATTENDEES_PACKAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_BOOKING_ATTENDEES_PACKAGE_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_BOOKING_ATTENDEES_PACKAGE_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_BOOKING_ATTENDEES_PACKAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_BOOKING_PRICE_AND_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_BOOKING_PRICE_AND_PAYMENT_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_BOOKING_PRICE_AND_PAYMENT_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_BOOKING_PRICE_AND_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_BOOKING_STAY_FORMALITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_BOOKING_STAY_FORMALITIES_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_BOOKING_STAY_FORMALITIES_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR_BOOKING_STAY_FORMALITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_BOOKING_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_BOOKING_TRANSPORT_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_BOOKING_TRANSPORT_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLEAR_BOOKING_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return OPEN_CHILDCARE_INFORMATIONS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CLOSE_CHILDCARE_INFORMATIONS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_RESOLVED; });
/* unused harmony export FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_REJECTED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_PACKAGE_UPSELL_INFORMATIONS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return OPEN_PACKAGE_UPSELL_INFORMATIONS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLOSE_PACKAGE_UPSELL_INFORMATIONS_MODAL; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("30WP");


var BOOKING_DETAILS = 'BOOKING_DETAILS';
var BOOKING_ATTENDEES_PACKAGE = 'BOOKING_ATTENDEES_PACKAGE';
var BOOKING_PRICE_AND_PAYMENT = 'BOOKING_PRICE_AND_PAYMENT';
var BOOKING_STAY_FORMALITIES = 'BOOKING_STAY_FORMALITIES';
var BOOKING_TRANSPORT = 'BOOKING_TRANSPORT';
var CHILDCARE_INFORMATIONS_MODAL = 'CHILDCARE_INFORMATIONS_MODAL';
var PACKAGE_UPSELL_INFORMATIONS_MODAL = 'PACKAGE_UPSELL_INFORMATIONS_MODAL';
var FETCH_BOOKING_DETAILS = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "c"])(BOOKING_DETAILS);
var FETCH_BOOKING_DETAILS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_DETAILS);
var FETCH_BOOKING_DETAILS_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_DETAILS);
var CLEAR_BOOKING_DETAILS = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_DETAILS);
var FETCH_BOOKING_ATTENDEES_PACKAGE = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "c"])(BOOKING_ATTENDEES_PACKAGE);
var FETCH_BOOKING_ATTENDEES_PACKAGE_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_ATTENDEES_PACKAGE);
var FETCH_BOOKING_ATTENDEES_PACKAGE_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_ATTENDEES_PACKAGE);
var CLEAR_BOOKING_ATTENDEES_PACKAGE = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_ATTENDEES_PACKAGE);
var FETCH_BOOKING_PRICE_AND_PAYMENT = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "c"])(BOOKING_PRICE_AND_PAYMENT);
var FETCH_BOOKING_PRICE_AND_PAYMENT_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_PRICE_AND_PAYMENT);
var FETCH_BOOKING_PRICE_AND_PAYMENT_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_PRICE_AND_PAYMENT);
var CLEAR_BOOKING_PRICE_AND_PAYMENT = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_PRICE_AND_PAYMENT);
var FETCH_BOOKING_STAY_FORMALITIES = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "c"])(BOOKING_STAY_FORMALITIES);
var FETCH_BOOKING_STAY_FORMALITIES_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_STAY_FORMALITIES);
var FETCH_BOOKING_STAY_FORMALITIES_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_STAY_FORMALITIES);
var CLEAR_BOOKING_STAY_FORMALITIES = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_STAY_FORMALITIES);
var FETCH_BOOKING_TRANSPORT = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "c"])(BOOKING_TRANSPORT);
var FETCH_BOOKING_TRANSPORT_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_BOOKING_TRANSPORT);
var FETCH_BOOKING_TRANSPORT_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_BOOKING_TRANSPORT);
var CLEAR_BOOKING_TRANSPORT = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(BOOKING_TRANSPORT);
var OPEN_CHILDCARE_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* open */ "d"])(CHILDCARE_INFORMATIONS_MODAL);
var CLOSE_CHILDCARE_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* close */ "b"])(CHILDCARE_INFORMATIONS_MODAL);
var FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetch */ "c"])(PACKAGE_UPSELL_INFORMATIONS_MODAL);
var FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL);
var FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_REJECTED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["reject"])(FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL);
var CLEAR_PACKAGE_UPSELL_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* clear */ "a"])(PACKAGE_UPSELL_INFORMATIONS_MODAL);
var OPEN_PACKAGE_UPSELL_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* open */ "d"])(PACKAGE_UPSELL_INFORMATIONS_MODAL);
var CLOSE_PACKAGE_UPSELL_INFORMATIONS_MODAL = Object(_constants_helper__WEBPACK_IMPORTED_MODULE_1__[/* close */ "b"])(PACKAGE_UPSELL_INFORMATIONS_MODAL);

/***/ }),

/***/ "R3TX":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("zWgn"),
    overRest = __webpack_require__("UAs9"),
    setToString = __webpack_require__("7Pat");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "R5u7":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("pPzx"),
    isArrayLike = __webpack_require__("9y2L"),
    isIndex = __webpack_require__("pnw1"),
    isObject = __webpack_require__("tQYX");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "RBO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* unused harmony export getMainContactOptinEmail */
/* unused harmony export getMainContactOptinSms */
/* unused harmony export getMainContactOptinFosun */
/* unused harmony export getMainContactOptinMail */
/* unused harmony export getMainContactOptinPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTripFlexibility; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var mainContactSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref2) {
  var mainContact = _ref2.mainContact;
  return mainContact || {};
});
var getDepartureCity = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref3) {
  var departureCity = _ref3.departureCity;
  return departureCity;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref4) {
  var departureDate = _ref4.departureDate;
  return departureDate;
});
var getMainContactOptinEmail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref5) {
  var optinEmail = _ref5.optinEmail;
  return optinEmail;
});
var getMainContactOptinSms = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref6) {
  var optinSms = _ref6.optinSms;
  return optinSms;
});
var getMainContactOptinMail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref7) {
  var optinMail = _ref7.optinMail;
  return optinMail;
});
var getMainContactOptinPhone = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref8) {
  var optinPhone = _ref8.optinPhone;
  return optinPhone;
});
var getMainContactOptinFosun = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref9) {
  var optinFosun = _ref9.optinFosun;
  return optinFosun;
});
var getTripDuration = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref10) {
  var duration = _ref10.duration;
  return duration;
});
var getTripFlexibility = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref11) {
  var flexibility = _ref11.flexibility;
  return flexibility;
});


/***/ }),

/***/ "RBan":
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ "RBvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_TRIP_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_NO_DURATION; });
var TRIP_INFORMATION_SET_DURATION = 'TRIP_INFORMATION_SET_DURATION';
var DEFAULT_TRIP_DURATION = 7;
var DEFAULT_NO_DURATION = null;

/***/ }),

/***/ "RNvQ":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("tQYX"),
    now = __webpack_require__("ENE1"),
    toNumber = __webpack_require__("nvU9");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "SKAX":
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__("JC6p"),
    createBaseEach = __webpack_require__("lQqw");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ "SQLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("\n  fragment BookingAttendeesProfile on Profile {\n    gmNumber\n    civility\n    firstName\n    lastName\n    unicodeFirstName\n    unicodeLastName\n  }\n");

/***/ }),

/***/ "TVUe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TrackingPageLoad_TrackingPageLoad; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/last-visited-tracking-api/index.js
var last_visited_tracking_api = __webpack_require__("evRn");

// EXTERNAL MODULE: ./src/client/store/lead-info/leadInfo.selector.js
var leadInfo_selector = __webpack_require__("8fx4");

// CONCATENATED MODULE: ./src/client/tracking/tracking-component/index.jsx


var __jsx = react["createElement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var tracking_component_TrackingComponent = function TrackingComponent(_ref) {
  var children = _ref.children,
      track = _ref.track,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "track"]);

  var appContext = react["useContext"](ReactAppContext["a" /* default */]);
  var pageContext = react["useContext"](context_pageContext["a" /* ReactPageContext */]);
  var leadScoring = Object(es["e" /* useSelector */])(leadInfo_selector["a" /* getLeadScore */]); // in some cases (like the NotFoundView) the siteSection's value cannot be dynamically built
  // from the pageType and attached to the pageContext,
  // so we need to declare it in the props directly but this should be avoided

  var siteSection = props.siteSection || pageContext.siteSection;
  react["useEffect"](function () {
    // $FlowFixMe
    Object(last_visited_tracking_api["b" /* trackLastVisitedProducts */])(pageContext, props.resortCode);
  }, [props.pageName]);
  react["useEffect"](function () {
    // pageId is not actually needed here, since the categoryGA is only used for events
    // not for page loading (the analytics team doesn't care), but it makes our API more
    // consistent
    tracking_api["b" /* setDataLayer */](_objectSpread(_objectSpread(_objectSpread({}, props), {}, {
      // $FlowFixMe
      siteSection: siteSection
    }, siteSection && siteSection.includes(constants["l" /* PLE */]) ? {
      BE_customerStatus: appContext.customerType
    } : undefined), leadScoring ? {
      leadScoring: leadScoring
    } : null), appContext, pageContext.pageId);

    if (track) {
      track();
    }
  }, [props.pageName]);
  return __jsx("div", null, children);
};

/* harmony default export */ var tracking_component = (tracking_component_TrackingComponent);
// CONCATENATED MODULE: ./src/client/tracking/tracking-component/index.js

/* harmony default export */ var tracking_tracking_component = (tracking_component);
// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/store/user-info/userInfo.selectors.js
var userInfo_selectors = __webpack_require__("apzf");

// CONCATENATED MODULE: ./src/client/tracking/tracking-pageload/TrackingPageLoad.jsx


var TrackingPageLoad_jsx = react_default.a.createElement;

function TrackingPageLoad_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function TrackingPageLoad_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TrackingPageLoad_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TrackingPageLoad_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var TrackingPageLoad_TrackingPageLoad = function TrackingPageLoad(props) {
  var _profile$loyaltyProgr;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var trackingPageLoadAppendSuffix = location.queryParams.trackingPageLoadAppendSuffix;
  var profile = Object(es["e" /* useSelector */])(userInfo_selectors["a" /* userInfoSelector */]);

  var trackingProps = TrackingPageLoad_objectSpread(TrackingPageLoad_objectSpread(TrackingPageLoad_objectSpread(TrackingPageLoad_objectSpread({}, props.trackingKey ?
  /**
   * We need to omit ski data because in case of 2 bookings from the same session,
   * when the first one has ski equipments and second one has none,
   * the second one get wrong ski data from locale storage
   * In case of new ski data exist, it will be added from props anyway
   */
  Object(lodash["omit"])(tracking_storage_api["a" /* get */](props.trackingKey), 'skiEquipment', 'skiingEquipment', 'snowboardingEquipment', 'hikingEquipment') : {}), {
    event: constants["y" /* VIRTUAL_PAGE_LOAD */]
  }), {
    fidelityStatus: (profile === null || profile === void 0 ? void 0 : (_profile$loyaltyProgr = profile.loyaltyProgram) === null || _profile$loyaltyProgr === void 0 ? void 0 : _profile$loyaltyProgr.status) || ''
  }), Object(lodash["omit"])(props, 'children', 'location', 'history', 'match', 'trackingKey'));

  if (trackingPageLoadAppendSuffix) {
    trackingProps.pageName = "".concat(trackingProps.pageName, "_").concat(trackingPageLoadAppendSuffix);
  }

  react_default.a.useEffect(function () {
    if (props.event) {
      tracking_storage_api["b" /* set */](trackingProps);
    }
  }, [props.event]);
  return TrackingPageLoad_jsx(tracking_tracking_component, Object(esm_extends["a" /* default */])({}, trackingProps, {
    track: props.track
  }));
};

/***/ }),

/***/ "TYzI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* unused harmony export CriteriaDisplayContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useCriteriaDisplayContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CriteriaDisplayProvider; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var ACTIONS = Object.freeze({
  CLOSE_CRITERIA: 'CLOSE_CRITERIA',
  OPEN_CRITERIA: 'OPEN_CRITERIA',
  OPEN_NEXT_CRITERIA: 'OPEN_NEXT_CRITERIA'
});
var initialState = {
  criteriaWhenIsOpen: false,
  criteriaWhoIsOpen: false,
  criteriaTransportIsOpen: false
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  switch (action.type) {
    case ACTIONS.OPEN_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), true));

    case ACTIONS.CLOSE_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), false));

    case ACTIONS.OPEN_NEXT_CRITERIA:
      var _action$payload = action.payload,
          currentCriteria = _action$payload.currentCriteria,
          criteriaContext = _action$payload.criteriaContext;

      if (currentCriteria === 'criteriaTransport') {
        return state;
      }

      if (currentCriteria === 'criteriaWho' && !criteriaContext.criteriaTransportIsSet) {
        return _objectSpread(_objectSpread({}, state), {}, {
          criteriaTransportIsOpen: true
        });
      }

      if (currentCriteria === 'criteriaWhen') {
        if (!criteriaContext.criteriaWhoIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhoIsOpen: true
          });
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaTransportIsOpen: true
          });
        }
      }

      return state;

    default:
      return state;
  }
};

var CriteriaDisplayContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["createContext"])([initialState, function () {}]);
var useCriteriaDisplayContext = function useCriteriaDisplayContext() {
  return Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(CriteriaDisplayContext);
};
var CriteriaDisplayProvider = function CriteriaDisplayProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_1__["useReducer"])(criteriaContextReducer, _objectSpread(_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  return __jsx(CriteriaDisplayContext.Provider, {
    value: [state, dispatch]
  }, children);
};

/***/ }),

/***/ "TnNS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatedData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return submitSubscriptionForm; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Nhxn");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






function filterObjectWithMapping(data) {
  var rules = {
    email: 'email',
    civility: 'gender',
    firstName: 'firstName',
    lastName: 'lastName',
    unicodeFirstName: 'unicodeFirstName',
    unicodeLastName: 'unicodeLastName',
    subscriptions: 'newsletterSubscriptions',
    conditions: 'legalInformations'
  };
  return Object.keys(data).reduce(function (result, currentAttribute) {
    var mappedField = rules[currentAttribute];

    if (!Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(mappedField)) {
      result[mappedField] = data[currentAttribute];
    }

    return result;
  }, {});
}

var LIST_INPUTS = ['civility', 'firstName', 'lastName', 'email', 'unicodeFirstName', 'unicodeLastName'];
var formatedData = function formatedData(values) {
  var subscriptions = Object.keys(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["omitBy"])(values, function (value) {
    return value === false;
  }));
  return _objectSpread(_objectSpread({}, values), {}, {
    subscriptions: lodash__WEBPACK_IMPORTED_MODULE_1__["without"].apply(void 0, [subscriptions].concat(LIST_INPUTS))
  });
};
function submitSubscriptionForm(_ref) {
  var appContext = _ref.appContext,
      subscriptionId = _ref.subscriptionId,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      isSubscription = _ref.isSubscription;
  var filteredData = filterObjectWithMapping(data);

  if (!Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(subscriptionId)) {
    filteredData.subscriptionId = subscriptionId;
  }

  filteredData.isSubscription = isSubscription;
  var selection = Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_4__[/* attributesToString */ "a"])(filteredData);
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runNoCacheQuery("mutation RootMutationType {subscription (".concat(selection, ") { id neolaneId error { errorDescription }}}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* NEWSLETTER_SUBMIT_SUBSCRIPTION */ "Lc"]
  });
}

/***/ }),

/***/ "U9LJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var buildings = [{
  id: 'floors',
  source: 'buildingsSource',
  type: 'fill-extrusion',
  filter: ['!=', 'building_id', ''],
  interactive: false,
  paint: {
    'fill-extrusion-color': {
      base: 1,
      type: 'exponential',
      property: 'level',
      stops: [[0, 'hsl(47, 43%, 55%)'], [1, 'hsl(48, 45%, 62%)'], [2, 'hsl(48, 49%, 69%)'], [3, 'hsl(47, 55%, 76%)'], [4, 'hsl(49, 64%, 84%)'], [5, 'hsl(49, 64%, 84%)']]
    },
    'fill-extrusion-opacity': 1,
    'fill-extrusion-height': {
      base: 1,
      type: 'exponential',
      property: 'height',
      stops: [[0, 0], [100, 100]]
    },
    'fill-extrusion-base': {
      base: 1,
      type: 'exponential',
      property: 'min_height',
      stops: [[0, 0], [100, 100]]
    }
  }
}, {
  id: 'floors_current',
  source: 'buildingsSource',
  type: 'fill-extrusion',
  filter: ['all', ['==', 'building_id', ''], ['<=', 'level', 999]],
  paint: {
    'fill-extrusion-color': {
      base: 1,
      type: 'exponential',
      property: 'level',
      stops: [[0, 'hsl(208, 38%, 52%)'], [1, 'hsl(208, 42%, 59%)'], [2, 'hsl(207, 47%, 66%)'], [3, 'hsl(206, 55%, 73%)'], [4, 'hsl(204, 70%, 79%)'], [5, 'hsl(201, 97%, 86%)']]
    },
    'fill-extrusion-opacity': 1,
    'fill-extrusion-height': {
      base: 1,
      type: 'exponential',
      property: 'height',
      stops: [[0, 0], [100, 100]]
    },
    'fill-extrusion-base': {
      base: 1,
      type: 'exponential',
      property: 'min_height',
      stops: [[0, 0], [100, 100]]
    }
  }
}, {
  id: 'floors_current_dimmed',
  source: 'buildingsSource',
  type: 'fill-extrusion',
  filter: ['all', ['==', 'building_id', ''], ['>', 'level', 999]],
  paint: {
    'fill-extrusion-color': {
      base: 1,
      type: 'exponential',
      property: 'level',
      stops: [[0, 'hsl(208, 38%, 52%)'], [1, 'hsl(208, 42%, 59%)'], [2, 'hsl(207, 47%, 66%)'], [3, 'hsl(206, 55%, 73%)'], [4, 'hsl(204, 70%, 79%)'], [5, 'hsl(201, 97%, 86%)']]
    },
    'fill-extrusion-opacity': 0.3,
    'fill-extrusion-height': {
      base: 1,
      type: 'exponential',
      property: 'height',
      stops: [[0, 0], [100, 100]]
    },
    'fill-extrusion-base': {
      base: 1,
      type: 'exponential',
      property: 'min_height',
      stops: [[0, 0], [100, 100]]
    }
  }
}, {
  id: 'floors_highlight',
  source: 'buildingsSource',
  type: 'fill-extrusion',
  filter: ['==', 'building_id', ''],
  paint: {
    'fill-extrusion-color': {
      base: 1,
      type: 'exponential',
      property: 'level',
      stops: [[0, 'hsl(208, 38%, 52%)'], [1, 'hsl(208, 42%, 59%)'], [2, 'hsl(207, 47%, 66%)'], [3, 'hsl(206, 55%, 73%)'], [4, 'hsl(204, 70%, 79%)'], [5, 'hsl(201, 97%, 86%)']]
    },
    'fill-extrusion-height': {
      base: 1,
      type: 'exponential',
      property: 'height',
      stops: [[0, 0], [100, 100]]
    },
    'fill-extrusion-base': {
      base: 1,
      type: 'exponential',
      property: 'min_height',
      stops: [[0, 0], [100, 100]]
    }
  }
}];
/* harmony default export */ __webpack_exports__["a"] = (buildings);

/***/ }),

/***/ "UAs9":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("zaNA");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "UIAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ACCOMMODATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_ACCOMMODATION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_TRANSFER_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return UPDATE_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_PROPOSALS; });
/* unused harmony export LOAD_PROPOSAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_PROPOSALS_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_SELECTED_PROPOSAL_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return REMOVE_TRANSFER_FROM_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SAVE_CUSTOMER_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return UPDATE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PREPARE_BE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DISPLAY_TOAST_ON_CONTEXT_SHARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_PROPOSALS_FROM_EDIT_CRITERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SAVE_DONATION_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_PROMO_CODE; });
/* unused harmony export SET_PROMO_CODE_FAILURE_STATUS */
/* unused harmony export SET_PROMO_CODE_SUCCESS_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return UPDATE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SWITCH_PROPOSALS_OFFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PRICE_COUNTER_PROPOSAL_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return INSURANCE_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return INSURANCE_DELETED; });
var ADD_ACCOMMODATION = 'ADD_ACCOMMODATION';
var ADD_ACCOMMODATION_ERROR = 'ADD_ACCOMMODATION_ERROR';
var ADD_TRANSFER_TO_PROPOSALS = 'ADD_TRANSFER_TO_PROPOSALS';
var ADD_TRANSPORT = 'ADD_TRANSPORT';
var UPDATE_ATTENDEES = 'UPDATE_ATTENDEES';
var CLEAR_PROPOSALS = 'CLEAR_PROPOSALS';
var LOAD_PROPOSAL = 'LOAD_PROPOSAL';
var FETCH_PROPOSALS = 'FETCH_PROPOSALS';
var FETCH_PROPOSALS_BY_ID = 'FETCH_PROPOSALS_BY_ID';
var FETCH_SELECTED_PROPOSAL_PAYMENT = 'FETCH_SELECTED_PROPOSAL_PAYMENT';
var REMOVE_TRANSFER_FROM_PROPOSALS = 'REMOVE_TRANSFER_FROM_PROPOSALS';
var SET_PROPOSALS = 'SET_PROPOSALS';
var SAVE_CUSTOMER_PROPOSAL = 'SAVE_CUSTOMER_PROPOSAL';
var UPDATE_INSURANCES = 'UPDATE_INSURANCES';
var DELETE_INSURANCES = 'DELETE_INSURANCES';
var PREPARE_BE = 'PREPARE_BE';
var DISPLAY_TOAST_ON_CONTEXT_SHARE = 'DISPLAY_TOAST_ON_CONTEXT_SHARE';
var FETCH_PROPOSALS_FROM_EDIT_CRITERIA = 'FETCH_PROPOSALS_FROM_EDIT_CRITERIA';
var SAVE_DONATION_TO_PROPOSALS = 'SAVE_DONATION_TO_PROPOSALS';
var SET_PROMO_CODE = 'SET_PROMO_CODE';
var SET_PROMO_CODE_FAILURE_STATUS = 'failure';
var SET_PROMO_CODE_SUCCESS_STATUS = 'success';
var UPDATE_SERVICES = 'UPDATE_SERVICES';
var ADD_SERVICE = 'ADD_SERVICE';
var DELETE_SERVICE = 'DELETE_SERVICE';
var SWITCH_PROPOSALS_OFFERS = 'SWITCH_PROPOSALS_OFFERS';
var PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
var PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD = 30;
var INSURANCE_ADDED = 'INSURANCE_DELETED';
var INSURANCE_DELETED = 'INSURANCE_ADDED';

/***/ }),

/***/ "UNi/":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "Uq20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROUTING_CHANGE; });
var ROUTING_CHANGE = 'ROUTING_CHANGE';

/***/ }),

/***/ "V6Ve":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("kekF");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "V8Kl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),

/***/ "VD47":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("XGnz"),
    baseRest = __webpack_require__("EA7m"),
    baseUniq = __webpack_require__("LGYb"),
    isArrayLikeObject = __webpack_require__("3L66"),
    last = __webpack_require__("RBan");

/**
 * This method is like `_.union` except that it accepts `comparator` which
 * is invoked to compare elements of `arrays`. Result values are chosen from
 * the first array in which the value occurs. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.unionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var unionWith = baseRest(function(arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
});

module.exports = unionWith;


/***/ }),

/***/ "VHif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Badge_Badge; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.themes.js

var variants = {
  diamond: {
    root: ' rotate-45',
    item: ' -rotate-45'
  },
  pill: {
    root: ' rounded-full',
    item: ''
  }
};
var themes = {
  "default": function _default(_ref) {
    var _ref$colorBg = _ref.colorBg,
        colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].BLUE : _ref$colorBg,
        _ref$colorBorder = _ref.colorBorder,
        colorBorder = _ref$colorBorder === void 0 ? colors["a" /* COLORS */].BLUE : _ref$colorBorder,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref$color,
        hasShadow = _ref.hasShadow,
        variant = _ref.variant;
    return {
      thRoot: "bg-".concat(colorBg, " border-").concat(colorBorder, " text-").concat(color, " border-2 flex-none inline-flex items-center justify-center leading-none overflow-hidden relative").concat(hasShadow ? ' shadow' : '').concat(variant ? variants[variant].root : ''),
      thImage: "absolute inset-0 ".concat(variant ? variants[variant].item : ''),
      thIcon: "absolute flex items-center justify-center inset-0".concat(variant ? variants[variant].item : ''),
      thIconSize: '65%',
      thLabel: "absolute flex items-center justify-center leading-tight overflow-hidden inset-0 text-center ".concat(variant ? variants[variant].item : ''),
      thLabelStyle: {
        fontSize: '1em'
      }
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.jsx
var __jsx = react_default.a.createElement;





var Badge_Badge = function Badge(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      colorBg = _ref.colorBg,
      colorBorder = _ref.colorBorder,
      color = _ref.color,
      hasShadow = _ref.hasShadow,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      imageSrc = _ref.imageSrc,
      label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 50 : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      variant = _ref.variant;

  if (!iconName && !imageSrc && !label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    colorBg: colorBg,
    colorBorder: colorBorder,
    color: color,
    hasShadow: hasShadow,
    variant: variant
  }),
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thImage = _themes$theme.thImage,
      thLabel = _themes$theme.thLabel,
      thLabelStyle = _themes$theme.thLabelStyle,
      thRoot = _themes$theme.thRoot;

  var styles = {
    width: size,
    height: size
  };
  var imageSize = {
    w: size,
    h: size
  };
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    style: styles
  }, !!imageSrc && __jsx("div", {
    className: thImage
  }, __jsx(Image["a" /* default */], {
    altMsg: alt,
    forceImage: true,
    imageUrl: imageSrc,
    mandatoryWidthAndHeight: imageSize
  })), !!iconName && __jsx("div", {
    className: thIcon
  }, __jsx(Icon["a" /* Icon */], {
    alt: alt,
    name: iconName,
    width: iconSize || thIconSize
  })), !!label && __jsx("div", {
    className: thLabel,
    style: thLabelStyle
  }, label));
};

/***/ }),

/***/ "VaNO":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "VtPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIAL_MONTH; });
/* unused harmony export calendarQuery */
/* unused harmony export bookableDatesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return queryFetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return queryFetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDefaultSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPricesByDays; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nv//");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ldK3");






var NO_TRANSPORT_VALUE = 'NO';
var DATE_FORMAT = 'YYYYMM';
var INITIAL_MONTH = 0;
function calendarQuery(args) {
  var resortId = args.resortId,
      duration = args.duration,
      departureCity = args.departureCity,
      urgentisationRate = args.urgentisationRate;
  return "\n      calendar(resortId: \"".concat(resortId, "\", duration: \"").concat(duration, "\", departureCity: \"").concat(departureCity, "\") {\n        basePrice {\n          currency\n          bestPrice {\n            value\n            currency\n            formattedValue\n          }\n          initialPrice {\n            value\n            currency\n            formattedValue\n          }\n          unit\n        }\n        blocks {\n          hasPrice\n          id\n          name\n          price {\n            value\n            currency\n            formattedValue\n          }\n          shortName\n          year\n        }\n        firstAvailableMonthIndex\n        months {\n          id\n          days {\n            dayContent {\n              arrivalDate\n              availability\n              canGoToBooking\n              id\n              isCurrentMonth\n              name\n              number\n              offer(urgentisationRate: ").concat(urgentisationRate, ")\n              shortName\n            }\n            priceConfig {\n              bestPrice(forceAdultPerTrip: true) { value formattedValue }\n              currency\n              initialPrice(forceAdultPerTrip: true) { value formattedValue }\n              isBestPriceMonth\n              termsAndConditions {\n                accommodationComfortLabel\n                departureCity {\n                  value\n                  name\n                }\n                departureDate\n                duration\n                numberOfAdults\n              }\n              rawUnit\n              unit\n            }\n          }\n        }\n        weekDays\n      }\n    ");
}
function bookableDatesQuery(_ref) {
  var departureCity = _ref.departureCity,
      departureDate = _ref.departureDate,
      lastDate = _ref.lastDate,
      productId = _ref.productId;
  return "\n    bookableDates(productId: \"".concat(productId, "\", departureDate: \"").concat(departureDate, "\", lastDate: \"").concat(lastDate, "\", departureCity: \"").concat(departureCity, "\") {\n      months {\n        id\n        days {\n          id\n          availabilities {\n            status\n            durations\n          }\n        }\n      }\n    }\n  ");
}
function queryFetchCalendar(appContext, options) {
  var locale = appContext.locale;
  var _options$resortId = options.resortId,
      resortId = _options$resortId === void 0 ? '' : _options$resortId,
      _options$transport = options.transport,
      transport = _options$transport === void 0 ? '' : _options$transport,
      duration = options.duration,
      urgentisationRate = options.urgentisationRate;
  var calendarQueryArgs = {
    locale: locale,
    resortId: resortId,
    departureCity: transport || NO_TRANSPORT_VALUE,
    duration: duration,
    urgentisationRate: urgentisationRate
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery("query {".concat(calendarQuery(calendarQueryArgs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* STATE_PRODUCT_CALENDAR */ "Cd"]
  }).then(function (_ref2) {
    var calendar = _ref2.calendar;
    return {
      calendar: calendar
    };
  });
}
function queryFetchBookableDates(appContext, options) {
  var _options$productId = options.productId,
      productId = _options$productId === void 0 ? '' : _options$productId,
      _options$departureDat = options.departureDate,
      departureDate = _options$departureDat === void 0 ? '' : _options$departureDat,
      _options$departureCit = options.departureCity,
      departureCity = _options$departureCit === void 0 ? '' : _options$departureCit,
      _options$lastDate = options.lastDate,
      lastDate = _options$lastDate === void 0 ? '' : _options$lastDate;
  var bookableDatesQueryArs = {
    productId: productId,
    departureDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* timestampToApiDate */ "l"])(departureDate || '') || '',
    lastDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* timestampToApiDate */ "l"])(lastDate || '') || '',
    departureCity: departureCity
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery("query {".concat(bookableDatesQuery(bookableDatesQueryArs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* STATE_PRODUCT_BOOKABLE_DATES */ "Bd"]
  }).then(function (_ref3) {
    var bookableDates = _ref3.bookableDates;
    return {
      bookableDates: bookableDates
    };
  });
}
function getDefaultSelectedMonth() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var momentDate = value ? moment__WEBPACK_IMPORTED_MODULE_0___default()(value, format) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
  return parseInt(momentDate.format(DATE_FORMAT), 10);
}
function getSelectedMonth(calendar, previousSelectedMonth) {
  var _calendar$months; // The query date param prevails


  var dateQueryParam = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_4__[/* getSpecificQueryParam */ "j"])(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_DEPARTURE_DATE */ "f"]);

  if (dateQueryParam) {
    return getDefaultSelectedMonth(dateQueryParam);
  }

  var firstCalendarMonth = ((_calendar$months = calendar.months) === null || _calendar$months === void 0 ? void 0 : _calendar$months[0].id) || getDefaultSelectedMonth();
  var firstAvailableMonthIndex = calendar.firstAvailableMonthIndex || INITIAL_MONTH;
  var firstAvailableMonth = parseInt(moment__WEBPACK_IMPORTED_MODULE_0___default()(firstCalendarMonth, DATE_FORMAT).add(firstAvailableMonthIndex, 'months').format(DATE_FORMAT), 10); // The previously selected month remains selected unless the first available dates are later

  if (previousSelectedMonth > firstAvailableMonth) {
    return previousSelectedMonth;
  }

  return firstAvailableMonth;
}
function getPricesByDays(calendar) {
  var prices = {};

  if (calendar.months) {
    calendar.months.forEach(function (_ref4) {
      var days = _ref4.days;

      if (days) {
        days.forEach(function (_ref5) {
          var _priceConfig$termsAnd, _priceConfig$termsAnd2;

          var dayContent = _ref5.dayContent,
              priceConfig = _ref5.priceConfig;

          var _ref6 = dayContent || {},
              availability = _ref6.availability,
              id = _ref6.id,
              offer = _ref6.offer;

          var isBestPrice = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.isBestPriceMonth;
          var unit = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.unit;
          var departureCityValue = (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd === void 0 ? void 0 : (_priceConfig$termsAnd2 = _priceConfig$termsAnd.departureCity) === null || _priceConfig$termsAnd2 === void 0 ? void 0 : _priceConfig$termsAnd2.value) || NO_TRANSPORT_VALUE;

          if (id) {
            var _priceConfig$termsAnd3, _priceConfig$termsAnd4, _priceConfig$initialP, _priceConfig$bestPric, _priceConfig$bestPric2;

            var closed = availability === 'closed';
            var exclusivity = availability === 'exclusivity';
            var noDeparture = availability === 'noDeparture';
            var noFlight = availability === 'noFlight';
            var full = availability === 'full';
            var noAvailability = availability === '';
            var available = availability === 'available' || availability === 'unknown';
            var lastAvailability = offer === 'urgentisation';
            prices[id] = {
              availability: availability,
              available: available,
              closed: closed,
              currency: priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.currency,
              departureCity: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd3 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd3 === void 0 ? void 0 : (_priceConfig$termsAnd4 = _priceConfig$termsAnd3.departureCity) === null || _priceConfig$termsAnd4 === void 0 ? void 0 : _priceConfig$termsAnd4.name) || '',
              exclusivity: exclusivity,
              full: full,
              hasTransport: departureCityValue !== NO_TRANSPORT_VALUE,
              isBestPrice: isBestPrice,
              lastAvailability: lastAvailability,
              noAvailability: noAvailability,
              noDeparture: noDeparture,
              noFlight: noFlight,
              oldPrice: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$initialP = priceConfig.initialPrice) === null || _priceConfig$initialP === void 0 ? void 0 : _priceConfig$initialP.formattedValue) || null,
              price: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric = priceConfig.bestPrice) === null || _priceConfig$bestPric === void 0 ? void 0 : _priceConfig$bestPric.formattedValue) || null,
              priceValue: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric2 = priceConfig.bestPrice) === null || _priceConfig$bestPric2 === void 0 ? void 0 : _priceConfig$bestPric2.value) || null,
              unit: unit
            };
          }
        });
      }
    });
  }

  return prices;
}

/***/ }),

/***/ "WGoB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAttendeesSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTravelSectionSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pluralizeLabel; });
/* unused harmony export prefixWithPlusIfPositive */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return capitalizeName; });
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("kiXb");


function pluralizeLabel(singularLabel, pluralLabel, value) {
  return value > 1 ? pluralLabel : singularLabel;
}

function prefixWithPlusIfPositive(value, label) {
  return value >= 0 ? "+".concat(label) : label;
}

function capitalizeName(text) {
  return (text || '').toLowerCase().replace(/(?:^|[-\s.'&])\S/g, function (a) {
    return a.toUpperCase();
  });
}

var getAttendeesSummary = function getAttendeesSummary(_ref) {
  var adultsCount = _ref.adultsCount,
      kidsCount = _ref.kidsCount;
  return "".concat(adultsCount, " ").concat(pluralizeLabel(Object(_i18n__WEBPACK_IMPORTED_MODULE_0__[/* t */ "f"])('booking.common.adult'), Object(_i18n__WEBPACK_IMPORTED_MODULE_0__[/* t */ "f"])('booking.common.adults'), adultsCount), " ").concat(kidsCount > 0 ? " - ".concat(kidsCount, " ").concat(pluralizeLabel(Object(_i18n__WEBPACK_IMPORTED_MODULE_0__[/* t */ "f"])('booking.common.child'), Object(_i18n__WEBPACK_IMPORTED_MODULE_0__[/* t */ "f"])('booking.common.children'), kidsCount)) : '');
};
var getTravelSectionSummary = function getTravelSectionSummary(_ref2) {
  var travelSection = _ref2.travelSection;
  return "".concat(travelSection.label.toLowerCase(), " (").concat(travelSection.id.toUpperCase(), ")");
};


/***/ }),

/***/ "WzQP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridRow; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("I6kL");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




function getResponsiveClasses(grid) {
  return Object.keys(_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"]).map(function (key) {
    if (grid.hasOwnProperty(key)) {
      return " ".concat(_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"][key], "-GridRow--").concat(grid[_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"][key]]); // fit, full, 1of2, 1of3
    }
  }).join('');
}

function GridRow(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$grid = _ref.grid,
      grid = _ref$grid === void 0 ? {} : _ref$grid,
      _ref$hasLeftGutters = _ref.hasLeftGutters,
      hasLeftGutters = _ref$hasLeftGutters === void 0 ? true : _ref$hasLeftGutters,
      _ref$hasTopGutters = _ref.hasTopGutters,
      hasTopGutters = _ref$hasTopGutters === void 0 ? true : _ref$hasTopGutters;
  if (!react__WEBPACK_IMPORTED_MODULE_0__["Children"].count(children)) return null;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'flex flex-wrap', {
      'GridRow--leftGutters': hasLeftGutters,
      'GridRow--topGutters': hasTopGutters
    }, getResponsiveClasses(grid))
  }, children);
}

/***/ }),

/***/ "XGnz":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("CH3K"),
    isFlattenable = __webpack_require__("BiGR");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ "XHSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export savePaymentTrackingDatas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPaymentTrackingDatas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return makeBuildPrePaymentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildPrePaymentUrlAndRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFormData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return extractPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDevice; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O2W8");
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lz_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("U2CP");
/* harmony import */ var _utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("6jSF");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("CcNa");
/* harmony import */ var _PrePayment_queries__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("19WB");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}












function initPayment(payload, appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].runNoCacheQuery(Object(_PrePayment_queries__WEBPACK_IMPORTED_MODULE_10__[/* getInitPaymentQuery */ "b"])(payload), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_9__[/* PAYMENT_INIT */ "Zc"]
  }).then(function (_ref) {
    var prePayment = _ref.prePayment;
    return prePayment || {};
  });
}

function buildPrePaymentUrl() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var locale = arguments.length > 1 ? arguments[1] : undefined;
  var t = payload ? lz_string__WEBPACK_IMPORTED_MODULE_2___default.a.compressToEncodedURIComponent(JSON.stringify(payload)) : '';
  var query = {
    t: t,
    locale: locale
  };
  return new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(_routes_routeBuilder__WEBPACK_IMPORTED_MODULE_6__[/* urlPattern */ "b"]('prePayment')).query(query).toString();
}

function savePaymentTrackingDatas(orderId, values) {
  js_cookie__WEBPACK_IMPORTED_MODULE_3___default.a.set('PRE_PAYMENT_INFOS-' + orderId, _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["oidc"].toUriEncodedState(values));
}
function getPaymentTrackingDatas(orderId) {
  var value = js_cookie__WEBPACK_IMPORTED_MODULE_3___default.a.get("PRE_PAYMENT_INFOS-".concat(orderId));
  return value ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["oidc"].fromUriEncodedState(value) : null;
}
function makeBuildPrePaymentUrl(appContext) {
  return function createPrePaymentUrl() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return initPayment(params, appContext).then(function (datas) {
      var payload = _objectSpread(_objectSpread({}, params), datas);

      if (params.urlRedirectionIfNothingToPay && datas.amount === 0) {
        if (params.beforeRedirect) {
          params.beforeRedirect();
        }

        return params.urlRedirectionIfNothingToPay;
      }

      return buildPrePaymentUrl(payload, Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(appContext, 'locale'));
    });
  };
}
function buildPrePaymentUrlAndRedirect(_ref2) {
  var appContext = _ref2.appContext,
      history = _ref2.history,
      location = _ref2.location,
      _ref2$payload = _ref2.payload,
      payload = _ref2$payload === void 0 ? {} : _ref2$payload,
      _ref2$isFreeDeposit = _ref2.isFreeDeposit,
      isFreeDeposit = _ref2$isFreeDeposit === void 0 ? false : _ref2$isFreeDeposit;
  return makeBuildPrePaymentUrl(appContext)(payload).then(function (url) {
    history.pushRoute(isFreeDeposit ? new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(url).addQuery('freedeposit').toString() : url);
  })["catch"](function (err) {
    if (_utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__[/* hasAuthResponseError */ "l"](err)) {
      _utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__[/* redirectOnLoginPage */ "o"]({
        locale: appContext.locale,
        redirectPath: location.pathname
      });
      return;
    }

    if (_utils_ple_utils__WEBPACK_IMPORTED_MODULE_7__[/* hasNotFoundError */ "m"](err)) {
      _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].setLocation('/404');
      return;
    }

    throw err;
  });
}
function getFormData(params, appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].runNoCacheQuery(Object(_PrePayment_queries__WEBPACK_IMPORTED_MODULE_10__[/* getFormDataQuery */ "a"])(params), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_9__[/* PAYMENT_PRE_GET_FORM_DATA */ "dd"]
  });
}
function extractPayload(payload) {
  if (!payload) {
    return null;
  }

  var value = null;

  try {
    value = lz_string__WEBPACK_IMPORTED_MODULE_2___default.a.decompressFromEncodedURIComponent(payload);
    return JSON.parse(value);
  } catch (e) {
    console.error('extractPayload', e, ' for value:', value); // eslint-disable-line no-console

    return null;
  }
}
function getDevice(responsive) {
  if (responsive.isDesktop) return 'DESKTOP';
  if (responsive.isTablet) return 'TABLET';
  return 'MOBILE';
}

/***/ }),

/***/ "XTOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_Product; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// CONCATENATED MODULE: ./src/client/components/widgets/offer-discount/OfferDiscount.jsx

var __jsx = react_default.a.createElement;



function OfferDiscount(props) {
  var className = props.className,
      _props$discount = props.discount,
      discount = _props$discount === void 0 ? {} : _props$discount,
      _props$i18n = props.i18n,
      i18n = _props$i18n === void 0 ? {} : _props$i18n;
  var offerName = discount && discount.offerName || i18n.defaultLabel || '';
  var color = discount && discount.offerColor || i18n.defaultColor || '';
  return Object(lodash["get"])(discount, 'amount.value') ? __jsx("div", {
    className: classnames_default()(className, 'bg-current font-bold p-1 text-center text-sm uppercase', Object(defineProperty["a" /* default */])({}, "text-".concat(color), color)),
    style: {
      backgroundColor: color
    }
  }, __jsx("span", {
    className: "text-white"
  }, offerName)) : null;
}
// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.utils.js
var Product_utils = __webpack_require__("Fe0B");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/Availability.jsx
var Availability_jsx = react_default.a.createElement;




var computeAvailabilityStatus = function computeAvailabilityStatus(_ref) {
  var availability = _ref.availability,
      remainingStock = _ref.remainingStock;

  switch (true) {
    case availability === 'UNAVAILABLE':
    case availability === 'AVAILABLE' && remainingStock === 0:
      return 'unavailable';

    case availability === 'AVAILABLE' && remainingStock !== null && +remainingStock < 10:
    case availability === 'PARTIAL':
      return 'remaining';

    case availability === 'AVAILABLE':
      return 'available';

    default:
      return 'unknown';
  }
};

var Availability_Availability = function Availability(_ref2) {
  var availability = _ref2.availability,
      config = _ref2.config,
      remainingStock = _ref2.remainingStock;
  var availabilityStatus = computeAvailabilityStatus({
    availability: availability,
    remainingStock: remainingStock
  });

  var _ref3 = config[availabilityStatus] || {},
      color = _ref3.color,
      icon = _ref3.icon,
      label = _ref3.label;

  return label ? Availability_jsx("span", {
    className: "flex flex-none flex-shrink items-center text-".concat(color, " rtl:text-right")
  }, icon && Availability_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-1",
    name: icon,
    width: "0.8rem"
  }), Object(dist["messageFormat"])(label).format({
    count: remainingStock
  })) : null;
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/AvailabilityAge.jsx
var AvailabilityAge_jsx = react_default.a.createElement;



var shouldShowAgeInMonth = function shouldShowAgeInMonth(ageInNumberOfMonths) {
  return ageInNumberOfMonths <= 23;
};

var shouldShowAgeInYearsRange = function shouldShowAgeInYearsRange(ageMin, ageMax) {
  return !(Math.floor(ageMin / 12) === Math.floor(ageMax / 12));
};

var AvailabilityAge_AvailabilityAge = function AvailabilityAge(_ref) {
  var ageMax = _ref.ageMax,
      ageMin = _ref.ageMin,
      childcareLabel = _ref.childcareLabel,
      monthsLabel = _ref.monthsLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var message = '';

  if (shouldShowAgeInMonth(ageMax)) {
    message = Object(dist["messageFormat"])(monthsLabel).format({
      min: ageMin,
      max: ageMax
    });
  } else if (shouldShowAgeInYearsRange(ageMin, ageMax)) {
    message = Object(dist["messageFormat"])(yearsLabel).format({
      min: Math.floor(ageMin / 12),
      max: Math.floor(ageMax / 12)
    });
  } else {
    // Shows a single year age
    message = Object(dist["messageFormat"])(yearLabel).format({
      fixed: Math.floor(ageMin / 12)
    });
  }

  return AvailabilityAge_jsx(react["Fragment"], null, "".concat(childcareLabel, " "), AvailabilityAge_jsx("span", {
    className: "font-normal whitespace-no-wrap"
  }, "(", message, ")"));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/productChildcareAvailabilities.jsx
var productChildcareAvailabilities_jsx = react_default.a.createElement;







var productChildcareAvailabilities_ProductChildcareAvailabilities = function ProductChildcareAvailabilities(_ref) {
  var availableLabel = _ref.availableLabel,
      childcareLabel = _ref.childcareLabel,
      items = _ref.items,
      monthsLabel = _ref.monthsLabel,
      remainingLabel = _ref.remainingLabel,
      unavailableLabel = _ref.unavailableLabel,
      unknownLabel = _ref.unknownLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var renderConfig = {
    available: {
      color: colors["a" /* COLORS */].EMERALD,
      icon: icons["a" /* ICONS */].SMALL_CHECK,
      label: availableLabel
    },
    remaining: {
      color: colors["a" /* COLORS */].ORANGE,
      icon: icons["a" /* ICONS */].WARNING,
      label: remainingLabel
    },
    unavailable: {
      color: colors["a" /* COLORS */].RED,
      icon: icons["a" /* ICONS */].SMALL_CROSS,
      label: unavailableLabel
    },
    unknown: {
      color: colors["a" /* COLORS */].GRAY_MEDIUM,
      label: unknownLabel
    }
  };
  return productChildcareAvailabilities_jsx(react["Fragment"], null, items.map(function (_ref2) {
    var id = _ref2.id,
        ageMin = _ref2.ageMin,
        ageMax = _ref2.ageMax,
        availability = _ref2.availability,
        isIncluded = _ref2.isIncluded,
        remainingStock = _ref2.remainingStock;
    return productChildcareAvailabilities_jsx("p", {
      key: id,
      className: "flex font-bold items-start justify-between mt-3 reset-paragraph text-base text-gray-darker"
    }, productChildcareAvailabilities_jsx("span", {
      className: "flex-1"
    }, productChildcareAvailabilities_jsx(AvailabilityAge_AvailabilityAge, {
      ageMax: ageMax,
      ageMin: ageMin,
      childcareLabel: childcareLabel,
      monthsLabel: monthsLabel,
      yearLabel: yearLabel,
      yearsLabel: yearsLabel
    }), productChildcareAvailabilities_jsx("span", {
      className: classnames_default()('font-brand font-normal ml-1 text-sm', {
        'text-blue': isIncluded,
        'text-red': !isIncluded
      })
    }, isIncluded ? Object(src_i18n["f" /* t */])('common.included') : Object(src_i18n["f" /* t */])('common.onDemand'))), productChildcareAvailabilities_jsx(Availability_Availability, {
      availability: availability,
      config: renderConfig,
      remainingStock: remainingStock
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-comparison/ProductComparison.jsx

var ProductComparison_jsx = react_default.a.createElement;





var ProductComparison_ProductComparison = function ProductComparison(_ref) {
  var children = _ref.children,
      className = _ref.className,
      eligibilityLabel = _ref.eligibilityLabel,
      isEligible = _ref.isEligible,
      label = _ref.label,
      onComparisonClick = _ref.onComparisonClick,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? product_utils["b" /* IS_ENABLED */] : _ref$status;

  if (!react["Children"].count(children)) {
    return null;
  }

  if (!isEligible) return ProductComparison_jsx("div", {
    className: "relative"
  }, children, ProductComparison_jsx("div", {
    className: "absolute bg-overlay-white-60 flex font-bold items-center justify-center inset-0 p-5 text-base text-center z-1"
  }, eligibilityLabel));
  var isSelectable = status !== product_utils["a" /* IS_DISABLED */];
  var isSelected = status === product_utils["c" /* IS_SELECTED */];
  var buttonProps = isSelectable ? {
    onClick: onComparisonClick,
    type: 'button',
    title: label
  } : null;
  var TagName = isSelectable ? 'button' : 'div';
  return ProductComparison_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()(className, 'relative', 'reset-button')
  }, buttonProps), children, ProductComparison_jsx("div", {
    className: classnames_default()('absolute', 'bg-overlay-gray-darker-40', 'flex items-center', 'justify-center', 'p-4', 'inset-0', 'text-white', 'z-1', 'rounded-tiny', {
      'cursor-pointer': isSelectable
    })
  }, isSelectable && ProductComparison_jsx("div", {
    className: classnames_default()('flex flex-col', 'items-center', 'opacity-100', 'p-2', 'rounded-full', 'border-2', 'transition-colors', {
      'bg-transparent border-white': !isSelected
    }, {
      'bg-emerald border-emerald': isSelected
    })
  }, ProductComparison_jsx(Icon["a" /* Icon */], {
    name: isSelected ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].PLUS,
    width: "1.25rem"
  }))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx + 1 modules
var ProductFlag = __webpack_require__("ELg1");

// EXTERNAL MODULE: ./src/client/components/widgets/product/product-header/ProductHeader.jsx
var ProductHeader = __webpack_require__("hgS3");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-thumbnail/ProductThumbnail.jsx

var ProductThumbnail_jsx = react_default.a.createElement;










var OPENING_STATUS = dist["constants"].OPENING_STATUS;
var ProductThumbnail_ProductThumbnail = /*#__PURE__*/Object(react["memo"])(function ProductThumbnail(_ref) {
  var closedLabel = _ref.closedLabel,
      className = _ref.className,
      hasBorder = _ref.hasBorder,
      hasTransport = _ref.hasTransport,
      isLinkDisabled = _ref.isLinkDisabled,
      link = _ref.link,
      nextLabel = _ref.nextLabel,
      openingStatus = _ref.openingStatus,
      openingSoonLabel = _ref.openingSoonLabel,
      _ref$pictures = _ref.pictures,
      pictures = _ref$pictures === void 0 ? [] : _ref$pictures,
      previousLabel = _ref.previousLabel,
      productTags = _ref.productTags,
      _ref$tagsColor = _ref.tagsColor,
      tagsColor = _ref$tagsColor === void 0 ? colors["a" /* COLORS */].BLUE : _ref$tagsColor,
      transportLabel = _ref.transportLabel,
      isSliderDisabled = _ref.isSliderDisabled,
      hasLazyLoading = _ref.hasLazyLoading;
  var TagName = isLinkDisabled ? 'div' : DynamicLink["a" /* default */];
  var defaultPicture = pictures[0] || {};
  return ProductThumbnail_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()('block', 'image-responsive-cell', 'relative', className)
  }, isLinkDisabled ? null : link), !isSliderDisabled && pictures.length > 1 && openingStatus !== OPENING_STATUS.CLOSED ? ProductThumbnail_jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    hasInsetBorder: hasBorder,
    hasLazyLoading: true,
    media: pictures,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratios_utils["a" /* default */].XL
  }) : ProductThumbnail_jsx(Image["a" /* default */], {
    altMsg: defaultPicture.alt,
    className: classnames_default()({
      'inset-border-after': hasBorder
    }),
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    groupKey: "thumbnails",
    ratioKey: ratios_utils["a" /* default */].XL,
    hasLazyLoading: hasLazyLoading
  }), hasTransport && ProductThumbnail_jsx("div", {
    className: "bg-blue inline-flex items-center overflow-hidden p-2 text-xs text-white uppercase absolute top-0 rtl:right-0 mt-5 rtl:mr-5 rounded-tiny font-brand uppercase",
    "data-testid": "ProductThumbnail-transport"
  }, ProductThumbnail_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0 rtl:mr-1",
    name: icons["a" /* ICONS */].TRANSPORT,
    width: "calc(10rem / 16)"
  }), ProductThumbnail_jsx("div", {
    className: "leading-tight text-xxs",
    "data-testid": "ProductThumbnail-transportLabel"
  }, transportLabel)), openingStatus === OPENING_STATUS.OPENING_SOON && ProductThumbnail_jsx("div", {
    className: "bg-orange inline-flex items-center overflow-hidden p-2 text-xs text-white uppercase absolute top-0 rtl:right-0 mt-5 rtl:mr-5 rounded-tiny font-bold",
    "data-testid": "ProductThumbnail-openingSoon"
  }, ProductThumbnail_jsx("div", {
    className: "leading-tight text-xxs",
    "data-testid": "ProductThumbnail-openingSoonlabel"
  }, openingSoonLabel)), openingStatus === OPENING_STATUS.CLOSED && ProductThumbnail_jsx("div", {
    className: "absolute bg-overlay-black-60 font-bold inline-flex items-center justify-center overflow-hidden inset-0 rounded-tiny text-white text-xl uppercase",
    "data-testid": "ProductThumbnail-closed"
  }, ProductThumbnail_jsx("div", {
    "data-testid": "ProductThumbnail-closedLabel"
  }, closedLabel)), !!productTags && ProductThumbnail_jsx("div", {
    "data-testid": "ProductThumbnail-bottomTags",
    className: classnames_default()("bg-".concat(tagsColor), 'absolute leading-one font-brand uppercase left-1/2 bottom-0 p-2 mb-5 rounded-tiny text-center text-white text-xs -translate-x-50 whitespace-no-wrap max-w-9/10 truncate z-1')
  }, productTags));
});
// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.jsx



var Product_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

























var Product_Product = function Product(_ref) {
  var _flag$price, _flag$price$bestPrice;

  var _ref$callToAction = _ref.callToAction,
      callToAction = _ref$callToAction === void 0 ? {} : _ref$callToAction,
      childcare = _ref.childcare,
      childcareIncluded = _ref.childcareIncluded,
      className = _ref.className,
      comfort = _ref.comfort,
      comparison = _ref.comparison,
      departureDateOn = _ref.departureDateOn,
      _ref$flag = _ref.flag,
      flag = _ref$flag === void 0 ? {} : _ref$flag,
      hasComparison = _ref.hasComparison,
      hasDiscount = _ref.hasDiscount,
      _ref$hasFadeIn = _ref.hasFadeIn,
      hasFadeIn = _ref$hasFadeIn === void 0 ? true : _ref$hasFadeIn,
      hasLazyLoading = _ref.hasLazyLoading,
      header = _ref.header,
      id = _ref.id,
      index = _ref.index,
      isLinkDisabled = _ref.isLinkDisabled,
      _ref$kids = _ref.kids,
      kids = _ref$kids === void 0 ? [] : _ref$kids,
      lineName = _ref.lineName,
      _ref$minAuthorizedAge = _ref.minAuthorizedAge,
      minAuthorizedAge = _ref$minAuthorizedAge === void 0 ? {} : _ref$minAuthorizedAge,
      offer = _ref.offer,
      offerDiscount = _ref.offerDiscount,
      onClick = _ref.onClick,
      onComparisonClick = _ref.onComparisonClick,
      thumbnail = _ref.thumbnail,
      url = _ref.url,
      _ref$cmtaLinks = _ref.cmtaLinks,
      cmtaLinks = _ref$cmtaLinks === void 0 ? {} : _ref$cmtaLinks;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 2),
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var track = Object(useTracking["a" /* useTracking */])({});
  var pageContext = react_default.a.useContext(context_pageContext["a" /* ReactPageContext */]);
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';
  var clickThumbnailTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: id,
    resortCode: id,
    resortTrident: typeof comfort === 'number' ? comfort : '',
    thumbnailPrice: (flag === null || flag === void 0 ? void 0 : (_flag$price = flag.price) === null || _flag$price === void 0 ? void 0 : (_flag$price$bestPrice = _flag$price.bestPrice) === null || _flag$price$bestPrice === void 0 ? void 0 : _flag$price$bestPrice.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(Object(lodash["camelCase"])(lineName)) : siteSection,
    thumbnailPosition: index + 1
  } : null;
  var ProductHeaderWrapper = hasComparison ? ProductComparison_ProductComparison : react["Fragment"];
  var linkShouldBeDisabled = isLinkDisabled || hasComparison;

  var goOnResort = function goOnResort() {
    var newHistoryState = new DynamicLinkUtil["a" /* default */](dist["windowWrapper"].getLocation(), url ? Object(Product_utils["c" /* generateProductLink */])(url, offer) : '');
    history.pushRoute(newHistoryState.toString());
  };

  var productHeader = Product_jsx(ProductHeader["a" /* ProductHeader */], Object(esm_extends["a" /* default */])({}, header, {
    className: "pt-5",
    isLinkDisabled: linkShouldBeDisabled,
    link: appContext.isCmta && id && Object(Product_utils["e" /* localeHasCmtaLinks */])(cmtaLinks) ? Object(Product_utils["a" /* generateCmtaLinkProp */])(id, cmtaLinks) : Object(Product_utils["b" /* generateLinkProp */])(url, offer),
    onClick: function onClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    }
  }));

  var minAuthorizedAgeMessage = (minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) === 0 ? Object(src_i18n["f" /* t */])('faceting.availabilities.noChildcareFrom0') : Object(dist["messageFormat"])(Object(src_i18n["f" /* t */])('faceting.availabilities.noChildcare')).format({
    min_authorized_age_in_months: Math.floor((minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) / 12)
  });

  var childcareBirthdateAlert = (kids === null || kids === void 0 ? void 0 : kids.length) > 0 && childcare && Object(lodash["isEmpty"])(childcare.items) && !childcareIncluded && Product_jsx("div", {
    className: "border-1 flex p-2 rounded-tiny text-sm"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-1",
    color: colors["a" /* COLORS */].BLACK,
    name: icons["a" /* ICONS */].SMALL_WARNING,
    width: "1rem"
  }), minAuthorizedAgeMessage);

  var noChildcareAlert = kids && kids.length > 0 && kids.some(function (kid) {
    return !kid.birthdate;
  }) && childcareIncluded && Product_jsx("button", {
    className: "bg-turquoise focus:bg-turquoise-active hover:bg-turquoise-active cursor-pointer font-bold leading-one p-2 flex rounded-tiny text-initial text-sm text-white transition-colors",
    onClick: function onClick() {
      dispatchCriteriaDisplayContext({
        type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
        payload: 'criteriaWho'
      });
      Object(scrollToElement["a" /* scrollToElement */])('[data-testid="CriteriaWho"]', 600);
    },
    type: "button"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-1",
    name: icons["a" /* ICONS */].KIDS,
    width: "1rem"
  }), Object(src_i18n["f" /* t */])('faceting.availabilities.enterBirthdate'));

  return Product_jsx("article", {
    className: classnames_default()(className, 'fadeInLong flex flex-col relative', {
      fadeInLong: hasFadeIn
    }),
    onClick: onClick
  }, Product_jsx(ProductHeaderWrapper, hasComparison ? _objectSpread(_objectSpread({}, comparison), {}, {
    onComparisonClick: onComparisonClick
  }) : {}, Product_jsx("div", {
    className: "relative",
    "data-testid": "Product-Header-Wrapper"
  }, !!departureDateOn && Product_jsx("div", {
    className: "bg-white p-2 z-2 absolute rtl:left-0 -mt-5 rtl:ml-2 rounded-tiny font-brand border-1 border-turquoise shadow-xs",
    "data-testid": "Product-departure"
  }, Product_jsx("div", {
    className: "leading-tight text-base text-black",
    "data-testid": "Product-departureLabel"
  }, departureDateOn)), hasDiscount && // $FlowFixMe
  Product_jsx(OfferDiscount, Object(esm_extends["a" /* default */])({}, offerDiscount, {
    className: "absolute opacity-75 inset-x-0 z-1"
  })), Product_jsx(ProductThumbnail_ProductThumbnail, Object(esm_extends["a" /* default */])({
    className: classnames_default()('rounded-tiny', 'overflow-hidden')
  }, thumbnail, {
    hasLazyLoading: hasLazyLoading,
    isLinkDisabled: true,
    nextLabel: Object(src_i18n["f" /* t */])('common.next'),
    previousLabel: Object(src_i18n["f" /* t */])('common.previous')
  })), !hasComparison ? productHeader : null)), hasComparison ? productHeader : null, Product_jsx(ProductFlag["a" /* ProductFlag */], Object(esm_extends["a" /* default */])({}, flag, {
    isLinkDisabled: linkShouldBeDisabled,
    onClick: goOnResort,
    onCtaClick: function onCtaClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_discoverResort")
        }));
      }
    },
    onEmptyPriceClick: function onEmptyPriceClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    },
    onPriceClick: function onPriceClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_bestPrice")
        }));
      }
    },
    price: flag.price
  })), childcareBirthdateAlert, noChildcareAlert, !!callToAction.label && Product_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, callToAction, {
    className: "mt-2 w-full",
    colorBg: linkShouldBeDisabled ? colors["a" /* COLORS */].INFO : colors["a" /* COLORS */].BLUE,
    colorBorder: linkShouldBeDisabled ? colors["a" /* COLORS */].INFO : colors["a" /* COLORS */].BLUE,
    iconRight: {
      name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH
    },
    isDisabled: linkShouldBeDisabled,
    onClick: goOnResort
  }), callToAction.label), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('faceting.childcare') && childcare && !Object(lodash["isEmpty"])(childcare.items) && Product_jsx(productChildcareAvailabilities_ProductChildcareAvailabilities, childcare));
};

/***/ }),

/***/ "XpIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LEGAL_INFO_WEBTHEO_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LEGAL_INFO_THEO_ID; });
/* unused harmony export LEGAL_INFO_SMS_ID */
/* unused harmony export LEGAL_INFO_EMAIL_ID */
/* unused harmony export LEGAL_INFO_MAIL_ID */
/* unused harmony export LEGAL_INFO_FOSUN_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEGAL_INFO_CGV_ID; });
var LEGAL_INFO_WEBTHEO_ID = 'WEBTHEO';
var LEGAL_INFO_THEO_ID = 'THEO';
var LEGAL_INFO_SMS_ID = 'SMS_OPTIN';
var LEGAL_INFO_EMAIL_ID = 'EMAIL_OPTIN';
var LEGAL_INFO_MAIL_ID = 'MAIL_OPTIN';
var LEGAL_INFO_FOSUN_ID = 'FOSUN_PARTNERS';
var LEGAL_INFO_CGV_ID = 'CGV';

/***/ }),

/***/ "Xt/L":
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ "Y+p1":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("wF/u");

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ "YS3K":
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__("idjV").runInContext();
module.exports = __webpack_require__("ttrC")(_, _);


/***/ }),

/***/ "YZTm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ID_LAYER_HEADER__BE__ACCOMMODATIONS_DESKTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ID_LAYER_HEADER__BE__ACCOMMODATIONS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ID_LAYER_HEADER__BE__CATEGORY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ID_LAYER_HEADER__BE__CHOOSE_EQUIPEMENT; });
/* unused harmony export ID_LAYER_HEADER__BE__MOBILE_FILTERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ID_LAYER_HEADER__BE__SELLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE; });
/* unused harmony export ID_LAYER_HEADER__PLE__PYR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ID_LAYER_HEADER__PLE__PYR_AGENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ID_LAYER_HEADER__PLE__PYR_RESORT_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ID_LAYER_HEADER__PLE__PYR_ROOM_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS; });
/* unused harmony export ID_MODAL_HEADER__BE__BUSINESS_CLASS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ID_MODAL_HEADER__BE__OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ID_MODAL_HEADER__BE__PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ID_MODAL_HEADER__BE__SHARE_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ID_MODAL_HEADER__BE__MISMATCH_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ID_MODAL_HEADER__PLE__LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ID_MODAL_HEADER__BE__CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ID_MODAL_HEADER__PLE__NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ID_SIDEPANEL_HEADER__SHOPPING__WIBILONG_NARROW; });
// Layers header IDs
var ID_LAYER_HEADER__BE__ACCOMMODATIONS_DESKTOP = 'AccommodationsDesktopLayerHeaderId';
var ID_LAYER_HEADER__BE__ACCOMMODATIONS_MOBILE = 'AccommodationsMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__CATEGORY_LIST = 'CategoryListLayerHeaderId';
var ID_LAYER_HEADER__BE__CHOOSE_EQUIPEMENT = 'ChooseEquipmentLayerHeaderId';
var ID_LAYER_HEADER__BE__MOBILE_FILTERS = 'MobileFiltersLayerHeaderId';
var ID_LAYER_HEADER__BE__SELLER = 'SellerLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP = 'TransportsDesktopLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE = 'TransportsMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE = 'OtherProposalsMobileLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR = 'PickYourRoomLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR_AGENCY = 'PickYourRoomAgencyLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR_RESORT_ONLY = 'PYRResortOnlyLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR_ROOM_RESORT = 'PickYourRoomResortLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES = 'CookiePreferencesLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL = 'CriteriaModalLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER = 'CriteriaTriggerLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS = 'PriceRemoteDetailsLayerHeaderId'; // Modals header IDs

var ID_MODAL_HEADER__BE__BUSINESS_CLASS = 'BusinessClassModalHeaderId';
var ID_MODAL_HEADER__BE__OPTION = 'OptionModalHeaderId';
var ID_MODAL_HEADER__BE__PROMO_CODE = 'PromoCodeModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION = 'SaveCriteriaConfirmationModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN = 'SaveCriteriaLoginModalHeaderId';
var ID_MODAL_HEADER__BE__SHARE_CONTEXT = 'ShareContextModalHeaderId';
var ID_MODAL_HEADER__BE__MISMATCH_COUNTRY = 'MismatchCountryModalHeaderId';
var ID_MODAL_HEADER__PLE__LOGIN = 'ParticipantsLoginToPleModalHeaderId';
var ID_MODAL_HEADER__BE__CUSTOMER = 'ParticipantsCustomerModalHeaderId';
var ID_MODAL_HEADER__PLE__NEWSLETTER = 'NewsletterModalHeaderId';
var ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER = 'WebCallBackTriggerModalHeaderId'; // SidePanel header IDs

var ID_SIDEPANEL_HEADER__SHOPPING__WIBILONG_NARROW = 'WibilongNarrowSidePanelHeaderId';

/***/ }),

/***/ "YjXp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputSwitch_InputSwitch; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.themes.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var DEFAULT_SIZES = {
  small: 15,
  medium: 23,
  large: 23
};
var themes = {
  "default": function _default(props) {
    var color = props.color,
        isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        size = props.size,
        validationState = props.validationState;
    return {
      thRoot: 'flex items-center',
      thLabel: classnames_default()('flex items-center text-base px-px10', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'font-bold text-blue text-lg': size === 'large',
        'text-success': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'text-danger': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled
      }),
      thChecked: classnames_default()('leading-none bg-white border-1 border-solid border-gray-medium flex-shrink-0 p-px rounded-tiny', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'text-blue': isChecked,
        'bg-gray-light opacity-25': isDisabled
      }),
      thCheckedStyle: {
        width: DEFAULT_SIZES[size],
        height: DEFAULT_SIZES[size]
      },
      thLoading: 'rtl:ml-px10 flex items-center leading-none',
      thSwitch: classnames_default()('reset-button border-2 flex items-center transition-all', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), Object(defineProperty["a" /* default */])({
        'bg-gray-light border-gray-light': isDisabled,
        'bg-gray-darker border-gray-darker': !isChecked && !isDisabled
      }, "bg-".concat(color, " border-").concat(color), isChecked && !isDisabled)),
      thSwitchStyle: {
        width: 58,
        padding: '0 1px',
        height: 30,
        borderRadius: 30
      },
      thSwitchToggler: classnames_default()('bg-white block leading-none flex items-center justify-center rounded-half transition-all', Object(defineProperty["a" /* default */])({
        'rtl:translate-x-100': isChecked
      }, "text-".concat(color), isChecked && !isDisabled)),
      thSwitchTogglerStyle: {
        width: 28,
        height: 28
      }
    };
  },
  bubble: function bubble(props) {
    var isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        validationState = props.validationState;
    return {
      thRoot: 'relative',
      thLabel: classnames_default()('flex items-center justify-center shadow border-1 rounded py-px10 px-5 text-base text-center transition-colors', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'bg-white': !isDisabled,
        'bg-gray-light border-gray-light opacity-50': isDisabled,
        'border-gray-light': !isChecked && validationState === 'NOT_VALIDATED',
        'border-current text-blue': isChecked && validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'border-current text-success': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'border-current text-danger': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled
      }),
      thChecked: 'hidden',
      thLoading: 'absolute flex h-full items-center leading-none left-1/2 -translate-x-50'
    };
  },
  bubble2: function bubble2(props) {
    var isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        validationState = props.validationState;
    return {
      thRoot: 'relative',
      thLabel: classnames_default()('flex items-center justify-center border-1 rounded py-px5 px-px5 text-base text-center transition-colors', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'bg-white': !isChecked,
        'border-gray-light opacity-50': isDisabled && !isChecked,
        'border-gray-light': !isChecked && validationState === 'NOT_VALIDATED',
        'border-blue text-white bg-blue': isChecked && validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'border-current text-success': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'border-current text-danger': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled,
        'border-blue text-white bg-blue opacity-50': isDisabled && isChecked
      }),
      thChecked: 'hidden',
      thLoading: 'absolute flex h-full items-center leading-none left-1/2 -translate-x-50'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx







var __jsx = react_default.a.createElement;

function InputSwitch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function InputSwitch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InputSwitch_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InputSwitch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }











var InputSwitch_InputSwitch = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputSwitch, _Component);

  var _super = _createSuper(InputSwitch);

  function InputSwitch(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputSwitch);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function () {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? '' : _this$props$value;

      if (!isReadOnly && !isDisabled && !isLoading) {
        var isChecked = !_this.state.isChecked;

        _this.setState({
          isChecked: isChecked
        }, function () {
          return onChange(name, isChecked, value);
        });
      }
    });

    _this.state = {
      isChecked: props.isChecked || false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputSwitch, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isChecked !== this.props.isChecked) {
        this.setState({
          isChecked: this.props.isChecked
        });
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var _this$props2 = this.props,
          _this$props2$iconChec = _this$props2.iconChecked,
          iconChecked = _this$props2$iconChec === void 0 ? null : _this$props2$iconChec,
          _this$props2$iconUnCh = _this$props2.iconUnChecked,
          iconUnChecked = _this$props2$iconUnCh === void 0 ? null : _this$props2$iconUnCh;
      return this.state.isChecked ? iconChecked : iconUnChecked;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          ariaDescribedby = _this$props3.ariaDescribedby,
          ariaLabelledby = _this$props3.ariaLabelledby,
          className = _this$props3.className,
          _this$props3$id = _this$props3.id,
          id = _this$props3$id === void 0 ? "InputSwitch_".concat(shortid_default.a.generate()) : _this$props3$id,
          inputTestId = _this$props3.inputTestId,
          isDisabled = _this$props3.isDisabled,
          isLoading = _this$props3.isLoading,
          isReadOnly = _this$props3.isReadOnly,
          isRequired = _this$props3.isRequired,
          isSwitch = _this$props3.isSwitch,
          label = _this$props3.label,
          labelClassName = _this$props3.labelClassName,
          name = _this$props3.name,
          onClick = _this$props3.onClick,
          theme = _this$props3.theme,
          value = _this$props3.value,
          dataTestId = _this$props3.dataTestId;
      var isChecked = this.state.isChecked;

      var _themes$theme = themes[theme](InputSwitch_objectSpread({
        isChecked: isChecked
      }, this.props)),
          thChecked = _themes$theme.thChecked,
          thCheckedStyle = _themes$theme.thCheckedStyle,
          thLabel = _themes$theme.thLabel,
          thLoading = _themes$theme.thLoading,
          thRoot = _themes$theme.thRoot,
          thSwitch = _themes$theme.thSwitch,
          thSwitchStyle = _themes$theme.thSwitchStyle,
          thSwitchToggler = _themes$theme.thSwitchToggler,
          thSwitchTogglerStyle = _themes$theme.thSwitchTogglerStyle;

      return __jsx("div", {
        "data-testid": dataTestId,
        className: classnames_default()(className, thRoot)
      }, isSwitch ? __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: thSwitch,
        "data-testid": id,
        onClick: this.onChange,
        role: "checkbox",
        style: thSwitchStyle,
        type: "button"
      }, __jsx("span", {
        className: thSwitchToggler,
        style: thSwitchTogglerStyle
      }, isChecked ? __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].CHECK
      }) : __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].CROSS,
        width: "0.7rem"
      }))) : __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: classnames_default()('reset-button', thChecked),
        "data-testid": id,
        disabled: isDisabled,
        onClick: this.onChange,
        role: "checkbox",
        style: thCheckedStyle,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: this.getIcon(),
        width: "100%"
      })), __jsx("input", {
        checked: isChecked,
        className: "hidden",
        disabled: isDisabled,
        id: id,
        "data-testid": inputTestId,
        label: label,
        name: name,
        onChange: this.onChange,
        onClick: onClick,
        required: isRequired,
        type: "checkbox",
        value: value
      }), isLoading && !isDisabled && !isReadOnly && __jsx("div", {
        className: thLoading
      }, __jsx(Spinner["a" /* Spinner */], {
        size: "small"
      })), !!label && __jsx("label", {
        className: classnames_default()(labelClassName, thLabel),
        htmlFor: id
      }, Object(lodash["isString"])(label) ? Object(form_util["b" /* getFormattedLabel */])(label, isRequired) : label));
    }
  }]);

  return InputSwitch;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputSwitch_InputSwitch, "defaultProps", {
  color: colors["a" /* COLORS */].BLUE,
  iconChecked: icons["a" /* ICONS */].CHECK,
  iconUnChecked: null,
  isDisabled: false,
  isLoading: false,
  size: 'medium',
  theme: 'default',
  validationState: 'NOT_VALIDATED'
});

/***/ }),

/***/ "ZCpW":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__("lm/5"),
    getMatchData = __webpack_require__("O7RO"),
    matchesStrictComparable = __webpack_require__("IOzZ");

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ "ZHK4":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__("1TCz");
      }
    ]);
  

/***/ }),

/***/ "ZLJe":
/***/ (function(module) {

module.exports = JSON.parse("{\"amp\":\"&\",\"apos\":\"'\",\"gt\":\">\",\"lt\":\"<\",\"quot\":\"\\\"\"}");

/***/ }),

/***/ "ZP80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FETCH_PREBOOKING_TRAVELERS; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ fetchPrebookingTravelers; });

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/BookingAttendeesProfile.fragment.js
var BookingAttendeesProfile_fragment = __webpack_require__("SQLw");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// CONCATENATED MODULE: ./src/client/store/prebooking-form/prebookingform.queries.js


function travelerProfilesQuery(_ref) {
  var adults = _ref.adults,
      kids = _ref.kids;
  return "\n    {\n      ".concat(Object(BookingEngine_query["a" /* getCxoAttendeesData */])({
    adultsAttendeesIds: adults,
    kidsAttendeesIds: kids
  }), "\n    }\n    ").concat(adults && adults[0] || kids && kids[0] ? BookingAttendeesProfile_fragment["a" /* default */] : '', "\n  ");
}
// CONCATENATED MODULE: ./src/client/store/prebooking-form/prebookingform.action.js





var FETCH_PREBOOKING_TRAVELERS = 'FETCH_PREBOOKING_TRAVELERS';
function fetchPrebookingTravelers(params, appContext) {
  return function (dispatch) {
    if (!params.adults || params.adults.length === 0) {
      return Promise.reject();
    }

    var query = travelerProfilesQuery(params);
    var promise = graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
      requestName: requestDictionary["gb" /* CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_TRAVELERS */]
    })["catch"](function (error) {
      if (error.errors && error.errors.some(function (e) {
        return e.statusCode === 401;
      })) {
        Object(sellerUtils["f" /* handle401GraphqlErrorSeller */])(error, appContext);
      }

      return {};
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(FETCH_PREBOOKING_TRAVELERS, params, {
      optimist: true,
      promise: promise
    }));
  };
}

/***/ }),

/***/ "ZS6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductPriceInfo; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qqKu");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var ProductPriceInfo = function ProductPriceInfo(_ref) {
  var city = _ref.city,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      isCruise = _ref.isCruise,
      isJoyview = _ref.isJoyview,
      isTour = _ref.isTour,
      onClick = _ref.onClick,
      startDate = _ref.startDate,
      unit = _ref.unit;
  var isAllInclusive = !isJoyview && !isTour; // eslint-disable-next-line no-nested-ternary

  var buttonLabel = isTour ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.buttonTourLabel') : isCruise ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.buttonCruiseLabel') : Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.buttonLabel');
  return __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "a"], {
    className: "p-5",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].GRAY_DARKER,
    text: [hasTransport ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.startingPriceDescriptionWithTransport', {
      unit: unit,
      city: city,
      endDate: endDate,
      startDate: startDate
    }) : Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.startingPriceDescriptionWithoutTransport', {
      endDate: endDate,
      startDate: startDate,
      unit: unit
    }), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.roomAvailability')].join(' '),
    theme: "text-sans-2"
  }), (isAllInclusive || onClick) && __jsx("div", {
    className: "flex flex-col items-center border-t-1 border-gray-light p-5"
  }, isAllInclusive && __jsx("p", {
    className: "flex flex-col sm:flex-row sm:flex-wrap sm:justify-center max-w-full reset-paragraph text-center text-gray-darker text-sm"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.priceIsLabel'), ' ', __jsx("span", {
    className: "font-brand rtl:ml-1 text-blue text-md"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    className: "-mt-1 rtl:mr-1",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLUE,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].ALL_INCLUSIVE,
    width: "1.2rem"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.startingPrice.allInclusive'))), onClick && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_4__[/* Button */ "a"], {
    className: "mt-px10",
    colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BOOKING,
    colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BOOKING,
    dataTestId: "ProductPriceInfo-button",
    onClick: onClick
  }, buttonLabel)));
};

/***/ }),

/***/ "ZoZw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PYR_MAP_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_POLYGONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIGHLIGHT_BUILDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TOGGLE_BUILDING_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESET_BUILDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SELECT_MAP_FLOOR_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIT_BOUNDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return reducer; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_widgets_pick_your_room_wrapper_map_gl_styles_buildings_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("U9LJ");
/* harmony import */ var _app_pickYourRoom_reducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ogu6");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var PYR_MAP_ERROR = 'PYR_MAP_ERROR';
var LOAD_STYLE = 'LOAD_STYLE';
var LOAD_POLYGONS = 'LOAD_POLYGONS';
var SET_RESORT = 'SET_RESORT_PYR';
var HIGHLIGHT_BUILDING = 'HIGHLIGHT_BUILDING';
var TOGGLE_BUILDING_SELECTION = 'TOGGLE_BUILDING_SELECTION';
var RESET_BUILDING = 'RESET_BUILDING';
var SELECT_MAP_FLOOR_LEVEL = 'SELECT_MAP_FLOOR_LEVEL';
var FIT_BOUNDS = 'FIT_BOUNDS';
var initialState = {
  mapStyle: null,
  maxBounds: null,
  amenities: [],
  geoJSON: null,
  currentBounds: null,
  highlightedBuildingId: ''
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case PYR_MAP_ERROR:
      {
        var error = action.payload.error;
        return _objectSpread(_objectSpread({}, state), {}, {
          error: error
        });
      }

    case LOAD_STYLE:
      {
        var mapStyle = action.payload.mapStyle;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: mapStyle
        });
      }

    case SET_RESORT:
      {
        var resortData = action.payload.resortData;

        if (!resortData) {
          return state;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          baseViewport: resortData.initialViewport,
          targetViewport: resortData.targetViewport,
          maxBounds: resortData.maxBounds,
          amenities: resortData.amenities.features
        });
      }

    case LOAD_POLYGONS:
      {
        var geoJSON = action.payload.geojson;
        var _mapStyle = state.mapStyle;
        var layers = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_mapStyle.layers || []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_components_widgets_pick_your_room_wrapper_map_gl_styles_buildings_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"] || []));
        var layerIndexes = {
          floors: layers.findIndex(function (layer) {
            return layer.id === 'floors';
          }),
          floorsCurrent: layers.findIndex(function (layer) {
            return layer.id === 'floors_current';
          }),
          floorsCurrentDimmed: layers.findIndex(function (layer) {
            return layer.id === 'floors_current_dimmed';
          }),
          floorsHighlight: layers.findIndex(function (layer) {
            return layer.id === 'floors_highlight';
          })
        };
        var newMapStyle = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(state.mapStyle);
        newMapStyle.sources.buildingsSource = {
          type: 'geojson',
          data: geoJSON
        };
        return _objectSpread(_objectSpread({}, state), {}, {
          geoJSON: geoJSON,
          layerIndexes: layerIndexes,
          mapStyle: _objectSpread(_objectSpread({}, newMapStyle), {}, {
            layers: layers
          })
        });
      }

    case _app_pickYourRoom_reducer__WEBPACK_IMPORTED_MODULE_4__[/* SELECT_BUILDING */ "i"]:
      {
        var buildingId = action.payload.buildingId;
        var _layerIndexes = state.layerIndexes,
            _mapStyle2 = state.mapStyle;

        var _newMapStyle = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle2);

        _newMapStyle.layers[_layerIndexes.floors].filter[2] = buildingId;
        _newMapStyle.layers[_layerIndexes.floorsCurrent].filter[1][2] = buildingId;
        _newMapStyle.layers[_layerIndexes.floorsCurrentDimmed].filter[1][2] = buildingId;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _objectSpread(_objectSpread({}, _mapStyle2), _newMapStyle)
        });
      }

    case RESET_BUILDING:
      {
        var _layerIndexes2 = state.layerIndexes,
            _mapStyle3 = state.mapStyle;

        var _newMapStyle2 = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle3);

        _newMapStyle2.layers[_layerIndexes2.floors].filter[2] = '';
        _newMapStyle2.layers[_layerIndexes2.floorsCurrent].filter[1][2] = '';
        _newMapStyle2.layers[_layerIndexes2.floorsCurrentDimmed].filter[1][2] = '';
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _objectSpread(_objectSpread({}, _mapStyle3), _newMapStyle2),
          highlightedBuildingId: ''
        });
      }

    case SELECT_MAP_FLOOR_LEVEL:
      {
        var _layerIndexes3 = state.layerIndexes,
            _mapStyle4 = state.mapStyle;
        var level = action.payload.level;

        var _newMapStyle3 = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle4);

        _newMapStyle3.layers[_layerIndexes3.floorsCurrent].filter[2][2] = level;
        _newMapStyle3.layers[_layerIndexes3.floorsCurrentDimmed].filter[2][2] = level;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _objectSpread(_objectSpread({}, _mapStyle4), _newMapStyle3)
        });
      }

    case HIGHLIGHT_BUILDING:
      {
        var _layerIndexes4 = state.layerIndexes,
            _mapStyle5 = state.mapStyle;
        var _buildingId = action.payload.buildingId;

        var _newMapStyle4 = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle5);

        _newMapStyle4.layers[_layerIndexes4.floorsHighlight].filter[2] = _buildingId;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _objectSpread(_objectSpread({}, _mapStyle5), _newMapStyle4),
          highlightedBuildingId: _buildingId
        });
      }

    case TOGGLE_BUILDING_SELECTION:
      {
        var _layerIndexes5 = state.layerIndexes,
            _mapStyle6 = state.mapStyle;
        var allow = action.payload.allow;

        var _newMapStyle5 = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["cloneDeep"])(_mapStyle6);

        _newMapStyle5.layers[_layerIndexes5.floors].interactive = allow;
        return _objectSpread(_objectSpread({}, state), {}, {
          mapStyle: _newMapStyle5
        });
      }

    case FIT_BOUNDS:
      {
        var bounds = action.payload.bounds;
        return _objectSpread(_objectSpread({}, state), {}, {
          currentBounds: bounds
        });
      }

    default:
      {
        return state;
      }
  }
}

/***/ }),

/***/ "aUQU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAutocomplete; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zygG");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ub5k");
/* harmony import */ var _use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ngAq");
/* harmony import */ var _client_store_utils_autocompleteItemHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Qmkj");
/* harmony import */ var _utils_pertimm_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("y316");








function useAutocomplete() {
  var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(keywords),
      autocompleteQuery = _useState[0],
      setAutocompleteQuery = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])([]),
      autocompleteResults = _useState2[0],
      setAutocompleteResults = _useState2[1];

  var _useDebounce = Object(_use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_5__[/* useDebounce */ "a"])([autocompleteQuery], 300),
      _useDebounce2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_useDebounce, 1),
      debouncedAutocompleteQuery = _useDebounce2[0]; // This effect is used to fetch autocomplete suggestions when the query changes (with a 300ms debounce)


  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee() {
        var _ref2, _ref2$answers, answers, results;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_7__[/* suggest */ "d"])({
                  criteria: {
                    keywords: debouncedAutocompleteQuery
                  },
                  appContext: appContext
                });

              case 3:
                _ref2 = _context.sent;
                _ref2$answers = _ref2.answers;
                answers = _ref2$answers === void 0 ? [] : _ref2$answers;
                results = answers.map(_client_store_utils_autocompleteItemHelper__WEBPACK_IMPORTED_MODULE_6__[/* getResultItem */ "b"]).sort(function (_ref3, _ref4) {
                  var productIdA = _ref3.productId;
                  var productIdB = _ref4.productId;

                  if (productIdA && !productIdB) {
                    return -1;
                  }

                  if (!productIdA && productIdB) {
                    return 1;
                  }

                  return 0;
                });
                setAutocompleteResults(results);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                setAutocompleteResults([]);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    if (debouncedAutocompleteQuery) {
      fetchData();
    } else {
      setAutocompleteResults([]);
    }
  }, [debouncedAutocompleteQuery]);
  return {
    autocompleteQuery: autocompleteQuery,
    setAutocompleteQuery: setAutocompleteQuery,
    autocompleteResults: autocompleteResults,
    setAutocompleteResults: setAutocompleteResults
  };
}

/***/ }),

/***/ "aWOT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCGVFromLegalInfos; });
/* unused harmony export getCarriersLabel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tAlt; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("YS3K");
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_booking_process_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("XpIN");






var PRODUCT_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES;

var getCGVFromLegalInfos = function getCGVFromLegalInfos(bookingProcess) {
  // $FlowFixMe
  return (bookingProcess || []).find(function (bp) {
    return bp.id === _utils_booking_process_constants__WEBPACK_IMPORTED_MODULE_5__[/* LEGAL_INFO_CGV_ID */ "a"];
  }) || {
    label: ''
  };
};

function getCarriersLabels(journey) {
  return Object(lodash_fp__WEBPACK_IMPORTED_MODULE_1__["pipe"])([Object(lodash_fp__WEBPACK_IMPORTED_MODULE_1__["path"])('travelSections') || [], Object(lodash_fp__WEBPACK_IMPORTED_MODULE_1__["map"])(Object(lodash_fp__WEBPACK_IMPORTED_MODULE_1__["path"])('transport.companyOperator.label'))])(journey);
}

var getCarriersLabel = function getCarriersLabel(inbound, outbound) {
  var uniqCarriers = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["uniq"])([].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(getCarriersLabels(inbound)), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(getCarriersLabels(outbound))));
  var firstCarrier = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["head"])(uniqCarriers);
  var lastCarriers = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["tail"])(uniqCarriers);
  return !Object(lodash__WEBPACK_IMPORTED_MODULE_2__["isEmpty"])(lastCarriers) ? lastCarriers.join(', ').concat(" {lastSeparator} ".concat(firstCarrier)) : firstCarrier;
};

var tAlt = function tAlt(_ref) {
  var resortKeyPath = _ref.resortKeyPath,
      cruiseKeyPath = _ref.cruiseKeyPath,
      resort = _ref.resort,
      variables = _ref.variables;
  return Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])(resort.type === PRODUCT_TYPES.CRUISE ? cruiseKeyPath : resortKeyPath, variables);
};



/***/ }),

/***/ "alwl":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("eUgh"),
    baseIteratee = __webpack_require__("ut/Y"),
    baseMap = __webpack_require__("l9OW"),
    baseSortBy = __webpack_require__("1LK5"),
    baseUnary = __webpack_require__("sEf8"),
    compareMultiple = __webpack_require__("IWTy"),
    identity = __webpack_require__("zZ0H");

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ "b0q8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.resolve = resolve;
exports.reject = reject;
exports.unresolve = unresolve;
exports.unreject = unreject;
exports.isResolvedAction = isResolvedAction;
exports.isRejectedAction = isRejectedAction;
exports.isThenAction = isThenAction;
exports.default = optimistPromiseMiddleware;

var _fluxStandardAction = __webpack_require__("8soX");

function isPromise(val) {
  return val && typeof val.then === 'function';
}

var RESOLVED_NAME = '_RESOLVED',
    REJECTED_NAME = '_REJECTED';

var BEGIN = 'BEGIN';
var COMMIT = 'COMMIT';
var REVERT = 'REVERT';

function resolve(actionName) {
  return actionName + RESOLVED_NAME;
}

function reject(actionName) {
  return actionName + REJECTED_NAME;
}

function unresolve(resolvedActionName) {
  return resolvedActionName.split(RESOLVED_NAME)[0];
}

function unreject(rejectedActionName) {
  return rejectedActionName.split(REJECTED_NAME)[0];
}

function isResolvedAction(resolvedActionName) {
  return unresolve(resolvedActionName) !== resolvedActionName;
}

function isRejectedAction(rejectedActionName) {
  return unreject(rejectedActionName) !== rejectedActionName;
}

function isThenAction(thenActionName) {
  return isResolvedAction(thenActionName) || isRejectedAction(thenActionName);
}

function optimistPromiseMiddleware() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$throwOnReject = _ref.throwOnReject,
      throwOnReject = _ref$throwOnReject === undefined ? true : _ref$throwOnReject,
      _ref$resolvedName = _ref.resolvedName,
      resolvedName = _ref$resolvedName === undefined ? RESOLVED_NAME : _ref$resolvedName,
      _ref$rejectedName = _ref.rejectedName,
      rejectedName = _ref$rejectedName === undefined ? REJECTED_NAME : _ref$rejectedName;

  RESOLVED_NAME = resolvedName;
  REJECTED_NAME = rejectedName;

  var nextTransactionID = 0;
  return function (_ref2) {
    var dispatch = _ref2.dispatch;
    return function (next) {
      return function (action) {
        if (!(0, _fluxStandardAction.isFSA)(action) || !action.meta || !isPromise(action.meta.promise)) {
          return next(action);
        }

        var isOptimist = action.meta.optimist;

        var transactionID = void 0;

        if (isOptimist) {
          transactionID = nextTransactionID++;
        }

        // (1) Dispatch actionName with meta with arguments apart from promise

        // Clone original action
        var newAction = _extends({}, action, {
          meta: _extends({}, action.meta)
        });

        if (isOptimist) {
          // Adding optimistic meta
          newAction.optimist = { type: BEGIN, id: transactionID };
          delete newAction.meta.optimist;
        }

        if (Object.keys(newAction.meta).length === 1) {
          delete newAction.meta;
        } else {
          // Other arguments, delete promise and optimist only
          delete newAction.meta.promise;
        }

        var skipOptimist = action.meta.skipOptimist;

        if (!skipOptimist) {
          next(newAction);
        }

        // Create a base for the next action containing the metadata.
        var nextActionBase = {
          meta: _extends({}, newAction.meta, {
            payload: newAction.payload
          })
        };

        if (!nextActionBase.meta.payload) {
          // No payload, no need to include them in the meta.
          delete nextActionBase.meta.payload;
        }
        if (Object.keys(nextActionBase.meta).length === 0) {
          // No meta was included either, remove all meta.
          delete nextActionBase.meta;
        }

        // (2) Listen to promise and dispatch payload with new actionName
        return action.meta.promise.then(function (result) {
          var actionToDispatch = _extends({
            type: resolve(action.type),
            payload: result
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: COMMIT, id: transactionID };
          }
          dispatch(actionToDispatch);
          return result;
        }).catch(function (error) {
          var actionToDispatch = _extends({
            type: reject(action.type),
            payload: error
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: REVERT, id: transactionID };
          }
          dispatch(actionToDispatch);
          if (throwOnReject) {
            throw error;
          }
        });
      };
    };
  };
}

/***/ }),

/***/ "b80T":
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__("UNi/"),
    isArguments = __webpack_require__("03A+"),
    isArray = __webpack_require__("Z0cm"),
    isBuffer = __webpack_require__("DSRE"),
    isIndex = __webpack_require__("wJg7"),
    isTypedArray = __webpack_require__("c6wG");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "bJ4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isTokenValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleInvalidToken; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("L7OA");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("6jSF");




var isTokenValid = function isTokenValid(userInfo) {
  return userInfo && moment__WEBPACK_IMPORTED_MODULE_0___default()(userInfo.expirationDate, 'X').startOf('second').isAfter();
};
var handleInvalidToken = function handleInvalidToken(_ref) {
  var appContext = _ref.appContext,
      currentUri = _ref.currentUri,
      res = _ref.res,
      userInfo = _ref.userInfo;
  var redirectUri = Object(_index__WEBPACK_IMPORTED_MODULE_3__[/* isCxoSellerContext */ "n"])(currentUri.search()) ? Object(_index__WEBPACK_IMPORTED_MODULE_3__[/* buildSellerSigninUrl */ "e"])({
    locale: appContext.locale,
    redirectUri: currentUri.toString(),
    redirectURIError: Object(_index__WEBPACK_IMPORTED_MODULE_3__[/* buildErrorUrl */ "c"])(currentUri.toString(), appContext.locale)
  }) : Object(_index__WEBPACK_IMPORTED_MODULE_3__[/* buildSigninUrl */ "f"])({
    locale: appContext.locale,
    redirectUri: currentUri.toString(),
    redirectURIError: Object(_index__WEBPACK_IMPORTED_MODULE_3__[/* buildErrorUrl */ "c"])(currentUri.toString(), appContext.locale),
    isQuickLoginFirst: currentUri.toString().includes("provider=".concat(_index__WEBPACK_IMPORTED_MODULE_3__[/* QUICK_LOGIN_QUERY_PARAM */ "a"])) || Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_2__[/* isFeatureFlipped */ "a"])(appContext)('memberSpace.isQuickLoginFirst')
  }); // not filled because the cookie is httpOnly
  // if (!appContext.authenticationToken) {

  if (!appContext.isUserLogged && !appContext.isUserQuickLogged && !appContext.isSellerLogged) {
    if (res) {
      res.redirect(302, redirectUri);
    } else {
      _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["windowWrapper"].setLocation(redirectUri);
    }
  } else if ((appContext.isUserLogged || appContext.isUserQuickLogged) && !isTokenValid(userInfo)) {
    _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["windowWrapper"].setLocation(redirectUri);
  }
};

/***/ }),

/***/ "c6wG":
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__("dD9F"),
    baseUnary = __webpack_require__("sEf8"),
    nodeUtil = __webpack_require__("mdPL");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "cGFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getValidationStateFromKid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getValidationStateFromKids; });
/* unused harmony export updateValidationStateForKid */
/* unused harmony export addOrRemoveKidFromValidationState */
/* unused harmony export addOrRemoveKidFromKidsList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasKidWithoutAValidBirthdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasOnlyValidKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return invalidateNotValidatedKids; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* harmony import */ var _facetingUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kNiU");
/* harmony import */ var _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("45yR");




var getValidationStateFromKid = function getValidationStateFromKid(kid, isKidBirthdateRequired) {
  if (typeof kid !== 'object') {
    return _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
  }

  if (!kid.birthdate) {
    return isKidBirthdateRequired ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"];
  }

  return typeof kid === 'object' && Object(_facetingUtils__WEBPACK_IMPORTED_MODULE_2__[/* isKidMinor */ "g"])(kid.birthdate) ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_VALID */ "b"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
};
var getValidationStateFromKids = function getValidationStateFromKids() {
  var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return kids.map(function (kid) {
    return getValidationStateFromKid(kid);
  });
};
var updateValidationStateForKid = function updateValidationStateForKid(_ref) {
  var index = _ref.index,
      kid = _ref.kid,
      _ref$kidsValidationSt = _ref.kidsValidationState,
      kidsValidationState = _ref$kidsValidationSt === void 0 ? [] : _ref$kidsValidationSt;
  var validationState = getValidationStateFromKid(kid);
  return kidsValidationState.map(function (kidValidation, indexKid) {
    var isNewKid = kidValidation === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"];
    var kidNeedsValidation = !!kid.birthdate || !isNewKid;
    return indexKid === index && kidNeedsValidation ? validationState : kidValidation;
  });
};
var addOrRemoveKidFromValidationState = function addOrRemoveKidFromValidationState(_ref2) {
  var _ref2$currentState = _ref2.currentState,
      currentState = _ref2$currentState === void 0 ? [] : _ref2$currentState,
      kidsNumber = _ref2.kidsNumber;

  if (kidsNumber > currentState.length) {
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(currentState), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Array(kidsNumber - currentState.length).fill(_client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__[/* VALIDATION_STATE_ENUM */ "f"].notvalidated)));
  }

  if (kidsNumber < currentState.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(currentState.slice(0, kidsNumber));
  }

  return currentState;
};
var addOrRemoveKidFromKidsList = function addOrRemoveKidFromKidsList(args) {
  var _args$kids = args.kids,
      kids = _args$kids === void 0 ? [] : _args$kids,
      kidsNumber = args.kidsNumber;

  if (kidsNumber > kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(kids).concat(Array(kidsNumber - kids.length).fill().map(function () {
      return _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__[/* DEFAULT_KID_VALUE */ "a"];
    }));
  }

  if (kidsNumber < kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(kids.slice(0, kidsNumber));
  }

  return kids;
};
var hasKidWithoutAValidBirthdate = function hasKidWithoutAValidBirthdate(kidsValidationState) {
  return Boolean(kidsValidationState && kidsValidationState.find(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
  }));
};
var hasOnlyValidKids = function hasOnlyValidKids(kidsValidationState) {
  return kidsValidationState.every(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_VALID */ "b"];
  });
};
var invalidateNotValidatedKids = function invalidateNotValidatedKids(kidsValidationState) {
  return kidsValidationState.reduce(function (acc, current) {
    if (current === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"]) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [_client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"]]);
    }

    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [current]);
  }, []);
};

/***/ }),

/***/ "cHMM":
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__("tRRp");

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),

/***/ "cq/+":
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__("mc0g");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "cvCv":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "cvSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SYNC_WITH_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SEARCH_SET_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return TRIP_INFORMATION_SET_DEPARTURE_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TRIP_INFORMATION_SET_DEPARTURE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_USER_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_USER_PAST_TRIPS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RESET_USER_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_USER_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_USER_FUTURE_TRIPS_FETCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_USER_FUTURE_TRIPS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RESET_USER_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_USER_SEARCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_USER_SEARCHES_RESOLVED; });
/* unused harmony export SET_PARTICIPANTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_CALENDAR_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_CALENDAR_TRIP_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_CALENDAR_TRIP_PRICE_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_BOOKABLE_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_BOOKABLE_DATES_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALENDAR_CHANGE_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CALENDAR_SET_INITIAL_DURATION; });
/* unused harmony export QUOTATION_FORM_UPDATE */
/* unused harmony export QUOTATION_FORM_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UPDATE_TRIP_DATE_CRITERIA; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);

var SYNC_WITH_LOCATION = 'SYNC_WITH_LOCATION';
var SEARCH_SET_KEYWORDS = 'SEARCH_SET_KEYWORDS';
var TRIP_INFORMATION_SET_DEPARTURE_CITY = 'TRIP_INFORMATION_SET_DEPARTURE_CITY';
var TRIP_INFORMATION_SET_DEPARTURE_DATE = 'TRIP_INFORMATION_SET_DEPARTURE_DATE';
var FETCH_USER_PAST_TRIPS = 'FETCH_USER_PAST_TRIPS';
var FETCH_USER_PAST_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_PAST_TRIPS);
var RESET_USER_PAST_TRIPS = 'RESET_USER_PAST_TRIPS';
var FETCH_USER_FUTURE_TRIPS = 'FETCH_USER_FUTURE_TRIPS';
var FETCH_USER_FUTURE_TRIPS_FETCHED = 'FETCH_USER_FUTURE_TRIPS_FETCHED';
var FETCH_USER_FUTURE_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_FUTURE_TRIPS);
var RESET_USER_FUTURE_TRIPS = 'RESET_USER_FUTURE_TRIPS';
var FETCH_USER_SEARCHES = 'FETCH_USER_SEARCHES';
var FETCH_USER_SEARCHES_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_SEARCHES);
var SET_PARTICIPANTS = 'SET_PARTICIPANTS';
var FETCH_CALENDAR = 'FETCH_CALENDAR';
var FETCH_CALENDAR_ABORT = 'FETCH_CALENDAR_ABORT';
var FETCH_CALENDAR_TRIP_PRICE = 'FETCH_CALENDAR_TRIP_PRICE';
var FETCH_CALENDAR_TRIP_PRICE_ABORT = 'FETCH_CALENDAR_TRIP_PRICE_ABORT';
var FETCH_BOOKABLE_DATES = 'FETCH_BOOKABLE_DATES';
var FETCH_BOOKABLE_DATES_ABORT = 'FETCH_BOOKABLE_DATES_ABORT';
var CALENDAR_CHANGE_MONTH = 'CALENDAR_CHANGE_MONTH';
var CLEAR_CALENDAR = 'CLEAR_CALENDAR';
var CALENDAR_SET_INITIAL_DURATION = 'CALENDAR_SET_INITIAL_DURATION';
var QUOTATION_FORM_UPDATE = 'QUOTATION_FORM_UPDATE';
var QUOTATION_FORM_REQUEST = 'QUOTATION_FORM_REQUEST';
var UPDATE_TRIP_DATE_CRITERIA = 'UPDATE_TRIP_DATE_CRITERIA';

/***/ }),

/***/ "dD9F":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("NykK"),
    isLength = __webpack_require__("shjB"),
    isObjectLike = __webpack_require__("ExA7");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "dGB2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CABIN_CLASS_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPANIES_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LAYOVERS_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TIME_RANGES_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CABIN_CLASS_ECO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CABIN_CLASS_BUSINESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FLIGHT_CLASS_ECO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FLIGHT_CLASS_BUSINESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FLIGHT_CLASS_ALIZEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FLIGHT_CLASS_EMERALD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FLIGHT_CLASS_FIRST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FLIGHT_CLASS_PREMIUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ZERO_LAYOVERS_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ONE_LAYOVERS_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TWO_LAYOVERS_ICON; });
var CABIN_CLASS_CATEGORY = 'cabinClass';
var COMPANIES_CATEGORY = 'companies';
var LAYOVERS_CATEGORY = 'layovers';
var TIME_RANGES_CATEGORY = 'timeRanges';
var CABIN_CLASS_ECO = 'ECO';
var CABIN_CLASS_BUSINESS = 'BUSINESS';
var FLIGHT_CLASS_ECO = 'ECO';
var FLIGHT_CLASS_BUSINESS = 'BUS';
var FLIGHT_CLASS_ALIZEE = 'EC+';
var FLIGHT_CLASS_EMERALD = 'DIB';
var FLIGHT_CLASS_FIRST = 'FIR';
var FLIGHT_CLASS_PREMIUM = 'PRE';
var ZERO_LAYOVERS_ICON = 'noStop';
var ONE_LAYOVERS_ICON = '1Stop';
var TWO_LAYOVERS_ICON = '2Stops';

/***/ }),

/***/ "dQpi":
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__("yGk4"),
    noop = __webpack_require__("vN+2"),
    setToArray = __webpack_require__("rEGp");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ "e5cp":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("fmRc"),
    equalArrays = __webpack_require__("or5M"),
    equalByTag = __webpack_require__("HDyB"),
    equalObjects = __webpack_require__("seXi"),
    getTag = __webpack_require__("QqLw"),
    isArray = __webpack_require__("Z0cm"),
    isBuffer = __webpack_require__("DSRE"),
    isTypedArray = __webpack_require__("c6wG");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "eN33":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "evRn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLastVisitedProductIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackLastVisitedProducts; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _local_storage_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1RIK");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("829J");





var _b2cPagesService$PAGE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["b2cPagesService"].PAGE_TYPES,
    RESORT = _b2cPagesService$PAGE.RESORT,
    TOUR = _b2cPagesService$PAGE.TOUR,
    CRUISE = _b2cPagesService$PAGE.CRUISE,
    RESORT_MICE = _b2cPagesService$PAGE.RESORT_MICE;
function getLastVisitedProductIds() {
  var trackingShopping = Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_3__[/* getFromLocalStorage */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_TRACKING */ "u"]);
  return trackingShopping ? trackingShopping[_constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_LAST_VISITED_PRODUCTS */ "s"]] : [];
}
function trackLastVisitedProducts(pageContext, productId) {
  if ([RESORT, TOUR, CRUISE, RESORT_MICE].includes(pageContext.pageType) && productId) {
    var seenProductIds = getLastVisitedProductIds().filter(function (seenResortId) {
      return seenResortId !== productId;
    }).slice(0, _constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_LAST_VISITED_PRODUCTS_NUMBER */ "t"] - 1);
    Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_3__[/* setInLocalStorage */ "d"])(_constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_TRACKING */ "u"], Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, _constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_LAST_VISITED_PRODUCTS */ "s"], [productId].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(seenProductIds))));
  }
}

/***/ }),

/***/ "fR/l":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("CH3K"),
    isArray = __webpack_require__("Z0cm");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "fYnN":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "fflk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureDate; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function setDepartureDate(departureDate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_DATE */ "v"], {
    departureDate: departureDate
  });
}



/***/ }),

/***/ "fmRc":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("Xi7e"),
    stackClear = __webpack_require__("77Zs"),
    stackDelete = __webpack_require__("L8xA"),
    stackGet = __webpack_require__("gCq4"),
    stackHas = __webpack_require__("VaNO"),
    stackSet = __webpack_require__("0Cz8");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "ftKO":
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "gCq4":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "gyFy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("Phb7");


/***/ }),

/***/ "hPQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACET_QUERY_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return navigateToSearchPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return navigateToResortPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentUrlContainsSearchQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return currentUrlHasNoQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFacetsAsString; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("U2CP");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("k9PE");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("nv//");








var FACET_QUERY_PARAMS = [_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_KIDS */ "h"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "A"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"]];

var computeQueryParamsForUrl = function computeQueryParamsForUrl(args) {
  var _ref;

  var criteriaKeysToPersist = args.criteriaKeysToPersist,
      searchCriteria = args.searchCriteria;
  var formattedDate = searchCriteria.departureDate && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* getDepartureDateDisplayValue */ "d"])(Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* formatDepartureDateForStore */ "a"])(searchCriteria.departureDate, ''));
  var searchQuery = searchCriteria.query ? searchCriteria.query.label : '';
  return _ref = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"]) && formattedDate || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"]) && searchCriteria.duration || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"]) && searchCriteria.departureCity || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "A"], criteriaKeysToPersist.includes(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "A"]) && (searchCriteria.keywords || searchQuery) || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_KIDS */ "h"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_KIDS */ "h"]) && searchCriteria.kids.length > 0 && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* serializeKidsToQueryParam */ "h"])({
    kids: searchCriteria.kids,
    kidsValidationState: searchCriteria.kidsValidationState
  }) || undefined), _ref;
};

var navigateToSearchPage = function navigateToSearchPage(args) {
  var criteriaKeysToPersist = args.criteriaKeysToPersist,
      location = args.location,
      searchCriteria = args.searchCriteria,
      searchPageRouteName = args.searchPageRouteName;
  var queryParams = computeQueryParamsForUrl({
    criteriaKeysToPersist: criteriaKeysToPersist,
    searchCriteria: searchCriteria
  }); // NOTE: URI.setQuery() does not remove existing queries

  var searchPageUrl = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_7__[/* convertLocationToURI */ "c"])(location).setQuery(queryParams);
  var previousPathname = searchPageUrl.pathname();
  var pathname = searchPageRouteName ? _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_2__[/* urlPattern */ "b"](searchPageRouteName) : null;

  if (pathname) {
    searchPageUrl.pathname(pathname);
  }

  var isShallow = searchPageUrl.pathname() === previousPathname;
  _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].redirectTo()(searchPageUrl, {
    replace: isShallow,
    shallow: isShallow
  });
};
var navigateToResortPage = function navigateToResortPage(args) {
  var location = args.location,
      query = args.query,
      searchCriteria = args.searchCriteria;
  var queryParams = computeQueryParamsForUrl({
    criteriaKeysToPersist: [_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"]],
    searchCriteria: searchCriteria
  });
  var resortPageUrl = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_7__[/* convertLocationToURI */ "c"])(location).pathname(query.link).setQuery(queryParams);
  _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].redirectTo()(resortPageUrl);
};
var currentUrlContainsSearchQueryParam = function currentUrlContainsSearchQueryParam(location) {
  return !Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(location.queryParams[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "A"]]);
};
var currentUrlHasNoQueryParams = function currentUrlHasNoQueryParams(location) {
  return FACET_QUERY_PARAMS.every(function (queryKey) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(location.queryParams[queryKey]);
  });
};
var getFacetsAsString = function getFacetsAsString(filters, facetCategoryId) {
  var facetsInCategory = filters.filter(function (filter) {
    return filter.id === facetCategoryId;
  });

  if (facetsInCategory.length === 0) {
    return null;
  }

  return facetsInCategory.map(function (filter) {
    return filter.name;
  }).join('|');
};

/***/ }),

/***/ "heNW":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "hfZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABTestContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ABTestContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});

/***/ }),

/***/ "hgQt":
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__("Juji"),
    hasPath = __webpack_require__("4sDh");

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ "hgS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductHeader; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("VHif");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("i5Mr");
/* harmony import */ var _exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Itgl");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("MWZw");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;







var ICONS_HEIGHT = 32;
var ProductHeader = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["memo"])(function ProductHeader(_ref) {
  var badge = _ref.badge,
      _ref$badgeColor = _ref.badgeColor,
      badgeColor = _ref$badgeColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BLUE : _ref$badgeColor,
      _ref$badgeIcon = _ref.badgeIcon,
      badgeIcon = _ref$badgeIcon === void 0 ? {} : _ref$badgeIcon,
      className = _ref.className,
      hasECLogo = _ref.hasECLogo,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? {} : _ref$heading,
      isLinkDisabled = _ref.isLinkDisabled,
      link = _ref.link,
      onClick = _ref.onClick;
  var _heading$title = heading.title,
      title = _heading$title === void 0 ? '' : _heading$title,
      _heading$subtitle = heading.subtitle,
      subtitle = _heading$subtitle === void 0 ? '' : _heading$subtitle;
  var TagName = isLinkDisabled ? 'div' : _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"];
  return __jsx("header", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'flex'),
    onClick: onClick,
    "data-testid": "Product-Header"
  }, __jsx(TagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    className: "reset-anchor flex flex-1 z-1 min-w-0",
    "data-testid": "ProductHeader-link"
  }, isLinkDisabled ? null : link), !isLinkDisabled && __jsx("div", {
    className: "absolute inset-0",
    "data-testid": "ProductHeader-link-overlay"
  }), __jsx("div", {
    className: "relative flex-1 flex flex-col-reverse justify-center -mb-px overflow-hidden rtl:pr-1"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__[/* Title */ "a"], {
    className: "flex items-center font-brand leading-one text-lg",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].GRAY_DARKER,
    hasEllipsis: true,
    hLevel: 2,
    role: "presentation",
    theme: "none"
  }, title), __jsx("div", {
    className: "flex"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__[/* Title */ "a"], {
    className: "flex min-w-0 items-center font-bold font-sans text-sm uppercase tracking-tight",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].GRAY_MEDIUM,
    hasEllipsis: true,
    hLevel: 3,
    role: "presentation",
    theme: "none"
  }, subtitle), !!badge && __jsx("div", {
    "data-testid": "ProductHeader-seasonBadge",
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("bg-".concat(badgeColor), 'leading-one p-1 font-bold uppercase rounded-tiny text-center text-white text-xs whitespace-no-wrap rtl:ml-2')
  }, __jsx("div", {
    className: "-mb-px"
  }, badge))))), __jsx("div", {
    className: "flex -mx-1"
  }, __jsx(_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__[/* Badge */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, badgeIcon, {
    className: "mx-1 rounded-tiny",
    size: ICONS_HEIGHT
  })), hasECLogo && (badgeIcon === null || badgeIcon === void 0 ? void 0 : badgeIcon.iconName) && __jsx("span", {
    className: "font-brand leading-none text-sm self-center"
  }, "&"), hasECLogo && __jsx(_exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_6__[/* ECBadge */ "a"], {
    className: "flex-none mx-1",
    height: ICONS_HEIGHT,
    iconWidth: "95%"
  })));
});

/***/ }),

/***/ "hqKg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),

/***/ "iGAk":
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),

/***/ "idjV":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 */
;(function(){function n(n,t,r){switch(r.length){case 0:return n.call(t);case 1:return n.call(t,r[0]);case 2:return n.call(t,r[0],r[1]);case 3:return n.call(t,r[0],r[1],r[2])}return n.apply(t,r)}function t(n,t,r,e){for(var u=-1,i=null==n?0:n.length;++u<i;){var o=n[u];t(e,o,r(o),n)}return e}function r(n,t){for(var r=-1,e=null==n?0:n.length;++r<e&&false!==t(n[r],r,n););return n}function e(n,t){for(var r=null==n?0:n.length;r--&&false!==t(n[r],r,n););return n}function u(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(!t(n[r],r,n))return false;
return true}function i(n,t){for(var r=-1,e=null==n?0:n.length,u=0,i=[];++r<e;){var o=n[r];t(o,r,n)&&(i[u++]=o)}return i}function o(n,t){return!(null==n||!n.length)&&-1<v(n,t,0)}function f(n,t,r){for(var e=-1,u=null==n?0:n.length;++e<u;)if(r(t,n[e]))return true;return false}function c(n,t){for(var r=-1,e=null==n?0:n.length,u=Array(e);++r<e;)u[r]=t(n[r],r,n);return u}function a(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function l(n,t,r,e){var u=-1,i=null==n?0:n.length;for(e&&i&&(r=n[++u]);++u<i;)r=t(r,n[u],u,n);
return r}function s(n,t,r,e){var u=null==n?0:n.length;for(e&&u&&(r=n[--u]);u--;)r=t(r,n[u],u,n);return r}function h(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(t(n[r],r,n))return true;return false}function p(n,t,r){var e;return r(n,function(n,r,u){if(t(n,r,u))return e=r,false}),e}function _(n,t,r,e){var u=n.length;for(r+=e?1:-1;e?r--:++r<u;)if(t(n[r],r,n))return r;return-1}function v(n,t,r){if(t===t)n:{--r;for(var e=n.length;++r<e;)if(n[r]===t){n=r;break n}n=-1}else n=_(n,d,r);return n}function g(n,t,r,e){
--r;for(var u=n.length;++r<u;)if(e(n[r],t))return r;return-1}function d(n){return n!==n}function y(n,t){var r=null==n?0:n.length;return r?m(n,t)/r:F}function b(n){return function(t){return null==t?T:t[n]}}function x(n){return function(t){return null==n?T:n[t]}}function j(n,t,r,e,u){return u(n,function(n,u,i){r=e?(e=false,n):t(r,n,u,i)}),r}function w(n,t){var r=n.length;for(n.sort(t);r--;)n[r]=n[r].c;return n}function m(n,t){for(var r,e=-1,u=n.length;++e<u;){var i=t(n[e]);i!==T&&(r=r===T?i:r+i)}return r;
}function A(n,t){for(var r=-1,e=Array(n);++r<n;)e[r]=t(r);return e}function k(n,t){return c(t,function(t){return[t,n[t]]})}function E(n){return function(t){return n(t)}}function S(n,t){return c(t,function(t){return n[t]})}function O(n,t){return n.has(t)}function I(n,t){for(var r=-1,e=n.length;++r<e&&-1<v(t,n[r],0););return r}function R(n,t){for(var r=n.length;r--&&-1<v(t,n[r],0););return r}function z(n){return"\\"+Ln[n]}function W(n){var t=-1,r=Array(n.size);return n.forEach(function(n,e){r[++t]=[e,n];
}),r}function U(n,t){return function(r){return n(t(r))}}function B(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r];o!==t&&"__lodash_placeholder__"!==o||(n[r]="__lodash_placeholder__",i[u++]=r)}return i}function L(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=n}),r}function C(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=[n,n]}),r}function D(n){if(Rn.test(n)){for(var t=On.lastIndex=0;On.test(n);)++t;n=t}else n=Qn(n);return n}function M(n){return Rn.test(n)?n.match(On)||[]:n.split("");
}var T,$=1/0,F=NaN,N=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],P=/\b__p\+='';/g,Z=/\b(__p\+=)''\+/g,q=/(__e\(.*?\)|\b__t\))\+'';/g,V=/&(?:amp|lt|gt|quot|#39);/g,K=/[&<>"']/g,G=RegExp(V.source),H=RegExp(K.source),J=/<%-([\s\S]+?)%>/g,Y=/<%([\s\S]+?)%>/g,Q=/<%=([\s\S]+?)%>/g,X=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,nn=/^\w*$/,tn=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,rn=/[\\^$.*+?()[\]{}|]/g,en=RegExp(rn.source),un=/^\s+|\s+$/g,on=/^\s+/,fn=/\s+$/,cn=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,an=/\{\n\/\* \[wrapped with (.+)\] \*/,ln=/,? & /,sn=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,hn=/\\(\\)?/g,pn=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,_n=/\w*$/,vn=/^[-+]0x[0-9a-f]+$/i,gn=/^0b[01]+$/i,dn=/^\[object .+?Constructor\]$/,yn=/^0o[0-7]+$/i,bn=/^(?:0|[1-9]\d*)$/,xn=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,jn=/($^)/,wn=/['\n\r\u2028\u2029\\]/g,mn="[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",An="(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])"+mn,kn="(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",En=RegExp("['\u2019]","g"),Sn=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g"),On=RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|"+kn+mn,"g"),In=RegExp(["[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?|\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])|\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])|\\d+",An].join("|"),"g"),Rn=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),zn=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Wn="Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(" "),Un={};
Un["[object Float32Array]"]=Un["[object Float64Array]"]=Un["[object Int8Array]"]=Un["[object Int16Array]"]=Un["[object Int32Array]"]=Un["[object Uint8Array]"]=Un["[object Uint8ClampedArray]"]=Un["[object Uint16Array]"]=Un["[object Uint32Array]"]=true,Un["[object Arguments]"]=Un["[object Array]"]=Un["[object ArrayBuffer]"]=Un["[object Boolean]"]=Un["[object DataView]"]=Un["[object Date]"]=Un["[object Error]"]=Un["[object Function]"]=Un["[object Map]"]=Un["[object Number]"]=Un["[object Object]"]=Un["[object RegExp]"]=Un["[object Set]"]=Un["[object String]"]=Un["[object WeakMap]"]=false;
var Bn={};Bn["[object Arguments]"]=Bn["[object Array]"]=Bn["[object ArrayBuffer]"]=Bn["[object DataView]"]=Bn["[object Boolean]"]=Bn["[object Date]"]=Bn["[object Float32Array]"]=Bn["[object Float64Array]"]=Bn["[object Int8Array]"]=Bn["[object Int16Array]"]=Bn["[object Int32Array]"]=Bn["[object Map]"]=Bn["[object Number]"]=Bn["[object Object]"]=Bn["[object RegExp]"]=Bn["[object Set]"]=Bn["[object String]"]=Bn["[object Symbol]"]=Bn["[object Uint8Array]"]=Bn["[object Uint8ClampedArray]"]=Bn["[object Uint16Array]"]=Bn["[object Uint32Array]"]=true,
Bn["[object Error]"]=Bn["[object Function]"]=Bn["[object WeakMap]"]=false;var Ln={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Cn=parseFloat,Dn=parseInt,Mn=typeof global=="object"&&global&&global.Object===Object&&global,Tn=typeof self=="object"&&self&&self.Object===Object&&self,$n=Mn||Tn||Function("return this")(),Fn= true&&exports&&!exports.nodeType&&exports,Nn=Fn&&typeof module=="object"&&module&&!module.nodeType&&module,Pn=Nn&&Nn.exports===Fn,Zn=Pn&&Mn.process,qn=function(){
try{var n=Nn&&Nn.require&&Nn.require("util").types;return n?n:Zn&&Zn.binding&&Zn.binding("util")}catch(n){}}(),Vn=qn&&qn.isArrayBuffer,Kn=qn&&qn.isDate,Gn=qn&&qn.isMap,Hn=qn&&qn.isRegExp,Jn=qn&&qn.isSet,Yn=qn&&qn.isTypedArray,Qn=b("length"),Xn=x({"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xc7":"C","\xe7":"c","\xd0":"D","\xf0":"d","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e",
"\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xd1":"N","\xf1":"n","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xdd":"Y","\xfd":"y","\xff":"y","\xc6":"Ae","\xe6":"ae","\xde":"Th","\xfe":"th","\xdf":"ss","\u0100":"A","\u0102":"A","\u0104":"A","\u0101":"a","\u0103":"a","\u0105":"a",
"\u0106":"C","\u0108":"C","\u010a":"C","\u010c":"C","\u0107":"c","\u0109":"c","\u010b":"c","\u010d":"c","\u010e":"D","\u0110":"D","\u010f":"d","\u0111":"d","\u0112":"E","\u0114":"E","\u0116":"E","\u0118":"E","\u011a":"E","\u0113":"e","\u0115":"e","\u0117":"e","\u0119":"e","\u011b":"e","\u011c":"G","\u011e":"G","\u0120":"G","\u0122":"G","\u011d":"g","\u011f":"g","\u0121":"g","\u0123":"g","\u0124":"H","\u0126":"H","\u0125":"h","\u0127":"h","\u0128":"I","\u012a":"I","\u012c":"I","\u012e":"I","\u0130":"I",
"\u0129":"i","\u012b":"i","\u012d":"i","\u012f":"i","\u0131":"i","\u0134":"J","\u0135":"j","\u0136":"K","\u0137":"k","\u0138":"k","\u0139":"L","\u013b":"L","\u013d":"L","\u013f":"L","\u0141":"L","\u013a":"l","\u013c":"l","\u013e":"l","\u0140":"l","\u0142":"l","\u0143":"N","\u0145":"N","\u0147":"N","\u014a":"N","\u0144":"n","\u0146":"n","\u0148":"n","\u014b":"n","\u014c":"O","\u014e":"O","\u0150":"O","\u014d":"o","\u014f":"o","\u0151":"o","\u0154":"R","\u0156":"R","\u0158":"R","\u0155":"r","\u0157":"r",
"\u0159":"r","\u015a":"S","\u015c":"S","\u015e":"S","\u0160":"S","\u015b":"s","\u015d":"s","\u015f":"s","\u0161":"s","\u0162":"T","\u0164":"T","\u0166":"T","\u0163":"t","\u0165":"t","\u0167":"t","\u0168":"U","\u016a":"U","\u016c":"U","\u016e":"U","\u0170":"U","\u0172":"U","\u0169":"u","\u016b":"u","\u016d":"u","\u016f":"u","\u0171":"u","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017b":"Z","\u017d":"Z","\u017a":"z","\u017c":"z","\u017e":"z","\u0132":"IJ",
"\u0133":"ij","\u0152":"Oe","\u0153":"oe","\u0149":"'n","\u017f":"s"}),nt=x({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}),tt=x({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"}),rt=function x(mn){function An(n){if(yu(n)&&!ff(n)&&!(n instanceof Ln)){if(n instanceof On)return n;if(oi.call(n,"__wrapped__"))return Fe(n)}return new On(n)}function kn(){}function On(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=T}function Ln(n){
this.__wrapped__=n,this.__actions__=[],this.__dir__=1,this.__filtered__=false,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}function Mn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Tn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Fn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Nn(n){var t=-1,r=null==n?0:n.length;for(this.__data__=new Fn;++t<r;)this.add(n[t]);
}function Zn(n){this.size=(this.__data__=new Tn(n)).size}function qn(n,t){var r,e=ff(n),u=!e&&of(n),i=!e&&!u&&af(n),o=!e&&!u&&!i&&_f(n),u=(e=e||u||i||o)?A(n.length,ni):[],f=u.length;for(r in n)!t&&!oi.call(n,r)||e&&("length"==r||i&&("offset"==r||"parent"==r)||o&&("buffer"==r||"byteLength"==r||"byteOffset"==r)||Se(r,f))||u.push(r);return u}function Qn(n){var t=n.length;return t?n[ir(0,t-1)]:T}function et(n,t){return De(Lr(n),pt(t,0,n.length))}function ut(n){return De(Lr(n))}function it(n,t,r){(r===T||lu(n[t],r))&&(r!==T||t in n)||st(n,t,r);
}function ot(n,t,r){var e=n[t];oi.call(n,t)&&lu(e,r)&&(r!==T||t in n)||st(n,t,r)}function ft(n,t){for(var r=n.length;r--;)if(lu(n[r][0],t))return r;return-1}function ct(n,t,r,e){return uo(n,function(n,u,i){t(e,n,r(n),i)}),e}function at(n,t){return n&&Cr(t,Wu(t),n)}function lt(n,t){return n&&Cr(t,Uu(t),n)}function st(n,t,r){"__proto__"==t&&Ai?Ai(n,t,{configurable:true,enumerable:true,value:r,writable:true}):n[t]=r}function ht(n,t){for(var r=-1,e=t.length,u=Ku(e),i=null==n;++r<e;)u[r]=i?T:Ru(n,t[r]);return u;
}function pt(n,t,r){return n===n&&(r!==T&&(n=n<=r?n:r),t!==T&&(n=n>=t?n:t)),n}function _t(n,t,e,u,i,o){var f,c=1&t,a=2&t,l=4&t;if(e&&(f=i?e(n,u,i,o):e(n)),f!==T)return f;if(!du(n))return n;if(u=ff(n)){if(f=me(n),!c)return Lr(n,f)}else{var s=vo(n),h="[object Function]"==s||"[object GeneratorFunction]"==s;if(af(n))return Ir(n,c);if("[object Object]"==s||"[object Arguments]"==s||h&&!i){if(f=a||h?{}:Ae(n),!c)return a?Mr(n,lt(f,n)):Dr(n,at(f,n))}else{if(!Bn[s])return i?n:{};f=ke(n,s,c)}}if(o||(o=new Zn),
i=o.get(n))return i;if(o.set(n,f),pf(n))return n.forEach(function(r){f.add(_t(r,t,e,r,n,o))}),f;if(sf(n))return n.forEach(function(r,u){f.set(u,_t(r,t,e,u,n,o))}),f;var a=l?a?ve:_e:a?Uu:Wu,p=u?T:a(n);return r(p||n,function(r,u){p&&(u=r,r=n[u]),ot(f,u,_t(r,t,e,u,n,o))}),f}function vt(n){var t=Wu(n);return function(r){return gt(r,n,t)}}function gt(n,t,r){var e=r.length;if(null==n)return!e;for(n=Qu(n);e--;){var u=r[e],i=t[u],o=n[u];if(o===T&&!(u in n)||!i(o))return false}return true}function dt(n,t,r){if(typeof n!="function")throw new ti("Expected a function");
return bo(function(){n.apply(T,r)},t)}function yt(n,t,r,e){var u=-1,i=o,a=true,l=n.length,s=[],h=t.length;if(!l)return s;r&&(t=c(t,E(r))),e?(i=f,a=false):200<=t.length&&(i=O,a=false,t=new Nn(t));n:for(;++u<l;){var p=n[u],_=null==r?p:r(p),p=e||0!==p?p:0;if(a&&_===_){for(var v=h;v--;)if(t[v]===_)continue n;s.push(p)}else i(t,_,e)||s.push(p)}return s}function bt(n,t){var r=true;return uo(n,function(n,e,u){return r=!!t(n,e,u)}),r}function xt(n,t,r){for(var e=-1,u=n.length;++e<u;){var i=n[e],o=t(i);if(null!=o&&(f===T?o===o&&!wu(o):r(o,f)))var f=o,c=i;
}return c}function jt(n,t){var r=[];return uo(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function wt(n,t,r,e,u){var i=-1,o=n.length;for(r||(r=Ee),u||(u=[]);++i<o;){var f=n[i];0<t&&r(f)?1<t?wt(f,t-1,r,e,u):a(u,f):e||(u[u.length]=f)}return u}function mt(n,t){return n&&oo(n,t,Wu)}function At(n,t){return n&&fo(n,t,Wu)}function kt(n,t){return i(t,function(t){return _u(n[t])})}function Et(n,t){t=Sr(t,n);for(var r=0,e=t.length;null!=n&&r<e;)n=n[Me(t[r++])];return r&&r==e?n:T}function St(n,t,r){return t=t(n),
ff(n)?t:a(t,r(n))}function Ot(n){if(null==n)return n===T?"[object Undefined]":"[object Null]";if(mi&&mi in Qu(n)){var t=oi.call(n,mi),r=n[mi];try{n[mi]=T;var e=true}catch(n){}var u=ai.call(n);e&&(t?n[mi]=r:delete n[mi]),n=u}else n=ai.call(n);return n}function It(n,t){return n>t}function Rt(n,t){return null!=n&&oi.call(n,t)}function zt(n,t){return null!=n&&t in Qu(n)}function Wt(n,t,r){for(var e=r?f:o,u=n[0].length,i=n.length,a=i,l=Ku(i),s=1/0,h=[];a--;){var p=n[a];a&&t&&(p=c(p,E(t))),s=Ci(p.length,s),
l[a]=!r&&(t||120<=u&&120<=p.length)?new Nn(a&&p):T}var p=n[0],_=-1,v=l[0];n:for(;++_<u&&h.length<s;){var g=p[_],d=t?t(g):g,g=r||0!==g?g:0;if(v?!O(v,d):!e(h,d,r)){for(a=i;--a;){var y=l[a];if(y?!O(y,d):!e(n[a],d,r))continue n}v&&v.push(d),h.push(g)}}return h}function Ut(n,t,r,e){return mt(n,function(n,u,i){t(e,r(n),u,i)}),e}function Bt(t,r,e){return r=Sr(r,t),t=2>r.length?t:Et(t,hr(r,0,-1)),r=null==t?t:t[Me(Ve(r))],null==r?T:n(r,t,e)}function Lt(n){return yu(n)&&"[object Arguments]"==Ot(n)}function Ct(n){
return yu(n)&&"[object ArrayBuffer]"==Ot(n)}function Dt(n){return yu(n)&&"[object Date]"==Ot(n)}function Mt(n,t,r,e,u){if(n===t)return true;if(null==n||null==t||!yu(n)&&!yu(t))return n!==n&&t!==t;n:{var i=ff(n),o=ff(t),f=i?"[object Array]":vo(n),c=o?"[object Array]":vo(t),f="[object Arguments]"==f?"[object Object]":f,c="[object Arguments]"==c?"[object Object]":c,a="[object Object]"==f,o="[object Object]"==c;if((c=f==c)&&af(n)){if(!af(t)){t=false;break n}i=true,a=false}if(c&&!a)u||(u=new Zn),t=i||_f(n)?se(n,t,r,e,Mt,u):he(n,t,f,r,e,Mt,u);else{
if(!(1&r)&&(i=a&&oi.call(n,"__wrapped__"),f=o&&oi.call(t,"__wrapped__"),i||f)){n=i?n.value():n,t=f?t.value():t,u||(u=new Zn),t=Mt(n,t,r,e,u);break n}if(c)t:if(u||(u=new Zn),i=1&r,f=_e(n),o=f.length,c=_e(t).length,o==c||i){for(a=o;a--;){var l=f[a];if(!(i?l in t:oi.call(t,l))){t=false;break t}}if((c=u.get(n))&&u.get(t))t=c==t;else{c=true,u.set(n,t),u.set(t,n);for(var s=i;++a<o;){var l=f[a],h=n[l],p=t[l];if(e)var _=i?e(p,h,l,t,n,u):e(h,p,l,n,t,u);if(_===T?h!==p&&!Mt(h,p,r,e,u):!_){c=false;break}s||(s="constructor"==l);
}c&&!s&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(c=false)),u.delete(n),u.delete(t),t=c}}else t=false;else t=false}}return t}function Tt(n){return yu(n)&&"[object Map]"==vo(n)}function $t(n,t,r,e){var u=r.length,i=u,o=!e;if(null==n)return!i;for(n=Qu(n);u--;){var f=r[u];if(o&&f[2]?f[1]!==n[f[0]]:!(f[0]in n))return false}for(;++u<i;){var f=r[u],c=f[0],a=n[c],l=f[1];if(o&&f[2]){if(a===T&&!(c in n))return false;
}else{if(f=new Zn,e)var s=e(a,l,c,n,t,f);if(s===T?!Mt(l,a,3,e,f):!s)return false}}return true}function Ft(n){return!(!du(n)||ci&&ci in n)&&(_u(n)?hi:dn).test(Te(n))}function Nt(n){return yu(n)&&"[object RegExp]"==Ot(n)}function Pt(n){return yu(n)&&"[object Set]"==vo(n)}function Zt(n){return yu(n)&&gu(n.length)&&!!Un[Ot(n)]}function qt(n){return typeof n=="function"?n:null==n?$u:typeof n=="object"?ff(n)?Jt(n[0],n[1]):Ht(n):Zu(n)}function Vt(n){if(!ze(n))return Bi(n);var t,r=[];for(t in Qu(n))oi.call(n,t)&&"constructor"!=t&&r.push(t);
return r}function Kt(n,t){return n<t}function Gt(n,t){var r=-1,e=su(n)?Ku(n.length):[];return uo(n,function(n,u,i){e[++r]=t(n,u,i)}),e}function Ht(n){var t=xe(n);return 1==t.length&&t[0][2]?We(t[0][0],t[0][1]):function(r){return r===n||$t(r,n,t)}}function Jt(n,t){return Ie(n)&&t===t&&!du(t)?We(Me(n),t):function(r){var e=Ru(r,n);return e===T&&e===t?zu(r,n):Mt(t,e,3)}}function Yt(n,t,r,e,u){n!==t&&oo(t,function(i,o){if(du(i)){u||(u=new Zn);var f=u,c=Be(n,o),a=Be(t,o),l=f.get(a);if(!l){var l=e?e(c,a,o+"",n,t,f):T,s=l===T;
if(s){var h=ff(a),p=!h&&af(a),_=!h&&!p&&_f(a),l=a;h||p||_?ff(c)?l=c:hu(c)?l=Lr(c):p?(s=false,l=Ir(a,true)):_?(s=false,l=zr(a,true)):l=[]:xu(a)||of(a)?(l=c,of(c)?l=Ou(c):du(c)&&!_u(c)||(l=Ae(a))):s=false}s&&(f.set(a,l),Yt(l,a,r,e,f),f.delete(a))}it(n,o,l)}else f=e?e(Be(n,o),i,o+"",n,t,u):T,f===T&&(f=i),it(n,o,f)},Uu)}function Qt(n,t){var r=n.length;if(r)return t+=0>t?r:0,Se(t,r)?n[t]:T}function Xt(n,t,r){var e=-1;return t=c(t.length?t:[$u],E(ye())),n=Gt(n,function(n,r,u){return{a:c(t,function(t){return t(n)}),
b:++e,c:n}}),w(n,function(n,t){var e;n:{e=-1;for(var u=n.a,i=t.a,o=u.length,f=r.length;++e<o;){var c=Wr(u[e],i[e]);if(c){if(e>=f){e=c;break n}e=c*("desc"==r[e]?-1:1);break n}}e=n.b-t.b}return e})}function nr(n,t){return tr(n,t,function(t,r){return zu(n,r)})}function tr(n,t,r){for(var e=-1,u=t.length,i={};++e<u;){var o=t[e],f=Et(n,o);r(f,o)&&lr(i,Sr(o,n),f)}return i}function rr(n){return function(t){return Et(t,n)}}function er(n,t,r,e){var u=e?g:v,i=-1,o=t.length,f=n;for(n===t&&(t=Lr(t)),r&&(f=c(n,E(r)));++i<o;)for(var a=0,l=t[i],l=r?r(l):l;-1<(a=u(f,l,a,e));)f!==n&&xi.call(f,a,1),
xi.call(n,a,1);return n}function ur(n,t){for(var r=n?t.length:0,e=r-1;r--;){var u=t[r];if(r==e||u!==i){var i=u;Se(u)?xi.call(n,u,1):xr(n,u)}}return n}function ir(n,t){return n+Ii(Ti()*(t-n+1))}function or(n,t){var r="";if(!n||1>t||9007199254740991<t)return r;do t%2&&(r+=n),(t=Ii(t/2))&&(n+=n);while(t);return r}function fr(n,t){return xo(Ue(n,t,$u),n+"")}function cr(n){return Qn(Lu(n))}function ar(n,t){var r=Lu(n);return De(r,pt(t,0,r.length))}function lr(n,t,r,e){if(!du(n))return n;t=Sr(t,n);for(var u=-1,i=t.length,o=i-1,f=n;null!=f&&++u<i;){
var c=Me(t[u]),a=r;if(u!=o){var l=f[c],a=e?e(l,c,f):T;a===T&&(a=du(l)?l:Se(t[u+1])?[]:{})}ot(f,c,a),f=f[c]}return n}function sr(n){return De(Lu(n))}function hr(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Ku(u);++e<u;)r[e]=n[e+t];return r}function pr(n,t){var r;return uo(n,function(n,e,u){return r=t(n,e,u),!r}),!!r}function _r(n,t,r){var e=0,u=null==n?e:n.length;if(typeof t=="number"&&t===t&&2147483647>=u){for(;e<u;){var i=e+u>>>1,o=n[i];null!==o&&!wu(o)&&(r?o<=t:o<t)?e=i+1:u=i;
}return u}return vr(n,t,$u,r)}function vr(n,t,r,e){t=r(t);for(var u=0,i=null==n?0:n.length,o=t!==t,f=null===t,c=wu(t),a=t===T;u<i;){var l=Ii((u+i)/2),s=r(n[l]),h=s!==T,p=null===s,_=s===s,v=wu(s);(o?e||_:a?_&&(e||h):f?_&&h&&(e||!p):c?_&&h&&!p&&(e||!v):p||v?0:e?s<=t:s<t)?u=l+1:i=l}return Ci(i,4294967294)}function gr(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r],f=t?t(o):o;if(!r||!lu(f,c)){var c=f;i[u++]=0===o?0:o}}return i}function dr(n){return typeof n=="number"?n:wu(n)?F:+n}function yr(n){
if(typeof n=="string")return n;if(ff(n))return c(n,yr)+"";if(wu(n))return ro?ro.call(n):"";var t=n+"";return"0"==t&&1/n==-$?"-0":t}function br(n,t,r){var e=-1,u=o,i=n.length,c=true,a=[],l=a;if(r)c=false,u=f;else if(200<=i){if(u=t?null:so(n))return L(u);c=false,u=O,l=new Nn}else l=t?[]:a;n:for(;++e<i;){var s=n[e],h=t?t(s):s,s=r||0!==s?s:0;if(c&&h===h){for(var p=l.length;p--;)if(l[p]===h)continue n;t&&l.push(h),a.push(s)}else u(l,h,r)||(l!==a&&l.push(h),a.push(s))}return a}function xr(n,t){return t=Sr(t,n),
n=2>t.length?n:Et(n,hr(t,0,-1)),null==n||delete n[Me(Ve(t))]}function jr(n,t,r,e){for(var u=n.length,i=e?u:-1;(e?i--:++i<u)&&t(n[i],i,n););return r?hr(n,e?0:i,e?i+1:u):hr(n,e?i+1:0,e?u:i)}function wr(n,t){var r=n;return r instanceof Ln&&(r=r.value()),l(t,function(n,t){return t.func.apply(t.thisArg,a([n],t.args))},r)}function mr(n,t,r){var e=n.length;if(2>e)return e?br(n[0]):[];for(var u=-1,i=Ku(e);++u<e;)for(var o=n[u],f=-1;++f<e;)f!=u&&(i[u]=yt(i[u]||o,n[f],t,r));return br(wt(i,1),t,r)}function Ar(n,t,r){
for(var e=-1,u=n.length,i=t.length,o={};++e<u;)r(o,n[e],e<i?t[e]:T);return o}function kr(n){return hu(n)?n:[]}function Er(n){return typeof n=="function"?n:$u}function Sr(n,t){return ff(n)?n:Ie(n,t)?[n]:jo(Iu(n))}function Or(n,t,r){var e=n.length;return r=r===T?e:r,!t&&r>=e?n:hr(n,t,r)}function Ir(n,t){if(t)return n.slice();var r=n.length,r=gi?gi(r):new n.constructor(r);return n.copy(r),r}function Rr(n){var t=new n.constructor(n.byteLength);return new vi(t).set(new vi(n)),t}function zr(n,t){return new n.constructor(t?Rr(n.buffer):n.buffer,n.byteOffset,n.length);
}function Wr(n,t){if(n!==t){var r=n!==T,e=null===n,u=n===n,i=wu(n),o=t!==T,f=null===t,c=t===t,a=wu(t);if(!f&&!a&&!i&&n>t||i&&o&&c&&!f&&!a||e&&o&&c||!r&&c||!u)return 1;if(!e&&!i&&!a&&n<t||a&&r&&u&&!e&&!i||f&&r&&u||!o&&u||!c)return-1}return 0}function Ur(n,t,r,e){var u=-1,i=n.length,o=r.length,f=-1,c=t.length,a=Li(i-o,0),l=Ku(c+a);for(e=!e;++f<c;)l[f]=t[f];for(;++u<o;)(e||u<i)&&(l[r[u]]=n[u]);for(;a--;)l[f++]=n[u++];return l}function Br(n,t,r,e){var u=-1,i=n.length,o=-1,f=r.length,c=-1,a=t.length,l=Li(i-f,0),s=Ku(l+a);
for(e=!e;++u<l;)s[u]=n[u];for(l=u;++c<a;)s[l+c]=t[c];for(;++o<f;)(e||u<i)&&(s[l+r[o]]=n[u++]);return s}function Lr(n,t){var r=-1,e=n.length;for(t||(t=Ku(e));++r<e;)t[r]=n[r];return t}function Cr(n,t,r,e){var u=!r;r||(r={});for(var i=-1,o=t.length;++i<o;){var f=t[i],c=e?e(r[f],n[f],f,r,n):T;c===T&&(c=n[f]),u?st(r,f,c):ot(r,f,c)}return r}function Dr(n,t){return Cr(n,po(n),t)}function Mr(n,t){return Cr(n,_o(n),t)}function Tr(n,r){return function(e,u){var i=ff(e)?t:ct,o=r?r():{};return i(e,n,ye(u,2),o);
}}function $r(n){return fr(function(t,r){var e=-1,u=r.length,i=1<u?r[u-1]:T,o=2<u?r[2]:T,i=3<n.length&&typeof i=="function"?(u--,i):T;for(o&&Oe(r[0],r[1],o)&&(i=3>u?T:i,u=1),t=Qu(t);++e<u;)(o=r[e])&&n(t,o,e,i);return t})}function Fr(n,t){return function(r,e){if(null==r)return r;if(!su(r))return n(r,e);for(var u=r.length,i=t?u:-1,o=Qu(r);(t?i--:++i<u)&&false!==e(o[i],i,o););return r}}function Nr(n){return function(t,r,e){var u=-1,i=Qu(t);e=e(t);for(var o=e.length;o--;){var f=e[n?o:++u];if(false===r(i[f],f,i))break;
}return t}}function Pr(n,t,r){function e(){return(this&&this!==$n&&this instanceof e?i:n).apply(u?r:this,arguments)}var u=1&t,i=Vr(n);return e}function Zr(n){return function(t){t=Iu(t);var r=Rn.test(t)?M(t):T,e=r?r[0]:t.charAt(0);return t=r?Or(r,1).join(""):t.slice(1),e[n]()+t}}function qr(n){return function(t){return l(Mu(Du(t).replace(En,"")),n,"")}}function Vr(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:
return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var r=eo(n.prototype),t=n.apply(r,t);return du(t)?t:r}}function Kr(t,r,e){function u(){for(var o=arguments.length,f=Ku(o),c=o,a=de(u);c--;)f[c]=arguments[c];return c=3>o&&f[0]!==a&&f[o-1]!==a?[]:B(f,a),o-=c.length,o<e?ue(t,r,Jr,u.placeholder,T,f,c,T,T,e-o):n(this&&this!==$n&&this instanceof u?i:t,this,f);
}var i=Vr(t);return u}function Gr(n){return function(t,r,e){var u=Qu(t);if(!su(t)){var i=ye(r,3);t=Wu(t),r=function(n){return i(u[n],n,u)}}return r=n(t,r,e),-1<r?u[i?t[r]:r]:T}}function Hr(n){return pe(function(t){var r=t.length,e=r,u=On.prototype.thru;for(n&&t.reverse();e--;){var i=t[e];if(typeof i!="function")throw new ti("Expected a function");if(u&&!o&&"wrapper"==ge(i))var o=new On([],true)}for(e=o?e:r;++e<r;)var i=t[e],u=ge(i),f="wrapper"==u?ho(i):T,o=f&&Re(f[0])&&424==f[1]&&!f[4].length&&1==f[9]?o[ge(f[0])].apply(o,f[3]):1==i.length&&Re(i)?o[u]():o.thru(i);
return function(){var n=arguments,e=n[0];if(o&&1==n.length&&ff(e))return o.plant(e).value();for(var u=0,n=r?t[u].apply(this,n):e;++u<r;)n=t[u].call(this,n);return n}})}function Jr(n,t,r,e,u,i,o,f,c,a){function l(){for(var d=arguments.length,y=Ku(d),b=d;b--;)y[b]=arguments[b];if(_){var x,j=de(l),b=y.length;for(x=0;b--;)y[b]===j&&++x}if(e&&(y=Ur(y,e,u,_)),i&&(y=Br(y,i,o,_)),d-=x,_&&d<a)return j=B(y,j),ue(n,t,Jr,l.placeholder,r,y,j,f,c,a-d);if(j=h?r:this,b=p?j[n]:n,d=y.length,f){x=y.length;for(var w=Ci(f.length,x),m=Lr(y);w--;){
var A=f[w];y[w]=Se(A,x)?m[A]:T}}else v&&1<d&&y.reverse();return s&&c<d&&(y.length=c),this&&this!==$n&&this instanceof l&&(b=g||Vr(b)),b.apply(j,y)}var s=128&t,h=1&t,p=2&t,_=24&t,v=512&t,g=p?T:Vr(n);return l}function Yr(n,t){return function(r,e){return Ut(r,n,t(e),{})}}function Qr(n,t){return function(r,e){var u;if(r===T&&e===T)return t;if(r!==T&&(u=r),e!==T){if(u===T)return e;typeof r=="string"||typeof e=="string"?(r=yr(r),e=yr(e)):(r=dr(r),e=dr(e)),u=n(r,e)}return u}}function Xr(t){return pe(function(r){
return r=c(r,E(ye())),fr(function(e){var u=this;return t(r,function(t){return n(t,u,e)})})})}function ne(n,t){t=t===T?" ":yr(t);var r=t.length;return 2>r?r?or(t,n):t:(r=or(t,Oi(n/D(t))),Rn.test(t)?Or(M(r),0,n).join(""):r.slice(0,n))}function te(t,r,e,u){function i(){for(var r=-1,c=arguments.length,a=-1,l=u.length,s=Ku(l+c),h=this&&this!==$n&&this instanceof i?f:t;++a<l;)s[a]=u[a];for(;c--;)s[a++]=arguments[++r];return n(h,o?e:this,s)}var o=1&r,f=Vr(t);return i}function re(n){return function(t,r,e){
e&&typeof e!="number"&&Oe(t,r,e)&&(r=e=T),t=Au(t),r===T?(r=t,t=0):r=Au(r),e=e===T?t<r?1:-1:Au(e);var u=-1;r=Li(Oi((r-t)/(e||1)),0);for(var i=Ku(r);r--;)i[n?r:++u]=t,t+=e;return i}}function ee(n){return function(t,r){return typeof t=="string"&&typeof r=="string"||(t=Su(t),r=Su(r)),n(t,r)}}function ue(n,t,r,e,u,i,o,f,c,a){var l=8&t,s=l?o:T;o=l?T:o;var h=l?i:T;return i=l?T:i,t=(t|(l?32:64))&~(l?64:32),4&t||(t&=-4),u=[n,t,u,h,s,i,o,f,c,a],r=r.apply(T,u),Re(n)&&yo(r,u),r.placeholder=e,Le(r,n,t)}function ie(n){
var t=Yu[n];return function(n,r){if(n=Su(n),r=null==r?0:Ci(ku(r),292)){var e=(Iu(n)+"e").split("e"),e=t(e[0]+"e"+(+e[1]+r)),e=(Iu(e)+"e").split("e");return+(e[0]+"e"+(+e[1]-r))}return t(n)}}function oe(n){return function(t){var r=vo(t);return"[object Map]"==r?W(t):"[object Set]"==r?C(t):k(t,n(t))}}function fe(n,t,r,e,u,i,o,f){var c=2&t;if(!c&&typeof n!="function")throw new ti("Expected a function");var a=e?e.length:0;if(a||(t&=-97,e=u=T),o=o===T?o:Li(ku(o),0),f=f===T?f:ku(f),a-=u?u.length:0,64&t){
var l=e,s=u;e=u=T}var h=c?T:ho(n);return i=[n,t,r,e,u,l,s,i,o,f],h&&(r=i[1],n=h[1],t=r|n,e=128==n&&8==r||128==n&&256==r&&i[7].length<=h[8]||384==n&&h[7].length<=h[8]&&8==r,131>t||e)&&(1&n&&(i[2]=h[2],t|=1&r?0:4),(r=h[3])&&(e=i[3],i[3]=e?Ur(e,r,h[4]):r,i[4]=e?B(i[3],"__lodash_placeholder__"):h[4]),(r=h[5])&&(e=i[5],i[5]=e?Br(e,r,h[6]):r,i[6]=e?B(i[5],"__lodash_placeholder__"):h[6]),(r=h[7])&&(i[7]=r),128&n&&(i[8]=null==i[8]?h[8]:Ci(i[8],h[8])),null==i[9]&&(i[9]=h[9]),i[0]=h[0],i[1]=t),n=i[0],t=i[1],
r=i[2],e=i[3],u=i[4],f=i[9]=i[9]===T?c?0:n.length:Li(i[9]-a,0),!f&&24&t&&(t&=-25),c=t&&1!=t?8==t||16==t?Kr(n,t,f):32!=t&&33!=t||u.length?Jr.apply(T,i):te(n,t,r,e):Pr(n,t,r),Le((h?co:yo)(c,i),n,t)}function ce(n,t,r,e){return n===T||lu(n,ei[r])&&!oi.call(e,r)?t:n}function ae(n,t,r,e,u,i){return du(n)&&du(t)&&(i.set(t,n),Yt(n,t,T,ae,i),i.delete(t)),n}function le(n){return xu(n)?T:n}function se(n,t,r,e,u,i){var o=1&r,f=n.length,c=t.length;if(f!=c&&!(o&&c>f))return false;if((c=i.get(n))&&i.get(t))return c==t;
var c=-1,a=true,l=2&r?new Nn:T;for(i.set(n,t),i.set(t,n);++c<f;){var s=n[c],p=t[c];if(e)var _=o?e(p,s,c,t,n,i):e(s,p,c,n,t,i);if(_!==T){if(_)continue;a=false;break}if(l){if(!h(t,function(n,t){if(!O(l,t)&&(s===n||u(s,n,r,e,i)))return l.push(t)})){a=false;break}}else if(s!==p&&!u(s,p,r,e,i)){a=false;break}}return i.delete(n),i.delete(t),a}function he(n,t,r,e,u,i,o){switch(r){case"[object DataView]":if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)break;n=n.buffer,t=t.buffer;case"[object ArrayBuffer]":
if(n.byteLength!=t.byteLength||!i(new vi(n),new vi(t)))break;return true;case"[object Boolean]":case"[object Date]":case"[object Number]":return lu(+n,+t);case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object RegExp]":case"[object String]":return n==t+"";case"[object Map]":var f=W;case"[object Set]":if(f||(f=L),n.size!=t.size&&!(1&e))break;return(r=o.get(n))?r==t:(e|=2,o.set(n,t),t=se(f(n),f(t),e,u,i,o),o.delete(n),t);case"[object Symbol]":if(to)return to.call(n)==to.call(t)}
return false}function pe(n){return xo(Ue(n,T,Ze),n+"")}function _e(n){return St(n,Wu,po)}function ve(n){return St(n,Uu,_o)}function ge(n){for(var t=n.name+"",r=Gi[t],e=oi.call(Gi,t)?r.length:0;e--;){var u=r[e],i=u.func;if(null==i||i==n)return u.name}return t}function de(n){return(oi.call(An,"placeholder")?An:n).placeholder}function ye(){var n=An.iteratee||Fu,n=n===Fu?qt:n;return arguments.length?n(arguments[0],arguments[1]):n}function be(n,t){var r=n.__data__,e=typeof t;return("string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t)?r[typeof t=="string"?"string":"hash"]:r.map;
}function xe(n){for(var t=Wu(n),r=t.length;r--;){var e=t[r],u=n[e];t[r]=[e,u,u===u&&!du(u)]}return t}function je(n,t){var r=null==n?T:n[t];return Ft(r)?r:T}function we(n,t,r){t=Sr(t,n);for(var e=-1,u=t.length,i=false;++e<u;){var o=Me(t[e]);if(!(i=null!=n&&r(n,o)))break;n=n[o]}return i||++e!=u?i:(u=null==n?0:n.length,!!u&&gu(u)&&Se(o,u)&&(ff(n)||of(n)))}function me(n){var t=n.length,r=new n.constructor(t);return t&&"string"==typeof n[0]&&oi.call(n,"index")&&(r.index=n.index,r.input=n.input),r}function Ae(n){
return typeof n.constructor!="function"||ze(n)?{}:eo(di(n))}function ke(n,t,r){var e=n.constructor;switch(t){case"[object ArrayBuffer]":return Rr(n);case"[object Boolean]":case"[object Date]":return new e(+n);case"[object DataView]":return t=r?Rr(n.buffer):n.buffer,new n.constructor(t,n.byteOffset,n.byteLength);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":
case"[object Uint16Array]":case"[object Uint32Array]":return zr(n,r);case"[object Map]":return new e;case"[object Number]":case"[object String]":return new e(n);case"[object RegExp]":return t=new n.constructor(n.source,_n.exec(n)),t.lastIndex=n.lastIndex,t;case"[object Set]":return new e;case"[object Symbol]":return to?Qu(to.call(n)):{}}}function Ee(n){return ff(n)||of(n)||!!(ji&&n&&n[ji])}function Se(n,t){var r=typeof n;return t=null==t?9007199254740991:t,!!t&&("number"==r||"symbol"!=r&&bn.test(n))&&-1<n&&0==n%1&&n<t;
}function Oe(n,t,r){if(!du(r))return false;var e=typeof t;return!!("number"==e?su(r)&&Se(t,r.length):"string"==e&&t in r)&&lu(r[t],n)}function Ie(n,t){if(ff(n))return false;var r=typeof n;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=n&&!wu(n))||(nn.test(n)||!X.test(n)||null!=t&&n in Qu(t))}function Re(n){var t=ge(n),r=An[t];return typeof r=="function"&&t in Ln.prototype&&(n===r||(t=ho(r),!!t&&n===t[0]))}function ze(n){var t=n&&n.constructor;return n===(typeof t=="function"&&t.prototype||ei)}function We(n,t){
return function(r){return null!=r&&(r[n]===t&&(t!==T||n in Qu(r)))}}function Ue(t,r,e){return r=Li(r===T?t.length-1:r,0),function(){for(var u=arguments,i=-1,o=Li(u.length-r,0),f=Ku(o);++i<o;)f[i]=u[r+i];for(i=-1,o=Ku(r+1);++i<r;)o[i]=u[i];return o[r]=e(f),n(t,this,o)}}function Be(n,t){if("__proto__"!=t)return n[t]}function Le(n,t,r){var e=t+"";t=xo;var u,i=$e;return u=(u=e.match(an))?u[1].split(ln):[],r=i(u,r),(i=r.length)&&(u=i-1,r[u]=(1<i?"& ":"")+r[u],r=r.join(2<i?", ":" "),e=e.replace(cn,"{\n/* [wrapped with "+r+"] */\n")),
t(n,e)}function Ce(n){var t=0,r=0;return function(){var e=Di(),u=16-(e-r);if(r=e,0<u){if(800<=++t)return arguments[0]}else t=0;return n.apply(T,arguments)}}function De(n,t){var r=-1,e=n.length,u=e-1;for(t=t===T?e:t;++r<t;){var e=ir(r,u),i=n[e];n[e]=n[r],n[r]=i}return n.length=t,n}function Me(n){if(typeof n=="string"||wu(n))return n;var t=n+"";return"0"==t&&1/n==-$?"-0":t}function Te(n){if(null!=n){try{return ii.call(n)}catch(n){}return n+""}return""}function $e(n,t){return r(N,function(r){var e="_."+r[0];
t&r[1]&&!o(n,e)&&n.push(e)}),n.sort()}function Fe(n){if(n instanceof Ln)return n.clone();var t=new On(n.__wrapped__,n.__chain__);return t.__actions__=Lr(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Ne(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:ku(r),0>r&&(r=Li(e+r,0)),_(n,ye(t,3),r)):-1}function Pe(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e-1;return r!==T&&(u=ku(r),u=0>r?Li(e+u,0):Ci(u,e-1)),_(n,ye(t,3),u,true)}function Ze(n){return(null==n?0:n.length)?wt(n,1):[];
}function qe(n){return n&&n.length?n[0]:T}function Ve(n){var t=null==n?0:n.length;return t?n[t-1]:T}function Ke(n,t){return n&&n.length&&t&&t.length?er(n,t):n}function Ge(n){return null==n?n:$i.call(n)}function He(n){if(!n||!n.length)return[];var t=0;return n=i(n,function(n){if(hu(n))return t=Li(n.length,t),true}),A(t,function(t){return c(n,b(t))})}function Je(t,r){if(!t||!t.length)return[];var e=He(t);return null==r?e:c(e,function(t){return n(r,T,t)})}function Ye(n){return n=An(n),n.__chain__=true,n;
}function Qe(n,t){return t(n)}function Xe(){return this}function nu(n,t){return(ff(n)?r:uo)(n,ye(t,3))}function tu(n,t){return(ff(n)?e:io)(n,ye(t,3))}function ru(n,t){return(ff(n)?c:Gt)(n,ye(t,3))}function eu(n,t,r){return t=r?T:t,t=n&&null==t?n.length:t,fe(n,128,T,T,T,T,t)}function uu(n,t){var r;if(typeof t!="function")throw new ti("Expected a function");return n=ku(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=T),r}}function iu(n,t,r){return t=r?T:t,n=fe(n,8,T,T,T,T,T,t),n.placeholder=iu.placeholder,
n}function ou(n,t,r){return t=r?T:t,n=fe(n,16,T,T,T,T,T,t),n.placeholder=ou.placeholder,n}function fu(n,t,r){function e(t){var r=c,e=a;return c=a=T,_=t,s=n.apply(e,r)}function u(n){var r=n-p;return n-=_,p===T||r>=t||0>r||g&&n>=l}function i(){var n=Go();if(u(n))return o(n);var r,e=bo;r=n-_,n=t-(n-p),r=g?Ci(n,l-r):n,h=e(i,r)}function o(n){return h=T,d&&c?e(n):(c=a=T,s)}function f(){var n=Go(),r=u(n);if(c=arguments,a=this,p=n,r){if(h===T)return _=n=p,h=bo(i,t),v?e(n):s;if(g)return h=bo(i,t),e(p)}return h===T&&(h=bo(i,t)),
s}var c,a,l,s,h,p,_=0,v=false,g=false,d=true;if(typeof n!="function")throw new ti("Expected a function");return t=Su(t)||0,du(r)&&(v=!!r.leading,l=(g="maxWait"in r)?Li(Su(r.maxWait)||0,t):l,d="trailing"in r?!!r.trailing:d),f.cancel=function(){h!==T&&lo(h),_=0,c=p=a=h=T},f.flush=function(){return h===T?s:o(Go())},f}function cu(n,t){if(typeof n!="function"||null!=t&&typeof t!="function")throw new ti("Expected a function");var r=function(){var e=arguments,u=t?t.apply(this,e):e[0],i=r.cache;return i.has(u)?i.get(u):(e=n.apply(this,e),
r.cache=i.set(u,e)||i,e)};return r.cache=new(cu.Cache||Fn),r}function au(n){if(typeof n!="function")throw new ti("Expected a function");return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function lu(n,t){return n===t||n!==n&&t!==t}function su(n){return null!=n&&gu(n.length)&&!_u(n)}function hu(n){return yu(n)&&su(n)}function pu(n){if(!yu(n))return false;
var t=Ot(n);return"[object Error]"==t||"[object DOMException]"==t||typeof n.message=="string"&&typeof n.name=="string"&&!xu(n)}function _u(n){return!!du(n)&&(n=Ot(n),"[object Function]"==n||"[object GeneratorFunction]"==n||"[object AsyncFunction]"==n||"[object Proxy]"==n)}function vu(n){return typeof n=="number"&&n==ku(n)}function gu(n){return typeof n=="number"&&-1<n&&0==n%1&&9007199254740991>=n}function du(n){var t=typeof n;return null!=n&&("object"==t||"function"==t)}function yu(n){return null!=n&&typeof n=="object";
}function bu(n){return typeof n=="number"||yu(n)&&"[object Number]"==Ot(n)}function xu(n){return!(!yu(n)||"[object Object]"!=Ot(n))&&(n=di(n),null===n||(n=oi.call(n,"constructor")&&n.constructor,typeof n=="function"&&n instanceof n&&ii.call(n)==li))}function ju(n){return typeof n=="string"||!ff(n)&&yu(n)&&"[object String]"==Ot(n)}function wu(n){return typeof n=="symbol"||yu(n)&&"[object Symbol]"==Ot(n)}function mu(n){if(!n)return[];if(su(n))return ju(n)?M(n):Lr(n);if(wi&&n[wi]){n=n[wi]();for(var t,r=[];!(t=n.next()).done;)r.push(t.value);
return r}return t=vo(n),("[object Map]"==t?W:"[object Set]"==t?L:Lu)(n)}function Au(n){return n?(n=Su(n),n===$||n===-$?1.7976931348623157e308*(0>n?-1:1):n===n?n:0):0===n?n:0}function ku(n){n=Au(n);var t=n%1;return n===n?t?n-t:n:0}function Eu(n){return n?pt(ku(n),0,4294967295):0}function Su(n){if(typeof n=="number")return n;if(wu(n))return F;if(du(n)&&(n=typeof n.valueOf=="function"?n.valueOf():n,n=du(n)?n+"":n),typeof n!="string")return 0===n?n:+n;n=n.replace(un,"");var t=gn.test(n);return t||yn.test(n)?Dn(n.slice(2),t?2:8):vn.test(n)?F:+n;
}function Ou(n){return Cr(n,Uu(n))}function Iu(n){return null==n?"":yr(n)}function Ru(n,t,r){return n=null==n?T:Et(n,t),n===T?r:n}function zu(n,t){return null!=n&&we(n,t,zt)}function Wu(n){return su(n)?qn(n):Vt(n)}function Uu(n){if(su(n))n=qn(n,true);else if(du(n)){var t,r=ze(n),e=[];for(t in n)("constructor"!=t||!r&&oi.call(n,t))&&e.push(t);n=e}else{if(t=[],null!=n)for(r in Qu(n))t.push(r);n=t}return n}function Bu(n,t){if(null==n)return{};var r=c(ve(n),function(n){return[n]});return t=ye(t),tr(n,r,function(n,r){
return t(n,r[0])})}function Lu(n){return null==n?[]:S(n,Wu(n))}function Cu(n){return $f(Iu(n).toLowerCase())}function Du(n){return(n=Iu(n))&&n.replace(xn,Xn).replace(Sn,"")}function Mu(n,t,r){return n=Iu(n),t=r?T:t,t===T?zn.test(n)?n.match(In)||[]:n.match(sn)||[]:n.match(t)||[]}function Tu(n){return function(){return n}}function $u(n){return n}function Fu(n){return qt(typeof n=="function"?n:_t(n,1))}function Nu(n,t,e){var u=Wu(t),i=kt(t,u);null!=e||du(t)&&(i.length||!u.length)||(e=t,t=n,n=this,i=kt(t,Wu(t)));
var o=!(du(e)&&"chain"in e&&!e.chain),f=_u(n);return r(i,function(r){var e=t[r];n[r]=e,f&&(n.prototype[r]=function(){var t=this.__chain__;if(o||t){var r=n(this.__wrapped__);return(r.__actions__=Lr(this.__actions__)).push({func:e,args:arguments,thisArg:n}),r.__chain__=t,r}return e.apply(n,a([this.value()],arguments))})}),n}function Pu(){}function Zu(n){return Ie(n)?b(Me(n)):rr(n)}function qu(){return[]}function Vu(){return false}mn=null==mn?$n:rt.defaults($n.Object(),mn,rt.pick($n,Wn));var Ku=mn.Array,Gu=mn.Date,Hu=mn.Error,Ju=mn.Function,Yu=mn.Math,Qu=mn.Object,Xu=mn.RegExp,ni=mn.String,ti=mn.TypeError,ri=Ku.prototype,ei=Qu.prototype,ui=mn["__core-js_shared__"],ii=Ju.prototype.toString,oi=ei.hasOwnProperty,fi=0,ci=function(){
var n=/[^.]+$/.exec(ui&&ui.keys&&ui.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),ai=ei.toString,li=ii.call(Qu),si=$n._,hi=Xu("^"+ii.call(oi).replace(rn,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),pi=Pn?mn.Buffer:T,_i=mn.Symbol,vi=mn.Uint8Array,gi=pi?pi.allocUnsafe:T,di=U(Qu.getPrototypeOf,Qu),yi=Qu.create,bi=ei.propertyIsEnumerable,xi=ri.splice,ji=_i?_i.isConcatSpreadable:T,wi=_i?_i.iterator:T,mi=_i?_i.toStringTag:T,Ai=function(){try{var n=je(Qu,"defineProperty");
return n({},"",{}),n}catch(n){}}(),ki=mn.clearTimeout!==$n.clearTimeout&&mn.clearTimeout,Ei=Gu&&Gu.now!==$n.Date.now&&Gu.now,Si=mn.setTimeout!==$n.setTimeout&&mn.setTimeout,Oi=Yu.ceil,Ii=Yu.floor,Ri=Qu.getOwnPropertySymbols,zi=pi?pi.isBuffer:T,Wi=mn.isFinite,Ui=ri.join,Bi=U(Qu.keys,Qu),Li=Yu.max,Ci=Yu.min,Di=Gu.now,Mi=mn.parseInt,Ti=Yu.random,$i=ri.reverse,Fi=je(mn,"DataView"),Ni=je(mn,"Map"),Pi=je(mn,"Promise"),Zi=je(mn,"Set"),qi=je(mn,"WeakMap"),Vi=je(Qu,"create"),Ki=qi&&new qi,Gi={},Hi=Te(Fi),Ji=Te(Ni),Yi=Te(Pi),Qi=Te(Zi),Xi=Te(qi),no=_i?_i.prototype:T,to=no?no.valueOf:T,ro=no?no.toString:T,eo=function(){
function n(){}return function(t){return du(t)?yi?yi(t):(n.prototype=t,t=new n,n.prototype=T,t):{}}}();An.templateSettings={escape:J,evaluate:Y,interpolate:Q,variable:"",imports:{_:An}},An.prototype=kn.prototype,An.prototype.constructor=An,On.prototype=eo(kn.prototype),On.prototype.constructor=On,Ln.prototype=eo(kn.prototype),Ln.prototype.constructor=Ln,Mn.prototype.clear=function(){this.__data__=Vi?Vi(null):{},this.size=0},Mn.prototype.delete=function(n){return n=this.has(n)&&delete this.__data__[n],
this.size-=n?1:0,n},Mn.prototype.get=function(n){var t=this.__data__;return Vi?(n=t[n],"__lodash_hash_undefined__"===n?T:n):oi.call(t,n)?t[n]:T},Mn.prototype.has=function(n){var t=this.__data__;return Vi?t[n]!==T:oi.call(t,n)},Mn.prototype.set=function(n,t){var r=this.__data__;return this.size+=this.has(n)?0:1,r[n]=Vi&&t===T?"__lodash_hash_undefined__":t,this},Tn.prototype.clear=function(){this.__data__=[],this.size=0},Tn.prototype.delete=function(n){var t=this.__data__;return n=ft(t,n),!(0>n)&&(n==t.length-1?t.pop():xi.call(t,n,1),
--this.size,true)},Tn.prototype.get=function(n){var t=this.__data__;return n=ft(t,n),0>n?T:t[n][1]},Tn.prototype.has=function(n){return-1<ft(this.__data__,n)},Tn.prototype.set=function(n,t){var r=this.__data__,e=ft(r,n);return 0>e?(++this.size,r.push([n,t])):r[e][1]=t,this},Fn.prototype.clear=function(){this.size=0,this.__data__={hash:new Mn,map:new(Ni||Tn),string:new Mn}},Fn.prototype.delete=function(n){return n=be(this,n).delete(n),this.size-=n?1:0,n},Fn.prototype.get=function(n){return be(this,n).get(n);
},Fn.prototype.has=function(n){return be(this,n).has(n)},Fn.prototype.set=function(n,t){var r=be(this,n),e=r.size;return r.set(n,t),this.size+=r.size==e?0:1,this},Nn.prototype.add=Nn.prototype.push=function(n){return this.__data__.set(n,"__lodash_hash_undefined__"),this},Nn.prototype.has=function(n){return this.__data__.has(n)},Zn.prototype.clear=function(){this.__data__=new Tn,this.size=0},Zn.prototype.delete=function(n){var t=this.__data__;return n=t.delete(n),this.size=t.size,n},Zn.prototype.get=function(n){
return this.__data__.get(n)},Zn.prototype.has=function(n){return this.__data__.has(n)},Zn.prototype.set=function(n,t){var r=this.__data__;if(r instanceof Tn){var e=r.__data__;if(!Ni||199>e.length)return e.push([n,t]),this.size=++r.size,this;r=this.__data__=new Fn(e)}return r.set(n,t),this.size=r.size,this};var uo=Fr(mt),io=Fr(At,true),oo=Nr(),fo=Nr(true),co=Ki?function(n,t){return Ki.set(n,t),n}:$u,ao=Ai?function(n,t){return Ai(n,"toString",{configurable:true,enumerable:false,value:Tu(t),writable:true})}:$u,lo=ki||function(n){
return $n.clearTimeout(n)},so=Zi&&1/L(new Zi([,-0]))[1]==$?function(n){return new Zi(n)}:Pu,ho=Ki?function(n){return Ki.get(n)}:Pu,po=Ri?function(n){return null==n?[]:(n=Qu(n),i(Ri(n),function(t){return bi.call(n,t)}))}:qu,_o=Ri?function(n){for(var t=[];n;)a(t,po(n)),n=di(n);return t}:qu,vo=Ot;(Fi&&"[object DataView]"!=vo(new Fi(new ArrayBuffer(1)))||Ni&&"[object Map]"!=vo(new Ni)||Pi&&"[object Promise]"!=vo(Pi.resolve())||Zi&&"[object Set]"!=vo(new Zi)||qi&&"[object WeakMap]"!=vo(new qi))&&(vo=function(n){
var t=Ot(n);if(n=(n="[object Object]"==t?n.constructor:T)?Te(n):"")switch(n){case Hi:return"[object DataView]";case Ji:return"[object Map]";case Yi:return"[object Promise]";case Qi:return"[object Set]";case Xi:return"[object WeakMap]"}return t});var go=ui?_u:Vu,yo=Ce(co),bo=Si||function(n,t){return $n.setTimeout(n,t)},xo=Ce(ao),jo=function(n){n=cu(n,function(n){return 500===t.size&&t.clear(),n});var t=n.cache;return n}(function(n){var t=[];return 46===n.charCodeAt(0)&&t.push(""),n.replace(tn,function(n,r,e,u){
t.push(e?u.replace(hn,"$1"):r||n)}),t}),wo=fr(function(n,t){return hu(n)?yt(n,wt(t,1,hu,true)):[]}),mo=fr(function(n,t){var r=Ve(t);return hu(r)&&(r=T),hu(n)?yt(n,wt(t,1,hu,true),ye(r,2)):[]}),Ao=fr(function(n,t){var r=Ve(t);return hu(r)&&(r=T),hu(n)?yt(n,wt(t,1,hu,true),T,r):[]}),ko=fr(function(n){var t=c(n,kr);return t.length&&t[0]===n[0]?Wt(t):[]}),Eo=fr(function(n){var t=Ve(n),r=c(n,kr);return t===Ve(r)?t=T:r.pop(),r.length&&r[0]===n[0]?Wt(r,ye(t,2)):[]}),So=fr(function(n){var t=Ve(n),r=c(n,kr);return(t=typeof t=="function"?t:T)&&r.pop(),
r.length&&r[0]===n[0]?Wt(r,T,t):[]}),Oo=fr(Ke),Io=pe(function(n,t){var r=null==n?0:n.length,e=ht(n,t);return ur(n,c(t,function(n){return Se(n,r)?+n:n}).sort(Wr)),e}),Ro=fr(function(n){return br(wt(n,1,hu,true))}),zo=fr(function(n){var t=Ve(n);return hu(t)&&(t=T),br(wt(n,1,hu,true),ye(t,2))}),Wo=fr(function(n){var t=Ve(n),t=typeof t=="function"?t:T;return br(wt(n,1,hu,true),T,t)}),Uo=fr(function(n,t){return hu(n)?yt(n,t):[]}),Bo=fr(function(n){return mr(i(n,hu))}),Lo=fr(function(n){var t=Ve(n);return hu(t)&&(t=T),
mr(i(n,hu),ye(t,2))}),Co=fr(function(n){var t=Ve(n),t=typeof t=="function"?t:T;return mr(i(n,hu),T,t)}),Do=fr(He),Mo=fr(function(n){var t=n.length,t=1<t?n[t-1]:T,t=typeof t=="function"?(n.pop(),t):T;return Je(n,t)}),To=pe(function(n){var t=n.length,r=t?n[0]:0,e=this.__wrapped__,u=function(t){return ht(t,n)};return!(1<t||this.__actions__.length)&&e instanceof Ln&&Se(r)?(e=e.slice(r,+r+(t?1:0)),e.__actions__.push({func:Qe,args:[u],thisArg:T}),new On(e,this.__chain__).thru(function(n){return t&&!n.length&&n.push(T),
n})):this.thru(u)}),$o=Tr(function(n,t,r){oi.call(n,r)?++n[r]:st(n,r,1)}),Fo=Gr(Ne),No=Gr(Pe),Po=Tr(function(n,t,r){oi.call(n,r)?n[r].push(t):st(n,r,[t])}),Zo=fr(function(t,r,e){var u=-1,i=typeof r=="function",o=su(t)?Ku(t.length):[];return uo(t,function(t){o[++u]=i?n(r,t,e):Bt(t,r,e)}),o}),qo=Tr(function(n,t,r){st(n,r,t)}),Vo=Tr(function(n,t,r){n[r?0:1].push(t)},function(){return[[],[]]}),Ko=fr(function(n,t){if(null==n)return[];var r=t.length;return 1<r&&Oe(n,t[0],t[1])?t=[]:2<r&&Oe(t[0],t[1],t[2])&&(t=[t[0]]),
Xt(n,wt(t,1),[])}),Go=Ei||function(){return $n.Date.now()},Ho=fr(function(n,t,r){var e=1;if(r.length)var u=B(r,de(Ho)),e=32|e;return fe(n,e,t,r,u)}),Jo=fr(function(n,t,r){var e=3;if(r.length)var u=B(r,de(Jo)),e=32|e;return fe(t,e,n,r,u)}),Yo=fr(function(n,t){return dt(n,1,t)}),Qo=fr(function(n,t,r){return dt(n,Su(t)||0,r)});cu.Cache=Fn;var Xo=fr(function(t,r){r=1==r.length&&ff(r[0])?c(r[0],E(ye())):c(wt(r,1),E(ye()));var e=r.length;return fr(function(u){for(var i=-1,o=Ci(u.length,e);++i<o;)u[i]=r[i].call(this,u[i]);
return n(t,this,u)})}),nf=fr(function(n,t){return fe(n,32,T,t,B(t,de(nf)))}),tf=fr(function(n,t){return fe(n,64,T,t,B(t,de(tf)))}),rf=pe(function(n,t){return fe(n,256,T,T,T,t)}),ef=ee(It),uf=ee(function(n,t){return n>=t}),of=Lt(function(){return arguments}())?Lt:function(n){return yu(n)&&oi.call(n,"callee")&&!bi.call(n,"callee")},ff=Ku.isArray,cf=Vn?E(Vn):Ct,af=zi||Vu,lf=Kn?E(Kn):Dt,sf=Gn?E(Gn):Tt,hf=Hn?E(Hn):Nt,pf=Jn?E(Jn):Pt,_f=Yn?E(Yn):Zt,vf=ee(Kt),gf=ee(function(n,t){return n<=t}),df=$r(function(n,t){
if(ze(t)||su(t))Cr(t,Wu(t),n);else for(var r in t)oi.call(t,r)&&ot(n,r,t[r])}),yf=$r(function(n,t){Cr(t,Uu(t),n)}),bf=$r(function(n,t,r,e){Cr(t,Uu(t),n,e)}),xf=$r(function(n,t,r,e){Cr(t,Wu(t),n,e)}),jf=pe(ht),wf=fr(function(n,t){n=Qu(n);var r=-1,e=t.length,u=2<e?t[2]:T;for(u&&Oe(t[0],t[1],u)&&(e=1);++r<e;)for(var u=t[r],i=Uu(u),o=-1,f=i.length;++o<f;){var c=i[o],a=n[c];(a===T||lu(a,ei[c])&&!oi.call(n,c))&&(n[c]=u[c])}return n}),mf=fr(function(t){return t.push(T,ae),n(Of,T,t)}),Af=Yr(function(n,t,r){
null!=t&&typeof t.toString!="function"&&(t=ai.call(t)),n[t]=r},Tu($u)),kf=Yr(function(n,t,r){null!=t&&typeof t.toString!="function"&&(t=ai.call(t)),oi.call(n,t)?n[t].push(r):n[t]=[r]},ye),Ef=fr(Bt),Sf=$r(function(n,t,r){Yt(n,t,r)}),Of=$r(function(n,t,r,e){Yt(n,t,r,e)}),If=pe(function(n,t){var r={};if(null==n)return r;var e=false;t=c(t,function(t){return t=Sr(t,n),e||(e=1<t.length),t}),Cr(n,ve(n),r),e&&(r=_t(r,7,le));for(var u=t.length;u--;)xr(r,t[u]);return r}),Rf=pe(function(n,t){return null==n?{}:nr(n,t);
}),zf=oe(Wu),Wf=oe(Uu),Uf=qr(function(n,t,r){return t=t.toLowerCase(),n+(r?Cu(t):t)}),Bf=qr(function(n,t,r){return n+(r?"-":"")+t.toLowerCase()}),Lf=qr(function(n,t,r){return n+(r?" ":"")+t.toLowerCase()}),Cf=Zr("toLowerCase"),Df=qr(function(n,t,r){return n+(r?"_":"")+t.toLowerCase()}),Mf=qr(function(n,t,r){return n+(r?" ":"")+$f(t)}),Tf=qr(function(n,t,r){return n+(r?" ":"")+t.toUpperCase()}),$f=Zr("toUpperCase"),Ff=fr(function(t,r){try{return n(t,T,r)}catch(n){return pu(n)?n:new Hu(n)}}),Nf=pe(function(n,t){
return r(t,function(t){t=Me(t),st(n,t,Ho(n[t],n))}),n}),Pf=Hr(),Zf=Hr(true),qf=fr(function(n,t){return function(r){return Bt(r,n,t)}}),Vf=fr(function(n,t){return function(r){return Bt(n,r,t)}}),Kf=Xr(c),Gf=Xr(u),Hf=Xr(h),Jf=re(),Yf=re(true),Qf=Qr(function(n,t){return n+t},0),Xf=ie("ceil"),nc=Qr(function(n,t){return n/t},1),tc=ie("floor"),rc=Qr(function(n,t){return n*t},1),ec=ie("round"),uc=Qr(function(n,t){return n-t},0);return An.after=function(n,t){if(typeof t!="function")throw new ti("Expected a function");
return n=ku(n),function(){if(1>--n)return t.apply(this,arguments)}},An.ary=eu,An.assign=df,An.assignIn=yf,An.assignInWith=bf,An.assignWith=xf,An.at=jf,An.before=uu,An.bind=Ho,An.bindAll=Nf,An.bindKey=Jo,An.castArray=function(){if(!arguments.length)return[];var n=arguments[0];return ff(n)?n:[n]},An.chain=Ye,An.chunk=function(n,t,r){if(t=(r?Oe(n,t,r):t===T)?1:Li(ku(t),0),r=null==n?0:n.length,!r||1>t)return[];for(var e=0,u=0,i=Ku(Oi(r/t));e<r;)i[u++]=hr(n,e,e+=t);return i},An.compact=function(n){for(var t=-1,r=null==n?0:n.length,e=0,u=[];++t<r;){
var i=n[t];i&&(u[e++]=i)}return u},An.concat=function(){var n=arguments.length;if(!n)return[];for(var t=Ku(n-1),r=arguments[0];n--;)t[n-1]=arguments[n];return a(ff(r)?Lr(r):[r],wt(t,1))},An.cond=function(t){var r=null==t?0:t.length,e=ye();return t=r?c(t,function(n){if("function"!=typeof n[1])throw new ti("Expected a function");return[e(n[0]),n[1]]}):[],fr(function(e){for(var u=-1;++u<r;){var i=t[u];if(n(i[0],this,e))return n(i[1],this,e)}})},An.conforms=function(n){return vt(_t(n,1))},An.constant=Tu,
An.countBy=$o,An.create=function(n,t){var r=eo(n);return null==t?r:at(r,t)},An.curry=iu,An.curryRight=ou,An.debounce=fu,An.defaults=wf,An.defaultsDeep=mf,An.defer=Yo,An.delay=Qo,An.difference=wo,An.differenceBy=mo,An.differenceWith=Ao,An.drop=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:ku(t),hr(n,0>t?0:t,e)):[]},An.dropRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:ku(t),t=e-t,hr(n,0,0>t?0:t)):[]},An.dropRightWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),true,true):[];
},An.dropWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),true):[]},An.fill=function(n,t,r,e){var u=null==n?0:n.length;if(!u)return[];for(r&&typeof r!="number"&&Oe(n,t,r)&&(r=0,e=u),u=n.length,r=ku(r),0>r&&(r=-r>u?0:u+r),e=e===T||e>u?u:ku(e),0>e&&(e+=u),e=r>e?0:Eu(e);r<e;)n[r++]=t;return n},An.filter=function(n,t){return(ff(n)?i:jt)(n,ye(t,3))},An.flatMap=function(n,t){return wt(ru(n,t),1)},An.flatMapDeep=function(n,t){return wt(ru(n,t),$)},An.flatMapDepth=function(n,t,r){return r=r===T?1:ku(r),
wt(ru(n,t),r)},An.flatten=Ze,An.flattenDeep=function(n){return(null==n?0:n.length)?wt(n,$):[]},An.flattenDepth=function(n,t){return null!=n&&n.length?(t=t===T?1:ku(t),wt(n,t)):[]},An.flip=function(n){return fe(n,512)},An.flow=Pf,An.flowRight=Zf,An.fromPairs=function(n){for(var t=-1,r=null==n?0:n.length,e={};++t<r;){var u=n[t];e[u[0]]=u[1]}return e},An.functions=function(n){return null==n?[]:kt(n,Wu(n))},An.functionsIn=function(n){return null==n?[]:kt(n,Uu(n))},An.groupBy=Po,An.initial=function(n){
return(null==n?0:n.length)?hr(n,0,-1):[]},An.intersection=ko,An.intersectionBy=Eo,An.intersectionWith=So,An.invert=Af,An.invertBy=kf,An.invokeMap=Zo,An.iteratee=Fu,An.keyBy=qo,An.keys=Wu,An.keysIn=Uu,An.map=ru,An.mapKeys=function(n,t){var r={};return t=ye(t,3),mt(n,function(n,e,u){st(r,t(n,e,u),n)}),r},An.mapValues=function(n,t){var r={};return t=ye(t,3),mt(n,function(n,e,u){st(r,e,t(n,e,u))}),r},An.matches=function(n){return Ht(_t(n,1))},An.matchesProperty=function(n,t){return Jt(n,_t(t,1))},An.memoize=cu,
An.merge=Sf,An.mergeWith=Of,An.method=qf,An.methodOf=Vf,An.mixin=Nu,An.negate=au,An.nthArg=function(n){return n=ku(n),fr(function(t){return Qt(t,n)})},An.omit=If,An.omitBy=function(n,t){return Bu(n,au(ye(t)))},An.once=function(n){return uu(2,n)},An.orderBy=function(n,t,r,e){return null==n?[]:(ff(t)||(t=null==t?[]:[t]),r=e?T:r,ff(r)||(r=null==r?[]:[r]),Xt(n,t,r))},An.over=Kf,An.overArgs=Xo,An.overEvery=Gf,An.overSome=Hf,An.partial=nf,An.partialRight=tf,An.partition=Vo,An.pick=Rf,An.pickBy=Bu,An.property=Zu,
An.propertyOf=function(n){return function(t){return null==n?T:Et(n,t)}},An.pull=Oo,An.pullAll=Ke,An.pullAllBy=function(n,t,r){return n&&n.length&&t&&t.length?er(n,t,ye(r,2)):n},An.pullAllWith=function(n,t,r){return n&&n.length&&t&&t.length?er(n,t,T,r):n},An.pullAt=Io,An.range=Jf,An.rangeRight=Yf,An.rearg=rf,An.reject=function(n,t){return(ff(n)?i:jt)(n,au(ye(t,3)))},An.remove=function(n,t){var r=[];if(!n||!n.length)return r;var e=-1,u=[],i=n.length;for(t=ye(t,3);++e<i;){var o=n[e];t(o,e,n)&&(r.push(o),
u.push(e))}return ur(n,u),r},An.rest=function(n,t){if(typeof n!="function")throw new ti("Expected a function");return t=t===T?t:ku(t),fr(n,t)},An.reverse=Ge,An.sampleSize=function(n,t,r){return t=(r?Oe(n,t,r):t===T)?1:ku(t),(ff(n)?et:ar)(n,t)},An.set=function(n,t,r){return null==n?n:lr(n,t,r)},An.setWith=function(n,t,r,e){return e=typeof e=="function"?e:T,null==n?n:lr(n,t,r,e)},An.shuffle=function(n){return(ff(n)?ut:sr)(n)},An.slice=function(n,t,r){var e=null==n?0:n.length;return e?(r&&typeof r!="number"&&Oe(n,t,r)?(t=0,
r=e):(t=null==t?0:ku(t),r=r===T?e:ku(r)),hr(n,t,r)):[]},An.sortBy=Ko,An.sortedUniq=function(n){return n&&n.length?gr(n):[]},An.sortedUniqBy=function(n,t){return n&&n.length?gr(n,ye(t,2)):[]},An.split=function(n,t,r){return r&&typeof r!="number"&&Oe(n,t,r)&&(t=r=T),r=r===T?4294967295:r>>>0,r?(n=Iu(n))&&(typeof t=="string"||null!=t&&!hf(t))&&(t=yr(t),!t&&Rn.test(n))?Or(M(n),0,r):n.split(t,r):[]},An.spread=function(t,r){if(typeof t!="function")throw new ti("Expected a function");return r=null==r?0:Li(ku(r),0),
fr(function(e){var u=e[r];return e=Or(e,0,r),u&&a(e,u),n(t,this,e)})},An.tail=function(n){var t=null==n?0:n.length;return t?hr(n,1,t):[]},An.take=function(n,t,r){return n&&n.length?(t=r||t===T?1:ku(t),hr(n,0,0>t?0:t)):[]},An.takeRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:ku(t),t=e-t,hr(n,0>t?0:t,e)):[]},An.takeRightWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),false,true):[]},An.takeWhile=function(n,t){return n&&n.length?jr(n,ye(t,3)):[]},An.tap=function(n,t){return t(n),
n},An.throttle=function(n,t,r){var e=true,u=true;if(typeof n!="function")throw new ti("Expected a function");return du(r)&&(e="leading"in r?!!r.leading:e,u="trailing"in r?!!r.trailing:u),fu(n,t,{leading:e,maxWait:t,trailing:u})},An.thru=Qe,An.toArray=mu,An.toPairs=zf,An.toPairsIn=Wf,An.toPath=function(n){return ff(n)?c(n,Me):wu(n)?[n]:Lr(jo(Iu(n)))},An.toPlainObject=Ou,An.transform=function(n,t,e){var u=ff(n),i=u||af(n)||_f(n);if(t=ye(t,4),null==e){var o=n&&n.constructor;e=i?u?new o:[]:du(n)&&_u(o)?eo(di(n)):{};
}return(i?r:mt)(n,function(n,r,u){return t(e,n,r,u)}),e},An.unary=function(n){return eu(n,1)},An.union=Ro,An.unionBy=zo,An.unionWith=Wo,An.uniq=function(n){return n&&n.length?br(n):[]},An.uniqBy=function(n,t){return n&&n.length?br(n,ye(t,2)):[]},An.uniqWith=function(n,t){return t=typeof t=="function"?t:T,n&&n.length?br(n,T,t):[]},An.unset=function(n,t){return null==n||xr(n,t)},An.unzip=He,An.unzipWith=Je,An.update=function(n,t,r){return null!=n&&(r=Er(r),n=lr(n,t,r(Et(n,t)),void 0)),n},An.updateWith=function(n,t,r,e){
return e=typeof e=="function"?e:T,null!=n&&(r=Er(r),n=lr(n,t,r(Et(n,t)),e)),n},An.values=Lu,An.valuesIn=function(n){return null==n?[]:S(n,Uu(n))},An.without=Uo,An.words=Mu,An.wrap=function(n,t){return nf(Er(t),n)},An.xor=Bo,An.xorBy=Lo,An.xorWith=Co,An.zip=Do,An.zipObject=function(n,t){return Ar(n||[],t||[],ot)},An.zipObjectDeep=function(n,t){return Ar(n||[],t||[],lr)},An.zipWith=Mo,An.entries=zf,An.entriesIn=Wf,An.extend=yf,An.extendWith=bf,Nu(An,An),An.add=Qf,An.attempt=Ff,An.camelCase=Uf,An.capitalize=Cu,
An.ceil=Xf,An.clamp=function(n,t,r){return r===T&&(r=t,t=T),r!==T&&(r=Su(r),r=r===r?r:0),t!==T&&(t=Su(t),t=t===t?t:0),pt(Su(n),t,r)},An.clone=function(n){return _t(n,4)},An.cloneDeep=function(n){return _t(n,5)},An.cloneDeepWith=function(n,t){return t=typeof t=="function"?t:T,_t(n,5,t)},An.cloneWith=function(n,t){return t=typeof t=="function"?t:T,_t(n,4,t)},An.conformsTo=function(n,t){return null==t||gt(n,t,Wu(t))},An.deburr=Du,An.defaultTo=function(n,t){return null==n||n!==n?t:n},An.divide=nc,An.endsWith=function(n,t,r){
n=Iu(n),t=yr(t);var e=n.length,e=r=r===T?e:pt(ku(r),0,e);return r-=t.length,0<=r&&n.slice(r,e)==t},An.eq=lu,An.escape=function(n){return(n=Iu(n))&&H.test(n)?n.replace(K,nt):n},An.escapeRegExp=function(n){return(n=Iu(n))&&en.test(n)?n.replace(rn,"\\$&"):n},An.every=function(n,t,r){var e=ff(n)?u:bt;return r&&Oe(n,t,r)&&(t=T),e(n,ye(t,3))},An.find=Fo,An.findIndex=Ne,An.findKey=function(n,t){return p(n,ye(t,3),mt)},An.findLast=No,An.findLastIndex=Pe,An.findLastKey=function(n,t){return p(n,ye(t,3),At);
},An.floor=tc,An.forEach=nu,An.forEachRight=tu,An.forIn=function(n,t){return null==n?n:oo(n,ye(t,3),Uu)},An.forInRight=function(n,t){return null==n?n:fo(n,ye(t,3),Uu)},An.forOwn=function(n,t){return n&&mt(n,ye(t,3))},An.forOwnRight=function(n,t){return n&&At(n,ye(t,3))},An.get=Ru,An.gt=ef,An.gte=uf,An.has=function(n,t){return null!=n&&we(n,t,Rt)},An.hasIn=zu,An.head=qe,An.identity=$u,An.includes=function(n,t,r,e){return n=su(n)?n:Lu(n),r=r&&!e?ku(r):0,e=n.length,0>r&&(r=Li(e+r,0)),ju(n)?r<=e&&-1<n.indexOf(t,r):!!e&&-1<v(n,t,r);
},An.indexOf=function(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:ku(r),0>r&&(r=Li(e+r,0)),v(n,t,r)):-1},An.inRange=function(n,t,r){return t=Au(t),r===T?(r=t,t=0):r=Au(r),n=Su(n),n>=Ci(t,r)&&n<Li(t,r)},An.invoke=Ef,An.isArguments=of,An.isArray=ff,An.isArrayBuffer=cf,An.isArrayLike=su,An.isArrayLikeObject=hu,An.isBoolean=function(n){return true===n||false===n||yu(n)&&"[object Boolean]"==Ot(n)},An.isBuffer=af,An.isDate=lf,An.isElement=function(n){return yu(n)&&1===n.nodeType&&!xu(n)},An.isEmpty=function(n){
if(null==n)return true;if(su(n)&&(ff(n)||typeof n=="string"||typeof n.splice=="function"||af(n)||_f(n)||of(n)))return!n.length;var t=vo(n);if("[object Map]"==t||"[object Set]"==t)return!n.size;if(ze(n))return!Vt(n).length;for(var r in n)if(oi.call(n,r))return false;return true},An.isEqual=function(n,t){return Mt(n,t)},An.isEqualWith=function(n,t,r){var e=(r=typeof r=="function"?r:T)?r(n,t):T;return e===T?Mt(n,t,T,r):!!e},An.isError=pu,An.isFinite=function(n){return typeof n=="number"&&Wi(n)},An.isFunction=_u,
An.isInteger=vu,An.isLength=gu,An.isMap=sf,An.isMatch=function(n,t){return n===t||$t(n,t,xe(t))},An.isMatchWith=function(n,t,r){return r=typeof r=="function"?r:T,$t(n,t,xe(t),r)},An.isNaN=function(n){return bu(n)&&n!=+n},An.isNative=function(n){if(go(n))throw new Hu("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");return Ft(n)},An.isNil=function(n){return null==n},An.isNull=function(n){return null===n},An.isNumber=bu,An.isObject=du,An.isObjectLike=yu,An.isPlainObject=xu,An.isRegExp=hf,
An.isSafeInteger=function(n){return vu(n)&&-9007199254740991<=n&&9007199254740991>=n},An.isSet=pf,An.isString=ju,An.isSymbol=wu,An.isTypedArray=_f,An.isUndefined=function(n){return n===T},An.isWeakMap=function(n){return yu(n)&&"[object WeakMap]"==vo(n)},An.isWeakSet=function(n){return yu(n)&&"[object WeakSet]"==Ot(n)},An.join=function(n,t){return null==n?"":Ui.call(n,t)},An.kebabCase=Bf,An.last=Ve,An.lastIndexOf=function(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e;if(r!==T&&(u=ku(r),u=0>u?Li(e+u,0):Ci(u,e-1)),
t===t)n:{for(r=u+1;r--;)if(n[r]===t){n=r;break n}n=r}else n=_(n,d,u,true);return n},An.lowerCase=Lf,An.lowerFirst=Cf,An.lt=vf,An.lte=gf,An.max=function(n){return n&&n.length?xt(n,$u,It):T},An.maxBy=function(n,t){return n&&n.length?xt(n,ye(t,2),It):T},An.mean=function(n){return y(n,$u)},An.meanBy=function(n,t){return y(n,ye(t,2))},An.min=function(n){return n&&n.length?xt(n,$u,Kt):T},An.minBy=function(n,t){return n&&n.length?xt(n,ye(t,2),Kt):T},An.stubArray=qu,An.stubFalse=Vu,An.stubObject=function(){
return{}},An.stubString=function(){return""},An.stubTrue=function(){return true},An.multiply=rc,An.nth=function(n,t){return n&&n.length?Qt(n,ku(t)):T},An.noConflict=function(){return $n._===this&&($n._=si),this},An.noop=Pu,An.now=Go,An.pad=function(n,t,r){n=Iu(n);var e=(t=ku(t))?D(n):0;return!t||e>=t?n:(t=(t-e)/2,ne(Ii(t),r)+n+ne(Oi(t),r))},An.padEnd=function(n,t,r){n=Iu(n);var e=(t=ku(t))?D(n):0;return t&&e<t?n+ne(t-e,r):n},An.padStart=function(n,t,r){n=Iu(n);var e=(t=ku(t))?D(n):0;return t&&e<t?ne(t-e,r)+n:n;
},An.parseInt=function(n,t,r){return r||null==t?t=0:t&&(t=+t),Mi(Iu(n).replace(on,""),t||0)},An.random=function(n,t,r){if(r&&typeof r!="boolean"&&Oe(n,t,r)&&(t=r=T),r===T&&(typeof t=="boolean"?(r=t,t=T):typeof n=="boolean"&&(r=n,n=T)),n===T&&t===T?(n=0,t=1):(n=Au(n),t===T?(t=n,n=0):t=Au(t)),n>t){var e=n;n=t,t=e}return r||n%1||t%1?(r=Ti(),Ci(n+r*(t-n+Cn("1e-"+((r+"").length-1))),t)):ir(n,t)},An.reduce=function(n,t,r){var e=ff(n)?l:j,u=3>arguments.length;return e(n,ye(t,4),r,u,uo)},An.reduceRight=function(n,t,r){
var e=ff(n)?s:j,u=3>arguments.length;return e(n,ye(t,4),r,u,io)},An.repeat=function(n,t,r){return t=(r?Oe(n,t,r):t===T)?1:ku(t),or(Iu(n),t)},An.replace=function(){var n=arguments,t=Iu(n[0]);return 3>n.length?t:t.replace(n[1],n[2])},An.result=function(n,t,r){t=Sr(t,n);var e=-1,u=t.length;for(u||(u=1,n=T);++e<u;){var i=null==n?T:n[Me(t[e])];i===T&&(e=u,i=r),n=_u(i)?i.call(n):i}return n},An.round=ec,An.runInContext=x,An.sample=function(n){return(ff(n)?Qn:cr)(n)},An.size=function(n){if(null==n)return 0;
if(su(n))return ju(n)?D(n):n.length;var t=vo(n);return"[object Map]"==t||"[object Set]"==t?n.size:Vt(n).length},An.snakeCase=Df,An.some=function(n,t,r){var e=ff(n)?h:pr;return r&&Oe(n,t,r)&&(t=T),e(n,ye(t,3))},An.sortedIndex=function(n,t){return _r(n,t)},An.sortedIndexBy=function(n,t,r){return vr(n,t,ye(r,2))},An.sortedIndexOf=function(n,t){var r=null==n?0:n.length;if(r){var e=_r(n,t);if(e<r&&lu(n[e],t))return e}return-1},An.sortedLastIndex=function(n,t){return _r(n,t,true)},An.sortedLastIndexBy=function(n,t,r){
return vr(n,t,ye(r,2),true)},An.sortedLastIndexOf=function(n,t){if(null==n?0:n.length){var r=_r(n,t,true)-1;if(lu(n[r],t))return r}return-1},An.startCase=Mf,An.startsWith=function(n,t,r){return n=Iu(n),r=null==r?0:pt(ku(r),0,n.length),t=yr(t),n.slice(r,r+t.length)==t},An.subtract=uc,An.sum=function(n){return n&&n.length?m(n,$u):0},An.sumBy=function(n,t){return n&&n.length?m(n,ye(t,2)):0},An.template=function(n,t,r){var e=An.templateSettings;r&&Oe(n,t,r)&&(t=T),n=Iu(n),t=bf({},t,e,ce),r=bf({},t.imports,e.imports,ce);
var u,i,o=Wu(r),f=S(r,o),c=0;r=t.interpolate||jn;var a="__p+='";r=Xu((t.escape||jn).source+"|"+r.source+"|"+(r===Q?pn:jn).source+"|"+(t.evaluate||jn).source+"|$","g");var l="sourceURL"in t?"//# sourceURL="+t.sourceURL+"\n":"";if(n.replace(r,function(t,r,e,o,f,l){return e||(e=o),a+=n.slice(c,l).replace(wn,z),r&&(u=true,a+="'+__e("+r+")+'"),f&&(i=true,a+="';"+f+";\n__p+='"),e&&(a+="'+((__t=("+e+"))==null?'':__t)+'"),c=l+t.length,t}),a+="';",(t=t.variable)||(a="with(obj){"+a+"}"),a=(i?a.replace(P,""):a).replace(Z,"$1").replace(q,"$1;"),
a="function("+(t||"obj")+"){"+(t?"":"obj||(obj={});")+"var __t,__p=''"+(u?",__e=_.escape":"")+(i?",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}":";")+a+"return __p}",t=Ff(function(){return Ju(o,l+"return "+a).apply(T,f)}),t.source=a,pu(t))throw t;return t},An.times=function(n,t){if(n=ku(n),1>n||9007199254740991<n)return[];var r=4294967295,e=Ci(n,4294967295);for(t=ye(t),n-=4294967295,e=A(e,t);++r<n;)t(r);return e},An.toFinite=Au,An.toInteger=ku,An.toLength=Eu,An.toLower=function(n){
return Iu(n).toLowerCase()},An.toNumber=Su,An.toSafeInteger=function(n){return n?pt(ku(n),-9007199254740991,9007199254740991):0===n?n:0},An.toString=Iu,An.toUpper=function(n){return Iu(n).toUpperCase()},An.trim=function(n,t,r){return(n=Iu(n))&&(r||t===T)?n.replace(un,""):n&&(t=yr(t))?(n=M(n),r=M(t),t=I(n,r),r=R(n,r)+1,Or(n,t,r).join("")):n},An.trimEnd=function(n,t,r){return(n=Iu(n))&&(r||t===T)?n.replace(fn,""):n&&(t=yr(t))?(n=M(n),t=R(n,M(t))+1,Or(n,0,t).join("")):n},An.trimStart=function(n,t,r){
return(n=Iu(n))&&(r||t===T)?n.replace(on,""):n&&(t=yr(t))?(n=M(n),t=I(n,M(t)),Or(n,t).join("")):n},An.truncate=function(n,t){var r=30,e="...";if(du(t))var u="separator"in t?t.separator:u,r="length"in t?ku(t.length):r,e="omission"in t?yr(t.omission):e;n=Iu(n);var i=n.length;if(Rn.test(n))var o=M(n),i=o.length;if(r>=i)return n;if(i=r-D(e),1>i)return e;if(r=o?Or(o,0,i).join(""):n.slice(0,i),u===T)return r+e;if(o&&(i+=r.length-i),hf(u)){if(n.slice(i).search(u)){var f=r;for(u.global||(u=Xu(u.source,Iu(_n.exec(u))+"g")),
u.lastIndex=0;o=u.exec(f);)var c=o.index;r=r.slice(0,c===T?i:c)}}else n.indexOf(yr(u),i)!=i&&(u=r.lastIndexOf(u),-1<u&&(r=r.slice(0,u)));return r+e},An.unescape=function(n){return(n=Iu(n))&&G.test(n)?n.replace(V,tt):n},An.uniqueId=function(n){var t=++fi;return Iu(n)+t},An.upperCase=Tf,An.upperFirst=$f,An.each=nu,An.eachRight=tu,An.first=qe,Nu(An,function(){var n={};return mt(An,function(t,r){oi.call(An.prototype,r)||(n[r]=t)}),n}(),{chain:false}),An.VERSION="4.17.11",r("bind bindKey curry curryRight partial partialRight".split(" "),function(n){
An[n].placeholder=An}),r(["drop","take"],function(n,t){Ln.prototype[n]=function(r){r=r===T?1:Li(ku(r),0);var e=this.__filtered__&&!t?new Ln(this):this.clone();return e.__filtered__?e.__takeCount__=Ci(r,e.__takeCount__):e.__views__.push({size:Ci(r,4294967295),type:n+(0>e.__dir__?"Right":"")}),e},Ln.prototype[n+"Right"]=function(t){return this.reverse()[n](t).reverse()}}),r(["filter","map","takeWhile"],function(n,t){var r=t+1,e=1==r||3==r;Ln.prototype[n]=function(n){var t=this.clone();return t.__iteratees__.push({
iteratee:ye(n,3),type:r}),t.__filtered__=t.__filtered__||e,t}}),r(["head","last"],function(n,t){var r="take"+(t?"Right":"");Ln.prototype[n]=function(){return this[r](1).value()[0]}}),r(["initial","tail"],function(n,t){var r="drop"+(t?"":"Right");Ln.prototype[n]=function(){return this.__filtered__?new Ln(this):this[r](1)}}),Ln.prototype.compact=function(){return this.filter($u)},Ln.prototype.find=function(n){return this.filter(n).head()},Ln.prototype.findLast=function(n){return this.reverse().find(n);
},Ln.prototype.invokeMap=fr(function(n,t){return typeof n=="function"?new Ln(this):this.map(function(r){return Bt(r,n,t)})}),Ln.prototype.reject=function(n){return this.filter(au(ye(n)))},Ln.prototype.slice=function(n,t){n=ku(n);var r=this;return r.__filtered__&&(0<n||0>t)?new Ln(r):(0>n?r=r.takeRight(-n):n&&(r=r.drop(n)),t!==T&&(t=ku(t),r=0>t?r.dropRight(-t):r.take(t-n)),r)},Ln.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},Ln.prototype.toArray=function(){return this.take(4294967295);
},mt(Ln.prototype,function(n,t){var r=/^(?:filter|find|map|reject)|While$/.test(t),e=/^(?:head|last)$/.test(t),u=An[e?"take"+("last"==t?"Right":""):t],i=e||/^find/.test(t);u&&(An.prototype[t]=function(){var t=this.__wrapped__,o=e?[1]:arguments,f=t instanceof Ln,c=o[0],l=f||ff(t),s=function(n){return n=u.apply(An,a([n],o)),e&&h?n[0]:n};l&&r&&typeof c=="function"&&1!=c.length&&(f=l=false);var h=this.__chain__,p=!!this.__actions__.length,c=i&&!h,f=f&&!p;return!i&&l?(t=f?t:new Ln(this),t=n.apply(t,o),t.__actions__.push({
func:Qe,args:[s],thisArg:T}),new On(t,h)):c&&f?n.apply(this,o):(t=this.thru(s),c?e?t.value()[0]:t.value():t)})}),r("pop push shift sort splice unshift".split(" "),function(n){var t=ri[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|shift)$/.test(n);An.prototype[n]=function(){var n=arguments;if(e&&!this.__chain__){var u=this.value();return t.apply(ff(u)?u:[],n)}return this[r](function(r){return t.apply(ff(r)?r:[],n)})}}),mt(Ln.prototype,function(n,t){var r=An[t];if(r){var e=r.name+"";
(Gi[e]||(Gi[e]=[])).push({name:t,func:r})}}),Gi[Jr(T,2).name]=[{name:"wrapper",func:T}],Ln.prototype.clone=function(){var n=new Ln(this.__wrapped__);return n.__actions__=Lr(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=Lr(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=Lr(this.__views__),n},Ln.prototype.reverse=function(){if(this.__filtered__){var n=new Ln(this);n.__dir__=-1,n.__filtered__=true}else n=this.clone(),n.__dir__*=-1;return n;
},Ln.prototype.value=function(){var n,t=this.__wrapped__.value(),r=this.__dir__,e=ff(t),u=0>r,i=e?t.length:0;n=0;for(var o=i,f=this.__views__,c=-1,a=f.length;++c<a;){var l=f[c],s=l.size;switch(l.type){case"drop":n+=s;break;case"dropRight":o-=s;break;case"take":o=Ci(o,n+s);break;case"takeRight":n=Li(n,o-s)}}if(n={start:n,end:o},o=n.start,f=n.end,n=f-o,o=u?f:o-1,f=this.__iteratees__,c=f.length,a=0,l=Ci(n,this.__takeCount__),!e||!u&&i==n&&l==n)return wr(t,this.__actions__);e=[];n:for(;n--&&a<l;){for(o+=r,
u=-1,i=t[o];++u<c;){var h=f[u],s=h.type,h=(0,h.iteratee)(i);if(2==s)i=h;else if(!h){if(1==s)continue n;break n}}e[a++]=i}return e},An.prototype.at=To,An.prototype.chain=function(){return Ye(this)},An.prototype.commit=function(){return new On(this.value(),this.__chain__)},An.prototype.next=function(){this.__values__===T&&(this.__values__=mu(this.value()));var n=this.__index__>=this.__values__.length;return{done:n,value:n?T:this.__values__[this.__index__++]}},An.prototype.plant=function(n){for(var t,r=this;r instanceof kn;){
var e=Fe(r);e.__index__=0,e.__values__=T,t?u.__wrapped__=e:t=e;var u=e,r=r.__wrapped__}return u.__wrapped__=n,t},An.prototype.reverse=function(){var n=this.__wrapped__;return n instanceof Ln?(this.__actions__.length&&(n=new Ln(this)),n=n.reverse(),n.__actions__.push({func:Qe,args:[Ge],thisArg:T}),new On(n,this.__chain__)):this.thru(Ge)},An.prototype.toJSON=An.prototype.valueOf=An.prototype.value=function(){return wr(this.__wrapped__,this.__actions__)},An.prototype.first=An.prototype.head,wi&&(An.prototype[wi]=Xe),
An}(); true?($n._=rt, !(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return rt}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))):undefined}).call(this);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq"), __webpack_require__("EIeC")(module)))

/***/ }),

/***/ "igjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isStrictlyProductionEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isStrictlyStagingEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isStrictlyIntegrationEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isStrictlyTestEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isStrictlyDevelopmentEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentLocale; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_2__);



function getCurrentUri(req) {
  return new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(decodeURI(req.originalUrl)).protocol(req.protocol).host(req.get('host'));
}
function isProduction() {
  return _config__WEBPACK_IMPORTED_MODULE_2___default.a.get('DEPLOYMENT_ENV') === 'production';
}
function isStrictlyProductionEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && (cfg.get('DEPLOYMENT_ENV') === 'production' || cfg.get('DEPLOYMENT_ENV') === 'prod');
}
function isStrictlyStagingEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'staging';
}
function isStrictlyIntegrationEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'integration';
}
function isStrictlyTestEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'test';
}
function isStrictlyDevelopmentEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'development' || cfg.get('NODE_ENV') === 'dev';
}
function getCurrentLocale(requestedLocale, hostname) {
  if (requestedLocale) {
    return requestedLocale;
  }

  var domainServiceForHostname = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default.a.forHostname(hostname);
  return domainServiceForHostname.getDefaultLocale();
}

/***/ }),

/***/ "jD8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TextLink_TextLink; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.themes.js

var themes = {
  "default": function _default(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color;
    return {
      thIconWidth: '.7em',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-base focus:underline hover:underline"),
      thLabel: '',
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  },
  fancy: function fancy(_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color;
    return {
      thIconWidth: '0.4375rem',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-sm"),
      thLabel: '',
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  },
  solid: function solid(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref3$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " bg-current font-bold font-sans leading-one p-px10 rounded-tiny text-base uppercase"),
      thLabel: 'text-white',
      thIconLeft: 'text-white rtl:mr-px10',
      thIconRight: 'text-white rtl:ml-px10'
    };
  },
  simple: function simple(_ref4) {
    var _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _ref4$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " font-sans leading-loose self-start rtl:ml-auto text-base underline"),
      thLabel: '',
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx

var __jsx = react_default.a.createElement;







var TextLink_TextLink = function TextLink(_ref) {
  var ariaHidden = _ref.ariaHidden,
      ariaLabel = _ref.ariaLabel,
      className = _ref.className,
      color = _ref.color,
      iconLeftName = _ref.iconLeftName,
      _ref$iconRightName = _ref.iconRightName,
      iconRightName = _ref$iconRightName === void 0 ? icons["a" /* ICONS */].BOLDER_ARROW_FORTH : _ref$iconRightName,
      isExternalLink = _ref.isExternalLink,
      label = _ref.label,
      onClick = _ref.onClick,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      target = _ref.target,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      trackingData = _ref.trackingData,
      url = _ref.url;

  if (!label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    color: color
  }),
      thIconLeft = _themes$theme.thIconLeft,
      thIconRight = _themes$theme.thIconRight,
      thIconWidth = _themes$theme.thIconWidth,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  return __jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    as: url ? DynamicLink["a" /* default */] : 'button',
    className: classnames_default()(className, 'reset-button inline-flex items-center', thRoot),
    onClick: onClick,
    tabIndex: tabIndex,
    target: target,
    trackingData: trackingData
  }, url ? {
    url: url,
    isExternalLink: isExternalLink
  } : {
    type: 'button'
  }), !!iconLeftName && __jsx(Icon["a" /* Icon */], {
    className: thIconLeft,
    hasRtl: true,
    name: iconLeftName,
    width: thIconWidth
  }), __jsx("span", {
    className: thLabel
  }, label), !!iconRightName && __jsx(Icon["a" /* Icon */], {
    className: thIconRight,
    hasRtl: true,
    name: iconRightName,
    width: thIconWidth
  }));
};

/***/ }),

/***/ "jbM+":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("R/W3");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "jw1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPriceFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanupArgs; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);


var generateCmsArgs = function generateCmsArgs(content, release) {
  return "content : \"".concat(content, "\" release : \"").concat(release, "\"");
};

var getPriceArgs = function getPriceArgs(args) {
  return ['offerId', 'offerName', 'date', 'dateStart', 'dateEnd', 'duration', 'departureCity', 'forceWithoutTransport', 'optimizedPriceCalls'].filter(function (key) {
    return args[key];
  }).map(function (key) {
    var value = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isString"])(args[key]) ? "\"".concat(args[key], "\"") : args[key];
    return [key, value];
  });
};

var buildPriceGraphqlArgs = function buildPriceGraphqlArgs(args) {
  return args.length ? "(".concat(args.map(function (priceArg) {
    return priceArg.join(' : ');
  }).join(' '), ")") : '';
};

function getPriceFields(args) {
  var content = args.content,
      release = args.release;
  var cmsArgs = generateCmsArgs(content, release);
  var priceArgs = buildPriceGraphqlArgs(getPriceArgs(args));
  return "\n    price ".concat(priceArgs, " {\n      bestPrice {\n        value\n        formattedValue\n      }\n      initialPrice {\n        value\n        formattedValue\n      }\n      unit(").concat(cmsArgs, ")\n      currency\n      termsAndConditions {\n        departureDate\n        duration\n        durationFormatted(").concat(cmsArgs, ")\n        numberOfAdults\n        departureCity {\n          value\n          name\n        }\n        accommodationComfortLabel\n      }\n    }");
}

function getThumbnailBaseFields(args) {
  var offerName = args.offerName,
      tourDurationPlaceholder = args.tourDurationPlaceholder,
      cruiseTimingPlaceholder = args.cruiseTimingPlaceholder,
      cruiseDurationPlaceholder = args.cruiseDurationPlaceholder,
      dateFormat = args.dateFormat,
      content = args.content,
      release = args.release; // use typeof string since we cannot be sure that there are no empty strings on the CMS

  var durationArgs = typeof tourDurationPlaceholder === 'string' && typeof cruiseDurationPlaceholder === 'string' ? "(message : \"".concat(tourDurationPlaceholder, "\", cruiseMessage : \"").concat(cruiseDurationPlaceholder, "\")") : '';
  var timingDescriptionArgs = typeof cruiseTimingPlaceholder === 'string' && typeof dateFormat === 'string' ? "(message : \"".concat(cruiseTimingPlaceholder, "\" dateFormat : \"").concat(dateFormat, "\")") : '';
  return "\n    badgeIcon\n    childcareDetails {\n      id\n      included\n    }\n    color\n    comfort\n    comfortLabel\n    destination {\n      area\n      country\n    }\n    duration".concat(durationArgs, "\n    href(offerName : \"").concat(offerName, "\")\n    id\n    images\n    isCruise\n    isDoubleSeason\n    isExclusiveCollection\n    isExplicitEC\n    isJoyview\n    isResort\n    isSummer\n    isTour\n    isVilla\n    isWinter\n    minAuthorizedAge {\n      value\n    }\n    name\n    openingStatus\n    rangeId\n    rangeLabel\n    resortId\n    seasonName\n    seasonTrad(").concat(generateCmsArgs(content, release), ")\n    thematics {\n      label\n    }\n    timingDescription").concat(timingDescriptionArgs, "\n    title\n    type");
}

function cleanupArgs(args) {
  return {
    content: args.content || '',
    release: args.release || '',
    cruiseTimingPlaceholder: args.cruiseTimingPlaceholder,
    cruiseDurationPlaceholder: args.cruiseDurationPlaceholder,
    date: args.date || '',
    dateFormat: args.dateFormat,
    departureCity: args.departureCity || '',
    duration: args.duration || null,
    dateStart: args.dateStart || '',
    dateEnd: args.dateEnd || '',
    forceWithoutTransport: !!args.forceWithoutTransport,
    offerId: args.offerId || '',
    offerName: args.offerName || '',
    optimizedPriceCalls: args.optimizedPriceCalls || false,
    tourDurationPlaceholder: args.tourDurationPlaceholder
  };
}

function makeResortThumbnailQuery(args, options) {
  var _ref = options || {},
      _ref$withoutPrice = _ref.withoutPrice,
      withoutPrice = _ref$withoutPrice === void 0 ? false : _ref$withoutPrice;

  var priceFields = !withoutPrice ? getPriceFields(cleanupArgs(args)) : '';
  return "".concat(getThumbnailBaseFields(cleanupArgs(args))).concat(priceFields);
}

/* harmony default export */ __webpack_exports__["b"] = (makeResortThumbnailQuery);

/***/ }),

/***/ "k9PE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("qm5D");
/* harmony import */ var _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Mkub");



 // TODO This was a curried function. It should be just redirectTo(uri: string): void

function redirectTo(currentUrl) {
  return function (uri, options) {
    if (true) {
      var dynamicLinkHelper = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"](currentUrl || window.location.href, uri);

      if (dynamicLinkHelper.isExternalUrl()) {
        _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].setLocation(uri);
      } else {
        var objectUri = new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(uri); // next/router is not happy if you only pass him the query parameters. So get the pathname
        // when not provided

        if (objectUri.pathname() === '') {
          objectUri.pathname(window.location.pathname);
        }

        var currentUri = new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(window.location.href);

        if (currentUri.resource() !== objectUri.resource()) {
          // URI().resource() prevent domain name to be passed to the history
          // http://domain/foo -> /foo
          // /foo -> /foo
          if (options === null || options === void 0 ? void 0 : options.shallow) {
            if (options.replace) {
              _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].shallowReplaceRoute(objectUri.resource());
            } else {
              _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].shallowPushRoute(objectUri.resource());
            }
          } else if (options === null || options === void 0 ? void 0 : options.replace) {
            _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].replaceRoute(objectUri.resource());
          } else {
            _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].pushRoute(objectUri.resource(), undefined, options);
          }
        }
      }
    }
  };
}

function redirectToUri() {
  return function (uri) {
    return function () {
      var redirectUri = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"](_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].getLocation(), uri).toString();
      redirectTo()(redirectUri);
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  redirectTo: redirectTo,
  redirectToUri: redirectToUri
});

/***/ }),

/***/ "kD/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_BOOKING_CART; });
/* unused harmony export getBookingCartQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchBookingCart; });
/* unused harmony export removeService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateBookingCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateBookingCartSequencially; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateBookingCartAll; });
/* harmony import */ var _store_utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Nhxn");




var FETCH_BOOKING_CART = 'FETCH_BOOKING_CART';
var UPDATE_BOOKING_CART = 'UPDATE_BOOKING_CART';
var cartQuery = "\n    cart {\n        childcares {\n            id\n            productId\n            label\n            type\n            attendees {\n                id\n                price\n            }\n            startDate\n            endDate\n            schedules {\n              startDate\n              endDate\n              attendees {\n                id\n                price\n              }\n            }\n        }\n        transfers {\n          id\n          productId\n          type\n          label\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n        }\n        insurance {\n          id\n          productId\n          type\n          label\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n        }\n        rentals {\n          id\n          productId\n          type\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n          attendees {\n            id\n            schedules {\n              price {\n                value\n              }\n              startDate\n              endDate\n            }\n          }\n        }\n        activities {\n          id\n          productId\n          type\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n              price\n            }\n          }\n        }\n        pickRoom { \n          id\n          type\n          accommodations {\n            id \n            rooms {\n              id\n            }\n          }\n        }\n        price {\n            total {\n                formattedValue(precision: 2)\n                value\n                currency\n            }\n            currency\n            detail {\n              service\n              amount\n            }\n        }\n        isEmpty\n    }\n";
var getBookingCartQuery = function getBookingCartQuery(bookingId) {
  return "query {\n        userBooking(bookingId : \"".concat(bookingId, "\") {\n          ").concat(cartQuery, "\n        }\n    }");
};
var fetchBookingCart = function fetchBookingCart(stay, context) {
  return function (dispatch) {
    return dispatch(Object(_store_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(FETCH_BOOKING_CART, {
      stay: stay
    }, {
      optimist: true,
      promise: _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(getBookingCartQuery(stay.bookingId), context, {
        requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_GET_BOOKING_CART */ "h"]
      })
    }));
  };
};

var addService = function addService(_ref) {
  var id = _ref.id,
      bookingId = _ref.bookingId,
      schedules = _ref.schedules,
      accommodations = _ref.accommodations,
      serviceName = _ref.serviceName;
  return "mutation {\n            addServiceCart(\n             bookingId : \"".concat(bookingId, "\",\n             serviceCart: {\n                 id: \"").concat(id, "\",\n                 ").concat(schedules ? Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_3__[/* attributesToString */ "a"])({
    schedules: schedules
  }) : '', "\n                 ").concat(accommodations ? Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_3__[/* attributesToString */ "a"])({
    accommodations: accommodations
  }) : '', "\n             }\n             serviceName: \"").concat(serviceName, "\") {\n                ").concat(cartQuery, "\n             }\n          }");
};

var removeService = function removeService(id, bookingId) {
  return "mutation {\n              removeServiceCart(\n               bookingId : \"".concat(bookingId, "\",\n               itemId: \"").concat(id, "\")\n               {\n                ").concat(cartQuery, "\n               }\n            }");
};
var updateBookingCart = function updateBookingCart(_ref2) {
  var id = _ref2.id,
      bookingId = _ref2.bookingId,
      schedules = _ref2.schedules,
      accommodations = _ref2.accommodations,
      serviceName = _ref2.serviceName,
      context = _ref2.context,
      action = _ref2.action,
      successMsg = _ref2.successMsg;
  return function (dispatch) {
    return dispatch(Object(_store_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(UPDATE_BOOKING_CART, {
      id: id,
      toastLabel: successMsg
    }, {
      optimist: true,
      promise: _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
        id: id,
        bookingId: bookingId,
        schedules: schedules,
        accommodations: accommodations,
        serviceName: serviceName
      }) : removeService(id, bookingId), context, {
        requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "T"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "Q"]
      })
    }));
  };
};
var updateBookingCartSequencially = function updateBookingCartSequencially(params) {
  if (params.length === 0) {
    return Promise.resolve();
  }

  var _params$ = params[0],
      id = _params$.id,
      bookingId = _params$.bookingId,
      schedules = _params$.schedules,
      accommodations = _params$.accommodations,
      serviceName = _params$.serviceName,
      context = _params$.context,
      action = _params$.action;
  var promise = _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
    id: id,
    bookingId: bookingId,
    schedules: schedules,
    accommodations: accommodations,
    serviceName: serviceName
  }) : removeService(id, bookingId), context, {
    requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "T"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "Q"]
  });
  return promise.then(function () {
    return updateBookingCartSequencially(params.slice(1));
  });
};
var updateBookingCartAll = function updateBookingCartAll(params) {
  return Promise.all(params.map(function (_ref3) {
    var id = _ref3.id,
        bookingId = _ref3.bookingId,
        schedules = _ref3.schedules,
        accommodations = _ref3.accommodations,
        serviceName = _ref3.serviceName,
        context = _ref3.context,
        action = _ref3.action;
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
      id: id,
      bookingId: bookingId,
      schedules: schedules,
      accommodations: accommodations,
      serviceName: serviceName
    }) : removeService(id, bookingId), context, {
      requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "T"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "Q"]
    });
  }));
};

/***/ }),

/***/ "kD1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConfigWithNoThirdPartySupport; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_has__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OFL0");
/* harmony import */ var lodash_has__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_has__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_3__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



 // makes inexact to allow other query params

var shouldIgnoreThirdParty = function shouldIgnoreThirdParty(queryParams) {
  return lodash_has__WEBPACK_IMPORTED_MODULE_1___default()(queryParams, _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["appQueryParameters"].noThirdParty);
};

var appLocaleConfig;
var getConfigWithNoThirdPartySupport = function getConfigWithNoThirdPartySupport(_ref) {
  var name = _ref.name,
      locale = _ref.locale,
      queryParams = _ref.queryParams; // cache if on browser

  if (!appLocaleConfig || false) {
    appLocaleConfig = _config__WEBPACK_IMPORTED_MODULE_3___default.a.locale(locale);
  }

  var originalConfig = appLocaleConfig.get(name);
  return shouldIgnoreThirdParty(queryParams) ? _objectSpread(_objectSpread({}, originalConfig), {}, {
    enabled: false
  }) : originalConfig;
};

/***/ }),

/***/ "kG2z":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "kNiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return serializeKidsToQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getKidAgeInMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDepartureDateDisplayValue; });
/* unused harmony export findFacetCategoryById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatDepartureDateForStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getChildcareFacets; });
/* unused harmony export getChildren */
/* unused harmony export getFormattedDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCities; });
/* unused harmony export getSelectedDepartureCity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isDateInThePast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isKidMinor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return unserializeKidsFromQueryParam; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wQ38");
/* harmony import */ var _uri_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Sj1w");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sW3P");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







function findFacetCategoryById(facets, facetCategoryId) {
  return facets.find(function (facetCategory) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(facetCategory, 'id') === facetCategoryId;
  });
}

function _getFacetValues(facets, categoryId) {
  var category = findFacetCategoryById(facets, categoryId);
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(category, 'list', []);
}

function getChildcareFacets(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_5__[/* CHILDCARE_FACET_ID */ "e"]);
}

function getDepartureCities(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "j"]);
}

function getSelectedDepartureCity(facets) {
  var selectedCity = getDepartureCities(facets).find(function (facet) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(facet, 'selected');
  });
  return selectedCity ? Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(selectedCity, 'name') : null;
}

function formatDepartureDateForStore(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_5__[/* DATE_FORMAT */ "g"];
  return date !== null ? moment__WEBPACK_IMPORTED_MODULE_2___default()(date, format).valueOf() : null;
}

function getDepartureDateDisplayValue() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var momentDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(date);
  return momentDate.isValid() ? momentDate.format(_constants__WEBPACK_IMPORTED_MODULE_5__[/* DATE_FORMAT */ "g"]) : '';
}

function isDateInThePast(timestampDate) {
  return timestampDate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(timestampDate).isBefore() : false;
}

function getFormattedDepartureDate(date, dateFormat) {
  return date ? moment__WEBPACK_IMPORTED_MODULE_2___default()(date).format(dateFormat) : '';
}

function isKidMinor(birthdate) {
  if (!birthdate) {
    return false;
  }

  var minBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()().subtract(18, 'years');
  var momentBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate);
  return momentBirthdate.isValid() && momentBirthdate.isBetween(minBirthdate, moment__WEBPACK_IMPORTED_MODULE_2___default()());
}

function getChildren(numberOfChildren, childrenBirthdates) {
  if (Number.isInteger(numberOfChildren) && numberOfChildren >= 0 && numberOfChildren <= _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "u"]) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["times"])(numberOfChildren, function (idx) {
      return childrenBirthdates && childrenBirthdates.length > idx ? {
        birthdate: moment__WEBPACK_IMPORTED_MODULE_2___default()(childrenBirthdates[idx], 'YYYYMMDD', true).valueOf(),
        childcareIncluded: false
      } : {
        childcareIncluded: false
      };
    });
  }

  return null;
}

function unserializeKidsFromQueryParam(value) {
  if (!value) return [];
  var kidsNumber = Number(value); // NOTE: DO NOT USE parseInt() !!! parseInt('2010-12-10c') will return 2010 ...

  if (kidsNumber > _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "u"]) {
    return [];
  }

  if (Number.isInteger(kidsNumber)) return new Array(kidsNumber).fill(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"]));
  var kids = value.split(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_KIDS_DELIMITER */ "i"]).map(function (serializedKidString) {
    var hasChildcareFlag = serializedKidString.substr(-1) === _uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"];
    var strBirthdate = serializedKidString.replace(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"], '');
    var birthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(strBirthdate, _uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DATE_FORMAT */ "e"], true);
    var childcareIncluded = birthdate.isValid() ? hasChildcareFlag : _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"].childcareIncluded;
    return _objectSpread(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"]), {}, {
      childcareIncluded: childcareIncluded,
      birthdate: birthdate.isValid() ? birthdate.valueOf() : undefined
    });
  });
  return kids.length > _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "u"] ? [] : kids;
}
/**
 * Helper to serialize kids array as a URI query parameter.
 *
 * Example of returns:
 *
 * - `kids=1` (1 kid, no birthdate)
 * - `kids=2010-10-30` (1 kid, with birthdate)
 * - `kids=_` (2 kids)
 * - `kids=2010-10-30=_` (2 kids, 1 birthdate)
 * - `kids=2010-10-30c=___`
 * - `kids=2010-10-30c_2009-04-01!`
 */


var serializeKidsToQueryParam = function serializeKidsToQueryParam(params) {
  var kids = params.kids,
      kidsValidationState = params.kidsValidationState;
  var serializedKids = kids.map(function (_ref, index) {
    var birthdate = _ref.birthdate;

    if (!birthdate || !kidsValidationState || kidsValidationState[index] !== _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* VALIDATION_STATE_ENUM */ "f"].valid) {
      return '';
    }

    var formattedBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate).format(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DATE_FORMAT */ "e"]);
    return formattedBirthdate;
  }).filter(function (birthdate) {
    return birthdate !== '';
  }); // Special case when there is only one kid, as we can't make a join('_') with only one item

  var serializedOutput = '';

  if (serializedKids.length === 1) {
    if (serializedKids.filter(Boolean).length === 0) {
      serializedOutput = '1';
    } // Return kid's birthdate


    if (serializedOutput !== '1') {
      serializedOutput = serializedKids.shift();
    }

    var childcareIncluded = kids.some(function (kid) {
      return kid.childcareIncluded;
    });

    if (childcareIncluded) {
      serializedOutput = "".concat(serializedOutput).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"]);
    }

    return serializedOutput;
  }

  return serializedKids.join(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_KIDS_DELIMITER */ "i"]);
};
var getKidAgeInMonths = function getKidAgeInMonths(_ref2) {
  var birthdate = _ref2.birthdate,
      departureDate = _ref2.departureDate;
  var defaultDepartureDate = moment__WEBPACK_IMPORTED_MODULE_2___default()().add(_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH */ "k"], 'months').valueOf();
  var b = birthdate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate) : moment__WEBPACK_IMPORTED_MODULE_2___default()().subtract(8, 'y');
  return moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate || defaultDepartureDate).diff(b, 'months');
};


/***/ }),

/***/ "kWb8":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"Agrave\":\"À\",\"agrave\":\"à\",\"amp\":\"&\",\"AMP\":\"&\",\"Aring\":\"Å\",\"aring\":\"å\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"brvbar\":\"¦\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"cedil\":\"¸\",\"cent\":\"¢\",\"copy\":\"©\",\"COPY\":\"©\",\"curren\":\"¤\",\"deg\":\"°\",\"divide\":\"÷\",\"Eacute\":\"É\",\"eacute\":\"é\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"Egrave\":\"È\",\"egrave\":\"è\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"frac12\":\"½\",\"frac14\":\"¼\",\"frac34\":\"¾\",\"gt\":\">\",\"GT\":\">\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"iexcl\":\"¡\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"iquest\":\"¿\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"laquo\":\"«\",\"lt\":\"<\",\"LT\":\"<\",\"macr\":\"¯\",\"micro\":\"µ\",\"middot\":\"·\",\"nbsp\":\" \",\"not\":\"¬\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ordf\":\"ª\",\"ordm\":\"º\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"para\":\"¶\",\"plusmn\":\"±\",\"pound\":\"£\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"raquo\":\"»\",\"reg\":\"®\",\"REG\":\"®\",\"sect\":\"§\",\"shy\":\"­\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"szlig\":\"ß\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"times\":\"×\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uml\":\"¨\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"yen\":\"¥\",\"yuml\":\"ÿ\"}");

/***/ }),

/***/ "kWbI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTrackQueryChange; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("RPju");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sRdV");
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("zwLB");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var useTrackQueryChange = function useTrackQueryChange() {
  var pageContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_2__[/* ReactPageContext */ "a"]);
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_3__[/* useTracking */ "a"])();

  var executeTracking = function executeTracking(query, payload) {
    if (query) {
      var isFromAutoComplete = Boolean(query.type);
      track(_objectSpread({
        categoryGA: pageContext.pageId,
        actionGA: 'search',
        labelGA: Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_4__[/* getSearchMappedTypeForLabelGA */ "c"])(query.type),
        internalSearchEngineNbResults: '',
        searchReferrer: pageContext.pageId,
        searchRequestType: isFromAutoComplete ? 'Autocomplete' : 'Nocomplete',
        searchTerms: query.label || null
      }, payload));
    }
  };

  return executeTracking;
};

/***/ }),

/***/ "kekF":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "l5FB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["a"] = (/*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({
  departureCities: [],
  setDepartureCities: function setDepartureCities() {}
}));

/***/ }),

/***/ "l9OW":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("SKAX"),
    isArrayLike = __webpack_require__("MMmD");

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ "lQqw":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("MMmD");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ "lZ21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOMMODATION_COMFORT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORRESPONDANCE_ROOM_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ROOM_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VILLETA_ROOM_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORRESPONDENCE_CABIN_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CABIN_TYPE; });
/**
 * @see src/components/utils/icon/icons.js l40
 */
var ACCOMMODATION_COMFORT_ORDER = ['000017', // club
'000048', // club seaside view
'000061', // superior
'000018', // deluxe
'000039', // deluxe zen
'000047', // deluxe seaside view
'000056', // Deluxe Exclusive
'000019', // suite
'000020' // suite 5 tridents
];
var SINGLE_ROOM = 'simpleRoom';
var SEPARATE_ROOMS = 'separatedRooms';
var CONNECTING_ROOMS = 'simpleRooms';
var SEPARATE_ROOMS_3 = 'separatedRooms3';
var CORRESPONDANCE_ROOM_TYPE = {
  SINGLE_ROOM: SINGLE_ROOM,
  SEPARATE_ROOMS: SEPARATE_ROOMS,
  CONNECTING_ROOMS: CONNECTING_ROOMS,
  SEPARATE_ROOMS_3: SEPARATE_ROOMS
};
var CORRESPONDENCE_CABIN_TYPE = {
  SINGLE_ROOM: 'simpleCabin',
  SEPARATE_ROOMS: 'separatedCabins',
  CONNECTING_ROOMS: 'simpleCabins',
  SEPARATE_ROOMS_3: 'separatedCabins'
};
var ROOM_TYPE = {
  SINGLE_ROOM: SINGLE_ROOM,
  SEPARATE_ROOMS: SEPARATE_ROOMS,
  CONNECTING_ROOMS: CONNECTING_ROOMS,
  SEPARATE_ROOMS_3: SEPARATE_ROOMS_3
};
var CABIN_TYPE = {
  SINGLE_ROOM: 'simpleCabin',
  SEPARATE_ROOMS: 'separatedCabins',
  CONNECTING_ROOMS: 'simpleCabins',
  SEPARATE_ROOMS_3: 'separatedCabins3'
};
var VILLETA_ROOM_REGEX = new RegExp(/^(B2|B2\+|B2T)+$/);


/***/ }),

/***/ "lm/5":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("fmRc"),
    baseIsEqual = __webpack_require__("wF/u");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ "loSl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return toggleFacet; });
/* unused harmony export changeKids */
/* unused harmony export changeKidsNumberWith */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeKidsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeDepartureCity; });
/* unused harmony export changeDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setInitialProductPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setKidsValidationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetRedirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resetSearch; });
/* unused harmony export setFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return updateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resetCriteria; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return resetCalendarCriteria; });
/* unused harmony export setIsDateRequired */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setIsSearchEnabled; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("uDfI");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rJ95");
/* harmony import */ var _search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("0ibg");
/* harmony import */ var _search_search_selector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("B3yO");
/* harmony import */ var _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("wQ38");
/* harmony import */ var _trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("1bWg");
/* harmony import */ var _trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("fflk");
/* harmony import */ var _trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+mhw");
/* harmony import */ var _trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("6wD6");
/* harmony import */ var _trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("C5R2");
/* harmony import */ var _trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("RBvG");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Jsmy");
/* harmony import */ var _faceting_selector__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("vIa8");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("9QcM");





function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

















function setActiveFacet(categoryId, value, isSelected) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_TOGGLE_FACET_SELECTED */ "p"], {
    categoryId: categoryId,
    value: value,
    isSelected: isSelected
  });
}

function toggleFacet(_ref) {
  var categoryId = _ref.categoryId,
      isSelected = _ref.isSelected,
      value = _ref.value;
  return setActiveFacet(categoryId, value, isSelected);
}
function changeKids(value) {
  return function (dispatch, getState) {
    var oldKids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__[/* getKids */ "c"])(getState());
    var newKids = value.map(function (kid, index) {
      return _objectSpread(_objectSpread({}, kid), {}, {
        neolid: Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(oldKids, "[".concat(index, "].neolid"))
      });
    });
    return dispatch(Object(_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_10__[/* setKids */ "b"])(newKids));
  };
}

function _changeKidsSize(kids, newSize) {
  var emptyKids = Object(lodash__WEBPACK_IMPORTED_MODULE_4__["times"])(newSize - kids.length, function () {
    return _objectSpread({}, _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_9__[/* DEFAULT_KID_VALUE */ "a"]);
  });

  if (newSize < kids.length) {
    return kids.slice(0, newSize);
  }

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(kids), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(emptyKids));
} // use this export when testing.


var changeKidsNumberWith = function changeKidsNumberWith(changeKidsFunc) {
  return function changeKidsNumber(value) {
    return function (dispatch, getState) {
      var kids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__[/* getKids */ "c"])(getState());

      var newKids = _changeKidsSize(kids, value);

      return dispatch(changeKidsFunc(newKids));
    };
  };
}; // use this export in app code.

var changeKidsNumber = changeKidsNumberWith(changeKids);
function changeDepartureCity(value) {
  return Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_12__[/* setDepartureCity */ "a"])({
    value: value
  });
}
function changeDepartureDate(_ref2) {
  var value = _ref2.value;
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(value);
}
var clearDepartureDate = function clearDepartureDate() {
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(null);
};
var setSearchQuery = function setSearchQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    label: ''
  };
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_SEARCH_QUERY */ "o"], {
    value: query
  });
};
function clearTripDuration() {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEFAULT_NO_DURATION */ "a"]);
}
function changeSearchQuery(value) {
  return function (dispatch, getState) {
    var store = getState();
    var keywords = Object(_search_search_selector__WEBPACK_IMPORTED_MODULE_8__[/* keywordsSelector */ "a"])(store);
    var searchQuery = Object(_faceting_selector__WEBPACK_IMPORTED_MODULE_17__[/* searchQuerySelector */ "m"])(getState());
    Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* batch */ "b"])(function () {
      if (keywords) {
        dispatch(Object(_search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_7__[/* setKeywords */ "a"])(''));
      }

      if (searchQuery.label !== value.label) {
        dispatch(setSearchQuery(value));
      }
    });
  };
}
function changeTripDuration(value) {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(value);
}
function setInitialProductPrices(initialProductPrices) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_INITIAL_PRICES */ "j"], {
    initialProductPrices: initialProductPrices
  });
}
function setKidsValidationState(kidsValidationState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_KIDS_VALIDATION_STATE */ "m"], {
    kidsValidationState: kidsValidationState
  });
}
function clearFacets(categoryId) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_CLEAR_FACETS */ "b"], {
    categoryId: categoryId
  });
}
function resetRedirection() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_RESET_REDIRECTION */ "f"]);
}
function resetSearch() {
  return /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_RESET_SEARCH */ "g"])));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
}
function setFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_FILTERS */ "i"], {
    filters: filters
  });
}
function updateFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_UPDATE_FILTERS */ "s"], {
    filters: filters
  });
}
function resetCriteria() {
  return /*#__PURE__*/function () {
    var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* batch */ "b"])(function () {
                dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(null));
                dispatch(Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_12__[/* setDepartureCity */ "a"])({
                  value: null
                }));
                dispatch(Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEFAULT_NO_DURATION */ "a"]));
                dispatch(updateFilters([]));
                dispatch(setSearchQuery({
                  label: ''
                }));
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
}
function resetCalendarCriteria() {
  return /*#__PURE__*/function () {
    var _ref5 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee3(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* batch */ "b"])(function () {
                dispatch(Object(_trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_13__[/* updateTripDateCriteria */ "a"])({
                  day: null
                }));
                dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(null));
                dispatch(Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEFAULT_NO_DURATION */ "a"]));
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
}
function setIsDateRequired(isDateRequired) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_IS_DATE_REQUIRED */ "k"], {
    isDateRequired: isDateRequired
  });
}
function setIsSearchEnabled(isSearchEnabled) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_IS_SEARCH_ENABLED */ "l"], {
    isSearchEnabled: isSearchEnabled
  });
}

/***/ }),

/***/ "lvO4":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),

/***/ "m9Sl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ENTRY_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNSET_ENTRY_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return entryRouteReducer; });
var SET_ENTRY_ROUTE = 'SET_ENTRY_ROUTE';
var UNSET_ENTRY_ROUTE = 'UNSET_ENTRY_ROUTE';
var initialState = '';
var entryRouteReducer = function entryRouteReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_ENTRY_ROUTE:
      return action.payload;

    case UNSET_ENTRY_ROUTE:
      return initialState;

    default:
      return state;
  }
};

/***/ }),

/***/ "mc0g":
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "mdPL":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("WFqU");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("EIeC")(module)))

/***/ }),

/***/ "mv/X":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("ljhN"),
    isArrayLike = __webpack_require__("MMmD"),
    isIndex = __webpack_require__("wJg7"),
    isObject = __webpack_require__("GoyQ");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "ngAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useDebounce; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // Our hook

function useDebounce(values, delay) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(values),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(values);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, values);
  return debouncedValue;
}

/***/ }),

/***/ "nnm9":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "nvU9":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("tQYX"),
    isSymbol = __webpack_require__("a88S");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "oG87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorBoundary; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("aPQG");






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(ErrorBoundary, [{
    key: "componentDidCatch",
    // eslint-disable-next-line class-methods-use-this
    value: function componentDidCatch(error, info) {
      Object(_errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_6__[/* handleComponentError */ "a"])(error, info);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError && !this.props.useNativeErrorHandling) {
        return null;
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_5___default.a.Component);

/***/ }),

/***/ "oL6k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildTransportKey */
/* unused harmony export getAccommodationComfortIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAdultsCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getPackage; });
/* unused harmony export getCurrency */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getRONPackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getKidsCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getFormattedArrivalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getFormattedDepartureDate; });
/* unused harmony export hasAllInclusive */
/* unused harmony export hasChildren */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return hasChildcare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return hasTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getTotalPriceFormatted; });
/* unused harmony export hasTransport */
/* unused harmony export isTransportATrain */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isCharterFlight; });
/* unused harmony export isDateAfterOptionRange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isOptionAllowed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return isRecommendedTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return saveRecommendedTransport; });
/* unused harmony export getArrivalDate */
/* unused harmony export getTripArrival */
/* unused harmony export getTripDeparture */
/* unused harmony export hasAccomodation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compareAccommodationsByComfort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compareProposalsByComfort; });
/* unused harmony export getNbParticipants */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return hasErroredProposals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return hasFetchProposalsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getResolvedProposals; });
/* unused harmony export getSelectedProposal */
/* unused harmony export getSelectedProposalById */
/* unused harmony export getStockWarning */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getTotalValue; });
/* unused harmony export getFormatedPrice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFormatedPriceByLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getPriceDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return hasTransportOrTransferSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDefaultProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return isPremiumAccommodation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getComparatorErrorMessage; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _client_local_storage_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1RIK");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ldK3");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("lZ21");
/* harmony import */ var _booking_process_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("XpIN");
/* harmony import */ var _label_labelUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("WGoB");
/* harmony import */ var _currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("wz9x");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("tI+f");










var OPTIONS_DAYS_RANGE = 29;
var DEFAULT_STOCK_WARNING_LIMIT = 2;
var TWO_WEEKS_IN_MS = 14 * 24 * 3600 * 1000;

function getAccommodationComfortIndex(accommodation) {
  return _accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_5__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(accommodation, 'categoryId'));
}

function compareProposalsByComfort(proposal1, proposal2) {
  var proposal1Index = getAccommodationComfortIndex(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal1, 'accommodations[0]'));
  var proposal2Index = getAccommodationComfortIndex(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal2, 'accommodations[0]')); // if we have not sorted the accommodation we don't change the order returned by the api

  if (proposal1Index === -1 || proposal2Index === -1) {
    return 0;
  }

  return proposal1Index - proposal2Index;
}

function compareAccommodationsByComfort(accommodation1, accommodation2) {
  return getAccommodationComfortIndex(accommodation1) - getAccommodationComfortIndex(accommodation2);
}

function isCharterFlight(cancellationPolicy) {
  return [_booking_process_constants__WEBPACK_IMPORTED_MODULE_6__[/* LEGAL_INFO_THEO_ID */ "b"], _booking_process_constants__WEBPACK_IMPORTED_MODULE_6__[/* LEGAL_INFO_WEBTHEO_ID */ "c"]].includes(cancellationPolicy);
}

function isDateAfterOptionRange(date) {
  return date && date.isValid() && date.diff(moment__WEBPACK_IMPORTED_MODULE_1___default()(), 'days') >= OPTIONS_DAYS_RANGE;
}

function isOptionAllowed(proposal) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'optionAvailable');
}

function getAdultsCount(proposal) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'adultsCount', 1);
}

function getCurrency(proposal) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'price.currency');
}

function getKidsCount(proposal) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'childrenCount', 0);
}

function getTotalPriceFormatted(proposal) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'price.total.formattedValue');
}

function getArrivalDate(proposal) {
  return Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_3__[/* momentFromApiDate */ "h"])(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'arrivalDate'));
}

function getTripDeparture(proposal) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'transports.inbound.travelSections[0].departure.label', '');
}

function getTripArrival(proposal) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'transports.outbound.travelSections[0].departure.label', '');
}

function hasChildren(proposal) {
  return getKidsCount(proposal) > 0;
}

function hasChildcare(proposal) {
  return proposal.additionalServices.childcares.length > 0;
}

function hasAllInclusive(proposal) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'packageId') === _constants__WEBPACK_IMPORTED_MODULE_9__[/* PACKAGE_ALL_INCLUSIVE */ "f"];
}

function getFormattedDate(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD MMMM YYYY';
  return Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_3__[/* momentFromApiDate */ "h"])(date).format(dateFormat);
}

function getFormattedArrivalDate(proposal, dateFormat) {
  return getFormattedDate(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'arrivalDate'), dateFormat);
}

function getFormattedDepartureDate(proposal, dateFormat) {
  return getFormattedDate(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'departureDate'), dateFormat);
}

function getRONPackage(proposal) {
  var packages = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'packages') || [];
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["find"])(packages, function (pkg) {
    return pkg.id === _constants__WEBPACK_IMPORTED_MODULE_9__[/* PACKAGE_ROOM_ONLY */ "h"];
  });
}

function getPackage(proposal, packageId) {
  var packages = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'packages') || [];
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["find"])(packages, function (pkg) {
    return pkg.id === packageId;
  });
}

function hasTransport(proposal) {
  return !!Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'transports');
}

function hasTransfer(proposal) {
  return hasTransport(proposal) || !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'additionalServices.transfers'));
}

function hasTransportOrTransferSelected(proposal) {
  return hasTransport(proposal) || !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])((proposal.additionalServices.transfers || []).filter(function (transfer) {
    return transfer.pricingInfo.isFullyRented;
  }));
}

function isTransportATrain(proposal) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'transports.inbound.travelSections[0].transport.type') === 'TRAIN' && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'transports.outbound.travelSections[0].transport.type') === 'TRAIN';
}

function hasAccomodation(proposal) {
  return !!Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'accommodations.length');
}

function getResolvedProposals(proposals) {
  return proposals.filter(function (p) {
    return !p.errorCode;
  });
}

function hasErroredProposals(proposals) {
  return proposals.some(function (p) {
    return p.errorCode;
  });
}

function hasFetchProposalsFailed(_ref) {
  var errors = _ref.errors,
      proposals = _ref.proposals;
  return errors && errors.length > 0 || hasErroredProposals(proposals) || !proposals || proposals.length === 0 || proposals.some(function (proposal) {
    return proposal.price.gap > _constants__WEBPACK_IMPORTED_MODULE_9__[/* PRICE_COUNTER_PROPOSAL_THRESHOLD */ "i"];
  });
}

function getSelectedProposal(proposals, selectedProposalIndex) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["nth"])(proposals, selectedProposalIndex);
}

function getSelectedProposalById(proposals, selectedProposalId) {
  return proposals.find(function (proposal) {
    return proposal.id === selectedProposalId;
  }) || proposals[0];
}

function getStockWarning(i18n, remainingStock) {
  return {
    showStockWarning: remainingStock <= Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(i18n, 'stockWarningLimit', DEFAULT_STOCK_WARNING_LIMIT),
    stockWarning: "".concat(remainingStock, " ").concat(Object(_label_labelUtils__WEBPACK_IMPORTED_MODULE_7__[/* pluralizeLabel */ "d"])(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(i18n, 'room', ''), Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(i18n, 'rooms', ''), remainingStock))
  };
}

function getNbParticipants(proposal) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'adultsCount', 0) + Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'childrenCount', 0);
}

function getTotalValue(proposal) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'price.total.value', 0);
}

function getFormatedPrice(formatedPrice, amount) {
  if (amount === 0) {
    return "".concat(formatedPrice);
  }

  return amount > 0 ? "+".concat(formatedPrice) : "-".concat(formatedPrice);
}

function getFormatedPriceByLocale(price, locale, currency) {
  return getFormatedPrice(Object(_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_8__[/* formatAmountForLocale */ "b"])(Math.abs(price), locale, currency), price);
}

function getPriceDiff(proposalPrice, selectedProposalPrice, locale, currency) {
  var diffPrice = proposalPrice - selectedProposalPrice;
  return diffPrice === 0 ? null : getFormatedPriceByLocale(diffPrice, locale, currency);
}

var getDefaultProposal = function getDefaultProposal(proposals, resort) {
  /**
   * There is a random corner case that make selectedProposal as undefined
   * It should be the default one (mainly the first one).
   * Maybe proposals array is empty at some point...
   * Unable to reproduce the bug... See BookingEngine.container
   */
  var firstProposal = proposals[0] || {};

  if (resort && resort.id === _constants__WEBPACK_IMPORTED_MODULE_9__[/* CEFALU_RESORT */ "a"]) {
    var deluxeProposal = proposals.find(function (proposal) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(proposal, 'accommodations[0].comfortType') === _constants__WEBPACK_IMPORTED_MODULE_9__[/* DELUXE_COMFORT */ "e"];
    });
    return deluxeProposal ? deluxeProposal : firstProposal;
  }

  return firstProposal;
};

var isPremiumAccommodation = function isPremiumAccommodation(accommodation) {
  return !!(accommodation.comfortId && [_constants__WEBPACK_IMPORTED_MODULE_9__[/* COMFORT_TYPE_SUITE */ "c"], _constants__WEBPACK_IMPORTED_MODULE_9__[/* COMFORT_TYPE_CHALET */ "b"], _constants__WEBPACK_IMPORTED_MODULE_9__[/* COMFORT_TYPE_VILLA */ "d"]].includes(accommodation.comfortId));
};

function buildJourneyKey(journey) {
  return journey.travelSections.map(function (section) {
    var _section$transport, _section$transport2, _section$transport2$c, _section$departure, _section$departure2, _section$departure3, _section$arrival, _section$arrival2, _section$arrival3;

    var transportClass = (_section$transport = section.transport) === null || _section$transport === void 0 ? void 0 : _section$transport["class"];
    var company = "".concat(transportClass).concat((_section$transport2 = section.transport) === null || _section$transport2 === void 0 ? void 0 : (_section$transport2$c = _section$transport2.companyOperator) === null || _section$transport2$c === void 0 ? void 0 : _section$transport2$c.id);
    return "".concat((_section$departure = section.departure) === null || _section$departure === void 0 ? void 0 : _section$departure.id).concat((_section$departure2 = section.departure) === null || _section$departure2 === void 0 ? void 0 : _section$departure2.date).concat((_section$departure3 = section.departure) === null || _section$departure3 === void 0 ? void 0 : _section$departure3.time, "-").concat((_section$arrival = section.arrival) === null || _section$arrival === void 0 ? void 0 : _section$arrival.id).concat((_section$arrival2 = section.arrival) === null || _section$arrival2 === void 0 ? void 0 : _section$arrival2.date).concat((_section$arrival3 = section.arrival) === null || _section$arrival3 === void 0 ? void 0 : _section$arrival3.time, "-").concat(company);
  }).join(':');
}

var buildTransportKey = function buildTransportKey(transport) {
  return "".concat(buildJourneyKey(transport.inbound), "/").concat(buildJourneyKey(transport.outbound));
};

var isRecommendedTransport = function isRecommendedTransport(transport, proposalId) {
  return buildTransportKey(transport) === Object(_client_local_storage_api__WEBPACK_IMPORTED_MODULE_2__[/* getFromLocalStorage */ "a"])("recommendedTransport-".concat(proposalId));
};

var saveRecommendedTransport = function saveRecommendedTransport(transport, proposalId) {
  var localStorageKey = "recommendedTransport-".concat(proposalId);

  if (!Object(_client_local_storage_api__WEBPACK_IMPORTED_MODULE_2__[/* getFromLocalStorage */ "a"])(localStorageKey)) {
    Object(_client_local_storage_api__WEBPACK_IMPORTED_MODULE_2__[/* setInLocalStorage */ "d"])(localStorageKey, buildTransportKey(transport), {
      ttl: TWO_WEEKS_IN_MS
    });
  }
};

var getComparatorErrorMessage = function getComparatorErrorMessage(errorCode) {
  var errorToMessageMapper = {
    NOT_ON_SALE_FOR_THE_PERIOD: Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('booking.accommodation.errorMessages.calendar.resortNotOnSale'),
    INVALID_PRODUCT_ID: Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('booking.accommodation.errorMessages.calendar.resortNotOnSale'),
    NO_TRANSPORT: Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('booking.accommodation.errorMessages.noTransport'),
    NO_ACCOMODATION: Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('booking.accommodation.errorMessages.noAccommodation'),
    UNAVAILABLE_FOR_BIRTHDATES: Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('booking.accommodation.errorMessages.ageIncorrectOrUnauthorized'),
    INVALID_BOOKING_CRITERIA: Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('booking.accommodation.errorMessages.invalidBookingCriteria'),
    NO_PROPOSAL: Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('booking.accommodation.errorMessages.noProposalAvailable'),
    TECHNICAL_ERROR: Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('booking.accommodation.errorMessages.technicalError')
  };
  return errorToMessageMapper[Object(lodash__WEBPACK_IMPORTED_MODULE_0__["snakeCase"])(errorCode).toUpperCase()] || Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('productsComparison.resortNotAvailable');
};



/***/ }),

/***/ "oW49":
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__("8PLQ"),
    legacyMap = __webpack_require__("kWb8"),
    xmlMap    = __webpack_require__("ZLJe"),
    decodeCodePoint = __webpack_require__("cHMM");

var decodeXMLStrict  = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map){
	var keys = Object.keys(map).join("|"),
	    replace = getReplacer(map);

	keys += "|#[xX][\\da-fA-F]+|#\\d+";

	var re = new RegExp("&(?:" + keys + ");", "g");

	return function(str){
		return String(str).replace(re, replace);
	};
}

var decodeHTML = (function(){
	var legacy = Object.keys(legacyMap)
		.sort(sorter);

	var keys = Object.keys(entityMap)
		.sort(sorter);

	for(var i = 0, j = 0; i < keys.length; i++){
		if(legacy[j] === keys[i]){
			keys[i] += ";?";
			j++;
		} else {
			keys[i] += ";";
		}
	}

	var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	    replace = getReplacer(entityMap);

	function replacer(str){
		if(str.substr(-1) !== ";") str += ";";
		return replace(str);
	}

	//TODO consider creating a merged map
	return function(str){
		return String(str).replace(re, replacer);
	};
}());

function sorter(a, b){
	return a < b ? 1 : -1;
}

function getReplacer(map){
	return function replace(str){
		if(str.charAt(1) === "#"){
			if(str.charAt(2) === "X" || str.charAt(2) === "x"){
				return decodeCodePoint(parseInt(str.substr(3), 16));
			}
			return decodeCodePoint(parseInt(str.substr(2), 10));
		}
		return map[str.slice(1, -1)];
	};
}

module.exports = {
	XML: decodeXMLStrict,
	HTML: decodeHTML,
	HTMLStrict: decodeHTMLStrict
};

/***/ }),

/***/ "ogu6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOAD_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOADING_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOADING_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOAD_SELECTABLE_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOADING_SELECTABLE_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPLETE_INTRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_ROOM_SELECTION_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SELECT_BUILDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SELECT_FLOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SELECT_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HIGHLIGHT_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CUSTOMER_FIDELITY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return reducer; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_widgets_cart_bookingCart_reducer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("xl1w");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var initialState = {
  completedIntro: false,
  resort: null,
  stayWithVendor: null,
  selectableRooms: [],
  selectableRoomsUnitPrice: null,
  currentSelectedRoomIndex: null,
  currentSelectableRoomIds: [],
  currentSelectableFloorIds: [],
  currentSelectableBuildingIds: [],
  filteredBuildings: [],
  selectedBuildingId: null,
  filteredFloors: [],
  selectedFloorId: null,
  filteredRoomsForCurrentFloor: [],
  filteredRooms: [],
  selectedRooms: [],
  numRoomsLeftToPick: null,
  highlightedRoom: null,
  isLoadingResort: false,
  isLoadingSelectableRooms: false,
  resortPYRMail: null,
  errors: null,
  roomsInCart: []
};
var LOAD_RESORT = 'LOAD_RESORT';
var LOADING_ERROR = 'LOADING_ERROR';
var LOADING_RESORT = 'LOADING_RESORT';
var LOAD_SELECTABLE_ROOMS = 'LOAD_SELECTABLE_ROOMS';
var LOADING_SELECTABLE_ROOMS = 'LOADING_SELECTABLE_ROOMS';
var COMPLETE_INTRO = 'COMPLETE_INTRO';
var SET_ROOM_SELECTION_INDEX = 'SET_ROOM_SELECTION_INDEX';
var SELECT_BUILDING = 'SELECT_BUILDING';
var SELECT_FLOOR = 'SELECT_FLOOR';
var SELECT_ROOM = 'SELECT_ROOM';
var HIGHLIGHT_ROOM = 'HIGHLIGHT_ROOM';
var CUSTOMER_FIDELITY_STATUS = 'CUSTOMER_FIDELITY_STATUS';

function getResortFeatures(state) {
  return state.resort && state.resort.rooms_geo_json.features || [];
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case CUSTOMER_FIDELITY_STATUS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          fidelityStatus: action.payload
        });
      }

    case LOADING_RESORT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingResort: true
        });
      }

    case LOADING_ERROR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingResort: false
        });
      }

    case LOAD_RESORT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          resort: action.payload,
          isLoadingResort: false
        });
      }

    case LOADING_SELECTABLE_ROOMS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingSelectableRooms: true
        });
      }

    case LOAD_SELECTABLE_ROOMS:
      {
        var _action$payload = action.payload,
            stayWithVendor = _action$payload.stayWithVendor,
            roomSelectionServices = _action$payload.roomSelectionServices,
            errors = _action$payload.errors,
            resortPYRMail = _action$payload.resortPYRMail;
        var selectableRooms = (roomSelectionServices || []).reduce(function (acc, roomSelectionService) {
          return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(new Array(roomSelectionService.quantity).fill(_objectSpread(_objectSpread({}, roomSelectionService.accommodations[0]), {}, {
            _serviceId: roomSelectionService.id,
            _unitPrice: roomSelectionService.unit_price
          }))));
        }, []);

        if (state.roomsInCart.length > 0) {
          var selectedRooms = state.roomsInCart.map(function (roomId) {
            return getResortFeatures(state).find(function (geoRoom) {
              return geoRoom.properties.id === roomId;
            });
          });
          return _objectSpread(_objectSpread({}, state), {}, {
            isLoadingSelectableRooms: false,
            stayWithVendor: stayWithVendor,
            selectableRooms: selectableRooms,
            errors: errors,
            resortPYRMail: resortPYRMail,
            selectedRooms: selectedRooms,
            numRoomsLeftToPick: selectableRooms.length - selectedRooms.length,
            highlightedRoom: null
          });
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingSelectableRooms: false,
          stayWithVendor: stayWithVendor,
          selectableRooms: selectableRooms,
          numRoomsLeftToPick: selectableRooms.length,
          errors: errors,
          resortPYRMail: resortPYRMail
        });
      }

    case COMPLETE_INTRO:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          completedIntro: true
        });
      }

    case SET_ROOM_SELECTION_INDEX:
      {
        var roomIndex = action.payload.roomIndex;
        var features = getResortFeatures(state);

        if (typeof roomIndex === 'undefined' || roomIndex === null) {
          return _objectSpread(_objectSpread({}, state), {}, {
            currentSelectedRoomIndex: null,
            currentSelectableRoomIds: [],
            currentSelectableFloorIds: [],
            currentSelectableBuildingIds: [],
            filteredBuildings: [],
            selectedBuildingId: null,
            filteredFloors: [],
            selectedFloorId: null,
            filteredRoomsForCurrentFloor: [],
            filteredRooms: []
          });
        }

        var isRoomSelected = function isRoomSelected(roomId) {
          return state.selectedRooms.some(function (selectedRoomItem) {
            return selectedRoomItem && selectedRoomItem.properties.id === roomId;
          });
        }; // collect all ids for the current selectable room


        var currentSelectableRoomIds = state.selectableRooms[roomIndex].rooms.map(function (room) {
          return room.id;
        }).filter(function (roomId) {
          return !isRoomSelected(roomId);
        }); // collect properties and geometries for those rooms

        var currentSelectableRooms = features.filter(function (room) {
          return currentSelectableRoomIds.indexOf(room.properties.id) > -1;
        }); // collect properties and geometries for those rooms
        // $FlowFixMe

        var currentSelectableFloorIds = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["uniq"])(currentSelectableRooms.map(function (room) {
          return room.properties.floor_id;
        })); // collect all building ids that contain those floors
        // $FlowFixMe

        var currentSelectableBuildingIds = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["uniq"])((state.resort && state.resort.floors || []).filter(function (floor) {
          return currentSelectableFloorIds.indexOf(floor.id) > -1;
        }).map(function (floor) {
          return floor.building_id;
        }));
        var filteredBuildings = (state.resort && state.resort.buildings || []).filter(function (building) {
          return currentSelectableBuildingIds.indexOf(building.id) > -1;
        });

        if (filteredBuildings.length === 0) {
          _logger__WEBPACK_IMPORTED_MODULE_3___default.a.warn('SET_ROOM_SELECTION_INDEX no building found for building.id', 'currentSelectableBuildingIds:', currentSelectableBuildingIds, 'state.resort.buildings:', state.resort && state.resort.buildings);
          _logger__WEBPACK_IMPORTED_MODULE_3___default.a.warn('currentSelectableBuildingIds:', currentSelectableBuildingIds, 'currentSelectableFloorIds:', currentSelectableFloorIds, 'currentSelectableRooms:', currentSelectableRooms, 'currentSelectableRoomIds:', currentSelectableRoomIds);
        }

        var filteredRooms = features.filter(function (room) {
          return currentSelectableRoomIds.indexOf(room.properties.id) > -1;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          currentSelectedRoomIndex: roomIndex,
          currentSelectableRoomIds: currentSelectableRoomIds,
          currentSelectableFloorIds: currentSelectableFloorIds,
          currentSelectableBuildingIds: currentSelectableBuildingIds,
          filteredBuildings: filteredBuildings,
          selectedBuildingId: null,
          filteredFloors: [],
          selectedFloorId: null,
          filteredRoomsForCurrentFloor: [],
          filteredRooms: filteredRooms
        });
      }

    case SELECT_BUILDING:
      {
        var buildingId = action.payload.buildingId;
        var filteredFloors = (state.resort && state.resort.floors || []).filter(function (floor) {
          return state.currentSelectableFloorIds.indexOf(floor.id) > -1 && floor.building_id === buildingId;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedBuildingId: buildingId,
          filteredFloors: filteredFloors
        });
      }

    case SELECT_FLOOR:
      {
        var floorId = action.payload.floorId;
        var filteredRoomsForCurrentFloor = getResortFeatures(state).filter(function (room) {
          return state.currentSelectableRoomIds.indexOf(room.properties.id) > -1 && room.properties.floor_id === floorId;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedFloorId: floorId,
          filteredRoomsForCurrentFloor: filteredRoomsForCurrentFloor
        });
      }

    case SELECT_ROOM:
      {
        var roomId = action.payload.roomId;

        var selectedRoom = _objectSpread({}, getResortFeatures(state).find(function (geoRoom) {
          return geoRoom.properties.id === roomId;
        }));

        var _selectedRooms = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(state.selectedRooms);

        if (state.currentSelectedRoomIndex || state.currentSelectedRoomIndex === 0) {
          _selectedRooms[state.currentSelectedRoomIndex] = selectedRoom;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          selectedRooms: _selectedRooms,
          numRoomsLeftToPick: state.selectableRooms.length - _selectedRooms.filter(function (r) {
            return r !== undefined;
          }).length,
          highlightedRoom: null
        });
      }

    case HIGHLIGHT_ROOM:
      {
        var _roomId = action.payload.roomId;
        var highlightedRoom = _roomId === undefined ? null : _objectSpread({}, getResortFeatures(state).find(function (room) {
          return room.properties.id === _roomId;
        }));
        return _objectSpread(_objectSpread({}, state), {}, {
          highlightedRoom: highlightedRoom
        });
      }

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_4__["resolve"])(_components_widgets_cart_bookingCart_reducer__WEBPACK_IMPORTED_MODULE_5__[/* FETCH_BOOKING_CART */ "a"]):
      {
        var payload = action.payload;
        var roomIds = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(payload, 'userBooking.cart.pickRoom', []).reduce(function (acc, srv) {
          return acc.concat(srv.accommodations.reduce(function (r, a) {
            return r.concat(a.rooms.map(function (_ref) {
              var id = _ref.id;
              return id;
            }));
          }, []));
        }, []);

        if (getResortFeatures(state).length === 0) {
          return _objectSpread(_objectSpread({}, state), {}, {
            roomsInCart: roomIds
          });
        } else {
          var _selectedRooms2 = roomIds.map(function (roomId) {
            return getResortFeatures(state).find(function (geoRoom) {
              return geoRoom.properties.id === roomId;
            });
          });

          return _objectSpread(_objectSpread({}, state), {}, {
            selectedRooms: _selectedRooms2,
            numRoomsLeftToPick: state.selectableRooms.length - _selectedRooms2.length,
            highlightedRoom: null
          });
        }
      }

    default:
      {
        return state;
      }
  }
}

/***/ }),

/***/ "or5M":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("1hJj"),
    arraySome = __webpack_require__("QoRX"),
    cacheHas = __webpack_require__("xYSL");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "oweP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("aWzz");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("R6jJ");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("s5tn");
/* harmony import */ var _medium__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("7LZv");







function MoveFocusInside(_ref) {
  var isDisabled = _ref.disabled,
      className = _ref.className,
      children = _ref.children;
  var ref = react__WEBPACK_IMPORTED_MODULE_1___default.a.useRef(null);
  var disabled = react__WEBPACK_IMPORTED_MODULE_1___default.a.useRef(isDisabled);

  var moveFocus = function moveFocus() {
    var observed = ref.current;
    _medium__WEBPACK_IMPORTED_MODULE_5__[/* mediumEffect */ "b"].useMedium(function (car) {
      if (!disabled.current && observed) {
        if (!car.focusInside(observed)) {
          car.moveFocusInside(observed, null);
        }
      }
    });
  };

  react__WEBPACK_IMPORTED_MODULE_1___default.a.useEffect(function () {
    disabled.current = isDisabled;
    moveFocus();
  }, [isDisabled]);
  return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, Object(_util__WEBPACK_IMPORTED_MODULE_4__[/* inlineProp */ "b"])(focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__[/* FOCUS_AUTO */ "b"], !isDisabled), {
    ref: ref,
    className: className
  }), children);
}

MoveFocusInside.propTypes =  false ? undefined : {};
MoveFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (MoveFocusInside);

/***/ }),

/***/ "p7XS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SidePanel_SidePanel; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react-focus-on/dist/es2015/Combination.js + 8 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react-focus-lock/dist/es2015/AutoFocusInside.js
var AutoFocusInside = __webpack_require__("JPie");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.themes.js
var themes = {
  "default": {
    thRoot: 'bg-white',
    thCloseButton: 'reset-button bg-white cursor-pointer leading-none m-5 p-4 rounded-full text-gray-darker text-md',
    thCloseButtonLabel: 'sr-only'
  }
};
var POSITIONS_CLASSES = {
  top: {
    pin: 'inset-x-0 top-0',
    transform: '-translate-y-100',
    style: {
      maxHeight: 'calc(100% - 100px)'
    },
    button: 'bottom-0 rtl:right-0 rtl:slideInRight'
  },
  bottom: {
    pin: 'inset-x-0 bottom-0',
    transform: 'translate-y-100',
    style: {
      maxHeight: 'calc(100% - 100px)'
    },
    button: 'top-0 rtl:right-0 rtl:slideInRight'
  },
  left: {
    pin: 'inset-y-0 left-0',
    transform: '-translate-x-100',
    style: {
      maxWidth: 'calc(100vw - 100px)'
    },
    button: 'top-0 right-0'
  },
  right: {
    pin: 'inset-y-0 right-0',
    transform: 'translate-x-100',
    style: {
      maxWidth: 'calc(100vw - 100px)'
    },
    button: 'top-0 left-0'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx

var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var SidePanel_SidePanel = function SidePanel(_ref) {
  var _classnames;

  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      _ref$backdropColor = _ref.backdropColor,
      backdropColor = _ref$backdropColor === void 0 ? '#000' : _ref$backdropColor,
      _ref$backdropOpacity = _ref.backdropOpacity,
      backdropOpacity = _ref$backdropOpacity === void 0 ? 0.8 : _ref$backdropOpacity,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      height = _ref.height,
      isExpanded = _ref.isExpanded,
      onClose = _ref.onClose,
      _ref$portalName = _ref.portalName,
      portalName = _ref$portalName === void 0 ? Portal_constants["d" /* OVER_BOT */] : _ref$portalName,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom' : _ref$position,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var sidePanelBodyref = Object(react["useRef"])();
  var onScroll = Object(lodash["throttle"])(function () {
    Object(lib["forceCheck"])();
  }, 250);
  Object(react["useEffect"])(function () {
    // $FlowFixMe
    sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.addEventListener('scroll', onScroll);
    return function () {
      // $FlowFixMe
      sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.removeEventListener('scroll', onScroll);
    };
  }, []);
  Object(react["useEffect"])(function () {
    if (isExpanded) {
      Object(lib["forceCheck"])();
    }
  }, [isExpanded]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thRoot = _themes$theme.thRoot;
  var positionClasses = POSITIONS_CLASSES[position];
  var closeBtnSidePanel = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  return __jsx(Portal["a" /* default */], {
    name: portalName
  }, __jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: isExpanded
  }, isExpanded && __jsx("div", {
    className: "fadeIn fixed h-screen inset-0",
    "data-testid": "SidePanel-backdrop",
    style: {
      backgroundColor: backdropColor,
      opacity: backdropOpacity
    }
  }), __jsx("div", {
    "aria-hidden": !isExpanded,
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, __jsx("div", {
    role: "document"
  }, __jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: isExpanded,
    onClickOutside: onClose,
    onEscapeKey: onClose
  }, isExpanded && __jsx(AutoFocusInside["a" /* default */], null, __jsx("button", {
    className: classnames_default()('fixed z-2', thCloseButton, positionClasses.button),
    onClick: onClose,
    type: "button"
  }, closeBtnSidePanel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnSidePanel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  }))), __jsx("aside", {
    className: classnames_default()(className, thRoot, positionClasses.pin, 'fixed h-full overflow-y-scroll transition-all w-full z-1', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, positionClasses.transform, !isExpanded), Object(defineProperty["a" /* default */])(_classnames, 'translate-0', isExpanded), _classnames)),
    ref: sidePanelBodyref,
    style: _objectSpread({
      height: height
    }, positionClasses.style)
  }, isExpanded && children))))));
};

/***/ }),

/***/ "p9RO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLegalInformationTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackForYouClub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onCheckboxChange; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d1HQ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);




var findLegalInformation = function findLegalInformation(ref, legalInformations) {
  return legalInformations && legalInformations.find(function (_ref) {
    var legalInfoRef = _ref.ref;
    return legalInfoRef === ref;
  });
};

var getLegalInformationTitle = function getLegalInformationTitle(ref, legalInformations) {
  return (findLegalInformation(ref, legalInformations) || {}).title || ref;
};
var trackForYouClub = function trackForYouClub(context) {
  _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_1__[/* setDataLayer */ "b"]({
    event: 'eventGA',
    categoryGA: 'PLE',
    actionGA: 'CTA_optin_foryouclub',
    labelGA: 'profilePage'
  }, context);
};
var CLUBMED = 'CLUBMED';
var PARTNERS = 'PARTNERS';
var FOSUN_PARTNERS = 'FOSUN_PARTNERS';
var FORYOUCLUB = 'FORYOUCLUB';
function onCheckboxChange(checkbox, setFieldValue) {
  var _fields;

  var fields = (_fields = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_fields, CLUBMED, {
    checked: [CLUBMED],
    unchecked: [CLUBMED, PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_fields, PARTNERS, {
    checked: [CLUBMED, PARTNERS],
    unchecked: [PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_fields, FOSUN_PARTNERS, {
    checked: [FOSUN_PARTNERS],
    unchecked: [FOSUN_PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_fields, FORYOUCLUB, {
    checked: [FORYOUCLUB],
    unchecked: [FORYOUCLUB]
  }), _fields);

  if (checkbox.checked) {
    Object(lodash__WEBPACK_IMPORTED_MODULE_2__["difference"])(fields[checkbox.name].checked, [checkbox.name]).map(function (id) {
      return setFieldValue(id, true);
    });
  } else {
    Object(lodash__WEBPACK_IMPORTED_MODULE_2__["difference"])(fields[checkbox.name].unchecked, [checkbox.name]).map(function (id) {
      return setFieldValue(id, false);
    });
  }
}

/***/ }),

/***/ "pFRH":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("cvCv"),
    defineProperty = __webpack_require__("O0oS"),
    identity = __webpack_require__("zZ0H");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "pP7N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setCms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_BOOKING_ENGINE_I18N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBookingEngineI18n; });
/* harmony import */ var _views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9LZ4");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");


var SET_CMS = 'SET_CMS';
var setCms = function setCms(config, legalInformations) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SET_CMS, {
    config: config,
    legalInformations: legalInformations
  });
};
var GET_BOOKING_ENGINE_I18N = 'GET_BOOKING_ENGINE_I18N';
var getBookingEngineI18n = function getBookingEngineI18n(appContext) {
  return function (dispatch) {
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(GET_BOOKING_ENGINE_I18N, {}, {
      promise: Object(_views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__[/* fetchBookingEngineI18nQuery */ "a"])(appContext)
    }));
  };
};

/***/ }),

/***/ "pPFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isRegexp = __webpack_require__("1dAi");
var isPlainObj = __webpack_require__("I8qj");

module.exports = function (val, opts, pad) {
	var seen = [];

	return (function stringify(val, opts, pad) {
		opts = opts || {};
		opts.indent = opts.indent || '\t';
		pad = pad || '';
		var tokens;
		if(opts.inlineCharacterLimit == void 0) {
			tokens = {
				newLine: '\n',
				newLineOrSpace: '\n',
				pad: pad,
				indent: pad + opts.indent
			};
		} else {
			tokens = {
				newLine: '@@__STRINGIFY_OBJECT_NEW_LINE__@@',
				newLineOrSpace: '@@__STRINGIFY_OBJECT_NEW_LINE_OR_SPACE__@@',
				pad: '@@__STRINGIFY_OBJECT_PAD__@@',
				indent: '@@__STRINGIFY_OBJECT_INDENT__@@'
			}
		}
		var expandWhiteSpace = function(string) {
			if (opts.inlineCharacterLimit == void 0) { return string; }
			var oneLined = string.
				replace(new RegExp(tokens.newLine, 'g'), '').
				replace(new RegExp(tokens.newLineOrSpace, 'g'), ' ').
				replace(new RegExp(tokens.pad + '|' + tokens.indent, 'g'), '');

			if(oneLined.length <= opts.inlineCharacterLimit) {
				return oneLined;
			} else {
				return string.
					replace(new RegExp(tokens.newLine + '|' + tokens.newLineOrSpace, 'g'), '\n').
					replace(new RegExp(tokens.pad, 'g'), pad).
					replace(new RegExp(tokens.indent, 'g'), pad + opts.indent);
			}
		};

		if (seen.indexOf(val) !== -1) {
			return '"[Circular]"';
		}

		if (val === null ||
			val === undefined ||
			typeof val === 'number' ||
			typeof val === 'boolean' ||
			typeof val === 'function' ||
			isRegexp(val)) {
			return String(val);
		}

		if (val instanceof Date) {
			return 'new Date(\'' + val.toISOString() + '\')';
		}

		if (Array.isArray(val)) {
			if (val.length === 0) {
				return '[]';
			}

			seen.push(val);

			var ret = '[' + tokens.newLine + val.map(function (el, i) {
				var eol = val.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
				return tokens.indent + stringify(el, opts, pad + opts.indent) + eol;
			}).join('') + tokens.pad + ']';

			seen.pop(val);

			return expandWhiteSpace(ret);
		}

		if (isPlainObj(val)) {
			var objKeys = Object.keys(val);

			if (objKeys.length === 0) {
				return '{}';
			}

			seen.push(val);

			var ret = '{' + tokens.newLine + objKeys.map(function (el, i) {
				if (opts.filter && !opts.filter(val, el)) {
					return '';
				}

				var eol = objKeys.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
				var key = /^[a-z$_][a-z$_0-9]*$/i.test(el) ? el : stringify(el, opts);
				return tokens.indent + key + ': ' + stringify(val[el], opts, pad + opts.indent) + eol;
			}).join('') + tokens.pad + '}';

			seen.pop(val);

			return expandWhiteSpace(ret);
		}

		val = String(val).replace(/[\r\n]/g, function (x) {
			return x === '\n' ? '\\n' : '\\r';
		});

		if (opts.singleQuotes === false) {
			return '"' + val.replace(/"/g, '\\\"') + '"';
		}

		return '\'' + val.replace(/'/g, '\\\'') + '\'';
	})(val, opts, pad);
};


/***/ }),

/***/ "qFX+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCALES; });
var LOCALES = {
  EN_CN: 'en-CN',
  ZH_CN: 'zh-CN'
};


/***/ }),

/***/ "qZTm":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("fR/l"),
    getSymbols = __webpack_require__("MvSz"),
    keys = __webpack_require__("7GkX");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "qd7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIGNOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return signout; });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("H6pA");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rJ95");



var SIGNOUT = 'SIGNOUT';

function cleanCookies() {
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_1__[/* USER_INFO */ "d"]);
}

function signout() {
  cleanCookies();
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"])(SIGNOUT);
}

/***/ }),

/***/ "rAD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_QUICKLOGIN_INFOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_QUICKLOGIN_INFOS; });
var UPDATE_QUICKLOGIN_INFOS = 'UPDATE_QUICKLOGIN_INFOS';
var RESET_QUICKLOGIN_INFOS = 'RESET_QUICKLOGIN_INFOS';

/***/ }),

/***/ "rEGp":
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "rJ95":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createOptimisticAction; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function createAction(type, payload) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _objectSpread(_objectSpread({
    type: type
  }, payload ? {
    payload: payload
  } : null), {}, {
    meta: meta
  });
}

function createOptimisticAction(type, payload, meta) {
  return _objectSpread(_objectSpread({
    type: type
  }, payload ? {
    payload: payload
  } : null), {}, {
    meta: meta
  });
}


/* harmony default export */ __webpack_exports__["b"] = (createAction);

/***/ }),

/***/ "sEf8":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "sRdV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTracking; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Ub5k");
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("RPju");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("d1HQ");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("829J");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var useTracking = function useTracking(defaultPayload) {
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]);
  var pageContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_3__[/* ReactPageContext */ "a"]);

  var payload = _objectSpread(_objectSpread({}, _constants__WEBPACK_IMPORTED_MODULE_5__[/* GA_DEFAULT_PAYLOAD */ "i"]), {}, {
    siteSection: pageContext.siteSection
  }, defaultPayload);

  return function (trackPayload) {
    ___WEBPACK_IMPORTED_MODULE_4__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, payload), trackPayload), appContext, pageContext.pageType);
  };
};

/***/ }),

/***/ "sW3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADULTS_ONLY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADULTS_NUMBER_MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADULTS_NUMBER_MAX; });
/* unused harmony export AREA_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHILDCARE_FACET_ID; });
/* unused harmony export COUNTRY_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DEFAULT_DEPARTURE_CITY_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DEPARTURE_CITY_FACET_ID; });
/* unused harmony export DEPARTURE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DEPARTURE_DATE_MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DEPARTURE_DATE_MAX_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DEPARTURE_DATE_MIN_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DURATION_FACET; });
/* unused harmony export KIDS_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return KIDS_NUMBER_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return LOCALE_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MAX_NUMBER_OF_SELECTED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return OFFER_ID_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PRODUCT_FACET_ID; });
/* unused harmony export WHEN_FACET_ID */
/* unused harmony export WHERE_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DESTINATIONS_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COUNTRIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return TYPES_OF_STAY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FACET_COMFORT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return QUERY_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PRODUCTS_TO_COMPARE_QUERY_PARAM; });
/* unused harmony export FACET_QUERY_PARAMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEFAULT_CHILDCARE_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FILTERABLE_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FILTERABLE_FACETS_TRACKING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FILTERABLE_FACETS_TEMPLATE_CONFIG; });
/* unused harmony export FACETS */
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");


var ADULTS_ONLY_FACET_ID = 'facette_adult_only';
var ADULTS_NUMBER_MIN = 1;
var ADULTS_NUMBER_MAX = 6;
var AREA_FACET_PREFIX_ID = 'AREA';
var CHILDCARE_FACET_ID = 'facette_childcare_age_in_month';
var COUNTRY_FACET_PREFIX_ID = 'COUNTRY';
var DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_DEPARTURE_CITY_VALUE = 'NO';
var DEPARTURE_CITY_FACET_ID = 'facette_departure_city';
var DEPARTURE_DATE = 'date';
var DEPARTURE_DATE_MAX_DATE = {
  years: 2
};
var DEPARTURE_DATE_MAX_FACET_ID = 'departure_date_max';
var DEPARTURE_DATE_MIN_FACET_ID = 'departure_date_min';
var DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH = 6;
var DURATION_FACET = 'facette_duration';
var KIDS_FACET_ID = 'facette_kids';
var KIDS_NUMBER_MAX = 5;
var LOCALE_FACET_ID = 'locale';
var MAX_NUMBER_OF_SELECTED_PRODUCTS = 3;
var OFFER_ID_FACET_ID = 'facette_offer_id';
var PRODUCT_FACET_ID = 'product_id';
var WHEN_FACET_ID = 'facette_when';
var WHERE_FACET_ID = 'facette_where';
var ACTIVITIES_FACET_ID = 'activities_tree';
var DESTINATIONS_FACET_ID = 'destinations_tree';
var COUNTRIES_FACET_ID = 'facette_destination_country';
var TYPES_OF_STAY_FACET_ID = 'facette_type';
var FACET_COMFORT_ID = 'facette_comfort_label';
var QUERY_QUERY_PARAM = 'search';
var PRODUCTS_TO_COMPARE_QUERY_PARAM = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].productsComparison.productIds;
var FACET_QUERY_PARAMS = [{
  id: 'destination',
  facetId: COUNTRIES_FACET_ID
}, {
  id: 'departure_city',
  facetId: DEPARTURE_CITY_FACET_ID
}];
var DEFAULT_CHILDCARE_FACETS = ['132-215', '24-47', '4-23', '48-131'];
var FILTERABLE_FACETS_IDS = [ACTIVITIES_FACET_ID, DESTINATIONS_FACET_ID, COUNTRIES_FACET_ID, TYPES_OF_STAY_FACET_ID, FACET_COMFORT_ID];
var FILTERABLE_FACETS_TRACKING_CONFIG = [{
  id: ACTIVITIES_FACET_ID,
  trackingPrefixLabel: 'activities'
}, {
  id: DESTINATIONS_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: COUNTRIES_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FACET_COMFORT_ID,
  trackingPrefixLabel: 'comfort'
}];
var FILTERABLE_FACETS_TEMPLATE_CONFIG = [{
  id: DESTINATIONS_FACET_ID,
  dataLabel: 'where',
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].EARTH_PLANE,
  facetLists: [{
    deep: false,
    id: DESTINATIONS_FACET_ID,
    titleLabel: 'faceting.where.destinationTitle'
  }, {
    deep: false,
    id: COUNTRIES_FACET_ID,
    titleLabel: 'faceting.where.countriesTitle'
  }],
  titleLabel: 'faceting.where.title'
}, {
  id: ACTIVITIES_FACET_ID,
  dataLabel: 'activities',
  facetLists: [{
    deep: true,
    id: ACTIVITIES_FACET_ID
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].ACTIVITIES,
  titleLabel: 'faceting.activities.title'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  dataLabel: 'typeofstay',
  facetLists: [{
    deep: false,
    id: TYPES_OF_STAY_FACET_ID,
    facetLabels: 'faceting.typesOfStay'
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].BEACH,
  titleLabel: 'faceting.typesOfStay.title',
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FACET_COMFORT_ID,
  dataLabel: 'comfort',
  facetLists: [{
    deep: false,
    id: FACET_COMFORT_ID
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT1,
  titleLabel: 'faceting.comfort.title'
}];
var FACETS = {
  when: 'when',
  who: 'who',
  where: 'where'
};

/***/ }),

/***/ "seXi":
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__("qZTm");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "shjB":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "tI+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PACKAGE_ALL_INCLUSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PACKAGE_ROOM_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CEFALU_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELUXE_COMFORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PACKAGE_FOOD_AND_BEVERAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PRICE_COUNTER_PROPOSAL_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMFORT_TYPE_SUITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMFORT_TYPE_CHALET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMFORT_TYPE_VILLA; });
var PACKAGE_ALL_INCLUSIVE = 'PAI';
var PACKAGE_ROOM_ONLY = 'RON';
var PACKAGE_FOOD_AND_BEVERAGE = 'FFB';
var CEFALU_RESORT = 'CFAC';
var DELUXE_COMFORT = 'Deluxe';
var PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
var COMFORT_TYPE_SUITE = 'typeoflodging_comfort_type_suite';
var COMFORT_TYPE_CHALET = 'typeoflodging_comfort_type_chalet';
var COMFORT_TYPE_VILLA = 'typeoflodging_comfort_type_villa';


/***/ }),

/***/ "tJAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("\n  fragment Address on Address {\n    streetNumber\n    streetName\n    additionalInformation1\n    additionalInformation2\n    addOn\n    zipCode\n    city\n    town\n    stateOrDistrict\n    country\n    countryCode\n  }\n");

/***/ }),

/***/ "tRRp":
/***/ (function(module) {

module.exports = JSON.parse("{\"0\":65533,\"128\":8364,\"130\":8218,\"131\":402,\"132\":8222,\"133\":8230,\"134\":8224,\"135\":8225,\"136\":710,\"137\":8240,\"138\":352,\"139\":8249,\"140\":338,\"142\":381,\"145\":8216,\"146\":8217,\"147\":8220,\"148\":8221,\"149\":8226,\"150\":8211,\"151\":8212,\"152\":732,\"153\":8482,\"154\":353,\"155\":8250,\"156\":339,\"158\":382,\"159\":376}");

/***/ }),

/***/ "tadb":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("Cwc5"),
    root = __webpack_require__("Kz5y");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "ttrC":
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__("iGAk"),
    fallbackHolder = __webpack_require__("wuTn");

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var defaultHolder = isLib ? func : fallbackHolder,
      forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func, placeholder) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    result.placeholder = func.placeholder = placeholder;

    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func, defaultHolder);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func, _)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  _.placeholder = _;

  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),

/***/ "u9tP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAuthenticationMiddleware; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_ple_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("6jSF");



function createAuthenticationMiddleware() {
  return function () {
    return function (next) {
      return function (action) {
        try {
          var _action$meta; // Works only on rejected optimistic actions, with a redirect_uri in payload's meta
          // $FlowFixMe


          var redirectUri = (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.redirect_uri;

          if (!!redirectUri && _utils_ple_utils__WEBPACK_IMPORTED_MODULE_2__[/* hasAuthResponseError */ "l"](action.payload)) {
            _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["windowWrapper"].setLocation(redirectUri);
          }
        } catch (e) {
          _logger__WEBPACK_IMPORTED_MODULE_1___default.a.warn(e);
        }

        return next(action);
      };
    };
  };
}

/***/ }),

/***/ "uGNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SELECTED_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSelectedProposal; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nv//");
/* harmony import */ var _views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("47Eh");




var SELECT_PROPOSAL = 'SELECT_PROPOSAL';
var CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';

function clearSelectedProposal() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(CLEAR_SELECTED_PROPOSAL, {});
}

function selectProposal(proposalId, location, history) {
  var updatedUri = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_2__[/* convertLocationToURI */ "c"])(location).setQuery(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].booking.selectedProposalId, proposalId);
  Object(_views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_3__[/* navigateInBookingEngine */ "d"])({
    location: updatedUri,
    history: history,
    replace: true
  });
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SELECT_PROPOSAL, {
    proposalId: proposalId
  });
}



/***/ }),

/***/ "uL19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addUserInfosToAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getCustomerSearchResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterProposalBySamePackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAdditionalTransportsError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getIsLoadingAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getIsLoadingAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getProposals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdditionalAccommodationsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAdditionalAccommodationsError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getFilteredAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getFilteredAdditionalAccommodationsSets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getSearchCriteriaTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getSearchCriteriaTransportsInbound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getAdditionalTransportsFilters; });
/* unused harmony export getFilteredAdditionalTransports */
/* unused harmony export getAdditionalTransportsSorters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getReservedServicesByAttendee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getSelectedProposalId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCurrentResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getPaymentProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getProposalsWithMappedAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCurrentProposal; });
/* unused harmony export getProposalHasAnyEquipmentForRent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getDetailedAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAttendeesWithInfos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getConnectedUserInfoSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return proposalsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getInsuranceStatus; });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("oL6k");
/* harmony import */ var _user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("apzf");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Jsmy");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ldK3");




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var bookingSelector = function bookingSelector(_ref) {
  var booking = _ref.booking;
  return booking || {};
};

var additionalTransportsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref2) {
  var additionalTransports = _ref2.additionalTransports;
  return additionalTransports || {};
});
var getPaymentProviders = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref3) {
  var paymentProviders = _ref3.paymentProviders;
  return paymentProviders;
});
var getInsuranceStatus = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref4) {
  var insurance = _ref4.insurance;
  return insurance;
});
var getSearchCriteriaTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref5) {
  var searchCriteria = _ref5.searchCriteria;
  return searchCriteria;
});
var getSearchCriteriaTransportsInbound = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref6) {
  var searchCriteria = _ref6.searchCriteria;
  return searchCriteria && searchCriteria[0];
});
var getAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref7) {
  var transports = _ref7.transports;
  return transports;
});
var getAdditionalTransportsFilters = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref8) {
  var filters = _ref8.filters;
  return filters;
});
var getFilteredAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref9) {
  var filteredTransports = _ref9.filteredTransports;
  return filteredTransports;
});
var getAdditionalTransportsSorters = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref10) {
  var sorters = _ref10.sorters;
  return sorters || [];
});
var getAdditionalTransportsError = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref11) {
  var error = _ref11.error;
  return error;
});
var getIsLoadingAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref12) {
  var isLoading = _ref12.isLoading;
  return isLoading;
});
var additionalAccommodationsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref13) {
  var additionalAccommodations = _ref13.additionalAccommodations;
  return additionalAccommodations || {};
});
var getIsLoadingAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref14) {
  var isLoading = _ref14.isLoading;
  return isLoading;
});
var getAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref15) {
  var accommodationsSets = _ref15.accommodationsSets;
  return accommodationsSets;
});
var getAdditionalAccommodationsFilters = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref16) {
  var filters = _ref16.filters;
  return filters;
});
var getAdditionalAccommodationsError = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref17) {
  var error = _ref17.error;
  return error;
});
var getFilteredAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref18) {
  var filteredAccommodations = _ref18.filteredAccommodations;
  return filteredAccommodations;
});
var getFilteredAdditionalAccommodationsSets = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getFilteredAdditionalAccommodations, getAdditionalAccommodations, function (filteredAccommodations, additionalAccommodations) {
  return filteredAccommodations && filteredAccommodations.length > 0 ? filteredAccommodations : additionalAccommodations;
});
var proposalsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref19) {
  var proposals = _ref19.proposals;
  return proposals || [];
});
var getCurrentResort = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref20) {
  var resort = _ref20.resort;
  return resort;
});

var findAttendeeByNeolid = function findAttendeeByNeolid(attendees, neolid) {
  return attendees.find(function (attendee) {
    return attendee.neolid === neolid;
  });
};

var getSelectedProposalId = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref21) {
  var selectedProposalId = _ref21.selectedProposalId;
  return selectedProposalId;
});
/**
 * It should be getSelectedProposal but there is a selector getSelectedProposal
 * witch get the proposal from paymentInfoSelector
 * I do not know why...
 */

var getCurrentProposal = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref22) {
  var proposals = _ref22.proposals,
      selectedProposalId = _ref22.selectedProposalId;
  return (
    /**
     * return the selected proposal if found,
     * if not (for any reason) the default proposal for keeping the return shape value consistent
     */
    proposals.find(function (proposal) {
      return proposal.id === selectedProposalId;
    }) || Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_5__[/* getDefaultProposal */ "e"])(proposals)
  );
});

var filterProposalBySamePackage = function filterProposalBySamePackage(proposals, selectedProposal) {
  var errorsProposals = proposals.filter(function (proposal) {
    return proposal.errorCode;
  });

  if (errorsProposals.length) {
    return errorsProposals;
  }

  return proposals.filter(function (item) {
    var _item$accommodations = item.accommodations,
        accommodations = _item$accommodations === void 0 ? [] : _item$accommodations,
        packageId = item.packageId;
    return accommodations.length && packageId === selectedProposal.packageId;
  });
};

var getProposals = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(proposalsSelector, getCurrentProposal, filterProposalBySamePackage);
var getProposalsWithMappedAttendees = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getProposals, _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_7__[/* tripInformationSelector */ "d"], function (proposals, tripInformation) {
  if (!proposals) {
    return proposals;
  }

  return proposals.map(function (proposal) {
    return _objectSpread(_objectSpread({}, proposal), {}, {
      attendees: _objectSpread(_objectSpread({}, proposal.attendees), {}, {
        list: proposal.attendees.list.map(function (attendee) {
          // if there is a birthdate it's a children otherwise it's an adult
          var attendeeData = attendee.birthdate ? findAttendeeByNeolid(tripInformation.kids, attendee.customerId) : findAttendeeByNeolid(tripInformation.adults, attendee.customerId);

          if (!attendeeData) {
            return attendee;
          }

          return _objectSpread(_objectSpread({}, attendee), {}, {
            firstName: attendeeData.firstName,
            lastName: attendeeData.lastName
          });
        })
      })
    });
  });
});
var getProposalHasAnyEquipmentForRent = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref23) {
  var rentalEquipments = _ref23.rentalEquipments;
  return rentalEquipments.hasAnyEquipmentForRent;
});
var getAttendees = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getCurrentProposal, function (_ref24) {
  var attendees = _ref24.attendees;
  return attendees;
});
var getConnectedUserInfoSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_6__[/* userInfoSelector */ "a"], function (connectedUserInfo) {
  return connectedUserInfo.isQuickLoggedIn ? {} : Object(lodash__WEBPACK_IMPORTED_MODULE_4__["omit"])(_objectSpread(_objectSpread({}, connectedUserInfo), {}, {
    birthdate: connectedUserInfo.dateOfBirth,
    neolid: connectedUserInfo.neolaneId,
    // harmonize the neolid between user and seller
    mobile: connectedUserInfo.mobilePhoneNumber
  }), ['dateOfBirth', 'GMNumber', 'homePhoneNumber', 'isProspect', 'neolaneId', 'unicodeCivility', 'expirationDate', 'mobilePhoneNumber']);
});
var getSuggestions = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref25) {
  var suggestions = _ref25.suggestions;
  return suggestions;
});
/**
 * The comparator does not put proposal in store
 * We need to use this function instead of the getAttendeesWithInfos selector
 */

var addUserInfosToAttendees = function addUserInfosToAttendees(proposalAttendees, tripAttendees, connectedUserInfo) {
  var getSortAttendeesByGmNumber = function getSortAttendeesByGmNumber(attendee1, attendee2) {
    if (!attendee1.gmNumber || !attendee2.gmNumber) {
      return 0;
    }

    return tripAttendees.adults.findIndex(function (attendee) {
      return attendee.gmNumber === attendee1.gmNumber;
    }) - tripAttendees.adults.findIndex(function (attendee) {
      return attendee.gmNumber === attendee2.gmNumber;
    });
  }; // defensive code if store is not available (ex: confirmation page)


  if (!tripAttendees || !proposalAttendees) {
    return {
      adults: [],
      children: []
    };
  }

  var sortedAdultsAttendees = tripAttendees.adults.sort(getSortAttendeesByGmNumber);
  var adultsList = proposalAttendees.adults.map(function (adult, index) {
    return _objectSpread(_objectSpread(_objectSpread({}, index === 0 ? connectedUserInfo : null), adult), Object(lodash__WEBPACK_IMPORTED_MODULE_4__["omitBy"])(sortedAdultsAttendees[index], function (value) {
      return value === undefined;
    }));
  });
  var childrenList = proposalAttendees.children.map(function (child) {
    return _objectSpread(_objectSpread({}, child), Object(lodash__WEBPACK_IMPORTED_MODULE_4__["omitBy"])(tripAttendees.kids.find(function (kid) {
      if (kid.id) {
        return kid.birthdate === Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* apiDateToTimestamp */ "d"])(child.birthdate) && kid.id === child.id;
      }

      if (kid.neolid && child.customerId) {
        return kid.birthdate === Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* apiDateToTimestamp */ "d"])(child.birthdate) && kid.neolid === child.customerId;
      }

      return kid.birthdate === Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* apiDateToTimestamp */ "d"])(child.birthdate);
    }), function (value, key) {
      return value === undefined || key === 'birthdate';
    }));
  }).sort(getSortAttendeesByGmNumber).sort(function (child1, child2) {
    // for seller set children with neolid (so with his fields already filled) first
    if (child1.neolid && !child2.neolid) {
      return -1;
    }

    if (!child1.neolid && child2.neolid) {
      return 1;
    }

    return 0;
  });
  return {
    adults: adultsList,
    children: childrenList
  };
};
var getCustomerSearchResult = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (booking) {
  return booking.customerSearch;
});

var addSearchDataToAttendees = function addSearchDataToAttendees(attendeesWithInfo, attendeesFromSearch) {
  var enrichedAdults = attendeesWithInfo.adults.map(function (attendee, index) {
    var attendeeFromSearch = attendeesFromSearch.adults[index];
    return _objectSpread(_objectSpread({}, attendee), attendeeFromSearch ? _objectSpread(_objectSpread({}, attendeeFromSearch), {}, {
      /**
       * attendeeFromSearch has a "fake" id which is in reality customerId (see commonProfileFieldsFragment)
       * we want to have the proposal attendee id here because it's what the api is waiting for
       *  */
      id: attendee.id,
      customerId: attendeeFromSearch.id
    }) : null);
  });
  var enrichedChildren = attendeesWithInfo.children.map(function (attendee, index) {
    var attendeeFromSearch = attendeesFromSearch.children[index];
    return _objectSpread(_objectSpread({}, attendee), attendeeFromSearch ? _objectSpread(_objectSpread({}, attendeeFromSearch), {}, {
      /**
       * attendeeFromSearch has a "fake" id which is in reality customerId (see commonProfileFieldsFragment)
       * we want to have the proposal attendee id here because it's what the api is waiting for
       *  */
      id: attendee.id,
      customerId: attendeeFromSearch.id
    }) : null);
  });
  return {
    adults: enrichedAdults,
    children: enrichedChildren
  };
};

var enrichAttendeesWithAvailableData = function enrichAttendeesWithAvailableData(proposalAttendees, tripAttendees, connectedUserInfo, searchResult) {
  var attendeesWithInfo = addUserInfosToAttendees(proposalAttendees, tripAttendees, connectedUserInfo);
  return searchResult && searchResult.data ? addSearchDataToAttendees(attendeesWithInfo, searchResult.data) : attendeesWithInfo;
};

var getAttendeesWithInfos = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getAttendees, _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_7__[/* tripInformationSelector */ "d"], getConnectedUserInfoSelector, getCustomerSearchResult, enrichAttendeesWithAvailableData);
var getReservedServicesByAttendee = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getCurrentProposal, getAttendeesWithInfos, function (_ref26, attendeesWithInfos) {
  var additionalServices = _ref26.additionalServices; // defensive code if store is not available (ex: confirmation page)

  if (!additionalServices || !attendeesWithInfos) {
    return [];
  }

  var attendeesWithServiceRented = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(additionalServices.activities), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(additionalServices.rentals)).reduce(function (acc, service) {
    var pricingInfo = service.pricingInfo,
        productInfo = service.productInfo;
    pricingInfo.schedules.forEach(function (_ref27) {
      var attendees = _ref27.attendees;
      attendees.forEach(function (attendee) {
        if (attendee.isRented) {
          if (acc[attendee.id]) {
            if (acc[attendee.id][productInfo.id]) {
              acc[attendee.id][productInfo.id].price += attendee.price.value;

              if (!acc[attendee.id][productInfo.id].services.some(function (_ref28) {
                var servicePricingInfo = _ref28.pricingInfo;
                return servicePricingInfo.id === service.pricingInfo.id;
              })) {
                acc[attendee.id][productInfo.id].services.push(service);
              }
            } else {
              acc[attendee.id][productInfo.id] = {
                price: attendee.price.value,
                services: [service]
              };
            }
          } else {
            acc[attendee.id] = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({}, productInfo.id, {
              price: attendee.price.value,
              services: [service]
            });
          }
        }
      });
    });
    return acc;
  }, {});
  return Object.entries(attendeesWithServiceRented).reduce(function (reservedServicesByAttendee, _ref29) {
    var _ref30 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref29, 2),
        id = _ref30[0],
        rentedServices = _ref30[1];

    var childIndex = attendeesWithInfos.children.findIndex(function (attendee) {
      return attendee.id === id;
    });

    if (childIndex > -1) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.children[childIndex]), {}, {
        id: id,
        index: childIndex + 1,
        isAdult: false,
        // $FlowFixMe 🤷‍️
        rentedServices: Object.values(rentedServices)
      })]);
    }

    var adultIndex = attendeesWithInfos.adults.findIndex(function (attendee) {
      return attendee.id === id;
    });
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.adults[adultIndex]), {}, {
      id: id,
      index: adultIndex + 1,
      isAdult: true,
      // $FlowFixMe 🤷‍️
      rentedServices: Object.values(rentedServices)
    })]);
  }, []).sort(function (a, b) {
    if (a.isAdult && !b.isAdult) {
      return -1;
    }

    if (!a.isAdult && b.isAdult) {
      return 1;
    }

    return a.index - b.index;
  });
});

var getDetailedAttendees = function getDetailedAttendees(_ref31) {
  var booking = _ref31.booking;
  return booking.attendees;
};



/***/ }),

/***/ "uLWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: Grid

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.jsx
var Responsive = __webpack_require__("Gqxm");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/frameworks/more-results/MoreResults.themes.js
var themes = {
  "default": {
    thRoot: 'flex pt-2 w-full',
    thContent: 'bg-white flex flex-wrap relative w-full',
    thButton: 'absolute bottom-0 flex left-0 justify-center w-full',
    thPlaceholders: 'w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/more-results/MoreResults.jsx
var __jsx = react_default.a.createElement;







var PLACEHOLDER_URLS = ['https://ns.clubmed.com/it/2019/shop/dummy.png', 'https://ns.clubmed.com/it/2019/shop/dummy2.png', 'https://ns.clubmed.com/it/2019/shop/dummy3.png'];
var MoreResults_MoreResults = function MoreResults(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      _ref$number = _ref.number,
      number = _ref$number === void 0 ? 0 : _ref$number,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? lodash["noop"] : _ref$onClick,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      grid = _ref.grid,
      maxPlaceholders = _ref.maxPlaceholders;

  if (!number) {
    return null;
  }

  var _themes$theme = themes[theme],
      thContent = _themes$theme.thContent,
      thButton = _themes$theme.thButton,
      thPlaceholders = _themes$theme.thPlaceholders,
      thRoot = _themes$theme.thRoot;

  var renderPlaceholders = function renderPlaceholders() {
    var placeholders = [];

    for (var i = 0; i < number && i < maxPlaceholders; i++) {
      placeholders.push(__jsx(Image["a" /* default */], {
        className: classnames_default()('fadeIn px-2 align-bottom', grid),
        imageUrl: PLACEHOLDER_URLS[i],
        mandatoryWidthAndHeight: {
          w: 760,
          h: 'auto'
        },
        key: PLACEHOLDER_URLS[i]
      }));
    }

    return placeholders;
  };

  return __jsx("div", {
    className: classnames_default()(className, thRoot)
  }, __jsx("div", {
    className: thContent
  }, __jsx("div", {
    className: thPlaceholders
  }, renderPlaceholders(), __jsx("div", {
    style: {
      position: 'absolute',
      bottom: '0',
      left: '0',
      right: '0',
      top: '0',
      background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%)'
    }
  })), __jsx("div", {
    className: thButton
  }, __jsx(Button["a" /* Button */], {
    onClick: onClick,
    dataTestId: "more-results-btn",
    iconRight: {
      name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH
    },
    minWidth: "220px",
    isLoading: isLoading
  }, __jsx("span", {
    "data-testid": "Moreresults-number"
  }, number), " ", text))));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/grid/Grid.jsx









var Grid_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






function getWidth() {
  var fraction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return fraction < 2 || fraction > 6 ? 'w-full' : "w-1/".concat(fraction);
}

function filterContext(hasOneRemaining, itemsByLine, isSeeMoreVisible) {
  return function (item, index) {
    if (isSeeMoreVisible) {
      return index < itemsByLine;
    }

    return true;
  };
}

var Grid_Grid = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Grid, _Component);

  var _super = _createSuper(Grid);

  function Grid() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Grid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      isExpanded: !_this.props.hasSeeMore
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickSeeMore", function () {
      var _this$props = _this.props,
          _this$props$totalNumb = _this$props.totalNumberToDisplay,
          totalNumberToDisplay = _this$props$totalNumb === void 0 ? 0 : _this$props$totalNumb,
          _this$props$getChildr = _this$props.getChildren,
          getChildren = _this$props$getChildr === void 0 ? function () {
        return Promise.resolve({});
      } : _this$props$getChildr,
          _this$props$isSynchro = _this$props.isSynchronousGrid,
          isSynchronousGrid = _this$props$isSynchro === void 0 ? false : _this$props$isSynchro;

      if (isSynchronousGrid || totalNumberToDisplay === _this.getItemsByLine()) {
        _this.setState({
          isExpanded: true
        });
      }

      if (totalNumberToDisplay > _this.getItemsByLine()) {
        getChildren();
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Grid, [{
    key: "getGrid",
    value: function getGrid() {
      var _this$props$grid = this.props.grid,
          grid = _this$props$grid === void 0 ? {} : _this$props$grid;
      var desktop = grid.desktop,
          tablet = grid.tablet,
          phablet = grid.phablet,
          mobile = grid.mobile;
      return "".concat(getWidth(mobile), " sm:").concat(getWidth(phablet), " md:").concat(getWidth(tablet), " lg:").concat(getWidth(desktop));
    }
  }, {
    key: "getItemsByLine",
    value: function getItemsByLine() {
      var _this$props2 = this.props,
          _this$props2$display = _this$props2.display,
          display = _this$props2$display === void 0 ? {} : _this$props2$display,
          _this$props2$responsi = _this$props2.responsive,
          responsive = _this$props2$responsi === void 0 ? {} : _this$props2$responsi;
      var _display$desktop = display.desktop,
          desktop = _display$desktop === void 0 ? 1 : _display$desktop,
          _display$tablet = display.tablet,
          tablet = _display$tablet === void 0 ? 1 : _display$tablet,
          _display$phablet = display.phablet,
          phablet = _display$phablet === void 0 ? 1 : _display$phablet,
          _display$mobile = display.mobile,
          mobile = _display$mobile === void 0 ? 1 : _display$mobile;
      var _responsive$isBrowser = responsive.isBrowserGreaterThan,
          isBrowserGreaterThan = _responsive$isBrowser === void 0 ? {} : _responsive$isBrowser;

      if (isBrowserGreaterThan.M && desktop > -1) {
        return desktop;
      }

      if (isBrowserGreaterThan.S && tablet > -1) {
        return tablet;
      }

      if (isBrowserGreaterThan.XS && phablet > -1) {
        return phablet;
      }

      return mobile;
    }
  }, {
    key: "getNumberOfItemsByLineExcludingSeeMore",
    value: function getNumberOfItemsByLineExcludingSeeMore() {
      return this.getItemsByLine();
    }
  }, {
    key: "getRest",
    value: function getRest() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          totalNumberToDisplay = _this$props3.totalNumberToDisplay;
      return totalNumberToDisplay ? totalNumberToDisplay - this.getItemsByLine() : react["Children"].count(children) - this.getItemsByLine();
    }
  }, {
    key: "getSeeMore",
    value: function getSeeMore() {
      var _this$props4 = this.props,
          hasSeeMore = _this$props4.hasSeeMore,
          isLoading = _this$props4.isLoading,
          seeMore = _this$props4.seeMore;
      return hasSeeMore && this.getRest() > 0 && !this.state.isExpanded ? Grid_jsx(MoreResults_MoreResults, Object(esm_extends["a" /* default */])({}, seeMore, {
        className: "h-full",
        isLoading: isLoading,
        number: this.getRest(),
        onClick: this.onClickSeeMore,
        grid: this.getGrid(),
        maxPlaceholders: this.getItemsByLine()
      })) : null;
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this2 = this;

      var hasOneRemaining = this.getRest() === 1;
      var filterItem = filterContext(hasOneRemaining, this.getNumberOfItemsByLineExcludingSeeMore(), !this.state.isExpanded);
      return react["Children"].toArray(this.props.children).filter(filterItem).map(function (item) {
        return Grid_jsx("div", {
          className: classnames_default()('fadeIn p-px10', _this2.getGrid(), _this2.props.childrenClassName),
          "data-testid": "Grid-item",
          key: item.key
        }, item);
      });
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return [].concat(Object(toConsumableArray["a" /* default */])(this.getChildren()), [this.getSeeMore()]).filter(function (i) {
        return i;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var isLoading = _ref.isLoading;

      if (isLoading && !this.props.isLoading && !this.state.isExpanded) {
        this.setState({
          isExpanded: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var items = this.getItems();
      return items.length ? Grid_jsx("div", {
        className: classnames_default()(className, 'flex flex-wrap -m-px10'),
        "data-testid": "grid"
      }, items.map(function (item, index) {
        return (
          /* eslint-disable react/no-array-index-key */
          Grid_jsx(react["Fragment"], {
            key: index
          }, item)
        );
      })) : null;
    }
  }]);

  return Grid;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Grid_Grid, "defaultProps", {
  display: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  },
  getChildren: function getChildren() {
    return Promise.resolve({});
  },
  grid: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  }
});

/* harmony default export */ var grid_Grid = __webpack_exports__["a"] = (Object(Responsive["a" /* default */])(Grid_Grid));

/***/ }),

/***/ "uRnh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
var themes = {
  "default": {
    thRoot: 'cursor-pointer flex items-center font-bold font-sans leading-one no-underline text-sm text-white',
    thIcon: 'rtl:mr-px5',
    thIconWidth: '2.5rem',
    thSText: 'text-base uppercase',
    thCustomText1: 'text-base uppercase'
  },
  black: {
    thRoot: 'flex justify-end items-center font-bold font-sans leading-tight no-underline text-initial text-gray-darker text-md',
    thIcon: 'text-gray-darker mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '2rem',
    thCustomText2: 'text-booking'
  },
  footerLite: {
    thRoot: 'flex flex-col lg:flex-row items-center text-center lg:text-initial text-blue',
    thIcon: 'lg:flex-shrink-0 mb-px10 lg:mb-0 lg:rtl:mr-px10',
    thIconWidth: '1.5625rem',
    thTexts: 'lg:flex-1 text-gray-darker text-base',
    thCustomText0: 'font-bold text-blue text-md',
    thCustomText1: 'font-bold text-blue text-md'
  },
  contact: {
    thRoot: 'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '1.75rem',
    thSText: 'hidden sm:block font-normal text-base text-gray-light'
  },
  contact2: {
    thRoot: 'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '3rem',
    thCustomText1: 'font-normal text-base text-gray-light',
    thCustomText2: 'font-normal text-base text-gray-darker'
  },
  smallFooterLite: {
    thRoot: 'cursor-pointer flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md text-blue',
    thIcon: 'text-blue mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '1.2rem',
    thSText: 'hidden sm:block font-normal text-base text-gray-darker'
  },
  search: {
    thRoot: 'cursor-pointer items-center font-sans no-underline text-sm text-white'
  }
};

/***/ }),

/***/ "ubam":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROFILE_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return notifyProfileChanged; });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("H6pA");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("rJ95");




var PROFILE_CHANGED = 'PLE_PROFILE_CHANGED';

function refreshCookie(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      unicodeFirstName = _ref.unicodeFirstName,
      unicodeLastName = _ref.unicodeLastName;
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.set(_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_2__[/* USER_INFO */ "d"], _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["oidc"].toUriEncodedState({
    firstName: firstName,
    lastName: lastName,
    unicodeFirstName: unicodeFirstName,
    unicodeLastName: unicodeLastName
  }));
}

function notifyProfileChanged(newProfile) {
  refreshCookie(newProfile);
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"])(PROFILE_CHANGED, newProfile);
}

/***/ }),

/***/ "unIT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_DATA_SCORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATA_SCORE_SESSION_STORAGE_KEY; });
var SET_DATA_SCORE = 'SET_DATA_SCORE';
var DATA_SCORE_SESSION_STORAGE_KEY = 'cmLeadScore';


/***/ }),

/***/ "ut/Y":
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__("ZCpW"),
    baseMatchesProperty = __webpack_require__("GDhZ"),
    identity = __webpack_require__("zZ0H"),
    isArray = __webpack_require__("Z0cm"),
    property = __webpack_require__("+c4W");

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ "v315":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ rootReducer; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/redux/es/redux.js
var redux = __webpack_require__("9OUN");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorageApi.js
var sessionStorageApi = __webpack_require__("9NGo");

// EXTERNAL MODULE: ./src/client/store/lead-info/constants.js
var constants = __webpack_require__("unIT");

// CONCATENATED MODULE: ./src/client/store/lead-info/leadInfo.reducer.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var initialState = {
  score: parseFloat(Object(sessionStorageApi["b" /* getFromSessionStorage */])(constants["a" /* DATA_SCORE_SESSION_STORAGE_KEY */])) || 0
};

var leadInfo_reducer_leadInfosReducer = function leadInfosReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      payload = action.payload;

  if (type === constants["b" /* SET_DATA_SCORE */]) {
    return _objectSpread(_objectSpread({}, state), {}, {
      score: payload.score
    });
  }

  return state;
};


// EXTERNAL MODULE: ./src/client/store/booking/customer-search/customerSearch.reducer.js
var customerSearch_reducer = __webpack_require__("E3ZW");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/redux-optimist-promise/build/index.js
var build = __webpack_require__("b0q8");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/constants.js
var kids_constants = __webpack_require__("wQ38");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/constants.js
var store_constants = __webpack_require__("cvSI");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.reducer.utils.js


function proposals_reducer_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function proposals_reducer_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      proposals_reducer_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      proposals_reducer_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



function getTransportsWithTransfer(proposal) {
  return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.transports), {}, {
    inbound: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, Object(lodash["get"])(proposal, 'transports.inbound')), {}, {
      transferIncluded: true
    }),
    outbound: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, Object(lodash["get"])(proposal, 'transports.outbound')), {}, {
      transferIncluded: true
    })
  });
}

function setTransferIncludedInProposal(proposal) {
  return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), Object(lodash["has"])(proposal, 'transports.inbound') && Object(lodash["has"])(proposal, 'transports.outbound') ? {
    transports: getTransportsWithTransfer(proposal)
  } : null);
}

function updateProposal(proposalId, state, updateFn) {
  var indexToUpdate = state.findIndex(function (p) {
    return Object(lodash["get"])(p, 'id') === proposalId;
  });
  return indexToUpdate !== -1 ? state.map(function (proposal, index) {
    return index === indexToUpdate ? updateFn(proposal) : proposal;
  }) : state;
}

function updateTransfers(state, proposalFields) {
  if (Object(lodash["isEmpty"])(proposalFields)) return state;

  var updateFn = function updateFn(proposal) {
    var currentProposal = proposalFields.find(function (_ref) {
      var id = _ref.id;
      return id === Object(lodash["get"])(proposal, 'id');
    }) || {};
    var price = currentProposal.price,
        availableTransfers = currentProposal.availableTransfers,
        paymentSchedule = currentProposal.paymentSchedule,
        selectedTransfers = currentProposal.selectedTransfers;
    return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), {}, {
      price: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.price), price),
      paymentSchedule: paymentSchedule,
      availableTransfers: availableTransfers || proposal.availableTransfers,
      selectedTransfers: selectedTransfers || proposal.selectedTransfers
    });
  };

  return state.map(updateFn);
}

function updateTransportError(state, proposalId, error) {
  var updateFn = function updateFn(proposal) {
    return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), {}, {
      transports: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.transports), {}, {
        error: error
      })
    });
  }; // $FlowFixMe


  return updateProposal(proposalId, state, updateFn);
}

function updateAttendees(state, proposalFields) {
  if (!proposalFields) return state;
  var price = proposalFields.price,
      attendees = proposalFields.attendees;

  var updateFn = function updateFn(proposal) {
    return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), {}, {
      price: price,
      attendees: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.attendees), {}, {
        list: attendees.list
      })
    });
  }; // $FlowFixMe


  return updateProposal(proposalFields.id, state, updateFn);
}


// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.reducer.js



function proposals_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function proposals_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      proposals_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      proposals_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var proposals_reducer_initialState = [];
function proposalsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : proposals_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case proposals_constants["p" /* PREPARE_BE */]:
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      {
        var proposals = Object(lodash["get"])(action, 'payload.proposals.proposals', []).map(setTransferIncludedInProposal).sort(proposalUtils["b" /* compareProposalsByComfort */]);
        var errors = Object(lodash["get"])(action, 'payload.proposals.errors', []);
        proposals.forEach(function (proposal) {
          if (proposal.transports) {
            Object(proposalUtils["y" /* saveRecommendedTransport */])(proposal.transports, proposal.id);
          }
        });
        return [].concat(Object(toConsumableArray["a" /* default */])(proposals), Object(toConsumableArray["a" /* default */])(errors));
      }

    case Object(build["resolve"])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
      {
        var paymentSchedule = action.payload.proposal.paymentSchedule;
        var selectedProposalId = Object(lodash["get"])(action, 'meta.payload.selectedProposalId');
        return state.map(function (proposal) {
          return proposal.id === selectedProposalId ? proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
            paymentSchedule: paymentSchedule
          }) : proposal;
        });
      }

    case Object(build["reject"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
      {
        // $FlowFixMe
        return [{
          errorCode: 500
        }];
      }

    case proposals_constants["w" /* SET_PROPOSALS */]:
      return Object(lodash["get"])(action, 'payload.proposals');

    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
      return action.payload.addAccommodation || state;

    case proposals_constants["y" /* UPDATE_ATTENDEES */]:
      return updateAttendees(state, Object(lodash["get"])(action, 'payload.proposal'));

    case proposals_constants["j" /* FETCH_PROPOSALS */]:
    case proposals_constants["f" /* CLEAR_PROPOSALS */]:
    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
    case store_constants["w" /* UPDATE_TRIP_DATE_CRITERIA */]:
      return proposals_reducer_initialState;

    case Object(build["resolve"])(proposals_constants["d" /* ADD_TRANSFER_TO_PROPOSALS */]):
      {
        var transfersAdded = Object(lodash["get"])(action, 'payload', []).map(function (item) {
          return Object(lodash["get"])(item, 'addTransfer');
        }).flat();
        return updateTransfers(state, transfersAdded);
      }

    case Object(build["resolve"])(proposals_constants["s" /* REMOVE_TRANSFER_FROM_PROPOSALS */]):
      {
        var transfersRemoved = Object(lodash["get"])(action, 'payload', []).map(function (item) {
          return Object(lodash["get"])(item, 'removeTransfer');
        }).flat();
        return updateTransfers(state, transfersRemoved);
      }

    case Object(build["resolve"])(proposals_constants["e" /* ADD_TRANSPORT */]):
      {
        if (!action.payload.addTransport) {
          return state;
        }

        return action.payload.addTransport.map(function (proposal) {
          return setTransferIncludedInProposal(proposal);
        });
      }

    case Object(build["reject"])(proposals_constants["e" /* ADD_TRANSPORT */]):
      var transportExpiredError = Object(lodash["get"])(action, 'payload.errors', []).find(function (error) {
        return Object(lodash["get"])(error, 'statusCode') === 400;
      });
      var proposalId = Object(lodash["get"])(action, 'meta.payload.proposalId');
      var errorInfo = Object(lodash["pick"])(transportExpiredError, ['statusCode', 'message']);
      return transportExpiredError ? updateTransportError(state, proposalId, errorInfo) : state;

    case Object(build["resolve"])(proposals_constants["v" /* SET_PROMO_CODE */]):
      return state.map(function (proposal) {
        if (proposal.id === Object(lodash["get"])(action, 'payload.promoCodeProposal.id')) {
          return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
            price: proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal.price), {}, {
              aggregateDiscount: Object(lodash["get"])(action, 'payload.promoCodeProposal.price.aggregateDiscount'),
              aggregateDiscountPromoCode: Object(lodash["get"])(action, 'payload.promoCodeProposal.price.aggregateDiscountPromoCode'),
              promoCode: Object(lodash["get"])(action, 'payload.promoCodeProposal.price.promoCode'),
              total: Object(lodash["get"])(action, 'payload.promoCodeProposal.price.total')
            }),
            paymentSchedule: Object(lodash["get"])(action, 'payload.promoCodeProposal.paymentSchedule')
          });
        }

        return proposal;
      });

    case proposals_constants["z" /* UPDATE_INSURANCES */]:
      var proposalFields = Object(lodash["get"])(action, 'payload.modifyInsurances.proposal');
      if (!proposalFields) return state;
      return updateProposal(proposalFields.id, state, function (proposal) {
        return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
          listInsurances: Object(toConsumableArray["a" /* default */])(proposalFields.listInsurances),
          price: proposalFields.price,
          paymentSchedule: proposalFields.paymentSchedule
        });
      });

    case proposals_constants["g" /* DELETE_INSURANCES */]:
      var proposalDeleteInsurances = Object(lodash["get"])(action, 'payload.deleteInsurances.proposal');
      if (!proposalDeleteInsurances) return state;
      return updateProposal(proposalDeleteInsurances.id, state, function (proposal) {
        return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
          listInsurances: Object(toConsumableArray["a" /* default */])(proposalDeleteInsurances.listInsurances),
          price: proposalDeleteInsurances.price,
          paymentSchedule: proposalDeleteInsurances.paymentSchedule
        });
      });

    case proposals_constants["u" /* SAVE_DONATION_TO_PROPOSALS */]:
      return state.map(function (proposal) {
        return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
          price: proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal.price), {}, {
            donation: action.payload
          })
        });
      });

    case Object(build["resolve"])(proposals_constants["c" /* ADD_SERVICE */]):
    case Object(build["resolve"])(proposals_constants["A" /* UPDATE_SERVICES */]):
    case Object(build["resolve"])(proposals_constants["h" /* DELETE_SERVICE */]):
      {
        // $FlowFixMe
        var data = Object.values(action.payload)[0];
        return state.map(function (proposal, proposalIndex) {
          return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), data[proposalIndex]);
        });
      }

    case Object(build["resolve"])(proposals_constants["x" /* SWITCH_PROPOSALS_OFFERS */]):
      return state.map(function (proposal) {
        var proposalData = action.payload.proposals.find(function (_ref) {
          var id = _ref.id;
          return id === proposal.id;
        });

        if (proposalData) {
          return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), proposalData);
        }

        return proposals_reducer_objectSpread({}, proposal);
      });

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/proposals/insurance/insurance.reducer.js

var insurance_reducer_initialState = {
  isAdded: false,
  isDeleted: false
};
var insurance_reducer_insuranceReducer = function insuranceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : insurance_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case proposals_constants["n" /* INSURANCE_ADDED */]:
      return {
        isDeleted: false,
        isAdded: true
      };

    case proposals_constants["o" /* INSURANCE_DELETED */]:
      return {
        isAdded: false,
        isDeleted: true
      };

    default:
      return state;
  }
};
// CONCATENATED MODULE: ./src/client/store/booking/resort/resort.reducer.js






var resort_reducer_initialState = null;
function resortReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : resort_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      {
        return Object(lodash["get"])(action, 'payload.proposals.resort', null);
      }

    case proposals_constants["p" /* PREPARE_BE */]:
      return Object(lodash["get"])(action, 'payload.resort', null);

    case proposals_constants["j" /* FETCH_PROPOSALS */]:
    case proposals_constants["f" /* CLEAR_PROPOSALS */]:
    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
    case store_constants["w" /* UPDATE_TRIP_DATE_CRITERIA */]:
      return resort_reducer_initialState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.action.js
var selectedProposalId_action = __webpack_require__("uGNg");

// CONCATENATED MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.reducer.js



var selectedProposalId_reducer_initialState = null;

function selectedProposalIdReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectedProposalId_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case proposals_constants["p" /* PREPARE_BE */]:
    case selectedProposalId_action["b" /* SELECT_PROPOSAL */]:
      return Object(lodash["get"])(action, 'payload.proposalId');

    case selectedProposalId_action["a" /* CLEAR_SELECTED_PROPOSAL */]:
      return selectedProposalId_reducer_initialState;

    default:
      return state;
  }
}

/* harmony default export */ var selectedProposalId_reducer = (selectedProposalIdReducer);
// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/constants.js
var departure_city_constants = __webpack_require__("PFCZ");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.constants.js
var duration_constants = __webpack_require__("RBvG");

// CONCATENATED MODULE: ./src/client/store/booking/best-proposal-id/bestProposalId.reducer.js










var bestProposalId_reducer_initialState = null;
function bestProposalIdReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bestProposalId_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
      {
        var proposals = Object(toConsumableArray["a" /* default */])(Object(lodash["get"])(action, 'payload.proposals.proposals', [])).sort(proposalUtils["b" /* compareProposalsByComfort */]);

        return Object(lodash["get"])(proposals, '[0].id', null);
      }

    case proposals_constants["w" /* SET_PROPOSALS */]:
      {
        return Object(lodash["get"])(action, 'payload.proposals[0].id', null);
      }

    case Object(build["reject"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case proposals_constants["f" /* CLEAR_PROPOSALS */]:
    case duration_constants["c" /* TRIP_INFORMATION_SET_DURATION */]:
    case departure_city_constants["b" /* TRIP_INFORMATION_SET_DEPARTURE_CITY */]:
    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
    case store_constants["w" /* UPDATE_TRIP_DATE_CRITERIA */]:
      {
        return bestProposalId_reducer_initialState;
      }

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.action.js
var additionalAccommodations_action = __webpack_require__("06Jt");

// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/is-loading/isLoading.reducer.js



var isLoading_reducer_initialState = false;

function isLoadingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isLoading_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return true;

    case Object(build["reject"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
    case Object(build["resolve"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      return false;

    default:
      return state;
  }
}

/* harmony default export */ var isLoading_reducer = (isLoadingReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/accommodations-sets/accommodationsSets.reducer.js


function accommodationsSets_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function accommodationsSets_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      accommodationsSets_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      accommodationsSets_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var accommodationsSets_reducer_initialState = [];

function accommodationsSetsReducer() {
  var _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : accommodationsSets_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return accommodationsSets_reducer_initialState;

    case Object(build["resolve"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      return ((action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.additionalAccommodations) || []).
      /**
       * Sometimes we get a corner case from API responses where arrangement accommodation does not match any of resort accommodations
       * In this case we could get and accommodationsSet with empty accommodations field... It makes no sense to display it to the user
       * See https://github.com/ClubMediterranee/cm-b2c/issues/14959
       */
      filter(function (additionalAccommodationSet) {
        return additionalAccommodationSet.accommodations && additionalAccommodationSet.accommodations.length > 0;
      }).map(function (accommodation, index) {
        return accommodationsSets_reducer_objectSpread(accommodationsSets_reducer_objectSpread({}, accommodation), {}, {
          accommodationSetNumber: index + 1
        });
      });

    default:
      return state;
  }
}

/* harmony default export */ var accommodationsSets_reducer = (accommodationsSetsReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/error/error.reducer.js



var error_reducer_initialState = null;

function additionalAccommodationsErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : error_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return error_reducer_initialState;

    case Object(build["reject"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      var error = Object(lodash["get"])(action, 'payload.errors[0]', {});
      return {
        statusCode: error.statusCode || 500,
        message: error.message || 'UNKNOWN ERROR'
      };

    default:
      return state;
  }
}

/* harmony default export */ var error_reducer = (additionalAccommodationsErrorReducer);
// EXTERNAL MODULE: ./src/client/components/widgets/additional-accommodations/AdditionalAccommodationsUtils.js
var AdditionalAccommodationsUtils = __webpack_require__("CwJu");

// EXTERNAL MODULE: ./src/utils/accommodation/accommodation.constants.js
var accommodation_constants = __webpack_require__("lZ21");

// CONCATENATED MODULE: ./src/client/store/filters/filtersHelper.js



function filtersHelper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function filtersHelper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      filtersHelper_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      filtersHelper_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var defaultMatch = function defaultMatch(a, b) {
  return a === b;
};

function _getMatcher(filter) {
  return filter.match || defaultMatch;
}

function _matchFilter(data) {
  return function (filter) {
    var dataValue = Object(lodash["get"])(data, filter.path);
    var filterValue = filter.value;
    return _getMatcher(filter)(dataValue, filterValue);
  };
}

function _toggleFilter(filters) {
  return function (toggledFilter) {
    return filters.map(function (filter) {
      var shouldToggleFilter = filter.path === toggledFilter.path && filter.value === toggledFilter.value;
      return filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
        selected: shouldToggleFilter ? !filter.selected : filter.selected
      });
    });
  };
}

function _filterDataSet(dataSet, filters) {
  var condition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return true;
  };
  var activeFilters = filters.filter(function (f) {
    return condition(f) === true;
  });
  return dataSet.filter(function (data) {
    var match = _matchFilter(data);

    return Object(lodash["isEmpty"])(activeFilters) || activeFilters.some(function (activeFilter) {
      return match(activeFilter);
    });
  });
}

function _removeUnusedFilters(filters) {
  return filters.map(function (filter) {
    return filter.selected === true && filter.matchedOccurrences === 0 ? filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
      selected: false
    }) : filter;
  });
}

function filterDataSetWithSelectedAndMatchedFilters(dataSet, filters) {
  return _filterDataSet(dataSet, filters, function (filter) {
    return filter.selected && Object(lodash["get"])(filter, 'matchedOccurrences', 0) > 0;
  });
}

function getDataSetIfFilterWasSelected(dataSet, filter) {
  return _filterDataSet(dataSet, [filter]);
}

function getFiltersWithMatchedOccurrences(dataSet) {
  return function (filters) {
    // First, we group all filters by their path
    var filtersByCategory = Object(lodash["groupBy"])(filters, 'category');
    return filters.map(function (filter) {
      // Then, for every filter, we get all data objects matching all active filters in all other categories
      var matchedResultsInOtherCategories = Object.keys(filtersByCategory).filter(function (category) {
        return category !== filter.category;
      }).map(function (filterKey) {
        return filterDataSetWithSelectedAndMatchedFilters(dataSet, Object(lodash["get"])(filtersByCategory, filterKey));
      }); // Then, we activate the current filter (whether its current activation state) and get all data objects matching only this filter

      var matchedResultsForCurrentFilter = getDataSetIfFilterWasSelected(dataSet, filter); // Finally, The intersection gives us the list of results matching all our active filters
      // prettier-ignore

      var matchedOccurrences = ( // $FlowFixMe
      lodash["intersectionBy"].apply(void 0, Object(toConsumableArray["a" /* default */])(matchedResultsInOtherCategories).concat([matchedResultsForCurrentFilter, 'id'])) || []).length;
      return filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
        matchedOccurrences: matchedOccurrences
      });
    });
  };
}

function _activateFilter(filters, valuesToActivate) {
  return filters.map(function (filter) {
    var matchedOccurrences = Object(lodash["get"])(filter, 'matchedOccurrences', 0);

    if (matchedOccurrences > 0 && valuesToActivate.includes(filter.value)) {
      return filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
        selected: true
      });
    }

    return filter;
  });
}

function getPreselectedFilters(filters, selectedProposal) {
  var accommodationFilters = filters.filter(function (f) {
    return f.category === 'accommodations' && Object(lodash["get"])(f, 'matchedOccurrences', 0) > 0;
  }); // categoryId is the comfort level of the room, used as value for comfort filters

  var selectedProposalComfort = Object(lodash["get"])(selectedProposal, 'accommodations[0].categoryId');
  var selectedProposalComfortOrder = accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */].indexOf(selectedProposalComfort); // at first, activate filters equal to selected proposal comfort level
  // and those with higher comfort level

  var higherComfortCodes = Object(lodash["slice"])(accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */], selectedProposalComfortOrder);
  var filtersToActivate = higherComfortCodes.filter(function (code) {
    return Object(lodash["find"])(accommodationFilters, {
      value: code
    });
  }); // if no equal or higher comfort level filter found,
  // activate the one below the selected proposal comfort level

  if (filtersToActivate.length === 0) {
    var lowerComfortCodes = Object(lodash["take"])(accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */], selectedProposalComfortOrder); // use findLast to start from the end of the array
    // and get the highest comfort level possible

    var codeToActivate = Object(lodash["findLast"])(lowerComfortCodes, function (code) {
      return Object(lodash["find"])(accommodationFilters, {
        value: code
      });
    });
    codeToActivate && filtersToActivate.push(codeToActivate);
  }

  switch (selectedProposalComfort) {
    // if selected proposal comfort level is club, club seaside view
    // or superior (default state), do not activate any filter
    case '000017': // club

    case '000048': // club seaside view

    case '000061':
      // superior
      return filters;

    default:
      return _activateFilter(filters, filtersToActivate);
  }
}

function toggleFilter(dataSet) {
  return function (filters, toggledFilter) {
    var updateMatchOccurrences = getFiltersWithMatchedOccurrences(dataSet);

    var updatedToggleFilters = _toggleFilter(filters)(toggledFilter);

    var updatedOccurrencesFilters = updateMatchOccurrences(updatedToggleFilters);
    return _removeUnusedFilters(updatedOccurrencesFilters);
  };
}

function filterDataSet(dataSet, filters) {
  if (!filters) {
    return dataSet;
  }

  var filtersByCategory = Object(lodash["groupBy"])(filters, 'category');
  return Object.keys(filtersByCategory) // $FlowFixMe
  .reduce(function (filteredResults, category) {
    return filterDataSetWithSelectedAndMatchedFilters(filteredResults, filtersByCategory[category]);
  }, dataSet);
}


// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/filters/filterUtils.js
var filterUtils = __webpack_require__("KxdP");

// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/filters/filters.reducer.js





var filters_reducer_initialState = null;
function filtersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filters_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalAccommodations = Object(lodash["get"])(action, 'payload.additionalAccommodations') || [];
  var proposal = Object(lodash["get"])(action, 'payload.selectedProposal') || null; // remove initial accommodation (related to selected proposal) from additional accommodations

  var filteredAdditionalAccommodations = proposal && additionalAccommodations.length ? Object(AdditionalAccommodationsUtils["a" /* filterAccommodations */])(proposal, additionalAccommodations) : additionalAccommodations;
  var getFiltersWithOccurrences = getFiltersWithMatchedOccurrences(filteredAdditionalAccommodations);

  switch (action.type) {
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return filters_reducer_initialState;

    case additionalAccommodations_action["b" /* CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS */]:
      var _action$payload = action.payload,
          i18n = _action$payload.i18n,
          selectedProposal = _action$payload.selectedProposal,
          shouldPreselectFilters = _action$payload.shouldPreselectFilters,
          resort = _action$payload.resort;
      var filters = Object(filterUtils["d" /* createFilters */])(filteredAdditionalAccommodations, i18n, resort);
      var filtersWithOccurences = getFiltersWithOccurrences(filters);
      return filtersWithOccurences && shouldPreselectFilters ? getPreselectedFilters(filtersWithOccurences, selectedProposal) : filtersWithOccurences;

    case additionalAccommodations_action["d" /* TOGGLE_ACCOMMODATIONS_FILTER */]:
      var filter = action.payload.filter;
      return toggleFilter(filteredAdditionalAccommodations)(state || [], filter);

    case additionalAccommodations_action["e" /* UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY */]:
      var category = action.payload.category;
      var updatedFilters = Object(filterUtils["e" /* unselectCategory */])(state || [])(category);
      return getFiltersWithOccurrences(updatedFilters);

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/is-data-fetched/isDataFetched.reducer.js


var isDataFetched_reducer_initialState = false;
function isDataFetched() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isDataFetched_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
      return false;

    case Object(build["reject"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
    case Object(build["resolve"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      return true;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/filtered-accommodations/filteredAccommodations.reducer.js



var filteredAccommodations_reducer_initialState = null;

function filteredAccommodationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filteredAccommodations_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalAccommodations = Object(lodash["get"])(action, 'payload.additionalAccommodations') || [];
  var filters = Object(lodash["get"])(action, 'payload.filters') || [];

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return filteredAccommodations_reducer_initialState;

    case additionalAccommodations_action["f" /* UPDATE_FILTERED_ACCOMMODATIONS_RESULTS */]:
      return filterDataSet(additionalAccommodations, filters);

    default:
      return state;
  }
}

/* harmony default export */ var filteredAccommodations_reducer = (filteredAccommodationsReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.reducer.js







var additionalAccommodations_reducer_additionalAccommodations = Object(redux["c" /* combineReducers */])({
  error: error_reducer,
  isLoading: isLoading_reducer,
  accommodationsSets: accommodationsSets_reducer,
  filters: filtersReducer,
  filteredAccommodations: filteredAccommodations_reducer,
  isDataFetched: isDataFetched
});
// EXTERNAL MODULE: ./src/client/store/booking/additional-transports/additionalTransports.action.js
var additionalTransports_action = __webpack_require__("04nu");

// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/is-loading/isLoading.reducer.js




var is_loading_isLoading_reducer_initialState = false;

function isLoading_reducer_isLoadingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : is_loading_isLoading_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
    case proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]:
      return true;

    case Object(build["resolve"])(additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]):
    case additionalTransports_action["b" /* CREATE_ADDITIONAL_TRANSPORTS_FILTERS */]:
    case Object(build["reject"])(additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["reject"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      return false;

    default:
      return state;
  }
}

/* harmony default export */ var is_loading_isLoading_reducer = (isLoading_reducer_isLoadingReducer);
// EXTERNAL MODULE: ./src/client/store/booking/additional-transports/transports/transports.reducer.js
var transports_reducer = __webpack_require__("Fk4B");

// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/error/error.reducer.js




var error_error_reducer_initialState = null;

function additionalTransportsErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : error_error_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return error_error_reducer_initialState;

    case Object(build["reject"])(additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]):
    case Object(build["reject"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      var error = Object(lodash["get"])(action, 'payload.errors[0]', {});
      return {
        statusCode: error.statusCode || 500,
        message: error.message || 'UNKNOWN ERROR'
      };

    default:
      return state;
  }
}

/* harmony default export */ var error_error_reducer = (additionalTransportsErrorReducer);
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__("YS3K");

// EXTERNAL MODULE: ./src/utils/transport/additionalTransports.constants.js
var additionalTransports_constants = __webpack_require__("dGB2");

// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/filters/filterUtils.js



function filterUtils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function filterUtils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      filterUtils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      filterUtils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






function geIntValue(time) {
  return time.hours * 60 + time.minutes;
}

function isTimeBefore(time, refTime) {
  return geIntValue(time) < geIntValue(refTime);
}

function isTimeAfter(time, refTime) {
  return geIntValue(time) >= geIntValue(refTime);
}

function isTimeInRange(time) {
  return function (timeRange) {
    return isTimeAfter(time, timeRange.start) && isTimeBefore(time, timeRange.end);
  };
}

function timeRangeValueToString(_ref) {
  var hours = _ref.hours,
      minutes = _ref.minutes;
  return "".concat(hours, ":").concat(minutes < 10 ? "0".concat(minutes) : minutes);
}

function timeRangeToString(time) {
  return "".concat(timeRangeValueToString(time.start), " - ").concat(timeRangeValueToString(time.end));
}

var STRICT_EQUALITY_MATCHER = function STRICT_EQUALITY_MATCHER(a, b) {
  return a === b;
};

var ARRAY_INCLUSION_MATCHER = function ARRAY_INCLUSION_MATCHER(array, item) {
  return array.includes(item);
};

var COMPANIES_MATCHER = function COMPANIES_MATCHER(companies, companyId) {
  return !!companies.find(function (c) {
    return c.id === companyId;
  });
};

var TIME_RANGE_MATCHER = function TIME_RANGE_MATCHER(time, timeRange) {
  return isTimeInRange(time)(timeRange);
};

function createCompaniesFilters(transports) {
  var companies = Object(fp["pipe"])([Object(fp["map"])(Object(fp["path"])('filterValues.companies')), fp["flatten"], fp["compact"], Object(fp["uniqBy"])('id')])(transports);
  return companies.map(function (company) {
    return {
      id: shortid_default.a.generate(),
      category: additionalTransports_constants["d" /* COMPANIES_CATEGORY */],
      match: COMPANIES_MATCHER,
      meta: {
        imageUrl: company.logo,
        label: company.label
      },
      path: 'filterValues.companies',
      selected: false,
      value: company.id
    };
  });
}

function getLayoversInfo(i18n) {
  return function (layovers) {
    switch (layovers) {
      case 0:
        return {
          label: Object(lodash["get"])(i18n, 'filters.layovers.direct'),
          icon: additionalTransports_constants["o" /* ZERO_LAYOVERS_ICON */]
        };

      case 1:
        return {
          label: "".concat(layovers, " ").concat(Object(lodash["get"])(i18n, 'filters.layovers.stop.label_1')),
          icon: additionalTransports_constants["l" /* ONE_LAYOVERS_ICON */]
        };

      default:
        return {
          label: "".concat(layovers, " ").concat(Object(lodash["get"])(i18n, 'filters.layovers.stop.label_n')),
          icon: additionalTransports_constants["n" /* TWO_LAYOVERS_ICON */]
        };
    }
  };
}

function createLayoversFilters(transports, i18n) {
  var layoversInfo = getLayoversInfo(i18n);
  var layovers = Object(fp["pipe"])([Object(fp["map"])(Object(fp["path"])('filterValues.layovers')), Object(fp["filter"])(fp["isNumber"]), Object(fp["sortBy"])(fp["identity"]), fp["sortedUniq"]])(transports);
  return layovers.map(function (layover) {
    var _layoversInfo = layoversInfo(layover),
        label = _layoversInfo.label,
        icon = _layoversInfo.icon;

    return {
      id: shortid_default.a.generate(),
      category: additionalTransports_constants["k" /* LAYOVERS_CATEGORY */],
      match: STRICT_EQUALITY_MATCHER,
      meta: {
        icon: icon,
        label: label
      },
      path: 'filterValues.layovers',
      selected: false,
      value: layover
    };
  });
}

function getTimeRangeTransformations(timeRanges) {
  return function (pathValue) {
    function getTimeRange(time) {
      return time && timeRanges.find(isTimeInRange(time));
    }

    return [Object(fp["map"])(Object(fp["path"])(pathValue)), Object(fp["map"])(getTimeRange), fp["compact"], fp["uniq"], Object(fp["sortBy"])(function (timeRange) {
      return timeRange.start.hours;
    })];
  };
}

function createTimeRangeFilters(transports, timeRanges) {
  return function (pathValue) {
    var values = Object(fp["pipe"])(getTimeRangeTransformations(timeRanges)(pathValue))(transports);
    return values.map(function (value) {
      return {
        id: shortid_default.a.generate(),
        category: additionalTransports_constants["m" /* TIME_RANGES_CATEGORY */],
        match: TIME_RANGE_MATCHER,
        meta: {
          icon: value.icon,
          label: value.label,
          subLabel: timeRangeToString(value)
        },
        path: pathValue,
        selected: false,
        value: value
      };
    });
  };
}

function createCabinClassFilters(transports, i18n) {
  var cabinClassPath = 'filterValues.cabinClasses';
  var cabinClasses = Object(fp["pipe"])([Object(fp["map"])(Object(fp["path"])('filterValues.cabinClasses')), fp["compact"]])(transports);
  return !Object(lodash["isEmpty"])(cabinClasses) ? [{
    id: shortid_default.a.generate(),
    category: additionalTransports_constants["b" /* CABIN_CLASS_CATEGORY */],
    match: ARRAY_INCLUSION_MATCHER,
    meta: {
      label: Object(lodash["get"])(i18n, 'filters.cabinClass.economy')
    },
    path: cabinClassPath,
    selected: false,
    value: additionalTransports_constants["c" /* CABIN_CLASS_ECO */] // temporairement en dur car on ne récupère que des ECO pour les vols

  }, {
    id: shortid_default.a.generate(),
    category: additionalTransports_constants["b" /* CABIN_CLASS_CATEGORY */],
    match: ARRAY_INCLUSION_MATCHER,
    meta: {
      label: Object(lodash["get"])(i18n, 'filters.cabinClass.business')
    },
    path: cabinClassPath,
    selected: false,
    value: additionalTransports_constants["a" /* CABIN_CLASS_BUSINESS */]
  }] : [];
}

function createFilters(transports, timeRanges, i18n) {
  var timeRangeFilters = createTimeRangeFilters(transports, timeRanges);
  return [].concat(Object(toConsumableArray["a" /* default */])(createCabinClassFilters(transports, i18n)), Object(toConsumableArray["a" /* default */])(createCompaniesFilters(transports)), Object(toConsumableArray["a" /* default */])(createLayoversFilters(transports, i18n)), Object(toConsumableArray["a" /* default */])(timeRangeFilters('filterValues.inboundDepartureTime')), Object(toConsumableArray["a" /* default */])(timeRangeFilters('filterValues.inboundArrivalTime')), Object(toConsumableArray["a" /* default */])(timeRangeFilters('filterValues.outboundDepartureTime')), Object(toConsumableArray["a" /* default */])(timeRangeFilters('filterValues.outboundArrivalTime')));
}

function unselectCategory(filters) {
  return function (category) {
    return filters.map(function (f) {
      return filterUtils_objectSpread(filterUtils_objectSpread({}, f), {}, {
        selected: f.category === category ? false : f.selected
      });
    });
  };
}

function unselectFilters(filters, filtersToDisable) {
  return filters.map(function (f) {
    var filterToDisable = filtersToDisable.find(function (_ref2) {
      var id = _ref2.id;
      return id === f.id;
    });
    return filterUtils_objectSpread(filterUtils_objectSpread({}, f), {}, {
      selected: filterToDisable ? false : f.selected
    });
  });
}


// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/filters/filters.reducer.js




var filters_filters_reducer_initialState = null;
function filters_reducer_filtersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filters_filters_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalTransports = Object(lodash["get"])(action, 'payload.additionalTransports') || [];
  var getFiltersWithOccurrences = getFiltersWithMatchedOccurrences(additionalTransports);

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["a" /* CLEAR_ADDITIONAL_TRANSPORTS */]:
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return filters_filters_reducer_initialState;

    case additionalTransports_action["b" /* CREATE_ADDITIONAL_TRANSPORTS_FILTERS */]:
      var i18n = Object(lodash["get"])(action, 'payload.i18n') || {};
      var timeRanges = Object(lodash["get"])(i18n, 'filters.departureArrival.timeRanges') || [];
      var filters = createFilters(additionalTransports, timeRanges, i18n);
      return getFiltersWithOccurrences(filters);

    case additionalTransports_action["g" /* TOGGLE_FILTER */]:
      var filter = Object(lodash["get"])(action, 'payload.filter');
      return toggleFilter(additionalTransports)(state || [], filter);

    case additionalTransports_action["h" /* UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY */]:
      var category = Object(lodash["get"])(action, 'payload.category', '');
      var updatedFilters = unselectCategory(state || [])(category);
      return getFiltersWithOccurrences(updatedFilters);

    case additionalTransports_action["c" /* DISABLE_FILTERS */]:
      var filtersToDisable = Object(lodash["get"])(action, 'payload.filters', []);
      return getFiltersWithOccurrences(unselectFilters(state || [], filtersToDisable));

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/filtered-transports/filteredTransports.reducer.js



var filteredTransports_reducer_initialState = null;

function filteredTransportsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filteredTransports_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalTransports = Object(lodash["get"])(action, 'payload.additionalTransports') || [];
  var filters = Object(lodash["get"])(action, 'payload.filters') || [];

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["a" /* CLEAR_ADDITIONAL_TRANSPORTS */]:
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return filteredTransports_reducer_initialState;

    case additionalTransports_action["f" /* SORT_ADDITIONAL_TRANSPORTS */]:
      var sorterPath = Object(lodash["get"])(action, 'payload.sorter.path');
      return Object(lodash["sortBy"])(filterDataSet(additionalTransports, filters), sorterPath);

    case additionalTransports_action["i" /* UPDATE_FILTERED_RESULTS */]:
      return filterDataSet(additionalTransports, filters);

    default:
      return state;
  }
}

/* harmony default export */ var filteredTransports_reducer = (filteredTransportsReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/sorters/constants.js
var sorterByPrice = {
  selected: false,
  id: 'best-price',
  name: 'sortByBestPrices',
  path: 'totalDifferentialPrice.value'
};
var sorterByRecommendation = {
  selected: false,
  id: 'recommendation',
  name: 'sortByRecommendation',
  path: ''
};

// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/sorters/sorters.reducer.js


function sorters_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function sorters_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      sorters_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      sorters_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var sorters_reducer_initialState = [sorters_reducer_objectSpread(sorters_reducer_objectSpread({}, sorterByRecommendation), {}, {
  selected: true
}), sorterByPrice];
function sortersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sorters_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case additionalTransports_action["a" /* CLEAR_ADDITIONAL_TRANSPORTS */]:
      return sorters_reducer_initialState;

    case additionalTransports_action["f" /* SORT_ADDITIONAL_TRANSPORTS */]:
      var selectedSorterId = Object(lodash["get"])(action, 'payload.sorter.id');
      return state.map(function (sorter) {
        return sorters_reducer_objectSpread(sorters_reducer_objectSpread({}, sorter), {}, {
          selected: sorter.id === selectedSorterId
        });
      });

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/transports/searchCriteria.reducer.js


var searchCriteria_reducer_initialState = [];

function searchCriteriaReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchCriteria_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action === null || action === void 0 ? void 0 : action.type) {
    case additionalTransports_action["e" /* SEARCH_CRITERIA_TRANSPORTS */]:
      var criterias = (action === null || action === void 0 ? void 0 : action.payload) || [];
      return Object(toConsumableArray["a" /* default */])(criterias);

    default:
      return state;
  }
}

/* harmony default export */ var searchCriteria_reducer = (searchCriteriaReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/additionalTransports.reducer.js








/* harmony default export */ var additionalTransports_reducer = (Object(redux["c" /* combineReducers */])({
  error: error_error_reducer,
  isLoading: is_loading_isLoading_reducer,
  transports: transports_reducer["a" /* default */],
  filters: filters_reducer_filtersReducer,
  sorters: sortersReducer,
  filteredTransports: filteredTransports_reducer,
  searchCriteria: searchCriteria_reducer
}));
// CONCATENATED MODULE: ./src/client/store/booking/payment-providers/paymentProviders.reducer.js



var paymentProviders_reducer_initialState = [];

function paymentProvidersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : paymentProviders_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
      return Object(lodash["get"])(action, 'payload.paymentProviders', paymentProviders_reducer_initialState);

    default:
      return state;
  }
}

/* harmony default export */ var paymentProviders_reducer = (paymentProvidersReducer);
// CONCATENATED MODULE: ./src/client/store/booking/booking-engine-entry/bookingEngineEntry.reducer.js

var bookingEngineEntry_reducer_initialState = null;
function bookingEngineEntry() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bookingEngineEntry_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case proposals_constants["j" /* FETCH_PROPOSALS */]:
      {
        return action.payload.bookingEngineEntry;
      }

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/attendees/attendees.reducer.js



function attendees_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function attendees_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      attendees_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      attendees_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var attendees_reducer_initialState = {
  adultsAttendees: [],
  kidsAttendees: []
};
function attendeesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : attendees_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case proposals_constants["p" /* PREPARE_BE */]:
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      {
        var _action$payload = action.payload,
            adultsAttendees = _action$payload.adultsAttendees,
            kidsAttendees = _action$payload.kidsAttendees;
        return attendees_reducer_objectSpread(attendees_reducer_objectSpread({}, state), {}, {
          adultsAttendees: adultsAttendees ? [].concat(Object(toConsumableArray["a" /* default */])(state.adultsAttendees), Object(toConsumableArray["a" /* default */])(adultsAttendees)) : state.adultsAttendees,
          kidsAttendees: kidsAttendees ? [].concat(Object(toConsumableArray["a" /* default */])(state.kidsAttendees), Object(toConsumableArray["a" /* default */])(kidsAttendees)) : state.kidsAttendees
        });
      }

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/suggestions/suggestions.reducer.js


function suggestions_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function suggestions_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      suggestions_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      suggestions_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var suggestions_reducer_initialState = {
  dates: [],
  durations: [],
  resorts: []
};
function suggestionsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : suggestions_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
      {
        var dates = Object(lodash["get"])(action, 'payload.proposals.dateSuggestion', []);
        var durations = Object(lodash["get"])(action, 'payload.proposals.durationSuggestions', []);
        var resorts = Object(lodash["get"])(action, 'payload.proposals.suggestions', []);
        return suggestions_reducer_objectSpread(suggestions_reducer_objectSpread({}, state), {}, {
          dates: dates,
          resorts: resorts,
          durations: durations
        });
      }

    case proposals_constants["f" /* CLEAR_PROPOSALS */]:
      return suggestions_reducer_initialState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/booking/criteria-list/criteriaList.reducer.js
var criteriaList_reducer = __webpack_require__("FcTP");

// EXTERNAL MODULE: ./src/client/store/booking/entry-route/entryRoute.reducer.js
var entryRoute_reducer = __webpack_require__("m9Sl");

// CONCATENATED MODULE: ./src/client/store/booking/booking.reducer.js















var booking = Object(redux["c" /* combineReducers */])({
  additionalAccommodations: additionalAccommodations_reducer_additionalAccommodations,
  additionalTransports: additionalTransports_reducer,
  attendees: attendeesReducer,
  bestProposalId: bestProposalIdReducer,
  bookingEngineEntry: bookingEngineEntry,
  customerSearch: customerSearch_reducer["b" /* customerSearch */],
  insurance: insurance_reducer_insuranceReducer,
  paymentProviders: paymentProviders_reducer,
  proposals: proposalsReducer,
  resort: resortReducer,
  selectedProposalId: selectedProposalId_reducer,
  suggestions: suggestionsReducer,
  criteriaList: criteriaList_reducer["b" /* criteriaListReducer */],
  entryRoute: entryRoute_reducer["c" /* entryRouteReducer */]
});
// EXTERNAL MODULE: ./src/client/store/calendar/calendar.helper.js
var calendar_helper = __webpack_require__("VtPb");

// EXTERNAL MODULE: ./src/client/store/utils/createReducer.js
var createReducer = __webpack_require__("4Bi9");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// CONCATENATED MODULE: ./src/client/store/calendar/calendar.reducer.js


var _createReducer;

function calendar_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function calendar_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      calendar_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      calendar_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var calendar_reducer_initialState = {
  basePrice: null,
  bookableDateLastRequestId: -1,
  byDays: {},
  calendar: {},
  initialDuration: null,
  isLoading: true,
  errorResponse: {},
  selectedMonth: Object(calendar_helper["b" /* getDefaultSelectedMonth */])(),
  lastRequestId: -1,
  tripPrice: {},
  tripPriceLastRequestId: -1,
  tripPriceIsLoading: false
};
var calendarReducer = Object(createReducer["a" /* default */])(calendar_reducer_initialState, (_createReducer = {}, Object(defineProperty["a" /* default */])(_createReducer, store_constants["t" /* SYNC_WITH_LOCATION */], function (state, action) {
  var _action$payload$locat = action.payload.location.queryParams,
      queryParams = _action$payload$locat === void 0 ? {} : _action$payload$locat;

  if (!queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]]) {
    return state;
  }

  var selectedMonth = Object(calendar_helper["b" /* getDefaultSelectedMonth */])(queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]] || state.selectedMonth, uri_constants["e" /* QUERY_DATE_FORMAT */]);
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    selectedMonth: selectedMonth
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["f" /* FETCH_CALENDAR */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    isLoading: true,
    lastRequestId: Object(lodash["get"])(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["resolve"])(store_constants["f" /* FETCH_CALENDAR */]), function (state, action) {
  var _action$optimist = action.optimist;
  _action$optimist = _action$optimist === void 0 ? {} : _action$optimist;
  var _action$optimist$id = _action$optimist.id,
      id = _action$optimist$id === void 0 ? -1 : _action$optimist$id,
      calendar = action.payload.calendar; // If there is another request in progress

  if (id !== state.lastRequestId || !calendar) {
    return state;
  }

  var selectedMonth = state.selectedMonth;
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    basePrice: calendar.basePrice,
    byDays: Object(calendar_helper["c" /* getPricesByDays */])(calendar),
    calendar: calendar,
    selectedMonth: Object(calendar_helper["d" /* getSelectedMonth */])(calendar, selectedMonth),
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["reject"])(store_constants["f" /* FETCH_CALENDAR */]), function (state, action) {
  var errors = action.payload.errors || '';
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    byDays: {},
    errorResponse: {
      errors: errors
    },
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["d" /* FETCH_BOOKABLE_DATES */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    bookableDatesLoading: true,
    bookableDateLastRequestId: Object(lodash["get"])(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["resolve"])(store_constants["d" /* FETCH_BOOKABLE_DATES */]), function (state, action) {
  var _action$optimist2 = action.optimist;
  _action$optimist2 = _action$optimist2 === void 0 ? {} : _action$optimist2;
  var _action$optimist2$id = _action$optimist2.id,
      id = _action$optimist2$id === void 0 ? -1 : _action$optimist2$id,
      bookableDates = action.payload.bookableDates;

  if (id !== state.bookableDateLastRequestId || !bookableDates) {
    return state;
  }

  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    bookableDates: bookableDates,
    bookableDatesLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["reject"])(store_constants["d" /* FETCH_BOOKABLE_DATES */]), function (state, action) {
  var errors = action.payload.errors || '';
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    bookableDates: {},
    errorResponse: {
      errors: errors
    },
    bookableDatesLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["a" /* CALENDAR_CHANGE_MONTH */], function (state, action) {
  var selectedMonth = action.payload.selectedMonth || calendar_helper["a" /* INITIAL_MONTH */];
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    selectedMonth: selectedMonth
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["c" /* CLEAR_CALENDAR */], function () {
  return calendar_reducer_initialState;
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["v" /* TRIP_INFORMATION_SET_DEPARTURE_DATE */], function (state, action) {
  if (!action.payload.departureDate) {
    return state;
  }

  var selectedMonth = Object(calendar_helper["b" /* getDefaultSelectedMonth */])(action.payload.departureDate);
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    selectedMonth: selectedMonth
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["b" /* CALENDAR_SET_INITIAL_DURATION */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    initialDuration: action.payload.duration
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["h" /* FETCH_CALENDAR_TRIP_PRICE */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    tripPriceIsLoading: true,
    tripPriceLastRequestId: Object(lodash["get"])(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["resolve"])(store_constants["h" /* FETCH_CALENDAR_TRIP_PRICE */]), function (state, action) {
  var _action$optimist3 = action.optimist;
  _action$optimist3 = _action$optimist3 === void 0 ? {} : _action$optimist3;
  var _action$optimist3$id = _action$optimist3.id,
      id = _action$optimist3$id === void 0 ? -1 : _action$optimist3$id,
      _action$payload = action.payload;
  _action$payload = _action$payload === void 0 ? {} : _action$payload;
  var tripPrice = _action$payload.price;

  if (id !== state.tripPriceLastRequestId) {
    return state;
  }

  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    tripPrice: tripPrice,
    tripPriceIsLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["reject"])(store_constants["h" /* FETCH_CALENDAR_TRIP_PRICE */]), function (state) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    tripPrice: {},
    tripPriceIsLoading: false
  });
}), _createReducer));
// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// CONCATENATED MODULE: ./src/client/store/cms/cms.reducer.js


function cms_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function cms_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      cms_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      cms_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var cms_reducer_initialState = {};
function cmsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cms_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case Object(build["resolve"])(cms_actions["a" /* GET_BOOKING_ENGINE_I18N */]):
    case cms_actions["b" /* SET_CMS */]:
      {
        var data = Object(lodash["merge"])({}, state, cms_reducer_objectSpread(cms_reducer_objectSpread(cms_reducer_objectSpread({}, Object(lodash["get"])(action, 'payload.config', {})), Object(lodash["get"])(action, 'payload.legalInformations', {})), {}, {
          paymentProviders: Object(lodash["get"])(action, 'payload.paymentProviders', {})
        }));
        Object(src_i18n["a" /* addTranslationKeys */])(data);
        return data;
      }

    default:
      return state;
  }
}
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./node_modules/entities/index.js
var entities = __webpack_require__("4oK2");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/client/store/faceting/constants.js
var store_faceting_constants = __webpack_require__("9QcM");

// CONCATENATED MODULE: ./src/client/store/faceting/faceting.reducer.js




var faceting_reducer_createReducer;

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function faceting_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function faceting_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      faceting_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      faceting_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









var IGNORED_FILTERS_IDS = [faceting_constants["z" /* PRODUCT_FACET_ID */], faceting_constants["m" /* DEPARTURE_DATE_MAX_FACET_ID */], faceting_constants["v" /* LOCALE_FACET_ID */], faceting_constants["f" /* COUNTRIES_FACET_ID */]];

function catalogFacetItemToState(item) {
  return {
    label: item.i18n,
    value: item.filter,
    count: item.freq
  };
} // Pertimm will always send `interpretation_explanation.interpretations` dates
// in the format 'DD/MM/YYYY', for any locale


var PERTIMM_INTERPRETATION_DATE_FORMAT = 'DD/MM/YYYY';
var PERTIMM_DEPARTURE_MIN_DATE = 'departure_date_min';
var PERTIMM_DEPARTURE_MAX_DATE = 'departure_date_max';
/**
 * Takes the Pertimm catalog of facets and restructure it before storage in redux store.
 */

function catalogToState() {
  var catalogs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var catalogIdsAsList = [faceting_constants["j" /* DEPARTURE_CITY_FACET_ID */], faceting_constants["f" /* COUNTRIES_FACET_ID */], faceting_constants["e" /* CHILDCARE_FACET_ID */], faceting_constants["B" /* TYPES_OF_STAY_FACET_ID */], faceting_constants["q" /* FACET_COMFORT_ID */], faceting_constants["p" /* DURATION_FACET */]];
  var catalogIdsAsTree = [faceting_constants["a" /* ACTIVITIES_FACET_ID */], faceting_constants["o" /* DESTINATIONS_FACET_ID */]];
  var facetsAsList = catalogs.filter(function (catalog) {
    return catalogIdsAsList.includes(catalog.id);
  }).map(function (_ref) {
    var id = _ref.id,
        name = _ref.name,
        list = _ref.list;
    return {
      id: id,
      name: name,
      // $FlowFixMe
      list: list.map(catalogFacetItemToState)
    };
  });
  var facetsAsTree = catalogs.filter(function (catalog) {
    return catalogIdsAsTree.includes(catalog.id);
  }).map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        tree = _ref2.tree;
    return {
      id: id,
      name: name,
      // $FlowFixMe
      list: tree.map(function (list) {
        return faceting_reducer_objectSpread(faceting_reducer_objectSpread({
          id: list.name
        }, catalogFacetItemToState(list)), {}, {
          list: list.tree.map(catalogFacetItemToState)
        });
      })
    };
  });
  return facetsAsList.concat(facetsAsTree);
}
function filtersToActiveFacetsState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return filters.reduce(function (acc, filter) {
    var categoryId = filter.id;

    if (faceting_constants["r" /* FILTERABLE_FACETS_IDS */].includes(categoryId)) {
      return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, categoryId, faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, acc[categoryId]), {}, Object(defineProperty["a" /* default */])({}, filter.value, true))));
    }

    return acc;
  }, {});
}

function sanitizeFilters(filters) {
  return filters.filter(function (filter) {
    return !Object(lodash["includes"])(IGNORED_FILTERS_IDS, Object(lodash["get"])(filter, 'id'));
  });
}

function filtersToState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return sanitizeFilters(filters).map(function (filter) {
    return {
      id: Object(lodash["get"])(filter, 'id'),
      name: Object(lodash["get"])(filter, 'value'),
      label: Object(lodash["get"])(filter, 'value_i18n'),
      selected: true
    };
  });
}

function parseBanners() {
  var banners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  try {
    return banners.map(function (banner) {
      return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, banner), {}, {
        content: JSON.parse(banner.content)
      });
    });
  } catch (e) {
    return [];
  }
}

function removeUnselectedFiltersFromActiveFacetsState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var activeFacetsState = arguments.length > 1 ? arguments[1] : undefined;

  var activeFacets = faceting_reducer_objectSpread({}, activeFacetsState);

  var newActiveFacets = {};

  if (filters.length) {
    var _loop = function _loop(categoryId) {
      if (activeFacets.hasOwnProperty(categoryId)) {
        var categoryIdFilter = Object(toConsumableArray["a" /* default */])(filters).filter(function (_ref3) {
          var id = _ref3.id;
          return id === categoryId;
        });

        if (categoryIdFilter.length) {
          newActiveFacets[categoryId] = {};

          var _loop2 = function _loop2(categoryName) {
            if (activeFacets[categoryId].hasOwnProperty(categoryName) && // $FlowFixMe
            categoryIdFilter.some(function (_ref4) {
              var name = _ref4.name,
                  id = _ref4.id;
              return name === categoryName && id === categoryId;
            })) {
              newActiveFacets[categoryId][categoryName] = activeFacets[categoryId][categoryName];
            }
          };

          for (var categoryName in activeFacets[categoryId]) {
            _loop2(categoryName);
          }
        }
      }
    };

    for (var categoryId in activeFacets) {
      _loop(categoryId);
    }
  }

  return newActiveFacets;
}
var faceting_reducer_initialState = {
  // Special pertimm marchandising rules with pre-parameterized criteria
  // such as `minDate` / `maxDate` for some user queries such as `noel`.
  pertimmInterpretations: {},
  products: [],
  recommandedProducts: [],
  facets: [],
  activeFacets: {},
  childcareAvailabilities: [],
  filters: [],
  query: {
    label: ''
  },
  redirection: null,
  scrollToResults: false,
  isLoading: true,
  isPriceLoading: true,
  isLoadingChildcareAvailabilities: false,
  isSearchEnabled: false,
  isSelectionModeEnabled: false,
  kidsValidationState: [],
  joyviewOffsetSell: -1,
  resortOffsetSell: -1,
  productsSelectedForComparison: [],
  prices: [],
  noResults: false,
  lastRequestId: -1,
  lastRecommandedRequestId: -1,
  isDateRequired: false
};
var facetingReducer = Object(createReducer["a" /* default */])(faceting_reducer_initialState, (faceting_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["f" /* FACETING_RESET_REDIRECTION */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    redirection: null
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["g" /* FACETING_RESET_SEARCH */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    products: [],
    prices: [],
    childcareAvailabilities: [],
    redirection: null,
    scrollToResults: false,
    isLoading: true,
    noResults: false,
    searchIsEnabled: false
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["c" /* FACETING_LOAD_OFFSET_SELL_REQUEST */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    joyviewOffsetSell: -1,
    resortOffsetSell: -1
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["c" /* FACETING_LOAD_OFFSET_SELL_REQUEST */]), function (state, action) {
  var locale = action.payload.locale;
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    joyviewOffsetSell: (locale === null || locale === void 0 ? void 0 : locale.joyviewOffsetSell) || -1,
    resortOffsetSell: (locale === null || locale === void 0 ? void 0 : locale.resortOffsetSell) || -1
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["c" /* FACETING_LOAD_OFFSET_SELL_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    joyviewOffsetSell: -1,
    resortOffsetSell: -1
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["d" /* FACETING_LOAD_PRODUCTS_REQUEST */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    childcareAvailabilities: [],
    isLoading: true,
    lastRecommandedRequestId: Object(lodash["get"])(action, 'optimist.id', -1),
    recommandedProducts: [],
    noResults: true,
    prices: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["d" /* FACETING_LOAD_PRODUCTS_REQUEST */]), function (state, action) {
  var _action$optimist; // If there is another request in progress


  if ((action === null || action === void 0 ? void 0 : (_action$optimist = action.optimist) === null || _action$optimist === void 0 ? void 0 : _action$optimist.id) !== state.lastRecommandedRequestId) {
    return state;
  }

  var resorts = action.payload.resorts;
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    recommandedProducts: resorts,
    noResults: true
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["d" /* FACETING_LOAD_PRODUCTS_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    noResults: true
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["h" /* FACETING_SEARCH_REQUEST */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    childcareAvailabilities: [],
    isLoading: true,
    lastRequestId: Object(lodash["get"])(action, 'optimist.id', -1),
    noResults: false,
    prices: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["h" /* FACETING_SEARCH_REQUEST */]), function (state, action) {
  // If there is another request in progress
  if (Object(lodash["get"])(action, 'optimist.id') !== state.lastRequestId) {
    return state;
  }

  var products = action.payload.search.products;
  var productsSelectedForComparison = Object(lodash["get"])(state, 'productsSelectedForComparison', []).filter(function (selectedProductId) {
    return products.some(function (product) {
      return product.id === selectedProductId;
    });
  });
  var pertimmInterpretations = Object(lodash["get"])(action.payload, 'interpretation_explanation.interpretations', []).reduce(function (acc, interpretation) {
    if (interpretation.filter_name === PERTIMM_DEPARTURE_MIN_DATE) {
      acc.minDate = Object(dateUtils["d" /* getTimestamp */])(interpretation.filter_value, PERTIMM_INTERPRETATION_DATE_FORMAT);
    }

    if (interpretation.filter_name === PERTIMM_DEPARTURE_MAX_DATE) {
      acc.maxDate = Object(dateUtils["d" /* getTimestamp */])(interpretation.filter_value, PERTIMM_INTERPRETATION_DATE_FORMAT);
    }

    return acc;
  }, {});
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    banners: parseBanners(action.payload.banners),
    pertimmInterpretations: pertimmInterpretations,
    // If the catalog of facets is empty (e.g. "no results"), keep the previous state
    facets: !Object(lodash["isEmpty"])(action.payload.catalogs) ? catalogToState(action.payload.catalogs) : state.facets,
    activeFacets: filtersToActiveFacetsState(action.payload.filters),
    isLoading: false,
    filters: filtersToState(action.payload.filters),
    products: products,
    query: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.query), {}, {
      label: Object(entities["decodeHTML"])(action.payload.query)
    }),
    redirection: action.payload.redirection,
    productsSelectedForComparison: productsSelectedForComparison,
    noResults: !action.payload.redirection && products.length === 0
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["h" /* FACETING_SEARCH_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    noResults: true
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["e" /* FACETING_PRICES_REQUEST */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isPriceLoading: true,
    prices: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["e" /* FACETING_PRICES_REQUEST */]), function (state, action) {
  var resorts = action.payload.resorts;
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isPriceLoading: false,
    prices: resorts,
    scrollToResults: false
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["e" /* FACETING_PRICES_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isPriceLoading: false,
    prices: [],
    scrollToResults: true
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["a" /* FACETING_CHILDCARE_REQUEST */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: true,
    childcareAvailabilities: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["a" /* FACETING_CHILDCARE_REQUEST */]), function (state, action) {
  var childcareSearch = action.payload.childcareSearch;
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: false,
    childcareAvailabilities: childcareSearch
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["a" /* FACETING_CHILDCARE_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: false,
    childcareAvailabilities: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["i" /* FACETING_SET_FILTERS */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    filters: action.payload.filters
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["j" /* FACETING_SET_INITIAL_PRICES */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    prices: action.payload.initialProductPrices,
    isPriceLoading: false
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["l" /* FACETING_SET_IS_SEARCH_ENABLED */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isSearchEnabled: action.payload.isSearchEnabled
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["m" /* FACETING_SET_KIDS_VALIDATION_STATE */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    kidsValidationState: action.payload.kidsValidationState
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["n" /* FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isSelectionModeEnabled: action.payload.enable,
    productsSelectedForComparison: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["r" /* FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON */], function (state, action) {
  var productsCurrentlySelected = Object(lodash["get"])(state, 'productsSelectedForComparison');
  var productToBeToggled = Object(lodash["get"])(action, 'payload.productId', null);

  if (!productToBeToggled) {
    return state;
  }

  if (Object(lodash["includes"])(productsCurrentlySelected, productToBeToggled)) {
    return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
      productsSelectedForComparison: productsCurrentlySelected.filter(function (p) {
        return p !== productToBeToggled;
      })
    });
  }

  if (productsCurrentlySelected.length < faceting_constants["w" /* MAX_NUMBER_OF_SELECTED_PRODUCTS */]) {
    return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
      productsSelectedForComparison: [].concat(Object(toConsumableArray["a" /* default */])(productsCurrentlySelected), [productToBeToggled])
    });
  }

  return state;
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_constants["t" /* SYNC_WITH_LOCATION */], function (state, action) {
  var _action$payload = action.payload;
  _action$payload = _action$payload === void 0 ? {} : _action$payload;
  var queryParams = _action$payload.location.queryParams;

  if (!queryParams[faceting_constants["A" /* QUERY_QUERY_PARAM */]]) {
    return state;
  }

  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    query: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.query), {}, {
      label: queryParams[faceting_constants["A" /* QUERY_QUERY_PARAM */]]
    })
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["o" /* FACETING_SET_SEARCH_QUERY */], function (state, _ref5) {
  var value = _ref5.payload.value;

  if (Object(lodash["isUndefined"])(value)) {
    return state;
  }

  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    query: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, value), {}, {
      label: Object(entities["decodeHTML"])(value.label)
    })
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["b" /* FACETING_CLEAR_FACETS */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    activeFacets: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.activeFacets), {}, Object(defineProperty["a" /* default */])({}, action.payload.categoryId, {}))
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["p" /* FACETING_TOGGLE_FACET_SELECTED */], function (state, action) {
  var facet = action.payload;
  var categoryActiveFacets = state.activeFacets[facet.categoryId];
  var newState;

  if (facet.isSelected) {
    // lodash/fp
    // return set(`activeFacets.${facet.category}.${facet.value}`, action.payload.isSelected, state);
    newState = faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, categoryActiveFacets), {}, Object(defineProperty["a" /* default */])({}, facet.value, facet.isSelected));
  } else {
    var _facet$value = facet.value,
        _ = categoryActiveFacets[_facet$value],
        rest = Object(objectWithoutProperties["a" /* default */])(categoryActiveFacets, [_facet$value].map(_toPropertyKey)); // eslint-disable-line


    newState = rest;
  }

  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    activeFacets: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.activeFacets), {}, Object(defineProperty["a" /* default */])({}, facet.categoryId, faceting_reducer_objectSpread({}, newState)))
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["k" /* FACETING_SET_IS_DATE_REQUIRED */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isDateRequired: action.payload.isDateRequired
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["s" /* FACETING_UPDATE_FILTERS */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    filters: action.payload.filters,
    activeFacets: removeUnselectedFiltersFromActiveFacetsState( // $FlowFixMe
    action.payload.filters, state.activeFacets)
  });
}), faceting_reducer_createReducer));
// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// CONCATENATED MODULE: ./src/client/store/faceting-trip-information/facetingTripInformation.reducer.js






var facetingTripInformation_reducer_initialState = {
  departureCities: []
};
var facetingTripInformation = Object(createReducer["a" /* default */])(facetingTripInformation_reducer_initialState, Object(defineProperty["a" /* default */])({}, Object(build["resolve"])(store_faceting_constants["h" /* FACETING_SEARCH_REQUEST */]), function (state, action) {
  return {
    departureCities: Object(facetingUtils["c" /* getDepartureCities */])(Object(lodash["get"])(action, 'payload.catalogs', []))
  };
}));
/* harmony default export */ var facetingTripInformation_reducer = (facetingTripInformation);
// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// CONCATENATED MODULE: ./src/client/store/global-loader/label/label.reducer.js




var label_reducer_initialState = '';
/* harmony default export */ var label_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : label_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case globalLoader_action["b" /* START_LOADING */]:
    case proposals_constants["a" /* ADD_ACCOMMODATION */]:
    case proposals_constants["e" /* ADD_TRANSPORT */]:
    case proposals_constants["j" /* FETCH_PROPOSALS */]:
    case proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]:
      return Object(lodash["get"])(action, 'payload.globalLoaderLabel', null);

    case globalLoader_action["a" /* END_LOADING */]:
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["reject"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["resolve"])(proposals_constants["e" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["e" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
    case Object(build["reject"])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
      return label_reducer_initialState;

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/client/store/global-loader/navigation/navigation.reducer.js

var navigation_reducer_initialState = false;
var navigation_reducer_isNavigation = function isNavigation() {
  var _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigation_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action === null || action === void 0 ? void 0 : action.type) {
    case globalLoader_action["b" /* START_LOADING */]:
      return !!(action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.isNavigation);

    case globalLoader_action["a" /* END_LOADING */]:
      return navigation_reducer_initialState;

    default:
      return state;
  }
};
// CONCATENATED MODULE: ./src/client/store/global-loader/should-display/shouldDisplay.reducer.js




var shouldDisplay_reducer_initialState = false;
/* harmony default export */ var shouldDisplay_reducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shouldDisplay_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case globalLoader_action["b" /* START_LOADING */]:
    case proposals_constants["a" /* ADD_ACCOMMODATION */]:
    case proposals_constants["e" /* ADD_TRANSPORT */]:
    case proposals_constants["j" /* FETCH_PROPOSALS */]:
    case proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]:
    case proposals_constants["t" /* SAVE_CUSTOMER_PROPOSAL */]:
    case proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]:
      return true;

    case globalLoader_action["a" /* END_LOADING */]:
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["reject"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["resolve"])(proposals_constants["e" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["e" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
    case Object(build["reject"])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
    case Object(build["resolve"])(proposals_constants["t" /* SAVE_CUSTOMER_PROPOSAL */]):
    case Object(build["reject"])(proposals_constants["t" /* SAVE_CUSTOMER_PROPOSAL */]):
    case Object(build["resolve"])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
    case Object(build["reject"])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
      return false;

    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
      return Object(lodash["get"])(action, 'payload.proposals.errors') ? false : state;

    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/client/store/global-loader/globalLoader.reducer.js




/* harmony default export */ var globalLoader_reducer = (Object(redux["c" /* combineReducers */])({
  isNavigation: navigation_reducer_isNavigation,
  label: label_reducer,
  shouldDisplay: shouldDisplay_reducer
}));
// EXTERNAL MODULE: ./src/client/components/widgets/profile-info/travel-companions/travelCompanions.reducer.js
var travelCompanions_reducer = __webpack_require__("xAOE");

// CONCATENATED MODULE: ./src/client/components/widgets/childcare-layer/ChildcareLayer.reducer.js


var ChildcareLayer_reducer_createReducer;

function ChildcareLayer_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function ChildcareLayer_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ChildcareLayer_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ChildcareLayer_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var FETCH_BOOKING_CHILDCARE = 'FETCH_BOOKING_CHILDCARE';
var UPDATE_CART = 'UPDATE_CART';
var ChildcareLayer_reducer_initialState = {
  data: [],
  isLoading: false,
  isLoaded: false,
  errorResponse: {}
};
var childcareLayerReducer = Object(createReducer["a" /* default */])(ChildcareLayer_reducer_initialState, (ChildcareLayer_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, FETCH_BOOKING_CHILDCARE, function (state) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, Object(build["resolve"])(FETCH_BOOKING_CHILDCARE), function (state, action) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: Object(lodash["get"])(action, 'payload', {}),
    errorResponse: {}
  });
}), Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, Object(build["reject"])(FETCH_BOOKING_CHILDCARE), function (state, action) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, Object(build["resolve"])(UPDATE_CART), function (state, action) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    data: ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state.data), {}, {
      userBooking: ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state.data.userBooking), action.payload.addServiceCart), action.payload.removeServiceCart)
    })
  });
}), Object(defineProperty["a" /* default */])(ChildcareLayer_reducer_createReducer, Object(build["reject"])(UPDATE_CART), function (state, action) {
  return ChildcareLayer_reducer_objectSpread(ChildcareLayer_reducer_objectSpread({}, state), {}, {
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), ChildcareLayer_reducer_createReducer));
// EXTERNAL MODULE: ./src/client/components/widgets/cart/bookingCart.reducer.js
var bookingCart_reducer = __webpack_require__("xl1w");

// EXTERNAL MODULE: ./src/client/store/member-space/booking/booking.constants.js
var booking_constants = __webpack_require__("R3QM");

// CONCATENATED MODULE: ./src/client/store/member-space/booking/details/details.reducer.js


var details_reducer_createReducer;

function details_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function details_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      details_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      details_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var details_reducer_initialState = {
  data: null,
  isLoading: true,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var details_reducer = (Object(createReducer["a" /* default */])(details_reducer_initialState, (details_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(details_reducer_createReducer, booking_constants["l" /* FETCH_BOOKING_DETAILS */], function (state) {
  return details_reducer_objectSpread(details_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(details_reducer_createReducer, booking_constants["n" /* FETCH_BOOKING_DETAILS_RESOLVED */], function (state, action) {
  return details_reducer_objectSpread(details_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload.userBooking'),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(details_reducer_createReducer, booking_constants["m" /* FETCH_BOOKING_DETAILS_REJECTED */], function (state, action) {
  return details_reducer_objectSpread(details_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(details_reducer_createReducer, booking_constants["b" /* CLEAR_BOOKING_DETAILS */], function () {
  return details_reducer_initialState;
}), details_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/package/package.reducer.js


var package_reducer_createReducer;

function package_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function package_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      package_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      package_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var package_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var package_reducer = (Object(createReducer["a" /* default */])(package_reducer_initialState, (package_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(package_reducer_createReducer, booking_constants["i" /* FETCH_BOOKING_ATTENDEES_PACKAGE */], function (state) {
  return package_reducer_objectSpread(package_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(package_reducer_createReducer, booking_constants["k" /* FETCH_BOOKING_ATTENDEES_PACKAGE_RESOLVED */], function (state, action) {
  return package_reducer_objectSpread(package_reducer_objectSpread({}, state), {}, {
    data: {
      attendees: Object(lodash["get"])(action, 'payload.userBooking.attendees') || [],
      "package": Object(lodash["get"])(action, 'payload.package')
    },
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(package_reducer_createReducer, booking_constants["j" /* FETCH_BOOKING_ATTENDEES_PACKAGE_REJECTED */], function (state, action) {
  return package_reducer_objectSpread(package_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(package_reducer_createReducer, booking_constants["a" /* CLEAR_BOOKING_ATTENDEES_PACKAGE */], function () {
  return package_reducer_initialState;
}), package_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/price-and-payment/priceAndPayment.reducer.js


var priceAndPayment_reducer_createReducer;

function priceAndPayment_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function priceAndPayment_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      priceAndPayment_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      priceAndPayment_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var priceAndPayment_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var priceAndPayment_reducer = (Object(createReducer["a" /* default */])(priceAndPayment_reducer_initialState, (priceAndPayment_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(priceAndPayment_reducer_createReducer, booking_constants["o" /* FETCH_BOOKING_PRICE_AND_PAYMENT */], function (state) {
  return priceAndPayment_reducer_objectSpread(priceAndPayment_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(priceAndPayment_reducer_createReducer, booking_constants["q" /* FETCH_BOOKING_PRICE_AND_PAYMENT_RESOLVED */], function (state, action) {
  return priceAndPayment_reducer_objectSpread(priceAndPayment_reducer_objectSpread({}, state), {}, {
    data: priceAndPayment_reducer_objectSpread(priceAndPayment_reducer_objectSpread({}, state.data), {}, {
      priceDetails: Object(lodash["get"])(action, 'payload.userBooking.priceDetails'),
      paymentDetails: Object(lodash["get"])(action, 'payload.userBooking.paymentDetails')
    }),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(priceAndPayment_reducer_createReducer, booking_constants["p" /* FETCH_BOOKING_PRICE_AND_PAYMENT_REJECTED */], function (state, action) {
  return priceAndPayment_reducer_objectSpread(priceAndPayment_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(priceAndPayment_reducer_createReducer, booking_constants["c" /* CLEAR_BOOKING_PRICE_AND_PAYMENT */], function () {
  return priceAndPayment_reducer_initialState;
}), priceAndPayment_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/transport/transport.reducer.js


var transport_reducer_createReducer;

function transport_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function transport_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      transport_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      transport_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var transport_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var transport_reducer = (Object(createReducer["a" /* default */])(transport_reducer_initialState, (transport_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(transport_reducer_createReducer, booking_constants["u" /* FETCH_BOOKING_TRANSPORT */], function (state) {
  return transport_reducer_objectSpread(transport_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(transport_reducer_createReducer, booking_constants["w" /* FETCH_BOOKING_TRANSPORT_RESOLVED */], function (state, action) {
  return transport_reducer_objectSpread(transport_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload.userBooking.transports'),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(transport_reducer_createReducer, booking_constants["v" /* FETCH_BOOKING_TRANSPORT_REJECTED */], function (state, action) {
  return transport_reducer_objectSpread(transport_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(transport_reducer_createReducer, booking_constants["e" /* CLEAR_BOOKING_TRANSPORT */], function () {
  return transport_reducer_initialState;
}), transport_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/modals/childcare/childcare.reducer.js


var childcare_reducer_createReducer;

function childcare_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function childcare_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      childcare_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      childcare_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */




var childcare_reducer_initialState = {
  data: {
    isVisible: false,
    activity: null
  }
};
/* harmony default export */ var childcare_reducer = (Object(createReducer["a" /* default */])(childcare_reducer_initialState, (childcare_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(childcare_reducer_createReducer, booking_constants["z" /* OPEN_CHILDCARE_INFORMATIONS_MODAL */], function (state, _ref) {
  var payload = _ref.payload;
  return childcare_reducer_objectSpread(childcare_reducer_objectSpread({}, state), {}, {
    data: childcare_reducer_objectSpread(childcare_reducer_objectSpread({}, state.data), {}, {
      isVisible: true,
      activity: payload.activity
    })
  });
}), Object(defineProperty["a" /* default */])(childcare_reducer_createReducer, booking_constants["g" /* CLOSE_CHILDCARE_INFORMATIONS_MODAL */], function () {
  return childcare_reducer_initialState;
}), childcare_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/modals/package-upsell/packageUpsell.reducer.js


var packageUpsell_reducer_createReducer;

function packageUpsell_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function packageUpsell_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      packageUpsell_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      packageUpsell_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var packageUpsell_reducer_initialState = {
  content: null,
  isOpen: false
};
/* harmony default export */ var packageUpsell_reducer = (Object(createReducer["a" /* default */])(packageUpsell_reducer_initialState, (packageUpsell_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(packageUpsell_reducer_createReducer, booking_constants["A" /* OPEN_PACKAGE_UPSELL_INFORMATIONS_MODAL */], function (state, _ref) {
  var payload = _ref.payload;
  return packageUpsell_reducer_objectSpread(packageUpsell_reducer_objectSpread({}, state), {}, {
    isOpen: true,
    content: Object(lodash["get"])(state, "package_".concat(payload.productId, "_").concat(payload.packageId))
  });
}), Object(defineProperty["a" /* default */])(packageUpsell_reducer_createReducer, booking_constants["h" /* CLOSE_PACKAGE_UPSELL_INFORMATIONS_MODAL */], function (state) {
  return packageUpsell_reducer_objectSpread(packageUpsell_reducer_objectSpread({}, state), {}, {
    isOpen: false,
    content: null
  });
}), Object(defineProperty["a" /* default */])(packageUpsell_reducer_createReducer, booking_constants["y" /* FETCH_PACKAGE_UPSELL_INFORMATIONS_MODAL_RESOLVED */], function (state, _ref2) {
  var payload = _ref2.payload;
  return packageUpsell_reducer_objectSpread(packageUpsell_reducer_objectSpread({}, state), {}, Object(defineProperty["a" /* default */])({}, "package_".concat(payload["package"].productId, "_").concat(payload["package"].id), payload["package"]));
}), Object(defineProperty["a" /* default */])(packageUpsell_reducer_createReducer, booking_constants["f" /* CLEAR_PACKAGE_UPSELL_INFORMATIONS_MODAL */], function () {
  return packageUpsell_reducer_initialState;
}), packageUpsell_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/modals/modals.reducer.js



/* harmony default export */ var modals_reducer = (Object(redux["c" /* combineReducers */])({
  childcare: childcare_reducer,
  packageUpsell: packageUpsell_reducer
}));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/stay-formalities/stayFormalities.reducer.js


var stayFormalities_reducer_createReducer;

function stayFormalities_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function stayFormalities_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      stayFormalities_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      stayFormalities_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var stayFormalities_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var stayFormalities_reducer = (Object(createReducer["a" /* default */])(stayFormalities_reducer_initialState, (stayFormalities_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(stayFormalities_reducer_createReducer, booking_constants["r" /* FETCH_BOOKING_STAY_FORMALITIES */], function (state) {
  return stayFormalities_reducer_objectSpread(stayFormalities_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(stayFormalities_reducer_createReducer, booking_constants["t" /* FETCH_BOOKING_STAY_FORMALITIES_RESOLVED */], function (state, action) {
  return stayFormalities_reducer_objectSpread(stayFormalities_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload.userBooking.stayFormalities') || [],
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(stayFormalities_reducer_createReducer, booking_constants["s" /* FETCH_BOOKING_STAY_FORMALITIES_REJECTED */], function (state, action) {
  return stayFormalities_reducer_objectSpread(stayFormalities_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(stayFormalities_reducer_createReducer, booking_constants["d" /* CLEAR_BOOKING_STAY_FORMALITIES */], function () {
  return stayFormalities_reducer_initialState;
}), stayFormalities_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/booking/booking.reducer.js







/* harmony default export */ var booking_reducer = (Object(redux["c" /* combineReducers */])({
  details: details_reducer,
  packageUpsell: package_reducer,
  priceAndPayment: priceAndPayment_reducer,
  transport: transport_reducer,
  modals: modals_reducer,
  stayFormalities: stayFormalities_reducer
}));
// EXTERNAL MODULE: ./src/client/store/member-space/constants.helper.js
var constants_helper = __webpack_require__("30WP");

// CONCATENATED MODULE: ./src/client/store/member-space/pre-payment/prePayment.constants.js


var PRE_PAYMENT_DETAILS = 'PRE_PAYMENT/DETAILS';
var PRE_PAYMENT_PAYLOAD_DATAS = 'PRE_PAYMENT/PAYLOAD_DATAS';
var FETCH_PRE_PAYMENT_DETAILS = Object(constants_helper["c" /* fetch */])(PRE_PAYMENT_DETAILS);
var FETCH_PRE_PAYMENT_DETAILS_RESOLVED = Object(build["resolve"])(FETCH_PRE_PAYMENT_DETAILS);
var FETCH_PRE_PAYMENT_DETAILS_REJECTED = Object(build["reject"])(FETCH_PRE_PAYMENT_DETAILS);
var CLEAR_PRE_PAYMENT_DETAILS = Object(constants_helper["a" /* clear */])(PRE_PAYMENT_DETAILS);
var SET_PRE_PAYMENT_PROVIDER = 'SET_PRE_PAYMENT_PROVIDER';
var SET_PRE_PAYMENT_PAYMENT_METHOD_ID = 'SET_PRE_PAYMENT_PAYMENT_METHOD_ID';
var SET_PRE_PAYMENT_PAYMENT_METHOD_CONDITION_ID = 'SET_PRE_PAYMENT_PAYMENT_METHOD_CONDITION_ID';
var CLEAR_PRE_PAYMENT_BUTTON = 'CLEAR_PRE_PAYMENT_BUTTON';
var FETCH_PRE_PAYMENT_PAYLOAD_DATAS = Object(constants_helper["c" /* fetch */])(PRE_PAYMENT_PAYLOAD_DATAS);
var FETCH_PRE_PAYMENT_PAYLOAD_DATAS_RESOLVED = Object(build["resolve"])(FETCH_PRE_PAYMENT_PAYLOAD_DATAS);
var FETCH_PRE_PAYMENT_PAYLOAD_DATAS_REJECTED = Object(build["reject"])(FETCH_PRE_PAYMENT_PAYLOAD_DATAS);
var CLEAR_PRE_PAYMENT_PAYLOAD_DATAS = Object(constants_helper["a" /* clear */])(PRE_PAYMENT_PAYLOAD_DATAS);
// CONCATENATED MODULE: ./src/client/store/member-space/pre-payment/details/details.reducer.js


var details_details_reducer_createReducer;

function details_details_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function details_details_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      details_details_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      details_details_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var details_details_reducer_initialState = {
  data: null,
  isLoading: true,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var details_details_reducer = (Object(createReducer["a" /* default */])(details_details_reducer_initialState, (details_details_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(details_details_reducer_createReducer, FETCH_PRE_PAYMENT_DETAILS, function (state) {
  return details_details_reducer_objectSpread(details_details_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(details_details_reducer_createReducer, FETCH_PRE_PAYMENT_DETAILS_RESOLVED, function (state, action) {
  return details_details_reducer_objectSpread(details_details_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload'),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(details_details_reducer_createReducer, FETCH_PRE_PAYMENT_DETAILS_REJECTED, function (state, action) {
  return details_details_reducer_objectSpread(details_details_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(details_details_reducer_createReducer, CLEAR_PRE_PAYMENT_DETAILS, function () {
  return details_details_reducer_initialState;
}), details_details_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/pre-payment/button/button.reducer.js


var button_reducer_createReducer;

function button_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function button_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      button_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      button_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var button_reducer_initialState = {
  selectedProviderId: null,
  paymentMethodId: null,
  paymentConditionId: null
};
/* harmony default export */ var button_reducer = (Object(createReducer["a" /* default */])(button_reducer_initialState, (button_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(button_reducer_createReducer, SET_PRE_PAYMENT_PROVIDER, function (state, _ref) {
  var payload = _ref.payload;
  return button_reducer_objectSpread(button_reducer_objectSpread({}, state), {}, {
    selectedProviderId: payload.providerId
  });
}), Object(defineProperty["a" /* default */])(button_reducer_createReducer, SET_PRE_PAYMENT_PAYMENT_METHOD_ID, function (state, _ref2) {
  var payload = _ref2.payload;
  return button_reducer_objectSpread(button_reducer_objectSpread({}, state), {}, {
    paymentMethodId: payload.id
  });
}), Object(defineProperty["a" /* default */])(button_reducer_createReducer, SET_PRE_PAYMENT_PAYMENT_METHOD_CONDITION_ID, function (state, _ref3) {
  var payload = _ref3.payload;
  return button_reducer_objectSpread(button_reducer_objectSpread({}, state), {}, {
    paymentConditionId: payload.conditionId
  });
}), Object(defineProperty["a" /* default */])(button_reducer_createReducer, CLEAR_PRE_PAYMENT_BUTTON, function () {
  return button_reducer_initialState;
}), button_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/pre-payment/prePayment.reducer.js



/* harmony default export */ var prePayment_reducer = (Object(redux["c" /* combineReducers */])({
  details: details_details_reducer,
  button: button_reducer
}));
// EXTERNAL MODULE: ./src/client/store/member-space/customer/customer.constants.js
var customer_constants = __webpack_require__("CDVU");

// CONCATENATED MODULE: ./src/client/store/member-space/customer/customer.reducer.js


var customer_reducer_createReducer;

function customer_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function customer_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      customer_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      customer_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var customer_reducer_initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null
};
/* harmony default export */ var customer_reducer = (Object(createReducer["a" /* default */])(customer_reducer_initialState, (customer_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(customer_reducer_createReducer, customer_constants["a" /* FETCH_CUSTOMER */], function (state) {
  return customer_reducer_objectSpread(customer_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(customer_reducer_createReducer, customer_constants["c" /* FETCH_CUSTOMER_RESOLVED */], function (state, action) {
  return customer_reducer_objectSpread(customer_reducer_objectSpread({}, state), {}, {
    data: Object(lodash["get"])(action, 'payload'),
    isLoaded: true,
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(customer_reducer_createReducer, customer_constants["b" /* FETCH_CUSTOMER_REJECTED */], function (state, action) {
  return customer_reducer_objectSpread(customer_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    isOnError: true,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), customer_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/user-searches/userSearches.reducer.js


var userSearches_reducer_createReducer;

function userSearches_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function userSearches_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      userSearches_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      userSearches_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */






var userSearches_reducer_initialState = {
  data: {
    bookings: []
  },
  isLoading: false,
  isLoaded: false,
  errorResponse: {}
};
/* harmony default export */ var userSearches_reducer = (Object(createReducer["a" /* default */])(userSearches_reducer_initialState, (userSearches_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(userSearches_reducer_createReducer, store_constants["o" /* FETCH_USER_SEARCHES */], function (state) {
  return userSearches_reducer_objectSpread(userSearches_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(userSearches_reducer_createReducer, store_constants["p" /* FETCH_USER_SEARCHES_RESOLVED */], function (state, action) {
  var fetchedTripsList = Object(lodash["get"])(action, 'payload.bookings', []);
  return userSearches_reducer_objectSpread(userSearches_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: {
      bookings: fetchedTripsList
    }
  });
}), Object(defineProperty["a" /* default */])(userSearches_reducer_createReducer, Object(build["reject"])(store_constants["o" /* FETCH_USER_SEARCHES */]), function (state, action) {
  return userSearches_reducer_objectSpread(userSearches_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), userSearches_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/future-trips/futureTrips.reducer.js


var futureTrips_reducer_createReducer;

function futureTrips_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function futureTrips_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      futureTrips_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      futureTrips_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */






var futureTrips_reducer_initialState = {
  data: {
    bookings: []
  },
  isLoading: false,
  isLoaded: false,
  errorResponse: {},
  hasNextPage: false,
  currentPage: 1,
  nextPage: 2
};
/* harmony default export */ var futureTrips_reducer = (Object(createReducer["a" /* default */])(futureTrips_reducer_initialState, (futureTrips_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, store_constants["k" /* FETCH_USER_FUTURE_TRIPS_FETCHED */], function (state, action) {
  return futureTrips_reducer_objectSpread(futureTrips_reducer_objectSpread({}, state), {}, {
    data: {
      bookings: Object(lodash["get"])(action, 'payload.bookings.data', [])
    }
  });
}), Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, store_constants["j" /* FETCH_USER_FUTURE_TRIPS */], function (state) {
  return futureTrips_reducer_objectSpread(futureTrips_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, store_constants["l" /* FETCH_USER_FUTURE_TRIPS_RESOLVED */], function (state, action) {
  var hasNextPage = Object(lodash["get"])(action, 'payload.userBookings.pageInfo.hasNextPage');
  var currentPage = Object(lodash["get"])(action, 'payload.userBookings.pageInfo.currentPage');
  var fetchedTripsList = Object(lodash["get"])(action, 'payload.userBookings.data', []);
  var trips = Object(lodash["get"])(state, 'data.bookings').concat(fetchedTripsList);
  return futureTrips_reducer_objectSpread(futureTrips_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: {
      bookings: trips
    },
    hasNextPage: hasNextPage,
    currentPage: currentPage,
    nextPage: currentPage + 1
  });
}), Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, Object(build["reject"])(store_constants["j" /* FETCH_USER_FUTURE_TRIPS */]), function (state, action) {
  return futureTrips_reducer_objectSpread(futureTrips_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(futureTrips_reducer_createReducer, store_constants["q" /* RESET_USER_FUTURE_TRIPS */], function () {
  return futureTrips_reducer_initialState;
}), futureTrips_reducer_createReducer)));
// CONCATENATED MODULE: ./src/client/store/member-space/past-trips/pastTrips.reducer.js


var pastTrips_reducer_createReducer;

function pastTrips_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function pastTrips_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      pastTrips_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      pastTrips_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */






var pastTrips_reducer_initialState = {
  data: {
    bookings: []
  },
  isLoading: false,
  isLoaded: false,
  errorResponse: {},
  hasNextPage: false,
  currentPage: 1,
  nextPage: 2
};
/* harmony default export */ var pastTrips_reducer = (Object(createReducer["a" /* default */])(pastTrips_reducer_initialState, (pastTrips_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(pastTrips_reducer_createReducer, store_constants["m" /* FETCH_USER_PAST_TRIPS */], function (state) {
  return pastTrips_reducer_objectSpread(pastTrips_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(pastTrips_reducer_createReducer, store_constants["n" /* FETCH_USER_PAST_TRIPS_RESOLVED */], function (state, action) {
  var hasNextPage = Object(lodash["get"])(action, 'payload.userBookings.pageInfo.hasNextPage');
  var currentPage = Object(lodash["get"])(action, 'payload.userBookings.pageInfo.currentPage');
  var fetchedPastTripsList = Object(lodash["get"])(action, 'payload.userBookings.data', []);
  var pastTrips = Object(lodash["get"])(state, 'data.bookings').concat(fetchedPastTripsList);
  return pastTrips_reducer_objectSpread(pastTrips_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: {
      bookings: pastTrips
    },
    hasNextPage: hasNextPage,
    currentPage: currentPage,
    nextPage: currentPage + 1
  });
}), Object(defineProperty["a" /* default */])(pastTrips_reducer_createReducer, Object(build["reject"])(store_constants["m" /* FETCH_USER_PAST_TRIPS */]), function (state, action) {
  return pastTrips_reducer_objectSpread(pastTrips_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(defineProperty["a" /* default */])(pastTrips_reducer_createReducer, store_constants["r" /* RESET_USER_PAST_TRIPS */], function () {
  return pastTrips_reducer_initialState;
}), pastTrips_reducer_createReducer)));
// EXTERNAL MODULE: ./src/client/store/member-space/quick-login/quickLogin.constants.js
var quickLogin_constants = __webpack_require__("rAD9");

// CONCATENATED MODULE: ./src/client/store/member-space/quick-login/quickLogin.reducer.js


var quickLogin_reducer_createReducer;




var quickLogin_reducer_initialState = {
  bookingId: null,
  stayId: null
};
var quickLogin = Object(createReducer["a" /* default */])(quickLogin_reducer_initialState, (quickLogin_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(quickLogin_reducer_createReducer, quickLogin_constants["b" /* UPDATE_QUICKLOGIN_INFOS */], function (state, _ref) {
  var payload = _ref.payload;
  return {
    bookingId: Object(lodash["get"])(payload, 'bookingId') || null,
    stayId: Object(lodash["get"])(payload, 'stayId') || null
  };
}), Object(defineProperty["a" /* default */])(quickLogin_reducer_createReducer, quickLogin_constants["a" /* RESET_QUICKLOGIN_INFOS */], function () {
  return quickLogin_reducer_initialState;
}), quickLogin_reducer_createReducer));
// CONCATENATED MODULE: ./src/client/store/member-space/memberSpace.reducer.js











var memberSpace = Object(redux["c" /* combineReducers */])({
  booking: booking_reducer,
  prePayment: prePayment_reducer,
  customer: customer_reducer,
  userSearches: userSearches_reducer,
  futureTrips: futureTrips_reducer,
  pastTrips: pastTrips_reducer,
  travelCompanions: travelCompanions_reducer["b" /* default */],
  quickLogin: quickLogin,
  bookingChildcare: childcareLayerReducer,
  bookingCart: bookingCart_reducer["b" /* bookingCartReducer */]
});
// EXTERNAL MODULE: ./src/client/store/pick-your-room/app/pickYourRoom.reducer.js
var pickYourRoom_reducer = __webpack_require__("ogu6");

// EXTERNAL MODULE: ./src/client/store/pick-your-room/map/map.reducer.js
var map_reducer = __webpack_require__("ZoZw");

// CONCATENATED MODULE: ./src/client/store/pick-your-room/pickYourRoom.reducer.js



var pickYourRoom = Object(redux["c" /* combineReducers */])({
  app: pickYourRoom_reducer["m" /* default */],
  mapper: map_reducer["j" /* default */]
});
/* harmony default export */ var pick_your_room_pickYourRoom_reducer = (pickYourRoom);
// CONCATENATED MODULE: ./src/client/store/search/query/searchQuery.reducer.js


function searchQuery_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function searchQuery_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      searchQuery_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      searchQuery_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable new-cap */





var searchQuery_reducer_initialState = {
  keywords: ''
};
var searchQueryReducer = Object(createReducer["a" /* default */])(searchQuery_reducer_initialState, Object(defineProperty["a" /* default */])({}, store_constants["s" /* SEARCH_SET_KEYWORDS */], function (state, action) {
  return searchQuery_reducer_objectSpread(searchQuery_reducer_objectSpread({}, state), {}, {
    keywords: Object(lodash["get"])(action, 'payload.keywords')
  });
}));
// CONCATENATED MODULE: ./src/client/store/search/search.reducer.js


var searchReducer = Object(redux["c" /* combineReducers */])({
  query: searchQueryReducer
});
// CONCATENATED MODULE: ./src/client/store/seller/neolidsReducer.js
var neolidsReducer_initialState = [];
var neolidsReducer = function neolidsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : neolidsReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined; // there is just a switch with a default case because data is initialized in src/client/store/getInitialReduxState.client.js
  // and is never changed after that (data come from query params)

  switch (action.type) {
    default:
      return state;
  }
};
// EXTERNAL MODULE: ./src/client/store/seller/sellerInfoReducer.js
var sellerInfoReducer = __webpack_require__("+2AQ");

// CONCATENATED MODULE: ./src/client/store/seller/sellerReducer.js



/* harmony default export */ var sellerReducer = (Object(redux["c" /* combineReducers */])({
  neolids: neolidsReducer,
  sellerInfo: sellerInfoReducer["b" /* sellerInfoReducer */]
}));
// EXTERNAL MODULE: ./src/client/store/user-info/actions/signout.js
var signout = __webpack_require__("qd7E");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/departure-city/departureCity.reducer.js





var departureCity_reducer_initialState = null;

function departureCityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : departureCity_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case store_constants["t" /* SYNC_WITH_LOCATION */]:
      var _ref = action || {},
          _ref$payload = _ref.payload;

      _ref$payload = _ref$payload === void 0 ? {} : _ref$payload;
      var queryParams = _ref$payload.location.queryParams; // in cases where params is not in the url, we should just keep the state as it is.

      return queryParams[uri_constants["k" /* QUERY_TRANSPORT */]] ? queryParams[uri_constants["k" /* QUERY_TRANSPORT */]] : state;

    case departure_city_constants["b" /* TRIP_INFORMATION_SET_DEPARTURE_CITY */]:
      return Object(lodash["get"])(action, 'payload.value', departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */]);

    case signout["a" /* SIGNOUT */]:
      return departureCity_reducer_initialState;

    default:
      return state;
  }
}

/* harmony default export */ var departureCity_reducer = (departureCityReducer);
// CONCATENATED MODULE: ./src/client/store/trip-criteria/departure-date/departureDate.reducer.js




var departureDate_reducer_initialState = null;

function departureDateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : departureDate_reducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case store_constants["t" /* SYNC_WITH_LOCATION */]:
      // in cases where params is not in the url, we should just keep the state as it is.
      return payload.location.queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]] ? Object(dateUtils["d" /* getTimestamp */])(payload.location.queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]], uri_constants["e" /* QUERY_DATE_FORMAT */]) : state;

    case store_constants["v" /* TRIP_INFORMATION_SET_DEPARTURE_DATE */]:
      return Object(lodash["get"])(payload, 'departureDate');

    default:
      return state;
  }
}

/* harmony default export */ var departureDate_reducer = (departureDateReducer);
// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/duration/duration.reducer.js
/* eslint-disable no-duplicate-imports */








var duration_reducer_initialState = null;
function tripDurationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : duration_reducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case store_constants["t" /* SYNC_WITH_LOCATION */]:
      {
        var _ref2 = payload,
            queryParams = _ref2.location.queryParams;
        if (queryParams[uri_constants["g" /* QUERY_DURATION */]]) return parseInt(queryParams[uri_constants["g" /* QUERY_DURATION */]], 10);
        return state ? state : duration_constants["a" /* DEFAULT_NO_DURATION */];
      }

    case duration_constants["c" /* TRIP_INFORMATION_SET_DURATION */]:
      var _ref3 = payload,
          value = _ref3.value;

      if (value === duration_constants["a" /* DEFAULT_NO_DURATION */]) {
        return null;
      }

      return Number(value) || state;

    case Object(build["resolve"])(store_faceting_constants["h" /* FACETING_SEARCH_REQUEST */]):
      var _ref4 = payload,
          search = _ref4.search;
      var products = search ? search.products : [];
      var durationQueryParam = Object(uriUtils["j" /* getSpecificQueryParam */])(uri_constants["g" /* QUERY_DURATION */]);
      var defaultDuration = durationQueryParam ? Number(durationQueryParam) : state;
      var durationFromPrice = Object(lodash["get"])(products, '0.price.termsAndConditions.duration');
      return durationFromPrice ? Number(durationFromPrice) : defaultDuration;

    case signout["a" /* SIGNOUT */]:
      return duration_reducer_initialState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.constants.js
var flexibility_constants = __webpack_require__("45Yg");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.reducer.js

var flexibility_reducer_initialState = null;
function flexibilityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : flexibility_reducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case flexibility_constants["a" /* TRIP_INFORMATION_SET_FLEXIBILITY */]:
      return payload.value;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/trip-criteria/tripCriteria.reducer.js





/* harmony default export */ var tripCriteria_reducer = (Object(redux["c" /* combineReducers */])({
  departureCity: departureCity_reducer,
  departureDate: departureDate_reducer,
  duration: tripDurationReducer,
  flexibility: flexibilityReducer
}));
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// CONCATENATED MODULE: ./src/client/store/trip-date-criteria/tripDateCriteria.reducer.js



var tripDateCriteria_reducer_createReducer;








var tripDateCriteria_reducer_initialState = {
  departureDate: null,
  arrivalDate: null
};
/* harmony default export */ var tripDateCriteria_reducer = (Object(createReducer["a" /* default */])(tripDateCriteria_reducer_initialState, (tripDateCriteria_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(tripDateCriteria_reducer_createReducer, store_constants["t" /* SYNC_WITH_LOCATION */], function (state, _ref) {
  var payload = _ref.payload;

  if (!payload.location.queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]]) {
    return state;
  }

  var formattedDate = Object(dateUtils["b" /* formatDate */])('YYYYMMDD')(payload.location.queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]], uri_constants["e" /* QUERY_DATE_FORMAT */]);
  return {
    arrivalDate: Number(formattedDate),
    departureDate: Number(formattedDate)
  };
}), Object(defineProperty["a" /* default */])(tripDateCriteria_reducer_createReducer, Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]), function (state, action) {
  var _get = Object(lodash["get"])(action, 'payload.proposals.proposals', [tripDateCriteria_reducer_initialState]),
      _get2 = Object(slicedToArray["a" /* default */])(_get, 1),
      proposal = _get2[0];

  if (proposal) {
    var arrivalDate = proposal.arrivalDate,
        departureDate = proposal.departureDate;
    return {
      arrivalDate: Number(arrivalDate),
      departureDate: Number(departureDate)
    };
  }

  return state;
}), Object(defineProperty["a" /* default */])(tripDateCriteria_reducer_createReducer, store_constants["w" /* UPDATE_TRIP_DATE_CRITERIA */], function (state, action) {
  var day = Object(lodash["get"])(action, 'payload.day', {});
  var departureDate = Number(Object(lodash["get"])(day, 'id')) || null;
  var arrivalDate = Number(Object(lodash["get"])(day, 'arrivalDate', departureDate)) || null;
  return {
    departureDate: departureDate,
    arrivalDate: arrivalDate
  };
}), tripDateCriteria_reducer_createReducer)));
// EXTERNAL MODULE: ./src/client/store/price-remote/constants.js
var price_remote_constants = __webpack_require__("GZgf");

// CONCATENATED MODULE: ./src/client/store/price-remote/price-of-stay/priceOfStay.reducer.js


var priceOfStay_reducer_createReducer;

function priceOfStay_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function priceOfStay_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      priceOfStay_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      priceOfStay_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var priceOfStay_reducer_initialState = {
  isLoading: true,
  data: null,
  error: null,
  lastRequestId: -1
};
var priceOfStayReducer = Object(createReducer["a" /* default */])(priceOfStay_reducer_initialState, (priceOfStay_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */], function (state, action) {
  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    isLoading: true,
    lastRequestId: Object(lodash["get"])(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, Object(build["resolve"])(price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */]), function (state, action) {
  // If there is another request in progress
  if (Object(lodash["get"])(action, 'optimist.id', -1) !== state.lastRequestId) {
    return state;
  }

  var priceOfStay = action.payload.priceOfStay;

  if (priceOfStay && priceOfStay.errors) {
    return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
      isLoading: false,
      data: null,
      error: priceOfStay.errors
    });
  }

  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    data: priceOfStay,
    error: null
  });
}), Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, Object(build["reject"])(price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */]), function (state) {
  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, price_remote_constants["c" /* RESET_PRICE_OF_STAY */], function (state) {
  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    error: null,
    data: null
  });
}), priceOfStay_reducer_createReducer));
// CONCATENATED MODULE: ./src/client/store/price-remote/all-inclusive-services/allInclusiveServices.reducer.js


var allInclusiveServices_reducer_createReducer;

function allInclusiveServices_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function allInclusiveServices_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      allInclusiveServices_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      allInclusiveServices_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var allInclusiveServices_reducer_initialState = {
  isLoading: true,
  data: [],
  lastRequestId: -1
};
var allInclusiveServicesReducer = Object(createReducer["a" /* default */])(allInclusiveServices_reducer_initialState, (allInclusiveServices_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(allInclusiveServices_reducer_createReducer, price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */], function (state, action) {
  return allInclusiveServices_reducer_objectSpread(allInclusiveServices_reducer_objectSpread({}, state), {}, {
    isLoading: true,
    lastRequestId: Object(lodash["get"])(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(allInclusiveServices_reducer_createReducer, Object(build["resolve"])(price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */]), function (state, action) {
  // If there is another request in progress
  if (Object(lodash["get"])(action, 'optimist.id', -1) !== state.lastRequestId) {
    return state;
  }

  return allInclusiveServices_reducer_objectSpread(allInclusiveServices_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    data: action.payload.allInclusiveServices
  });
}), Object(defineProperty["a" /* default */])(allInclusiveServices_reducer_createReducer, Object(build["reject"])(price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */]), function (state) {
  return allInclusiveServices_reducer_objectSpread(allInclusiveServices_reducer_objectSpread({}, state), {}, {
    isLoading: false
  });
}), allInclusiveServices_reducer_createReducer));
// CONCATENATED MODULE: ./src/client/store/price-remote/priceRemote.reducer.js



var priceRemoteReducer = Object(redux["c" /* combineReducers */])({
  allInclusiveServices: allInclusiveServicesReducer,
  priceOfStay: priceOfStayReducer
});
// EXTERNAL MODULE: ./src/client/store/priceTicket/constants.js
var priceTicket_constants = __webpack_require__("0OJc");

// CONCATENATED MODULE: ./src/client/store/priceTicket/priceTicket.reducer.js


var priceTicket_reducer_createReducer;

function priceTicket_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function priceTicket_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      priceTicket_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      priceTicket_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var priceTicket_reducer_initialState = {
  isLoading: true,
  price: {}
};
/* harmony default export */ var priceTicket_reducer = (Object(createReducer["a" /* default */])(priceTicket_reducer_initialState, (priceTicket_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(priceTicket_reducer_createReducer, priceTicket_constants["a" /* default */], function (state) {
  return priceTicket_reducer_objectSpread(priceTicket_reducer_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(defineProperty["a" /* default */])(priceTicket_reducer_createReducer, Object(build["resolve"])(priceTicket_constants["a" /* default */]), function (state, action) {
  var price = Object(lodash["get"])(action, 'payload.price') || {};
  return {
    isLoading: false,
    price: price
  };
}), Object(defineProperty["a" /* default */])(priceTicket_reducer_createReducer, Object(build["reject"])(priceTicket_constants["a" /* default */]), function (state) {
  return priceTicket_reducer_objectSpread(priceTicket_reducer_objectSpread({}, state), {}, {
    isLoading: false
  });
}), priceTicket_reducer_createReducer)));
// EXTERNAL MODULE: ./src/client/store/prebooking-form/prebookingform.action.js + 1 modules
var prebookingform_action = __webpack_require__("ZP80");

// CONCATENATED MODULE: ./src/client/store/trip-information/tripInformation.action.js
var TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME = 'TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME';

function setParticipantsLastNameWithMainContacts(userInfos, adultCount, kidCount) {
  return {
    type: TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME,
    payload: {
      userInfos: userInfos,
      adultCount: adultCount,
      kidCount: kidCount
    }
  };
}


// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/store/trip-information/kids/kids.reducer.js



function kids_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function kids_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      kids_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      kids_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable flowtype/no-weak-types */











var kids_reducer_initialState = [];

function updateKid(state, action) {
  var _get = Object(lodash["get"])(action, 'payload'),
      index = _get.index,
      valuesToUpdate = _get.valuesToUpdate;

  if (!Number.isFinite(index)) {
    return state;
  }

  var kidsState = state || [];
  return Array(index >= kidsState.length ? index + 1 : kidsState.length).fill(kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */])).map(function (defaultKid, i) {
    if (i !== index) return kidsState[i] ? kidsState[i] : kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]);
    return kids_reducer_objectSpread(kids_reducer_objectSpread({}, kids_reducer_objectSpread({}, kidsState[i] ? kidsState[i] : defaultKid)), valuesToUpdate);
  });
}

function updateKidsWithMainContactLastName(state, action) {
  var _action$payload = action.payload,
      userInfos = _action$payload.userInfos,
      kidCount = _action$payload.kidCount;

  if (userInfos.lastName === '') {
    return state;
  }

  var kids = state || [];
  return Array(kidCount).fill(kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */])).map(function (defaultKid, i) {
    return kids_reducer_objectSpread(kids_reducer_objectSpread(kids_reducer_objectSpread({}, defaultKid), kids[i]), {}, {
      lastName: kids[i] && !Object(lodash["isEmpty"])(kids[i].lastName) ? kids[i].lastName : userInfos.lastName
    });
  });
}

var kids_reducer_updateKids = function updateKids(state, _ref) {
  var payload = _ref.payload;

  if (!payload.kidsAttendees) {
    return state.map(function (kid) {
      return {
        birthdate: kid.birthdate,
        neolid: kid.neolid,
        childcareIncluded: kid.childcareIncluded,
        mainContactId: undefined
      };
    });
  }

  return state.map(function (kid, index) {
    var _get2 = Object(lodash["get"])(payload, "kidsAttendees[".concat(index, "]"), {}),
        birthdate = _get2.birthdate,
        restAttendeeData = Object(objectWithoutProperties["a" /* default */])(_get2, ["birthdate"]);

    return kids_reducer_objectSpread(kids_reducer_objectSpread({}, restAttendeeData), {}, {
      birthdate: kid.birthdate,
      neolid: kid.neolid,
      childcareIncluded: kid.childcareIncluded,
      mainContactId: undefined
    });
  });
};

function kidsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : kids_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case kids_constants["e" /* TRIP_INFORMATION_UPDATE_KID */]:
      return updateKid(state, action);

    case TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME:
      return updateKidsWithMainContactLastName(state, action);

    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
      {
        var kids = Object(lodash["get"])(action, 'payload.kids') || [];
        return kids.map(function (kid) {
          return kid || kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]);
        });
      }

    case kids_constants["d" /* TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS */]:
      {
        var _kids = Object(lodash["get"])(action, 'payload.kids') || [];

        return _kids.map(function (kid, index) {
          return kid ? kids_reducer_objectSpread(kids_reducer_objectSpread(kids_reducer_objectSpread({}, state[index]), kid), {}, {
            birthdate: typeof kid.birthdate === 'string' ? Object(apiDate["d" /* apiDateToTimestamp */])(kid.birthdate) : kid.birthdate,
            neolid: kid.neolid || Object(lodash["get"])(state[index], 'neolid'),
            mainContactId: kid.neolid ? undefined : kid.mainContactId
          }) : kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]);
        });
      }

    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(prebookingform_action["a" /* FETCH_PREBOOKING_TRAVELERS */]):
    case adults_constants["d" /* SET_ATTENDEES */]:
      return kids_reducer_updateKids(state, action);

    case proposals_constants["y" /* UPDATE_ATTENDEES */]:
      {
        if (!action.payload.attendees) {
          return state;
        }

        return state.map(function (kid) {
          var updatedKid = action.payload.attendees.find(function (_ref2) {
            var id = _ref2.id;
            return id === kid.id;
          }) || {};
          return kids_reducer_objectSpread(kids_reducer_objectSpread({}, kid), {}, {
            neolid: updatedKid.customerId,
            gmNumber: updatedKid.gmNumber
          });
        });
      }

    case kids_constants["b" /* TRIP_INFORMATION_RESET_KIDS */]:
      return kids_reducer_initialState;

    case signout["a" /* SIGNOUT */]:
      return kids_reducer_initialState;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/trip-information/adults/adults.reducer.js



function adults_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function adults_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      adults_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      adults_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









var adults_reducer_initialState = [];

function updateAdult(state, action) {
  var _get = Object(lodash["get"])(action, 'payload'),
      index = _get.index,
      valuesToUpdate = _get.valuesToUpdate;

  if (!Number.isFinite(index)) {
    return state;
  }

  var adults = state || [];
  return Array(index >= adults.length ? index + 1 : adults.length).fill(adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */])).map(function (defaultAdult, i) {
    if (i !== index) return adults[i] ? adults[i] : adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */]);
    return adults_reducer_objectSpread(adults_reducer_objectSpread({}, adults_reducer_objectSpread({}, adults[i] ? adults[i] : defaultAdult)), valuesToUpdate);
  });
}

function setAdultsWithMainContactLastName(state, action) {
  var _action$payload = action.payload,
      userInfos = _action$payload.userInfos,
      adultCount = _action$payload.adultCount;
  var lastName = userInfos.lastName;

  if (lastName === '') {
    return state;
  }

  var adults = state || [];
  return Array(adultCount).fill(adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */])).map(function (defaultAdult, i) {
    // First adult = mainContact so update it with userInfosData
    if (i === 0) {
      return adults_reducer_objectSpread(adults_reducer_objectSpread(adults_reducer_objectSpread({}, defaultAdult), adults[i]), Object(lodash["pick"])(userInfos, ['lastName', 'firstName', 'birthdate', 'email', 'civility', 'unicodeFirstName', 'unicodeLastName']));
    }

    return adults_reducer_objectSpread(adults_reducer_objectSpread(adults_reducer_objectSpread({}, defaultAdult), adults[i]), {}, {
      lastName: adults[i] && !Object(lodash["isEmpty"])(adults[i].lastName) ? adults[i].lastName : userInfos.lastName
    });
  });
}

function setAdultsNumber(state, action) {
  var adultsNumber = Object(lodash["get"])(action, 'payload.adultsNumber');

  if (adultsNumber === 0) {
    return [];
  }

  if (!Number.isFinite(adultsNumber)) {
    return state;
  }

  var adults = state || [];
  return Array(adultsNumber).fill(adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */])).map(function (defaultAdult, i) {
    return adults_reducer_objectSpread({}, adults[i] ? adults[i] : defaultAdult);
  });
}

var adults_reducer_setAdults = function setAdults(state, _ref) {
  var payload = _ref.payload;

  if (!payload.adultsAttendees) {
    return state.map(function (adult) {
      return {
        neolid: adult.neolid
      };
    });
  }

  return state.map(function (adult, index) {
    var _ref2 = payload.adultsAttendees[index] || {},
        birthdate = _ref2.birthdate,
        homePhoneNumber = _ref2.homePhoneNumber,
        mobilePhoneNumber = _ref2.mobilePhoneNumber,
        restAttendeeData = Object(objectWithoutProperties["a" /* default */])(_ref2, ["birthdate", "homePhoneNumber", "mobilePhoneNumber"]);

    return adults_reducer_objectSpread(adults_reducer_objectSpread({}, restAttendeeData), {}, {
      birthdate: birthdate ? Object(apiDate["d" /* apiDateToTimestamp */])(birthdate) : null,
      phoneNumber: mobilePhoneNumber || homePhoneNumber,
      neolid: adult.neolid
    });
  });
};

function adultsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : adults_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (Object(lodash["get"])(action, 'type')) {
    case adults_constants["f" /* TRIP_INFORMATION_UPDATE_ADULT */]:
      return updateAdult(state, action);

    case TRIP_INFORMATION_UPDATE_PARTICIPANTS_LAST_NAME:
      return setAdultsWithMainContactLastName(state, action);

    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
      return setAdultsNumber(state, action);

    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(prebookingform_action["a" /* FETCH_PREBOOKING_TRAVELERS */]):
    case adults_constants["d" /* SET_ATTENDEES */]:
      return adults_reducer_setAdults(state, action);

    case proposals_constants["y" /* UPDATE_ATTENDEES */]:
      {
        if (!action.payload.attendees) {
          return state;
        }

        return state.map(function (adult) {
          var updatedAdult = action.payload.attendees.find(function (_ref3) {
            var id = _ref3.id;
            return id === adult.id;
          }) || {};
          return adults_reducer_objectSpread(adults_reducer_objectSpread({}, adult), {}, {
            neolid: updatedAdult.customerId,
            gmNumber: updatedAdult.gmNumber,
            mainContactId: undefined
          });
        });
      }

    case adults_constants["c" /* SET_ADULTS */]:
      return action.payload.map(function (adult, index) {
        return adults_reducer_objectSpread(adults_reducer_objectSpread(adults_reducer_objectSpread({}, state[index]), adult), {}, {
          mainContactId: adult.neolid ? undefined : adult.mainContactId,
          neolid: adult.neolid || Object(lodash["get"])(state[index], 'neolid')
        }, adult.address ? {
          address: adults_reducer_objectSpread(adults_reducer_objectSpread({}, Object(lodash["get"])(state[index], 'address')), adult.address)
        } : null);
      });

    case signout["a" /* SIGNOUT */]:
      return adults_reducer_initialState;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/trip-information/tripInformation.reducer.js



/* harmony default export */ var tripInformation_reducer = (Object(redux["c" /* combineReducers */])({
  kids: kidsReducer,
  adults: adultsReducer
}));
// EXTERNAL MODULE: ./src/client/store/routing/constants.js
var routing_constants = __webpack_require__("Uq20");

// EXTERNAL MODULE: ./src/client/components/widgets/cart/bookingCart.actions.js
var bookingCart_actions = __webpack_require__("kD/R");

// EXTERNAL MODULE: ./src/client/components/widgets/popin-newsletter/PopinNewsletter.jsx
var PopinNewsletter = __webpack_require__("Qosd");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/store/toast/toast.actions.js
var toast_actions = __webpack_require__("7Z8V");

// CONCATENATED MODULE: ./src/client/store/toast/toast.reducer.js


function toast_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function toast_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      toast_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      toast_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}












var toast_reducer_initialState = {
  shouldDisplay: false,
  label: '',
  icon: icons["a" /* ICONS */].CONFIRMATION,
  color: colors["a" /* COLORS */].WATER_GREEN
};
var toast_reducer_toast = function toast() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : toast_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case toast_actions["b" /* OPEN_TOAST */]:
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["resolve"])(proposals_constants["e" /* ADD_TRANSPORT */]):
      return {
        shouldDisplay: true,
        label: Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel') || '',
        icon: icons["a" /* ICONS */].CONFIRMATION,
        color: colors["a" /* COLORS */].WATER_GREEN,
        className: Object(lodash["get"])(action, 'payload.className', '')
      };

    case proposals_constants["i" /* DISPLAY_TOAST_ON_CONTEXT_SHARE */]:
    case PopinNewsletter["a" /* NEWSLETTER_SUBSCRIPTION_VALIDATION */]:
      return {
        shouldDisplay: true,
        label: Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel') || '',
        icon: icons["a" /* ICONS */].CONFIRMATION,
        color: colors["a" /* COLORS */].WATER_GREEN
      };

    case Object(build["resolve"])(proposals_constants["c" /* ADD_SERVICE */]):
    case Object(build["resolve"])(proposals_constants["A" /* UPDATE_SERVICES */]):
    case Object(build["resolve"])(proposals_constants["h" /* DELETE_SERVICE */]):
    case Object(build["resolve"])(bookingCart_actions["a" /* UPDATE_BOOKING_CART */]):
    case 'PICK_YOUR_ROOM_AGENCY_SUCCESS':
      return {
        shouldDisplay: !!(Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel')),
        label: Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel') || '',
        icon: icons["a" /* ICONS */].CONFIRMATION,
        color: colors["a" /* COLORS */].WATER_GREEN
      };

    case 'PICK_YOUR_ROOM_AGENCY':
      return {
        shouldDisplay: !!Object(lodash["get"])(action, 'payload.toastLabel'),
        label: Object(lodash["get"])(action, 'payload.toastLabel') || Object(lodash["get"])(action, 'meta.payload.toastLabel') || '',
        icon: icons["a" /* ICONS */].CIRCLED_CROSS,
        color: colors["a" /* COLORS */].WATER_GREEN
      };

    case 'PAYMENT_BUTTON_ERROR':
    case proposals_constants["b" /* ADD_ACCOMMODATION_ERROR */]:
      return {
        shouldDisplay: !!action.payload.toastLabel,
        label: action.payload.toastLabel,
        icon: icons["a" /* ICONS */].CIRCLED_CROSS,
        color: colors["a" /* COLORS */].RED
      };

    case proposals_constants["A" /* UPDATE_SERVICES */]:
    case proposals_constants["h" /* DELETE_SERVICE */]:
      return toast_reducer_objectSpread(toast_reducer_objectSpread({}, state), {}, {
        shouldDisplay: false
      });

    case toast_actions["a" /* CLOSE_TOAST */]:
    case routing_constants["a" /* ROUTING_CHANGE */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalTransports_action["d" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return toast_reducer_objectSpread(toast_reducer_objectSpread({}, state), {}, {
        shouldDisplay: false
      });

    default:
      return state;
  }
};
// EXTERNAL MODULE: ./src/client/store/user-info/actions/notifyProfileChanged.js
var notifyProfileChanged = __webpack_require__("ubam");

// CONCATENATED MODULE: ./src/client/store/user-info/reducers/userInfoReducer.js


function userInfoReducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function userInfoReducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      userInfoReducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      userInfoReducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var MAIN_CONTACT_INDEX = 0; // $FlowFixMe known flow bug. Faultly rejects empty object.

var userInfoReducer_initialState = {};
function userInfoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userInfoReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case signout["a" /* SIGNOUT */]:
      return userInfoReducer_initialState;

    case notifyProfileChanged["a" /* PROFILE_CHANGED */]:
      return userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, state), action.payload);

    case adults_constants["d" /* SET_ATTENDEES */]:
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
      var profile = action.payload.profile; // If profile is null, it means that the user is not logged or its token is not valid
      // and existing userInfo and no profile seems weird, but the token being short lived, it can
      // happen
      // address is nullable

      if (profile) {
        return userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, state), profile);
      }

      return state;

    case adults_constants["f" /* TRIP_INFORMATION_UPDATE_ADULT */]:
      if (Object(lodash["isEmpty"])(state)) return state;
      var _action$payload = action.payload,
          index = _action$payload.index,
          valuesToUpdate = _action$payload.valuesToUpdate;
      var updatedDateOfBirth = Object(lodash["get"])(valuesToUpdate, 'birthdate');
      var optinEmail = Object(lodash["get"])(valuesToUpdate, 'optinEmail');
      var optinSms = Object(lodash["get"])(valuesToUpdate, 'optinSms');
      var optinMail = Object(lodash["get"])(valuesToUpdate, 'optinMail');
      var optinPhone = Object(lodash["get"])(valuesToUpdate, 'optinPhone');
      var optinClubmedPlus = Object(lodash["get"])(valuesToUpdate, 'optinClubmedPlus');
      if (index !== MAIN_CONTACT_INDEX) return state;
      var newState = state;

      if (updatedDateOfBirth) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          updatedDateOfBirth: updatedDateOfBirth
        });
      }

      if (!Object(lodash["isNil"])(optinEmail)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinEmail: optinEmail
        });
      }

      if (!Object(lodash["isNil"])(optinSms)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinSms: optinSms
        });
      }

      if (!Object(lodash["isNil"])(optinMail)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinMail: optinMail
        });
      }

      if (!Object(lodash["isNil"])(optinPhone)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinPhone: optinPhone
        });
      }

      if (!Object(lodash["isNil"])(optinClubmedPlus)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinClubmedPlus: optinClubmedPlus
        });
      }

      return newState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/validation-schema/constants.js
var validation_schema_constants = __webpack_require__("Kb9x");

// CONCATENATED MODULE: ./src/client/store/validation-schema/validationSchema.reducer.js


function validationSchema_reducer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function validationSchema_reducer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      validationSchema_reducer_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      validationSchema_reducer_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var validationSchema_reducer_initialState = {
  'profile.address': []
};

var validationSchema_reducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : validationSchema_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(build["resolve"])(proposals_constants["j" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */]):
    case validation_schema_constants["a" /* UPDATE_VALIDATION_SCHEMA */]:
      {
        var validationSchema = action.payload.validationSchema;
        if (!validationSchema) return state;
        var addressEntry = validationSchema.find(function (entry) {
          return entry.name === 'address';
        });
        return addressEntry ? {
          'profile.address': addressEntry.fields.map(function (validation) {
            return validationSchema_reducer_objectSpread(validationSchema_reducer_objectSpread({}, validation), {}, {
              validators: validation.validators.map(function (validator) {
                return validator.name === 'pattern' ? {
                  name: 'pattern',
                  value: new RegExp(validator.value)
                } : validator;
              })
            });
          })
        } : state;
      }

    default:
      return state;
  }
};

/* harmony default export */ var validationSchema_reducer = (validationSchema_reducer_reducer);
// CONCATENATED MODULE: ./src/client/store/rootReducer.js




















var rootReducer = Object(redux["c" /* combineReducers */])({
  booking: booking,
  calendar: calendarReducer,
  cms: cmsReducer,
  faceting: facetingReducer,
  facetingTripInformation: facetingTripInformation_reducer,
  globalLoader: globalLoader_reducer,
  memberSpace: memberSpace,
  pickYourRoom: pick_your_room_pickYourRoom_reducer,
  priceRemote: priceRemoteReducer,
  priceTicket: priceTicket_reducer,
  search: searchReducer,
  seller: sellerReducer,
  tripDateCriteria: tripDateCriteria_reducer,
  tripInformation: tripInformation_reducer,
  userInfo: userInfoReducer,
  leadInfos: leadInfo_reducer_leadInfosReducer,
  tripCriteria: tripCriteria_reducer,
  toast: toast_reducer_toast,
  validationSchema: validationSchema_reducer
});

/***/ }),

/***/ "vIa8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ activeFacetsSelector; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ bannersSelector; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ facetingCriteriaSelector; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ facetsSelector; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ filteredProductsSelector; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ recommandedProductsSelector; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ filteredProductsCountSelector; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ filteredProductsSeasonsSelector; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ filtersSelector; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ getFacetingProductIds; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ getFiltersSelector; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getKidsValidationState; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ searchQuerySelector; });

// UNUSED EXPORTS: facetingSelector, facetingPricesSelector

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/reselect/lib/index.js
var lib = __webpack_require__("hqKg");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// CONCATENATED MODULE: ./src/utils/faceting/facetingFilters.js





var facetingFilters_FacetFilters = /*#__PURE__*/function () {
  function FacetFilters(list) {
    Object(classCallCheck["a" /* default */])(this, FacetFilters);

    this._list = list || [];
  }

  Object(createClass["a" /* default */])(FacetFilters, [{
    key: "addFilter",
    value: function addFilter(filter) {
      this._list.push({
        id: filter.id,
        name: filter.name
      });

      return this;
    }
  }, {
    key: "addFilters",
    value: function addFilters(filters) {
      if (filters) {
        filters.map(this.addFilter.bind(this));
      }

      return this;
    }
  }, {
    key: "removeFilters",
    value: function removeFilters(ids) {
      this._list = this._list.filter(function (item) {
        return !Object(lodash["includes"])(ids, item.id);
      });
      return this;
    }
  }, {
    key: "addChildcareFilters",
    value: function addChildcareFilters(args) {
      var kids = args.kids,
          _args$childcareFacets = args.childcareFacets,
          facets = _args$childcareFacets === void 0 ? [] : _args$childcareFacets,
          departureDate = args.departureDate;
      var childcareFacets = Object(lodash["isEmpty"])(facets) ? constants["h" /* DEFAULT_CHILDCARE_FACETS */].map(function (f) {
        return {
          label: f,
          value: f
        };
      }) : facets;
      var childcareRanges = childcareFacets.map(function (_ref) {
        var name = _ref.label;
        var facetRange = name.split('-');
        return {
          name: name,
          min: parseInt(facetRange[0], 10),
          max: parseInt(facetRange[1], 10)
        };
      });
      var childcareFilters = kids.filter(function (_ref2) {
        var childcareIncluded = _ref2.childcareIncluded;
        return childcareIncluded;
      }).map(function (_ref3) {
        var birthdate = _ref3.birthdate;
        var kidAgeInMonths = Object(facetingUtils["e" /* getKidAgeInMonths */])({
          birthdate: birthdate,
          departureDate: departureDate
        });
        var matchingFacet = childcareRanges.find(function (_ref4) {
          var min = _ref4.min,
              max = _ref4.max;
          return Object(lodash["inRange"])(kidAgeInMonths, min, max + 1);
        }); // lodash inRange exludes the max value

        if (!matchingFacet || !matchingFacet.name) {
          return null;
        }

        return {
          id: constants["e" /* CHILDCARE_FACET_ID */],
          name: matchingFacet.name
        };
      }).filter(Boolean);
      this._list = this._list.concat(Object(lodash["uniqWith"])(childcareFilters, lodash["isEqual"]));
      return this;
    }
  }, {
    key: "addAdultOnlyFilter",
    value: function addAdultOnlyFilter() {
      var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return Object(lodash["isEmpty"])(kids) ? this : this.addFilter({
        id: constants["d" /* ADULTS_ONLY_FACET_ID */],
        name: false
      });
    }
  }, {
    key: "value",
    value: function value() {
      return this._list.map(function (item) {
        return Object(lodash["pick"])(item, ['id', 'name']);
      });
    }
  }]);

  return FacetFilters;
}();
// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// CONCATENATED MODULE: ./src/client/store/faceting/faceting.selector.js


/* eslint-disable max-params */








var facetingSelector = function facetingSelector(_ref) {
  var faceting = _ref.faceting;
  return faceting || {};
};

var activeFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref2) {
  var activeFacets = _ref2.activeFacets;
  return activeFacets || {};
});
var searchQuerySelector = Object(lib["createSelector"])(facetingSelector, function (_ref3) {
  var query = _ref3.query;
  return query || {
    label: ''
  };
});
var facetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref4) {
  var facets = _ref4.facets;
  return facets || [];
});
var filtersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref5) {
  var filters = _ref5.filters;
  return filters || [];
});
var facetingPricesSelector = Object(lib["createSelector"])(facetingSelector, function (_ref6) {
  var prices = _ref6.prices;
  return prices;
});
var filteredProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref7) {
  var _ref7$products = _ref7.products,
      products = _ref7$products === void 0 ? [] : _ref7$products;
  return products;
});
var recommandedProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref8) {
  var _ref8$recommandedProd = _ref8.recommandedProducts,
      recommandedProducts = _ref8$recommandedProd === void 0 ? [] : _ref8$recommandedProd;
  return recommandedProducts;
});
var bannersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref9) {
  var banners = _ref9.banners;
  return banners || [];
});
var filteredProductsCountSelector = Object(lib["createSelector"])(facetingSelector, function (_ref10) {
  var _ref10$products = _ref10.products,
      products = _ref10$products === void 0 ? [] : _ref10$products;
  return products.length;
});
var filteredProductsSeasonsSelector = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.reduce(function (seasons, product) {
    return seasons.includes(product.seasonName) ? seasons : [].concat(Object(toConsumableArray["a" /* default */])(seasons), [product.seasonName]);
  }, []);
});
var getFacetingProductIds = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.map(function (_ref11) {
    var id = _ref11.id;
    return id;
  });
});
var getKidsValidationState = Object(lib["createSelector"])(facetingSelector, function (_ref12) {
  var _ref12$kidsValidation = _ref12.kidsValidationState,
      kidsValidationState = _ref12$kidsValidation === void 0 ? [] : _ref12$kidsValidation;
  return kidsValidationState;
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * representing active facets to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var activeFacetsCriteriaSelector = Object(lib["createSelector"])(activeFacetsSelector, function (activeFacets) {
  return Object.keys(activeFacets).reduce(function (acc, categoryId) {
    Object.entries(activeFacets[categoryId]).map(function (_ref13) {
      var _ref14 = Object(slicedToArray["a" /* default */])(_ref13, 2),
          filter = _ref14[0],
          isSelected = _ref14[1];

      if (isSelected) {
        acc.push({
          id: categoryId,
          name: filter
        });
      }
    });
    return acc;
  }, []);
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * containing aggregation of both facets and criterias to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'facette_adult_only', name: false },
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var getFiltersSelector = Object(lib["createSelector"])(storeHelper["c" /* getKids */], tripCriteria_selector["b" /* getDepartureDate */], activeFacetsCriteriaSelector, filtersSelector, tripCriteria_selector["a" /* getDepartureCity */], facetsSelector, function (kids, departureDate, activeFacets, filters, departureCity, facets) {
  var allFilters = new facetingFilters_FacetFilters(filters).removeFilters([constants["a" /* ACTIVITIES_FACET_ID */], constants["d" /* ADULTS_ONLY_FACET_ID */], constants["e" /* CHILDCARE_FACET_ID */], constants["j" /* DEPARTURE_CITY_FACET_ID */]].concat(Object(toConsumableArray["a" /* default */])(constants["r" /* FILTERABLE_FACETS_IDS */]))).addAdultOnlyFilter(kids).addChildcareFilters({
    kids: kids,
    childcareFacets: Object(facetingUtils["b" /* getChildcareFacets */])(facets),
    departureDate: departureDate
  }).addFilters(activeFacets);

  if (departureCity) {
    allFilters.addFilter({
      id: constants["j" /* DEPARTURE_CITY_FACET_ID */],
      name: departureCity
    });
  }

  return allFilters.value();
});
/**
 * Returns an object with an aggregation of criterias for Pertimm:
 *
 * Example:
 * ```json
 * {
 *    departureDate: '',
 *    tripDuration: '7',
 *    filters: [
 *      { id: 'facette_departure_city',  name: 'PAR' },
 *      { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 *    ]
 * }
 * ```
 */

var facetingCriteriaSelector = Object(lib["createSelector"])([tripCriteria_selector["b" /* getDepartureDate */], tripCriteria_selector["c" /* getTripDuration */], getFiltersSelector, storeHelper["c" /* getKids */]], function (departureDate, tripDuration, filters, kids) {
  return {
    departureDate: departureDate,
    tripDuration: tripDuration,
    filters: filters,
    kids: kids
  };
});


/***/ }),

/***/ "vN+2":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "wF/u":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__("e5cp"),
    isObjectLike = __webpack_require__("ExA7");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "wJg7":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "wQ38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_UPDATE_KID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRIP_INFORMATION_RESET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_KID_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALIDATION_STATE_ENUM; });
var TRIP_INFORMATION_SET_KIDS = 'TRIP_INFORMATION_UPDATE_KIDS';
var TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS = 'TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS';
var TRIP_INFORMATION_UPDATE_KID = 'TRIP_INFORMATION_UPDATE_KID';
var TRIP_INFORMATION_RESET_KIDS = 'TRIP_INFORMATION_RESET_KID';
var DEFAULT_KID_VALUE = {
  birthdate: undefined,
  neolid: undefined,
  childcareIncluded: true
};
var VALIDATION_STATE_ENUM = Object.freeze({
  valid: 'IS_VALID',
  invalid: 'IS_INVALID',
  notvalidated: 'NOT_VALIDATED'
});

/***/ }),

/***/ "wclG":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("pFRH"),
    shortOut = __webpack_require__("88Gu");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "whR3":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("c72w"),
    copyObject = __webpack_require__("LtXa"),
    createAssigner = __webpack_require__("wpQC"),
    isArrayLike = __webpack_require__("9y2L"),
    isPrototype = __webpack_require__("CbIe"),
    keys = __webpack_require__("BlJA");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ "wpQC":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("R3TX"),
    isIterateeCall = __webpack_require__("R5u7");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "wuTn":
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),

/***/ "xAOE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_TRAVEL_COMPANIONS_RESOLVED; });
/* unused harmony export initialState */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _store_utils_createReducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("4Bi9");


var _createReducer;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var FETCH_TRAVEL_COMPANIONS = 'FETCH_TRAVEL_COMPANIONS';
var UPDATE_TRAVEL_COMPANION = 'UPDATE_TRAVEL_COMPANION';
var FETCH_TRAVEL_COMPANIONS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["resolve"])(FETCH_TRAVEL_COMPANIONS);
var initialState = {
  data: [],
  isLoading: false,
  isLoaded: false,
  errorResponse: {}
};
/* harmony default export */ __webpack_exports__["b"] = (Object(_store_utils_createReducer__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(initialState, (_createReducer = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_createReducer, FETCH_TRAVEL_COMPANIONS, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_createReducer, FETCH_TRAVEL_COMPANIONS_RESOLVED, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    data: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(action, 'payload.travelCompanions', [])
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["reject"])(FETCH_TRAVEL_COMPANIONS), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    errorResponse: {
      errors: action.payload.errors
    }
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_createReducer, UPDATE_TRAVEL_COMPANION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    data: action.payload
  });
}), _createReducer)));

/***/ }),

/***/ "xYSL":
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "xl1w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_BOOKING_CART; });
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bookingCartReducer; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var FETCH_BOOKING_CART = 'FETCH_BOOKING_CART';
var UPDATE_BOOKING_CART = 'UPDATE_BOOKING_CART';
var initialState = {
  data: {},
  errorResponse: {},
  editingServiceId: '',
  stay: {}
};
var bookingCartReducer = function bookingCartReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case FETCH_BOOKING_CART:
      return _objectSpread(_objectSpread({}, state), {}, {
        stay: action.payload.stay
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["resolve"])(FETCH_BOOKING_CART):
      return _objectSpread(_objectSpread({}, state), {}, {
        data: Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(action, 'payload', {}),
        errorResponse: {}
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["reject"])(FETCH_BOOKING_CART):
      return _objectSpread(_objectSpread({}, state), {}, {
        errorResponse: {
          errors: action.payload.errors
        }
      });

    case UPDATE_BOOKING_CART:
      return _objectSpread(_objectSpread({}, state), {}, {
        editingServiceId: action.payload.id
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["resolve"])(UPDATE_BOOKING_CART):
      return _objectSpread(_objectSpread({}, state), {}, {
        editingServiceId: '',
        data: _objectSpread(_objectSpread({}, state.data), {}, {
          userBooking: _objectSpread(_objectSpread(_objectSpread({}, state.data.userBooking), action.payload.addServiceCart), action.payload.removeServiceCart)
        })
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["reject"])(UPDATE_BOOKING_CART):
      return _objectSpread(_objectSpread({}, state), {}, {
        editingServiceId: '',
        errorResponse: {
          errors: action.payload.errors
        }
      });

    default:
      return state;
  }
};

/***/ }),

/***/ "xweI":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("XGnz"),
    baseOrderBy = __webpack_require__("alwl"),
    baseRest = __webpack_require__("EA7m"),
    isIterateeCall = __webpack_require__("mv/X");

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ "y0S3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return composeFiltersAsPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLocaleFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFlexibilityDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureDateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureCityFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDurationFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getProductIdsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getOfferFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFacetsFilters; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("4+vj");
/* harmony import */ var _faceting_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sW3P");






var FILTER_PARAM = 'filters';
function composeFiltersAsPayload() {
  for (var _len = arguments.length, filters = new Array(_len), _key = 0; _key < _len; _key++) {
    filters[_key] = arguments[_key];
  }

  var formData = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flattenDeep"])(filters).reduce(function (acc, _ref) {
    var name = _ref.name,
        value = _ref.value,
        operation = _ref.operation;
    if (value) acc.push("".concat(FILTER_PARAM, "[").concat(name, "][values][]=").concat(urijs__WEBPACK_IMPORTED_MODULE_3___default.a.encode(value)));

    if (value && operation) {
      acc.push("".concat(FILTER_PARAM, "[").concat(name, "][operations][]=").concat(urijs__WEBPACK_IMPORTED_MODULE_3___default.a.encode(operation)));
    }

    return acc;
  }, []);
  return formData.join('&');
}

function buildFilters(_ref2) {
  var name = _ref2.name,
      value = _ref2.value,
      operation = _ref2.operation;
  return value ? [{
    name: name,
    value: value,
    operation: operation
  }] : [];
}

function getLocaleFilters(locale) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* LOCALE_FACET_ID */ "v"],
    value: locale,
    operation: operation
  });
}
var getFlexibilityDates = function getFlexibilityDates(_ref3) {
  var departureDate = _ref3.departureDate,
      flexibility = _ref3.flexibility;

  if (!flexibility || !departureDate) {
    return {
      minDepartureDate: departureDate,
      maxDepartureDate: departureDate
    };
  }

  var minDepartureDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).subtract(flexibility, 'days');
  return {
    minDepartureDate: minDepartureDate.isAfter(moment__WEBPACK_IMPORTED_MODULE_2___default()().add(1, 'days')) ? minDepartureDate.valueOf() : moment__WEBPACK_IMPORTED_MODULE_2___default()().add(1, 'days').valueOf(),
    maxDepartureDate: moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).add(flexibility, 'days').valueOf()
  };
};
function getDepartureDateFilters(_ref4) {
  var departureDate = _ref4.departureDate,
      _ref4$flexibility = _ref4.flexibility,
      flexibility = _ref4$flexibility === void 0 ? 0 : _ref4$flexibility,
      locale = _ref4.locale,
      _ref4$operation = _ref4.operation,
      operation = _ref4$operation === void 0 ? 'and' : _ref4$operation;

  var _getFlexibilityDates = getFlexibilityDates({
    departureDate: departureDate,
    flexibility: flexibility
  }),
      minDepartureDate = _getFlexibilityDates.minDepartureDate,
      maxDepartureDate = _getFlexibilityDates.maxDepartureDate;

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MIN_FACET_ID */ "n"],
    value: minDepartureDate && Object(_client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_4__[/* formatPertimmDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_2___default()(minDepartureDate), locale),
    operation: operation
  })), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MAX_FACET_ID */ "m"],
    value: maxDepartureDate && Object(_client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_4__[/* formatPertimmDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_2___default()(maxDepartureDate), locale),
    operation: operation
  })));
}
function getDepartureCityFilters(_ref5) {
  var _ref5$facets = _ref5.facets,
      facets = _ref5$facets === void 0 ? [] : _ref5$facets,
      _ref5$defaultValue = _ref5.defaultValue,
      defaultValue = _ref5$defaultValue === void 0 ? '' : _ref5$defaultValue,
      _ref5$operation = _ref5.operation,
      operation = _ref5$operation === void 0 ? 'and' : _ref5$operation;
  var departureCityFacet = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["findLast"])(facets, function (_ref6) {
    var id = _ref6.id;
    return id === _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "j"];
  }) || {};
  var value = departureCityFacet.name || defaultValue;
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "j"],
    value: value,
    operation: operation
  });
}
function getDurationFilters(duration) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DURATION_FACET */ "p"],
    value: duration,
    operation: operation
  });
}

function getProductIdFilters(id) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'or';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* PRODUCT_FACET_ID */ "z"],
    value: id,
    operation: operation
  });
}

function getProductIdsFilters() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 ? arguments[1] : undefined;
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flatten"])(ids.map(function (id) {
    return getProductIdFilters(id, operation);
  }));
}
function getOfferFilters(offerId) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* OFFER_ID_FACET_ID */ "x"],
    value: offerId,
    operation: operation
  });
}
var FACETS_TO_OMIT = [_faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MIN_FACET_ID */ "n"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MAX_FACET_ID */ "m"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "j"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DURATION_FACET */ "p"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* OFFER_ID_FACET_ID */ "x"]];
function getFacetsFilters() {
  var facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  var filters = facets.filter(function (facet) {
    return !FACETS_TO_OMIT.includes(facet.id);
  }).map(function (facet) {
    return buildFilters({
      name: facet.id,
      value: facet.name,
      operation: operation
    });
  });
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flatten"])(filters);
}

/***/ }),

/***/ "y316":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ suggest; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ search; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ searchWithFacets; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getIdsFromProducts; });

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/pertimm-client/filters.js
var filters = __webpack_require__("y0S3");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/error.js/index.js
var error_js = __webpack_require__("x5Ag");
var error_js_default = /*#__PURE__*/__webpack_require__.n(error_js);

// CONCATENATED MODULE: ./src/utils/pertimm-client/request.js



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var PertimmRequestFailed = error_js_default.a.create({
  name: 'PertimmRequestFailed',
  message: 'The Pertimm request failed'
});

var request_getAxiosConfig = function getAxiosConfig() {
  var proxyConfig = config_default.a.get('pertimm.proxy');
  var httpsAgent;

  if (false) {}

  return {
    httpsAgent: httpsAgent,
    proxy: httpsAgent ? false : undefined
  };
};

var START_INDEX_PARAM = 'res_sf';

function recursivePostRequest(_ref) {
  var axiosConfig = _ref.axiosConfig,
      url = _ref.url,
      payload = _ref.payload,
      queryparams = _ref.queryparams,
      acc = _ref.acc;
  return Object(axios["request"])(_objectSpread(_objectSpread({}, axiosConfig), {}, {
    method: 'POST',
    url: url,
    data: payload,
    params: queryparams
  })).then(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref2.data;

    if (!acc) acc = _objectSpread({}, data);else acc.answers = [].concat(Object(toConsumableArray["a" /* default */])(acc.answers), Object(toConsumableArray["a" /* default */])(data.answers || []));
    var nextStart = Number(data.start_answer) + Number(data.returned_answers_count) - 1;
    var hasMoreAnswers = nextStart + 1 < Number(data.available_answers_count);
    return hasMoreAnswers ? recursivePostRequest({
      axiosConfig: axiosConfig,
      url: url,
      payload: payload,
      queryparams: _objectSpread(_objectSpread({}, queryparams), {}, Object(defineProperty["a" /* default */])({}, START_INDEX_PARAM, nextStart)),
      acc: acc
    }) : acc;
  })["catch"](function () {
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _error$response = error.response;
    _error$response = _error$response === void 0 ? {} : _error$response;
    var _error$response$statu = _error$response.status,
        status = _error$response$statu === void 0 ? 500 : _error$response$statu,
        _error$response$data = _error$response.data,
        data = _error$response$data === void 0 ? '' : _error$response$data;
    throw new PertimmRequestFailed({
      statusCode: status,
      errors: data
    });
  });
}

function postSearchRequest(_ref3) {
  var _objectSpread3;

  var locale = _ref3.locale,
      _ref3$payload = _ref3.payload,
      payload = _ref3$payload === void 0 ? '' : _ref3$payload,
      _ref3$queryparams = _ref3.queryparams,
      queryparams = _ref3$queryparams === void 0 ? {} : _ref3$queryparams;
  return recursivePostRequest({
    url: config_default.a.get('pertimm.apiUrl'),
    axiosConfig: request_getAxiosConfig(),
    payload: payload,
    queryparams: _objectSpread((_objectSpread3 = {
      enable_interpretation_explanation: true
    }, Object(defineProperty["a" /* default */])(_objectSpread3, START_INDEX_PARAM, 0), Object(defineProperty["a" /* default */])(_objectSpread3, "search_locale", locale), Object(defineProperty["a" /* default */])(_objectSpread3, "user_locale", locale), _objectSpread3), queryparams),
    acc: undefined
  });
}
// CONCATENATED MODULE: ./src/utils/pertimm-client/index.js





var ACTIONS = {
  WORD_WHEEL: 'wordWheel',
  PERTIMM_SEARCH: 'pertimmSearch'
};
var pertimm_client_getApiKey = Object(lodash["memoize"])(function getApiKey(appContext) {
  return config_default.a.get( // eslint-disable-next-line no-nested-ternary
  appContext.isCmta ? 'api.cm_ta_api_key' : Object(sellerUtils["g" /* isSeller */])(appContext) ? 'api.seller.api_key' : 'api.api_key');
});

function suggest(_ref) {
  var appContext = _ref.appContext,
      _ref$criteria = _ref.criteria,
      criteria = _ref$criteria === void 0 ? {} : _ref$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords = criteria.keywords,
      keywords = _criteria$keywords === void 0 ? '' : _criteria$keywords,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.WORD_WHEEL,
      max_suggests: config_default.a.get('pertimm.max_suggests'),
      enable_interpretation_explanation: 'true',
      query: keywords
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }))
  });
}

function search(_ref2) {
  var appContext = _ref2.appContext,
      _ref2$criteria = _ref2.criteria,
      criteria = _ref2$criteria === void 0 ? {} : _ref2$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords2 = criteria.keywords,
      keywords = _criteria$keywords2 === void 0 ? '' : _criteria$keywords2,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: keywords
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }), Object(filters["g" /* getLocaleFilters */])(appContext.locale))
  });
}

function searchWithFacets(_ref3) {
  var _ref3$criteria = _ref3.criteria,
      criteria = _ref3$criteria === void 0 ? {} : _ref3$criteria,
      appContext = _ref3.appContext;
  var departureDate = criteria.departureDate,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: criteria.query || '',
      'contexts[boutique]': criteria.boutique,
      'contexts[screenSize]': criteria.screenSize
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }), Object(filters["g" /* getLocaleFilters */])(appContext.locale), Object(filters["b" /* getDepartureCityFilters */])({
      facets: criteria.filters,
      defaultValue: criteria.defaultDepartureCity
    }), Object(filters["d" /* getDurationFilters */])(criteria.tripDuration), Object(filters["i" /* getProductIdsFilters */])(criteria.productIds), Object(filters["e" /* getFacetsFilters */])(criteria.filters), Object(filters["h" /* getOfferFilters */])(criteria.offerId))
  });
}

function getIdsFromProducts(appContext) {
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      disable_catalogs: 1
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["g" /* getLocaleFilters */])(appContext.locale))
  }).then(function () {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$answers = _ref4.answers,
        answers = _ref4$answers === void 0 ? [] : _ref4$answers;

    return answers.map(function (result) {
      return Object(lodash["get"])(result, 'meta.product_id[0]');
    });
  });
}



/***/ }),

/***/ "yGk4":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("Cwc5"),
    root = __webpack_require__("Kz5y");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "ycRU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BOOKING_PAYMENT_STATUS_VALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BOOKING_PAYMENT_STATUS_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOOKING_PAYMENT_STATUS_CART; });
var BOOKING_PAYMENT_STATUS_VALIDATED = 'VALIDATED';
var BOOKING_PAYMENT_STATUS_OPTION = 'OPTION';
var BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE = 'PACKAGE_UPGRADE';
var BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE = 'ADDITIONAL_SERVICE';
var BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM = 'PICK_YOUR_ROOM';
var BOOKING_PAYMENT_STATUS_CART = 'CART';


/***/ }),

/***/ "yfdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductPriceModal_ProductPriceModal; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.utils.js

var ProductPriceModal_utils_getLabel = function getLabel(_ref) {
  var isJoyview = _ref.isJoyview,
      isTour = _ref.isTour;

  if (isTour) {
    return '';
  }

  return isJoyview ? Object(i18n["f" /* t */])('resort.startingPrice.roomOnly') : Object(i18n["f" /* t */])('resort.startingPrice.allInclusive');
};
// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// CONCATENATED MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx


var __jsx = react_default.a.createElement;

var ClickOutside_ClickOutside = function ClickOutside(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$shard = _ref.shard,
      shard = _ref$shard === void 0 ? {} : _ref$shard,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "onClick", "shard"]);

  var ref = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var current = ref.current;
      var shardElement = shard.current;
      var clickedElement = e.target;

      if (current && !current.contains(clickedElement)) {
        if (shardElement) {
          return !shardElement.contains(clickedElement) ? onClick() : undefined;
        }

        onClick();
      }
    };

    document.addEventListener('click', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
    };
  }, [children]);
  return __jsx("div", Object(esm_extends["a" /* default */])({}, rest, {
    className: className,
    ref: ref
  }), children);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.themes.js
var themes = {
  "default": {
    thContent: 'arrow-down arrow-large arrow-white bg-white filter-drop-shadow-after mb-5 rounded-tiny shadow-md'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx
var PopOver_jsx = react_default.a.createElement;







var PopOver_PopOver = function PopOver(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      _onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useState = Object(react["useState"])(false),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!react["Children"].count(children)) {
    return null;
  }

  var thContent = themes[theme].thContent;
  return PopOver_jsx("div", {
    className: classnames_default()(className, 'relative')
  }, PopOver_jsx("button", {
    className: "reset-button w-full",
    "data-testid": "PopOver-button",
    onClick: function onClick(e) {
      e.preventDefault();
      setIsVisible(!isVisible);
      !isVisible && _onClick && _onClick(e);
    },
    type: "button"
  }, children), isVisible && PopOver_jsx(react["Fragment"], null, isDesktop ? PopOver_jsx(ClickOutside_ClickOutside, {
    className: "absolute bottom-full fadeIn inset-x-0 -mb-1",
    onClick: function onClick() {
      return setIsVisible(false);
    }
  }, PopOver_jsx("div", {
    className: thContent
  }, content)) : PopOver_jsx(Modal["a" /* Modal */], {
    ariaLabel: ariaLabel,
    closeLabel: Object(i18n["f" /* t */])('common.close'),
    onClose: function onClose(e) {
      e.preventDefault();
      setIsVisible(false);
    },
    size: "small"
  }, content)));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx
var ProductPriceModal_jsx = react_default.a.createElement;




var ProductPriceModal_ProductPriceModal = function ProductPriceModal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      city = _ref.city,
      endDate = _ref.endDate,
      _ref$hasTransport = _ref.hasTransport,
      hasTransport = _ref$hasTransport === void 0 ? false : _ref$hasTransport,
      _ref$isCruise = _ref.isCruise,
      isCruise = _ref$isCruise === void 0 ? false : _ref$isCruise,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      _ref$isTour = _ref.isTour,
      isTour = _ref$isTour === void 0 ? false : _ref$isTour,
      onClick = _ref.onClick,
      onClickButton = _ref.onClickButton,
      startDate = _ref.startDate,
      unit = _ref.unit;

  if (!react["Children"].count(children)) {
    return null;
  }

  return ProductPriceModal_jsx(PopOver_PopOver, {
    ariaLabel: ProductPriceModal_utils_getLabel({
      isJoyview: isJoyview,
      isTour: isTour
    }),
    className: className,
    content: ProductPriceModal_jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
      city: city,
      endDate: endDate,
      hasTransport: hasTransport,
      isCruise: isCruise,
      isJoyview: isJoyview,
      isTour: isTour,
      onClick: onClickButton,
      startDate: startDate,
      unit: unit
    }),
    onClick: onClick
  }, children);
};

/***/ }),

/***/ "yue5":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("/9aa");

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ "z8xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PLANE; });
/* unused harmony export TRAIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRANSPORT_CLASS_TO_I18N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getFindSectionTransportTypeFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getClassLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDiffAbsoluteDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formatTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getWayLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getMinBaggageWeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatConnectionLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hasOnlyPlanes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isTransportPlaneTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return tripsHaveSchedules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return transformMinutesInHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTransportIcon; });
/* unused harmony export hasCancellationPolicy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCancellationPolicyDescription; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("oL6k");







var BOAT = 'BOAT';
var PLANE = 'PLANE';
var TRAIN = 'TRAIN';
var TRANSPORT_CLASS_TO_I18N = {
  '1CL': 'firstClassLabel',
  '2CL': 'secondClassLabel',
  BUS: 'businessClassLabel',
  DIV: 'economyClassLabel',
  DIB: 'emeraldClassLabel',
  'EC+': 'alizeeClassLabel',
  ECO: 'economyClassLabel',
  FIR: 'firstClassLabel',
  PRC: 'premiumClassLabel',
  PRE: 'premiumClassLabel'
};

function getDiffAbsoluteDays(fromDate, toDate) {
  var fromMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* momentFromApiDate */ "h"])(fromDate);
  var toMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* momentFromApiDate */ "h"])(toDate);

  if (fromMoment.isValid() && toMoment.isValid()) {
    return toMoment.diff(fromMoment, 'days');
  }

  return null;
}

function formatTime(time, format) {
  var renderedTime = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* momentFromApiTime */ "i"])(time).format(format);
  return renderedTime !== 'Invalid date' ? renderedTime : null;
}

function getWayLabel(i18n, way) {
  if (way === 'INBOUND') return i18n.common.transport.inboundLabel;
  if (way === 'OUTBOUND') return i18n.common.transport.outboundLabel;
  return null;
}

function getMinBaggageWeight(sections) {
  if (Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(sections)) {
    return {};
  } // $FlowFixMe


  var minBaggageWeightForSection = sections.reduce(function (a, b) {
    if (!Object(lodash__WEBPACK_IMPORTED_MODULE_0__["has"])(a, 'transport.baggage.weight')) {
      return b;
    }

    if (!Object(lodash__WEBPACK_IMPORTED_MODULE_0__["has"])(b, 'transport.baggage.weight')) {
      return a;
    }

    var baggageWeightA = a.transport.baggage.weight ? Number(a.transport.baggage.weight.replace(/(\d+).*/, '$1')) : NaN;
    var baggageWeightB = b.transport.baggage.weight ? Number(b.transport.baggage.weight.replace(/(\d+).*/, '$1')) : NaN;

    if (!baggageWeightA || !baggageWeightB) {
      return null;
    }

    return baggageWeightA < baggageWeightB ? a : b;
  });
  return minBaggageWeightForSection ? minBaggageWeightForSection.transport.baggage : {};
}

function formatConnectionLabel(label, duration) {
  var durationAsNumber = duration ? +duration : 0;
  var durationFormated = moment__WEBPACK_IMPORTED_MODULE_1___default.a.utc(moment__WEBPACK_IMPORTED_MODULE_1___default.a.duration(durationAsNumber, 'minutes').asMilliseconds());
  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["messageFormat"])('{label} {duration}').format({
    label: label,
    duration: "".concat(durationFormated.format('HH'), "h").concat(durationFormated.format('mm'))
  });
}

function getStep(i18n) {
  var timeFormat = i18n.common.timeFormat;
  var transportConnectionLabel = i18n.common.transport.connection;
  return function (step) {
    var connectionDuration = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'connectionDurationInMin');
    var stopOverDuration = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'stopDurationInMin');
    var information = !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(stopOverDuration) || !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(connectionDuration) ? formatConnectionLabel(transportConnectionLabel, stopOverDuration || connectionDuration) : null;
    return {
      id: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.reference'),
      type: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.type'),
      information: information,
      operator: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.companyOperator.label'),
      operatorId: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.companyOperator.id'),
      operatorLogo: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.companyOperator.logo'),
      start: {
        label: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'departure.airportLabel'),
        time: formatTime(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'departure.time'), timeFormat),
        date: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'departure.date')
      },
      end: {
        label: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'arrival.airportLabel'),
        time: formatTime(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'arrival.time'), timeFormat),
        date: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'arrival.date')
      },
      technicalStops: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'technicalStops')
    };
  };
}

function hasOnlyBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.every(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'transport.type') === BOAT;
  });
}

function hasBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'transport.type') === BOAT;
  });
}

function hasTrain(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'transport.type') === TRAIN;
  });
}

function hasOnlyPlanes(travelSections) {
  return !(hasTrain(travelSections) || hasBoat(travelSections));
}

function isTransportPlaneTicket(inboundFlight, outboundFlight) {
  return hasOnlyPlanes(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) && hasOnlyPlanes(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));
}

function getTransportIcon(inboundFlight, outboundFlight) {
  var isTrain = hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) && hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));

  if (isTrain) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].TRAIN;
  }

  var isBoat = hasOnlyBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) && hasOnlyBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));

  if (isBoat) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].BOAT;
  }

  return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].TRANSPORT;
}

function tripHasSchedules(travelSections) {
  return !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(travelSections) ? (travelSections || []).some(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'arrival.time') || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'departure.time');
  }) : false;
}

function tripsHaveSchedules(inboundFlight, outboundFlight) {
  return tripHasSchedules(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) || tripHasSchedules(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));
}

function transformMinutesInHours(minutes) {
  var numberMinutes = Number(minutes); // TODO cms translate h & m

  return Math.floor(numberMinutes / 60) + ' h ' + (numberMinutes % 60).toString().padStart(2, '0') + ' min';
}

function hasCancellationPolicy(transport) {
  var _transport$inbound, _transport$inbound2, _transport$outbound; // in case of AlternativeTransport


  if ((_transport$inbound = transport.inbound) === null || _transport$inbound === void 0 ? void 0 : _transport$inbound.hasOwnProperty('transportInfo')) {
    var _transport$inbound$jo;

    return (// $FlowFixMe at this point it's an AlternativeTransport object
      Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* isCharterFlight */ "u"])(((_transport$inbound$jo = transport.inbound.journey) === null || _transport$inbound$jo === void 0 ? void 0 : _transport$inbound$jo.cancellationPolicyType) || '') || // $FlowFixMe at this point it's an AlternativeTransport object
      transport.outboundList.some(function (outbound) {
        var _outbound$journey;

        return (// $FlowFixMe at this point it's an AlternativeTransport object
          Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* isCharterFlight */ "u"])(((_outbound$journey = outbound.journey) === null || _outbound$journey === void 0 ? void 0 : _outbound$journey.cancellationPolicyType) || '')
        );
      })
    );
  } // in case of Transport


  return (// $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* isCharterFlight */ "u"])(((_transport$inbound2 = transport.inbound) === null || _transport$inbound2 === void 0 ? void 0 : _transport$inbound2.cancellationPolicyType) || '') || // $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* isCharterFlight */ "u"])(((_transport$outbound = transport.outbound) === null || _transport$outbound === void 0 ? void 0 : _transport$outbound.cancellationPolicyType) || '')
  );
} // TODO: check business rule


var getCancellationPolicy = function getCancellationPolicy(transport) {
  var _transport$inbound3, _transport$inbound4, _transport$outbound2; // in case of AlternativeTransport


  if ((_transport$inbound3 = transport.inbound) === null || _transport$inbound3 === void 0 ? void 0 : _transport$inbound3.hasOwnProperty('transportInfo')) {
    var _transport$inbound$jo2;

    return (// $FlowFixMe at this point it's an AlternativeTransport object
      ((_transport$inbound$jo2 = transport.inbound.journey) === null || _transport$inbound$jo2 === void 0 ? void 0 : _transport$inbound$jo2.cancellationPolicyType) || // $FlowFixMe at this point it's an AlternativeTransport object
      transport.outboundList.find(function (outbound) {
        var _outbound$journey2;

        return !!((_outbound$journey2 = outbound.journey) === null || _outbound$journey2 === void 0 ? void 0 : _outbound$journey2.cancellationPolicyType);
      })
    );
  } // in case of Transport
  // $FlowFixMe at this point it's an Transport object


  return ((_transport$inbound4 = transport.inbound) === null || _transport$inbound4 === void 0 ? void 0 : _transport$inbound4.cancellationPolicyType) || ((_transport$outbound2 = transport.outbound) === null || _transport$outbound2 === void 0 ? void 0 : _transport$outbound2.cancellationPolicyType);
};

var getCancellationPolicyDescription = function getCancellationPolicyDescription(transport, i18n) {
  if (hasCancellationPolicy(transport)) {
    var _i18n$bookingProcess$;

    var cancellationPolicy = getCancellationPolicy(transport);
    return (_i18n$bookingProcess$ = i18n.bookingProcess.find(function (legalInformation) {
      return legalInformation.id === cancellationPolicy;
    })) === null || _i18n$bookingProcess$ === void 0 ? void 0 : _i18n$bookingProcess$.description;
  }
};

var getFindSectionTransportTypeFn = function getFindSectionTransportTypeFn(transportType) {
  return function (_ref) {
    var type = _ref.transport.type;
    return type === transportType;
  };
};
var getClassLabel = function getClassLabel(_ref2) {
  var transportType = _ref2.transportType,
      travelSections = _ref2.travelSections,
      inboundCriteria = _ref2.inboundCriteria;
  var transportClass = (inboundCriteria === null || inboundCriteria === void 0 ? void 0 : inboundCriteria.flightClass) || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(transportType ? travelSections.find(getFindSectionTransportTypeFn(transportType)) : travelSections[0], 'transport.class');

  if (!TRANSPORT_CLASS_TO_I18N[transportClass]) {
    return null;
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])("common.transport.transportClass.".concat(TRANSPORT_CLASS_TO_I18N[transportClass]));
};


/***/ }),

/***/ "zCbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING_PREFIX_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTrackingTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureCityCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCityName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isSummer; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("829J");



var WITH_TRANSPORT = 'with Transport';
var WITHOUT_TRANSPORT = 'without Transport';
var NO_DEPARTURE_CITY = 'NO';
var TRACKING_PREFIX_MAPPING = {
  ACTIVITIES: 'activities',
  CHILDCARE: 'childcare',
  WELLNESS: 'wellness'
};
function getTrackingTransport(departureCityCode) {
  return departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? WITH_TRANSPORT : WITHOUT_TRANSPORT;
}
function getDepartureCityCode(departureCityCode) {
  return departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityCode : WITHOUT_TRANSPORT;
}
function getDepartureCityName(departureCityCode, departureCityName) {
  return departureCityName && departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityName : '';
}
function isSummer(date) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["inRange"])(Number(moment__WEBPACK_IMPORTED_MODULE_1___default()(date).format('MMDD')), _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__[/* SUMMER_DATE_START */ "x"], _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__[/* SUMMER_DATE_END */ "w"]);
}

/***/ }),

/***/ "zZ0H":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "zaNA":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "zr3P":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("kn3Q");

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ "zwLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPLECategoryGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPLEPaymentConfirmationSiteSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSearchMappedTypeForLabelGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSiteSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return noCase; });
/* unused harmony export pascalCase */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LvDl");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("829J");



var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["b2cPagesService"].PAGE_TYPES;
function getPLECategoryGA(isUserQuickLogged) {
  return isUserQuickLogged ? _constants__WEBPACK_IMPORTED_MODULE_2__[/* PLE_QUICK */ "n"] : _constants__WEBPACK_IMPORTED_MODULE_2__[/* PLE */ "l"];
}
function getPLEPaymentConfirmationSiteSection(_ref) {
  var isOption = _ref.isOption,
      isUserQuickLogged = _ref.isUserQuickLogged;

  if (isOption) {
    return isUserQuickLogged ? _constants__WEBPACK_IMPORTED_MODULE_2__[/* PLE_QUICK_OPTION */ "o"] : _constants__WEBPACK_IMPORTED_MODULE_2__[/* PLE_OPTION */ "m"];
  } else {
    return getPLECategoryGA(isUserQuickLogged);
  }
}
function getSearchMappedTypeForLabelGA(type) {
  return _constants__WEBPACK_IMPORTED_MODULE_2__[/* SEARCH_LABEL_GA_MAP */ "r"][type || 'none'];
}
function getSiteSection(_ref2) {
  var _ref2$isOption = _ref2.isOption,
      isOption = _ref2$isOption === void 0 ? false : _ref2$isOption,
      _ref2$isUserQuickLogg = _ref2.isUserQuickLogged,
      isUserQuickLogged = _ref2$isUserQuickLogg === void 0 ? false : _ref2$isUserQuickLogg,
      pageType = _ref2.pageType;

  switch (pageType) {
    case PAGE_TYPES.DESTINATION_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.DESTINATION));

    case PAGE_TYPES.HOME_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.HOME));

    case PAGE_TYPES.LANDING_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.LANDING));

    case PAGE_TYPES.RESORT_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.RESORT));

    case PAGE_TYPES.PREBOOKING:
      var siteSection = pageType.split('-')[0];
      return "Shopping_".concat(pascalCase(siteSection));

    case _constants__WEBPACK_IMPORTED_MODULE_2__[/* STATIC_PAGE_TYPES */ "v"].BE:
      return _constants__WEBPACK_IMPORTED_MODULE_2__[/* BE */ "a"];

    case _constants__WEBPACK_IMPORTED_MODULE_2__[/* STATIC_PAGE_TYPES */ "v"].PLE:
      return getPLECategoryGA(isUserQuickLogged);

    case _constants__WEBPACK_IMPORTED_MODULE_2__[/* STATIC_PAGE_TYPES */ "v"].PLE_PAYMENT_CONFIRMATION:
      return getPLEPaymentConfirmationSiteSection({
        isOption: isOption,
        isUserQuickLogged: isUserQuickLogged
      });

    default:
      return "Shopping_".concat(pascalCase(pageType));
  }
}
function noCase(string) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["flow"])(lodash__WEBPACK_IMPORTED_MODULE_0__["startCase"], lodash__WEBPACK_IMPORTED_MODULE_0__["toLower"])(string);
}
function pascalCase(string) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["flow"])(lodash__WEBPACK_IMPORTED_MODULE_0__["camelCase"], lodash__WEBPACK_IMPORTED_MODULE_0__["upperFirst"])(string);
}

/***/ })

},[[5,1,2,4,7,5,9,10,12,47,0,3,6,8,11,13,14,16,15,17,18,21,19,23,22,24,50]]]);